webpackJsonp([1],{

/***/ "+O8B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+mqS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/45A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7zGH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0q+O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "15Az":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Ahr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1LeC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Cg7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2i4+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2lnh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3+Ul":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f79b7cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3bhw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3iZP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3k2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3nWo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "429B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4JsM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "55wj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("nnSp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6oUx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "78BN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7ZcN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7c/E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7zGH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8eG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "985r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9TJo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9o4/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9qti":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ATJE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AiL5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ApxZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AxHB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B3Bl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.gif";

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3iZP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CCc5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CUAD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ClLx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DC2r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DPlV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dm7L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FHgB":
/***/ (function(module, exports) {

module.exports = [{"name":"北京市","value":"110000"},{"name":"天津市","value":"120000"},{"name":"河北省","value":"130000"},{"name":"山西省","value":"140000"},{"name":"内蒙古自治区","value":"150000"},{"name":"辽宁省","value":"210000"},{"name":"吉林省","value":"220000"},{"name":"黑龙江省","value":"230000"},{"name":"上海市","value":"310000"},{"name":"江苏省","value":"320000"},{"name":"浙江省","value":"330000"},{"name":"安徽省","value":"340000"},{"name":"福建省","value":"350000"},{"name":"江西省","value":"360000"},{"name":"山东省","value":"370000"},{"name":"河南省","value":"410000"},{"name":"湖北省","value":"420000"},{"name":"湖南省","value":"430000"},{"name":"广东省","value":"440000"},{"name":"广西壮族自治区","value":"450000"},{"name":"海南省","value":"460000"},{"name":"重庆市","value":"500000"},{"name":"四川省","value":"510000"},{"name":"贵州省","value":"520000"},{"name":"云南省","value":"530000"},{"name":"西藏自治区","value":"540000"},{"name":"陕西省","value":"610000"},{"name":"甘肃省","value":"620000"},{"name":"青海省","value":"630000"},{"name":"宁夏回族自治区","value":"640000"},{"name":"新疆维吾尔自治区","value":"650000"},{"name":"市辖区","value":"110100","parent":"110000"},{"name":"东城区","value":"110101","parent":"110100"},{"name":"西城区","value":"110102","parent":"110100"},{"name":"朝阳区","value":"110105","parent":"110100"},{"name":"丰台区","value":"110106","parent":"110100"},{"name":"石景山区","value":"110107","parent":"110100"},{"name":"海淀区","value":"110108","parent":"110100"},{"name":"门头沟区","value":"110109","parent":"110100"},{"name":"房山区","value":"110111","parent":"110100"},{"name":"通州区","value":"110112","parent":"110100"},{"name":"顺义区","value":"110113","parent":"110100"},{"name":"昌平区","value":"110114","parent":"110100"},{"name":"大兴区","value":"110115","parent":"110100"},{"name":"怀柔区","value":"110116","parent":"110100"},{"name":"平谷区","value":"110117","parent":"110100"},{"name":"密云区","value":"110118","parent":"110100"},{"name":"延庆区","value":"110119","parent":"110100"},{"name":"市辖区","value":"120100","parent":"120000"},{"name":"和平区","value":"120101","parent":"120100"},{"name":"河东区","value":"120102","parent":"120100"},{"name":"河西区","value":"120103","parent":"120100"},{"name":"南开区","value":"120104","parent":"120100"},{"name":"河北区","value":"120105","parent":"120100"},{"name":"红桥区","value":"120106","parent":"120100"},{"name":"东丽区","value":"120110","parent":"120100"},{"name":"西青区","value":"120111","parent":"120100"},{"name":"津南区","value":"120112","parent":"120100"},{"name":"北辰区","value":"120113","parent":"120100"},{"name":"武清区","value":"120114","parent":"120100"},{"name":"宝坻区","value":"120115","parent":"120100"},{"name":"滨海新区","value":"120116","parent":"120100"},{"name":"宁河区","value":"120117","parent":"120100"},{"name":"静海区","value":"120118","parent":"120100"},{"name":"蓟州区","value":"120119","parent":"120100"},{"name":"石家庄市","value":"130100","parent":"130000"},{"name":"唐山市","value":"130200","parent":"130000"},{"name":"秦皇岛市","value":"130300","parent":"130000"},{"name":"邯郸市","value":"130400","parent":"130000"},{"name":"邢台市","value":"130500","parent":"130000"},{"name":"保定市","value":"130600","parent":"130000"},{"name":"张家口市","value":"130700","parent":"130000"},{"name":"承德市","value":"130800","parent":"130000"},{"name":"沧州市","value":"130900","parent":"130000"},{"name":"廊坊市","value":"131000","parent":"130000"},{"name":"衡水市","value":"131100","parent":"130000"},{"name":"定州市","value":"139001","parent":"130000"},{"name":"辛集市","value":"139002","parent":"130000"},{"name":"长安区","value":"130102","parent":"130100"},{"name":"桥西区","value":"130104","parent":"130100"},{"name":"新华区","value":"130105","parent":"130100"},{"name":"井陉矿区","value":"130107","parent":"130100"},{"name":"裕华区","value":"130108","parent":"130100"},{"name":"藁城区","value":"130109","parent":"130100"},{"name":"鹿泉区","value":"130110","parent":"130100"},{"name":"栾城区","value":"130111","parent":"130100"},{"name":"井陉县","value":"130121","parent":"130100"},{"name":"正定县","value":"130123","parent":"130100"},{"name":"行唐县","value":"130125","parent":"130100"},{"name":"灵寿县","value":"130126","parent":"130100"},{"name":"高邑县","value":"130127","parent":"130100"},{"name":"深泽县","value":"130128","parent":"130100"},{"name":"赞皇县","value":"130129","parent":"130100"},{"name":"无极县","value":"130130","parent":"130100"},{"name":"平山县","value":"130131","parent":"130100"},{"name":"元氏县","value":"130132","parent":"130100"},{"name":"赵县","value":"130133","parent":"130100"},{"name":"晋州市","value":"130183","parent":"130100"},{"name":"新乐市","value":"130184","parent":"130100"},{"name":"路南区","value":"130202","parent":"130200"},{"name":"路北区","value":"130203","parent":"130200"},{"name":"古冶区","value":"130204","parent":"130200"},{"name":"开平区","value":"130205","parent":"130200"},{"name":"丰南区","value":"130207","parent":"130200"},{"name":"丰润区","value":"130208","parent":"130200"},{"name":"曹妃甸区","value":"130209","parent":"130200"},{"name":"滦县","value":"130223","parent":"130200"},{"name":"滦南县","value":"130224","parent":"130200"},{"name":"乐亭县","value":"130225","parent":"130200"},{"name":"迁西县","value":"130227","parent":"130200"},{"name":"玉田县","value":"130229","parent":"130200"},{"name":"遵化市","value":"130281","parent":"130200"},{"name":"迁安市","value":"130283","parent":"130200"},{"name":"海港区","value":"130302","parent":"130300"},{"name":"山海关区","value":"130303","parent":"130300"},{"name":"北戴河区","value":"130304","parent":"130300"},{"name":"抚宁区","value":"130306","parent":"130300"},{"name":"青龙满族自治县","value":"130321","parent":"130300"},{"name":"昌黎县","value":"130322","parent":"130300"},{"name":"卢龙县","value":"130324","parent":"130300"},{"name":"邯山区","value":"130402","parent":"130400"},{"name":"丛台区","value":"130403","parent":"130400"},{"name":"复兴区","value":"130404","parent":"130400"},{"name":"峰峰矿区","value":"130406","parent":"130400"},{"name":"邯郸县","value":"130421","parent":"130400"},{"name":"临漳县","value":"130423","parent":"130400"},{"name":"成安县","value":"130424","parent":"130400"},{"name":"大名县","value":"130425","parent":"130400"},{"name":"涉县","value":"130426","parent":"130400"},{"name":"磁县","value":"130427","parent":"130400"},{"name":"肥乡县","value":"130428","parent":"130400"},{"name":"永年县","value":"130429","parent":"130400"},{"name":"邱县","value":"130430","parent":"130400"},{"name":"鸡泽县","value":"130431","parent":"130400"},{"name":"广平县","value":"130432","parent":"130400"},{"name":"馆陶县","value":"130433","parent":"130400"},{"name":"魏县","value":"130434","parent":"130400"},{"name":"曲周县","value":"130435","parent":"130400"},{"name":"武安市","value":"130481","parent":"130400"},{"name":"桥东区","value":"130502","parent":"130500"},{"name":"桥西区","value":"130503","parent":"130500"},{"name":"邢台县","value":"130521","parent":"130500"},{"name":"临城县","value":"130522","parent":"130500"},{"name":"内丘县","value":"130523","parent":"130500"},{"name":"柏乡县","value":"130524","parent":"130500"},{"name":"隆尧县","value":"130525","parent":"130500"},{"name":"任县","value":"130526","parent":"130500"},{"name":"南和县","value":"130527","parent":"130500"},{"name":"宁晋县","value":"130528","parent":"130500"},{"name":"巨鹿县","value":"130529","parent":"130500"},{"name":"新河县","value":"130530","parent":"130500"},{"name":"广宗县","value":"130531","parent":"130500"},{"name":"平乡县","value":"130532","parent":"130500"},{"name":"威县","value":"130533","parent":"130500"},{"name":"清河县","value":"130534","parent":"130500"},{"name":"临西县","value":"130535","parent":"130500"},{"name":"南宫市","value":"130581","parent":"130500"},{"name":"沙河市","value":"130582","parent":"130500"},{"name":"竞秀区","value":"130602","parent":"130600"},{"name":"莲池区","value":"130606","parent":"130600"},{"name":"满城区","value":"130607","parent":"130600"},{"name":"清苑区","value":"130608","parent":"130600"},{"name":"徐水区","value":"130609","parent":"130600"},{"name":"涞水县","value":"130623","parent":"130600"},{"name":"阜平县","value":"130624","parent":"130600"},{"name":"定兴县","value":"130626","parent":"130600"},{"name":"唐县","value":"130627","parent":"130600"},{"name":"高阳县","value":"130628","parent":"130600"},{"name":"容城县","value":"130629","parent":"130600"},{"name":"涞源县","value":"130630","parent":"130600"},{"name":"望都县","value":"130631","parent":"130600"},{"name":"安新县","value":"130632","parent":"130600"},{"name":"易县","value":"130633","parent":"130600"},{"name":"曲阳县","value":"130634","parent":"130600"},{"name":"蠡县","value":"130635","parent":"130600"},{"name":"顺平县","value":"130636","parent":"130600"},{"name":"博野县","value":"130637","parent":"130600"},{"name":"雄县","value":"130638","parent":"130600"},{"name":"涿州市","value":"130681","parent":"130600"},{"name":"安国市","value":"130683","parent":"130600"},{"name":"高碑店市","value":"130684","parent":"130600"},{"name":"桥东区","value":"130702","parent":"130700"},{"name":"桥西区","value":"130703","parent":"130700"},{"name":"宣化区","value":"130705","parent":"130700"},{"name":"下花园区","value":"130706","parent":"130700"},{"name":"万全区","value":"130708","parent":"130700"},{"name":"崇礼区","value":"130709","parent":"130700"},{"name":"张北县","value":"130722","parent":"130700"},{"name":"康保县","value":"130723","parent":"130700"},{"name":"沽源县","value":"130724","parent":"130700"},{"name":"尚义县","value":"130725","parent":"130700"},{"name":"蔚县","value":"130726","parent":"130700"},{"name":"阳原县","value":"130727","parent":"130700"},{"name":"怀安县","value":"130728","parent":"130700"},{"name":"怀来县","value":"130730","parent":"130700"},{"name":"涿鹿县","value":"130731","parent":"130700"},{"name":"赤城县","value":"130732","parent":"130700"},{"name":"双桥区","value":"130802","parent":"130800"},{"name":"双滦区","value":"130803","parent":"130800"},{"name":"鹰手营子矿区","value":"130804","parent":"130800"},{"name":"承德县","value":"130821","parent":"130800"},{"name":"兴隆县","value":"130822","parent":"130800"},{"name":"平泉县","value":"130823","parent":"130800"},{"name":"滦平县","value":"130824","parent":"130800"},{"name":"隆化县","value":"130825","parent":"130800"},{"name":"丰宁满族自治县","value":"130826","parent":"130800"},{"name":"宽城满族自治县","value":"130827","parent":"130800"},{"name":"围场满族蒙古族自治县","value":"130828","parent":"130800"},{"name":"新华区","value":"130902","parent":"130900"},{"name":"运河区","value":"130903","parent":"130900"},{"name":"沧县","value":"130921","parent":"130900"},{"name":"青县","value":"130922","parent":"130900"},{"name":"东光县","value":"130923","parent":"130900"},{"name":"海兴县","value":"130924","parent":"130900"},{"name":"盐山县","value":"130925","parent":"130900"},{"name":"肃宁县","value":"130926","parent":"130900"},{"name":"南皮县","value":"130927","parent":"130900"},{"name":"吴桥县","value":"130928","parent":"130900"},{"name":"献县","value":"130929","parent":"130900"},{"name":"孟村回族自治县","value":"130930","parent":"130900"},{"name":"泊头市","value":"130981","parent":"130900"},{"name":"任丘市","value":"130982","parent":"130900"},{"name":"黄骅市","value":"130983","parent":"130900"},{"name":"河间市","value":"130984","parent":"130900"},{"name":"安次区","value":"131002","parent":"131000"},{"name":"广阳区","value":"131003","parent":"131000"},{"name":"固安县","value":"131022","parent":"131000"},{"name":"永清县","value":"131023","parent":"131000"},{"name":"香河县","value":"131024","parent":"131000"},{"name":"大城县","value":"131025","parent":"131000"},{"name":"文安县","value":"131026","parent":"131000"},{"name":"大厂回族自治县","value":"131028","parent":"131000"},{"name":"霸州市","value":"131081","parent":"131000"},{"name":"三河市","value":"131082","parent":"131000"},{"name":"桃城区","value":"131102","parent":"131100"},{"name":"冀州区","value":"131103","parent":"131100"},{"name":"枣强县","value":"131121","parent":"131100"},{"name":"武邑县","value":"131122","parent":"131100"},{"name":"武强县","value":"131123","parent":"131100"},{"name":"饶阳县","value":"131124","parent":"131100"},{"name":"安平县","value":"131125","parent":"131100"},{"name":"故城县","value":"131126","parent":"131100"},{"name":"景县","value":"131127","parent":"131100"},{"name":"阜城县","value":"131128","parent":"131100"},{"name":"深州市","value":"131182","parent":"131100"},{"name":"太原市","value":"140100","parent":"140000"},{"name":"大同市","value":"140200","parent":"140000"},{"name":"阳泉市","value":"140300","parent":"140000"},{"name":"长治市","value":"140400","parent":"140000"},{"name":"晋城市","value":"140500","parent":"140000"},{"name":"朔州市","value":"140600","parent":"140000"},{"name":"晋中市","value":"140700","parent":"140000"},{"name":"运城市","value":"140800","parent":"140000"},{"name":"忻州市","value":"140900","parent":"140000"},{"name":"临汾市","value":"141000","parent":"140000"},{"name":"吕梁市","value":"141100","parent":"140000"},{"name":"小店区","value":"140105","parent":"140100"},{"name":"迎泽区","value":"140106","parent":"140100"},{"name":"杏花岭区","value":"140107","parent":"140100"},{"name":"尖草坪区","value":"140108","parent":"140100"},{"name":"万柏林区","value":"140109","parent":"140100"},{"name":"晋源区","value":"140110","parent":"140100"},{"name":"清徐县","value":"140121","parent":"140100"},{"name":"阳曲县","value":"140122","parent":"140100"},{"name":"娄烦县","value":"140123","parent":"140100"},{"name":"古交市","value":"140181","parent":"140100"},{"name":"城区","value":"140202","parent":"140200"},{"name":"矿区","value":"140203","parent":"140200"},{"name":"南郊区","value":"140211","parent":"140200"},{"name":"新荣区","value":"140212","parent":"140200"},{"name":"阳高县","value":"140221","parent":"140200"},{"name":"天镇县","value":"140222","parent":"140200"},{"name":"广灵县","value":"140223","parent":"140200"},{"name":"灵丘县","value":"140224","parent":"140200"},{"name":"浑源县","value":"140225","parent":"140200"},{"name":"左云县","value":"140226","parent":"140200"},{"name":"大同县","value":"140227","parent":"140200"},{"name":"城区","value":"140302","parent":"140300"},{"name":"矿区","value":"140303","parent":"140300"},{"name":"郊区","value":"140311","parent":"140300"},{"name":"平定县","value":"140321","parent":"140300"},{"name":"盂县","value":"140322","parent":"140300"},{"name":"城区","value":"140402","parent":"140400"},{"name":"郊区","value":"140411","parent":"140400"},{"name":"长治县","value":"140421","parent":"140400"},{"name":"襄垣县","value":"140423","parent":"140400"},{"name":"屯留县","value":"140424","parent":"140400"},{"name":"平顺县","value":"140425","parent":"140400"},{"name":"黎城县","value":"140426","parent":"140400"},{"name":"壶关县","value":"140427","parent":"140400"},{"name":"长子县","value":"140428","parent":"140400"},{"name":"武乡县","value":"140429","parent":"140400"},{"name":"沁县","value":"140430","parent":"140400"},{"name":"沁源县","value":"140431","parent":"140400"},{"name":"潞城市","value":"140481","parent":"140400"},{"name":"城区","value":"140502","parent":"140500"},{"name":"沁水县","value":"140521","parent":"140500"},{"name":"阳城县","value":"140522","parent":"140500"},{"name":"陵川县","value":"140524","parent":"140500"},{"name":"泽州县","value":"140525","parent":"140500"},{"name":"高平市","value":"140581","parent":"140500"},{"name":"朔城区","value":"140602","parent":"140600"},{"name":"平鲁区","value":"140603","parent":"140600"},{"name":"山阴县","value":"140621","parent":"140600"},{"name":"应县","value":"140622","parent":"140600"},{"name":"右玉县","value":"140623","parent":"140600"},{"name":"怀仁县","value":"140624","parent":"140600"},{"name":"榆次区","value":"140702","parent":"140700"},{"name":"榆社县","value":"140721","parent":"140700"},{"name":"左权县","value":"140722","parent":"140700"},{"name":"和顺县","value":"140723","parent":"140700"},{"name":"昔阳县","value":"140724","parent":"140700"},{"name":"寿阳县","value":"140725","parent":"140700"},{"name":"太谷县","value":"140726","parent":"140700"},{"name":"祁县","value":"140727","parent":"140700"},{"name":"平遥县","value":"140728","parent":"140700"},{"name":"灵石县","value":"140729","parent":"140700"},{"name":"介休市","value":"140781","parent":"140700"},{"name":"盐湖区","value":"140802","parent":"140800"},{"name":"临猗县","value":"140821","parent":"140800"},{"name":"万荣县","value":"140822","parent":"140800"},{"name":"闻喜县","value":"140823","parent":"140800"},{"name":"稷山县","value":"140824","parent":"140800"},{"name":"新绛县","value":"140825","parent":"140800"},{"name":"绛县","value":"140826","parent":"140800"},{"name":"垣曲县","value":"140827","parent":"140800"},{"name":"夏县","value":"140828","parent":"140800"},{"name":"平陆县","value":"140829","parent":"140800"},{"name":"芮城县","value":"140830","parent":"140800"},{"name":"永济市","value":"140881","parent":"140800"},{"name":"河津市","value":"140882","parent":"140800"},{"name":"忻府区","value":"140902","parent":"140900"},{"name":"定襄县","value":"140921","parent":"140900"},{"name":"五台县","value":"140922","parent":"140900"},{"name":"代县","value":"140923","parent":"140900"},{"name":"繁峙县","value":"140924","parent":"140900"},{"name":"宁武县","value":"140925","parent":"140900"},{"name":"静乐县","value":"140926","parent":"140900"},{"name":"神池县","value":"140927","parent":"140900"},{"name":"五寨县","value":"140928","parent":"140900"},{"name":"岢岚县","value":"140929","parent":"140900"},{"name":"河曲县","value":"140930","parent":"140900"},{"name":"保德县","value":"140931","parent":"140900"},{"name":"偏关县","value":"140932","parent":"140900"},{"name":"原平市","value":"140981","parent":"140900"},{"name":"尧都区","value":"141002","parent":"141000"},{"name":"曲沃县","value":"141021","parent":"141000"},{"name":"翼城县","value":"141022","parent":"141000"},{"name":"襄汾县","value":"141023","parent":"141000"},{"name":"洪洞县","value":"141024","parent":"141000"},{"name":"古县","value":"141025","parent":"141000"},{"name":"安泽县","value":"141026","parent":"141000"},{"name":"浮山县","value":"141027","parent":"141000"},{"name":"吉县","value":"141028","parent":"141000"},{"name":"乡宁县","value":"141029","parent":"141000"},{"name":"大宁县","value":"141030","parent":"141000"},{"name":"隰县","value":"141031","parent":"141000"},{"name":"永和县","value":"141032","parent":"141000"},{"name":"蒲县","value":"141033","parent":"141000"},{"name":"汾西县","value":"141034","parent":"141000"},{"name":"侯马市","value":"141081","parent":"141000"},{"name":"霍州市","value":"141082","parent":"141000"},{"name":"离石区","value":"141102","parent":"141100"},{"name":"文水县","value":"141121","parent":"141100"},{"name":"交城县","value":"141122","parent":"141100"},{"name":"兴县","value":"141123","parent":"141100"},{"name":"临县","value":"141124","parent":"141100"},{"name":"柳林县","value":"141125","parent":"141100"},{"name":"石楼县","value":"141126","parent":"141100"},{"name":"岚县","value":"141127","parent":"141100"},{"name":"方山县","value":"141128","parent":"141100"},{"name":"中阳县","value":"141129","parent":"141100"},{"name":"交口县","value":"141130","parent":"141100"},{"name":"孝义市","value":"141181","parent":"141100"},{"name":"汾阳市","value":"141182","parent":"141100"},{"name":"呼和浩特市","value":"150100","parent":"150000"},{"name":"包头市","value":"150200","parent":"150000"},{"name":"乌海市","value":"150300","parent":"150000"},{"name":"赤峰市","value":"150400","parent":"150000"},{"name":"通辽市","value":"150500","parent":"150000"},{"name":"鄂尔多斯市","value":"150600","parent":"150000"},{"name":"呼伦贝尔市","value":"150700","parent":"150000"},{"name":"巴彦淖尔市","value":"150800","parent":"150000"},{"name":"乌兰察布市","value":"150900","parent":"150000"},{"name":"兴安盟","value":"152200","parent":"150000"},{"name":"锡林郭勒盟","value":"152500","parent":"150000"},{"name":"阿拉善盟","value":"152900","parent":"150000"},{"name":"新城区","value":"150102","parent":"150100"},{"name":"回民区","value":"150103","parent":"150100"},{"name":"玉泉区","value":"150104","parent":"150100"},{"name":"赛罕区","value":"150105","parent":"150100"},{"name":"土默特左旗","value":"150121","parent":"150100"},{"name":"托克托县","value":"150122","parent":"150100"},{"name":"和林格尔县","value":"150123","parent":"150100"},{"name":"清水河县","value":"150124","parent":"150100"},{"name":"武川县","value":"150125","parent":"150100"},{"name":"东河区","value":"150202","parent":"150200"},{"name":"昆都仑区","value":"150203","parent":"150200"},{"name":"青山区","value":"150204","parent":"150200"},{"name":"石拐区","value":"150205","parent":"150200"},{"name":"白云鄂博矿区","value":"150206","parent":"150200"},{"name":"九原区","value":"150207","parent":"150200"},{"name":"土默特右旗","value":"150221","parent":"150200"},{"name":"固阳县","value":"150222","parent":"150200"},{"name":"达尔罕茂明安联合旗","value":"150223","parent":"150200"},{"name":"海勃湾区","value":"150302","parent":"150300"},{"name":"海南区","value":"150303","parent":"150300"},{"name":"乌达区","value":"150304","parent":"150300"},{"name":"红山区","value":"150402","parent":"150400"},{"name":"元宝山区","value":"150403","parent":"150400"},{"name":"松山区","value":"150404","parent":"150400"},{"name":"阿鲁科尔沁旗","value":"150421","parent":"150400"},{"name":"巴林左旗","value":"150422","parent":"150400"},{"name":"巴林右旗","value":"150423","parent":"150400"},{"name":"林西县","value":"150424","parent":"150400"},{"name":"克什克腾旗","value":"150425","parent":"150400"},{"name":"翁牛特旗","value":"150426","parent":"150400"},{"name":"喀喇沁旗","value":"150428","parent":"150400"},{"name":"宁城县","value":"150429","parent":"150400"},{"name":"敖汉旗","value":"150430","parent":"150400"},{"name":"科尔沁区","value":"150502","parent":"150500"},{"name":"科尔沁左翼中旗","value":"150521","parent":"150500"},{"name":"科尔沁左翼后旗","value":"150522","parent":"150500"},{"name":"开鲁县","value":"150523","parent":"150500"},{"name":"库伦旗","value":"150524","parent":"150500"},{"name":"奈曼旗","value":"150525","parent":"150500"},{"name":"扎鲁特旗","value":"150526","parent":"150500"},{"name":"霍林郭勒市","value":"150581","parent":"150500"},{"name":"东胜区","value":"150602","parent":"150600"},{"name":"康巴什区","value":"150603","parent":"150600"},{"name":"达拉特旗","value":"150621","parent":"150600"},{"name":"准格尔旗","value":"150622","parent":"150600"},{"name":"鄂托克前旗","value":"150623","parent":"150600"},{"name":"鄂托克旗","value":"150624","parent":"150600"},{"name":"杭锦旗","value":"150625","parent":"150600"},{"name":"乌审旗","value":"150626","parent":"150600"},{"name":"伊金霍洛旗","value":"150627","parent":"150600"},{"name":"海拉尔区","value":"150702","parent":"150700"},{"name":"扎赉诺尔区","value":"150703","parent":"150700"},{"name":"阿荣旗","value":"150721","parent":"150700"},{"name":"莫力达瓦达斡尔族自治旗","value":"150722","parent":"150700"},{"name":"鄂伦春自治旗","value":"150723","parent":"150700"},{"name":"鄂温克族自治旗","value":"150724","parent":"150700"},{"name":"陈巴尔虎旗","value":"150725","parent":"150700"},{"name":"新巴尔虎左旗","value":"150726","parent":"150700"},{"name":"新巴尔虎右旗","value":"150727","parent":"150700"},{"name":"满洲里市","value":"150781","parent":"150700"},{"name":"牙克石市","value":"150782","parent":"150700"},{"name":"扎兰屯市","value":"150783","parent":"150700"},{"name":"额尔古纳市","value":"150784","parent":"150700"},{"name":"根河市","value":"150785","parent":"150700"},{"name":"临河区","value":"150802","parent":"150800"},{"name":"五原县","value":"150821","parent":"150800"},{"name":"磴口县","value":"150822","parent":"150800"},{"name":"乌拉特前旗","value":"150823","parent":"150800"},{"name":"乌拉特中旗","value":"150824","parent":"150800"},{"name":"乌拉特后旗","value":"150825","parent":"150800"},{"name":"杭锦后旗","value":"150826","parent":"150800"},{"name":"集宁区","value":"150902","parent":"150900"},{"name":"卓资县","value":"150921","parent":"150900"},{"name":"化德县","value":"150922","parent":"150900"},{"name":"商都县","value":"150923","parent":"150900"},{"name":"兴和县","value":"150924","parent":"150900"},{"name":"凉城县","value":"150925","parent":"150900"},{"name":"察哈尔右翼前旗","value":"150926","parent":"150900"},{"name":"察哈尔右翼中旗","value":"150927","parent":"150900"},{"name":"察哈尔右翼后旗","value":"150928","parent":"150900"},{"name":"四子王旗","value":"150929","parent":"150900"},{"name":"丰镇市","value":"150981","parent":"150900"},{"name":"乌兰浩特市","value":"152201","parent":"152200"},{"name":"阿尔山市","value":"152202","parent":"152200"},{"name":"科尔沁右翼前旗","value":"152221","parent":"152200"},{"name":"科尔沁右翼中旗","value":"152222","parent":"152200"},{"name":"扎赉特旗","value":"152223","parent":"152200"},{"name":"突泉县","value":"152224","parent":"152200"},{"name":"二连浩特市","value":"152501","parent":"152500"},{"name":"锡林浩特市","value":"152502","parent":"152500"},{"name":"阿巴嘎旗","value":"152522","parent":"152500"},{"name":"苏尼特左旗","value":"152523","parent":"152500"},{"name":"苏尼特右旗","value":"152524","parent":"152500"},{"name":"东乌珠穆沁旗","value":"152525","parent":"152500"},{"name":"西乌珠穆沁旗","value":"152526","parent":"152500"},{"name":"太仆寺旗","value":"152527","parent":"152500"},{"name":"镶黄旗","value":"152528","parent":"152500"},{"name":"正镶白旗","value":"152529","parent":"152500"},{"name":"正蓝旗","value":"152530","parent":"152500"},{"name":"多伦县","value":"152531","parent":"152500"},{"name":"阿拉善左旗","value":"152921","parent":"152900"},{"name":"阿拉善右旗","value":"152922","parent":"152900"},{"name":"额济纳旗","value":"152923","parent":"152900"},{"name":"沈阳市","value":"210100","parent":"210000"},{"name":"大连市","value":"210200","parent":"210000"},{"name":"鞍山市","value":"210300","parent":"210000"},{"name":"抚顺市","value":"210400","parent":"210000"},{"name":"本溪市","value":"210500","parent":"210000"},{"name":"丹东市","value":"210600","parent":"210000"},{"name":"锦州市","value":"210700","parent":"210000"},{"name":"营口市","value":"210800","parent":"210000"},{"name":"阜新市","value":"210900","parent":"210000"},{"name":"辽阳市","value":"211000","parent":"210000"},{"name":"盘锦市","value":"211100","parent":"210000"},{"name":"铁岭市","value":"211200","parent":"210000"},{"name":"朝阳市","value":"211300","parent":"210000"},{"name":"葫芦岛市","value":"211400","parent":"210000"},{"name":"和平区","value":"210102","parent":"210100"},{"name":"沈河区","value":"210103","parent":"210100"},{"name":"大东区","value":"210104","parent":"210100"},{"name":"皇姑区","value":"210105","parent":"210100"},{"name":"铁西区","value":"210106","parent":"210100"},{"name":"苏家屯区","value":"210111","parent":"210100"},{"name":"浑南区","value":"210112","parent":"210100"},{"name":"沈北新区","value":"210113","parent":"210100"},{"name":"于洪区","value":"210114","parent":"210100"},{"name":"辽中区","value":"210115","parent":"210100"},{"name":"康平县","value":"210123","parent":"210100"},{"name":"法库县","value":"210124","parent":"210100"},{"name":"新民市","value":"210181","parent":"210100"},{"name":"中山区","value":"210202","parent":"210200"},{"name":"西岗区","value":"210203","parent":"210200"},{"name":"沙河口区","value":"210204","parent":"210200"},{"name":"甘井子区","value":"210211","parent":"210200"},{"name":"旅顺口区","value":"210212","parent":"210200"},{"name":"金州区","value":"210213","parent":"210200"},{"name":"普兰店区","value":"210214","parent":"210200"},{"name":"长海县","value":"210224","parent":"210200"},{"name":"瓦房店市","value":"210281","parent":"210200"},{"name":"庄河市","value":"210283","parent":"210200"},{"name":"铁东区","value":"210302","parent":"210300"},{"name":"铁西区","value":"210303","parent":"210300"},{"name":"立山区","value":"210304","parent":"210300"},{"name":"千山区","value":"210311","parent":"210300"},{"name":"台安县","value":"210321","parent":"210300"},{"name":"岫岩满族自治县","value":"210323","parent":"210300"},{"name":"海城市","value":"210381","parent":"210300"},{"name":"新抚区","value":"210402","parent":"210400"},{"name":"东洲区","value":"210403","parent":"210400"},{"name":"望花区","value":"210404","parent":"210400"},{"name":"顺城区","value":"210411","parent":"210400"},{"name":"抚顺县","value":"210421","parent":"210400"},{"name":"新宾满族自治县","value":"210422","parent":"210400"},{"name":"清原满族自治县","value":"210423","parent":"210400"},{"name":"平山区","value":"210502","parent":"210500"},{"name":"溪湖区","value":"210503","parent":"210500"},{"name":"明山区","value":"210504","parent":"210500"},{"name":"南芬区","value":"210505","parent":"210500"},{"name":"本溪满族自治县","value":"210521","parent":"210500"},{"name":"桓仁满族自治县","value":"210522","parent":"210500"},{"name":"元宝区","value":"210602","parent":"210600"},{"name":"振兴区","value":"210603","parent":"210600"},{"name":"振安区","value":"210604","parent":"210600"},{"name":"宽甸满族自治县","value":"210624","parent":"210600"},{"name":"东港市","value":"210681","parent":"210600"},{"name":"凤城市","value":"210682","parent":"210600"},{"name":"古塔区","value":"210702","parent":"210700"},{"name":"凌河区","value":"210703","parent":"210700"},{"name":"太和区","value":"210711","parent":"210700"},{"name":"黑山县","value":"210726","parent":"210700"},{"name":"义县","value":"210727","parent":"210700"},{"name":"凌海市","value":"210781","parent":"210700"},{"name":"北镇市","value":"210782","parent":"210700"},{"name":"站前区","value":"210802","parent":"210800"},{"name":"西市区","value":"210803","parent":"210800"},{"name":"鲅鱼圈区","value":"210804","parent":"210800"},{"name":"老边区","value":"210811","parent":"210800"},{"name":"盖州市","value":"210881","parent":"210800"},{"name":"大石桥市","value":"210882","parent":"210800"},{"name":"海州区","value":"210902","parent":"210900"},{"name":"新邱区","value":"210903","parent":"210900"},{"name":"太平区","value":"210904","parent":"210900"},{"name":"清河门区","value":"210905","parent":"210900"},{"name":"细河区","value":"210911","parent":"210900"},{"name":"阜新蒙古族自治县","value":"210921","parent":"210900"},{"name":"彰武县","value":"210922","parent":"210900"},{"name":"白塔区","value":"211002","parent":"211000"},{"name":"文圣区","value":"211003","parent":"211000"},{"name":"宏伟区","value":"211004","parent":"211000"},{"name":"弓长岭区","value":"211005","parent":"211000"},{"name":"太子河区","value":"211011","parent":"211000"},{"name":"辽阳县","value":"211021","parent":"211000"},{"name":"灯塔市","value":"211081","parent":"211000"},{"name":"双台子区","value":"211102","parent":"211100"},{"name":"兴隆台区","value":"211103","parent":"211100"},{"name":"大洼区","value":"211104","parent":"211100"},{"name":"盘山县","value":"211122","parent":"211100"},{"name":"银州区","value":"211202","parent":"211200"},{"name":"清河区","value":"211204","parent":"211200"},{"name":"铁岭县","value":"211221","parent":"211200"},{"name":"西丰县","value":"211223","parent":"211200"},{"name":"昌图县","value":"211224","parent":"211200"},{"name":"调兵山市","value":"211281","parent":"211200"},{"name":"开原市","value":"211282","parent":"211200"},{"name":"双塔区","value":"211302","parent":"211300"},{"name":"龙城区","value":"211303","parent":"211300"},{"name":"朝阳县","value":"211321","parent":"211300"},{"name":"建平县","value":"211322","parent":"211300"},{"name":"喀喇沁左翼蒙古族自治县","value":"211324","parent":"211300"},{"name":"北票市","value":"211381","parent":"211300"},{"name":"凌源市","value":"211382","parent":"211300"},{"name":"连山区","value":"211402","parent":"211400"},{"name":"龙港区","value":"211403","parent":"211400"},{"name":"南票区","value":"211404","parent":"211400"},{"name":"绥中县","value":"211421","parent":"211400"},{"name":"建昌县","value":"211422","parent":"211400"},{"name":"兴城市","value":"211481","parent":"211400"},{"name":"长春市","value":"220100","parent":"220000"},{"name":"吉林市","value":"220200","parent":"220000"},{"name":"四平市","value":"220300","parent":"220000"},{"name":"辽源市","value":"220400","parent":"220000"},{"name":"通化市","value":"220500","parent":"220000"},{"name":"白山市","value":"220600","parent":"220000"},{"name":"松原市","value":"220700","parent":"220000"},{"name":"白城市","value":"220800","parent":"220000"},{"name":"延边朝鲜族自治州","value":"222400","parent":"220000"},{"name":"南关区","value":"220102","parent":"220100"},{"name":"宽城区","value":"220103","parent":"220100"},{"name":"朝阳区","value":"220104","parent":"220100"},{"name":"二道区","value":"220105","parent":"220100"},{"name":"绿园区","value":"220106","parent":"220100"},{"name":"双阳区","value":"220112","parent":"220100"},{"name":"九台区","value":"220113","parent":"220100"},{"name":"农安县","value":"220122","parent":"220100"},{"name":"榆树市","value":"220182","parent":"220100"},{"name":"德惠市","value":"220183","parent":"220100"},{"name":"昌邑区","value":"220202","parent":"220200"},{"name":"龙潭区","value":"220203","parent":"220200"},{"name":"船营区","value":"220204","parent":"220200"},{"name":"丰满区","value":"220211","parent":"220200"},{"name":"永吉县","value":"220221","parent":"220200"},{"name":"蛟河市","value":"220281","parent":"220200"},{"name":"桦甸市","value":"220282","parent":"220200"},{"name":"舒兰市","value":"220283","parent":"220200"},{"name":"磐石市","value":"220284","parent":"220200"},{"name":"铁西区","value":"220302","parent":"220300"},{"name":"铁东区","value":"220303","parent":"220300"},{"name":"梨树县","value":"220322","parent":"220300"},{"name":"伊通满族自治县","value":"220323","parent":"220300"},{"name":"公主岭市","value":"220381","parent":"220300"},{"name":"双辽市","value":"220382","parent":"220300"},{"name":"龙山区","value":"220402","parent":"220400"},{"name":"西安区","value":"220403","parent":"220400"},{"name":"东丰县","value":"220421","parent":"220400"},{"name":"东辽县","value":"220422","parent":"220400"},{"name":"东昌区","value":"220502","parent":"220500"},{"name":"二道江区","value":"220503","parent":"220500"},{"name":"通化县","value":"220521","parent":"220500"},{"name":"辉南县","value":"220523","parent":"220500"},{"name":"柳河县","value":"220524","parent":"220500"},{"name":"梅河口市","value":"220581","parent":"220500"},{"name":"集安市","value":"220582","parent":"220500"},{"name":"浑江区","value":"220602","parent":"220600"},{"name":"江源区","value":"220605","parent":"220600"},{"name":"抚松县","value":"220621","parent":"220600"},{"name":"靖宇县","value":"220622","parent":"220600"},{"name":"长白朝鲜族自治县","value":"220623","parent":"220600"},{"name":"临江市","value":"220681","parent":"220600"},{"name":"宁江区","value":"220702","parent":"220700"},{"name":"前郭尔罗斯蒙古族自治县","value":"220721","parent":"220700"},{"name":"长岭县","value":"220722","parent":"220700"},{"name":"乾安县","value":"220723","parent":"220700"},{"name":"扶余市","value":"220781","parent":"220700"},{"name":"洮北区","value":"220802","parent":"220800"},{"name":"镇赉县","value":"220821","parent":"220800"},{"name":"通榆县","value":"220822","parent":"220800"},{"name":"洮南市","value":"220881","parent":"220800"},{"name":"大安市","value":"220882","parent":"220800"},{"name":"延吉市","value":"222401","parent":"222400"},{"name":"图们市","value":"222402","parent":"222400"},{"name":"敦化市","value":"222403","parent":"222400"},{"name":"珲春市","value":"222404","parent":"222400"},{"name":"龙井市","value":"222405","parent":"222400"},{"name":"和龙市","value":"222406","parent":"222400"},{"name":"汪清县","value":"222424","parent":"222400"},{"name":"安图县","value":"222426","parent":"222400"},{"name":"哈尔滨市","value":"230100","parent":"230000"},{"name":"齐齐哈尔市","value":"230200","parent":"230000"},{"name":"鸡西市","value":"230300","parent":"230000"},{"name":"鹤岗市","value":"230400","parent":"230000"},{"name":"双鸭山市","value":"230500","parent":"230000"},{"name":"大庆市","value":"230600","parent":"230000"},{"name":"伊春市","value":"230700","parent":"230000"},{"name":"佳木斯市","value":"230800","parent":"230000"},{"name":"七台河市","value":"230900","parent":"230000"},{"name":"牡丹江市","value":"231000","parent":"230000"},{"name":"黑河市","value":"231100","parent":"230000"},{"name":"绥化市","value":"231200","parent":"230000"},{"name":"大兴安岭地区","value":"232700","parent":"230000"},{"name":"道里区","value":"230102","parent":"230100"},{"name":"南岗区","value":"230103","parent":"230100"},{"name":"道外区","value":"230104","parent":"230100"},{"name":"平房区","value":"230108","parent":"230100"},{"name":"松北区","value":"230109","parent":"230100"},{"name":"香坊区","value":"230110","parent":"230100"},{"name":"呼兰区","value":"230111","parent":"230100"},{"name":"阿城区","value":"230112","parent":"230100"},{"name":"双城区","value":"230113","parent":"230100"},{"name":"依兰县","value":"230123","parent":"230100"},{"name":"方正县","value":"230124","parent":"230100"},{"name":"宾县","value":"230125","parent":"230100"},{"name":"巴彦县","value":"230126","parent":"230100"},{"name":"木兰县","value":"230127","parent":"230100"},{"name":"通河县","value":"230128","parent":"230100"},{"name":"延寿县","value":"230129","parent":"230100"},{"name":"尚志市","value":"230183","parent":"230100"},{"name":"五常市","value":"230184","parent":"230100"},{"name":"龙沙区","value":"230202","parent":"230200"},{"name":"建华区","value":"230203","parent":"230200"},{"name":"铁锋区","value":"230204","parent":"230200"},{"name":"昂昂溪区","value":"230205","parent":"230200"},{"name":"富拉尔基区","value":"230206","parent":"230200"},{"name":"碾子山区","value":"230207","parent":"230200"},{"name":"梅里斯达斡尔族区","value":"230208","parent":"230200"},{"name":"龙江县","value":"230221","parent":"230200"},{"name":"依安县","value":"230223","parent":"230200"},{"name":"泰来县","value":"230224","parent":"230200"},{"name":"甘南县","value":"230225","parent":"230200"},{"name":"富裕县","value":"230227","parent":"230200"},{"name":"克山县","value":"230229","parent":"230200"},{"name":"克东县","value":"230230","parent":"230200"},{"name":"拜泉县","value":"230231","parent":"230200"},{"name":"讷河市","value":"230281","parent":"230200"},{"name":"鸡冠区","value":"230302","parent":"230300"},{"name":"恒山区","value":"230303","parent":"230300"},{"name":"滴道区","value":"230304","parent":"230300"},{"name":"梨树区","value":"230305","parent":"230300"},{"name":"城子河区","value":"230306","parent":"230300"},{"name":"麻山区","value":"230307","parent":"230300"},{"name":"鸡东县","value":"230321","parent":"230300"},{"name":"虎林市","value":"230381","parent":"230300"},{"name":"密山市","value":"230382","parent":"230300"},{"name":"向阳区","value":"230402","parent":"230400"},{"name":"工农区","value":"230403","parent":"230400"},{"name":"南山区","value":"230404","parent":"230400"},{"name":"兴安区","value":"230405","parent":"230400"},{"name":"东山区","value":"230406","parent":"230400"},{"name":"兴山区","value":"230407","parent":"230400"},{"name":"萝北县","value":"230421","parent":"230400"},{"name":"绥滨县","value":"230422","parent":"230400"},{"name":"尖山区","value":"230502","parent":"230500"},{"name":"岭东区","value":"230503","parent":"230500"},{"name":"四方台区","value":"230505","parent":"230500"},{"name":"宝山区","value":"230506","parent":"230500"},{"name":"集贤县","value":"230521","parent":"230500"},{"name":"友谊县","value":"230522","parent":"230500"},{"name":"宝清县","value":"230523","parent":"230500"},{"name":"饶河县","value":"230524","parent":"230500"},{"name":"萨尔图区","value":"230602","parent":"230600"},{"name":"龙凤区","value":"230603","parent":"230600"},{"name":"让胡路区","value":"230604","parent":"230600"},{"name":"红岗区","value":"230605","parent":"230600"},{"name":"大同区","value":"230606","parent":"230600"},{"name":"肇州县","value":"230621","parent":"230600"},{"name":"肇源县","value":"230622","parent":"230600"},{"name":"林甸县","value":"230623","parent":"230600"},{"name":"杜尔伯特蒙古族自治县","value":"230624","parent":"230600"},{"name":"伊春区","value":"230702","parent":"230700"},{"name":"南岔区","value":"230703","parent":"230700"},{"name":"友好区","value":"230704","parent":"230700"},{"name":"西林区","value":"230705","parent":"230700"},{"name":"翠峦区","value":"230706","parent":"230700"},{"name":"新青区","value":"230707","parent":"230700"},{"name":"美溪区","value":"230708","parent":"230700"},{"name":"金山屯区","value":"230709","parent":"230700"},{"name":"五营区","value":"230710","parent":"230700"},{"name":"乌马河区","value":"230711","parent":"230700"},{"name":"汤旺河区","value":"230712","parent":"230700"},{"name":"带岭区","value":"230713","parent":"230700"},{"name":"乌伊岭区","value":"230714","parent":"230700"},{"name":"红星区","value":"230715","parent":"230700"},{"name":"上甘岭区","value":"230716","parent":"230700"},{"name":"嘉荫县","value":"230722","parent":"230700"},{"name":"铁力市","value":"230781","parent":"230700"},{"name":"向阳区","value":"230803","parent":"230800"},{"name":"前进区","value":"230804","parent":"230800"},{"name":"东风区","value":"230805","parent":"230800"},{"name":"郊区","value":"230811","parent":"230800"},{"name":"桦南县","value":"230822","parent":"230800"},{"name":"桦川县","value":"230826","parent":"230800"},{"name":"汤原县","value":"230828","parent":"230800"},{"name":"同江市","value":"230881","parent":"230800"},{"name":"富锦市","value":"230882","parent":"230800"},{"name":"抚远市","value":"230883","parent":"230800"},{"name":"新兴区","value":"230902","parent":"230900"},{"name":"桃山区","value":"230903","parent":"230900"},{"name":"茄子河区","value":"230904","parent":"230900"},{"name":"勃利县","value":"230921","parent":"230900"},{"name":"东安区","value":"231002","parent":"231000"},{"name":"阳明区","value":"231003","parent":"231000"},{"name":"爱民区","value":"231004","parent":"231000"},{"name":"西安区","value":"231005","parent":"231000"},{"name":"林口县","value":"231025","parent":"231000"},{"name":"绥芬河市","value":"231081","parent":"231000"},{"name":"海林市","value":"231083","parent":"231000"},{"name":"宁安市","value":"231084","parent":"231000"},{"name":"穆棱市","value":"231085","parent":"231000"},{"name":"东宁市","value":"231086","parent":"231000"},{"name":"爱辉区","value":"231102","parent":"231100"},{"name":"嫩江县","value":"231121","parent":"231100"},{"name":"逊克县","value":"231123","parent":"231100"},{"name":"孙吴县","value":"231124","parent":"231100"},{"name":"北安市","value":"231181","parent":"231100"},{"name":"五大连池市","value":"231182","parent":"231100"},{"name":"北林区","value":"231202","parent":"231200"},{"name":"望奎县","value":"231221","parent":"231200"},{"name":"兰西县","value":"231222","parent":"231200"},{"name":"青冈县","value":"231223","parent":"231200"},{"name":"庆安县","value":"231224","parent":"231200"},{"name":"明水县","value":"231225","parent":"231200"},{"name":"绥棱县","value":"231226","parent":"231200"},{"name":"安达市","value":"231281","parent":"231200"},{"name":"肇东市","value":"231282","parent":"231200"},{"name":"海伦市","value":"231283","parent":"231200"},{"name":"呼玛县","value":"232721","parent":"232700"},{"name":"塔河县","value":"232722","parent":"232700"},{"name":"漠河县","value":"232723","parent":"232700"},{"name":"市辖区","value":"310100","parent":"310000"},{"name":"黄浦区","value":"310101","parent":"310100"},{"name":"徐汇区","value":"310104","parent":"310100"},{"name":"长宁区","value":"310105","parent":"310100"},{"name":"静安区","value":"310106","parent":"310100"},{"name":"普陀区","value":"310107","parent":"310100"},{"name":"虹口区","value":"310109","parent":"310100"},{"name":"杨浦区","value":"310110","parent":"310100"},{"name":"闵行区","value":"310112","parent":"310100"},{"name":"宝山区","value":"310113","parent":"310100"},{"name":"嘉定区","value":"310114","parent":"310100"},{"name":"浦东新区","value":"310115","parent":"310100"},{"name":"金山区","value":"310116","parent":"310100"},{"name":"松江区","value":"310117","parent":"310100"},{"name":"青浦区","value":"310118","parent":"310100"},{"name":"奉贤区","value":"310120","parent":"310100"},{"name":"崇明区","value":"310151","parent":"310100"},{"name":"南京市","value":"320100","parent":"320000"},{"name":"无锡市","value":"320200","parent":"320000"},{"name":"徐州市","value":"320300","parent":"320000"},{"name":"常州市","value":"320400","parent":"320000"},{"name":"苏州市","value":"320500","parent":"320000"},{"name":"南通市","value":"320600","parent":"320000"},{"name":"连云港市","value":"320700","parent":"320000"},{"name":"淮安市","value":"320800","parent":"320000"},{"name":"盐城市","value":"320900","parent":"320000"},{"name":"扬州市","value":"321000","parent":"320000"},{"name":"镇江市","value":"321100","parent":"320000"},{"name":"泰州市","value":"321200","parent":"320000"},{"name":"宿迁市","value":"321300","parent":"320000"},{"name":"玄武区","value":"320102","parent":"320100"},{"name":"秦淮区","value":"320104","parent":"320100"},{"name":"建邺区","value":"320105","parent":"320100"},{"name":"鼓楼区","value":"320106","parent":"320100"},{"name":"浦口区","value":"320111","parent":"320100"},{"name":"栖霞区","value":"320113","parent":"320100"},{"name":"雨花台区","value":"320114","parent":"320100"},{"name":"江宁区","value":"320115","parent":"320100"},{"name":"六合区","value":"320116","parent":"320100"},{"name":"溧水区","value":"320117","parent":"320100"},{"name":"高淳区","value":"320118","parent":"320100"},{"name":"锡山区","value":"320205","parent":"320200"},{"name":"惠山区","value":"320206","parent":"320200"},{"name":"滨湖区","value":"320211","parent":"320200"},{"name":"梁溪区","value":"320213","parent":"320200"},{"name":"新吴区","value":"320214","parent":"320200"},{"name":"江阴市","value":"320281","parent":"320200"},{"name":"宜兴市","value":"320282","parent":"320200"},{"name":"鼓楼区","value":"320302","parent":"320300"},{"name":"云龙区","value":"320303","parent":"320300"},{"name":"贾汪区","value":"320305","parent":"320300"},{"name":"泉山区","value":"320311","parent":"320300"},{"name":"铜山区","value":"320312","parent":"320300"},{"name":"丰县","value":"320321","parent":"320300"},{"name":"沛县","value":"320322","parent":"320300"},{"name":"睢宁县","value":"320324","parent":"320300"},{"name":"新沂市","value":"320381","parent":"320300"},{"name":"邳州市","value":"320382","parent":"320300"},{"name":"天宁区","value":"320402","parent":"320400"},{"name":"钟楼区","value":"320404","parent":"320400"},{"name":"新北区","value":"320411","parent":"320400"},{"name":"武进区","value":"320412","parent":"320400"},{"name":"金坛区","value":"320413","parent":"320400"},{"name":"溧阳市","value":"320481","parent":"320400"},{"name":"虎丘区","value":"320505","parent":"320500"},{"name":"吴中区","value":"320506","parent":"320500"},{"name":"相城区","value":"320507","parent":"320500"},{"name":"姑苏区","value":"320508","parent":"320500"},{"name":"吴江区","value":"320509","parent":"320500"},{"name":"常熟市","value":"320581","parent":"320500"},{"name":"张家港市","value":"320582","parent":"320500"},{"name":"昆山市","value":"320583","parent":"320500"},{"name":"太仓市","value":"320585","parent":"320500"},{"name":"崇川区","value":"320602","parent":"320600"},{"name":"港闸区","value":"320611","parent":"320600"},{"name":"通州区","value":"320612","parent":"320600"},{"name":"海安县","value":"320621","parent":"320600"},{"name":"如东县","value":"320623","parent":"320600"},{"name":"启东市","value":"320681","parent":"320600"},{"name":"如皋市","value":"320682","parent":"320600"},{"name":"海门市","value":"320684","parent":"320600"},{"name":"连云区","value":"320703","parent":"320700"},{"name":"海州区","value":"320706","parent":"320700"},{"name":"赣榆区","value":"320707","parent":"320700"},{"name":"东海县","value":"320722","parent":"320700"},{"name":"灌云县","value":"320723","parent":"320700"},{"name":"灌南县","value":"320724","parent":"320700"},{"name":"淮安区","value":"320803","parent":"320800"},{"name":"淮阴区","value":"320804","parent":"320800"},{"name":"清江浦区","value":"320812","parent":"320800"},{"name":"洪泽区","value":"320813","parent":"320800"},{"name":"涟水县","value":"320826","parent":"320800"},{"name":"盱眙县","value":"320830","parent":"320800"},{"name":"金湖县","value":"320831","parent":"320800"},{"name":"亭湖区","value":"320902","parent":"320900"},{"name":"盐都区","value":"320903","parent":"320900"},{"name":"大丰区","value":"320904","parent":"320900"},{"name":"响水县","value":"320921","parent":"320900"},{"name":"滨海县","value":"320922","parent":"320900"},{"name":"阜宁县","value":"320923","parent":"320900"},{"name":"射阳县","value":"320924","parent":"320900"},{"name":"建湖县","value":"320925","parent":"320900"},{"name":"东台市","value":"320981","parent":"320900"},{"name":"广陵区","value":"321002","parent":"321000"},{"name":"邗江区","value":"321003","parent":"321000"},{"name":"江都区","value":"321012","parent":"321000"},{"name":"宝应县","value":"321023","parent":"321000"},{"name":"仪征市","value":"321081","parent":"321000"},{"name":"高邮市","value":"321084","parent":"321000"},{"name":"京口区","value":"321102","parent":"321100"},{"name":"润州区","value":"321111","parent":"321100"},{"name":"丹徒区","value":"321112","parent":"321100"},{"name":"丹阳市","value":"321181","parent":"321100"},{"name":"扬中市","value":"321182","parent":"321100"},{"name":"句容市","value":"321183","parent":"321100"},{"name":"海陵区","value":"321202","parent":"321200"},{"name":"高港区","value":"321203","parent":"321200"},{"name":"姜堰区","value":"321204","parent":"321200"},{"name":"兴化市","value":"321281","parent":"321200"},{"name":"靖江市","value":"321282","parent":"321200"},{"name":"泰兴市","value":"321283","parent":"321200"},{"name":"宿城区","value":"321302","parent":"321300"},{"name":"宿豫区","value":"321311","parent":"321300"},{"name":"沭阳县","value":"321322","parent":"321300"},{"name":"泗阳县","value":"321323","parent":"321300"},{"name":"泗洪县","value":"321324","parent":"321300"},{"name":"杭州市","value":"330100","parent":"330000"},{"name":"宁波市","value":"330200","parent":"330000"},{"name":"温州市","value":"330300","parent":"330000"},{"name":"嘉兴市","value":"330400","parent":"330000"},{"name":"湖州市","value":"330500","parent":"330000"},{"name":"绍兴市","value":"330600","parent":"330000"},{"name":"金华市","value":"330700","parent":"330000"},{"name":"衢州市","value":"330800","parent":"330000"},{"name":"舟山市","value":"330900","parent":"330000"},{"name":"台州市","value":"331000","parent":"330000"},{"name":"丽水市","value":"331100","parent":"330000"},{"name":"上城区","value":"330102","parent":"330100"},{"name":"下城区","value":"330103","parent":"330100"},{"name":"江干区","value":"330104","parent":"330100"},{"name":"拱墅区","value":"330105","parent":"330100"},{"name":"西湖区","value":"330106","parent":"330100"},{"name":"滨江区","value":"330108","parent":"330100"},{"name":"萧山区","value":"330109","parent":"330100"},{"name":"余杭区","value":"330110","parent":"330100"},{"name":"富阳区","value":"330111","parent":"330100"},{"name":"桐庐县","value":"330122","parent":"330100"},{"name":"淳安县","value":"330127","parent":"330100"},{"name":"建德市","value":"330182","parent":"330100"},{"name":"临安市","value":"330185","parent":"330100"},{"name":"海曙区","value":"330203","parent":"330200"},{"name":"江东区","value":"330204","parent":"330200"},{"name":"江北区","value":"330205","parent":"330200"},{"name":"北仑区","value":"330206","parent":"330200"},{"name":"镇海区","value":"330211","parent":"330200"},{"name":"鄞州区","value":"330212","parent":"330200"},{"name":"象山县","value":"330225","parent":"330200"},{"name":"宁海县","value":"330226","parent":"330200"},{"name":"余姚市","value":"330281","parent":"330200"},{"name":"慈溪市","value":"330282","parent":"330200"},{"name":"奉化市","value":"330283","parent":"330200"},{"name":"鹿城区","value":"330302","parent":"330300"},{"name":"龙湾区","value":"330303","parent":"330300"},{"name":"瓯海区","value":"330304","parent":"330300"},{"name":"洞头区","value":"330305","parent":"330300"},{"name":"永嘉县","value":"330324","parent":"330300"},{"name":"平阳县","value":"330326","parent":"330300"},{"name":"苍南县","value":"330327","parent":"330300"},{"name":"文成县","value":"330328","parent":"330300"},{"name":"泰顺县","value":"330329","parent":"330300"},{"name":"瑞安市","value":"330381","parent":"330300"},{"name":"乐清市","value":"330382","parent":"330300"},{"name":"南湖区","value":"330402","parent":"330400"},{"name":"秀洲区","value":"330411","parent":"330400"},{"name":"嘉善县","value":"330421","parent":"330400"},{"name":"海盐县","value":"330424","parent":"330400"},{"name":"海宁市","value":"330481","parent":"330400"},{"name":"平湖市","value":"330482","parent":"330400"},{"name":"桐乡市","value":"330483","parent":"330400"},{"name":"吴兴区","value":"330502","parent":"330500"},{"name":"南浔区","value":"330503","parent":"330500"},{"name":"德清县","value":"330521","parent":"330500"},{"name":"长兴县","value":"330522","parent":"330500"},{"name":"安吉县","value":"330523","parent":"330500"},{"name":"越城区","value":"330602","parent":"330600"},{"name":"柯桥区","value":"330603","parent":"330600"},{"name":"上虞区","value":"330604","parent":"330600"},{"name":"新昌县","value":"330624","parent":"330600"},{"name":"诸暨市","value":"330681","parent":"330600"},{"name":"嵊州市","value":"330683","parent":"330600"},{"name":"婺城区","value":"330702","parent":"330700"},{"name":"金东区","value":"330703","parent":"330700"},{"name":"武义县","value":"330723","parent":"330700"},{"name":"浦江县","value":"330726","parent":"330700"},{"name":"磐安县","value":"330727","parent":"330700"},{"name":"兰溪市","value":"330781","parent":"330700"},{"name":"义乌市","value":"330782","parent":"330700"},{"name":"东阳市","value":"330783","parent":"330700"},{"name":"永康市","value":"330784","parent":"330700"},{"name":"柯城区","value":"330802","parent":"330800"},{"name":"衢江区","value":"330803","parent":"330800"},{"name":"常山县","value":"330822","parent":"330800"},{"name":"开化县","value":"330824","parent":"330800"},{"name":"龙游县","value":"330825","parent":"330800"},{"name":"江山市","value":"330881","parent":"330800"},{"name":"定海区","value":"330902","parent":"330900"},{"name":"普陀区","value":"330903","parent":"330900"},{"name":"岱山县","value":"330921","parent":"330900"},{"name":"嵊泗县","value":"330922","parent":"330900"},{"name":"椒江区","value":"331002","parent":"331000"},{"name":"黄岩区","value":"331003","parent":"331000"},{"name":"路桥区","value":"331004","parent":"331000"},{"name":"玉环县","value":"331021","parent":"331000"},{"name":"三门县","value":"331022","parent":"331000"},{"name":"天台县","value":"331023","parent":"331000"},{"name":"仙居县","value":"331024","parent":"331000"},{"name":"温岭市","value":"331081","parent":"331000"},{"name":"临海市","value":"331082","parent":"331000"},{"name":"莲都区","value":"331102","parent":"331100"},{"name":"青田县","value":"331121","parent":"331100"},{"name":"缙云县","value":"331122","parent":"331100"},{"name":"遂昌县","value":"331123","parent":"331100"},{"name":"松阳县","value":"331124","parent":"331100"},{"name":"云和县","value":"331125","parent":"331100"},{"name":"庆元县","value":"331126","parent":"331100"},{"name":"景宁畲族自治县","value":"331127","parent":"331100"},{"name":"龙泉市","value":"331181","parent":"331100"},{"name":"合肥市","value":"340100","parent":"340000"},{"name":"芜湖市","value":"340200","parent":"340000"},{"name":"蚌埠市","value":"340300","parent":"340000"},{"name":"淮南市","value":"340400","parent":"340000"},{"name":"马鞍山市","value":"340500","parent":"340000"},{"name":"淮北市","value":"340600","parent":"340000"},{"name":"铜陵市","value":"340700","parent":"340000"},{"name":"安庆市","value":"340800","parent":"340000"},{"name":"黄山市","value":"341000","parent":"340000"},{"name":"滁州市","value":"341100","parent":"340000"},{"name":"阜阳市","value":"341200","parent":"340000"},{"name":"宿州市","value":"341300","parent":"340000"},{"name":"六安市","value":"341500","parent":"340000"},{"name":"亳州市","value":"341600","parent":"340000"},{"name":"池州市","value":"341700","parent":"340000"},{"name":"宣城市","value":"341800","parent":"340000"},{"name":"瑶海区","value":"340102","parent":"340100"},{"name":"庐阳区","value":"340103","parent":"340100"},{"name":"蜀山区","value":"340104","parent":"340100"},{"name":"包河区","value":"340111","parent":"340100"},{"name":"长丰县","value":"340121","parent":"340100"},{"name":"肥东县","value":"340122","parent":"340100"},{"name":"肥西县","value":"340123","parent":"340100"},{"name":"庐江县","value":"340124","parent":"340100"},{"name":"巢湖市","value":"340181","parent":"340100"},{"name":"镜湖区","value":"340202","parent":"340200"},{"name":"弋江区","value":"340203","parent":"340200"},{"name":"鸠江区","value":"340207","parent":"340200"},{"name":"三山区","value":"340208","parent":"340200"},{"name":"芜湖县","value":"340221","parent":"340200"},{"name":"繁昌县","value":"340222","parent":"340200"},{"name":"南陵县","value":"340223","parent":"340200"},{"name":"无为县","value":"340225","parent":"340200"},{"name":"龙子湖区","value":"340302","parent":"340300"},{"name":"蚌山区","value":"340303","parent":"340300"},{"name":"禹会区","value":"340304","parent":"340300"},{"name":"淮上区","value":"340311","parent":"340300"},{"name":"怀远县","value":"340321","parent":"340300"},{"name":"五河县","value":"340322","parent":"340300"},{"name":"固镇县","value":"340323","parent":"340300"},{"name":"大通区","value":"340402","parent":"340400"},{"name":"田家庵区","value":"340403","parent":"340400"},{"name":"谢家集区","value":"340404","parent":"340400"},{"name":"八公山区","value":"340405","parent":"340400"},{"name":"潘集区","value":"340406","parent":"340400"},{"name":"凤台县","value":"340421","parent":"340400"},{"name":"寿县","value":"340422","parent":"340400"},{"name":"花山区","value":"340503","parent":"340500"},{"name":"雨山区","value":"340504","parent":"340500"},{"name":"博望区","value":"340506","parent":"340500"},{"name":"当涂县","value":"340521","parent":"340500"},{"name":"含山县","value":"340522","parent":"340500"},{"name":"和县","value":"340523","parent":"340500"},{"name":"杜集区","value":"340602","parent":"340600"},{"name":"相山区","value":"340603","parent":"340600"},{"name":"烈山区","value":"340604","parent":"340600"},{"name":"濉溪县","value":"340621","parent":"340600"},{"name":"铜官区","value":"340705","parent":"340700"},{"name":"义安区","value":"340706","parent":"340700"},{"name":"郊区","value":"340711","parent":"340700"},{"name":"枞阳县","value":"340722","parent":"340700"},{"name":"迎江区","value":"340802","parent":"340800"},{"name":"大观区","value":"340803","parent":"340800"},{"name":"宜秀区","value":"340811","parent":"340800"},{"name":"怀宁县","value":"340822","parent":"340800"},{"name":"潜山县","value":"340824","parent":"340800"},{"name":"太湖县","value":"340825","parent":"340800"},{"name":"宿松县","value":"340826","parent":"340800"},{"name":"望江县","value":"340827","parent":"340800"},{"name":"岳西县","value":"340828","parent":"340800"},{"name":"桐城市","value":"340881","parent":"340800"},{"name":"屯溪区","value":"341002","parent":"341000"},{"name":"黄山区","value":"341003","parent":"341000"},{"name":"徽州区","value":"341004","parent":"341000"},{"name":"歙县","value":"341021","parent":"341000"},{"name":"休宁县","value":"341022","parent":"341000"},{"name":"黟县","value":"341023","parent":"341000"},{"name":"祁门县","value":"341024","parent":"341000"},{"name":"琅琊区","value":"341102","parent":"341100"},{"name":"南谯区","value":"341103","parent":"341100"},{"name":"来安县","value":"341122","parent":"341100"},{"name":"全椒县","value":"341124","parent":"341100"},{"name":"定远县","value":"341125","parent":"341100"},{"name":"凤阳县","value":"341126","parent":"341100"},{"name":"天长市","value":"341181","parent":"341100"},{"name":"明光市","value":"341182","parent":"341100"},{"name":"颍州区","value":"341202","parent":"341200"},{"name":"颍东区","value":"341203","parent":"341200"},{"name":"颍泉区","value":"341204","parent":"341200"},{"name":"临泉县","value":"341221","parent":"341200"},{"name":"太和县","value":"341222","parent":"341200"},{"name":"阜南县","value":"341225","parent":"341200"},{"name":"颍上县","value":"341226","parent":"341200"},{"name":"界首市","value":"341282","parent":"341200"},{"name":"埇桥区","value":"341302","parent":"341300"},{"name":"砀山县","value":"341321","parent":"341300"},{"name":"萧县","value":"341322","parent":"341300"},{"name":"灵璧县","value":"341323","parent":"341300"},{"name":"泗县","value":"341324","parent":"341300"},{"name":"金安区","value":"341502","parent":"341500"},{"name":"裕安区","value":"341503","parent":"341500"},{"name":"叶集区","value":"341504","parent":"341500"},{"name":"霍邱县","value":"341522","parent":"341500"},{"name":"舒城县","value":"341523","parent":"341500"},{"name":"金寨县","value":"341524","parent":"341500"},{"name":"霍山县","value":"341525","parent":"341500"},{"name":"谯城区","value":"341602","parent":"341600"},{"name":"涡阳县","value":"341621","parent":"341600"},{"name":"蒙城县","value":"341622","parent":"341600"},{"name":"利辛县","value":"341623","parent":"341600"},{"name":"贵池区","value":"341702","parent":"341700"},{"name":"东至县","value":"341721","parent":"341700"},{"name":"石台县","value":"341722","parent":"341700"},{"name":"青阳县","value":"341723","parent":"341700"},{"name":"宣州区","value":"341802","parent":"341800"},{"name":"郎溪县","value":"341821","parent":"341800"},{"name":"广德县","value":"341822","parent":"341800"},{"name":"泾县","value":"341823","parent":"341800"},{"name":"绩溪县","value":"341824","parent":"341800"},{"name":"旌德县","value":"341825","parent":"341800"},{"name":"宁国市","value":"341881","parent":"341800"},{"name":"福州市","value":"350100","parent":"350000"},{"name":"厦门市","value":"350200","parent":"350000"},{"name":"莆田市","value":"350300","parent":"350000"},{"name":"三明市","value":"350400","parent":"350000"},{"name":"泉州市","value":"350500","parent":"350000"},{"name":"漳州市","value":"350600","parent":"350000"},{"name":"南平市","value":"350700","parent":"350000"},{"name":"龙岩市","value":"350800","parent":"350000"},{"name":"宁德市","value":"350900","parent":"350000"},{"name":"鼓楼区","value":"350102","parent":"350100"},{"name":"台江区","value":"350103","parent":"350100"},{"name":"仓山区","value":"350104","parent":"350100"},{"name":"马尾区","value":"350105","parent":"350100"},{"name":"晋安区","value":"350111","parent":"350100"},{"name":"闽侯县","value":"350121","parent":"350100"},{"name":"连江县","value":"350122","parent":"350100"},{"name":"罗源县","value":"350123","parent":"350100"},{"name":"闽清县","value":"350124","parent":"350100"},{"name":"永泰县","value":"350125","parent":"350100"},{"name":"平潭县","value":"350128","parent":"350100"},{"name":"福清市","value":"350181","parent":"350100"},{"name":"长乐市","value":"350182","parent":"350100"},{"name":"思明区","value":"350203","parent":"350200"},{"name":"海沧区","value":"350205","parent":"350200"},{"name":"湖里区","value":"350206","parent":"350200"},{"name":"集美区","value":"350211","parent":"350200"},{"name":"同安区","value":"350212","parent":"350200"},{"name":"翔安区","value":"350213","parent":"350200"},{"name":"城厢区","value":"350302","parent":"350300"},{"name":"涵江区","value":"350303","parent":"350300"},{"name":"荔城区","value":"350304","parent":"350300"},{"name":"秀屿区","value":"350305","parent":"350300"},{"name":"仙游县","value":"350322","parent":"350300"},{"name":"梅列区","value":"350402","parent":"350400"},{"name":"三元区","value":"350403","parent":"350400"},{"name":"明溪县","value":"350421","parent":"350400"},{"name":"清流县","value":"350423","parent":"350400"},{"name":"宁化县","value":"350424","parent":"350400"},{"name":"大田县","value":"350425","parent":"350400"},{"name":"尤溪县","value":"350426","parent":"350400"},{"name":"沙县","value":"350427","parent":"350400"},{"name":"将乐县","value":"350428","parent":"350400"},{"name":"泰宁县","value":"350429","parent":"350400"},{"name":"建宁县","value":"350430","parent":"350400"},{"name":"永安市","value":"350481","parent":"350400"},{"name":"鲤城区","value":"350502","parent":"350500"},{"name":"丰泽区","value":"350503","parent":"350500"},{"name":"洛江区","value":"350504","parent":"350500"},{"name":"泉港区","value":"350505","parent":"350500"},{"name":"惠安县","value":"350521","parent":"350500"},{"name":"安溪县","value":"350524","parent":"350500"},{"name":"永春县","value":"350525","parent":"350500"},{"name":"德化县","value":"350526","parent":"350500"},{"name":"金门县","value":"350527","parent":"350500"},{"name":"石狮市","value":"350581","parent":"350500"},{"name":"晋江市","value":"350582","parent":"350500"},{"name":"南安市","value":"350583","parent":"350500"},{"name":"芗城区","value":"350602","parent":"350600"},{"name":"龙文区","value":"350603","parent":"350600"},{"name":"云霄县","value":"350622","parent":"350600"},{"name":"漳浦县","value":"350623","parent":"350600"},{"name":"诏安县","value":"350624","parent":"350600"},{"name":"长泰县","value":"350625","parent":"350600"},{"name":"东山县","value":"350626","parent":"350600"},{"name":"南靖县","value":"350627","parent":"350600"},{"name":"平和县","value":"350628","parent":"350600"},{"name":"华安县","value":"350629","parent":"350600"},{"name":"龙海市","value":"350681","parent":"350600"},{"name":"延平区","value":"350702","parent":"350700"},{"name":"建阳区","value":"350703","parent":"350700"},{"name":"顺昌县","value":"350721","parent":"350700"},{"name":"浦城县","value":"350722","parent":"350700"},{"name":"光泽县","value":"350723","parent":"350700"},{"name":"松溪县","value":"350724","parent":"350700"},{"name":"政和县","value":"350725","parent":"350700"},{"name":"邵武市","value":"350781","parent":"350700"},{"name":"武夷山市","value":"350782","parent":"350700"},{"name":"建瓯市","value":"350783","parent":"350700"},{"name":"新罗区","value":"350802","parent":"350800"},{"name":"永定区","value":"350803","parent":"350800"},{"name":"长汀县","value":"350821","parent":"350800"},{"name":"上杭县","value":"350823","parent":"350800"},{"name":"武平县","value":"350824","parent":"350800"},{"name":"连城县","value":"350825","parent":"350800"},{"name":"漳平市","value":"350881","parent":"350800"},{"name":"蕉城区","value":"350902","parent":"350900"},{"name":"霞浦县","value":"350921","parent":"350900"},{"name":"古田县","value":"350922","parent":"350900"},{"name":"屏南县","value":"350923","parent":"350900"},{"name":"寿宁县","value":"350924","parent":"350900"},{"name":"周宁县","value":"350925","parent":"350900"},{"name":"柘荣县","value":"350926","parent":"350900"},{"name":"福安市","value":"350981","parent":"350900"},{"name":"福鼎市","value":"350982","parent":"350900"},{"name":"南昌市","value":"360100","parent":"360000"},{"name":"景德镇市","value":"360200","parent":"360000"},{"name":"萍乡市","value":"360300","parent":"360000"},{"name":"九江市","value":"360400","parent":"360000"},{"name":"新余市","value":"360500","parent":"360000"},{"name":"鹰潭市","value":"360600","parent":"360000"},{"name":"赣州市","value":"360700","parent":"360000"},{"name":"吉安市","value":"360800","parent":"360000"},{"name":"宜春市","value":"360900","parent":"360000"},{"name":"抚州市","value":"361000","parent":"360000"},{"name":"上饶市","value":"361100","parent":"360000"},{"name":"东湖区","value":"360102","parent":"360100"},{"name":"西湖区","value":"360103","parent":"360100"},{"name":"青云谱区","value":"360104","parent":"360100"},{"name":"湾里区","value":"360105","parent":"360100"},{"name":"青山湖区","value":"360111","parent":"360100"},{"name":"新建区","value":"360112","parent":"360100"},{"name":"南昌县","value":"360121","parent":"360100"},{"name":"安义县","value":"360123","parent":"360100"},{"name":"进贤县","value":"360124","parent":"360100"},{"name":"昌江区","value":"360202","parent":"360200"},{"name":"珠山区","value":"360203","parent":"360200"},{"name":"浮梁县","value":"360222","parent":"360200"},{"name":"乐平市","value":"360281","parent":"360200"},{"name":"安源区","value":"360302","parent":"360300"},{"name":"湘东区","value":"360313","parent":"360300"},{"name":"莲花县","value":"360321","parent":"360300"},{"name":"上栗县","value":"360322","parent":"360300"},{"name":"芦溪县","value":"360323","parent":"360300"},{"name":"濂溪区","value":"360402","parent":"360400"},{"name":"浔阳区","value":"360403","parent":"360400"},{"name":"九江县","value":"360421","parent":"360400"},{"name":"武宁县","value":"360423","parent":"360400"},{"name":"修水县","value":"360424","parent":"360400"},{"name":"永修县","value":"360425","parent":"360400"},{"name":"德安县","value":"360426","parent":"360400"},{"name":"都昌县","value":"360428","parent":"360400"},{"name":"湖口县","value":"360429","parent":"360400"},{"name":"彭泽县","value":"360430","parent":"360400"},{"name":"瑞昌市","value":"360481","parent":"360400"},{"name":"共青城市","value":"360482","parent":"360400"},{"name":"庐山市","value":"360483","parent":"360400"},{"name":"渝水区","value":"360502","parent":"360500"},{"name":"分宜县","value":"360521","parent":"360500"},{"name":"月湖区","value":"360602","parent":"360600"},{"name":"余江县","value":"360622","parent":"360600"},{"name":"贵溪市","value":"360681","parent":"360600"},{"name":"章贡区","value":"360702","parent":"360700"},{"name":"南康区","value":"360703","parent":"360700"},{"name":"赣县","value":"360721","parent":"360700"},{"name":"信丰县","value":"360722","parent":"360700"},{"name":"大余县","value":"360723","parent":"360700"},{"name":"上犹县","value":"360724","parent":"360700"},{"name":"崇义县","value":"360725","parent":"360700"},{"name":"安远县","value":"360726","parent":"360700"},{"name":"龙南县","value":"360727","parent":"360700"},{"name":"定南县","value":"360728","parent":"360700"},{"name":"全南县","value":"360729","parent":"360700"},{"name":"宁都县","value":"360730","parent":"360700"},{"name":"于都县","value":"360731","parent":"360700"},{"name":"兴国县","value":"360732","parent":"360700"},{"name":"会昌县","value":"360733","parent":"360700"},{"name":"寻乌县","value":"360734","parent":"360700"},{"name":"石城县","value":"360735","parent":"360700"},{"name":"瑞金市","value":"360781","parent":"360700"},{"name":"吉州区","value":"360802","parent":"360800"},{"name":"青原区","value":"360803","parent":"360800"},{"name":"吉安县","value":"360821","parent":"360800"},{"name":"吉水县","value":"360822","parent":"360800"},{"name":"峡江县","value":"360823","parent":"360800"},{"name":"新干县","value":"360824","parent":"360800"},{"name":"永丰县","value":"360825","parent":"360800"},{"name":"泰和县","value":"360826","parent":"360800"},{"name":"遂川县","value":"360827","parent":"360800"},{"name":"万安县","value":"360828","parent":"360800"},{"name":"安福县","value":"360829","parent":"360800"},{"name":"永新县","value":"360830","parent":"360800"},{"name":"井冈山市","value":"360881","parent":"360800"},{"name":"袁州区","value":"360902","parent":"360900"},{"name":"奉新县","value":"360921","parent":"360900"},{"name":"万载县","value":"360922","parent":"360900"},{"name":"上高县","value":"360923","parent":"360900"},{"name":"宜丰县","value":"360924","parent":"360900"},{"name":"靖安县","value":"360925","parent":"360900"},{"name":"铜鼓县","value":"360926","parent":"360900"},{"name":"丰城市","value":"360981","parent":"360900"},{"name":"樟树市","value":"360982","parent":"360900"},{"name":"高安市","value":"360983","parent":"360900"},{"name":"临川区","value":"361002","parent":"361000"},{"name":"南城县","value":"361021","parent":"361000"},{"name":"黎川县","value":"361022","parent":"361000"},{"name":"南丰县","value":"361023","parent":"361000"},{"name":"崇仁县","value":"361024","parent":"361000"},{"name":"乐安县","value":"361025","parent":"361000"},{"name":"宜黄县","value":"361026","parent":"361000"},{"name":"金溪县","value":"361027","parent":"361000"},{"name":"资溪县","value":"361028","parent":"361000"},{"name":"东乡县","value":"361029","parent":"361000"},{"name":"广昌县","value":"361030","parent":"361000"},{"name":"信州区","value":"361102","parent":"361100"},{"name":"广丰区","value":"361103","parent":"361100"},{"name":"上饶县","value":"361121","parent":"361100"},{"name":"玉山县","value":"361123","parent":"361100"},{"name":"铅山县","value":"361124","parent":"361100"},{"name":"横峰县","value":"361125","parent":"361100"},{"name":"弋阳县","value":"361126","parent":"361100"},{"name":"余干县","value":"361127","parent":"361100"},{"name":"鄱阳县","value":"361128","parent":"361100"},{"name":"万年县","value":"361129","parent":"361100"},{"name":"婺源县","value":"361130","parent":"361100"},{"name":"德兴市","value":"361181","parent":"361100"},{"name":"济南市","value":"370100","parent":"370000"},{"name":"青岛市","value":"370200","parent":"370000"},{"name":"淄博市","value":"370300","parent":"370000"},{"name":"枣庄市","value":"370400","parent":"370000"},{"name":"东营市","value":"370500","parent":"370000"},{"name":"烟台市","value":"370600","parent":"370000"},{"name":"潍坊市","value":"370700","parent":"370000"},{"name":"济宁市","value":"370800","parent":"370000"},{"name":"泰安市","value":"370900","parent":"370000"},{"name":"威海市","value":"371000","parent":"370000"},{"name":"日照市","value":"371100","parent":"370000"},{"name":"莱芜市","value":"371200","parent":"370000"},{"name":"临沂市","value":"371300","parent":"370000"},{"name":"德州市","value":"371400","parent":"370000"},{"name":"聊城市","value":"371500","parent":"370000"},{"name":"滨州市","value":"371600","parent":"370000"},{"name":"菏泽市","value":"371700","parent":"370000"},{"name":"历下区","value":"370102","parent":"370100"},{"name":"市中区","value":"370103","parent":"370100"},{"name":"槐荫区","value":"370104","parent":"370100"},{"name":"天桥区","value":"370105","parent":"370100"},{"name":"历城区","value":"370112","parent":"370100"},{"name":"长清区","value":"370113","parent":"370100"},{"name":"平阴县","value":"370124","parent":"370100"},{"name":"济阳县","value":"370125","parent":"370100"},{"name":"商河县","value":"370126","parent":"370100"},{"name":"章丘市","value":"370181","parent":"370100"},{"name":"市南区","value":"370202","parent":"370200"},{"name":"市北区","value":"370203","parent":"370200"},{"name":"黄岛区","value":"370211","parent":"370200"},{"name":"崂山区","value":"370212","parent":"370200"},{"name":"李沧区","value":"370213","parent":"370200"},{"name":"城阳区","value":"370214","parent":"370200"},{"name":"胶州市","value":"370281","parent":"370200"},{"name":"即墨市","value":"370282","parent":"370200"},{"name":"平度市","value":"370283","parent":"370200"},{"name":"莱西市","value":"370285","parent":"370200"},{"name":"淄川区","value":"370302","parent":"370300"},{"name":"张店区","value":"370303","parent":"370300"},{"name":"博山区","value":"370304","parent":"370300"},{"name":"临淄区","value":"370305","parent":"370300"},{"name":"周村区","value":"370306","parent":"370300"},{"name":"桓台县","value":"370321","parent":"370300"},{"name":"高青县","value":"370322","parent":"370300"},{"name":"沂源县","value":"370323","parent":"370300"},{"name":"市中区","value":"370402","parent":"370400"},{"name":"薛城区","value":"370403","parent":"370400"},{"name":"峄城区","value":"370404","parent":"370400"},{"name":"台儿庄区","value":"370405","parent":"370400"},{"name":"山亭区","value":"370406","parent":"370400"},{"name":"滕州市","value":"370481","parent":"370400"},{"name":"东营区","value":"370502","parent":"370500"},{"name":"河口区","value":"370503","parent":"370500"},{"name":"垦利区","value":"370505","parent":"370500"},{"name":"利津县","value":"370522","parent":"370500"},{"name":"广饶县","value":"370523","parent":"370500"},{"name":"芝罘区","value":"370602","parent":"370600"},{"name":"福山区","value":"370611","parent":"370600"},{"name":"牟平区","value":"370612","parent":"370600"},{"name":"莱山区","value":"370613","parent":"370600"},{"name":"长岛县","value":"370634","parent":"370600"},{"name":"龙口市","value":"370681","parent":"370600"},{"name":"莱阳市","value":"370682","parent":"370600"},{"name":"莱州市","value":"370683","parent":"370600"},{"name":"蓬莱市","value":"370684","parent":"370600"},{"name":"招远市","value":"370685","parent":"370600"},{"name":"栖霞市","value":"370686","parent":"370600"},{"name":"海阳市","value":"370687","parent":"370600"},{"name":"潍城区","value":"370702","parent":"370700"},{"name":"寒亭区","value":"370703","parent":"370700"},{"name":"坊子区","value":"370704","parent":"370700"},{"name":"奎文区","value":"370705","parent":"370700"},{"name":"临朐县","value":"370724","parent":"370700"},{"name":"昌乐县","value":"370725","parent":"370700"},{"name":"青州市","value":"370781","parent":"370700"},{"name":"诸城市","value":"370782","parent":"370700"},{"name":"寿光市","value":"370783","parent":"370700"},{"name":"安丘市","value":"370784","parent":"370700"},{"name":"高密市","value":"370785","parent":"370700"},{"name":"昌邑市","value":"370786","parent":"370700"},{"name":"任城区","value":"370811","parent":"370800"},{"name":"兖州区","value":"370812","parent":"370800"},{"name":"微山县","value":"370826","parent":"370800"},{"name":"鱼台县","value":"370827","parent":"370800"},{"name":"金乡县","value":"370828","parent":"370800"},{"name":"嘉祥县","value":"370829","parent":"370800"},{"name":"汶上县","value":"370830","parent":"370800"},{"name":"泗水县","value":"370831","parent":"370800"},{"name":"梁山县","value":"370832","parent":"370800"},{"name":"曲阜市","value":"370881","parent":"370800"},{"name":"邹城市","value":"370883","parent":"370800"},{"name":"泰山区","value":"370902","parent":"370900"},{"name":"岱岳区","value":"370911","parent":"370900"},{"name":"宁阳县","value":"370921","parent":"370900"},{"name":"东平县","value":"370923","parent":"370900"},{"name":"新泰市","value":"370982","parent":"370900"},{"name":"肥城市","value":"370983","parent":"370900"},{"name":"环翠区","value":"371002","parent":"371000"},{"name":"文登区","value":"371003","parent":"371000"},{"name":"荣成市","value":"371082","parent":"371000"},{"name":"乳山市","value":"371083","parent":"371000"},{"name":"东港区","value":"371102","parent":"371100"},{"name":"岚山区","value":"371103","parent":"371100"},{"name":"五莲县","value":"371121","parent":"371100"},{"name":"莒县","value":"371122","parent":"371100"},{"name":"莱城区","value":"371202","parent":"371200"},{"name":"钢城区","value":"371203","parent":"371200"},{"name":"兰山区","value":"371302","parent":"371300"},{"name":"罗庄区","value":"371311","parent":"371300"},{"name":"河东区","value":"371312","parent":"371300"},{"name":"沂南县","value":"371321","parent":"371300"},{"name":"郯城县","value":"371322","parent":"371300"},{"name":"沂水县","value":"371323","parent":"371300"},{"name":"兰陵县","value":"371324","parent":"371300"},{"name":"费县","value":"371325","parent":"371300"},{"name":"平邑县","value":"371326","parent":"371300"},{"name":"莒南县","value":"371327","parent":"371300"},{"name":"蒙阴县","value":"371328","parent":"371300"},{"name":"临沭县","value":"371329","parent":"371300"},{"name":"德城区","value":"371402","parent":"371400"},{"name":"陵城区","value":"371403","parent":"371400"},{"name":"宁津县","value":"371422","parent":"371400"},{"name":"庆云县","value":"371423","parent":"371400"},{"name":"临邑县","value":"371424","parent":"371400"},{"name":"齐河县","value":"371425","parent":"371400"},{"name":"平原县","value":"371426","parent":"371400"},{"name":"夏津县","value":"371427","parent":"371400"},{"name":"武城县","value":"371428","parent":"371400"},{"name":"乐陵市","value":"371481","parent":"371400"},{"name":"禹城市","value":"371482","parent":"371400"},{"name":"东昌府区","value":"371502","parent":"371500"},{"name":"阳谷县","value":"371521","parent":"371500"},{"name":"莘县","value":"371522","parent":"371500"},{"name":"茌平县","value":"371523","parent":"371500"},{"name":"东阿县","value":"371524","parent":"371500"},{"name":"冠县","value":"371525","parent":"371500"},{"name":"高唐县","value":"371526","parent":"371500"},{"name":"临清市","value":"371581","parent":"371500"},{"name":"滨城区","value":"371602","parent":"371600"},{"name":"沾化区","value":"371603","parent":"371600"},{"name":"惠民县","value":"371621","parent":"371600"},{"name":"阳信县","value":"371622","parent":"371600"},{"name":"无棣县","value":"371623","parent":"371600"},{"name":"博兴县","value":"371625","parent":"371600"},{"name":"邹平县","value":"371626","parent":"371600"},{"name":"牡丹区","value":"371702","parent":"371700"},{"name":"定陶区","value":"371703","parent":"371700"},{"name":"曹县","value":"371721","parent":"371700"},{"name":"单县","value":"371722","parent":"371700"},{"name":"成武县","value":"371723","parent":"371700"},{"name":"巨野县","value":"371724","parent":"371700"},{"name":"郓城县","value":"371725","parent":"371700"},{"name":"鄄城县","value":"371726","parent":"371700"},{"name":"东明县","value":"371728","parent":"371700"},{"name":"郑州市","value":"410100","parent":"410000"},{"name":"开封市","value":"410200","parent":"410000"},{"name":"洛阳市","value":"410300","parent":"410000"},{"name":"平顶山市","value":"410400","parent":"410000"},{"name":"安阳市","value":"410500","parent":"410000"},{"name":"鹤壁市","value":"410600","parent":"410000"},{"name":"新乡市","value":"410700","parent":"410000"},{"name":"焦作市","value":"410800","parent":"410000"},{"name":"濮阳市","value":"410900","parent":"410000"},{"name":"许昌市","value":"411000","parent":"410000"},{"name":"漯河市","value":"411100","parent":"410000"},{"name":"三门峡市","value":"411200","parent":"410000"},{"name":"南阳市","value":"411300","parent":"410000"},{"name":"商丘市","value":"411400","parent":"410000"},{"name":"信阳市","value":"411500","parent":"410000"},{"name":"周口市","value":"411600","parent":"410000"},{"name":"驻马店市","value":"411700","parent":"410000"},{"name":"济源市","value":"419001","parent":"410000"},{"name":"中原区","value":"410102","parent":"410100"},{"name":"二七区","value":"410103","parent":"410100"},{"name":"管城回族区","value":"410104","parent":"410100"},{"name":"金水区","value":"410105","parent":"410100"},{"name":"上街区","value":"410106","parent":"410100"},{"name":"惠济区","value":"410108","parent":"410100"},{"name":"中牟县","value":"410122","parent":"410100"},{"name":"巩义市","value":"410181","parent":"410100"},{"name":"荥阳市","value":"410182","parent":"410100"},{"name":"新密市","value":"410183","parent":"410100"},{"name":"新郑市","value":"410184","parent":"410100"},{"name":"登封市","value":"410185","parent":"410100"},{"name":"龙亭区","value":"410202","parent":"410200"},{"name":"顺河回族区","value":"410203","parent":"410200"},{"name":"鼓楼区","value":"410204","parent":"410200"},{"name":"禹王台区","value":"410205","parent":"410200"},{"name":"金明区","value":"410211","parent":"410200"},{"name":"祥符区","value":"410212","parent":"410200"},{"name":"杞县","value":"410221","parent":"410200"},{"name":"通许县","value":"410222","parent":"410200"},{"name":"尉氏县","value":"410223","parent":"410200"},{"name":"兰考县","value":"410225","parent":"410200"},{"name":"老城区","value":"410302","parent":"410300"},{"name":"西工区","value":"410303","parent":"410300"},{"name":"瀍河回族区","value":"410304","parent":"410300"},{"name":"涧西区","value":"410305","parent":"410300"},{"name":"吉利区","value":"410306","parent":"410300"},{"name":"洛龙区","value":"410311","parent":"410300"},{"name":"孟津县","value":"410322","parent":"410300"},{"name":"新安县","value":"410323","parent":"410300"},{"name":"栾川县","value":"410324","parent":"410300"},{"name":"嵩县","value":"410325","parent":"410300"},{"name":"汝阳县","value":"410326","parent":"410300"},{"name":"宜阳县","value":"410327","parent":"410300"},{"name":"洛宁县","value":"410328","parent":"410300"},{"name":"伊川县","value":"410329","parent":"410300"},{"name":"偃师市","value":"410381","parent":"410300"},{"name":"新华区","value":"410402","parent":"410400"},{"name":"卫东区","value":"410403","parent":"410400"},{"name":"石龙区","value":"410404","parent":"410400"},{"name":"湛河区","value":"410411","parent":"410400"},{"name":"宝丰县","value":"410421","parent":"410400"},{"name":"叶县","value":"410422","parent":"410400"},{"name":"鲁山县","value":"410423","parent":"410400"},{"name":"郏县","value":"410425","parent":"410400"},{"name":"舞钢市","value":"410481","parent":"410400"},{"name":"汝州市","value":"410482","parent":"410400"},{"name":"文峰区","value":"410502","parent":"410500"},{"name":"北关区","value":"410503","parent":"410500"},{"name":"殷都区","value":"410505","parent":"410500"},{"name":"龙安区","value":"410506","parent":"410500"},{"name":"安阳县","value":"410522","parent":"410500"},{"name":"汤阴县","value":"410523","parent":"410500"},{"name":"滑县","value":"410526","parent":"410500"},{"name":"内黄县","value":"410527","parent":"410500"},{"name":"林州市","value":"410581","parent":"410500"},{"name":"鹤山区","value":"410602","parent":"410600"},{"name":"山城区","value":"410603","parent":"410600"},{"name":"淇滨区","value":"410611","parent":"410600"},{"name":"浚县","value":"410621","parent":"410600"},{"name":"淇县","value":"410622","parent":"410600"},{"name":"红旗区","value":"410702","parent":"410700"},{"name":"卫滨区","value":"410703","parent":"410700"},{"name":"凤泉区","value":"410704","parent":"410700"},{"name":"牧野区","value":"410711","parent":"410700"},{"name":"新乡县","value":"410721","parent":"410700"},{"name":"获嘉县","value":"410724","parent":"410700"},{"name":"原阳县","value":"410725","parent":"410700"},{"name":"延津县","value":"410726","parent":"410700"},{"name":"封丘县","value":"410727","parent":"410700"},{"name":"长垣县","value":"410728","parent":"410700"},{"name":"卫辉市","value":"410781","parent":"410700"},{"name":"辉县市","value":"410782","parent":"410700"},{"name":"解放区","value":"410802","parent":"410800"},{"name":"中站区","value":"410803","parent":"410800"},{"name":"马村区","value":"410804","parent":"410800"},{"name":"山阳区","value":"410811","parent":"410800"},{"name":"修武县","value":"410821","parent":"410800"},{"name":"博爱县","value":"410822","parent":"410800"},{"name":"武陟县","value":"410823","parent":"410800"},{"name":"温县","value":"410825","parent":"410800"},{"name":"沁阳市","value":"410882","parent":"410800"},{"name":"孟州市","value":"410883","parent":"410800"},{"name":"华龙区","value":"410902","parent":"410900"},{"name":"清丰县","value":"410922","parent":"410900"},{"name":"南乐县","value":"410923","parent":"410900"},{"name":"范县","value":"410926","parent":"410900"},{"name":"台前县","value":"410927","parent":"410900"},{"name":"濮阳县","value":"410928","parent":"410900"},{"name":"魏都区","value":"411002","parent":"411000"},{"name":"许昌县","value":"411023","parent":"411000"},{"name":"鄢陵县","value":"411024","parent":"411000"},{"name":"襄城县","value":"411025","parent":"411000"},{"name":"禹州市","value":"411081","parent":"411000"},{"name":"长葛市","value":"411082","parent":"411000"},{"name":"源汇区","value":"411102","parent":"411100"},{"name":"郾城区","value":"411103","parent":"411100"},{"name":"召陵区","value":"411104","parent":"411100"},{"name":"舞阳县","value":"411121","parent":"411100"},{"name":"临颍县","value":"411122","parent":"411100"},{"name":"湖滨区","value":"411202","parent":"411200"},{"name":"陕州区","value":"411203","parent":"411200"},{"name":"渑池县","value":"411221","parent":"411200"},{"name":"卢氏县","value":"411224","parent":"411200"},{"name":"义马市","value":"411281","parent":"411200"},{"name":"灵宝市","value":"411282","parent":"411200"},{"name":"宛城区","value":"411302","parent":"411300"},{"name":"卧龙区","value":"411303","parent":"411300"},{"name":"南召县","value":"411321","parent":"411300"},{"name":"方城县","value":"411322","parent":"411300"},{"name":"西峡县","value":"411323","parent":"411300"},{"name":"镇平县","value":"411324","parent":"411300"},{"name":"内乡县","value":"411325","parent":"411300"},{"name":"淅川县","value":"411326","parent":"411300"},{"name":"社旗县","value":"411327","parent":"411300"},{"name":"唐河县","value":"411328","parent":"411300"},{"name":"新野县","value":"411329","parent":"411300"},{"name":"桐柏县","value":"411330","parent":"411300"},{"name":"邓州市","value":"411381","parent":"411300"},{"name":"梁园区","value":"411402","parent":"411400"},{"name":"睢阳区","value":"411403","parent":"411400"},{"name":"民权县","value":"411421","parent":"411400"},{"name":"睢县","value":"411422","parent":"411400"},{"name":"宁陵县","value":"411423","parent":"411400"},{"name":"柘城县","value":"411424","parent":"411400"},{"name":"虞城县","value":"411425","parent":"411400"},{"name":"夏邑县","value":"411426","parent":"411400"},{"name":"永城市","value":"411481","parent":"411400"},{"name":"浉河区","value":"411502","parent":"411500"},{"name":"平桥区","value":"411503","parent":"411500"},{"name":"罗山县","value":"411521","parent":"411500"},{"name":"光山县","value":"411522","parent":"411500"},{"name":"新县","value":"411523","parent":"411500"},{"name":"商城县","value":"411524","parent":"411500"},{"name":"固始县","value":"411525","parent":"411500"},{"name":"潢川县","value":"411526","parent":"411500"},{"name":"淮滨县","value":"411527","parent":"411500"},{"name":"息县","value":"411528","parent":"411500"},{"name":"川汇区","value":"411602","parent":"411600"},{"name":"扶沟县","value":"411621","parent":"411600"},{"name":"西华县","value":"411622","parent":"411600"},{"name":"商水县","value":"411623","parent":"411600"},{"name":"沈丘县","value":"411624","parent":"411600"},{"name":"郸城县","value":"411625","parent":"411600"},{"name":"淮阳县","value":"411626","parent":"411600"},{"name":"太康县","value":"411627","parent":"411600"},{"name":"鹿邑县","value":"411628","parent":"411600"},{"name":"项城市","value":"411681","parent":"411600"},{"name":"驿城区","value":"411702","parent":"411700"},{"name":"西平县","value":"411721","parent":"411700"},{"name":"上蔡县","value":"411722","parent":"411700"},{"name":"平舆县","value":"411723","parent":"411700"},{"name":"正阳县","value":"411724","parent":"411700"},{"name":"确山县","value":"411725","parent":"411700"},{"name":"泌阳县","value":"411726","parent":"411700"},{"name":"汝南县","value":"411727","parent":"411700"},{"name":"遂平县","value":"411728","parent":"411700"},{"name":"新蔡县","value":"411729","parent":"411700"},{"name":"武汉市","value":"420100","parent":"420000"},{"name":"黄石市","value":"420200","parent":"420000"},{"name":"十堰市","value":"420300","parent":"420000"},{"name":"宜昌市","value":"420500","parent":"420000"},{"name":"襄阳市","value":"420600","parent":"420000"},{"name":"鄂州市","value":"420700","parent":"420000"},{"name":"荆门市","value":"420800","parent":"420000"},{"name":"孝感市","value":"420900","parent":"420000"},{"name":"荆州市","value":"421000","parent":"420000"},{"name":"黄冈市","value":"421100","parent":"420000"},{"name":"咸宁市","value":"421200","parent":"420000"},{"name":"随州市","value":"421300","parent":"420000"},{"name":"恩施土家族苗族自治州","value":"422800","parent":"420000"},{"name":"仙桃市","value":"429004","parent":"420000"},{"name":"潜江市","value":"429005","parent":"420000"},{"name":"天门市","value":"429006","parent":"420000"},{"name":"神农架林区","value":"429021","parent":"420000"},{"name":"江岸区","value":"420102","parent":"420100"},{"name":"江汉区","value":"420103","parent":"420100"},{"name":"硚口区","value":"420104","parent":"420100"},{"name":"汉阳区","value":"420105","parent":"420100"},{"name":"武昌区","value":"420106","parent":"420100"},{"name":"青山区","value":"420107","parent":"420100"},{"name":"洪山区","value":"420111","parent":"420100"},{"name":"东西湖区","value":"420112","parent":"420100"},{"name":"汉南区","value":"420113","parent":"420100"},{"name":"蔡甸区","value":"420114","parent":"420100"},{"name":"江夏区","value":"420115","parent":"420100"},{"name":"黄陂区","value":"420116","parent":"420100"},{"name":"新洲区","value":"420117","parent":"420100"},{"name":"黄石港区","value":"420202","parent":"420200"},{"name":"西塞山区","value":"420203","parent":"420200"},{"name":"下陆区","value":"420204","parent":"420200"},{"name":"铁山区","value":"420205","parent":"420200"},{"name":"阳新县","value":"420222","parent":"420200"},{"name":"大冶市","value":"420281","parent":"420200"},{"name":"茅箭区","value":"420302","parent":"420300"},{"name":"张湾区","value":"420303","parent":"420300"},{"name":"郧阳区","value":"420304","parent":"420300"},{"name":"郧西县","value":"420322","parent":"420300"},{"name":"竹山县","value":"420323","parent":"420300"},{"name":"竹溪县","value":"420324","parent":"420300"},{"name":"房县","value":"420325","parent":"420300"},{"name":"丹江口市","value":"420381","parent":"420300"},{"name":"西陵区","value":"420502","parent":"420500"},{"name":"伍家岗区","value":"420503","parent":"420500"},{"name":"点军区","value":"420504","parent":"420500"},{"name":"猇亭区","value":"420505","parent":"420500"},{"name":"夷陵区","value":"420506","parent":"420500"},{"name":"远安县","value":"420525","parent":"420500"},{"name":"兴山县","value":"420526","parent":"420500"},{"name":"秭归县","value":"420527","parent":"420500"},{"name":"长阳土家族自治县","value":"420528","parent":"420500"},{"name":"五峰土家族自治县","value":"420529","parent":"420500"},{"name":"宜都市","value":"420581","parent":"420500"},{"name":"当阳市","value":"420582","parent":"420500"},{"name":"枝江市","value":"420583","parent":"420500"},{"name":"襄城区","value":"420602","parent":"420600"},{"name":"樊城区","value":"420606","parent":"420600"},{"name":"襄州区","value":"420607","parent":"420600"},{"name":"南漳县","value":"420624","parent":"420600"},{"name":"谷城县","value":"420625","parent":"420600"},{"name":"保康县","value":"420626","parent":"420600"},{"name":"老河口市","value":"420682","parent":"420600"},{"name":"枣阳市","value":"420683","parent":"420600"},{"name":"宜城市","value":"420684","parent":"420600"},{"name":"梁子湖区","value":"420702","parent":"420700"},{"name":"华容区","value":"420703","parent":"420700"},{"name":"鄂城区","value":"420704","parent":"420700"},{"name":"东宝区","value":"420802","parent":"420800"},{"name":"掇刀区","value":"420804","parent":"420800"},{"name":"京山县","value":"420821","parent":"420800"},{"name":"沙洋县","value":"420822","parent":"420800"},{"name":"钟祥市","value":"420881","parent":"420800"},{"name":"孝南区","value":"420902","parent":"420900"},{"name":"孝昌县","value":"420921","parent":"420900"},{"name":"大悟县","value":"420922","parent":"420900"},{"name":"云梦县","value":"420923","parent":"420900"},{"name":"应城市","value":"420981","parent":"420900"},{"name":"安陆市","value":"420982","parent":"420900"},{"name":"汉川市","value":"420984","parent":"420900"},{"name":"沙市区","value":"421002","parent":"421000"},{"name":"荆州区","value":"421003","parent":"421000"},{"name":"公安县","value":"421022","parent":"421000"},{"name":"监利县","value":"421023","parent":"421000"},{"name":"江陵县","value":"421024","parent":"421000"},{"name":"石首市","value":"421081","parent":"421000"},{"name":"洪湖市","value":"421083","parent":"421000"},{"name":"松滋市","value":"421087","parent":"421000"},{"name":"黄州区","value":"421102","parent":"421100"},{"name":"团风县","value":"421121","parent":"421100"},{"name":"红安县","value":"421122","parent":"421100"},{"name":"罗田县","value":"421123","parent":"421100"},{"name":"英山县","value":"421124","parent":"421100"},{"name":"浠水县","value":"421125","parent":"421100"},{"name":"蕲春县","value":"421126","parent":"421100"},{"name":"黄梅县","value":"421127","parent":"421100"},{"name":"麻城市","value":"421181","parent":"421100"},{"name":"武穴市","value":"421182","parent":"421100"},{"name":"咸安区","value":"421202","parent":"421200"},{"name":"嘉鱼县","value":"421221","parent":"421200"},{"name":"通城县","value":"421222","parent":"421200"},{"name":"崇阳县","value":"421223","parent":"421200"},{"name":"通山县","value":"421224","parent":"421200"},{"name":"赤壁市","value":"421281","parent":"421200"},{"name":"曾都区","value":"421303","parent":"421300"},{"name":"随县","value":"421321","parent":"421300"},{"name":"广水市","value":"421381","parent":"421300"},{"name":"恩施市","value":"422801","parent":"422800"},{"name":"利川市","value":"422802","parent":"422800"},{"name":"建始县","value":"422822","parent":"422800"},{"name":"巴东县","value":"422823","parent":"422800"},{"name":"宣恩县","value":"422825","parent":"422800"},{"name":"咸丰县","value":"422826","parent":"422800"},{"name":"来凤县","value":"422827","parent":"422800"},{"name":"鹤峰县","value":"422828","parent":"422800"},{"name":"长沙市","value":"430100","parent":"430000"},{"name":"株洲市","value":"430200","parent":"430000"},{"name":"湘潭市","value":"430300","parent":"430000"},{"name":"衡阳市","value":"430400","parent":"430000"},{"name":"邵阳市","value":"430500","parent":"430000"},{"name":"岳阳市","value":"430600","parent":"430000"},{"name":"常德市","value":"430700","parent":"430000"},{"name":"张家界市","value":"430800","parent":"430000"},{"name":"益阳市","value":"430900","parent":"430000"},{"name":"郴州市","value":"431000","parent":"430000"},{"name":"永州市","value":"431100","parent":"430000"},{"name":"怀化市","value":"431200","parent":"430000"},{"name":"娄底市","value":"431300","parent":"430000"},{"name":"湘西土家族苗族自治州","value":"433100","parent":"430000"},{"name":"芙蓉区","value":"430102","parent":"430100"},{"name":"天心区","value":"430103","parent":"430100"},{"name":"岳麓区","value":"430104","parent":"430100"},{"name":"开福区","value":"430105","parent":"430100"},{"name":"雨花区","value":"430111","parent":"430100"},{"name":"望城区","value":"430112","parent":"430100"},{"name":"长沙县","value":"430121","parent":"430100"},{"name":"宁乡县","value":"430124","parent":"430100"},{"name":"浏阳市","value":"430181","parent":"430100"},{"name":"荷塘区","value":"430202","parent":"430200"},{"name":"芦淞区","value":"430203","parent":"430200"},{"name":"石峰区","value":"430204","parent":"430200"},{"name":"天元区","value":"430211","parent":"430200"},{"name":"株洲县","value":"430221","parent":"430200"},{"name":"攸县","value":"430223","parent":"430200"},{"name":"茶陵县","value":"430224","parent":"430200"},{"name":"炎陵县","value":"430225","parent":"430200"},{"name":"醴陵市","value":"430281","parent":"430200"},{"name":"雨湖区","value":"430302","parent":"430300"},{"name":"岳塘区","value":"430304","parent":"430300"},{"name":"湘潭县","value":"430321","parent":"430300"},{"name":"湘乡市","value":"430381","parent":"430300"},{"name":"韶山市","value":"430382","parent":"430300"},{"name":"珠晖区","value":"430405","parent":"430400"},{"name":"雁峰区","value":"430406","parent":"430400"},{"name":"石鼓区","value":"430407","parent":"430400"},{"name":"蒸湘区","value":"430408","parent":"430400"},{"name":"南岳区","value":"430412","parent":"430400"},{"name":"衡阳县","value":"430421","parent":"430400"},{"name":"衡南县","value":"430422","parent":"430400"},{"name":"衡山县","value":"430423","parent":"430400"},{"name":"衡东县","value":"430424","parent":"430400"},{"name":"祁东县","value":"430426","parent":"430400"},{"name":"耒阳市","value":"430481","parent":"430400"},{"name":"常宁市","value":"430482","parent":"430400"},{"name":"双清区","value":"430502","parent":"430500"},{"name":"大祥区","value":"430503","parent":"430500"},{"name":"北塔区","value":"430511","parent":"430500"},{"name":"邵东县","value":"430521","parent":"430500"},{"name":"新邵县","value":"430522","parent":"430500"},{"name":"邵阳县","value":"430523","parent":"430500"},{"name":"隆回县","value":"430524","parent":"430500"},{"name":"洞口县","value":"430525","parent":"430500"},{"name":"绥宁县","value":"430527","parent":"430500"},{"name":"新宁县","value":"430528","parent":"430500"},{"name":"城步苗族自治县","value":"430529","parent":"430500"},{"name":"武冈市","value":"430581","parent":"430500"},{"name":"岳阳楼区","value":"430602","parent":"430600"},{"name":"云溪区","value":"430603","parent":"430600"},{"name":"君山区","value":"430611","parent":"430600"},{"name":"岳阳县","value":"430621","parent":"430600"},{"name":"华容县","value":"430623","parent":"430600"},{"name":"湘阴县","value":"430624","parent":"430600"},{"name":"平江县","value":"430626","parent":"430600"},{"name":"汨罗市","value":"430681","parent":"430600"},{"name":"临湘市","value":"430682","parent":"430600"},{"name":"武陵区","value":"430702","parent":"430700"},{"name":"鼎城区","value":"430703","parent":"430700"},{"name":"安乡县","value":"430721","parent":"430700"},{"name":"汉寿县","value":"430722","parent":"430700"},{"name":"澧县","value":"430723","parent":"430700"},{"name":"临澧县","value":"430724","parent":"430700"},{"name":"桃源县","value":"430725","parent":"430700"},{"name":"石门县","value":"430726","parent":"430700"},{"name":"津市市","value":"430781","parent":"430700"},{"name":"永定区","value":"430802","parent":"430800"},{"name":"武陵源区","value":"430811","parent":"430800"},{"name":"慈利县","value":"430821","parent":"430800"},{"name":"桑植县","value":"430822","parent":"430800"},{"name":"资阳区","value":"430902","parent":"430900"},{"name":"赫山区","value":"430903","parent":"430900"},{"name":"南县","value":"430921","parent":"430900"},{"name":"桃江县","value":"430922","parent":"430900"},{"name":"安化县","value":"430923","parent":"430900"},{"name":"沅江市","value":"430981","parent":"430900"},{"name":"北湖区","value":"431002","parent":"431000"},{"name":"苏仙区","value":"431003","parent":"431000"},{"name":"桂阳县","value":"431021","parent":"431000"},{"name":"宜章县","value":"431022","parent":"431000"},{"name":"永兴县","value":"431023","parent":"431000"},{"name":"嘉禾县","value":"431024","parent":"431000"},{"name":"临武县","value":"431025","parent":"431000"},{"name":"汝城县","value":"431026","parent":"431000"},{"name":"桂东县","value":"431027","parent":"431000"},{"name":"安仁县","value":"431028","parent":"431000"},{"name":"资兴市","value":"431081","parent":"431000"},{"name":"零陵区","value":"431102","parent":"431100"},{"name":"冷水滩区","value":"431103","parent":"431100"},{"name":"祁阳县","value":"431121","parent":"431100"},{"name":"东安县","value":"431122","parent":"431100"},{"name":"双牌县","value":"431123","parent":"431100"},{"name":"道县","value":"431124","parent":"431100"},{"name":"江永县","value":"431125","parent":"431100"},{"name":"宁远县","value":"431126","parent":"431100"},{"name":"蓝山县","value":"431127","parent":"431100"},{"name":"新田县","value":"431128","parent":"431100"},{"name":"江华瑶族自治县","value":"431129","parent":"431100"},{"name":"鹤城区","value":"431202","parent":"431200"},{"name":"中方县","value":"431221","parent":"431200"},{"name":"沅陵县","value":"431222","parent":"431200"},{"name":"辰溪县","value":"431223","parent":"431200"},{"name":"溆浦县","value":"431224","parent":"431200"},{"name":"会同县","value":"431225","parent":"431200"},{"name":"麻阳苗族自治县","value":"431226","parent":"431200"},{"name":"新晃侗族自治县","value":"431227","parent":"431200"},{"name":"芷江侗族自治县","value":"431228","parent":"431200"},{"name":"靖州苗族侗族自治县","value":"431229","parent":"431200"},{"name":"通道侗族自治县","value":"431230","parent":"431200"},{"name":"洪江市","value":"431281","parent":"431200"},{"name":"娄星区","value":"431302","parent":"431300"},{"name":"双峰县","value":"431321","parent":"431300"},{"name":"新化县","value":"431322","parent":"431300"},{"name":"冷水江市","value":"431381","parent":"431300"},{"name":"涟源市","value":"431382","parent":"431300"},{"name":"吉首市","value":"433101","parent":"433100"},{"name":"泸溪县","value":"433122","parent":"433100"},{"name":"凤凰县","value":"433123","parent":"433100"},{"name":"花垣县","value":"433124","parent":"433100"},{"name":"保靖县","value":"433125","parent":"433100"},{"name":"古丈县","value":"433126","parent":"433100"},{"name":"永顺县","value":"433127","parent":"433100"},{"name":"龙山县","value":"433130","parent":"433100"},{"name":"广州市","value":"440100","parent":"440000"},{"name":"韶关市","value":"440200","parent":"440000"},{"name":"深圳市","value":"440300","parent":"440000"},{"name":"珠海市","value":"440400","parent":"440000"},{"name":"汕头市","value":"440500","parent":"440000"},{"name":"佛山市","value":"440600","parent":"440000"},{"name":"江门市","value":"440700","parent":"440000"},{"name":"湛江市","value":"440800","parent":"440000"},{"name":"茂名市","value":"440900","parent":"440000"},{"name":"肇庆市","value":"441200","parent":"440000"},{"name":"惠州市","value":"441300","parent":"440000"},{"name":"梅州市","value":"441400","parent":"440000"},{"name":"汕尾市","value":"441500","parent":"440000"},{"name":"河源市","value":"441600","parent":"440000"},{"name":"阳江市","value":"441700","parent":"440000"},{"name":"清远市","value":"441800","parent":"440000"},{"name":"东莞市","value":"441900","parent":"440000"},{"name":"中山市","value":"442000","parent":"440000"},{"name":"潮州市","value":"445100","parent":"440000"},{"name":"揭阳市","value":"445200","parent":"440000"},{"name":"云浮市","value":"445300","parent":"440000"},{"name":"荔湾区","value":"440103","parent":"440100"},{"name":"越秀区","value":"440104","parent":"440100"},{"name":"海珠区","value":"440105","parent":"440100"},{"name":"天河区","value":"440106","parent":"440100"},{"name":"白云区","value":"440111","parent":"440100"},{"name":"黄埔区","value":"440112","parent":"440100"},{"name":"番禺区","value":"440113","parent":"440100"},{"name":"花都区","value":"440114","parent":"440100"},{"name":"南沙区","value":"440115","parent":"440100"},{"name":"从化区","value":"440117","parent":"440100"},{"name":"增城区","value":"440118","parent":"440100"},{"name":"武江区","value":"440203","parent":"440200"},{"name":"浈江区","value":"440204","parent":"440200"},{"name":"曲江区","value":"440205","parent":"440200"},{"name":"始兴县","value":"440222","parent":"440200"},{"name":"仁化县","value":"440224","parent":"440200"},{"name":"翁源县","value":"440229","parent":"440200"},{"name":"乳源瑶族自治县","value":"440232","parent":"440200"},{"name":"新丰县","value":"440233","parent":"440200"},{"name":"乐昌市","value":"440281","parent":"440200"},{"name":"南雄市","value":"440282","parent":"440200"},{"name":"罗湖区","value":"440303","parent":"440300"},{"name":"福田区","value":"440304","parent":"440300"},{"name":"南山区","value":"440305","parent":"440300"},{"name":"宝安区","value":"440306","parent":"440300"},{"name":"龙岗区","value":"440307","parent":"440300"},{"name":"盐田区","value":"440308","parent":"440300"},{"name":"香洲区","value":"440402","parent":"440400"},{"name":"斗门区","value":"440403","parent":"440400"},{"name":"金湾区","value":"440404","parent":"440400"},{"name":"龙湖区","value":"440507","parent":"440500"},{"name":"金平区","value":"440511","parent":"440500"},{"name":"濠江区","value":"440512","parent":"440500"},{"name":"潮阳区","value":"440513","parent":"440500"},{"name":"潮南区","value":"440514","parent":"440500"},{"name":"澄海区","value":"440515","parent":"440500"},{"name":"南澳县","value":"440523","parent":"440500"},{"name":"禅城区","value":"440604","parent":"440600"},{"name":"南海区","value":"440605","parent":"440600"},{"name":"顺德区","value":"440606","parent":"440600"},{"name":"三水区","value":"440607","parent":"440600"},{"name":"高明区","value":"440608","parent":"440600"},{"name":"蓬江区","value":"440703","parent":"440700"},{"name":"江海区","value":"440704","parent":"440700"},{"name":"新会区","value":"440705","parent":"440700"},{"name":"台山市","value":"440781","parent":"440700"},{"name":"开平市","value":"440783","parent":"440700"},{"name":"鹤山市","value":"440784","parent":"440700"},{"name":"恩平市","value":"440785","parent":"440700"},{"name":"赤坎区","value":"440802","parent":"440800"},{"name":"霞山区","value":"440803","parent":"440800"},{"name":"坡头区","value":"440804","parent":"440800"},{"name":"麻章区","value":"440811","parent":"440800"},{"name":"遂溪县","value":"440823","parent":"440800"},{"name":"徐闻县","value":"440825","parent":"440800"},{"name":"廉江市","value":"440881","parent":"440800"},{"name":"雷州市","value":"440882","parent":"440800"},{"name":"吴川市","value":"440883","parent":"440800"},{"name":"茂南区","value":"440902","parent":"440900"},{"name":"电白区","value":"440904","parent":"440900"},{"name":"高州市","value":"440981","parent":"440900"},{"name":"化州市","value":"440982","parent":"440900"},{"name":"信宜市","value":"440983","parent":"440900"},{"name":"端州区","value":"441202","parent":"441200"},{"name":"鼎湖区","value":"441203","parent":"441200"},{"name":"高要区","value":"441204","parent":"441200"},{"name":"广宁县","value":"441223","parent":"441200"},{"name":"怀集县","value":"441224","parent":"441200"},{"name":"封开县","value":"441225","parent":"441200"},{"name":"德庆县","value":"441226","parent":"441200"},{"name":"四会市","value":"441284","parent":"441200"},{"name":"惠城区","value":"441302","parent":"441300"},{"name":"惠阳区","value":"441303","parent":"441300"},{"name":"博罗县","value":"441322","parent":"441300"},{"name":"惠东县","value":"441323","parent":"441300"},{"name":"龙门县","value":"441324","parent":"441300"},{"name":"梅江区","value":"441402","parent":"441400"},{"name":"梅县区","value":"441403","parent":"441400"},{"name":"大埔县","value":"441422","parent":"441400"},{"name":"丰顺县","value":"441423","parent":"441400"},{"name":"五华县","value":"441424","parent":"441400"},{"name":"平远县","value":"441426","parent":"441400"},{"name":"蕉岭县","value":"441427","parent":"441400"},{"name":"兴宁市","value":"441481","parent":"441400"},{"name":"城区","value":"441502","parent":"441500"},{"name":"海丰县","value":"441521","parent":"441500"},{"name":"陆河县","value":"441523","parent":"441500"},{"name":"陆丰市","value":"441581","parent":"441500"},{"name":"源城区","value":"441602","parent":"441600"},{"name":"紫金县","value":"441621","parent":"441600"},{"name":"龙川县","value":"441622","parent":"441600"},{"name":"连平县","value":"441623","parent":"441600"},{"name":"和平县","value":"441624","parent":"441600"},{"name":"东源县","value":"441625","parent":"441600"},{"name":"江城区","value":"441702","parent":"441700"},{"name":"阳东区","value":"441704","parent":"441700"},{"name":"阳西县","value":"441721","parent":"441700"},{"name":"阳春市","value":"441781","parent":"441700"},{"name":"清城区","value":"441802","parent":"441800"},{"name":"清新区","value":"441803","parent":"441800"},{"name":"佛冈县","value":"441821","parent":"441800"},{"name":"阳山县","value":"441823","parent":"441800"},{"name":"连山壮族瑶族自治县","value":"441825","parent":"441800"},{"name":"连南瑶族自治县","value":"441826","parent":"441800"},{"name":"英德市","value":"441881","parent":"441800"},{"name":"连州市","value":"441882","parent":"441800"},{"name":"湘桥区","value":"445102","parent":"445100"},{"name":"潮安区","value":"445103","parent":"445100"},{"name":"饶平县","value":"445122","parent":"445100"},{"name":"榕城区","value":"445202","parent":"445200"},{"name":"揭东区","value":"445203","parent":"445200"},{"name":"揭西县","value":"445222","parent":"445200"},{"name":"惠来县","value":"445224","parent":"445200"},{"name":"普宁市","value":"445281","parent":"445200"},{"name":"云城区","value":"445302","parent":"445300"},{"name":"云安区","value":"445303","parent":"445300"},{"name":"新兴县","value":"445321","parent":"445300"},{"name":"郁南县","value":"445322","parent":"445300"},{"name":"罗定市","value":"445381","parent":"445300"},{"name":"南宁市","value":"450100","parent":"450000"},{"name":"柳州市","value":"450200","parent":"450000"},{"name":"桂林市","value":"450300","parent":"450000"},{"name":"梧州市","value":"450400","parent":"450000"},{"name":"北海市","value":"450500","parent":"450000"},{"name":"防城港市","value":"450600","parent":"450000"},{"name":"钦州市","value":"450700","parent":"450000"},{"name":"贵港市","value":"450800","parent":"450000"},{"name":"玉林市","value":"450900","parent":"450000"},{"name":"百色市","value":"451000","parent":"450000"},{"name":"贺州市","value":"451100","parent":"450000"},{"name":"河池市","value":"451200","parent":"450000"},{"name":"来宾市","value":"451300","parent":"450000"},{"name":"崇左市","value":"451400","parent":"450000"},{"name":"兴宁区","value":"450102","parent":"450100"},{"name":"青秀区","value":"450103","parent":"450100"},{"name":"江南区","value":"450105","parent":"450100"},{"name":"西乡塘区","value":"450107","parent":"450100"},{"name":"良庆区","value":"450108","parent":"450100"},{"name":"邕宁区","value":"450109","parent":"450100"},{"name":"武鸣区","value":"450110","parent":"450100"},{"name":"隆安县","value":"450123","parent":"450100"},{"name":"马山县","value":"450124","parent":"450100"},{"name":"上林县","value":"450125","parent":"450100"},{"name":"宾阳县","value":"450126","parent":"450100"},{"name":"横县","value":"450127","parent":"450100"},{"name":"城中区","value":"450202","parent":"450200"},{"name":"鱼峰区","value":"450203","parent":"450200"},{"name":"柳南区","value":"450204","parent":"450200"},{"name":"柳北区","value":"450205","parent":"450200"},{"name":"柳江区","value":"450206","parent":"450200"},{"name":"柳城县","value":"450222","parent":"450200"},{"name":"鹿寨县","value":"450223","parent":"450200"},{"name":"融安县","value":"450224","parent":"450200"},{"name":"融水苗族自治县","value":"450225","parent":"450200"},{"name":"三江侗族自治县","value":"450226","parent":"450200"},{"name":"秀峰区","value":"450302","parent":"450300"},{"name":"叠彩区","value":"450303","parent":"450300"},{"name":"象山区","value":"450304","parent":"450300"},{"name":"七星区","value":"450305","parent":"450300"},{"name":"雁山区","value":"450311","parent":"450300"},{"name":"临桂区","value":"450312","parent":"450300"},{"name":"阳朔县","value":"450321","parent":"450300"},{"name":"灵川县","value":"450323","parent":"450300"},{"name":"全州县","value":"450324","parent":"450300"},{"name":"兴安县","value":"450325","parent":"450300"},{"name":"永福县","value":"450326","parent":"450300"},{"name":"灌阳县","value":"450327","parent":"450300"},{"name":"龙胜各族自治县","value":"450328","parent":"450300"},{"name":"资源县","value":"450329","parent":"450300"},{"name":"平乐县","value":"450330","parent":"450300"},{"name":"荔浦县","value":"450331","parent":"450300"},{"name":"恭城瑶族自治县","value":"450332","parent":"450300"},{"name":"万秀区","value":"450403","parent":"450400"},{"name":"长洲区","value":"450405","parent":"450400"},{"name":"龙圩区","value":"450406","parent":"450400"},{"name":"苍梧县","value":"450421","parent":"450400"},{"name":"藤县","value":"450422","parent":"450400"},{"name":"蒙山县","value":"450423","parent":"450400"},{"name":"岑溪市","value":"450481","parent":"450400"},{"name":"海城区","value":"450502","parent":"450500"},{"name":"银海区","value":"450503","parent":"450500"},{"name":"铁山港区","value":"450512","parent":"450500"},{"name":"合浦县","value":"450521","parent":"450500"},{"name":"港口区","value":"450602","parent":"450600"},{"name":"防城区","value":"450603","parent":"450600"},{"name":"上思县","value":"450621","parent":"450600"},{"name":"东兴市","value":"450681","parent":"450600"},{"name":"钦南区","value":"450702","parent":"450700"},{"name":"钦北区","value":"450703","parent":"450700"},{"name":"灵山县","value":"450721","parent":"450700"},{"name":"浦北县","value":"450722","parent":"450700"},{"name":"港北区","value":"450802","parent":"450800"},{"name":"港南区","value":"450803","parent":"450800"},{"name":"覃塘区","value":"450804","parent":"450800"},{"name":"平南县","value":"450821","parent":"450800"},{"name":"桂平市","value":"450881","parent":"450800"},{"name":"玉州区","value":"450902","parent":"450900"},{"name":"福绵区","value":"450903","parent":"450900"},{"name":"容县","value":"450921","parent":"450900"},{"name":"陆川县","value":"450922","parent":"450900"},{"name":"博白县","value":"450923","parent":"450900"},{"name":"兴业县","value":"450924","parent":"450900"},{"name":"北流市","value":"450981","parent":"450900"},{"name":"右江区","value":"451002","parent":"451000"},{"name":"田阳县","value":"451021","parent":"451000"},{"name":"田东县","value":"451022","parent":"451000"},{"name":"平果县","value":"451023","parent":"451000"},{"name":"德保县","value":"451024","parent":"451000"},{"name":"那坡县","value":"451026","parent":"451000"},{"name":"凌云县","value":"451027","parent":"451000"},{"name":"乐业县","value":"451028","parent":"451000"},{"name":"田林县","value":"451029","parent":"451000"},{"name":"西林县","value":"451030","parent":"451000"},{"name":"隆林各族自治县","value":"451031","parent":"451000"},{"name":"靖西市","value":"451081","parent":"451000"},{"name":"八步区","value":"451102","parent":"451100"},{"name":"平桂区","value":"451103","parent":"451100"},{"name":"昭平县","value":"451121","parent":"451100"},{"name":"钟山县","value":"451122","parent":"451100"},{"name":"富川瑶族自治县","value":"451123","parent":"451100"},{"name":"金城江区","value":"451202","parent":"451200"},{"name":"南丹县","value":"451221","parent":"451200"},{"name":"天峨县","value":"451222","parent":"451200"},{"name":"凤山县","value":"451223","parent":"451200"},{"name":"东兰县","value":"451224","parent":"451200"},{"name":"罗城仫佬族自治县","value":"451225","parent":"451200"},{"name":"环江毛南族自治县","value":"451226","parent":"451200"},{"name":"巴马瑶族自治县","value":"451227","parent":"451200"},{"name":"都安瑶族自治县","value":"451228","parent":"451200"},{"name":"大化瑶族自治县","value":"451229","parent":"451200"},{"name":"宜州市","value":"451281","parent":"451200"},{"name":"兴宾区","value":"451302","parent":"451300"},{"name":"忻城县","value":"451321","parent":"451300"},{"name":"象州县","value":"451322","parent":"451300"},{"name":"武宣县","value":"451323","parent":"451300"},{"name":"金秀瑶族自治县","value":"451324","parent":"451300"},{"name":"合山市","value":"451381","parent":"451300"},{"name":"江州区","value":"451402","parent":"451400"},{"name":"扶绥县","value":"451421","parent":"451400"},{"name":"宁明县","value":"451422","parent":"451400"},{"name":"龙州县","value":"451423","parent":"451400"},{"name":"大新县","value":"451424","parent":"451400"},{"name":"天等县","value":"451425","parent":"451400"},{"name":"凭祥市","value":"451481","parent":"451400"},{"name":"海口市","value":"460100","parent":"460000"},{"name":"三亚市","value":"460200","parent":"460000"},{"name":"三沙市","value":"460300","parent":"460000"},{"name":"儋州市","value":"460400","parent":"460000"},{"name":"五指山市","value":"469001","parent":"460000"},{"name":"琼海市","value":"469002","parent":"460000"},{"name":"文昌市","value":"469005","parent":"460000"},{"name":"万宁市","value":"469006","parent":"460000"},{"name":"东方市","value":"469007","parent":"460000"},{"name":"定安县","value":"469021","parent":"460000"},{"name":"屯昌县","value":"469022","parent":"460000"},{"name":"澄迈县","value":"469023","parent":"460000"},{"name":"临高县","value":"469024","parent":"460000"},{"name":"白沙黎族自治县","value":"469025","parent":"460000"},{"name":"昌江黎族自治县","value":"469026","parent":"460000"},{"name":"乐东黎族自治县","value":"469027","parent":"460000"},{"name":"陵水黎族自治县","value":"469028","parent":"460000"},{"name":"保亭黎族苗族自治县","value":"469029","parent":"460000"},{"name":"琼中黎族苗族自治县","value":"469030","parent":"460000"},{"name":"秀英区","value":"460105","parent":"460100"},{"name":"龙华区","value":"460106","parent":"460100"},{"name":"琼山区","value":"460107","parent":"460100"},{"name":"美兰区","value":"460108","parent":"460100"},{"name":"海棠区","value":"460202","parent":"460200"},{"name":"吉阳区","value":"460203","parent":"460200"},{"name":"天涯区","value":"460204","parent":"460200"},{"name":"崖州区","value":"460205","parent":"460200"},{"name":"市辖区","value":"500100","parent":"500000"},{"name":"县","value":"500200","parent":"500000"},{"name":"万州区","value":"500101","parent":"500100"},{"name":"涪陵区","value":"500102","parent":"500100"},{"name":"渝中区","value":"500103","parent":"500100"},{"name":"大渡口区","value":"500104","parent":"500100"},{"name":"江北区","value":"500105","parent":"500100"},{"name":"沙坪坝区","value":"500106","parent":"500100"},{"name":"九龙坡区","value":"500107","parent":"500100"},{"name":"南岸区","value":"500108","parent":"500100"},{"name":"北碚区","value":"500109","parent":"500100"},{"name":"綦江区","value":"500110","parent":"500100"},{"name":"大足区","value":"500111","parent":"500100"},{"name":"渝北区","value":"500112","parent":"500100"},{"name":"巴南区","value":"500113","parent":"500100"},{"name":"黔江区","value":"500114","parent":"500100"},{"name":"长寿区","value":"500115","parent":"500100"},{"name":"江津区","value":"500116","parent":"500100"},{"name":"合川区","value":"500117","parent":"500100"},{"name":"永川区","value":"500118","parent":"500100"},{"name":"南川区","value":"500119","parent":"500100"},{"name":"璧山区","value":"500120","parent":"500100"},{"name":"铜梁区","value":"500151","parent":"500100"},{"name":"潼南区","value":"500152","parent":"500100"},{"name":"荣昌区","value":"500153","parent":"500100"},{"name":"开州区","value":"500154","parent":"500100"},{"name":"梁平县","value":"500228","parent":"500200"},{"name":"城口县","value":"500229","parent":"500200"},{"name":"丰都县","value":"500230","parent":"500200"},{"name":"垫江县","value":"500231","parent":"500200"},{"name":"武隆县","value":"500232","parent":"500200"},{"name":"忠县","value":"500233","parent":"500200"},{"name":"云阳县","value":"500235","parent":"500200"},{"name":"奉节县","value":"500236","parent":"500200"},{"name":"巫山县","value":"500237","parent":"500200"},{"name":"巫溪县","value":"500238","parent":"500200"},{"name":"石柱土家族自治县","value":"500240","parent":"500200"},{"name":"秀山土家族苗族自治县","value":"500241","parent":"500200"},{"name":"酉阳土家族苗族自治县","value":"500242","parent":"500200"},{"name":"彭水苗族土家族自治县","value":"500243","parent":"500200"},{"name":"成都市","value":"510100","parent":"510000"},{"name":"自贡市","value":"510300","parent":"510000"},{"name":"攀枝花市","value":"510400","parent":"510000"},{"name":"泸州市","value":"510500","parent":"510000"},{"name":"德阳市","value":"510600","parent":"510000"},{"name":"绵阳市","value":"510700","parent":"510000"},{"name":"广元市","value":"510800","parent":"510000"},{"name":"遂宁市","value":"510900","parent":"510000"},{"name":"内江市","value":"511000","parent":"510000"},{"name":"乐山市","value":"511100","parent":"510000"},{"name":"南充市","value":"511300","parent":"510000"},{"name":"眉山市","value":"511400","parent":"510000"},{"name":"宜宾市","value":"511500","parent":"510000"},{"name":"广安市","value":"511600","parent":"510000"},{"name":"达州市","value":"511700","parent":"510000"},{"name":"雅安市","value":"511800","parent":"510000"},{"name":"巴中市","value":"511900","parent":"510000"},{"name":"资阳市","value":"512000","parent":"510000"},{"name":"阿坝藏族羌族自治州","value":"513200","parent":"510000"},{"name":"甘孜藏族自治州","value":"513300","parent":"510000"},{"name":"凉山彝族自治州","value":"513400","parent":"510000"},{"name":"锦江区","value":"510104","parent":"510100"},{"name":"青羊区","value":"510105","parent":"510100"},{"name":"金牛区","value":"510106","parent":"510100"},{"name":"武侯区","value":"510107","parent":"510100"},{"name":"成华区","value":"510108","parent":"510100"},{"name":"龙泉驿区","value":"510112","parent":"510100"},{"name":"青白江区","value":"510113","parent":"510100"},{"name":"新都区","value":"510114","parent":"510100"},{"name":"温江区","value":"510115","parent":"510100"},{"name":"双流区","value":"510116","parent":"510100"},{"name":"金堂县","value":"510121","parent":"510100"},{"name":"郫县","value":"510124","parent":"510100"},{"name":"大邑县","value":"510129","parent":"510100"},{"name":"蒲江县","value":"510131","parent":"510100"},{"name":"新津县","value":"510132","parent":"510100"},{"name":"都江堰市","value":"510181","parent":"510100"},{"name":"彭州市","value":"510182","parent":"510100"},{"name":"邛崃市","value":"510183","parent":"510100"},{"name":"崇州市","value":"510184","parent":"510100"},{"name":"简阳市","value":"510185","parent":"510100"},{"name":"自流井区","value":"510302","parent":"510300"},{"name":"贡井区","value":"510303","parent":"510300"},{"name":"大安区","value":"510304","parent":"510300"},{"name":"沿滩区","value":"510311","parent":"510300"},{"name":"荣县","value":"510321","parent":"510300"},{"name":"富顺县","value":"510322","parent":"510300"},{"name":"东区","value":"510402","parent":"510400"},{"name":"西区","value":"510403","parent":"510400"},{"name":"仁和区","value":"510411","parent":"510400"},{"name":"米易县","value":"510421","parent":"510400"},{"name":"盐边县","value":"510422","parent":"510400"},{"name":"江阳区","value":"510502","parent":"510500"},{"name":"纳溪区","value":"510503","parent":"510500"},{"name":"龙马潭区","value":"510504","parent":"510500"},{"name":"泸县","value":"510521","parent":"510500"},{"name":"合江县","value":"510522","parent":"510500"},{"name":"叙永县","value":"510524","parent":"510500"},{"name":"古蔺县","value":"510525","parent":"510500"},{"name":"旌阳区","value":"510603","parent":"510600"},{"name":"中江县","value":"510623","parent":"510600"},{"name":"罗江县","value":"510626","parent":"510600"},{"name":"广汉市","value":"510681","parent":"510600"},{"name":"什邡市","value":"510682","parent":"510600"},{"name":"绵竹市","value":"510683","parent":"510600"},{"name":"涪城区","value":"510703","parent":"510700"},{"name":"游仙区","value":"510704","parent":"510700"},{"name":"安州区","value":"510705","parent":"510700"},{"name":"三台县","value":"510722","parent":"510700"},{"name":"盐亭县","value":"510723","parent":"510700"},{"name":"梓潼县","value":"510725","parent":"510700"},{"name":"北川羌族自治县","value":"510726","parent":"510700"},{"name":"平武县","value":"510727","parent":"510700"},{"name":"江油市","value":"510781","parent":"510700"},{"name":"利州区","value":"510802","parent":"510800"},{"name":"昭化区","value":"510811","parent":"510800"},{"name":"朝天区","value":"510812","parent":"510800"},{"name":"旺苍县","value":"510821","parent":"510800"},{"name":"青川县","value":"510822","parent":"510800"},{"name":"剑阁县","value":"510823","parent":"510800"},{"name":"苍溪县","value":"510824","parent":"510800"},{"name":"船山区","value":"510903","parent":"510900"},{"name":"安居区","value":"510904","parent":"510900"},{"name":"蓬溪县","value":"510921","parent":"510900"},{"name":"射洪县","value":"510922","parent":"510900"},{"name":"大英县","value":"510923","parent":"510900"},{"name":"市中区","value":"511002","parent":"511000"},{"name":"东兴区","value":"511011","parent":"511000"},{"name":"威远县","value":"511024","parent":"511000"},{"name":"资中县","value":"511025","parent":"511000"},{"name":"隆昌县","value":"511028","parent":"511000"},{"name":"市中区","value":"511102","parent":"511100"},{"name":"沙湾区","value":"511111","parent":"511100"},{"name":"五通桥区","value":"511112","parent":"511100"},{"name":"金口河区","value":"511113","parent":"511100"},{"name":"犍为县","value":"511123","parent":"511100"},{"name":"井研县","value":"511124","parent":"511100"},{"name":"夹江县","value":"511126","parent":"511100"},{"name":"沐川县","value":"511129","parent":"511100"},{"name":"峨边彝族自治县","value":"511132","parent":"511100"},{"name":"马边彝族自治县","value":"511133","parent":"511100"},{"name":"峨眉山市","value":"511181","parent":"511100"},{"name":"顺庆区","value":"511302","parent":"511300"},{"name":"高坪区","value":"511303","parent":"511300"},{"name":"嘉陵区","value":"511304","parent":"511300"},{"name":"南部县","value":"511321","parent":"511300"},{"name":"营山县","value":"511322","parent":"511300"},{"name":"蓬安县","value":"511323","parent":"511300"},{"name":"仪陇县","value":"511324","parent":"511300"},{"name":"西充县","value":"511325","parent":"511300"},{"name":"阆中市","value":"511381","parent":"511300"},{"name":"东坡区","value":"511402","parent":"511400"},{"name":"彭山区","value":"511403","parent":"511400"},{"name":"仁寿县","value":"511421","parent":"511400"},{"name":"洪雅县","value":"511423","parent":"511400"},{"name":"丹棱县","value":"511424","parent":"511400"},{"name":"青神县","value":"511425","parent":"511400"},{"name":"翠屏区","value":"511502","parent":"511500"},{"name":"南溪区","value":"511503","parent":"511500"},{"name":"宜宾县","value":"511521","parent":"511500"},{"name":"江安县","value":"511523","parent":"511500"},{"name":"长宁县","value":"511524","parent":"511500"},{"name":"高县","value":"511525","parent":"511500"},{"name":"珙县","value":"511526","parent":"511500"},{"name":"筠连县","value":"511527","parent":"511500"},{"name":"兴文县","value":"511528","parent":"511500"},{"name":"屏山县","value":"511529","parent":"511500"},{"name":"广安区","value":"511602","parent":"511600"},{"name":"前锋区","value":"511603","parent":"511600"},{"name":"岳池县","value":"511621","parent":"511600"},{"name":"武胜县","value":"511622","parent":"511600"},{"name":"邻水县","value":"511623","parent":"511600"},{"name":"华蓥市","value":"511681","parent":"511600"},{"name":"通川区","value":"511702","parent":"511700"},{"name":"达川区","value":"511703","parent":"511700"},{"name":"宣汉县","value":"511722","parent":"511700"},{"name":"开江县","value":"511723","parent":"511700"},{"name":"大竹县","value":"511724","parent":"511700"},{"name":"渠县","value":"511725","parent":"511700"},{"name":"万源市","value":"511781","parent":"511700"},{"name":"雨城区","value":"511802","parent":"511800"},{"name":"名山区","value":"511803","parent":"511800"},{"name":"荥经县","value":"511822","parent":"511800"},{"name":"汉源县","value":"511823","parent":"511800"},{"name":"石棉县","value":"511824","parent":"511800"},{"name":"天全县","value":"511825","parent":"511800"},{"name":"芦山县","value":"511826","parent":"511800"},{"name":"宝兴县","value":"511827","parent":"511800"},{"name":"巴州区","value":"511902","parent":"511900"},{"name":"恩阳区","value":"511903","parent":"511900"},{"name":"通江县","value":"511921","parent":"511900"},{"name":"南江县","value":"511922","parent":"511900"},{"name":"平昌县","value":"511923","parent":"511900"},{"name":"雁江区","value":"512002","parent":"512000"},{"name":"安岳县","value":"512021","parent":"512000"},{"name":"乐至县","value":"512022","parent":"512000"},{"name":"马尔康市","value":"513201","parent":"513200"},{"name":"汶川县","value":"513221","parent":"513200"},{"name":"理县","value":"513222","parent":"513200"},{"name":"茂县","value":"513223","parent":"513200"},{"name":"松潘县","value":"513224","parent":"513200"},{"name":"九寨沟县","value":"513225","parent":"513200"},{"name":"金川县","value":"513226","parent":"513200"},{"name":"小金县","value":"513227","parent":"513200"},{"name":"黑水县","value":"513228","parent":"513200"},{"name":"壤塘县","value":"513230","parent":"513200"},{"name":"阿坝县","value":"513231","parent":"513200"},{"name":"若尔盖县","value":"513232","parent":"513200"},{"name":"红原县","value":"513233","parent":"513200"},{"name":"康定市","value":"513301","parent":"513300"},{"name":"泸定县","value":"513322","parent":"513300"},{"name":"丹巴县","value":"513323","parent":"513300"},{"name":"九龙县","value":"513324","parent":"513300"},{"name":"雅江县","value":"513325","parent":"513300"},{"name":"道孚县","value":"513326","parent":"513300"},{"name":"炉霍县","value":"513327","parent":"513300"},{"name":"甘孜县","value":"513328","parent":"513300"},{"name":"新龙县","value":"513329","parent":"513300"},{"name":"德格县","value":"513330","parent":"513300"},{"name":"白玉县","value":"513331","parent":"513300"},{"name":"石渠县","value":"513332","parent":"513300"},{"name":"色达县","value":"513333","parent":"513300"},{"name":"理塘县","value":"513334","parent":"513300"},{"name":"巴塘县","value":"513335","parent":"513300"},{"name":"乡城县","value":"513336","parent":"513300"},{"name":"稻城县","value":"513337","parent":"513300"},{"name":"得荣县","value":"513338","parent":"513300"},{"name":"西昌市","value":"513401","parent":"513400"},{"name":"木里藏族自治县","value":"513422","parent":"513400"},{"name":"盐源县","value":"513423","parent":"513400"},{"name":"德昌县","value":"513424","parent":"513400"},{"name":"会理县","value":"513425","parent":"513400"},{"name":"会东县","value":"513426","parent":"513400"},{"name":"宁南县","value":"513427","parent":"513400"},{"name":"普格县","value":"513428","parent":"513400"},{"name":"布拖县","value":"513429","parent":"513400"},{"name":"金阳县","value":"513430","parent":"513400"},{"name":"昭觉县","value":"513431","parent":"513400"},{"name":"喜德县","value":"513432","parent":"513400"},{"name":"冕宁县","value":"513433","parent":"513400"},{"name":"越西县","value":"513434","parent":"513400"},{"name":"甘洛县","value":"513435","parent":"513400"},{"name":"美姑县","value":"513436","parent":"513400"},{"name":"雷波县","value":"513437","parent":"513400"},{"name":"贵阳市","value":"520100","parent":"520000"},{"name":"六盘水市","value":"520200","parent":"520000"},{"name":"遵义市","value":"520300","parent":"520000"},{"name":"安顺市","value":"520400","parent":"520000"},{"name":"毕节市","value":"520500","parent":"520000"},{"name":"铜仁市","value":"520600","parent":"520000"},{"name":"黔西南布依族苗族自治州","value":"522300","parent":"520000"},{"name":"黔东南苗族侗族自治州","value":"522600","parent":"520000"},{"name":"黔南布依族苗族自治州","value":"522700","parent":"520000"},{"name":"南明区","value":"520102","parent":"520100"},{"name":"云岩区","value":"520103","parent":"520100"},{"name":"花溪区","value":"520111","parent":"520100"},{"name":"乌当区","value":"520112","parent":"520100"},{"name":"白云区","value":"520113","parent":"520100"},{"name":"观山湖区","value":"520115","parent":"520100"},{"name":"开阳县","value":"520121","parent":"520100"},{"name":"息烽县","value":"520122","parent":"520100"},{"name":"修文县","value":"520123","parent":"520100"},{"name":"清镇市","value":"520181","parent":"520100"},{"name":"钟山区","value":"520201","parent":"520200"},{"name":"六枝特区","value":"520203","parent":"520200"},{"name":"水城县","value":"520221","parent":"520200"},{"name":"盘县","value":"520222","parent":"520200"},{"name":"红花岗区","value":"520302","parent":"520300"},{"name":"汇川区","value":"520303","parent":"520300"},{"name":"播州区","value":"520304","parent":"520300"},{"name":"桐梓县","value":"520322","parent":"520300"},{"name":"绥阳县","value":"520323","parent":"520300"},{"name":"正安县","value":"520324","parent":"520300"},{"name":"道真仡佬族苗族自治县","value":"520325","parent":"520300"},{"name":"务川仡佬族苗族自治县","value":"520326","parent":"520300"},{"name":"凤冈县","value":"520327","parent":"520300"},{"name":"湄潭县","value":"520328","parent":"520300"},{"name":"余庆县","value":"520329","parent":"520300"},{"name":"习水县","value":"520330","parent":"520300"},{"name":"赤水市","value":"520381","parent":"520300"},{"name":"仁怀市","value":"520382","parent":"520300"},{"name":"西秀区","value":"520402","parent":"520400"},{"name":"平坝区","value":"520403","parent":"520400"},{"name":"普定县","value":"520422","parent":"520400"},{"name":"镇宁布依族苗族自治县","value":"520423","parent":"520400"},{"name":"关岭布依族苗族自治县","value":"520424","parent":"520400"},{"name":"紫云苗族布依族自治县","value":"520425","parent":"520400"},{"name":"七星关区","value":"520502","parent":"520500"},{"name":"大方县","value":"520521","parent":"520500"},{"name":"黔西县","value":"520522","parent":"520500"},{"name":"金沙县","value":"520523","parent":"520500"},{"name":"织金县","value":"520524","parent":"520500"},{"name":"纳雍县","value":"520525","parent":"520500"},{"name":"威宁彝族回族苗族自治县","value":"520526","parent":"520500"},{"name":"赫章县","value":"520527","parent":"520500"},{"name":"碧江区","value":"520602","parent":"520600"},{"name":"万山区","value":"520603","parent":"520600"},{"name":"江口县","value":"520621","parent":"520600"},{"name":"玉屏侗族自治县","value":"520622","parent":"520600"},{"name":"石阡县","value":"520623","parent":"520600"},{"name":"思南县","value":"520624","parent":"520600"},{"name":"印江土家族苗族自治县","value":"520625","parent":"520600"},{"name":"德江县","value":"520626","parent":"520600"},{"name":"沿河土家族自治县","value":"520627","parent":"520600"},{"name":"松桃苗族自治县","value":"520628","parent":"520600"},{"name":"兴义市","value":"522301","parent":"522300"},{"name":"兴仁县","value":"522322","parent":"522300"},{"name":"普安县","value":"522323","parent":"522300"},{"name":"晴隆县","value":"522324","parent":"522300"},{"name":"贞丰县","value":"522325","parent":"522300"},{"name":"望谟县","value":"522326","parent":"522300"},{"name":"册亨县","value":"522327","parent":"522300"},{"name":"安龙县","value":"522328","parent":"522300"},{"name":"凯里市","value":"522601","parent":"522600"},{"name":"黄平县","value":"522622","parent":"522600"},{"name":"施秉县","value":"522623","parent":"522600"},{"name":"三穗县","value":"522624","parent":"522600"},{"name":"镇远县","value":"522625","parent":"522600"},{"name":"岑巩县","value":"522626","parent":"522600"},{"name":"天柱县","value":"522627","parent":"522600"},{"name":"锦屏县","value":"522628","parent":"522600"},{"name":"剑河县","value":"522629","parent":"522600"},{"name":"台江县","value":"522630","parent":"522600"},{"name":"黎平县","value":"522631","parent":"522600"},{"name":"榕江县","value":"522632","parent":"522600"},{"name":"从江县","value":"522633","parent":"522600"},{"name":"雷山县","value":"522634","parent":"522600"},{"name":"麻江县","value":"522635","parent":"522600"},{"name":"丹寨县","value":"522636","parent":"522600"},{"name":"都匀市","value":"522701","parent":"522700"},{"name":"福泉市","value":"522702","parent":"522700"},{"name":"荔波县","value":"522722","parent":"522700"},{"name":"贵定县","value":"522723","parent":"522700"},{"name":"瓮安县","value":"522725","parent":"522700"},{"name":"独山县","value":"522726","parent":"522700"},{"name":"平塘县","value":"522727","parent":"522700"},{"name":"罗甸县","value":"522728","parent":"522700"},{"name":"长顺县","value":"522729","parent":"522700"},{"name":"龙里县","value":"522730","parent":"522700"},{"name":"惠水县","value":"522731","parent":"522700"},{"name":"三都水族自治县","value":"522732","parent":"522700"},{"name":"昆明市","value":"530100","parent":"530000"},{"name":"曲靖市","value":"530300","parent":"530000"},{"name":"玉溪市","value":"530400","parent":"530000"},{"name":"保山市","value":"530500","parent":"530000"},{"name":"昭通市","value":"530600","parent":"530000"},{"name":"丽江市","value":"530700","parent":"530000"},{"name":"普洱市","value":"530800","parent":"530000"},{"name":"临沧市","value":"530900","parent":"530000"},{"name":"楚雄彝族自治州","value":"532300","parent":"530000"},{"name":"红河哈尼族彝族自治州","value":"532500","parent":"530000"},{"name":"文山壮族苗族自治州","value":"532600","parent":"530000"},{"name":"西双版纳傣族自治州","value":"532800","parent":"530000"},{"name":"大理白族自治州","value":"532900","parent":"530000"},{"name":"德宏傣族景颇族自治州","value":"533100","parent":"530000"},{"name":"怒江傈僳族自治州","value":"533300","parent":"530000"},{"name":"迪庆藏族自治州","value":"533400","parent":"530000"},{"name":"五华区","value":"530102","parent":"530100"},{"name":"盘龙区","value":"530103","parent":"530100"},{"name":"官渡区","value":"530111","parent":"530100"},{"name":"西山区","value":"530112","parent":"530100"},{"name":"东川区","value":"530113","parent":"530100"},{"name":"呈贡区","value":"530114","parent":"530100"},{"name":"晋宁县","value":"530122","parent":"530100"},{"name":"富民县","value":"530124","parent":"530100"},{"name":"宜良县","value":"530125","parent":"530100"},{"name":"石林彝族自治县","value":"530126","parent":"530100"},{"name":"嵩明县","value":"530127","parent":"530100"},{"name":"禄劝彝族苗族自治县","value":"530128","parent":"530100"},{"name":"寻甸回族彝族自治县","value":"530129","parent":"530100"},{"name":"安宁市","value":"530181","parent":"530100"},{"name":"麒麟区","value":"530302","parent":"530300"},{"name":"沾益区","value":"530303","parent":"530300"},{"name":"马龙县","value":"530321","parent":"530300"},{"name":"陆良县","value":"530322","parent":"530300"},{"name":"师宗县","value":"530323","parent":"530300"},{"name":"罗平县","value":"530324","parent":"530300"},{"name":"富源县","value":"530325","parent":"530300"},{"name":"会泽县","value":"530326","parent":"530300"},{"name":"宣威市","value":"530381","parent":"530300"},{"name":"红塔区","value":"530402","parent":"530400"},{"name":"江川区","value":"530403","parent":"530400"},{"name":"澄江县","value":"530422","parent":"530400"},{"name":"通海县","value":"530423","parent":"530400"},{"name":"华宁县","value":"530424","parent":"530400"},{"name":"易门县","value":"530425","parent":"530400"},{"name":"峨山彝族自治县","value":"530426","parent":"530400"},{"name":"新平彝族傣族自治县","value":"530427","parent":"530400"},{"name":"元江哈尼族彝族傣族自治县","value":"530428","parent":"530400"},{"name":"隆阳区","value":"530502","parent":"530500"},{"name":"施甸县","value":"530521","parent":"530500"},{"name":"龙陵县","value":"530523","parent":"530500"},{"name":"昌宁县","value":"530524","parent":"530500"},{"name":"腾冲市","value":"530581","parent":"530500"},{"name":"昭阳区","value":"530602","parent":"530600"},{"name":"鲁甸县","value":"530621","parent":"530600"},{"name":"巧家县","value":"530622","parent":"530600"},{"name":"盐津县","value":"530623","parent":"530600"},{"name":"大关县","value":"530624","parent":"530600"},{"name":"永善县","value":"530625","parent":"530600"},{"name":"绥江县","value":"530626","parent":"530600"},{"name":"镇雄县","value":"530627","parent":"530600"},{"name":"彝良县","value":"530628","parent":"530600"},{"name":"威信县","value":"530629","parent":"530600"},{"name":"水富县","value":"530630","parent":"530600"},{"name":"古城区","value":"530702","parent":"530700"},{"name":"玉龙纳西族自治县","value":"530721","parent":"530700"},{"name":"永胜县","value":"530722","parent":"530700"},{"name":"华坪县","value":"530723","parent":"530700"},{"name":"宁蒗彝族自治县","value":"530724","parent":"530700"},{"name":"思茅区","value":"530802","parent":"530800"},{"name":"宁洱哈尼族彝族自治县","value":"530821","parent":"530800"},{"name":"墨江哈尼族自治县","value":"530822","parent":"530800"},{"name":"景东彝族自治县","value":"530823","parent":"530800"},{"name":"景谷傣族彝族自治县","value":"530824","parent":"530800"},{"name":"镇沅彝族哈尼族拉祜族自治县","value":"530825","parent":"530800"},{"name":"江城哈尼族彝族自治县","value":"530826","parent":"530800"},{"name":"孟连傣族拉祜族佤族自治县","value":"530827","parent":"530800"},{"name":"澜沧拉祜族自治县","value":"530828","parent":"530800"},{"name":"西盟佤族自治县","value":"530829","parent":"530800"},{"name":"临翔区","value":"530902","parent":"530900"},{"name":"凤庆县","value":"530921","parent":"530900"},{"name":"云县","value":"530922","parent":"530900"},{"name":"永德县","value":"530923","parent":"530900"},{"name":"镇康县","value":"530924","parent":"530900"},{"name":"双江拉祜族佤族布朗族傣族自治县","value":"530925","parent":"530900"},{"name":"耿马傣族佤族自治县","value":"530926","parent":"530900"},{"name":"沧源佤族自治县","value":"530927","parent":"530900"},{"name":"楚雄市","value":"532301","parent":"532300"},{"name":"双柏县","value":"532322","parent":"532300"},{"name":"牟定县","value":"532323","parent":"532300"},{"name":"南华县","value":"532324","parent":"532300"},{"name":"姚安县","value":"532325","parent":"532300"},{"name":"大姚县","value":"532326","parent":"532300"},{"name":"永仁县","value":"532327","parent":"532300"},{"name":"元谋县","value":"532328","parent":"532300"},{"name":"武定县","value":"532329","parent":"532300"},{"name":"禄丰县","value":"532331","parent":"532300"},{"name":"个旧市","value":"532501","parent":"532500"},{"name":"开远市","value":"532502","parent":"532500"},{"name":"蒙自市","value":"532503","parent":"532500"},{"name":"弥勒市","value":"532504","parent":"532500"},{"name":"屏边苗族自治县","value":"532523","parent":"532500"},{"name":"建水县","value":"532524","parent":"532500"},{"name":"石屏县","value":"532525","parent":"532500"},{"name":"泸西县","value":"532527","parent":"532500"},{"name":"元阳县","value":"532528","parent":"532500"},{"name":"红河县","value":"532529","parent":"532500"},{"name":"金平苗族瑶族傣族自治县","value":"532530","parent":"532500"},{"name":"绿春县","value":"532531","parent":"532500"},{"name":"河口瑶族自治县","value":"532532","parent":"532500"},{"name":"文山市","value":"532601","parent":"532600"},{"name":"砚山县","value":"532622","parent":"532600"},{"name":"西畴县","value":"532623","parent":"532600"},{"name":"麻栗坡县","value":"532624","parent":"532600"},{"name":"马关县","value":"532625","parent":"532600"},{"name":"丘北县","value":"532626","parent":"532600"},{"name":"广南县","value":"532627","parent":"532600"},{"name":"富宁县","value":"532628","parent":"532600"},{"name":"景洪市","value":"532801","parent":"532800"},{"name":"勐海县","value":"532822","parent":"532800"},{"name":"勐腊县","value":"532823","parent":"532800"},{"name":"大理市","value":"532901","parent":"532900"},{"name":"漾濞彝族自治县","value":"532922","parent":"532900"},{"name":"祥云县","value":"532923","parent":"532900"},{"name":"宾川县","value":"532924","parent":"532900"},{"name":"弥渡县","value":"532925","parent":"532900"},{"name":"南涧彝族自治县","value":"532926","parent":"532900"},{"name":"巍山彝族回族自治县","value":"532927","parent":"532900"},{"name":"永平县","value":"532928","parent":"532900"},{"name":"云龙县","value":"532929","parent":"532900"},{"name":"洱源县","value":"532930","parent":"532900"},{"name":"剑川县","value":"532931","parent":"532900"},{"name":"鹤庆县","value":"532932","parent":"532900"},{"name":"瑞丽市","value":"533102","parent":"533100"},{"name":"芒市","value":"533103","parent":"533100"},{"name":"梁河县","value":"533122","parent":"533100"},{"name":"盈江县","value":"533123","parent":"533100"},{"name":"陇川县","value":"533124","parent":"533100"},{"name":"泸水市","value":"533301","parent":"533300"},{"name":"福贡县","value":"533323","parent":"533300"},{"name":"贡山独龙族怒族自治县","value":"533324","parent":"533300"},{"name":"兰坪白族普米族自治县","value":"533325","parent":"533300"},{"name":"香格里拉市","value":"533401","parent":"533400"},{"name":"德钦县","value":"533422","parent":"533400"},{"name":"维西傈僳族自治县","value":"533423","parent":"533400"},{"name":"拉萨市","value":"540100","parent":"540000"},{"name":"日喀则市","value":"540200","parent":"540000"},{"name":"昌都市","value":"540300","parent":"540000"},{"name":"林芝市","value":"540400","parent":"540000"},{"name":"山南市","value":"540500","parent":"540000"},{"name":"那曲地区","value":"542400","parent":"540000"},{"name":"阿里地区","value":"542500","parent":"540000"},{"name":"城关区","value":"540102","parent":"540100"},{"name":"堆龙德庆区","value":"540103","parent":"540100"},{"name":"林周县","value":"540121","parent":"540100"},{"name":"当雄县","value":"540122","parent":"540100"},{"name":"尼木县","value":"540123","parent":"540100"},{"name":"曲水县","value":"540124","parent":"540100"},{"name":"达孜县","value":"540126","parent":"540100"},{"name":"墨竹工卡县","value":"540127","parent":"540100"},{"name":"桑珠孜区","value":"540202","parent":"540200"},{"name":"南木林县","value":"540221","parent":"540200"},{"name":"江孜县","value":"540222","parent":"540200"},{"name":"定日县","value":"540223","parent":"540200"},{"name":"萨迦县","value":"540224","parent":"540200"},{"name":"拉孜县","value":"540225","parent":"540200"},{"name":"昂仁县","value":"540226","parent":"540200"},{"name":"谢通门县","value":"540227","parent":"540200"},{"name":"白朗县","value":"540228","parent":"540200"},{"name":"仁布县","value":"540229","parent":"540200"},{"name":"康马县","value":"540230","parent":"540200"},{"name":"定结县","value":"540231","parent":"540200"},{"name":"仲巴县","value":"540232","parent":"540200"},{"name":"亚东县","value":"540233","parent":"540200"},{"name":"吉隆县","value":"540234","parent":"540200"},{"name":"聂拉木县","value":"540235","parent":"540200"},{"name":"萨嘎县","value":"540236","parent":"540200"},{"name":"岗巴县","value":"540237","parent":"540200"},{"name":"卡若区","value":"540302","parent":"540300"},{"name":"江达县","value":"540321","parent":"540300"},{"name":"贡觉县","value":"540322","parent":"540300"},{"name":"类乌齐县","value":"540323","parent":"540300"},{"name":"丁青县","value":"540324","parent":"540300"},{"name":"察雅县","value":"540325","parent":"540300"},{"name":"八宿县","value":"540326","parent":"540300"},{"name":"左贡县","value":"540327","parent":"540300"},{"name":"芒康县","value":"540328","parent":"540300"},{"name":"洛隆县","value":"540329","parent":"540300"},{"name":"边坝县","value":"540330","parent":"540300"},{"name":"巴宜区","value":"540402","parent":"540400"},{"name":"工布江达县","value":"540421","parent":"540400"},{"name":"米林县","value":"540422","parent":"540400"},{"name":"墨脱县","value":"540423","parent":"540400"},{"name":"波密县","value":"540424","parent":"540400"},{"name":"察隅县","value":"540425","parent":"540400"},{"name":"朗县","value":"540426","parent":"540400"},{"name":"乃东区","value":"540502","parent":"540500"},{"name":"扎囊县","value":"540521","parent":"540500"},{"name":"贡嘎县","value":"540522","parent":"540500"},{"name":"桑日县","value":"540523","parent":"540500"},{"name":"琼结县","value":"540524","parent":"540500"},{"name":"曲松县","value":"540525","parent":"540500"},{"name":"措美县","value":"540526","parent":"540500"},{"name":"洛扎县","value":"540527","parent":"540500"},{"name":"加查县","value":"540528","parent":"540500"},{"name":"隆子县","value":"540529","parent":"540500"},{"name":"错那县","value":"540530","parent":"540500"},{"name":"浪卡子县","value":"540531","parent":"540500"},{"name":"那曲县","value":"542421","parent":"542400"},{"name":"嘉黎县","value":"542422","parent":"542400"},{"name":"比如县","value":"542423","parent":"542400"},{"name":"聂荣县","value":"542424","parent":"542400"},{"name":"安多县","value":"542425","parent":"542400"},{"name":"申扎县","value":"542426","parent":"542400"},{"name":"索县","value":"542427","parent":"542400"},{"name":"班戈县","value":"542428","parent":"542400"},{"name":"巴青县","value":"542429","parent":"542400"},{"name":"尼玛县","value":"542430","parent":"542400"},{"name":"双湖县","value":"542431","parent":"542400"},{"name":"普兰县","value":"542521","parent":"542500"},{"name":"札达县","value":"542522","parent":"542500"},{"name":"噶尔县","value":"542523","parent":"542500"},{"name":"日土县","value":"542524","parent":"542500"},{"name":"革吉县","value":"542525","parent":"542500"},{"name":"改则县","value":"542526","parent":"542500"},{"name":"措勤县","value":"542527","parent":"542500"},{"name":"西安市","value":"610100","parent":"610000"},{"name":"铜川市","value":"610200","parent":"610000"},{"name":"宝鸡市","value":"610300","parent":"610000"},{"name":"咸阳市","value":"610400","parent":"610000"},{"name":"渭南市","value":"610500","parent":"610000"},{"name":"延安市","value":"610600","parent":"610000"},{"name":"汉中市","value":"610700","parent":"610000"},{"name":"榆林市","value":"610800","parent":"610000"},{"name":"安康市","value":"610900","parent":"610000"},{"name":"商洛市","value":"611000","parent":"610000"},{"name":"新城区","value":"610102","parent":"610100"},{"name":"碑林区","value":"610103","parent":"610100"},{"name":"莲湖区","value":"610104","parent":"610100"},{"name":"灞桥区","value":"610111","parent":"610100"},{"name":"未央区","value":"610112","parent":"610100"},{"name":"雁塔区","value":"610113","parent":"610100"},{"name":"阎良区","value":"610114","parent":"610100"},{"name":"临潼区","value":"610115","parent":"610100"},{"name":"长安区","value":"610116","parent":"610100"},{"name":"高陵区","value":"610117","parent":"610100"},{"name":"蓝田县","value":"610122","parent":"610100"},{"name":"周至县","value":"610124","parent":"610100"},{"name":"户县","value":"610125","parent":"610100"},{"name":"王益区","value":"610202","parent":"610200"},{"name":"印台区","value":"610203","parent":"610200"},{"name":"耀州区","value":"610204","parent":"610200"},{"name":"宜君县","value":"610222","parent":"610200"},{"name":"渭滨区","value":"610302","parent":"610300"},{"name":"金台区","value":"610303","parent":"610300"},{"name":"陈仓区","value":"610304","parent":"610300"},{"name":"凤翔县","value":"610322","parent":"610300"},{"name":"岐山县","value":"610323","parent":"610300"},{"name":"扶风县","value":"610324","parent":"610300"},{"name":"眉县","value":"610326","parent":"610300"},{"name":"陇县","value":"610327","parent":"610300"},{"name":"千阳县","value":"610328","parent":"610300"},{"name":"麟游县","value":"610329","parent":"610300"},{"name":"凤县","value":"610330","parent":"610300"},{"name":"太白县","value":"610331","parent":"610300"},{"name":"秦都区","value":"610402","parent":"610400"},{"name":"杨陵区","value":"610403","parent":"610400"},{"name":"渭城区","value":"610404","parent":"610400"},{"name":"三原县","value":"610422","parent":"610400"},{"name":"泾阳县","value":"610423","parent":"610400"},{"name":"乾县","value":"610424","parent":"610400"},{"name":"礼泉县","value":"610425","parent":"610400"},{"name":"永寿县","value":"610426","parent":"610400"},{"name":"彬县","value":"610427","parent":"610400"},{"name":"长武县","value":"610428","parent":"610400"},{"name":"旬邑县","value":"610429","parent":"610400"},{"name":"淳化县","value":"610430","parent":"610400"},{"name":"武功县","value":"610431","parent":"610400"},{"name":"兴平市","value":"610481","parent":"610400"},{"name":"临渭区","value":"610502","parent":"610500"},{"name":"华州区","value":"610503","parent":"610500"},{"name":"潼关县","value":"610522","parent":"610500"},{"name":"大荔县","value":"610523","parent":"610500"},{"name":"合阳县","value":"610524","parent":"610500"},{"name":"澄城县","value":"610525","parent":"610500"},{"name":"蒲城县","value":"610526","parent":"610500"},{"name":"白水县","value":"610527","parent":"610500"},{"name":"富平县","value":"610528","parent":"610500"},{"name":"韩城市","value":"610581","parent":"610500"},{"name":"华阴市","value":"610582","parent":"610500"},{"name":"宝塔区","value":"610602","parent":"610600"},{"name":"安塞区","value":"610603","parent":"610600"},{"name":"延长县","value":"610621","parent":"610600"},{"name":"延川县","value":"610622","parent":"610600"},{"name":"子长县","value":"610623","parent":"610600"},{"name":"志丹县","value":"610625","parent":"610600"},{"name":"吴起县","value":"610626","parent":"610600"},{"name":"甘泉县","value":"610627","parent":"610600"},{"name":"富县","value":"610628","parent":"610600"},{"name":"洛川县","value":"610629","parent":"610600"},{"name":"宜川县","value":"610630","parent":"610600"},{"name":"黄龙县","value":"610631","parent":"610600"},{"name":"黄陵县","value":"610632","parent":"610600"},{"name":"汉台区","value":"610702","parent":"610700"},{"name":"南郑县","value":"610721","parent":"610700"},{"name":"城固县","value":"610722","parent":"610700"},{"name":"洋县","value":"610723","parent":"610700"},{"name":"西乡县","value":"610724","parent":"610700"},{"name":"勉县","value":"610725","parent":"610700"},{"name":"宁强县","value":"610726","parent":"610700"},{"name":"略阳县","value":"610727","parent":"610700"},{"name":"镇巴县","value":"610728","parent":"610700"},{"name":"留坝县","value":"610729","parent":"610700"},{"name":"佛坪县","value":"610730","parent":"610700"},{"name":"榆阳区","value":"610802","parent":"610800"},{"name":"横山区","value":"610803","parent":"610800"},{"name":"神木县","value":"610821","parent":"610800"},{"name":"府谷县","value":"610822","parent":"610800"},{"name":"靖边县","value":"610824","parent":"610800"},{"name":"定边县","value":"610825","parent":"610800"},{"name":"绥德县","value":"610826","parent":"610800"},{"name":"米脂县","value":"610827","parent":"610800"},{"name":"佳县","value":"610828","parent":"610800"},{"name":"吴堡县","value":"610829","parent":"610800"},{"name":"清涧县","value":"610830","parent":"610800"},{"name":"子洲县","value":"610831","parent":"610800"},{"name":"汉滨区","value":"610902","parent":"610900"},{"name":"汉阴县","value":"610921","parent":"610900"},{"name":"石泉县","value":"610922","parent":"610900"},{"name":"宁陕县","value":"610923","parent":"610900"},{"name":"紫阳县","value":"610924","parent":"610900"},{"name":"岚皋县","value":"610925","parent":"610900"},{"name":"平利县","value":"610926","parent":"610900"},{"name":"镇坪县","value":"610927","parent":"610900"},{"name":"旬阳县","value":"610928","parent":"610900"},{"name":"白河县","value":"610929","parent":"610900"},{"name":"商州区","value":"611002","parent":"611000"},{"name":"洛南县","value":"611021","parent":"611000"},{"name":"丹凤县","value":"611022","parent":"611000"},{"name":"商南县","value":"611023","parent":"611000"},{"name":"山阳县","value":"611024","parent":"611000"},{"name":"镇安县","value":"611025","parent":"611000"},{"name":"柞水县","value":"611026","parent":"611000"},{"name":"兰州市","value":"620100","parent":"620000"},{"name":"嘉峪关市","value":"620200","parent":"620000"},{"name":"金昌市","value":"620300","parent":"620000"},{"name":"白银市","value":"620400","parent":"620000"},{"name":"天水市","value":"620500","parent":"620000"},{"name":"武威市","value":"620600","parent":"620000"},{"name":"张掖市","value":"620700","parent":"620000"},{"name":"平凉市","value":"620800","parent":"620000"},{"name":"酒泉市","value":"620900","parent":"620000"},{"name":"庆阳市","value":"621000","parent":"620000"},{"name":"定西市","value":"621100","parent":"620000"},{"name":"陇南市","value":"621200","parent":"620000"},{"name":"临夏回族自治州","value":"622900","parent":"620000"},{"name":"甘南藏族自治州","value":"623000","parent":"620000"},{"name":"城关区","value":"620102","parent":"620100"},{"name":"七里河区","value":"620103","parent":"620100"},{"name":"西固区","value":"620104","parent":"620100"},{"name":"安宁区","value":"620105","parent":"620100"},{"name":"红古区","value":"620111","parent":"620100"},{"name":"永登县","value":"620121","parent":"620100"},{"name":"皋兰县","value":"620122","parent":"620100"},{"name":"榆中县","value":"620123","parent":"620100"},{"name":"金川区","value":"620302","parent":"620300"},{"name":"永昌县","value":"620321","parent":"620300"},{"name":"白银区","value":"620402","parent":"620400"},{"name":"平川区","value":"620403","parent":"620400"},{"name":"靖远县","value":"620421","parent":"620400"},{"name":"会宁县","value":"620422","parent":"620400"},{"name":"景泰县","value":"620423","parent":"620400"},{"name":"秦州区","value":"620502","parent":"620500"},{"name":"麦积区","value":"620503","parent":"620500"},{"name":"清水县","value":"620521","parent":"620500"},{"name":"秦安县","value":"620522","parent":"620500"},{"name":"甘谷县","value":"620523","parent":"620500"},{"name":"武山县","value":"620524","parent":"620500"},{"name":"张家川回族自治县","value":"620525","parent":"620500"},{"name":"凉州区","value":"620602","parent":"620600"},{"name":"民勤县","value":"620621","parent":"620600"},{"name":"古浪县","value":"620622","parent":"620600"},{"name":"天祝藏族自治县","value":"620623","parent":"620600"},{"name":"甘州区","value":"620702","parent":"620700"},{"name":"肃南裕固族自治县","value":"620721","parent":"620700"},{"name":"民乐县","value":"620722","parent":"620700"},{"name":"临泽县","value":"620723","parent":"620700"},{"name":"高台县","value":"620724","parent":"620700"},{"name":"山丹县","value":"620725","parent":"620700"},{"name":"崆峒区","value":"620802","parent":"620800"},{"name":"泾川县","value":"620821","parent":"620800"},{"name":"灵台县","value":"620822","parent":"620800"},{"name":"崇信县","value":"620823","parent":"620800"},{"name":"华亭县","value":"620824","parent":"620800"},{"name":"庄浪县","value":"620825","parent":"620800"},{"name":"静宁县","value":"620826","parent":"620800"},{"name":"肃州区","value":"620902","parent":"620900"},{"name":"金塔县","value":"620921","parent":"620900"},{"name":"瓜州县","value":"620922","parent":"620900"},{"name":"肃北蒙古族自治县","value":"620923","parent":"620900"},{"name":"阿克塞哈萨克族自治县","value":"620924","parent":"620900"},{"name":"玉门市","value":"620981","parent":"620900"},{"name":"敦煌市","value":"620982","parent":"620900"},{"name":"西峰区","value":"621002","parent":"621000"},{"name":"庆城县","value":"621021","parent":"621000"},{"name":"环县","value":"621022","parent":"621000"},{"name":"华池县","value":"621023","parent":"621000"},{"name":"合水县","value":"621024","parent":"621000"},{"name":"正宁县","value":"621025","parent":"621000"},{"name":"宁县","value":"621026","parent":"621000"},{"name":"镇原县","value":"621027","parent":"621000"},{"name":"安定区","value":"621102","parent":"621100"},{"name":"通渭县","value":"621121","parent":"621100"},{"name":"陇西县","value":"621122","parent":"621100"},{"name":"渭源县","value":"621123","parent":"621100"},{"name":"临洮县","value":"621124","parent":"621100"},{"name":"漳县","value":"621125","parent":"621100"},{"name":"岷县","value":"621126","parent":"621100"},{"name":"武都区","value":"621202","parent":"621200"},{"name":"成县","value":"621221","parent":"621200"},{"name":"文县","value":"621222","parent":"621200"},{"name":"宕昌县","value":"621223","parent":"621200"},{"name":"康县","value":"621224","parent":"621200"},{"name":"西和县","value":"621225","parent":"621200"},{"name":"礼县","value":"621226","parent":"621200"},{"name":"徽县","value":"621227","parent":"621200"},{"name":"两当县","value":"621228","parent":"621200"},{"name":"临夏市","value":"622901","parent":"622900"},{"name":"临夏县","value":"622921","parent":"622900"},{"name":"康乐县","value":"622922","parent":"622900"},{"name":"永靖县","value":"622923","parent":"622900"},{"name":"广河县","value":"622924","parent":"622900"},{"name":"和政县","value":"622925","parent":"622900"},{"name":"东乡族自治县","value":"622926","parent":"622900"},{"name":"积石山保安族东乡族撒拉族自治县","value":"622927","parent":"622900"},{"name":"合作市","value":"623001","parent":"623000"},{"name":"临潭县","value":"623021","parent":"623000"},{"name":"卓尼县","value":"623022","parent":"623000"},{"name":"舟曲县","value":"623023","parent":"623000"},{"name":"迭部县","value":"623024","parent":"623000"},{"name":"玛曲县","value":"623025","parent":"623000"},{"name":"碌曲县","value":"623026","parent":"623000"},{"name":"夏河县","value":"623027","parent":"623000"},{"name":"西宁市","value":"630100","parent":"630000"},{"name":"海东市","value":"630200","parent":"630000"},{"name":"海北藏族自治州","value":"632200","parent":"630000"},{"name":"黄南藏族自治州","value":"632300","parent":"630000"},{"name":"海南藏族自治州","value":"632500","parent":"630000"},{"name":"果洛藏族自治州","value":"632600","parent":"630000"},{"name":"玉树藏族自治州","value":"632700","parent":"630000"},{"name":"海西蒙古族藏族自治州","value":"632800","parent":"630000"},{"name":"城东区","value":"630102","parent":"630100"},{"name":"城中区","value":"630103","parent":"630100"},{"name":"城西区","value":"630104","parent":"630100"},{"name":"城北区","value":"630105","parent":"630100"},{"name":"大通回族土族自治县","value":"630121","parent":"630100"},{"name":"湟中县","value":"630122","parent":"630100"},{"name":"湟源县","value":"630123","parent":"630100"},{"name":"乐都区","value":"630202","parent":"630200"},{"name":"平安区","value":"630203","parent":"630200"},{"name":"民和回族土族自治县","value":"630222","parent":"630200"},{"name":"互助土族自治县","value":"630223","parent":"630200"},{"name":"化隆回族自治县","value":"630224","parent":"630200"},{"name":"循化撒拉族自治县","value":"630225","parent":"630200"},{"name":"门源回族自治县","value":"632221","parent":"632200"},{"name":"祁连县","value":"632222","parent":"632200"},{"name":"海晏县","value":"632223","parent":"632200"},{"name":"刚察县","value":"632224","parent":"632200"},{"name":"同仁县","value":"632321","parent":"632300"},{"name":"尖扎县","value":"632322","parent":"632300"},{"name":"泽库县","value":"632323","parent":"632300"},{"name":"河南蒙古族自治县","value":"632324","parent":"632300"},{"name":"共和县","value":"632521","parent":"632500"},{"name":"同德县","value":"632522","parent":"632500"},{"name":"贵德县","value":"632523","parent":"632500"},{"name":"兴海县","value":"632524","parent":"632500"},{"name":"贵南县","value":"632525","parent":"632500"},{"name":"玛沁县","value":"632621","parent":"632600"},{"name":"班玛县","value":"632622","parent":"632600"},{"name":"甘德县","value":"632623","parent":"632600"},{"name":"达日县","value":"632624","parent":"632600"},{"name":"久治县","value":"632625","parent":"632600"},{"name":"玛多县","value":"632626","parent":"632600"},{"name":"玉树市","value":"632701","parent":"632700"},{"name":"杂多县","value":"632722","parent":"632700"},{"name":"称多县","value":"632723","parent":"632700"},{"name":"治多县","value":"632724","parent":"632700"},{"name":"囊谦县","value":"632725","parent":"632700"},{"name":"曲麻莱县","value":"632726","parent":"632700"},{"name":"格尔木市","value":"632801","parent":"632800"},{"name":"德令哈市","value":"632802","parent":"632800"},{"name":"乌兰县","value":"632821","parent":"632800"},{"name":"都兰县","value":"632822","parent":"632800"},{"name":"天峻县","value":"632823","parent":"632800"},{"name":"银川市","value":"640100","parent":"640000"},{"name":"石嘴山市","value":"640200","parent":"640000"},{"name":"吴忠市","value":"640300","parent":"640000"},{"name":"固原市","value":"640400","parent":"640000"},{"name":"中卫市","value":"640500","parent":"640000"},{"name":"兴庆区","value":"640104","parent":"640100"},{"name":"西夏区","value":"640105","parent":"640100"},{"name":"金凤区","value":"640106","parent":"640100"},{"name":"永宁县","value":"640121","parent":"640100"},{"name":"贺兰县","value":"640122","parent":"640100"},{"name":"灵武市","value":"640181","parent":"640100"},{"name":"大武口区","value":"640202","parent":"640200"},{"name":"惠农区","value":"640205","parent":"640200"},{"name":"平罗县","value":"640221","parent":"640200"},{"name":"利通区","value":"640302","parent":"640300"},{"name":"红寺堡区","value":"640303","parent":"640300"},{"name":"盐池县","value":"640323","parent":"640300"},{"name":"同心县","value":"640324","parent":"640300"},{"name":"青铜峡市","value":"640381","parent":"640300"},{"name":"原州区","value":"640402","parent":"640400"},{"name":"西吉县","value":"640422","parent":"640400"},{"name":"隆德县","value":"640423","parent":"640400"},{"name":"泾源县","value":"640424","parent":"640400"},{"name":"彭阳县","value":"640425","parent":"640400"},{"name":"沙坡头区","value":"640502","parent":"640500"},{"name":"中宁县","value":"640521","parent":"640500"},{"name":"海原县","value":"640522","parent":"640500"},{"name":"乌鲁木齐市","value":"650100","parent":"650000"},{"name":"克拉玛依市","value":"650200","parent":"650000"},{"name":"吐鲁番市","value":"650400","parent":"650000"},{"name":"哈密市","value":"650500","parent":"650000"},{"name":"昌吉回族自治州","value":"652300","parent":"650000"},{"name":"博尔塔拉蒙古自治州","value":"652700","parent":"650000"},{"name":"巴音郭楞蒙古自治州","value":"652800","parent":"650000"},{"name":"阿克苏地区","value":"652900","parent":"650000"},{"name":"克孜勒苏柯尔克孜自治州","value":"653000","parent":"650000"},{"name":"喀什地区","value":"653100","parent":"650000"},{"name":"和田地区","value":"653200","parent":"650000"},{"name":"伊犁哈萨克自治州","value":"654000","parent":"650000"},{"name":"塔城地区","value":"654200","parent":"650000"},{"name":"阿勒泰地区","value":"654300","parent":"650000"},{"name":"石河子市","value":"659001","parent":"650000"},{"name":"阿拉尔市","value":"659002","parent":"650000"},{"name":"图木舒克市","value":"659003","parent":"650000"},{"name":"五家渠市","value":"659004","parent":"650000"},{"name":"铁门关市","value":"659006","parent":"650000"},{"name":"天山区","value":"650102","parent":"650100"},{"name":"沙依巴克区","value":"650103","parent":"650100"},{"name":"新市区","value":"650104","parent":"650100"},{"name":"水磨沟区","value":"650105","parent":"650100"},{"name":"头屯河区","value":"650106","parent":"650100"},{"name":"达坂城区","value":"650107","parent":"650100"},{"name":"米东区","value":"650109","parent":"650100"},{"name":"乌鲁木齐县","value":"650121","parent":"650100"},{"name":"独山子区","value":"650202","parent":"650200"},{"name":"克拉玛依区","value":"650203","parent":"650200"},{"name":"白碱滩区","value":"650204","parent":"650200"},{"name":"乌尔禾区","value":"650205","parent":"650200"},{"name":"高昌区","value":"650402","parent":"650400"},{"name":"鄯善县","value":"650421","parent":"650400"},{"name":"托克逊县","value":"650422","parent":"650400"},{"name":"伊州区","value":"650502","parent":"650500"},{"name":"巴里坤哈萨克自治县","value":"650521","parent":"650500"},{"name":"伊吾县","value":"650522","parent":"650500"},{"name":"昌吉市","value":"652301","parent":"652300"},{"name":"阜康市","value":"652302","parent":"652300"},{"name":"呼图壁县","value":"652323","parent":"652300"},{"name":"玛纳斯县","value":"652324","parent":"652300"},{"name":"奇台县","value":"652325","parent":"652300"},{"name":"吉木萨尔县","value":"652327","parent":"652300"},{"name":"木垒哈萨克自治县","value":"652328","parent":"652300"},{"name":"博乐市","value":"652701","parent":"652700"},{"name":"阿拉山口市","value":"652702","parent":"652700"},{"name":"精河县","value":"652722","parent":"652700"},{"name":"温泉县","value":"652723","parent":"652700"},{"name":"库尔勒市","value":"652801","parent":"652800"},{"name":"轮台县","value":"652822","parent":"652800"},{"name":"尉犁县","value":"652823","parent":"652800"},{"name":"若羌县","value":"652824","parent":"652800"},{"name":"且末县","value":"652825","parent":"652800"},{"name":"焉耆回族自治县","value":"652826","parent":"652800"},{"name":"和静县","value":"652827","parent":"652800"},{"name":"和硕县","value":"652828","parent":"652800"},{"name":"博湖县","value":"652829","parent":"652800"},{"name":"阿克苏市","value":"652901","parent":"652900"},{"name":"温宿县","value":"652922","parent":"652900"},{"name":"库车县","value":"652923","parent":"652900"},{"name":"沙雅县","value":"652924","parent":"652900"},{"name":"新和县","value":"652925","parent":"652900"},{"name":"拜城县","value":"652926","parent":"652900"},{"name":"乌什县","value":"652927","parent":"652900"},{"name":"阿瓦提县","value":"652928","parent":"652900"},{"name":"柯坪县","value":"652929","parent":"652900"},{"name":"阿图什市","value":"653001","parent":"653000"},{"name":"阿克陶县","value":"653022","parent":"653000"},{"name":"阿合奇县","value":"653023","parent":"653000"},{"name":"乌恰县","value":"653024","parent":"653000"},{"name":"喀什市","value":"653101","parent":"653100"},{"name":"疏附县","value":"653121","parent":"653100"},{"name":"疏勒县","value":"653122","parent":"653100"},{"name":"英吉沙县","value":"653123","parent":"653100"},{"name":"泽普县","value":"653124","parent":"653100"},{"name":"莎车县","value":"653125","parent":"653100"},{"name":"叶城县","value":"653126","parent":"653100"},{"name":"麦盖提县","value":"653127","parent":"653100"},{"name":"岳普湖县","value":"653128","parent":"653100"},{"name":"伽师县","value":"653129","parent":"653100"},{"name":"巴楚县","value":"653130","parent":"653100"},{"name":"塔什库尔干塔吉克自治县","value":"653131","parent":"653100"},{"name":"和田市","value":"653201","parent":"653200"},{"name":"和田县","value":"653221","parent":"653200"},{"name":"墨玉县","value":"653222","parent":"653200"},{"name":"皮山县","value":"653223","parent":"653200"},{"name":"洛浦县","value":"653224","parent":"653200"},{"name":"策勒县","value":"653225","parent":"653200"},{"name":"于田县","value":"653226","parent":"653200"},{"name":"民丰县","value":"653227","parent":"653200"},{"name":"伊宁市","value":"654002","parent":"654000"},{"name":"奎屯市","value":"654003","parent":"654000"},{"name":"霍尔果斯市","value":"654004","parent":"654000"},{"name":"伊宁县","value":"654021","parent":"654000"},{"name":"察布查尔锡伯自治县","value":"654022","parent":"654000"},{"name":"霍城县","value":"654023","parent":"654000"},{"name":"巩留县","value":"654024","parent":"654000"},{"name":"新源县","value":"654025","parent":"654000"},{"name":"昭苏县","value":"654026","parent":"654000"},{"name":"特克斯县","value":"654027","parent":"654000"},{"name":"尼勒克县","value":"654028","parent":"654000"},{"name":"塔城市","value":"654201","parent":"654200"},{"name":"乌苏市","value":"654202","parent":"654200"},{"name":"额敏县","value":"654221","parent":"654200"},{"name":"沙湾县","value":"654223","parent":"654200"},{"name":"托里县","value":"654224","parent":"654200"},{"name":"裕民县","value":"654225","parent":"654200"},{"name":"和布克赛尔蒙古自治县","value":"654226","parent":"654200"},{"name":"阿勒泰市","value":"654301","parent":"654300"},{"name":"布尔津县","value":"654321","parent":"654300"},{"name":"富蕴县","value":"654322","parent":"654300"},{"name":"福海县","value":"654323","parent":"654300"},{"name":"哈巴河县","value":"654324","parent":"654300"},{"name":"青河县","value":"654325","parent":"654300"},{"name":"吉木乃县","value":"654326","parent":"654300"},{"name":"中西區","value":"810001","parent":"810000"},{"name":"灣仔區","value":"810002","parent":"810000"},{"name":"東區","value":"810003","parent":"810000"},{"name":"南區","value":"810004","parent":"810000"},{"name":"油尖旺區","value":"810005","parent":"810000"},{"name":"深水埗區","value":"810006","parent":"810000"},{"name":"九龍城區","value":"810007","parent":"810000"},{"name":"黃大仙區","value":"810008","parent":"810000"},{"name":"觀塘區","value":"810009","parent":"810000"},{"name":"荃灣區","value":"810010","parent":"810000"},{"name":"屯門區","value":"810011","parent":"810000"},{"name":"元朗區","value":"810012","parent":"810000"},{"name":"北區","value":"810013","parent":"810000"},{"name":"大埔區","value":"810014","parent":"810000"},{"name":"西貢區","value":"810015","parent":"810000"},{"name":"沙田區","value":"810016","parent":"810000"},{"name":"葵青區","value":"810017","parent":"810000"},{"name":"離島區","value":"810018","parent":"810000"},{"name":"花地瑪堂區","value":"820001","parent":"820000"},{"name":"花王堂區","value":"820002","parent":"820000"},{"name":"望德堂區","value":"820003","parent":"820000"},{"name":"大堂區","value":"820004","parent":"820000"},{"name":"風順堂區","value":"820005","parent":"820000"},{"name":"嘉模堂區","value":"820006","parent":"820000"},{"name":"路氹填海區","value":"820007","parent":"820000"},{"name":"聖方濟各堂區","value":"820008","parent":"820000"},{"name":"--","value":"--","parent":"139000"},{"name":"--","value":"--","parent":"139001"},{"name":"--","value":"--","parent":"139002"},{"name":"--","value":"--","parent":"419000"},{"name":"--","value":"--","parent":"419001"},{"name":"--","value":"--","parent":"429000"},{"name":"--","value":"--","parent":"429004"},{"name":"--","value":"--","parent":"429005"},{"name":"--","value":"--","parent":"429006"},{"name":"--","value":"--","parent":"429021"},{"name":"--","value":"--","parent":"441900"},{"name":"--","value":"--","parent":"442000"},{"name":"--","value":"--","parent":"460300"},{"name":"--","value":"--","parent":"460400"},{"name":"--","value":"--","parent":"469000"},{"name":"--","value":"--","parent":"469001"},{"name":"--","value":"--","parent":"469002"},{"name":"--","value":"--","parent":"469005"},{"name":"--","value":"--","parent":"469006"},{"name":"--","value":"--","parent":"469007"},{"name":"--","value":"--","parent":"469021"},{"name":"--","value":"--","parent":"469022"},{"name":"--","value":"--","parent":"469023"},{"name":"--","value":"--","parent":"469024"},{"name":"--","value":"--","parent":"469025"},{"name":"--","value":"--","parent":"469026"},{"name":"--","value":"--","parent":"469027"},{"name":"--","value":"--","parent":"469028"},{"name":"--","value":"--","parent":"469029"},{"name":"--","value":"--","parent":"469030"},{"name":"--","value":"--","parent":"620200"},{"name":"--","value":"--","parent":"659000"},{"name":"--","value":"--","parent":"659001"},{"name":"--","value":"--","parent":"659002"},{"name":"--","value":"--","parent":"659003"},{"name":"--","value":"--","parent":"659004"},{"name":"--","value":"--","parent":"659006"}]

/***/ }),

/***/ "FX6T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fgsu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FlU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GyPJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gz2+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HDDp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HHkT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IXTg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IXeR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JFGg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JPxP":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
(function(){function N(p,r){function q(a){if(q[a]!==w)return q[a];var c;if("bug-string-char-index"==a)c="a"!="a"[0];else if("json"==a)c=q("json-stringify")&&q("json-parse");else{var e;if("json-stringify"==a){c=r.stringify;var b="function"==typeof c&&s;if(b){(e=function(){return 1}).toJSON=e;try{b="0"===c(0)&&"0"===c(new t)&&'""'==c(new A)&&c(u)===w&&c(w)===w&&c()===w&&"1"===c(e)&&"[1]"==c([e])&&"[null]"==c([w])&&"null"==c(null)&&"[null,null,null]"==c([w,u,null])&&'{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}'==
c({a:[e,!0,!1,null,"\x00\b\n\f\r\t"]})&&"1"===c(null,e)&&"[\n 1,\n 2\n]"==c([1,2],null,1)&&'"-271821-04-20T00:00:00.000Z"'==c(new C(-864E13))&&'"+275760-09-13T00:00:00.000Z"'==c(new C(864E13))&&'"-000001-01-01T00:00:00.000Z"'==c(new C(-621987552E5))&&'"1969-12-31T23:59:59.999Z"'==c(new C(-1))}catch(f){b=!1}}c=b}if("json-parse"==a){c=r.parse;if("function"==typeof c)try{if(0===c("0")&&!c(!1)){e=c('{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}');var n=5==e.a.length&&1===e.a[0];if(n){try{n=!c('"\t"')}catch(d){}if(n)try{n=
1!==c("01")}catch(g){}if(n)try{n=1!==c("1.")}catch(m){}}}}catch(X){n=!1}c=n}}return q[a]=!!c}p||(p=k.Object());r||(r=k.Object());var t=p.Number||k.Number,A=p.String||k.String,H=p.Object||k.Object,C=p.Date||k.Date,G=p.SyntaxError||k.SyntaxError,K=p.TypeError||k.TypeError,L=p.Math||k.Math,I=p.JSON||k.JSON;"object"==typeof I&&I&&(r.stringify=I.stringify,r.parse=I.parse);var H=H.prototype,u=H.toString,v,B,w,s=new C(-0xc782b5b800cec);try{s=-109252==s.getUTCFullYear()&&0===s.getUTCMonth()&&1===s.getUTCDate()&&
10==s.getUTCHours()&&37==s.getUTCMinutes()&&6==s.getUTCSeconds()&&708==s.getUTCMilliseconds()}catch(Q){}if(!q("json")){var D=q("bug-string-char-index");if(!s)var x=L.floor,M=[0,31,59,90,120,151,181,212,243,273,304,334],E=function(a,c){return M[c]+365*(a-1970)+x((a-1969+(c=+(1<c)))/4)-x((a-1901+c)/100)+x((a-1601+c)/400)};(v=H.hasOwnProperty)||(v=function(a){var c={},e;(c.__proto__=null,c.__proto__={toString:1},c).toString!=u?v=function(a){var c=this.__proto__;a=a in(this.__proto__=null,this);this.__proto__=
c;return a}:(e=c.constructor,v=function(a){var c=(this.constructor||e).prototype;return a in this&&!(a in c&&this[a]===c[a])});c=null;return v.call(this,a)});B=function(a,c){var e=0,b,f,n;(b=function(){this.valueOf=0}).prototype.valueOf=0;f=new b;for(n in f)v.call(f,n)&&e++;b=f=null;e?B=2==e?function(a,c){var e={},b="[object Function]"==u.call(a),f;for(f in a)b&&"prototype"==f||v.call(e,f)||!(e[f]=1)||!v.call(a,f)||c(f)}:function(a,c){var e="[object Function]"==u.call(a),b,f;for(b in a)e&&"prototype"==
b||!v.call(a,b)||(f="constructor"===b)||c(b);(f||v.call(a,b="constructor"))&&c(b)}:(f="valueOf toString toLocaleString propertyIsEnumerable isPrototypeOf hasOwnProperty constructor".split(" "),B=function(a,c){var e="[object Function]"==u.call(a),b,h=!e&&"function"!=typeof a.constructor&&F[typeof a.hasOwnProperty]&&a.hasOwnProperty||v;for(b in a)e&&"prototype"==b||!h.call(a,b)||c(b);for(e=f.length;b=f[--e];h.call(a,b)&&c(b));});return B(a,c)};if(!q("json-stringify")){var U={92:"\\\\",34:'\\"',8:"\\b",
12:"\\f",10:"\\n",13:"\\r",9:"\\t"},y=function(a,c){return("000000"+(c||0)).slice(-a)},R=function(a){for(var c='"',b=0,h=a.length,f=!D||10<h,n=f&&(D?a.split(""):a);b<h;b++){var d=a.charCodeAt(b);switch(d){case 8:case 9:case 10:case 12:case 13:case 34:case 92:c+=U[d];break;default:if(32>d){c+="\\u00"+y(2,d.toString(16));break}c+=f?n[b]:a.charAt(b)}}return c+'"'},O=function(a,c,b,h,f,n,d){var g,m,k,l,p,r,s,t,q;try{g=c[a]}catch(z){}if("object"==typeof g&&g)if(m=u.call(g),"[object Date]"!=m||v.call(g,
"toJSON"))"function"==typeof g.toJSON&&("[object Number]"!=m&&"[object String]"!=m&&"[object Array]"!=m||v.call(g,"toJSON"))&&(g=g.toJSON(a));else if(g>-1/0&&g<1/0){if(E){l=x(g/864E5);for(m=x(l/365.2425)+1970-1;E(m+1,0)<=l;m++);for(k=x((l-E(m,0))/30.42);E(m,k+1)<=l;k++);l=1+l-E(m,k);p=(g%864E5+864E5)%864E5;r=x(p/36E5)%24;s=x(p/6E4)%60;t=x(p/1E3)%60;p%=1E3}else m=g.getUTCFullYear(),k=g.getUTCMonth(),l=g.getUTCDate(),r=g.getUTCHours(),s=g.getUTCMinutes(),t=g.getUTCSeconds(),p=g.getUTCMilliseconds();
g=(0>=m||1E4<=m?(0>m?"-":"+")+y(6,0>m?-m:m):y(4,m))+"-"+y(2,k+1)+"-"+y(2,l)+"T"+y(2,r)+":"+y(2,s)+":"+y(2,t)+"."+y(3,p)+"Z"}else g=null;b&&(g=b.call(c,a,g));if(null===g)return"null";m=u.call(g);if("[object Boolean]"==m)return""+g;if("[object Number]"==m)return g>-1/0&&g<1/0?""+g:"null";if("[object String]"==m)return R(""+g);if("object"==typeof g){for(a=d.length;a--;)if(d[a]===g)throw K();d.push(g);q=[];c=n;n+=f;if("[object Array]"==m){k=0;for(a=g.length;k<a;k++)m=O(k,g,b,h,f,n,d),q.push(m===w?"null":
m);a=q.length?f?"[\n"+n+q.join(",\n"+n)+"\n"+c+"]":"["+q.join(",")+"]":"[]"}else B(h||g,function(a){var c=O(a,g,b,h,f,n,d);c!==w&&q.push(R(a)+":"+(f?" ":"")+c)}),a=q.length?f?"{\n"+n+q.join(",\n"+n)+"\n"+c+"}":"{"+q.join(",")+"}":"{}";d.pop();return a}};r.stringify=function(a,c,b){var h,f,n,d;if(F[typeof c]&&c)if("[object Function]"==(d=u.call(c)))f=c;else if("[object Array]"==d){n={};for(var g=0,k=c.length,l;g<k;l=c[g++],(d=u.call(l),"[object String]"==d||"[object Number]"==d)&&(n[l]=1));}if(b)if("[object Number]"==
(d=u.call(b))){if(0<(b-=b%1))for(h="",10<b&&(b=10);h.length<b;h+=" ");}else"[object String]"==d&&(h=10>=b.length?b:b.slice(0,10));return O("",(l={},l[""]=a,l),f,n,h,"",[])}}if(!q("json-parse")){var V=A.fromCharCode,W={92:"\\",34:'"',47:"/",98:"\b",116:"\t",110:"\n",102:"\f",114:"\r"},b,J,l=function(){b=J=null;throw G();},z=function(){for(var a=J,c=a.length,e,h,f,k,d;b<c;)switch(d=a.charCodeAt(b),d){case 9:case 10:case 13:case 32:b++;break;case 123:case 125:case 91:case 93:case 58:case 44:return e=
D?a.charAt(b):a[b],b++,e;case 34:e="@";for(b++;b<c;)if(d=a.charCodeAt(b),32>d)l();else if(92==d)switch(d=a.charCodeAt(++b),d){case 92:case 34:case 47:case 98:case 116:case 110:case 102:case 114:e+=W[d];b++;break;case 117:h=++b;for(f=b+4;b<f;b++)d=a.charCodeAt(b),48<=d&&57>=d||97<=d&&102>=d||65<=d&&70>=d||l();e+=V("0x"+a.slice(h,b));break;default:l()}else{if(34==d)break;d=a.charCodeAt(b);for(h=b;32<=d&&92!=d&&34!=d;)d=a.charCodeAt(++b);e+=a.slice(h,b)}if(34==a.charCodeAt(b))return b++,e;l();default:h=
b;45==d&&(k=!0,d=a.charCodeAt(++b));if(48<=d&&57>=d){for(48==d&&(d=a.charCodeAt(b+1),48<=d&&57>=d)&&l();b<c&&(d=a.charCodeAt(b),48<=d&&57>=d);b++);if(46==a.charCodeAt(b)){for(f=++b;f<c&&(d=a.charCodeAt(f),48<=d&&57>=d);f++);f==b&&l();b=f}d=a.charCodeAt(b);if(101==d||69==d){d=a.charCodeAt(++b);43!=d&&45!=d||b++;for(f=b;f<c&&(d=a.charCodeAt(f),48<=d&&57>=d);f++);f==b&&l();b=f}return+a.slice(h,b)}k&&l();if("true"==a.slice(b,b+4))return b+=4,!0;if("false"==a.slice(b,b+5))return b+=5,!1;if("null"==a.slice(b,
b+4))return b+=4,null;l()}return"$"},P=function(a){var c,b;"$"==a&&l();if("string"==typeof a){if("@"==(D?a.charAt(0):a[0]))return a.slice(1);if("["==a){for(c=[];;b||(b=!0)){a=z();if("]"==a)break;b&&(","==a?(a=z(),"]"==a&&l()):l());","==a&&l();c.push(P(a))}return c}if("{"==a){for(c={};;b||(b=!0)){a=z();if("}"==a)break;b&&(","==a?(a=z(),"}"==a&&l()):l());","!=a&&"string"==typeof a&&"@"==(D?a.charAt(0):a[0])&&":"==z()||l();c[a.slice(1)]=P(z())}return c}l()}return a},T=function(a,b,e){e=S(a,b,e);e===
w?delete a[b]:a[b]=e},S=function(a,b,e){var h=a[b],f;if("object"==typeof h&&h)if("[object Array]"==u.call(h))for(f=h.length;f--;)T(h,f,e);else B(h,function(a){T(h,a,e)});return e.call(a,b,h)};r.parse=function(a,c){var e,h;b=0;J=""+a;e=P(z());"$"!=z()&&l();b=J=null;return c&&"[object Function]"==u.call(c)?S((h={},h[""]=e,h),"",c):e}}}r.runInContext=N;return r}var K="function"==="function"&&__webpack_require__("nErl"),F={"function":!0,object:!0},G=F[typeof exports]&&exports&&!exports.nodeType&&exports,k=F[typeof window]&&
window||this,t=G&&F[typeof module]&&module&&!module.nodeType&&"object"==typeof global&&global;!t||t.global!==t&&t.window!==t&&t.self!==t||(k=t);if(G&&!K)N(k,G);else{var L=k.JSON,Q=k.JSON3,M=!1,A=N(k,k.JSON3={noConflict:function(){M||(M=!0,k.JSON=L,k.JSON3=Q,L=Q=null);return A}});k.JSON={parse:A.parse,stringify:A.stringify}}K&&!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return A}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module), __webpack_require__("DuR2")))

/***/ }),

/***/ "K5PO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KU+f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KXcw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KwI3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Luh7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MGYK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MUCD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MppL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NBdk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NEF7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
    name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
    name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b4ecf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("rTDE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// EXTERNAL MODULE: ./node_modules/vux/src/components/alert/index.vue + 3 modules
var components_alert = __webpack_require__("mzja");

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var check_icon = ({
  name: 'check-icon',
  components: {
    Icon: icon["a" /* default */]
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_check_icon = ({
  name: 'check-icon',
  components: {
    Icon: icon["a" /* default */]
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de9c80d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/check-icon/index.vue
var check_icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-check-icon",on:{"click":_vm.updateValue}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'default' && _vm.value),expression:"type === 'default' && value"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'plain' && _vm.value),expression:"type === 'plain' && value"}],attrs:{"type":"success_circle"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],attrs:{"type":"circle"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var check_icon_staticRenderFns = []
var check_icon_esExports = { render: check_icon_render, staticRenderFns: check_icon_staticRenderFns }
/* harmony default export */ var src_components_check_icon = (check_icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/check-icon/index.vue
function check_icon_injectStyle (ssrContext) {
  __webpack_require__("0q+O")
}
var check_icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var check_icon___vue_template_functional__ = false
/* styles */
var check_icon___vue_styles__ = check_icon_injectStyle
/* scopeId */
var check_icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var check_icon___vue_module_identifier__ = null
var check_icon_Component = check_icon_normalizeComponent(
  components_check_icon,
  src_components_check_icon,
  check_icon___vue_template_functional__,
  check_icon___vue_styles__,
  check_icon___vue_scopeId__,
  check_icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_check_icon = (check_icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb20de40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/selector/index.vue
var selector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var selector_staticRenderFns = []
var selector_esExports = { render: selector_render, staticRenderFns: selector_staticRenderFns }
/* harmony default export */ var src_components_selector = (selector_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/selector/index.vue
function selector_injectStyle (ssrContext) {
  __webpack_require__("xtLV")
}
var selector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selector___vue_template_functional__ = false
/* styles */
var selector___vue_styles__ = selector_injectStyle
/* scopeId */
var selector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selector___vue_module_identifier__ = null
var selector_Component = selector_normalizeComponent(
  components_selector,
  src_components_selector,
  selector___vue_template_functional__,
  selector___vue_styles__,
  selector___vue_scopeId__,
  selector___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_selector = (selector_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("RMDY")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){_vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){_vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("owug")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux-blazy/blazy.js
var blazy = __webpack_require__("iRq5");
var blazy_default = /*#__PURE__*/__webpack_require__.n(blazy);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/webp-support.js
var webp_support = __webpack_require__("p3QP");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var components_x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5a953a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-img/index.vue
var x_img_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vux-x-img",attrs:{"src":_vm.defaultSrc,"data-src":_vm.currentSrc}})}
var x_img_staticRenderFns = []
var x_img_esExports = { render: x_img_render, staticRenderFns: x_img_staticRenderFns }
/* harmony default export */ var src_components_x_img = (x_img_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-img/index.vue
function x_img_injectStyle (ssrContext) {
  __webpack_require__("DPlV")
}
var x_img_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_img___vue_template_functional__ = false
/* styles */
var x_img___vue_styles__ = x_img_injectStyle
/* scopeId */
var x_img___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_img___vue_module_identifier__ = null
var x_img_Component = x_img_normalizeComponent(
  components_x_img,
  src_components_x_img,
  x_img___vue_template_functional__,
  x_img___vue_styles__,
  x_img___vue_scopeId__,
  x_img___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_img = (x_img_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0aeed9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){return _vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("aiyf")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login/register.vue













var vcity = {
  11: '北京',
  12: '天津',
  13: '河北',
  14: '山西',
  15: '内蒙古',
  21: '辽宁',
  22: '吉林',
  23: '黑龙江',
  31: '上海',
  32: '江苏',
  33: '浙江',
  34: '安徽',
  35: '福建',
  36: '江西',
  37: '山东',
  41: '河南',
  42: '湖北',
  43: '湖南',
  44: '广东',
  45: '广西',
  46: '海南',
  50: '重庆',
  51: '四川',
  52: '贵州',
  53: '云南',
  54: '西藏',
  61: '陕西',
  62: '甘肃',
  63: '青海',
  64: '宁夏',
  65: '新疆',
  71: '台湾',
  81: '香港',
  82: '澳门',
  91: '国外'
};

function isCardNo(card) {
  var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
  if (reg.test(card) === false) {
    return false;
  }
  return true;
}

function checkProvince(card) {
  var province = card.substr(0, 2);
  if (vcity[province] === undefined) {
    return false;
  }
  return true;
}

function checkBirthday(card) {
  var len = card.length;
  var arrData, year, month, day, birthday;

  if (len === 15) {
    var reFifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
    arrData = card.match(reFifteen);
    year = arrData[2];
    month = arrData[3];
    day = arrData[4];
    birthday = new Date('19' + year + '/' + month + '/' + day);
    return verifyBirthday('19' + year, month, day, birthday);
  }

  if (len === 18) {
    var reEighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/;
    arrData = card.match(reEighteen);
    year = arrData[2];
    month = arrData[3];
    day = arrData[4];
    birthday = new Date(year + '/' + month + '/' + day);
    return verifyBirthday(year, month, day, birthday);
  }
  return false;
}

function verifyBirthday(year, month, day, birthday) {
  var now = new Date();
  var nowYear = now.getFullYear();

  if (birthday.getFullYear() === parseInt(year) && birthday.getMonth() + 1 === parseInt(month) && birthday.getDate() === parseInt(day)) {

    var time = nowYear - year;
    if (time >= 3 && time <= 100) {
      return true;
    }
    return false;
  }
  return false;
}

function checkParity(card) {

  card = changeFivteenToEighteen(card);
  card = card.replace('x', 'X');
  var len = card.length;
  if (len === 18) {
    var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    var cardTemp = 0;
    var valnum = 0;
    for (var i = 0; i < 17; i++) {
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    valnum = arrCh[cardTemp % 11];
    if (valnum === card.substr(17, 1)) {
      return true;
    }
    return false;
  }
  return false;
}

function changeFivteenToEighteen(card) {
  if (card.length === 15) {
    var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    var cardTemp = 0;
    card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
    console.log(card);
    for (var i = 0; i < 17; i++) {
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    card += arrCh[cardTemp % 11];
    return card;
  }
  return card;
}

function checkCard(card) {

  if (isCardNo(card) === false) {
    return false;
  }

  if (checkProvince(card) === false) {
    return false;
  }

  if (checkBirthday(card) === false) {
    return false;
  }

  if (checkParity(card) === false) {
    return false;
  }
  return true;
}

function fun(value) {
  var pat = new RegExp('[^a-zA-Z0-9_\u4E00-\u9FA5]', "i");
  if (pat.test(value)) {
    return false;
  }
  return true;
}

/* harmony default export */ var register = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Alert: components_alert["a" /* default */],
    XImg: vux_src_components_x_img,
    CheckIcon: vux_src_components_check_icon
  },
  name: 'register',
  data: function data() {
    return {
      newmobile: '',
      name: '',
      idcard: '',
      mobile: '',
      company: '',
      passwd: '',
      passwd2: '',
      registerType: this.$route.query.role,
      openid: '',
      rcmd: '',
      smsCode: '',
      list: [{ key: 'users', value: '个人用户' }, { key: 'expert', value: '个人专家' }],
      checkidCard: function checkidCard(value) {
        return {
          valid: checkCard(value),
          msg: '身份证号码错误'
        };
      },
      smsDisabled: true,
      buttonText: '获取验证码',
      isDisabled: true,
      isChecked: false,
      checkName: function checkName(value) {
        return {
          valid: fun(value),
          msg: '用户名错误'
        };
      }
    };
  },

  methods: {
    handleDisabled: function handleDisabled() {
      this.isChecked = !this.isChecked;
      this.isDisabled = this.isChecked !== true;
    },
    registerSubmit: function registerSubmit() {
      var _this = this;

      var app = this;
      if (this.$refs.input1.valid && this.$refs.input2.valid && this.$refs.input3.valid && this.$refs.input4.valid && this.$refs.input5.valid && this.$refs.input6.valid && this.$refs.input7.valid && this.name && this.idcard && this.mobile) {
        if (this.checkValidatecode() && this.newmobile == this.mobile) {
          var info = {
            'code': this.smsCode,
            'mobile': this.mobile
          };
          this.$http.put('/api/v1/accounts/checksms', info).then(function (res) {
            var idcard = _this.idcard.replace('x', 'X');
            var userInfo = {
              'name': _this.name,
              'idcard': idcard,
              'mobile': _this.mobile,
              'passwd': _this.passwd,
              'account': _this.mobile,
              'openid': _this.openid,
              'rcmd': _this.rcmd,
              company: _this.company
            };
            var url = void 0;
            url = _this.registerType === 'expert' ? '/api/v1/experts/wechat' : '/api/v1/users/wechat';
            _this.$http.post(url, userInfo).then(function () {
              app.$vux.toast.show({
                text: '注册成功',
                type: 'success',
                time: '1000'
              });
              localStorage.setItem('account', userInfo.account);
              if (localStorage.getItem('history')) {
                app.$router.push({ name: 'attention', query: { id: localStorage.getItem('history') } });
                return;
              }
              if (localStorage.getItem('repair')) {
                _this.$router.push({ name: "normalrepairs" });
                return;
              }
              app.$router.push({ name: 'vip' });
            }).catch(function (error) {
              var code = JSON.parse(error.response.data.error_message).faultcode;
              if (code === 11013 || code === 11003) {
                app.$vux.toast.show({
                  text: '用户已注册，正在登录',
                  type: 'success',
                  time: '2000'
                });
                _this.$http.post("/api/v1/accounts", {
                  passwd: _this.smsCode,
                  account: _this.mobile,
                  is_passwd: false,
                  tp: 'mobile'
                }).then(function (response) {
                  localStorage.setItem("account", app.account);
                  localStorage.setItem("token", response.data.token);
                  localStorage.setItem("userid", response.data.userid);
                  var unionid = localStorage.getItem('unionid');

                  var nickname = localStorage.getItem('nickname');
                  var imgurl = localStorage.getItem('imgurl');
                  var obj = {
                    account: response.data.userid.toString(),
                    unionid: unionid,
                    nickname: nickname,
                    imgurl: imgurl,
                    otp: 'official'
                  };
                  var openid = localStorage.getItem("openid");
                  var head = {
                    headers: {
                      token: response.data.token,
                      opid: response.data.userid
                    }
                  };
                  _this.$http.post("/api/v1/wechat/" + openid, obj, head).then(function () {
                    if (localStorage.getItem('history')) {
                      _this.$router.push({
                        name: "attention", query: { id: localStorage.getItem('history') }
                      });
                      return;
                    }
                    if (localStorage.getItem('repair')) {
                      _this.$router.push({ name: localStorage.getItem('repair') });
                      return;
                    }
                    app.$router.push({ name: 'vip' });
                  }).catch(function () {
                    _this.$vux.alert.show({
                      title: '',
                      content: JSON.parse(error.response.data.error_message).zh_string
                    });
                  });
                });
              } else {
                _this.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            });
          }).catch(function (err) {
            console.log(err.response);
            app.$vux.alert.show({
              title: '',
              content: '验证码错误或已过期'
            });
          });
        } else {
          this.$vux.alert.show({
            title: '',
            content: '验证码错误或已过期'
          });
        }
      } else {
        if (!(this.$refs.input1.valid && this.$refs.input2.valid && this.$refs.input3.valid && this.$refs.input4.valid && this.$refs.input5.valid)) {
          this.$vux.alert.show({
            title: '',
            content: '输入信息有误'
          });
        } else {
          this.$vux.alert.show({
            title: '',
            content: '输入信息不完整'
          });
        }
      }
    },

    getSmscode: function getSmscode() {
      var info = {
        nationcode: '86',
        mobile: this.mobile
      };
      this.newmobile = info.mobile;
      var app = this;
      this.$http.post('/api/v1/accounts/sms', info).then(function (response) {
        console.log(response);
        if (response.data.result === 0) {
          var validateCode = {
            timestamp: parseInt(new Date().getTime() / 1000)

          };
          localStorage.setItem('validateCode', stringify_default()(validateCode));
        } else {
          app.$vux.alert.show({
            title: '',
            content: response.data.errmsg
          });
        }
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).faultstring
            });
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
      });
      sessionStorage.setItem('countDown', 60);
      if (app.buttonText === '获取验证码') {
        app.timeKeeping();
      } else {
        app.againTime();
      }
    },
    checkValidatecode: function checkValidatecode() {
      var validateCode = localStorage.getItem('validateCode');
      if (validateCode) {
        validateCode = JSON.parse(validateCode);
        var currentTime = parseInt(new Date().getTime() / 1000);
        return currentTime - validateCode.timestamp < 600;
      }
    },
    timeKeeping: function timeKeeping() {
      this.smsDisabled = true;
      var app = this;
      clearInterval(interval);
      var interval = setInterval(function () {

        var countDown = parseInt(sessionStorage.getItem('countDown'));

        app.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          sessionStorage.removeItem('countDown');
          app.buttonText = '重新发送';
          app.smsDisabled = false;
        } else {
          countDown--;
          sessionStorage.setItem('countDown', countDown);
        }
      }, 1000);
    },
    againTime: function againTime() {
      this.smsDisabled = true;
      var app = this;
      var timer = setInterval(function () {
        var countDown = parseInt(sessionStorage.getItem('countDown'));
        app.buttonText = countDown + '秒';
        if (countDown === 1) {
          clearInterval(timer);
          sessionStorage.setItem('countDown', NaN);
          app.buttonText = '重新发送';
          app.smsDisabled = false;
        }
      }, 1000);
    }
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var unionid = localStorage.getItem('unionid');
    ajax["a" /* default */].$http.get('/api/v1/wechat/' + unionid).then(function (response) {

      if (response.data.length > 0) {
        next({
          path: '/'
        });
      } else {
        if (from.name === 'protocal') {
          var regData = localStorage.getItem('regData');
          if (regData) {
            regData = JSON.parse(regData);
            next(function (vm) {
              vm.openid = openid;
              vm.name = regData.name;
              vm.idcard = regData.idcard;
              vm.mobile = regData.mobile;
              vm.passwd = regData.passwd;
              vm.passwd2 = regData.passwd2;
              vm.registerType = regData.registerType;
              vm.rcmd = regData.rcmd;
              vm.smsCode = regData.smsCode;
              vm.newmobile = regData.newmobile;
              vm.isDisabled = regData.isDisabled;
              vm.isChecked = regData.isChecked;
              vm.company = regData.company;
            });
          }
          next(function (vm) {
            vm.openid = openid;
          });
        }
        next(function (vm) {
          vm.openid = openid;
        });
      }
    }).catch(function (error) {
      this.$vux.alert.show({
        title: '',
        content: '服务器错误，请稍后重试'
      });
      if (error.response) {
        console.log(error.response.data);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'protocal') {
      var regData = {
        name: this.name,
        idcard: this.idcard,
        mobile: this.mobile,
        passwd: this.passwd,
        passwd2: this.passwd2,
        registerType: this.registerType,
        rcmd: this.rcmd,
        smsCode: this.smsCode,
        newmobile: this.newmobile,
        isDisabled: this.isDisabled,
        isChecked: this.isChecked,
        company: this.company
      };
      localStorage.setItem('regData', stringify_default()(regData));
    } else {
      localStorage.removeItem('regData');
    }
    next();
  },
  created: function created() {
    var countDown = sessionStorage.getItem('countDown');
    if (countDown && countDown !== 'NaN') {
      this.againTime();
    } else if (countDown == 'NaN') {
      this.buttonText = '重新发送';
      this.smsDisabled = false;
    } else {
      this.smsDisabled = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login/register.vue













var register_vcity = {
  11: '北京',
  12: '天津',
  13: '河北',
  14: '山西',
  15: '内蒙古',
  21: '辽宁',
  22: '吉林',
  23: '黑龙江',
  31: '上海',
  32: '江苏',
  33: '浙江',
  34: '安徽',
  35: '福建',
  36: '江西',
  37: '山东',
  41: '河南',
  42: '湖北',
  43: '湖南',
  44: '广东',
  45: '广西',
  46: '海南',
  50: '重庆',
  51: '四川',
  52: '贵州',
  53: '云南',
  54: '西藏',
  61: '陕西',
  62: '甘肃',
  63: '青海',
  64: '宁夏',
  65: '新疆',
  71: '台湾',
  81: '香港',
  82: '澳门',
  91: '国外'
};

function register_isCardNo(card) {
  var reg = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;
  if (reg.test(card) === false) {
    return false;
  }
  return true;
}

function register_checkProvince(card) {
  var province = card.substr(0, 2);
  if (register_vcity[province] === undefined) {
    return false;
  }
  return true;
}

function register_checkBirthday(card) {
  var len = card.length;
  var arrData, year, month, day, birthday;

  if (len === 15) {
    var reFifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
    arrData = card.match(reFifteen);
    year = arrData[2];
    month = arrData[3];
    day = arrData[4];
    birthday = new Date('19' + year + '/' + month + '/' + day);
    return register_verifyBirthday('19' + year, month, day, birthday);
  }

  if (len === 18) {
    var reEighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X|x)$/;
    arrData = card.match(reEighteen);
    year = arrData[2];
    month = arrData[3];
    day = arrData[4];
    birthday = new Date(year + '/' + month + '/' + day);
    return register_verifyBirthday(year, month, day, birthday);
  }
  return false;
}

function register_verifyBirthday(year, month, day, birthday) {
  var now = new Date();
  var nowYear = now.getFullYear();

  if (birthday.getFullYear() === parseInt(year) && birthday.getMonth() + 1 === parseInt(month) && birthday.getDate() === parseInt(day)) {

    var time = nowYear - year;
    if (time >= 3 && time <= 100) {
      return true;
    }
    return false;
  }
  return false;
}

function register_checkParity(card) {

  card = register_changeFivteenToEighteen(card);
  card = card.replace('x', 'X');
  var len = card.length;
  if (len === 18) {
    var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    var cardTemp = 0;
    var valnum = 0;
    for (var i = 0; i < 17; i++) {
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    valnum = arrCh[cardTemp % 11];
    if (valnum === card.substr(17, 1)) {
      return true;
    }
    return false;
  }
  return false;
}

function register_changeFivteenToEighteen(card) {
  if (card.length === 15) {
    var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    var arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    var cardTemp = 0;
    card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
    console.log(card);
    for (var i = 0; i < 17; i++) {
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    card += arrCh[cardTemp % 11];
    return card;
  }
  return card;
}

function register_checkCard(card) {

  if (register_isCardNo(card) === false) {
    return false;
  }

  if (register_checkProvince(card) === false) {
    return false;
  }

  if (register_checkBirthday(card) === false) {
    return false;
  }

  if (register_checkParity(card) === false) {
    return false;
  }
  return true;
}

function register_fun(value) {
  var pat = new RegExp('[^a-zA-Z0-9_\u4E00-\u9FA5]', "i");
  if (pat.test(value)) {
    return false;
  }
  return true;
}

/* harmony default export */ var login_register = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Alert: components_alert["a" /* default */],
    XImg: vux_src_components_x_img,
    CheckIcon: vux_src_components_check_icon
  },
  name: 'register',
  data: function data() {
    return {
      newmobile: '',
      name: '',
      idcard: '',
      mobile: '',
      company: '',
      passwd: '',
      passwd2: '',
      registerType: this.$route.query.role,
      openid: '',
      rcmd: '',
      smsCode: '',
      list: [{ key: 'users', value: '个人用户' }, { key: 'expert', value: '个人专家' }],
      checkidCard: function checkidCard(value) {
        return {
          valid: register_checkCard(value),
          msg: '身份证号码错误'
        };
      },
      smsDisabled: true,
      buttonText: '获取验证码',
      isDisabled: true,
      isChecked: false,
      checkName: function checkName(value) {
        return {
          valid: register_fun(value),
          msg: '用户名错误'
        };
      }
    };
  },

  methods: {
    handleDisabled: function handleDisabled() {
      this.isChecked = !this.isChecked;
      this.isDisabled = this.isChecked !== true;
    },
    registerSubmit: function registerSubmit() {
      var _this = this;

      var app = this;
      if (this.$refs.input1.valid && this.$refs.input2.valid && this.$refs.input3.valid && this.$refs.input4.valid && this.$refs.input5.valid && this.$refs.input6.valid && this.$refs.input7.valid && this.name && this.idcard && this.mobile) {
        if (this.checkValidatecode() && this.newmobile == this.mobile) {
          var info = {
            'code': this.smsCode,
            'mobile': this.mobile
          };
          this.$http.put('/api/v1/accounts/checksms', info).then(function (res) {
            var idcard = _this.idcard.replace('x', 'X');
            var userInfo = {
              'name': _this.name,
              'idcard': idcard,
              'mobile': _this.mobile,
              'passwd': _this.passwd,
              'account': _this.mobile,
              'openid': _this.openid,
              'rcmd': _this.rcmd,
              company: _this.company
            };
            var url = void 0;
            url = _this.registerType === 'expert' ? '/api/v1/experts/wechat' : '/api/v1/users/wechat';
            _this.$http.post(url, userInfo).then(function () {
              app.$vux.toast.show({
                text: '注册成功',
                type: 'success',
                time: '1000'
              });
              localStorage.setItem('account', userInfo.account);
              if (localStorage.getItem('history')) {
                app.$router.push({ name: 'attention', query: { id: localStorage.getItem('history') } });
                return;
              }
              if (localStorage.getItem('repair')) {
                _this.$router.push({ name: "normalrepairs" });
                return;
              }
              app.$router.push({ name: 'vip' });
            }).catch(function (error) {
              var code = JSON.parse(error.response.data.error_message).faultcode;
              if (code === 11013 || code === 11003) {
                app.$vux.toast.show({
                  text: '用户已注册，正在登录',
                  type: 'success',
                  time: '2000'
                });
                _this.$http.post("/api/v1/accounts", {
                  passwd: _this.smsCode,
                  account: _this.mobile,
                  is_passwd: false,
                  tp: 'mobile'
                }).then(function (response) {
                  localStorage.setItem("account", app.account);
                  localStorage.setItem("token", response.data.token);
                  localStorage.setItem("userid", response.data.userid);
                  var unionid = localStorage.getItem('unionid');

                  var nickname = localStorage.getItem('nickname');
                  var imgurl = localStorage.getItem('imgurl');
                  var obj = {
                    account: response.data.userid.toString(),
                    unionid: unionid,
                    nickname: nickname,
                    imgurl: imgurl,
                    otp: 'official'
                  };
                  var openid = localStorage.getItem("openid");
                  var head = {
                    headers: {
                      token: response.data.token,
                      opid: response.data.userid
                    }
                  };
                  _this.$http.post("/api/v1/wechat/" + openid, obj, head).then(function () {
                    if (localStorage.getItem('history')) {
                      _this.$router.push({
                        name: "attention", query: { id: localStorage.getItem('history') }
                      });
                      return;
                    }
                    if (localStorage.getItem('repair')) {
                      _this.$router.push({ name: localStorage.getItem('repair') });
                      return;
                    }
                    app.$router.push({ name: 'vip' });
                  }).catch(function () {
                    _this.$vux.alert.show({
                      title: '',
                      content: JSON.parse(error.response.data.error_message).zh_string
                    });
                  });
                });
              } else {
                _this.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            });
          }).catch(function (err) {
            console.log(err.response);
            app.$vux.alert.show({
              title: '',
              content: '验证码错误或已过期'
            });
          });
        } else {
          this.$vux.alert.show({
            title: '',
            content: '验证码错误或已过期'
          });
        }
      } else {
        if (!(this.$refs.input1.valid && this.$refs.input2.valid && this.$refs.input3.valid && this.$refs.input4.valid && this.$refs.input5.valid)) {
          this.$vux.alert.show({
            title: '',
            content: '输入信息有误'
          });
        } else {
          this.$vux.alert.show({
            title: '',
            content: '输入信息不完整'
          });
        }
      }
    },

    getSmscode: function getSmscode() {
      var info = {
        nationcode: '86',
        mobile: this.mobile
      };
      this.newmobile = info.mobile;
      var app = this;
      this.$http.post('/api/v1/accounts/sms', info).then(function (response) {
        console.log(response);
        if (response.data.result === 0) {
          var validateCode = {
            timestamp: parseInt(new Date().getTime() / 1000)

          };
          localStorage.setItem('validateCode', stringify_default()(validateCode));
        } else {
          app.$vux.alert.show({
            title: '',
            content: response.data.errmsg
          });
        }
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).faultstring
            });
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
      });
      sessionStorage.setItem('countDown', 60);
      if (app.buttonText === '获取验证码') {
        app.timeKeeping();
      } else {
        app.againTime();
      }
    },
    checkValidatecode: function checkValidatecode() {
      var validateCode = localStorage.getItem('validateCode');
      if (validateCode) {
        validateCode = JSON.parse(validateCode);
        var currentTime = parseInt(new Date().getTime() / 1000);
        return currentTime - validateCode.timestamp < 600;
      }
    },
    timeKeeping: function timeKeeping() {
      this.smsDisabled = true;
      var app = this;
      clearInterval(interval);
      var interval = setInterval(function () {

        var countDown = parseInt(sessionStorage.getItem('countDown'));

        app.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          sessionStorage.removeItem('countDown');
          app.buttonText = '重新发送';
          app.smsDisabled = false;
        } else {
          countDown--;
          sessionStorage.setItem('countDown', countDown);
        }
      }, 1000);
    },
    againTime: function againTime() {
      this.smsDisabled = true;
      var app = this;
      var timer = setInterval(function () {
        var countDown = parseInt(sessionStorage.getItem('countDown'));
        app.buttonText = countDown + '秒';
        if (countDown === 1) {
          clearInterval(timer);
          sessionStorage.setItem('countDown', NaN);
          app.buttonText = '重新发送';
          app.smsDisabled = false;
        }
      }, 1000);
    }
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var unionid = localStorage.getItem('unionid');
    ajax["a" /* default */].$http.get('/api/v1/wechat/' + unionid).then(function (response) {

      if (response.data.length > 0) {
        next({
          path: '/'
        });
      } else {
        if (from.name === 'protocal') {
          var regData = localStorage.getItem('regData');
          if (regData) {
            regData = JSON.parse(regData);
            next(function (vm) {
              vm.openid = openid;
              vm.name = regData.name;
              vm.idcard = regData.idcard;
              vm.mobile = regData.mobile;
              vm.passwd = regData.passwd;
              vm.passwd2 = regData.passwd2;
              vm.registerType = regData.registerType;
              vm.rcmd = regData.rcmd;
              vm.smsCode = regData.smsCode;
              vm.newmobile = regData.newmobile;
              vm.isDisabled = regData.isDisabled;
              vm.isChecked = regData.isChecked;
              vm.company = regData.company;
            });
          }
          next(function (vm) {
            vm.openid = openid;
          });
        }
        next(function (vm) {
          vm.openid = openid;
        });
      }
    }).catch(function (error) {
      this.$vux.alert.show({
        title: '',
        content: '服务器错误，请稍后重试'
      });
      if (error.response) {
        console.log(error.response.data);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'protocal') {
      var regData = {
        name: this.name,
        idcard: this.idcard,
        mobile: this.mobile,
        passwd: this.passwd,
        passwd2: this.passwd2,
        registerType: this.registerType,
        rcmd: this.rcmd,
        smsCode: this.smsCode,
        newmobile: this.newmobile,
        isDisabled: this.isDisabled,
        isChecked: this.isChecked,
        company: this.company
      };
      localStorage.setItem('regData', stringify_default()(regData));
    } else {
      localStorage.removeItem('regData');
    }
    next();
  },
  created: function created() {
    var countDown = sessionStorage.getItem('countDown');
    if (countDown && countDown !== 'NaN') {
      this.againTime();
    } else if (countDown == 'NaN') {
      this.buttonText = '重新发送';
      this.smsDisabled = false;
    } else {
      this.smsDisabled = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84bfffaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/register.vue
var register_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.registerType === 'users')?_c('x-header',{attrs:{"left-options":{showBack: false}}},[_vm._v("用户注册")]):_vm._e(),_vm._v(" "),(_vm.registerType === 'expert')?_c('x-header',{attrs:{"left-options":{showBack: false}}},[_vm._v("专家注册")]):_vm._e(),_vm._v(" "),_c('group',[_c('x-input',{ref:"input1",attrs:{"title":"姓名","type":"text","required":"","is-type":_vm.checkName,"placeholder":"请输入姓名","show-clear":false},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('x-input',{ref:"input7",attrs:{"title":"工作单位","required":"","type":"text","placeholder":"请输入工作单位","show-clear":false},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}}),_vm._v(" "),_c('x-input',{ref:"input2",attrs:{"title":"手机号码","required":"","max":13,"is-type":"china-mobile","placeholder":"请输入手机号码","show-clear":false},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}),_vm._v(" "),_c('x-input',{ref:"input3",attrs:{"title":"身份证号码","required":"","placeholder":"请输入身份证号码","is-type":_vm.checkidCard,"show-clear":false},model:{value:(_vm.idcard),callback:function ($$v) {_vm.idcard=$$v},expression:"idcard"}}),_vm._v(" "),_c('x-input',{ref:"input4",attrs:{"title":"请输入密码","required":"","type":"password","placeholder":"请输入密码","min":6,"show-clear":false},model:{value:(_vm.passwd),callback:function ($$v) {_vm.passwd=$$v},expression:"passwd"}}),_vm._v(" "),_c('x-input',{ref:"input5",attrs:{"title":"请确认密码","required":"","type":"password","placeholder":"请确认密码","equal-with":_vm.passwd,"show-clear":false},model:{value:(_vm.passwd2),callback:function ($$v) {_vm.passwd2=$$v},expression:"passwd2"}}),_vm._v(" "),_c('x-input',{ref:"input6",attrs:{"title":"推荐人账号","max":13,"is-type":"china-mobile","placeholder":"请输入推荐人账号","show-clear":false},model:{value:(_vm.rcmd),callback:function ($$v) {_vm.rcmd=$$v},expression:"rcmd"}}),_vm._v(" "),_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"验证码"},model:{value:(_vm.smsCode),callback:function ($$v) {_vm.smsCode=$$v},expression:"smsCode"}},[_c('x-button',{attrs:{"slot":"right","type":"primary","mini":"","disabled":_vm.smsDisabled,"text":_vm.buttonText},nativeOn:{"click":function($event){return _vm.getSmscode($event)}},slot:"right"})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"click":_vm.handleDisabled}}),_vm._v(" "),_c('router-link',{attrs:{"to":"protocal"}},[_vm._v("同意好云帷合作协议")])],1),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","disabled":"!agree","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.registerSubmit($event)}}},[_vm._v("\n      提交注册\n    ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_c('router-link',{staticStyle:{"color":"red"},attrs:{"to":{name:'login'}}},[_vm._v("已有账号，点此登录")])],1)],1)])}
var register_staticRenderFns = []
var register_esExports = { render: register_render, staticRenderFns: register_staticRenderFns }
/* harmony default export */ var components_login_register = (register_esExports);
// CONCATENATED MODULE: ./src/components/login/register.vue
function register_injectStyle (ssrContext) {
  __webpack_require__("1LeC")
}
var register_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var register___vue_template_functional__ = false
/* styles */
var register___vue_styles__ = register_injectStyle
/* scopeId */
var register___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var register___vue_module_identifier__ = null
var register_Component = register_normalizeComponent(
  login_register,
  components_login_register,
  register___vue_template_functional__,
  register___vue_styles__,
  register___vue_scopeId__,
  register___vue_module_identifier__
)

/* harmony default export */ var src_components_login_register = (register_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login/login.vue







/* harmony default export */ var login_login = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */]
  },
  name: "login",
  data: function data() {
    return {
      passwd: "",
      account: "",
      showAD: true,
      adSrc: "/static/img/ad.png",
      adTime: 0,
      flag: false,
      interval: '',
      register: ''
    };
  },

  methods: {
    close: function close() {
      clearInterval(this.interval);
      localStorage.setItem('showAD', '');
      this.showAD = false;
    },
    gotoVipPage: function gotoVipPage() {
      this.$router.push({
        name: "vip"
      });
    },
    adTimeshow: function adTimeshow() {
      var _this = this;

      this.interval = setInterval(function () {
        var countDown = parseInt(_this.adTime);
        if (countDown === 0) {
          clearInterval(_this.interval);
          localStorage.setItem('showAD', '');
          _this.showAD = false;
        } else {
          countDown--;
          _this.adTime = countDown;
        }
      }, 1000);
    },
    login: function login() {
      var _this2 = this;

      var userInfo = {
        passwd: this.passwd,
        account: this.account,
        is_passwd: true,
        tp: 'mobile'
      };
      var app = this;
      this.$http.post("/api/v1/accounts", userInfo).then(function (response) {
        if (app.flag) {
          app.$router.push({ name: "userhomepage" });
        } else {
          var head = {
            headers: {
              token: response.data.token,
              opid: response.data.userid
            }
          };
          var opid = response.data.userid;
          var openid = localStorage.getItem("openid");
          var unionid = localStorage.getItem('unionid');

          var nickname = localStorage.getItem('nickname');
          var imgurl = localStorage.getItem('imgurl');
          var obj = {
            account: response.data.userid.toString(),
            unionid: unionid,
            nickname: nickname,
            imgurl: imgurl,
            otp: 'official'
          };
          localStorage.setItem("account", app.account);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("userid", response.data.userid);
          app.$http.get("/api/v1/wechat/" + unionid).then(function (res) {

            if (res.data.indexOf(app.account) != -1) {
              app.gotoVipPage();
            } else {
              app.$http.get('api/v1/accounts/' + opid, head).then(function (resp) {
                var bool = false;
                for (var i = 0; i < resp.data.length; i++) {
                  if (resp.data[i].type == 'INDV' || resp.data[i].type == 'EXPT') {
                    bool = true;
                    break;
                  }
                }
                if (bool) {
                  app.$http.post("/api/v1/wechat/" + openid, obj, head).then(function (res) {
                    if (localStorage.getItem('history')) {
                      _this2.$router.push({
                        name: "attention", query: { id: localStorage.getItem('history') }
                      });
                      return;
                    }
                    if (localStorage.getItem('repair')) {
                      var _obj = void 0;
                      _obj = localStorage.getItem('repair') === 'solution_logs' ? {
                        name: localStorage.getItem('repair'),
                        params: {
                          role: localStorage.getItem('repairtype')
                        }
                      } : {
                        name: localStorage.getItem('repair')
                      };
                      _this2.$router.push(_obj);
                      localStorage.removeItem('repair');
                      return;
                    }
                    if (localStorage.getItem('viwocertificate')) {
                      _this2.$router.push({ name: 'viwocertificate' });
                      return;
                    }
                    app.gotoVipPage();
                    app.$vux.toast.show({
                      text: "登录成功",
                      type: "success",
                      time: "1000"
                    });
                  }).catch(function (error) {
                    app.$vux.toast.show({
                      text: JSON.parse(error.response.data.error_message).zh_string,
                      type: "cancel",
                      time: "1000"
                    });
                  });
                } else {
                  app.$vux.toast.show({
                    text: "该身份暂不允许登录",
                    type: "cancel",
                    time: "1000"
                  });
                }
              });
            }
          }).catch(function (error) {
            app.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: "cancel",
              time: "1000"
            });
          });
        }
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          if (error.response.data.error_message) {
            app.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: "cancel",
              time: "1000"
            });
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
      });
    }
  },
  created: function created() {
    this.adTimeshow();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === "register" || from.name === "RegisterType") {
      next(function (vm) {
        vm.adTime = 0;
        vm.showAD = false;
        localStorage.setItem('showAD', '');
      });
    } else {
      next(function (vm) {
        vm.adTime = 5;
        localStorage.setItem('showAD', 'true');
        vm.register = localStorage.getItem('history') ? {
          name: 'register',
          query: { role: 'users' }
        } : { name: 'RegisterType' };
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login/login.vue







/* harmony default export */ var components_login_login = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */]
  },
  name: "login",
  data: function data() {
    return {
      passwd: "",
      account: "",
      showAD: true,
      adSrc: "/static/img/ad.png",
      adTime: 0,
      flag: false,
      interval: '',
      register: ''
    };
  },

  methods: {
    close: function close() {
      clearInterval(this.interval);
      localStorage.setItem('showAD', '');
      this.showAD = false;
    },
    gotoVipPage: function gotoVipPage() {
      this.$router.push({
        name: "vip"
      });
    },
    adTimeshow: function adTimeshow() {
      var _this = this;

      this.interval = setInterval(function () {
        var countDown = parseInt(_this.adTime);
        if (countDown === 0) {
          clearInterval(_this.interval);
          localStorage.setItem('showAD', '');
          _this.showAD = false;
        } else {
          countDown--;
          _this.adTime = countDown;
        }
      }, 1000);
    },
    login: function login() {
      var _this2 = this;

      var userInfo = {
        passwd: this.passwd,
        account: this.account,
        is_passwd: true,
        tp: 'mobile'
      };
      var app = this;
      this.$http.post("/api/v1/accounts", userInfo).then(function (response) {
        if (app.flag) {
          app.$router.push({ name: "userhomepage" });
        } else {
          var head = {
            headers: {
              token: response.data.token,
              opid: response.data.userid
            }
          };
          var opid = response.data.userid;
          var openid = localStorage.getItem("openid");
          var unionid = localStorage.getItem('unionid');

          var nickname = localStorage.getItem('nickname');
          var imgurl = localStorage.getItem('imgurl');
          var obj = {
            account: response.data.userid.toString(),
            unionid: unionid,
            nickname: nickname,
            imgurl: imgurl,
            otp: 'official'
          };
          localStorage.setItem("account", app.account);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("userid", response.data.userid);
          app.$http.get("/api/v1/wechat/" + unionid).then(function (res) {

            if (res.data.indexOf(app.account) != -1) {
              app.gotoVipPage();
            } else {
              app.$http.get('api/v1/accounts/' + opid, head).then(function (resp) {
                var bool = false;
                for (var i = 0; i < resp.data.length; i++) {
                  if (resp.data[i].type == 'INDV' || resp.data[i].type == 'EXPT') {
                    bool = true;
                    break;
                  }
                }
                if (bool) {
                  app.$http.post("/api/v1/wechat/" + openid, obj, head).then(function (res) {
                    if (localStorage.getItem('history')) {
                      _this2.$router.push({
                        name: "attention", query: { id: localStorage.getItem('history') }
                      });
                      return;
                    }
                    if (localStorage.getItem('repair')) {
                      var _obj = void 0;
                      _obj = localStorage.getItem('repair') === 'solution_logs' ? {
                        name: localStorage.getItem('repair'),
                        params: {
                          role: localStorage.getItem('repairtype')
                        }
                      } : {
                        name: localStorage.getItem('repair')
                      };
                      _this2.$router.push(_obj);
                      localStorage.removeItem('repair');
                      return;
                    }
                    if (localStorage.getItem('viwocertificate')) {
                      _this2.$router.push({ name: 'viwocertificate' });
                      return;
                    }
                    app.gotoVipPage();
                    app.$vux.toast.show({
                      text: "登录成功",
                      type: "success",
                      time: "1000"
                    });
                  }).catch(function (error) {
                    app.$vux.toast.show({
                      text: JSON.parse(error.response.data.error_message).zh_string,
                      type: "cancel",
                      time: "1000"
                    });
                  });
                } else {
                  app.$vux.toast.show({
                    text: "该身份暂不允许登录",
                    type: "cancel",
                    time: "1000"
                  });
                }
              });
            }
          }).catch(function (error) {
            app.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: "cancel",
              time: "1000"
            });
          });
        }
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          if (error.response.data.error_message) {
            app.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: "cancel",
              time: "1000"
            });
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
      });
    }
  },
  created: function created() {
    this.adTimeshow();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === "register" || from.name === "RegisterType") {
      next(function (vm) {
        vm.adTime = 0;
        vm.showAD = false;
        localStorage.setItem('showAD', '');
      });
    } else {
      next(function (vm) {
        vm.adTime = 5;
        localStorage.setItem('showAD', 'true');
        vm.register = localStorage.getItem('history') ? {
          name: 'register',
          query: { role: 'users' }
        } : { name: 'RegisterType' };
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1934fb52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showAD),expression:"!showAD"}]},[_c('group',[_c('x-input',{attrs:{"title":"账号","required":"","max":13,"is-type":"china-mobile","placeholder":"请输入已注册账号"},model:{value:(_vm.account),callback:function ($$v) {_vm.account=$$v},expression:"account"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"请输入密码","required":"","type":"password","placeholder":"请输入登录密码"},model:{value:(_vm.passwd),callback:function ($$v) {_vm.passwd=$$v},expression:"passwd"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.login($event)}}},[_vm._v("登录")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","color":"#fff"}},[_c('p',[_c('router-link',{attrs:{"to":{name:'forgetpassword'}}},[_vm._v("忘记密码?")])],1),_vm._v(" "),_c('p',{staticStyle:{"text-align":"right"}},[_c('router-link',{attrs:{"to":{name:'RegisterType'}}},[_vm._v("立即注册")])],1)])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAD),expression:"showAD"}],staticStyle:{"background-color":"transparent","text-align":"center"}},[_c('div',{staticClass:"Countdown",on:{"click":function($event){_vm.close()}}},[_vm._v(_vm._s(_vm.adTime)+"跳过广告")]),_vm._v(" "),_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.adSrc}})])])}
var login_staticRenderFns = []
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_login_login = (login_esExports);
// CONCATENATED MODULE: ./src/components/login/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("CCc5")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-1934fb52"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  components_login_login,
  selectortype_template_index_0_src_components_login_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_components_login_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc96ffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("iASr")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["b" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["b" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc027bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/card/index.vue
var card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header && _vm.header.title)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header.title)},on:{"click":function($event){_vm.$emit('on-click-header')}}}):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_c('div',{staticClass:"vux-card-content"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title)?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":"javascript:"},on:{"click":_vm.onClickFooter}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()]),_vm._v(" "),_vm._t("footer")],2)}
var card_staticRenderFns = []
var card_esExports = { render: card_render, staticRenderFns: card_staticRenderFns }
/* harmony default export */ var src_components_card = (card_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/card/index.vue
function card_injectStyle (ssrContext) {
  __webpack_require__("Gz2+")
}
var card_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var card___vue_template_functional__ = false
/* styles */
var card___vue_styles__ = card_injectStyle
/* scopeId */
var card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var card___vue_module_identifier__ = null
var card_Component = card_normalizeComponent(
  components_card,
  src_components_card,
  card___vue_template_functional__,
  card___vue_styles__,
  card___vue_scopeId__,
  card___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_card = (card_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e51266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("QX3Y")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["b" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["b" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a1f8152","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-box/index.vue
var cell_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box weui-cell",class:_vm.className,style:(_vm.style),on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var cell_box_staticRenderFns = []
var cell_box_esExports = { render: cell_box_render, staticRenderFns: cell_box_staticRenderFns }
/* harmony default export */ var src_components_cell_box = (cell_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-box/index.vue
function cell_box_injectStyle (ssrContext) {
  __webpack_require__("KXcw")
}
var cell_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell_box___vue_template_functional__ = false
/* styles */
var cell_box___vue_styles__ = cell_box_injectStyle
/* scopeId */
var cell_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell_box___vue_module_identifier__ = null
var cell_box_Component = cell_box_normalizeComponent(
  components_cell_box,
  src_components_cell_box,
  cell_box___vue_template_functional__,
  cell_box___vue_styles__,
  cell_box___vue_scopeId__,
  cell_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_box = (cell_box_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/confirm/index.vue + 3 modules
var components_confirm = __webpack_require__("62KO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65b3ca5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/divider/index.vue
var divider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vux-divider"},[_vm._t("default")],2)}
var divider_staticRenderFns = []
var divider_esExports = { render: divider_render, staticRenderFns: divider_staticRenderFns }
/* harmony default export */ var src_components_divider = (divider_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/divider/index.vue
function divider_injectStyle (ssrContext) {
  __webpack_require__("78BN")
}
var divider_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var divider___vue_template_functional__ = false
/* styles */
var divider___vue_styles__ = divider_injectStyle
/* scopeId */
var divider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var divider___vue_module_identifier__ = null
var divider_Component = divider_normalizeComponent(
  components_divider,
  src_components_divider,
  divider___vue_template_functional__,
  divider___vue_styles__,
  divider___vue_scopeId__,
  divider___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_divider = (divider_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/vip.vue










/* harmony default export */ var vip = ({
  name: 'vip',
  components: {
    Card: vux_src_components_card,
    Divider: vux_src_components_divider,
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    Badge: vux_src_components_badge,
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */]
  },
  data: function data() {
    return {

      setimgUrl: '/static/img/set.png',
      imgUrl: '/static/img/vip.png',
      account: '',
      name: '',
      mobile: '',
      showContent001: false,
      isIndv: false,
      isExpt: false,
      isEntp: false,
      isSrvp: false,
      isAdmin: false,
      isSrvpAdmin: false,
      isLog: false,
      adSrc: '/static/img/ad.png',
      list: []
    };
  },

  methods: {
    add: function add() {
      if (!this.isIndv && this.isExpt) {
        this.$router.push({ name: 'addmyInfo' });
      }
      if (this.isIndv && !this.isExpt) {
        this.$router.push({ name: 'addexpertInfo' });
      }
    },
    myidentity: function myidentity() {
      this.showContent001 = !this.showContent001;
    },
    logout: function logout() {
      var obj = {
        name: this.name,
        mobile: this.mobile
      };
      this.$router.push({ name: 'glzh', params: { obj: obj } });
    }
  },
  created: function created() {
    var _this = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    var account = JSON.parse(localStorage.getItem('account'));

    console.log(account);
    var account1 = '';
    if (account.length > 0) {
      account.forEach(function (item) {
        if (item.role === 'EXPT') {
          _this.isExpt = true;
          account1 = item.account;
        } else if (item.role === 'INDV') {
          _this.isIndv = true;
          account1 = item.account;
        } else if (item.role === 'SRVP') {
          _this.isSrvpAdmin = true;
          _this.$http.post('api/v1/wechat/' + localStorage.getItem('unionid') + '/token', { 'account': item.account }).then(function (response) {
            _this.$http.get('api/v1/accounts/' + response.data.userid, {
              headers: {
                token: response.data.token,
                opid: response.data.userid
              }
            }).then(function (res) {
              res.data.forEach(function (item) {
                _this.isLog = item.supported.indexOf('log') !== -1;
              });
            });
          });
        } else if (item.role === 'ADMIN') {
          _this.isAdmin = true;
        }
      });

      if (account1 != '') {
        this.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account1 }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var url = void 0;
          if (account[0].role === 'EXPT') {
            url = '/api/v1/experts/';
          } else {
            url = '/api/v1/users/';
          }
          _this.$http.get(url + res.data.userid, {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          }).then(function (response) {
            if (response.data.detail) {
              _this.name = response.data.detail.name;
              _this.mobile = response.data.account;
            }
          });
        }).catch(function (error) {
          _this.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).faultstring,
            type: 'cancel',
            time: '1000'
          });
        });
      } else {
        this.$router.push({ path: '/login' });
      }
    } else {
      this.$router.push({ path: '/login' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/vip.vue










/* harmony default export */ var components_vip = ({
  name: 'vip',
  components: {
    Card: vux_src_components_card,
    Divider: vux_src_components_divider,
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    Badge: vux_src_components_badge,
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */]
  },
  data: function data() {
    return {

      setimgUrl: '/static/img/set.png',
      imgUrl: '/static/img/vip.png',
      account: '',
      name: '',
      mobile: '',
      showContent001: false,
      isIndv: false,
      isExpt: false,
      isEntp: false,
      isSrvp: false,
      isAdmin: false,
      isSrvpAdmin: false,
      isLog: false,
      adSrc: '/static/img/ad.png',
      list: []
    };
  },

  methods: {
    add: function add() {
      if (!this.isIndv && this.isExpt) {
        this.$router.push({ name: 'addmyInfo' });
      }
      if (this.isIndv && !this.isExpt) {
        this.$router.push({ name: 'addexpertInfo' });
      }
    },
    myidentity: function myidentity() {
      this.showContent001 = !this.showContent001;
    },
    logout: function logout() {
      var obj = {
        name: this.name,
        mobile: this.mobile
      };
      this.$router.push({ name: 'glzh', params: { obj: obj } });
    }
  },
  created: function created() {
    var _this = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    var account = JSON.parse(localStorage.getItem('account'));

    console.log(account);
    var account1 = '';
    if (account.length > 0) {
      account.forEach(function (item) {
        if (item.role === 'EXPT') {
          _this.isExpt = true;
          account1 = item.account;
        } else if (item.role === 'INDV') {
          _this.isIndv = true;
          account1 = item.account;
        } else if (item.role === 'SRVP') {
          _this.isSrvpAdmin = true;
          _this.$http.post('api/v1/wechat/' + localStorage.getItem('unionid') + '/token', { 'account': item.account }).then(function (response) {
            _this.$http.get('api/v1/accounts/' + response.data.userid, {
              headers: {
                token: response.data.token,
                opid: response.data.userid
              }
            }).then(function (res) {
              res.data.forEach(function (item) {
                _this.isLog = item.supported.indexOf('log') !== -1;
              });
            });
          });
        } else if (item.role === 'ADMIN') {
          _this.isAdmin = true;
        }
      });

      if (account1 != '') {
        this.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account1 }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var url = void 0;
          if (account[0].role === 'EXPT') {
            url = '/api/v1/experts/';
          } else {
            url = '/api/v1/users/';
          }
          _this.$http.get(url + res.data.userid, {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          }).then(function (response) {
            if (response.data.detail) {
              _this.name = response.data.detail.name;
              _this.mobile = response.data.account;
            }
          });
        }).catch(function (error) {
          _this.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).faultstring,
            type: 'cancel',
            time: '1000'
          });
        });
      } else {
        this.$router.push({ path: '/login' });
      }
    } else {
      this.$router.push({ path: '/login' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a1586b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vip.vue
var vip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('card',[_c('div',{staticClass:"divHeader",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticStyle:{"float":"left"}},[_c('img',{staticClass:"vipImage",attrs:{"src":_vm.imgUrl}})]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","left":"60px","top":"30px"}},[_c('span',{staticStyle:{"font-size":"0.85em"}},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.85em"}},[_vm._v(" "+_vm._s(_vm.mobile)+" ")])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","right":"20px","bottom":"10px","display":"flex","align-items":"center"}},[_c('img',{staticStyle:{"width":"15px","height":"15px","padding-right":"4px"},attrs:{"src":_vm.setimgUrl}}),_c('a',{staticStyle:{"font-size":"0.85em"},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.logout}},[_vm._v("账号管理")])])])]),_vm._v(" "),_c('group',[_c('cell',{attrs:{"title":('我的钱包'),"is-link":"","link":{ name: 'wallet'}}}),_vm._v(" "),_c('cell',{attrs:{"title":('我的身份'),"is-link":"","border-intent":false,"arrow-direction":_vm.showContent001 ? 'up' : 'down'},nativeOn:{"click":function($event){return _vm.myidentity($event)}}}),_vm._v(" "),(_vm.showContent001)?[(_vm.isIndv)?_c('cell-box',{staticStyle:{"color":"#888"},attrs:{"is-link":"","link":{ name: 'myInfo'}}},[_vm._v("个人用户")]):_vm._e(),_vm._v(" "),(_vm.isExpt)?_c('cell-box',{staticStyle:{"color":"#888"},attrs:{"is-link":"","link":{ name: 'expertInfo'}}},[_vm._v("个人专家")]):_vm._e()]:_vm._e(),_vm._v(" "),_c('cell',{attrs:{"title":('我的订单'),"is-link":"","link":{ name: 'userhomepage',query:{select:_vm.isIndv?'用户':_vm.isExpt?'工程师':''}}}})],2)],1)])}
var vip_staticRenderFns = []
var vip_esExports = { render: vip_render, staticRenderFns: vip_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_vip = (vip_esExports);
// CONCATENATED MODULE: ./src/components/vip.vue
function vip_injectStyle (ssrContext) {
  __webpack_require__("z+Wg")
}
var vip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var vip___vue_template_functional__ = false
/* styles */
var vip___vue_styles__ = vip_injectStyle
/* scopeId */
var vip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var vip___vue_module_identifier__ = null
var vip_Component = vip_normalizeComponent(
  components_vip,
  selectortype_template_index_0_src_components_vip,
  vip___vue_template_functional__,
  vip___vue_styles__,
  vip___vue_scopeId__,
  vip___vue_module_identifier__
)

/* harmony default export */ var src_components_vip = (vip_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker_checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c9f890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker.vue
var checker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-box"},[_vm._t("default")],2)}
var checker_staticRenderFns = []
var checker_esExports = { render: checker_render, staticRenderFns: checker_staticRenderFns }
/* harmony default export */ var components_checker_checker = (checker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker.vue
function checker_injectStyle (ssrContext) {
  __webpack_require__("Luh7")
}
var checker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker___vue_template_functional__ = false
/* styles */
var checker___vue_styles__ = checker_injectStyle
/* scopeId */
var checker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker___vue_module_identifier__ = null
var checker_Component = checker_normalizeComponent(
  checker_checker,
  components_checker_checker,
  checker___vue_template_functional__,
  checker___vue_styles__,
  checker___vue_scopeId__,
  checker___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker = (checker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && checker_item_isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return checker_item_isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function checker_item_isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcb1243a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker-item.vue
var checker_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-item",class:_vm.classNames,on:{"click":_vm.select}},[_vm._t("default")],2)}
var checker_item_staticRenderFns = []
var checker_item_esExports = { render: checker_item_render, staticRenderFns: checker_item_staticRenderFns }
/* harmony default export */ var components_checker_checker_item = (checker_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker-item.vue
function checker_item_injectStyle (ssrContext) {
  __webpack_require__("uGHa")
}
var checker_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker_item___vue_template_functional__ = false
/* styles */
var checker_item___vue_styles__ = checker_item_injectStyle
/* scopeId */
var checker_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker_item___vue_module_identifier__ = null
var checker_item_Component = checker_item_normalizeComponent(
  checker_checker_item,
  components_checker_checker_item,
  checker_item___vue_template_functional__,
  checker_item___vue_styles__,
  checker_item___vue_scopeId__,
  checker_item___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker_item = (checker_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/datas/china_address_v4.json
var china_address_v4 = __webpack_require__("FHgB");
var china_address_v4_default = /*#__PURE__*/__webpack_require__.n(china_address_v4);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/name2value.js
var name2value = __webpack_require__("dH7R");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js + 2 modules
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2025380c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}))],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("nfGx")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613daa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("MUCD")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5bfd958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){_vm.$emit('on-click-left')}}},[_vm._t("left-text",[_vm._v(_vm._s(_vm.leftText))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){_vm.$emit('on-click-right')}}},[_vm._t("right-text",[_vm._v(_vm._s(_vm.rightText))])],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("Dm7L")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a333ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()],{labelClass:"weui-label",labelStyle:_vm.labelStyles,labelTitle:_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){_vm.onHide(false)},"on-click-right":function($event){_vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("rFhX")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56bdfb3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-address/index.vue
var x_address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-picker',{attrs:{"fixed-columns":_vm.hideDistrict ? 2 : 0,"columns":3,"data":_vm.list,"title":_vm.title,"show-name":"","inline-desc":_vm.inlineDesc,"placeholder":_vm.placeholder,"value-text-align":_vm.valueTextAlign,"confirm-text":_vm.confirmText,"cancel-text":_vm.cancelText,"display-format":_vm.displayFormat,"popup-style":_vm.popupStyle,"popup-title":_vm.popupTitle,"show":_vm.showValue,"disabled":_vm.disabled},on:{"update:show":function($event){_vm.showValue=$event},"on-shadow-change":_vm.onShadowChange,"on-hide":_vm.emitHide,"on-show":function($event){_vm.$emit('on-show')}},scopedSlots:_vm._u([{key:"title",fn:function(props){return [_vm._t("title",[(props.labelTitle)?_c('label',{class:[props.labelClass,_vm.labelClass],style:(props.labelStyle),domProps:{"innerHTML":_vm._s(props.labelTitle)}}):_vm._e()],{labelClass:props.labelClass,labelStyle:props.labelStyles,labelTitle:props.title})]}}]),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var x_address_staticRenderFns = []
var x_address_esExports = { render: x_address_render, staticRenderFns: x_address_staticRenderFns }
/* harmony default export */ var src_components_x_address = (x_address_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-address/index.vue
var x_address_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_address___vue_template_functional__ = false
/* styles */
var x_address___vue_styles__ = null
/* scopeId */
var x_address___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_address___vue_module_identifier__ = null
var x_address_Component = x_address_normalizeComponent(
  components_x_address,
  src_components_x_address,
  x_address___vue_template_functional__,
  x_address___vue_styles__,
  x_address___vue_scopeId__,
  x_address___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_address = (x_address_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myInfo.vue













/* harmony default export */ var myInfo = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    XAddress: vux_src_components_x_address,
    Checker: src_components_checker_checker,
    CheckIcon: vux_src_components_check_icon,
    CheckerItem: src_components_checker_checker_item
  },
  name: "myInfo",
  data: function data() {
    return {
      isReadonly: true,
      issue: false,
      invoiceType: 1,
      invoiceTitle: 2,
      invoice: {
        company: "",
        taxNumber: "",
        bank: "",
        bankAccount: "",
        address: "",
        tel: ""
      },
      type: "",
      addressData: china_address_v4_default.a,
      account: "",
      sequence: "",
      email: "",
      emobile: "",
      ename: "",
      etelephone: "",
      idcard: "",
      mobile: "",
      name: "",
      zipcode: "",
      address1: [],
      opid: "",
      address2: "",
      company: ''
    };
  },

  methods: {
    registerSubmit: function registerSubmit() {
      if (this.company === '') {
        alert('请填写工作单位');
        return;
      }
      if (this.issue) {
        if (this.invoiceTitle === 2) {
          if (this.invoice.company === "" || this.invoice.taxNumber === "") {
            this.$vux.alert.show({
              title: "",
              content: "请补全发票信息后再提交"
            });
            return;
          }
        }
        if (this.invoiceType === 2) {
          if (this.invoice.bank === "" || this.invoice.bankAccount === "" || this.invoice.address === "" || this.invoice.tel === "") {
            this.$vux.alert.show({
              title: "",
              content: "请补全发票信息后再提交"
            });
            return;
          }
        }
      }
      if (this.address1.length !== 3 || !this.address2) {
        this.$vux.alert.show({
          title: "",
          content: "请填写通讯地址"
        });
        return;
      }
      var address = Object(value2name["a" /* default */])(this.address1, china_address_v4_default.a);
      address = address.split(' ');
      var invoiceAll = {};
      if (this.issue) {
        if (this.invoiceType == 1) {
          this.invoice.bank = "";
          this.invoice.bankAccount = "";
          this.invoice.address = "";
          this.invoice.tel = "";
          this.type = "ValueAddedTaxInvoiceUnit";
          if (this.invoiceTitle == 1) {
            this.invoice.company = "";
            this.invoice.taxNumber = "";
            this.type = "ValueAddedTaxInvoiceOne";
          }
        } else {
          this.type = "VatSpecialInvoice";
        }
        invoiceAll = {
          "content": this.invoice,
          "type": this.type
        };
      } else {
        invoiceAll = {
          "content": null,
          "type": ''
        };
      }

      var userInfo = {
        sequence: this.sequence,
        email: this.email,
        emobile: this.emobile,
        ename: this.ename,
        etelephone: this.etelephone,
        idcard: this.idcard,
        mobile: this.mobile,
        name: this.name,
        zipcode: this.zipcode,
        company: this.company,
        province: address[0],
        city: address[1],
        district: address[2],
        daddress: this.address2,
        invoice: invoiceAll
      };
      var app = this;
      var obj = {
        headers: {
          token: localStorage.getItem("token"),
          opid: this.opid
        }
      };

      this.$vux.confirm.show({
        title: "",
        content: "修改信息需要重新进行审核,确认修改？",
        onConfirm: function onConfirm() {
          app.$http.put("/api/v1/users/" + app.opid, userInfo, obj).then(function (response) {
            app.$router.push({ 'name': 'vip' });
            app.$vux.toast.show({
              text: "修改成功",
              type: "success",
              time: "1000"
            });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data.error_message) {
                app.$vux.toast.show({
                  text: JSON.parse(error.response.data.error_message).zh_string,
                  type: "cancel",
                  time: "1000"
                });
              }
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log("Error", error.message);
            }
          });
        }
      });
    },
    getUserInfo: function getUserInfo(opid) {
      var app = this;
      var obj = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      this.$http.get("/api/v1/users/" + opid, obj).then(function (response) {
        if (response.data.detail) {
          app.name = response.data.detail.name;
          app.idcard = response.data.detail.idcard;
          app.mobile = response.data.detail.mobile;
          app.sequence = response.data.sequence;
          app.email = response.data.detail.email;
          app.emobile = response.data.detail.emobile;
          app.ename = response.data.detail.ename;
          app.etelephone = response.data.detail.etelephone;
          app.company = response.data.detail.company;
          app.address1 = [response.data.detail.province, response.data.detail.city, response.data.detail.district];
          app.address2 = response.data.detail.daddress;
          app.zipcode = response.data.detail.zipcode;
          if (response.data.detail.invoice && response.data.detail.invoice.content) {
            app.invoice = response.data.detail.invoice.content;
            app.type = response.data.detail.invoice.type;
            app.issue = true;
            if (response.data.detail.invoice.type === "VatSpecialInvoice") {
              app.invoiceType = 2;
            } else {
              app.invoiceType = 1;
              if (response.data.detail.invoice.type === "ValueAddedTaxInvoiceUnit") {
                app.invoiceTitle = 2;
              } else {
                app.invoiceTitle = 1;
              }
            }
          } else {
            app.issue = false;
          }
          if (response.data.detail.result !== 'APPROVED') {
            app.isReadonly = false;
          }
        }
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
      });
    }
  },
  created: function created() {

    this.opid = localStorage.getItem("userid");
    this.getUserInfo(this.opid);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myInfo.vue













/* harmony default export */ var components_myInfo = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    XAddress: vux_src_components_x_address,
    Checker: src_components_checker_checker,
    CheckIcon: vux_src_components_check_icon,
    CheckerItem: src_components_checker_checker_item
  },
  name: "myInfo",
  data: function data() {
    return {
      isReadonly: true,
      issue: false,
      invoiceType: 1,
      invoiceTitle: 2,
      invoice: {
        company: "",
        taxNumber: "",
        bank: "",
        bankAccount: "",
        address: "",
        tel: ""
      },
      type: "",
      addressData: china_address_v4_default.a,
      account: "",
      sequence: "",
      email: "",
      emobile: "",
      ename: "",
      etelephone: "",
      idcard: "",
      mobile: "",
      name: "",
      zipcode: "",
      address1: [],
      opid: "",
      address2: "",
      company: ''
    };
  },

  methods: {
    registerSubmit: function registerSubmit() {
      if (this.company === '') {
        alert('请填写工作单位');
        return;
      }
      if (this.issue) {
        if (this.invoiceTitle === 2) {
          if (this.invoice.company === "" || this.invoice.taxNumber === "") {
            this.$vux.alert.show({
              title: "",
              content: "请补全发票信息后再提交"
            });
            return;
          }
        }
        if (this.invoiceType === 2) {
          if (this.invoice.bank === "" || this.invoice.bankAccount === "" || this.invoice.address === "" || this.invoice.tel === "") {
            this.$vux.alert.show({
              title: "",
              content: "请补全发票信息后再提交"
            });
            return;
          }
        }
      }
      if (this.address1.length !== 3 || !this.address2) {
        this.$vux.alert.show({
          title: "",
          content: "请填写通讯地址"
        });
        return;
      }
      var address = Object(value2name["a" /* default */])(this.address1, china_address_v4_default.a);
      address = address.split(' ');
      var invoiceAll = {};
      if (this.issue) {
        if (this.invoiceType == 1) {
          this.invoice.bank = "";
          this.invoice.bankAccount = "";
          this.invoice.address = "";
          this.invoice.tel = "";
          this.type = "ValueAddedTaxInvoiceUnit";
          if (this.invoiceTitle == 1) {
            this.invoice.company = "";
            this.invoice.taxNumber = "";
            this.type = "ValueAddedTaxInvoiceOne";
          }
        } else {
          this.type = "VatSpecialInvoice";
        }
        invoiceAll = {
          "content": this.invoice,
          "type": this.type
        };
      } else {
        invoiceAll = {
          "content": null,
          "type": ''
        };
      }

      var userInfo = {
        sequence: this.sequence,
        email: this.email,
        emobile: this.emobile,
        ename: this.ename,
        etelephone: this.etelephone,
        idcard: this.idcard,
        mobile: this.mobile,
        name: this.name,
        zipcode: this.zipcode,
        company: this.company,
        province: address[0],
        city: address[1],
        district: address[2],
        daddress: this.address2,
        invoice: invoiceAll
      };
      var app = this;
      var obj = {
        headers: {
          token: localStorage.getItem("token"),
          opid: this.opid
        }
      };

      this.$vux.confirm.show({
        title: "",
        content: "修改信息需要重新进行审核,确认修改？",
        onConfirm: function onConfirm() {
          app.$http.put("/api/v1/users/" + app.opid, userInfo, obj).then(function (response) {
            app.$router.push({ 'name': 'vip' });
            app.$vux.toast.show({
              text: "修改成功",
              type: "success",
              time: "1000"
            });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data.error_message) {
                app.$vux.toast.show({
                  text: JSON.parse(error.response.data.error_message).zh_string,
                  type: "cancel",
                  time: "1000"
                });
              }
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log("Error", error.message);
            }
          });
        }
      });
    },
    getUserInfo: function getUserInfo(opid) {
      var app = this;
      var obj = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      this.$http.get("/api/v1/users/" + opid, obj).then(function (response) {
        if (response.data.detail) {
          app.name = response.data.detail.name;
          app.idcard = response.data.detail.idcard;
          app.mobile = response.data.detail.mobile;
          app.sequence = response.data.sequence;
          app.email = response.data.detail.email;
          app.emobile = response.data.detail.emobile;
          app.ename = response.data.detail.ename;
          app.etelephone = response.data.detail.etelephone;
          app.company = response.data.detail.company;
          app.address1 = [response.data.detail.province, response.data.detail.city, response.data.detail.district];
          app.address2 = response.data.detail.daddress;
          app.zipcode = response.data.detail.zipcode;
          if (response.data.detail.invoice && response.data.detail.invoice.content) {
            app.invoice = response.data.detail.invoice.content;
            app.type = response.data.detail.invoice.type;
            app.issue = true;
            if (response.data.detail.invoice.type === "VatSpecialInvoice") {
              app.invoiceType = 2;
            } else {
              app.invoiceType = 1;
              if (response.data.detail.invoice.type === "ValueAddedTaxInvoiceUnit") {
                app.invoiceTitle = 2;
              } else {
                app.invoiceTitle = 1;
              }
            }
          } else {
            app.issue = false;
          }
          if (response.data.detail.result !== 'APPROVED') {
            app.isReadonly = false;
          }
        }
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
      });
    }
  },
  created: function created() {

    this.opid = localStorage.getItem("userid");
    this.getUserInfo(this.opid);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4668f1d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myInfo.vue
var myInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('x-header',[_vm._v("个人信息")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"姓名*","type":"text","readonly":_vm.isReadonly},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身份证号码*","readonly":_vm.isReadonly},model:{value:(_vm.idcard),callback:function ($$v) {_vm.idcard=$$v},expression:"idcard"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手机号码*","readonly":_vm.isReadonly},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"工作单位*"},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"邮箱","type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('x-address',{attrs:{"title":"通讯地址*","raw-value":"","list":_vm.addressData,"value-text-align":"right","placeholder":"请选择省-市-区"},model:{value:(_vm.address1),callback:function ($$v) {_vm.address1=$$v},expression:"address1"}}),_vm._v(" "),_c('x-input',{ref:"input2",attrs:{"min":3,"type":"text","placeholder":"详细地址"},model:{value:(_vm.address2),callback:function ($$v) {_vm.address2=$$v},expression:"address2"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"邮编","type":"number","mask":"999999"},model:{value:(_vm.zipcode),callback:function ($$v) {_vm.zipcode=$$v},expression:"zipcode"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"紧急联系人*","required":""},model:{value:(_vm.ename),callback:function ($$v) {_vm.ename=$$v},expression:"ename"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"紧急联系人手机*","required":"","is-type":"china-mobile"},model:{value:(_vm.emobile),callback:function ($$v) {_vm.emobile=$$v},expression:"emobile"}}),_vm._v(" "),_c('x-input',{staticClass:"l1",attrs:{"title":"紧急联系人座机"},model:{value:(_vm.etelephone),callback:function ($$v) {_vm.etelephone=$$v},expression:"etelephone"}}),_vm._v(" "),_c('check-icon',{attrs:{"value":_vm.issue},on:{"update:value":function($event){_vm.issue=$event}}},[_vm._v("开具发票")]),_vm._v(" "),(_vm.issue)?_c('div',{staticStyle:{"padding":"15px"}},[_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("发票类型")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"type-check-item","selected-item-class":"check-item-selected"},model:{value:(_vm.invoiceType),callback:function ($$v) {_vm.invoiceType=$$v},expression:"invoiceType"}},[_c('checker-item',{attrs:{"value":1}},[_vm._v("增值税普通发票")]),_vm._v(" "),_c('checker-item',{attrs:{"value":2}},[_vm._v("增值税专用发票")])],1),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("发票抬头")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"title-check-item","selected-item-class":"check-item-selected"},model:{value:(_vm.invoiceTitle),callback:function ($$v) {_vm.invoiceTitle=$$v},expression:"invoiceTitle"}},[(_vm.invoiceType == 1)?_c('checker-item',{attrs:{"value":1}},[_vm._v("个人")]):_vm._e(),_vm._v(" "),_c('checker-item',{attrs:{"value":2}},[_vm._v("单位")])],1),_vm._v(" "),(_vm.invoiceTitle == 2)?_c('group',[_c('x-input',{attrs:{"title":"单位名称","type":"text","required":""},model:{value:(_vm.invoice.company),callback:function ($$v) {_vm.$set(_vm.invoice, "company", $$v)},expression:"invoice.company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"纳税人识别号","type":"text","required":""},model:{value:(_vm.invoice.taxNumber),callback:function ($$v) {_vm.$set(_vm.invoice, "taxNumber", $$v)},expression:"invoice.taxNumber"}}),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"开户银行","type":"text","required":""},model:{value:(_vm.invoice.bank),callback:function ($$v) {_vm.$set(_vm.invoice, "bank", $$v)},expression:"invoice.bank"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"账号","type":"number","required":""},model:{value:(_vm.invoice.bankAccount),callback:function ($$v) {_vm.$set(_vm.invoice, "bankAccount", $$v)},expression:"invoice.bankAccount"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"地址","type":"text","required":""},model:{value:(_vm.invoice.address),callback:function ($$v) {_vm.$set(_vm.invoice, "address", $$v)},expression:"invoice.address"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"电话","type":"tel","required":""},model:{value:(_vm.invoice.tel),callback:function ($$v) {_vm.$set(_vm.invoice, "tel", $$v)},expression:"invoice.tel"}}):_vm._e()],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.registerSubmit($event)}}},[_vm._v("修改个人信息")])],1)}
var myInfo_staticRenderFns = []
var myInfo_esExports = { render: myInfo_render, staticRenderFns: myInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_myInfo = (myInfo_esExports);
// CONCATENATED MODULE: ./src/components/myInfo.vue
function myInfo_injectStyle (ssrContext) {
  __webpack_require__("j+UX")
}
var myInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myInfo___vue_template_functional__ = false
/* styles */
var myInfo___vue_styles__ = myInfo_injectStyle
/* scopeId */
var myInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var myInfo___vue_module_identifier__ = null
var myInfo_Component = myInfo_normalizeComponent(
  components_myInfo,
  selectortype_template_index_0_src_components_myInfo,
  myInfo___vue_template_functional__,
  myInfo___vue_styles__,
  myInfo___vue_scopeId__,
  myInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_myInfo = (myInfo_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid_grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64c838ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid.vue
var grid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var grid_staticRenderFns = []
var grid_esExports = { render: grid_render, staticRenderFns: grid_staticRenderFns }
/* harmony default export */ var components_grid_grid = (grid_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid.vue
function grid_injectStyle (ssrContext) {
  __webpack_require__("e6ed")
}
var grid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid___vue_template_functional__ = false
/* styles */
var grid___vue_styles__ = grid_injectStyle
/* scopeId */
var grid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid___vue_module_identifier__ = null
var grid_Component = grid_normalizeComponent(
  grid_grid,
  components_grid_grid,
  grid___vue_template_functional__,
  grid___vue_styles__,
  grid___vue_scopeId__,
  grid___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid = (grid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["b" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["b" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d50a10c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid-item.vue
var grid_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-grid",class:{
    'vux-grid-item-no-border': (_vm.isLast && !_vm.$parent.showLrBorders) || (!_vm.isLast && !_vm.$parent.showVerticalDividers),
  },style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.hasIconSlot || _vm.icon)?_c('div',{staticClass:"weui-grid__icon"},[_vm._t("icon",[_c('img',{attrs:{"src":_vm.icon,"alt":""}})])],2):_vm._e(),_vm._v(" "),(_vm.hasLabelSlot || _vm.label)?_c('p',{staticClass:"weui-grid__label"},[_vm._t("label",[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var grid_item_staticRenderFns = []
var grid_item_esExports = { render: grid_item_render, staticRenderFns: grid_item_staticRenderFns }
/* harmony default export */ var components_grid_grid_item = (grid_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid-item.vue
function grid_item_injectStyle (ssrContext) {
  __webpack_require__("X9XN")
}
var grid_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid_item___vue_template_functional__ = false
/* styles */
var grid_item___vue_styles__ = grid_item_injectStyle
/* scopeId */
var grid_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid_item___vue_module_identifier__ = null
var grid_item_Component = grid_item_normalizeComponent(
  grid_grid_item,
  components_grid_grid_item,
  grid_item___vue_template_functional__,
  grid_item___vue_styles__,
  grid_item___vue_scopeId__,
  grid_item___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid_item = (grid_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e221904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group-title/index.vue
var group_title_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells__title"},[_vm._t("default")],2)}
var group_title_staticRenderFns = []
var group_title_esExports = { render: group_title_render, staticRenderFns: group_title_staticRenderFns }
/* harmony default export */ var src_components_group_title = (group_title_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group-title/index.vue
function group_title_injectStyle (ssrContext) {
  __webpack_require__("DC2r")
}
var group_title_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group_title___vue_template_functional__ = false
/* styles */
var group_title___vue_styles__ = group_title_injectStyle
/* scopeId */
var group_title___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group_title___vue_module_identifier__ = null
var group_title_Component = group_title_normalizeComponent(
  components_group_title,
  src_components_group_title,
  group_title___vue_template_functional__,
  group_title___vue_styles__,
  group_title___vue_scopeId__,
  group_title___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group_title = (group_title_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b3ed8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-switch/index.vue
var x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-switch weui-cell weui-cell_switch"},[_c('div',{staticClass:"weui-cell__bd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),(_vm.preventDefault)?_c('div',{staticClass:"vux-x-switch-overlay",on:{"click":_vm.onClick}}):_vm._e()])])}
var x_switch_staticRenderFns = []
var x_switch_esExports = { render: x_switch_render, staticRenderFns: x_switch_staticRenderFns }
/* harmony default export */ var src_components_x_switch = (x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-switch/index.vue
function x_switch_injectStyle (ssrContext) {
  __webpack_require__("NxQa")
}
var x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_switch___vue_template_functional__ = false
/* styles */
var x_switch___vue_styles__ = x_switch_injectStyle
/* scopeId */
var x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_switch___vue_module_identifier__ = null
var x_switch_Component = x_switch_normalizeComponent(
  components_x_switch,
  src_components_x_switch,
  x_switch___vue_template_functional__,
  x_switch___vue_styles__,
  x_switch___vue_scopeId__,
  x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_switch = (x_switch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/expertInfo.vue




















/* harmony default export */ var expertInfo = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    XSwitch: vux_src_components_x_switch,
    XAddress: vux_src_components_x_address
  },
  name: "expertInfo",
  data: function data() {
    return {
      isReadonly: true,
      save_company: '',
      expertInfo: { visible: null },
      eduList: [{ key: 1, value: "博士研究生" }, { key: 2, value: "硕士研究生" }, { key: 3, value: "本科" }, { key: 4, value: "专科" }, { key: 5, value: "其他" }],
      addressData: china_address_v4_default.a,
      showAddress: false,
      address1: [],
      address2: "",
      result: "",
      isShow: false,
      strInfo: "",
      visiable: 0
    };
  },

  methods: {
    modifyInfo: function modifyInfo() {
      var _this = this;

      if (!this.$refs.input1.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写邮箱地址"
        });
        return;
      }
      if (!this.$refs.input2.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写详细地址"
        });
        return;
      }
      if (!this.$refs.input3.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写邮编"
        });
        return;
      }
      if (!this.$refs.input4.valid || !this.$refs.input5.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写紧急联系人信息"
        });
        return;
      }
      if (!this.$refs.input7.valid || !this.$refs.input8.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写现就职公司信息"
        });
        return;
      }
      if (this.address1.length !== 3 || !this.address2) {
        this.$vux.alert.show({
          title: "",
          content: "请填写通讯地址"
        });
        return;
      }
      var address = Object(value2name["a" /* default */])(this.address1, china_address_v4_default.a);
      address = address.split(' ');
      if (this.$refs.input1.valid && this.$refs.input2.valid && this.$refs.input3.valid && this.$refs.input4.valid && this.$refs.input5.valid && this.$refs.input6.valid && this.$refs.input7.valid && this.$refs.input8.valid) {
        if (this.expertInfo.idphoto.origin && this.expertInfo.idphoto2.origin) {
          this.expertInfo.province = address[0];
          this.expertInfo.city = address[1];
          this.expertInfo.district = address[2];
          this.expertInfo.daddress = this.address2;
          delete this.expertInfo.address1;
          delete this.expertInfo.address2;
          var userInfo = extends_default()({}, this.expertInfo);
          delete userInfo.result;
          delete userInfo.advice;
          delete userInfo.first;
          var app = this;
          var opid = localStorage.getItem("userid");
          var obj = {
            headers: {
              token: localStorage.getItem("token"),
              opid: opid
            }
          };
          if (!userInfo.visible) {
            if (app.save_company && app.save_company !== 'undefined' && app.save_company !== userInfo.company) {
              app.$vux.confirm.show({
                title: '',
                content: '当前已设置为公司不可见本账户，是否开启可见？',
                onConfirm: function onConfirm() {
                  app.$http.put("/api/v1/experts/" + opid + "/visible", { visible: 'yes' }, obj).then(function (res) {
                    app.updateInfo(opid, userInfo, obj);
                  }).catch(function (error) {
                    if (error.response.data.error_message) {
                      _this.$vux.alert.show({
                        title: "",
                        content: JSON.parse(error.response.data.error_message).zh_string
                      });
                    }
                  });
                },
                onCancel: function onCancel() {
                  app.updateInfo(opid, userInfo, obj);
                }
              });
            } else {
              app.updateInfo(opid, userInfo, obj);
            }
          } else {
            if (app.save_company && app.save_company !== 'undefined' && app.save_company !== userInfo.company) {
              app.$vux.confirm.show({
                title: '',
                content: '账户已被' + app.save_company + '绑定，修改后将取消绑定关系',
                onConfirm: function onConfirm() {
                  app.updateInfo(opid, userInfo, obj);
                },
                onCancel: function onCancel() {}
              });
            } else {
              app.updateInfo(opid, userInfo, obj);
            }
          }
        } else {
          this.$vux.alert.show({
            title: "",
            content: "请上传身份证信息"
          });
        }
      } else {
        this.$refs.input1.focus();
        this.$refs.input1.blur();
        this.$refs.input2.focus();
        this.$refs.input2.blur();
        this.$refs.input3.focus();
        this.$refs.input3.blur();
        this.$refs.input4.focus();
        this.$refs.input4.blur();
        this.$refs.input5.focus();
        this.$refs.input5.blur();
        this.$refs.input6.focus();
        this.$refs.input6.blur();
        this.$refs.input7.focus();
        this.$refs.input7.blur();
        this.$refs.input8.focus();
        this.$refs.input8.blur();
        this.$vux.alert.show({
          title: "",
          content: "输入信息有误"
        });
      }
    },
    updateInfo: function updateInfo(opid, userInfo, obj) {
      var _this2 = this;

      if (this.expertInfo.result === 'TO_BE_APPROVE') {
        this.updateExpt(opid, userInfo, obj);
      } else {
        this.$vux.confirm.show({
          title: "",
          content: "修改信息需要重新进行审核,将会影响接单等功能,确认修改？",
          onConfirm: function onConfirm() {
            _this2.updateExpt(opid, userInfo, obj);
          }
        });
      }
    },
    updateExpt: function updateExpt(opid, userInfo, obj) {
      var _this3 = this;

      this.$http.put("/api/v1/experts/" + opid, userInfo, obj).then(function (response) {
        _this3.$router.push({ name: "vip" });
        _this3.$vux.loading.hide();
        _this3.$vux.toast.show({
          text: "信息修改成功",
          type: "success",
          time: "1000"
        });
      }).catch(function (error) {
        if (error.response) {
          _this3.$vux.loading.hide();
          if (error.response.data.error_message) {
            _this3.$vux.alert.show({
              title: "",
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          } else {
            _this3.$vux.alert.show({
              title: "",
              content: "服务器错误，请稍后重试"
            });
          }
        } else if (error.request) {
          _this3.$vux.loading.hide();
          _this3.$vux.alert.show({
            title: "",
            content: "服务器错误，请稍后重试"
          });
          console.log(error.request);
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.alert.show({
            title: "",
            content: "服务器错误，请稍后重试"
          });
          console.log("Error", error.message);
        }
      });
    },
    updateVisible: function updateVisible() {
      if (this.expertInfo.first) {
        this.expertInfo.first = false;
        return;
      }
      var opid = localStorage.getItem("userid");
      var head = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      this.isShow = true;
      var visible = "";
      if (this.visiable !== 0) {
        this.visiable = 1;
        if (this.expertInfo.visible) {
          visible = "yes";
          this.strInfo = "已设置可见";
        } else {
          visible = "no";
          this.strInfo = "已设置不可见";
        }
        this.$http.put("/api/v1/experts/" + opid + "/visible", { visible: visible }, head).then(function (res) {});
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === "workExp" || to.name === "idPhoto" || to.name === "eduPhoto" || to.name === "skillPhoto" || to.name === "skill") {
      if (this.address1.length !== 3) {
        this.expertInfo.address1 = [];
      } else {
        this.expertInfo.address1 = stringify_default()(this.address1);
      }
      this.expertInfo.address2 = this.address2;
      var expertdata = stringify_default()(this.expertInfo);
      localStorage.setItem("expertdata", expertdata);
      localStorage.setItem('save_company', this.save_company);
    } else {
      localStorage.removeItem("expertdata");
      localStorage.removeItem('save_company');
    }
    localStorage.setItem('result', this.expertInfo.result);
    next();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === "workExp" || from.name === "idPhoto" || from.name === "eduPhoto" || from.name === "skillPhoto" || from.name === "skill") {
      var expertdata = localStorage.getItem("expertdata");
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        var result = "";
        switch (data.result) {
          case "TO_BE_APPROVE":
            result = "待审核";
            break;
          case "APPROVED":
            result = "审核通过";
            break;
          case "REJECTED":
            result = "审核未通过";
            break;
        }
        next(function (vm) {
          vm.expertInfo = data;
          vm.expertInfo.first = true;
          vm.save_company = localStorage.getItem('save_company');
          if (data.result !== 'APPROVED') {
            vm.isReadonly = false;
          }
          vm.result = result;
          vm.address1 = vm.expertInfo.address1 ? JSON.parse(vm.expertInfo.address1).length === 3 ? JSON.parse(vm.expertInfo.address1) : JSON.parse(vm.expertInfo.address1) : [];
          vm.address2 = vm.expertInfo.address2;
        });
      }
    } else {
      var opid = localStorage.getItem("userid");
      var obj = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      if (opid != null) {
        var url = "/api/v1/experts/";
        ajax["a" /* default */].$http.get(url + opid, obj).then(function (response) {
          if (response.data.detail) {
            var userinfo = {};
            userinfo.account = response.data.account;
            userinfo.sequence = response.data.sequence;
            userinfo.idcard = response.data.detail.idcard;
            userinfo.name = response.data.detail.name;
            userinfo.mobile = response.data.detail.mobile;
            userinfo.email = response.data.detail.email;
            userinfo.education = response.data.detail.education;
            userinfo.address = response.data.detail.address;

            userinfo.zipcode = response.data.detail.zipcode;
            userinfo.ename = response.data.detail.ename;
            userinfo.emobile = response.data.detail.emobile;
            userinfo.etelephone = response.data.detail.etelephone;
            userinfo.company = response.data.detail.company;

            userinfo.contact = response.data.detail.contact;
            userinfo.experience = response.data.detail.experience;
            userinfo.speciality = response.data.detail.speciality;
            userinfo.idphoto = response.data.detail.idphoto;
            userinfo.idphoto2 = response.data.detail.idphoto2;
            userinfo.eduphoto = response.data.detail.eduphoto;
            userinfo.diploma = response.data.detail.diploma;
            userinfo.skillphoto = response.data.detail.skillphoto;
            userinfo.result = response.data.detail.result;
            userinfo.advice = response.data.detail.advice;
            userinfo.memberof = response.data.detail.memberof;
            userinfo.visible = response.data.detail.visible;
            userinfo.first = response.data.detail.visible;
            var result = "";
            switch (response.data.detail.result) {
              case "TO_BE_APPROVE":
                result = "待审核";
                break;
              case "APPROVED":
                result = "审核通过";
                break;
              case "REJECTED":
                result = "审核未通过";
                break;
            }
            localStorage.removeItem("expertdata");
            next(function (vm) {
              vm.expertInfo = userinfo;
              vm.address1 = [response.data.detail.province, response.data.detail.city, response.data.detail.district];
              vm.address2 = response.data.detail.daddress;
              if (userinfo.result !== 'APPROVED') {
                vm.isReadonly = false;
              }
              vm.result = result;
              vm.save_company = response.data.detail.memberof;
              vm.visiable = response.data.detail.visible;
            });
          }
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/expertInfo.vue




















/* harmony default export */ var components_expertInfo = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    XSwitch: vux_src_components_x_switch,
    XAddress: vux_src_components_x_address
  },
  name: "expertInfo",
  data: function data() {
    return {
      isReadonly: true,
      save_company: '',
      expertInfo: { visible: null },
      eduList: [{ key: 1, value: "博士研究生" }, { key: 2, value: "硕士研究生" }, { key: 3, value: "本科" }, { key: 4, value: "专科" }, { key: 5, value: "其他" }],
      addressData: china_address_v4_default.a,
      showAddress: false,
      address1: [],
      address2: "",
      result: "",
      isShow: false,
      strInfo: "",
      visiable: 0
    };
  },

  methods: {
    modifyInfo: function modifyInfo() {
      var _this = this;

      if (!this.$refs.input1.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写邮箱地址"
        });
        return;
      }
      if (!this.$refs.input2.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写详细地址"
        });
        return;
      }
      if (!this.$refs.input3.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写邮编"
        });
        return;
      }
      if (!this.$refs.input4.valid || !this.$refs.input5.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写紧急联系人信息"
        });
        return;
      }
      if (!this.$refs.input7.valid || !this.$refs.input8.valid) {
        this.$vux.alert.show({
          title: "",
          content: "请填写现就职公司信息"
        });
        return;
      }
      if (this.address1.length !== 3 || !this.address2) {
        this.$vux.alert.show({
          title: "",
          content: "请填写通讯地址"
        });
        return;
      }
      var address = Object(value2name["a" /* default */])(this.address1, china_address_v4_default.a);
      address = address.split(' ');
      if (this.$refs.input1.valid && this.$refs.input2.valid && this.$refs.input3.valid && this.$refs.input4.valid && this.$refs.input5.valid && this.$refs.input6.valid && this.$refs.input7.valid && this.$refs.input8.valid) {
        if (this.expertInfo.idphoto.origin && this.expertInfo.idphoto2.origin) {
          this.expertInfo.province = address[0];
          this.expertInfo.city = address[1];
          this.expertInfo.district = address[2];
          this.expertInfo.daddress = this.address2;
          delete this.expertInfo.address1;
          delete this.expertInfo.address2;
          var userInfo = extends_default()({}, this.expertInfo);
          delete userInfo.result;
          delete userInfo.advice;
          delete userInfo.first;
          var app = this;
          var opid = localStorage.getItem("userid");
          var obj = {
            headers: {
              token: localStorage.getItem("token"),
              opid: opid
            }
          };
          if (!userInfo.visible) {
            if (app.save_company && app.save_company !== 'undefined' && app.save_company !== userInfo.company) {
              app.$vux.confirm.show({
                title: '',
                content: '当前已设置为公司不可见本账户，是否开启可见？',
                onConfirm: function onConfirm() {
                  app.$http.put("/api/v1/experts/" + opid + "/visible", { visible: 'yes' }, obj).then(function (res) {
                    app.updateInfo(opid, userInfo, obj);
                  }).catch(function (error) {
                    if (error.response.data.error_message) {
                      _this.$vux.alert.show({
                        title: "",
                        content: JSON.parse(error.response.data.error_message).zh_string
                      });
                    }
                  });
                },
                onCancel: function onCancel() {
                  app.updateInfo(opid, userInfo, obj);
                }
              });
            } else {
              app.updateInfo(opid, userInfo, obj);
            }
          } else {
            if (app.save_company && app.save_company !== 'undefined' && app.save_company !== userInfo.company) {
              app.$vux.confirm.show({
                title: '',
                content: '账户已被' + app.save_company + '绑定，修改后将取消绑定关系',
                onConfirm: function onConfirm() {
                  app.updateInfo(opid, userInfo, obj);
                },
                onCancel: function onCancel() {}
              });
            } else {
              app.updateInfo(opid, userInfo, obj);
            }
          }
        } else {
          this.$vux.alert.show({
            title: "",
            content: "请上传身份证信息"
          });
        }
      } else {
        this.$refs.input1.focus();
        this.$refs.input1.blur();
        this.$refs.input2.focus();
        this.$refs.input2.blur();
        this.$refs.input3.focus();
        this.$refs.input3.blur();
        this.$refs.input4.focus();
        this.$refs.input4.blur();
        this.$refs.input5.focus();
        this.$refs.input5.blur();
        this.$refs.input6.focus();
        this.$refs.input6.blur();
        this.$refs.input7.focus();
        this.$refs.input7.blur();
        this.$refs.input8.focus();
        this.$refs.input8.blur();
        this.$vux.alert.show({
          title: "",
          content: "输入信息有误"
        });
      }
    },
    updateInfo: function updateInfo(opid, userInfo, obj) {
      var _this2 = this;

      if (this.expertInfo.result === 'TO_BE_APPROVE') {
        this.updateExpt(opid, userInfo, obj);
      } else {
        this.$vux.confirm.show({
          title: "",
          content: "修改信息需要重新进行审核,将会影响接单等功能,确认修改？",
          onConfirm: function onConfirm() {
            _this2.updateExpt(opid, userInfo, obj);
          }
        });
      }
    },
    updateExpt: function updateExpt(opid, userInfo, obj) {
      var _this3 = this;

      this.$http.put("/api/v1/experts/" + opid, userInfo, obj).then(function (response) {
        _this3.$router.push({ name: "vip" });
        _this3.$vux.loading.hide();
        _this3.$vux.toast.show({
          text: "信息修改成功",
          type: "success",
          time: "1000"
        });
      }).catch(function (error) {
        if (error.response) {
          _this3.$vux.loading.hide();
          if (error.response.data.error_message) {
            _this3.$vux.alert.show({
              title: "",
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          } else {
            _this3.$vux.alert.show({
              title: "",
              content: "服务器错误，请稍后重试"
            });
          }
        } else if (error.request) {
          _this3.$vux.loading.hide();
          _this3.$vux.alert.show({
            title: "",
            content: "服务器错误，请稍后重试"
          });
          console.log(error.request);
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.alert.show({
            title: "",
            content: "服务器错误，请稍后重试"
          });
          console.log("Error", error.message);
        }
      });
    },
    updateVisible: function updateVisible() {
      if (this.expertInfo.first) {
        this.expertInfo.first = false;
        return;
      }
      var opid = localStorage.getItem("userid");
      var head = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      this.isShow = true;
      var visible = "";
      if (this.visiable !== 0) {
        this.visiable = 1;
        if (this.expertInfo.visible) {
          visible = "yes";
          this.strInfo = "已设置可见";
        } else {
          visible = "no";
          this.strInfo = "已设置不可见";
        }
        this.$http.put("/api/v1/experts/" + opid + "/visible", { visible: visible }, head).then(function (res) {});
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === "workExp" || to.name === "idPhoto" || to.name === "eduPhoto" || to.name === "skillPhoto" || to.name === "skill") {
      if (this.address1.length !== 3) {
        this.expertInfo.address1 = [];
      } else {
        this.expertInfo.address1 = stringify_default()(this.address1);
      }
      this.expertInfo.address2 = this.address2;
      var expertdata = stringify_default()(this.expertInfo);
      localStorage.setItem("expertdata", expertdata);
      localStorage.setItem('save_company', this.save_company);
    } else {
      localStorage.removeItem("expertdata");
      localStorage.removeItem('save_company');
    }
    localStorage.setItem('result', this.expertInfo.result);
    next();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === "workExp" || from.name === "idPhoto" || from.name === "eduPhoto" || from.name === "skillPhoto" || from.name === "skill") {
      var expertdata = localStorage.getItem("expertdata");
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        var result = "";
        switch (data.result) {
          case "TO_BE_APPROVE":
            result = "待审核";
            break;
          case "APPROVED":
            result = "审核通过";
            break;
          case "REJECTED":
            result = "审核未通过";
            break;
        }
        next(function (vm) {
          vm.expertInfo = data;
          vm.expertInfo.first = true;
          vm.save_company = localStorage.getItem('save_company');
          if (data.result !== 'APPROVED') {
            vm.isReadonly = false;
          }
          vm.result = result;
          vm.address1 = vm.expertInfo.address1 ? JSON.parse(vm.expertInfo.address1).length === 3 ? JSON.parse(vm.expertInfo.address1) : JSON.parse(vm.expertInfo.address1) : [];
          vm.address2 = vm.expertInfo.address2;
        });
      }
    } else {
      var opid = localStorage.getItem("userid");
      var obj = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      if (opid != null) {
        var url = "/api/v1/experts/";
        ajax["a" /* default */].$http.get(url + opid, obj).then(function (response) {
          if (response.data.detail) {
            var userinfo = {};
            userinfo.account = response.data.account;
            userinfo.sequence = response.data.sequence;
            userinfo.idcard = response.data.detail.idcard;
            userinfo.name = response.data.detail.name;
            userinfo.mobile = response.data.detail.mobile;
            userinfo.email = response.data.detail.email;
            userinfo.education = response.data.detail.education;
            userinfo.address = response.data.detail.address;

            userinfo.zipcode = response.data.detail.zipcode;
            userinfo.ename = response.data.detail.ename;
            userinfo.emobile = response.data.detail.emobile;
            userinfo.etelephone = response.data.detail.etelephone;
            userinfo.company = response.data.detail.company;

            userinfo.contact = response.data.detail.contact;
            userinfo.experience = response.data.detail.experience;
            userinfo.speciality = response.data.detail.speciality;
            userinfo.idphoto = response.data.detail.idphoto;
            userinfo.idphoto2 = response.data.detail.idphoto2;
            userinfo.eduphoto = response.data.detail.eduphoto;
            userinfo.diploma = response.data.detail.diploma;
            userinfo.skillphoto = response.data.detail.skillphoto;
            userinfo.result = response.data.detail.result;
            userinfo.advice = response.data.detail.advice;
            userinfo.memberof = response.data.detail.memberof;
            userinfo.visible = response.data.detail.visible;
            userinfo.first = response.data.detail.visible;
            var result = "";
            switch (response.data.detail.result) {
              case "TO_BE_APPROVE":
                result = "待审核";
                break;
              case "APPROVED":
                result = "审核通过";
                break;
              case "REJECTED":
                result = "审核未通过";
                break;
            }
            localStorage.removeItem("expertdata");
            next(function (vm) {
              vm.expertInfo = userinfo;
              vm.address1 = [response.data.detail.province, response.data.detail.city, response.data.detail.district];
              vm.address2 = response.data.detail.daddress;
              if (userinfo.result !== 'APPROVED') {
                vm.isReadonly = false;
              }
              vm.result = result;
              vm.save_company = response.data.detail.memberof;
              vm.visiable = response.data.detail.visible;
            });
          }
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-400383f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/expertInfo.vue
var expertInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("个人专家")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"姓名*","type":"text","readonly":_vm.isReadonly},model:{value:(_vm.expertInfo.name),callback:function ($$v) {_vm.$set(_vm.expertInfo, "name", $$v)},expression:"expertInfo.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身份证号码*","readonly":_vm.isReadonly},model:{value:(_vm.expertInfo.idcard),callback:function ($$v) {_vm.$set(_vm.expertInfo, "idcard", $$v)},expression:"expertInfo.idcard"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手机号码*","readonly":_vm.isReadonly},model:{value:(_vm.expertInfo.mobile),callback:function ($$v) {_vm.$set(_vm.expertInfo, "mobile", $$v)},expression:"expertInfo.mobile"}}),_vm._v(" "),_c('cell',{attrs:{"title":('本人身份证照片*'),"is-link":"","link":{ name: 'idPhoto' }}}),_vm._v(" "),_c('selector',{attrs:{"title":"学历","placeholder":"请选择学历","options":_vm.eduList},model:{value:(_vm.expertInfo.education ),callback:function ($$v) {_vm.$set(_vm.expertInfo, "education", $$v)},expression:"expertInfo.education "}}),_vm._v(" "),_c('cell',{attrs:{"title":('学历及学位照片'),"is-link":"","link":{ name: 'eduPhoto' }}}),_vm._v(" "),_c('x-input',{ref:"input1",attrs:{"title":"邮箱","is-type":"email","show-clear":false},model:{value:(_vm.expertInfo.email),callback:function ($$v) {_vm.$set(_vm.expertInfo, "email", $$v)},expression:"expertInfo.email"}}),_vm._v(" "),_c('x-address',{attrs:{"title":"通讯地址*","raw-value":"","list":_vm.addressData,"value-text-align":"right","placeholder":"请选择省-市-区"},model:{value:(_vm.address1),callback:function ($$v) {_vm.address1=$$v},expression:"address1"}}),_vm._v(" "),_c('x-input',{ref:"input2",attrs:{"min":3,"type":"text","show-clear":false,"placeholder":"详细地址"},model:{value:(_vm.address2),callback:function ($$v) {_vm.address2=$$v},expression:"address2"}}),_vm._v(" "),_c('x-input',{ref:"input3",attrs:{"title":"邮编","min":6,"max":6,"type":"number","show-clear":false},model:{value:(_vm.expertInfo.zipcode),callback:function ($$v) {_vm.$set(_vm.expertInfo, "zipcode", $$v)},expression:"expertInfo.zipcode"}}),_vm._v(" "),_c('x-input',{ref:"input7",attrs:{"title":"现就职公司*","type":"text","min":3,"show-clear":false,"required":""},model:{value:(_vm.expertInfo.company),callback:function ($$v) {_vm.$set(_vm.expertInfo, "company", $$v)},expression:"expertInfo.company"}}),_vm._v(" "),_c('x-input',{ref:"input8",attrs:{"title":"任职公司联系方式","type":"tel","show-clear":false},model:{value:(_vm.expertInfo.contact),callback:function ($$v) {_vm.$set(_vm.expertInfo, "contact", $$v)},expression:"expertInfo.contact"}}),_vm._v(" "),_c('cell',{attrs:{"title":('主要工作经历'),"is-link":"","link":{ name: 'workExp' }}}),_vm._v(" "),_c('cell',{attrs:{"title":('个人专业特长'),"is-link":"","link":{ name: 'skill' }}}),_vm._v(" "),_c('cell',{attrs:{"title":('技能证书照片'),"is-link":"","link":{ name: 'skillPhoto' }}}),_vm._v(" "),_c('x-input',{attrs:{"title":"审核结果","type":"text","readonly":""},model:{value:(_vm.result),callback:function ($$v) {_vm.result=$$v},expression:"result"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"审核意见","type":"text","readonly":""},model:{value:(_vm.expertInfo.advice),callback:function ($$v) {_vm.$set(_vm.expertInfo, "advice", $$v)},expression:"expertInfo.advice"}}),_vm._v(" "),_c('x-input',{ref:"input4",attrs:{"title":"紧急联系人*","show-clear":false,"required":""},model:{value:(_vm.expertInfo.ename),callback:function ($$v) {_vm.$set(_vm.expertInfo, "ename", $$v)},expression:"expertInfo.ename"}}),_vm._v(" "),_c('x-input',{ref:"input5",attrs:{"title":"紧急联系人手机*","is-type":"china-mobile","show-clear":false,"required":""},model:{value:(_vm.expertInfo.emobile),callback:function ($$v) {_vm.$set(_vm.expertInfo, "emobile", $$v)},expression:"expertInfo.emobile"}}),_vm._v(" "),_c('x-input',{ref:"input6",attrs:{"title":"紧急联系人座机","type":"tel","show-clear":false},model:{value:(_vm.expertInfo.etelephone),callback:function ($$v) {_vm.$set(_vm.expertInfo, "etelephone", $$v)},expression:"expertInfo.etelephone"}}),_vm._v(" "),_c('x-switch',{attrs:{"title":"账户信息是否允许公司可见"},on:{"on-change":function($event){_vm.updateVisible()}},model:{value:(_vm.expertInfo.visible),callback:function ($$v) {_vm.$set(_vm.expertInfo, "visible", $$v)},expression:"expertInfo.visible"}}),_vm._v(" "),_c('toast',{attrs:{"type":"text","text":_vm.strInfo},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"当前所属服务商","readonly":""},model:{value:(_vm.expertInfo.memberof),callback:function ($$v) {_vm.$set(_vm.expertInfo, "memberof", $$v)},expression:"expertInfo.memberof"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.modifyInfo($event)}}},[_vm._v("保存信息")])],1)}
var expertInfo_staticRenderFns = []
var expertInfo_esExports = { render: expertInfo_render, staticRenderFns: expertInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_expertInfo = (expertInfo_esExports);
// CONCATENATED MODULE: ./src/components/expertInfo.vue
var expertInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var expertInfo___vue_template_functional__ = false
/* styles */
var expertInfo___vue_styles__ = null
/* scopeId */
var expertInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var expertInfo___vue_module_identifier__ = null
var expertInfo_Component = expertInfo_normalizeComponent(
  components_expertInfo,
  selectortype_template_index_0_src_components_expertInfo,
  expertInfo___vue_template_functional__,
  expertInfo___vue_styles__,
  expertInfo___vue_scopeId__,
  expertInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_expertInfo = (expertInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af8ca20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/form-preview/index.vue
var form_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-form-preview weui-form-preview"},[_c('div',{staticClass:"weui-form-preview__hd"},[_c('label',{staticClass:"weui-form-preview__label",domProps:{"innerHTML":_vm._s(_vm.headerLabel)}}),_vm._v(" "),_c('em',{staticClass:"weui-form-preview__value",domProps:{"innerHTML":_vm._s(_vm.headerValue || '&nbsp;')}})]),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__bd"},_vm._l((_vm.bodyItems),function(item){return _c('div',{staticClass:"weui-form-preview__item"},[_c('label',{staticClass:"weui-form-preview__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticClass:"weui-form-preview__value"},[_vm._v(_vm._s(item.value))])])})),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__ft"},_vm._l((_vm.footerButtons),function(button){return _c('a',{staticClass:"weui-form-preview__btn",class:{'weui-form-preview__btn_default': button.style==='default', 'weui-form-preview__btn_primary': button.style === 'primary'},attrs:{"href":"javascript:"},on:{"click":function($event){_vm.onButtonClick(button.onButtonClick, button.link)}}},[_vm._v(_vm._s(button.text))])}))])}
var form_preview_staticRenderFns = []
var form_preview_esExports = { render: form_preview_render, staticRenderFns: form_preview_staticRenderFns }
/* harmony default export */ var src_components_form_preview = (form_preview_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/form-preview/index.vue
function form_preview_injectStyle (ssrContext) {
  __webpack_require__("ApxZ")
}
var form_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var form_preview___vue_template_functional__ = false
/* styles */
var form_preview___vue_styles__ = form_preview_injectStyle
/* scopeId */
var form_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var form_preview___vue_module_identifier__ = null
var form_preview_Component = form_preview_normalizeComponent(
  components_form_preview,
  src_components_form_preview,
  form_preview___vue_template_functional__,
  form_preview___vue_styles__,
  form_preview___vue_scopeId__,
  form_preview___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_form_preview = (form_preview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/workExp.vue














/* harmony default export */ var workExp = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    Cell: vux_src_components_cell,
    FormPreview: vux_src_components_form_preview
  },
  name: 'workExp',
  data: function data() {
    var _this = this;

    return {
      experience: [],
      delbutton: [{
        style: 'primary',
        text: '删除',
        onButtonClick: function onButtonClick(name) {
          _this.delExp(name);
        }
      }]
    };
  },

  methods: {
    delExp: function delExp(exp) {
      for (var i in this.experience) {
        if (this.experience[i].company + this.experience[i].starttime + this.experience[i].endtime + this.experience[i].title === exp) {
          this.experience.splice(i, 1);
          break;
        }
      }
      console.log(this.experience);
    },
    addExp: function addExp() {
      this.$router.push({ name: 'singleWorkExp' });
    },
    save: function save() {
      this.$router.push({ name: 'expertInfo' });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo' || to.name === 'singleWorkExp') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.experience = this.experience;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  },
  created: function created() {
    var expertdata = localStorage.getItem('expertdata');
    if (expertdata != null) {
      var data = JSON.parse(expertdata);

      data.experience.sort(function (a, b) {
        return a.endtime < b.endtime ? 1 : -1;
      });

      this.experience = data.experience;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/workExp.vue














/* harmony default export */ var components_workExp = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    Cell: vux_src_components_cell,
    FormPreview: vux_src_components_form_preview
  },
  name: 'workExp',
  data: function data() {
    var _this = this;

    return {
      experience: [],
      delbutton: [{
        style: 'primary',
        text: '删除',
        onButtonClick: function onButtonClick(name) {
          _this.delExp(name);
        }
      }]
    };
  },

  methods: {
    delExp: function delExp(exp) {
      for (var i in this.experience) {
        if (this.experience[i].company + this.experience[i].starttime + this.experience[i].endtime + this.experience[i].title === exp) {
          this.experience.splice(i, 1);
          break;
        }
      }
      console.log(this.experience);
    },
    addExp: function addExp() {
      this.$router.push({ name: 'singleWorkExp' });
    },
    save: function save() {
      this.$router.push({ name: 'expertInfo' });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo' || to.name === 'singleWorkExp') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.experience = this.experience;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  },
  created: function created() {
    var expertdata = localStorage.getItem('expertdata');
    if (expertdata != null) {
      var data = JSON.parse(expertdata);

      data.experience.sort(function (a, b) {
        return a.endtime < b.endtime ? 1 : -1;
      });

      this.experience = data.experience;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17874696","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workExp.vue
var workExp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options.showBack":"false"}},[_vm._v("工作经历")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._l((_vm.experience),function(exp,index){return _c('form-preview',{key:index,attrs:{"name":exp.company+exp.starttime+exp.endtime+exp.title,"footer-buttons":_vm.delbutton,"header-value":exp.company,"body-items":[{label: '起止时间',value: exp.starttime + '-' + exp.endtime},{label: '职位',value: exp.title}]}})}),_vm._v(" "),_c('br')],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.addExp($event)}}},[_vm._v("添加工作经历")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("完成")])],1)}
var workExp_staticRenderFns = []
var workExp_esExports = { render: workExp_render, staticRenderFns: workExp_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_workExp = (workExp_esExports);
// CONCATENATED MODULE: ./src/components/workExp.vue
var workExp_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var workExp___vue_template_functional__ = false
/* styles */
var workExp___vue_styles__ = null
/* scopeId */
var workExp___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var workExp___vue_module_identifier__ = null
var workExp_Component = workExp_normalizeComponent(
  components_workExp,
  selectortype_template_index_0_src_components_workExp,
  workExp___vue_template_functional__,
  workExp___vue_styles__,
  workExp___vue_scopeId__,
  workExp___vue_module_identifier__
)

/* harmony default export */ var src_components_workExp = (workExp_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/format.js
var format = __webpack_require__("ghQH");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-calendar/util.js
var util = __webpack_require__("1bLG");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-calendar/props.js
var inline_calendar_props = __webpack_require__("0sN4");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/calendar-marks.js
var calendar_marks = __webpack_require__("o6oK");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var inline_calendar = ({
  name: 'inline-calendar',
  mixins: [calendar_marks["a" /* default */]],
  props: Object(inline_calendar_props["a" /* default */])(),
  data: function data() {
    return {
      multi: false,
      year: 0,
      month: 0,
      days: [],
      today: Object(format["a" /* default */])(new Date(), 'YYYY-MM-DD'),
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      currentValue: '',
      viewChangeEventCount: -1
    };
  },
  created: function created() {
    this.currentValue = this.value;
    this.multi = Object.prototype.toString.call(this.currentValue) === '[object Array]';

    if (this.multi) {
      for (var i = 0; i < this.currentValue.length; i++) {
        this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
      }
    } else {
      this.currentValue = this.convertDate(this.currentValue);
    }

    this.render(this.renderMonth[0], this.renderMonth[1] - 1);
  },

  computed: {
    _weeksList: function _weeksList() {
      if (this.weeksList && this.weeksList.length) {
        return this.weeksList;
      }
      if (!this.weeksList || !this.weeksList.length) {
        // tip for older vux-loader
        if (false) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('[VUX warn] 抱歉，inline-calendar 组件需要升级 vux-loader 到最新版本才能正常使用');
          }
          return ['日', '一', '二', '三', '四', '五', '六'];
        } else {
          if (false) {
            // eslint-disable-line
            return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
          } else if (true) {
            // eslint-disable-line
            return ['日', '一', '二', '三', '四', '五', '六'];
          } else if (V_LOCALE === 'MULTI') {
            // eslint-disable-line
            return [0, 0, 0, 0, 0, 0, 0];
          }
        }
      }
    },
    _replaceTextList: function _replaceTextList() {
      var rs = {};
      for (var i in this.replaceTextList) {
        rs[this.convertDate(i)] = this.replaceTextList[i];
      }
      return rs;
    },
    currentYearMonth: function currentYearMonth() {
      return this.year + this.month;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = this.multi ? val : this.convertDate(val);
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);

      if (this.renderOnValueChange) {
        // if on the same year+month, stay quiet
        if (val && oldVal && val.slice(0, 7) === oldVal.slice(0, 7)) {
          return;
        }
        this.render(null, null, 'value change');
      }
    },
    renderFunction: function renderFunction() {
      this.render(this.year, this.month, this.currentValue);
    },
    renderMonth: function renderMonth(val) {
      if (val && val.length === 2) {
        this.render(val[0], val[1] - 1);
      }
    },
    returnSixRows: function returnSixRows(val) {
      this.render(this.year, this.month);
    },
    startDate: function startDate(val) {
      this.render(this.year, this.month);
    },
    endDate: function endDate(val) {
      this.render(this.year, this.month);
    },
    disablePast: function disablePast() {
      this.render(this.year, this.month);
    },
    disableFuture: function disableFuture() {
      this.render(this.year, this.month);
    },
    currentYearMonth: function currentYearMonth() {
      var lastLine = this.days[this.days.length - 1];
      var lastDate = lastLine[lastLine.length - 1];

      var days = [];
      this.days.forEach(function (line) {
        days = days.concat(line);
      });
      days = days.filter(function (date) {
        return !date.isLastMonth && !date.isNextMonth;
      });
      this.viewChangeEventCount++;
      this.$emit('on-view-change', {
        year: this.year,
        month: this.month + 1,
        firstDate: this.days[0][0].formatedDate,
        lastDate: lastDate.formatedDate,
        firstCurrentMonthDate: days[0].formatedDate,
        lastCurrentMonthDate: days[days.length - 1].formatedDate,
        allDates: this.days
      }, this.viewChangeEventCount);
    }
  },
  methods: {
    processDateItem: function processDateItem(item) {
      var temp = JSON.parse(stringify_default()(item));
      temp.isDisabled = this.isDisabled(item);
      temp.isBetween = this.isBetween(item.formatedDate);
      return temp;
    },
    isBetween: function isBetween(formatedDate) {
      return Object(util["b" /* isBetween */])(formatedDate, this.disablePast, this.disableFuture, this.startDate, this.endDate);
    },
    isDisabled: function isDisabled(date) {
      var disabled = !this.isBetween(date.formatedDate);
      disabled = disabled || date.isWeekend && this.disableWeekend;
      disabled = disabled || date.isNextMonth || date.isLastMonth;

      if (!this.disableDateFunction) {
        return disabled;
      } else {
        var value = this.disableDateFunction(date);
        if (typeof value === 'undefined') {
          return disabled;
        } else {
          return value;
        }
      }
    },
    switchViewToToday: function switchViewToToday() {
      var today = new Date();
      this.render(today.getFullYear(), today.getMonth());
    },
    switchViewToCurrentValue: function switchViewToCurrentValue() {
      if (!this.currentValue || this.multi && !this.currentValue.length) {
        return;
      }

      var value = void 0;
      var year = void 0;
      var month = void 0;
      if (typeof this.currentValue === 'string') {
        value = this.currentValue;
      } else {
        value = this.currentValue[0];
      }
      var splitList = value.split('-');
      year = parseInt(splitList[0], 10);
      month = parseInt(splitList[1], 10);
      this.switchViewToMonth(year, month);
    },
    switchViewToMonth: function switchViewToMonth(year, month) {
      if (!year || !month) {
        return this.switchViewToToday();
      }
      this.render(year, month - 1);
    },
    getDates: function getDates() {
      return this.days;
    },
    replaceText: function replaceText(day, formatDay) {
      var text = this._replaceTextList[formatDay];
      if (!text && typeof text === 'undefined') {
        return day;
      } else {
        return text;
      }
    },
    convertDate: function convertDate(date) {
      return date === 'TODAY' ? this.today : date;
    },
    buildClass: function buildClass(index, child) {
      var isCurrent = false;
      if (!child.isLastMonth && !child.isNextMonth) {
        if (this.multi && this.currentValue.length > 0) {
          isCurrent = this.currentValue.indexOf(this.formatDate(this.year, this.month, child)) > -1;
        } else {
          isCurrent = this.currentValue === this.formatDate(this.year, this.month, child);
        }
      }
      var className = defineProperty_default()({
        'current': isCurrent,
        'is-disabled': this.isDisabled(child),
        'is-today': child.isToday
      }, 'is-week-' + index, true);
      return className;
    },
    render: function render(year, month) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var data = null;
      var value = this.multi ? this.currentValue[this.currentValue.length - 1] : this.currentValue;
      data = Object(util["a" /* getDays */])({
        year: year,
        month: month,
        value: value,
        rangeBegin: this.convertDate(this.startDate),
        rangeEnd: this.convertDate(this.endDate),
        returnSixRows: this.returnSixRows,
        disablePast: this.disablePast,
        disableFuture: this.disableFuture
      });

      if (this.year === data.year && this.month === data.month && !force) {
        return;
      }
      this.year = data.year;
      this.month = data.month;
      this.days = data.days;
    },

    formatDate: function formatDate(year, month, child) {
      return [year, Object(util["c" /* zero */])(child.month + 1), Object(util["c" /* zero */])(child.day)].join('-');
    },
    prev: function prev() {
      if (this.month === 0) {
        this.month = 11;
        this.year = this.year - 1;
      } else {
        this.month = this.month - 1;
      }
      this.render(this.year, this.month, true);
    },
    next: function next() {
      if (this.month === 11) {
        this.month = 0;
        this.year = this.year + 1;
      } else {
        this.month = this.month + 1;
      }
      this.render(this.year, this.month, true);
    },
    go: function go(year, month) {
      this.render(year, month, true);
    },
    select: function select(k1, k2, data) {
      if (data.isLastMonth && !this.showLastMonth) {
        return;
      }
      if (data.isNextMonth && !this.showNextMonth) {
        return;
      }
      if (!this.isBetween(data.formatedDate)) {
        return;
      }

      if (this.isDisabled(data)) {
        // not in range
        if (!this.isBetween(data.formatedDate)) {
          return;
        } else {
          // in range but disabled by disableDateFunction
          if (this.disableDateFunction && this.disableDateFunction(data)) {
            return;
          }
          if (data.isWeekend && this.disableWeekend) {
            return;
          }
        }
      }
      var _currentValue = null;
      if (!data.isLastMonth && !data.isNextMonth) {
        this.days[k1][k2].current = true;
        _currentValue = [this.year, Object(util["c" /* zero */])(this.month + 1), Object(util["c" /* zero */])(this.days[k1][k2].day)].join('-');
      } else {
        _currentValue = [data.year, Object(util["c" /* zero */])(data.month + 1), Object(util["c" /* zero */])(data.day)].join('-');
      }
      if (this.multi) {
        var index = this.currentValue.indexOf(_currentValue);
        if (index > -1) {
          this.currentValue.splice(index, 1);
        } else {
          this.currentValue.push(_currentValue);
        }
      } else {
        this.currentValue = _currentValue;
        this.$emit('on-select-single-date', this.currentValue);
      }

      if (this.multi) {
        for (var i = 0; i < this.currentValue.length; i++) {
          this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
        }
      } else {
        this.currentValue = this.convertDate(this.currentValue);
      }

      if (this.renderOnValueChange) {
        this.render(null, null);
      }
    },
    showChild: function showChild(year, month, child) {
      if (this.replaceText(child.day, this.formatDate(year, month, child))) {
        return !child.isLastMonth && !child.isNextMonth || child.isLastMonth && this.showLastMonth || child.isNextMonth && this.showNextMonth;
      } else {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var components_inline_calendar = ({
  name: 'inline-calendar',
  mixins: [calendar_marks["a" /* default */]],
  props: Object(inline_calendar_props["a" /* default */])(),
  data: function data() {
    return {
      multi: false,
      year: 0,
      month: 0,
      days: [],
      today: Object(format["a" /* default */])(new Date(), 'YYYY-MM-DD'),
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      currentValue: '',
      viewChangeEventCount: -1
    };
  },
  created: function created() {
    this.currentValue = this.value;
    this.multi = Object.prototype.toString.call(this.currentValue) === '[object Array]';

    if (this.multi) {
      for (var i = 0; i < this.currentValue.length; i++) {
        this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
      }
    } else {
      this.currentValue = this.convertDate(this.currentValue);
    }

    this.render(this.renderMonth[0], this.renderMonth[1] - 1);
  },

  computed: {
    _weeksList: function _weeksList() {
      if (this.weeksList && this.weeksList.length) {
        return this.weeksList;
      }
      if (!this.weeksList || !this.weeksList.length) {
        // tip for older vux-loader
        if (false) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('[VUX warn] 抱歉，inline-calendar 组件需要升级 vux-loader 到最新版本才能正常使用');
          }
          return ['日', '一', '二', '三', '四', '五', '六'];
        } else {
          if (false) {
            // eslint-disable-line
            return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
          } else if (true) {
            // eslint-disable-line
            return ['日', '一', '二', '三', '四', '五', '六'];
          } else if (V_LOCALE === 'MULTI') {
            // eslint-disable-line
            return [0, 0, 0, 0, 0, 0, 0];
          }
        }
      }
    },
    _replaceTextList: function _replaceTextList() {
      var rs = {};
      for (var i in this.replaceTextList) {
        rs[this.convertDate(i)] = this.replaceTextList[i];
      }
      return rs;
    },
    currentYearMonth: function currentYearMonth() {
      return this.year + this.month;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = this.multi ? val : this.convertDate(val);
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);

      if (this.renderOnValueChange) {
        // if on the same year+month, stay quiet
        if (val && oldVal && val.slice(0, 7) === oldVal.slice(0, 7)) {
          return;
        }
        this.render(null, null, 'value change');
      }
    },
    renderFunction: function renderFunction() {
      this.render(this.year, this.month, this.currentValue);
    },
    renderMonth: function renderMonth(val) {
      if (val && val.length === 2) {
        this.render(val[0], val[1] - 1);
      }
    },
    returnSixRows: function returnSixRows(val) {
      this.render(this.year, this.month);
    },
    startDate: function startDate(val) {
      this.render(this.year, this.month);
    },
    endDate: function endDate(val) {
      this.render(this.year, this.month);
    },
    disablePast: function disablePast() {
      this.render(this.year, this.month);
    },
    disableFuture: function disableFuture() {
      this.render(this.year, this.month);
    },
    currentYearMonth: function currentYearMonth() {
      var lastLine = this.days[this.days.length - 1];
      var lastDate = lastLine[lastLine.length - 1];

      var days = [];
      this.days.forEach(function (line) {
        days = days.concat(line);
      });
      days = days.filter(function (date) {
        return !date.isLastMonth && !date.isNextMonth;
      });
      this.viewChangeEventCount++;
      this.$emit('on-view-change', {
        year: this.year,
        month: this.month + 1,
        firstDate: this.days[0][0].formatedDate,
        lastDate: lastDate.formatedDate,
        firstCurrentMonthDate: days[0].formatedDate,
        lastCurrentMonthDate: days[days.length - 1].formatedDate,
        allDates: this.days
      }, this.viewChangeEventCount);
    }
  },
  methods: {
    processDateItem: function processDateItem(item) {
      var temp = JSON.parse(stringify_default()(item));
      temp.isDisabled = this.isDisabled(item);
      temp.isBetween = this.isBetween(item.formatedDate);
      return temp;
    },
    isBetween: function isBetween(formatedDate) {
      return Object(util["b" /* isBetween */])(formatedDate, this.disablePast, this.disableFuture, this.startDate, this.endDate);
    },
    isDisabled: function isDisabled(date) {
      var disabled = !this.isBetween(date.formatedDate);
      disabled = disabled || date.isWeekend && this.disableWeekend;
      disabled = disabled || date.isNextMonth || date.isLastMonth;

      if (!this.disableDateFunction) {
        return disabled;
      } else {
        var value = this.disableDateFunction(date);
        if (typeof value === 'undefined') {
          return disabled;
        } else {
          return value;
        }
      }
    },
    switchViewToToday: function switchViewToToday() {
      var today = new Date();
      this.render(today.getFullYear(), today.getMonth());
    },
    switchViewToCurrentValue: function switchViewToCurrentValue() {
      if (!this.currentValue || this.multi && !this.currentValue.length) {
        return;
      }

      var value = void 0;
      var year = void 0;
      var month = void 0;
      if (typeof this.currentValue === 'string') {
        value = this.currentValue;
      } else {
        value = this.currentValue[0];
      }
      var splitList = value.split('-');
      year = parseInt(splitList[0], 10);
      month = parseInt(splitList[1], 10);
      this.switchViewToMonth(year, month);
    },
    switchViewToMonth: function switchViewToMonth(year, month) {
      if (!year || !month) {
        return this.switchViewToToday();
      }
      this.render(year, month - 1);
    },
    getDates: function getDates() {
      return this.days;
    },
    replaceText: function replaceText(day, formatDay) {
      var text = this._replaceTextList[formatDay];
      if (!text && typeof text === 'undefined') {
        return day;
      } else {
        return text;
      }
    },
    convertDate: function convertDate(date) {
      return date === 'TODAY' ? this.today : date;
    },
    buildClass: function buildClass(index, child) {
      var isCurrent = false;
      if (!child.isLastMonth && !child.isNextMonth) {
        if (this.multi && this.currentValue.length > 0) {
          isCurrent = this.currentValue.indexOf(this.formatDate(this.year, this.month, child)) > -1;
        } else {
          isCurrent = this.currentValue === this.formatDate(this.year, this.month, child);
        }
      }
      var className = defineProperty_default()({
        'current': isCurrent,
        'is-disabled': this.isDisabled(child),
        'is-today': child.isToday
      }, 'is-week-' + index, true);
      return className;
    },
    render: function render(year, month) {
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var data = null;
      var value = this.multi ? this.currentValue[this.currentValue.length - 1] : this.currentValue;
      data = Object(util["a" /* getDays */])({
        year: year,
        month: month,
        value: value,
        rangeBegin: this.convertDate(this.startDate),
        rangeEnd: this.convertDate(this.endDate),
        returnSixRows: this.returnSixRows,
        disablePast: this.disablePast,
        disableFuture: this.disableFuture
      });

      if (this.year === data.year && this.month === data.month && !force) {
        return;
      }
      this.year = data.year;
      this.month = data.month;
      this.days = data.days;
    },

    formatDate: function formatDate(year, month, child) {
      return [year, Object(util["c" /* zero */])(child.month + 1), Object(util["c" /* zero */])(child.day)].join('-');
    },
    prev: function prev() {
      if (this.month === 0) {
        this.month = 11;
        this.year = this.year - 1;
      } else {
        this.month = this.month - 1;
      }
      this.render(this.year, this.month, true);
    },
    next: function next() {
      if (this.month === 11) {
        this.month = 0;
        this.year = this.year + 1;
      } else {
        this.month = this.month + 1;
      }
      this.render(this.year, this.month, true);
    },
    go: function go(year, month) {
      this.render(year, month, true);
    },
    select: function select(k1, k2, data) {
      if (data.isLastMonth && !this.showLastMonth) {
        return;
      }
      if (data.isNextMonth && !this.showNextMonth) {
        return;
      }
      if (!this.isBetween(data.formatedDate)) {
        return;
      }

      if (this.isDisabled(data)) {
        // not in range
        if (!this.isBetween(data.formatedDate)) {
          return;
        } else {
          // in range but disabled by disableDateFunction
          if (this.disableDateFunction && this.disableDateFunction(data)) {
            return;
          }
          if (data.isWeekend && this.disableWeekend) {
            return;
          }
        }
      }
      var _currentValue = null;
      if (!data.isLastMonth && !data.isNextMonth) {
        this.days[k1][k2].current = true;
        _currentValue = [this.year, Object(util["c" /* zero */])(this.month + 1), Object(util["c" /* zero */])(this.days[k1][k2].day)].join('-');
      } else {
        _currentValue = [data.year, Object(util["c" /* zero */])(data.month + 1), Object(util["c" /* zero */])(data.day)].join('-');
      }
      if (this.multi) {
        var index = this.currentValue.indexOf(_currentValue);
        if (index > -1) {
          this.currentValue.splice(index, 1);
        } else {
          this.currentValue.push(_currentValue);
        }
      } else {
        this.currentValue = _currentValue;
        this.$emit('on-select-single-date', this.currentValue);
      }

      if (this.multi) {
        for (var i = 0; i < this.currentValue.length; i++) {
          this.$set(this.currentValue, i, this.convertDate(this.currentValue[i]));
        }
      } else {
        this.currentValue = this.convertDate(this.currentValue);
      }

      if (this.renderOnValueChange) {
        this.render(null, null);
      }
    },
    showChild: function showChild(year, month, child) {
      if (this.replaceText(child.day, this.formatDate(year, month, child))) {
        return !child.isLastMonth && !child.isNextMonth || child.isLastMonth && this.showLastMonth || child.isNextMonth && this.showNextMonth;
      } else {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49308382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-calendar/index.vue
var inline_calendar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-calendar",class:{'is-weekend-highlight': _vm.highlightWeekend}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideHeader),expression:"!hideHeader"}],staticClass:"calendar-header"},[_c('div',{staticClass:"calendar-year"},[_c('span',{on:{"click":function($event){_vm.go(_vm.year - 1, _vm.month)}}},[_c('a',{staticClass:"year-prev vux-prev-icon",attrs:{"href":"javascript:"}})]),_vm._v(" "),_c('a',{staticClass:"calendar-year-txt calendar-title",attrs:{"href":"javascript:"}},[_vm._v(_vm._s(_vm.year))]),_vm._v(" "),_c('span',{staticClass:"calendar-header-right-arrow",on:{"click":function($event){_vm.go(_vm.year + 1, _vm.month)}}},[_c('a',{staticClass:"year-next vux-next-icon",attrs:{"href":"javascript:"}})])]),_vm._v(" "),_c('div',{staticClass:"calendar-month"},[_c('span',{on:{"click":_vm.prev}},[_c('a',{staticClass:"month-prev vux-prev-icon",attrs:{"href":"javascript:"}})]),_vm._v(" "),_c('a',{staticClass:"calendar-month-txt calendar-title",attrs:{"href":"javascript:"}},[_vm._v(_vm._s(_vm.months[_vm.month]))]),_vm._v(" "),_c('span',{staticClass:"calendar-header-right-arrow",on:{"click":_vm.next}},[_c('a',{staticClass:"month-next vux-next-icon",attrs:{"href":"javascript:"}})])])]),_vm._v(" "),_c('table',[_c('thead',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideWeekList),expression:"!hideWeekList"}]},[_c('tr',_vm._l((_vm._weeksList),function(week,index){return _c('th',{staticClass:"week",class:("is-week-list-" + index)},[_vm._v(_vm._s(week || week))])}))]),_vm._v(" "),_c('tbody',_vm._l((_vm.days),function(day,k1){return _c('tr',_vm._l((day),function(child,k2){return _c('td',{class:_vm.buildClass(k2, child),attrs:{"data-date":_vm.formatDate(_vm.year, _vm.month, child),"data-current":_vm.currentValue},on:{"click":function($event){_vm.select(k1, k2, child)}}},[_vm._t("each-day",[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChild(_vm.year, _vm.month, child)),expression:"showChild(year, month, child)"}],staticClass:"vux-calendar-each-date",style:(_vm.getMarkStyle(child))},[_vm._v("\n              "+_vm._s(_vm.replaceText(child.day, _vm.formatDate(_vm.year, _vm.month, child)))+"\n              "),(_vm.isShowTopTip(child))?_c('span',{staticClass:"vux-calendar-top-tip",style:(_vm.isShowTopTip(child, 'style'))},[_c('span',[_vm._v(_vm._s(_vm.isShowTopTip(child, 'text')))])]):_vm._e()]),_vm._v(" "),(_vm.isShowBottomDot(child))?_c('span',{staticClass:"vux-calendar-dot"}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChild(_vm.year, _vm.month, child)),expression:"showChild(year, month, child)"}],domProps:{"innerHTML":_vm._s(_vm.renderFunction(k1, k2, child))}})],{year:_vm.year,month:_vm.month,child:_vm.processDateItem(child)/* deprecated, use date instead */,date:_vm.processDateItem(child),className:"vux-calendar-each-date",row:k1,col:k2,rawDate:_vm.formatDate(_vm.year, _vm.month, child),showDate:_vm.replaceText(child.day, _vm.formatDate(_vm.year, _vm.month, child)),isShow:_vm.showChild(_vm.year, _vm.month, child)})],2)}))}))])])}
var inline_calendar_staticRenderFns = []
var inline_calendar_esExports = { render: inline_calendar_render, staticRenderFns: inline_calendar_staticRenderFns }
/* harmony default export */ var src_components_inline_calendar = (inline_calendar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-calendar/index.vue
function inline_calendar_injectStyle (ssrContext) {
  __webpack_require__("bRlU")
}
var inline_calendar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_calendar___vue_template_functional__ = false
/* styles */
var inline_calendar___vue_styles__ = inline_calendar_injectStyle
/* scopeId */
var inline_calendar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_calendar___vue_module_identifier__ = null
var inline_calendar_Component = inline_calendar_normalizeComponent(
  components_inline_calendar,
  src_components_inline_calendar,
  inline_calendar___vue_template_functional__,
  inline_calendar___vue_styles__,
  inline_calendar___vue_scopeId__,
  inline_calendar___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_inline_calendar = (inline_calendar_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var getType = function getType(value) {
  if (typeof value === 'string') {
    return 'string';
  }
  if (Object.prototype.toString.call(value) === '[object Array]') {
    return 'array';
  }
};

var calendar_pure = function pure(value) {
  var type = getType(value);
  if (type === 'string') {
    return value;
  } else if (type === 'array') {
    return JSON.parse(stringify_default()(value));
  }
};

var Props = extends_default()({}, Object(inline_calendar_props["a" /* default */])(), {
  title: {
    type: String,
    required: true
  },
  placeholder: String,
  showPopupHeader: Boolean,
  popupHeaderTitle: String,
  displayFormat: {
    type: Function,
    default: function _default(value) {
      return typeof value === 'string' ? value : value.join(', ');
    }
  },
  // for test only
  shouldTransferDom: {
    type: Boolean,
    default: true
  },
  readonly: Boolean
});

/* harmony default export */ var calendar = ({
  name: 'calendar',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    InlineCalendar: vux_src_components_inline_calendar,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Cell: vux_src_components_cell
  },
  computed: {
    shouldConfirm: function shouldConfirm() {
      return this.showPopupHeader || this.getType(this.value) === 'array';
    },
    shouldShowPlaceholder: function shouldShowPlaceholder() {
      if (typeof this.value === 'string' && !this.value) {
        return true;
      }
      if (getType(this.value) === 'array' && !this.value.length) {
        return true;
      }
      return false;
    }
  },
  created: function created() {
    if (this.value === 'TODAY') {
      this.currentValue = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD');
      this.$emit('input', this.currentValue);
    } else {
      if (this.getType(this.value) === 'string') {
        this.currentValue = this.value;
      } else {
        this.currentValue = calendar_pure(this.value);
      }
    }
  },

  props: Props,
  methods: {
    onPopupShow: function onPopupShow() {
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide() {
      this.$emit('on-hide');
      // reset value to show value
      this.currentValue = calendar_pure(this.value);
    },

    getType: getType,
    onClickLeft: function onClickLeft() {
      this.show = false;
      this.currentValue = calendar_pure(this.value);
    },
    onClickRight: function onClickRight() {
      this.show = false;
      var value = calendar_pure(this.currentValue);
      this.$emit('input', value);
    },
    onClick: function onClick() {
      if (!this.readonly) {
        this.show = true;
      }
    },
    onCalendarValueChange: function onCalendarValueChange(val) {
      if (!this.shouldConfirm) {
        this.show = false;
        this.$emit('input', calendar_pure(val));
      }
    },
    onSelectSingleDate: function onSelectSingleDate() {
      if (!this.shouldConfirm) {
        this.show = false;
      }
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (this.getType(this.value) === 'string') {
        this.currentValue = newVal;
        this.$emit('on-change', newVal);
      } else {
        if (stringify_default()(newVal) !== stringify_default()(oldVal)) {
          this.$emit('on-change', calendar_pure(newVal));
        }
        this.currentValue = calendar_pure(newVal);
      }
    }
  },
  data: function data() {
    return {
      show: false,
      currentValue: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/calendar/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var calendar_getType = function getType(value) {
  if (typeof value === 'string') {
    return 'string';
  }
  if (Object.prototype.toString.call(value) === '[object Array]') {
    return 'array';
  }
};

var components_calendar_pure = function pure(value) {
  var type = calendar_getType(value);
  if (type === 'string') {
    return value;
  } else if (type === 'array') {
    return JSON.parse(stringify_default()(value));
  }
};

var calendar_Props = extends_default()({}, Object(inline_calendar_props["a" /* default */])(), {
  title: {
    type: String,
    required: true
  },
  placeholder: String,
  showPopupHeader: Boolean,
  popupHeaderTitle: String,
  displayFormat: {
    type: Function,
    default: function _default(value) {
      return typeof value === 'string' ? value : value.join(', ');
    }
  },
  // for test only
  shouldTransferDom: {
    type: Boolean,
    default: true
  },
  readonly: Boolean
});

/* harmony default export */ var components_calendar = ({
  name: 'calendar',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    InlineCalendar: vux_src_components_inline_calendar,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Cell: vux_src_components_cell
  },
  computed: {
    shouldConfirm: function shouldConfirm() {
      return this.showPopupHeader || this.getType(this.value) === 'array';
    },
    shouldShowPlaceholder: function shouldShowPlaceholder() {
      if (typeof this.value === 'string' && !this.value) {
        return true;
      }
      if (calendar_getType(this.value) === 'array' && !this.value.length) {
        return true;
      }
      return false;
    }
  },
  created: function created() {
    if (this.value === 'TODAY') {
      this.currentValue = Object(date_format["a" /* default */])(new Date(), 'YYYY-MM-DD');
      this.$emit('input', this.currentValue);
    } else {
      if (this.getType(this.value) === 'string') {
        this.currentValue = this.value;
      } else {
        this.currentValue = components_calendar_pure(this.value);
      }
    }
  },

  props: calendar_Props,
  methods: {
    onPopupShow: function onPopupShow() {
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide() {
      this.$emit('on-hide');
      // reset value to show value
      this.currentValue = components_calendar_pure(this.value);
    },

    getType: calendar_getType,
    onClickLeft: function onClickLeft() {
      this.show = false;
      this.currentValue = components_calendar_pure(this.value);
    },
    onClickRight: function onClickRight() {
      this.show = false;
      var value = components_calendar_pure(this.currentValue);
      this.$emit('input', value);
    },
    onClick: function onClick() {
      if (!this.readonly) {
        this.show = true;
      }
    },
    onCalendarValueChange: function onCalendarValueChange(val) {
      if (!this.shouldConfirm) {
        this.show = false;
        this.$emit('input', components_calendar_pure(val));
      }
    },
    onSelectSingleDate: function onSelectSingleDate() {
      if (!this.shouldConfirm) {
        this.show = false;
      }
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (this.getType(this.value) === 'string') {
        this.currentValue = newVal;
        this.$emit('on-change', newVal);
      } else {
        if (stringify_default()(newVal) !== stringify_default()(oldVal)) {
          this.$emit('on-change', components_calendar_pure(newVal));
        }
        this.currentValue = components_calendar_pure(newVal);
      }
    }
  },
  data: function data() {
    return {
      show: false,
      currentValue: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-245cd4be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/calendar/index.vue
var calendar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-calendar"},[_c('cell',{attrs:{"title":_vm.title,"primary":"content","is-link":!_vm.readonly},nativeOn:{"click":function($event){return _vm.onClick($event)}}},[(_vm.shouldShowPlaceholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(!_vm.shouldShowPlaceholder)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.getType(_vm.value))))]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.shouldTransferDom),expression:"shouldTransferDom"}]},[_c('popup',{on:{"on-show":_vm.onPopupShow,"on-hide":_vm.onPopupHide},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.shouldConfirm)?_c('popup-header',{attrs:{"title":_vm.popupHeaderTitle,"left-text":'取消',"right-text":'确定'},on:{"on-click-left":_vm.onClickLeft,"on-click-right":_vm.onClickRight}}):_vm._e(),_vm._v(" "),_vm._t("popup-before-calendar"),_vm._v(" "),_c('inline-calendar',{attrs:{"render-month":_vm.renderMonth,"start-date":_vm.startDate,"end-date":_vm.endDate,"show-last-month":_vm.showLastMonth,"show-next-month":_vm.showNextMonth,"highlight-weekend":_vm.highlightWeekend,"return-six-rows":_vm.returnSixRows,"hide-header":_vm.hideHeader,"hide-week-list":_vm.hideWeekList,"replace-text-list":_vm.replaceTextList,"weeks-list":_vm.weeksList,"render-function":_vm.renderFunction,"render-on-value-change":_vm.renderOnValueChange,"disable-past":_vm.disablePast,"disable-future":_vm.disableFuture,"marks":_vm.marks,"disable-weekend":_vm.disableWeekend,"disable-date-function":_vm.disableDateFunction},on:{"on-change":_vm.onCalendarValueChange,"on-select-single-date":_vm.onSelectSingleDate},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)],1)}
var calendar_staticRenderFns = []
var calendar_esExports = { render: calendar_render, staticRenderFns: calendar_staticRenderFns }
/* harmony default export */ var src_components_calendar = (calendar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/calendar/index.vue
function calendar_injectStyle (ssrContext) {
  __webpack_require__("2i4+")
}
var calendar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var calendar___vue_template_functional__ = false
/* styles */
var calendar___vue_styles__ = calendar_injectStyle
/* scopeId */
var calendar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var calendar___vue_module_identifier__ = null
var calendar_Component = calendar_normalizeComponent(
  components_calendar,
  src_components_calendar,
  calendar___vue_template_functional__,
  calendar___vue_styles__,
  calendar___vue_scopeId__,
  calendar___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_calendar = (calendar_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/index.vue + 3 modules
var datetime = __webpack_require__("UNGY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/singleWorkExp.vue










/* harmony default export */ var singleWorkExp = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Calendar: vux_src_components_calendar,
    Datetime: datetime["a" /* default */]
  },
  name: 'singleWorkExp',
  data: function data() {
    return {
      company: '',
      starttime: '',
      endtime: '',
      title: '',
      endDate: ''
    };
  },

  methods: {
    change: function change() {
      if (this.endtime === '至今') {
        var date = new Date();
        var seperator1 = '-';
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = '0' + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        this.endDate = currentdate;
      } else {
        this.endDate = this.endtime;
      }
    },
    addExp: function addExp() {
      if (this.$refs.input1.valid && this.$refs.input2.valid && this.company && this.starttime && this.endtime && this.title) {
        var exp = {
          'company': this.company,
          'starttime': this.starttime,
          'endtime': this.endtime,
          'title': this.title
        };
        var expertdata = localStorage.getItem('expertdata');
        if (expertdata != null) {
          var data = JSON.parse(expertdata);
          if (data.experience === null) {
            data.experience = [];
          }
          data.experience.push(exp);
          expertdata = stringify_default()(data);
          console.log(expertdata);
          localStorage.setItem('expertdata', expertdata);
        }
        this.$router.push({ name: 'workExp' });
      } else {
        if (!(this.$refs.input1.valid && this.$refs.input2.valid)) {
          this.$vux.alert.show({
            title: '',
            content: '输入信息有误'
          });
        } else {
          this.$vux.alert.show({
            title: '',
            content: '输入信息不完整，请补全后再提交'
          });
        }
      }
    },
    setToNow: function setToNow() {
      this.endtime = '至今';
    }
  },
  created: function created() {
    var date = new Date();
    var seperator1 = '-';
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    this.endDate = currentdate;
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/singleWorkExp.vue










/* harmony default export */ var components_singleWorkExp = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Calendar: vux_src_components_calendar,
    Datetime: datetime["a" /* default */]
  },
  name: 'singleWorkExp',
  data: function data() {
    return {
      company: '',
      starttime: '',
      endtime: '',
      title: '',
      endDate: ''
    };
  },

  methods: {
    change: function change() {
      if (this.endtime === '至今') {
        var date = new Date();
        var seperator1 = '-';
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = '0' + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        this.endDate = currentdate;
      } else {
        this.endDate = this.endtime;
      }
    },
    addExp: function addExp() {
      if (this.$refs.input1.valid && this.$refs.input2.valid && this.company && this.starttime && this.endtime && this.title) {
        var exp = {
          'company': this.company,
          'starttime': this.starttime,
          'endtime': this.endtime,
          'title': this.title
        };
        var expertdata = localStorage.getItem('expertdata');
        if (expertdata != null) {
          var data = JSON.parse(expertdata);
          if (data.experience === null) {
            data.experience = [];
          }
          data.experience.push(exp);
          expertdata = stringify_default()(data);
          console.log(expertdata);
          localStorage.setItem('expertdata', expertdata);
        }
        this.$router.push({ name: 'workExp' });
      } else {
        if (!(this.$refs.input1.valid && this.$refs.input2.valid)) {
          this.$vux.alert.show({
            title: '',
            content: '输入信息有误'
          });
        } else {
          this.$vux.alert.show({
            title: '',
            content: '输入信息不完整，请补全后再提交'
          });
        }
      }
    },
    setToNow: function setToNow() {
      this.endtime = '至今';
    }
  },
  created: function created() {
    var date = new Date();
    var seperator1 = '-';
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    this.endDate = currentdate;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29b4a60c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/singleWorkExp.vue
var singleWorkExp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("工作经历")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('group',[_c('x-input',{ref:"input1",attrs:{"title":"公司名称","type":"text","min":3,"show-clear":false,"required":""},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}}),_vm._v(" "),_c('datetime',{attrs:{"format":"YYYY-MM-DD","end-date":_vm.endDate,"title":('开始时间')},model:{value:(_vm.starttime),callback:function ($$v) {_vm.starttime=$$v},expression:"starttime"}}),_vm._v(" "),_c('datetime',{attrs:{"format":"YYYY-MM-DD","start-date":_vm.starttime,"end-date":_vm.endDate,"title":('结束时间'),"clear-text":"至今"},on:{"on-change":_vm.change,"on-clear":_vm.setToNow},model:{value:(_vm.endtime),callback:function ($$v) {_vm.endtime=$$v},expression:"endtime"}}),_vm._v(" "),_c('x-input',{ref:"input2",attrs:{"title":"职位","show-clear":false,"required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.addExp($event)}}},[_vm._v("确定")])],1)}
var singleWorkExp_staticRenderFns = []
var singleWorkExp_esExports = { render: singleWorkExp_render, staticRenderFns: singleWorkExp_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_singleWorkExp = (singleWorkExp_esExports);
// CONCATENATED MODULE: ./src/components/singleWorkExp.vue
var singleWorkExp_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var singleWorkExp___vue_template_functional__ = false
/* styles */
var singleWorkExp___vue_styles__ = null
/* scopeId */
var singleWorkExp___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var singleWorkExp___vue_module_identifier__ = null
var singleWorkExp_Component = singleWorkExp_normalizeComponent(
  components_singleWorkExp,
  selectortype_template_index_0_src_components_singleWorkExp,
  singleWorkExp___vue_template_functional__,
  singleWorkExp___vue_styles__,
  singleWorkExp___vue_scopeId__,
  singleWorkExp___vue_module_identifier__
)

/* harmony default export */ var src_components_singleWorkExp = (singleWorkExp_Component.exports);

// EXTERNAL MODULE: ./node_modules/weixin-js-sdk/index.js
var weixin_js_sdk = __webpack_require__("fxnj");
var weixin_js_sdk_default = /*#__PURE__*/__webpack_require__.n(weixin_js_sdk);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global.vue

/* harmony default export */ var global = ({
    entryUrl: null,
    openid: null,
    unionid: null
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/global.vue

/* harmony default export */ var components_global = ({
    entryUrl: null,
    openid: null,
    unionid: null
});
// CONCATENATED MODULE: ./src/components/global.vue
var global_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var global___vue_template_functional__ = false
/* styles */
var global___vue_styles__ = null
/* scopeId */
var global___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var global___vue_module_identifier__ = null
var global_Component = global_normalizeComponent(
  components_global,
  __vue_template__,
  global___vue_template_functional__,
  global___vue_styles__,
  global___vue_scopeId__,
  global___vue_module_identifier__
)

/* harmony default export */ var src_components_global = (global_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/idPhoto.vue










/* harmony default export */ var idPhoto = ({
  components: {
    Card: vux_src_components_card,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button
  },
  name: 'idPhoto',
  data: function data() {
    return {
      company: '',
      starttime: '',
      endtime: '',
      title: '',
      img1: '/static/img/idcard2.png',
      img2: '/static/img/idcard1.png',
      idphoto: { 'origin': '', 'thumb': '' },
      idphoto2: { 'origin': '', 'thumb': '' },
      account: '',
      sequence: '',
      flag: true,
      imgflag: false,
      imgflag1: false,
      result: localStorage.getItem('result'),
      arr: [{ 'value': '' }],
      brr: [{ 'value': '' }]
    };
  },

  methods: {
    confirm: function confirm() {
      this.$router.push({ name: 'expertInfo' });
    },
    upload: function upload(event) {
      var _this = this;

      var name = event.currentTarget.name;
      if (this.result === 'TO_BE_APPROVE') {
        this.uploadImg(name);
      } else {
        this.$vux.confirm.show({
          title: '',
          content: '修改信息需要重新进行审核,将会影响接单等功能,确认修改？',
          onConfirm: function onConfirm() {
            _this.uploadImg(name);
          }
        });
      }
    },
    uploadImg: function uploadImg(name) {
      var _this2 = this;

      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          if (name === 'image1') {
            _this2.img1 = localIds[0];
          } else {
            _this2.img2 = localIds[0];
          }
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                if (name === 'image1') {
                  _this2.img1 = res.localData;
                } else {
                  _this2.img2 = res.localData;
                }
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              var serverId = res.serverId;
              var userInfo;
              var obj = {
                photo: []
              };
              if (name === 'image1') {
                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  for (var i in res.data) {
                    app.idphoto.origin = res.data[i].origin;
                    app.idphoto.thumb = res.data[i].thumb;
                    var arr = [];
                    ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.idphoto.thumb, header).then(function (res) {
                      arr.push(res.data);
                    });
                    app.arr = arr;
                  }
                  userInfo = {
                    sequence: app.sequence,
                    idphoto: app.idphoto
                  };
                  app.submitImage(userInfo);
                }).catch(function (error) {
                  if (error.response) {
                    app.$vux.loading.hide();
                    if (error.response.data.error_message) {
                      app.$vux.alert.show({
                        title: '',
                        content: JSON.parse(error.response.data.error_message).zh_string
                      });
                    } else {
                      app.$vux.alert.show({
                        title: '',
                        content: '服务器错误，请稍后重试'
                      });
                    }
                  } else {
                    app.$vux.loading.hide();
                    app.$vux.alert.show({
                      title: '',
                      content: '服务器错误，请稍后重试'
                    });
                    console.log('Error', error.message);
                  }
                });
              } else {

                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  for (var i in res.data) {
                    app.idphoto2.origin = res.data[i].origin;
                    app.idphoto2.thumb = res.data[i].thumb;
                    var brr = [];
                    ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.idphoto2.thumb, header).then(function (res) {
                      brr.push(res.data);
                    });
                    app.brr = brr;
                  }
                  userInfo = {
                    sequence: app.sequence,
                    idphoto2: app.idphoto2
                  };
                  app.submitImage(userInfo);
                });
              }
            }
          }), 100);
        }

      });
    },
    submitImage: function submitImage(userInfo) {
      var app = this;
      app.$vux.loading.show();
      var opid = localStorage.getItem('userid');
      var head = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      app.$http.put('/api/v1/experts/' + opid + '/photo', userInfo, head).then(function (response) {
        app.$vux.loading.hide();
        app.$vux.alert.show({
          title: '',
          content: '图片保存成功',
          onHide: function onHide() {
            app.sequence += 1;
          }
        });
      }).catch(function (error) {
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          } else {
            app.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.alert.show({
            title: '',
            content: '服务器错误，请稍后重试'
          });
          console.log('Error', error.message);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this3;
      _this3.$http.get('static/config.json').then(function (response) {
        var config = response.data;

        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var expertdata = localStorage.getItem('expertdata');
    var token = localStorage.getItem('token');
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: token,
        opid: opid
      }
    };
    if (expertdata != null) {
      var data = JSON.parse(expertdata);
      if (data) {
        next(function (vm) {
          vm.idphoto = data.idphoto;
          vm.idphoto2 = data.idphoto2;
          vm.account = data.account;
          vm.sequence = data.sequence;
          if (data.idphoto.thumb) {
            var arr = [];
            vm.imgflag = true;
            vm.$vux.loading.show();
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.idphoto.thumb, header).then(function (res) {
              arr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.arr = arr;
          }
          if (data.idphoto2.thumb) {
            var brr = [];
            vm.imgflag1 = true;
            vm.$vux.loading.show();
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.idphoto2.thumb, header).then(function (res) {
              brr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.brr = brr;
          }
          if (data.result === 'APPROVED') {
            vm.flag = false;
          }
        });
      }
    } else {
      next({
        path: '/'
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.idphoto = this.idphoto;
        data.idphoto2 = this.idphoto2;
        data.sequence = this.sequence;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/idPhoto.vue










/* harmony default export */ var components_idPhoto = ({
  components: {
    Card: vux_src_components_card,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button
  },
  name: 'idPhoto',
  data: function data() {
    return {
      company: '',
      starttime: '',
      endtime: '',
      title: '',
      img1: '/static/img/idcard2.png',
      img2: '/static/img/idcard1.png',
      idphoto: { 'origin': '', 'thumb': '' },
      idphoto2: { 'origin': '', 'thumb': '' },
      account: '',
      sequence: '',
      flag: true,
      imgflag: false,
      imgflag1: false,
      result: localStorage.getItem('result'),
      arr: [{ 'value': '' }],
      brr: [{ 'value': '' }]
    };
  },

  methods: {
    confirm: function confirm() {
      this.$router.push({ name: 'expertInfo' });
    },
    upload: function upload(event) {
      var _this = this;

      var name = event.currentTarget.name;
      if (this.result === 'TO_BE_APPROVE') {
        this.uploadImg(name);
      } else {
        this.$vux.confirm.show({
          title: '',
          content: '修改信息需要重新进行审核,将会影响接单等功能,确认修改？',
          onConfirm: function onConfirm() {
            _this.uploadImg(name);
          }
        });
      }
    },
    uploadImg: function uploadImg(name) {
      var _this2 = this;

      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          if (name === 'image1') {
            _this2.img1 = localIds[0];
          } else {
            _this2.img2 = localIds[0];
          }
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                if (name === 'image1') {
                  _this2.img1 = res.localData;
                } else {
                  _this2.img2 = res.localData;
                }
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              var serverId = res.serverId;
              var userInfo;
              var obj = {
                photo: []
              };
              if (name === 'image1') {
                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  for (var i in res.data) {
                    app.idphoto.origin = res.data[i].origin;
                    app.idphoto.thumb = res.data[i].thumb;
                    var arr = [];
                    ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.idphoto.thumb, header).then(function (res) {
                      arr.push(res.data);
                    });
                    app.arr = arr;
                  }
                  userInfo = {
                    sequence: app.sequence,
                    idphoto: app.idphoto
                  };
                  app.submitImage(userInfo);
                }).catch(function (error) {
                  if (error.response) {
                    app.$vux.loading.hide();
                    if (error.response.data.error_message) {
                      app.$vux.alert.show({
                        title: '',
                        content: JSON.parse(error.response.data.error_message).zh_string
                      });
                    } else {
                      app.$vux.alert.show({
                        title: '',
                        content: '服务器错误，请稍后重试'
                      });
                    }
                  } else {
                    app.$vux.loading.hide();
                    app.$vux.alert.show({
                      title: '',
                      content: '服务器错误，请稍后重试'
                    });
                    console.log('Error', error.message);
                  }
                });
              } else {

                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  for (var i in res.data) {
                    app.idphoto2.origin = res.data[i].origin;
                    app.idphoto2.thumb = res.data[i].thumb;
                    var brr = [];
                    ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.idphoto2.thumb, header).then(function (res) {
                      brr.push(res.data);
                    });
                    app.brr = brr;
                  }
                  userInfo = {
                    sequence: app.sequence,
                    idphoto2: app.idphoto2
                  };
                  app.submitImage(userInfo);
                });
              }
            }
          }), 100);
        }

      });
    },
    submitImage: function submitImage(userInfo) {
      var app = this;
      app.$vux.loading.show();
      var opid = localStorage.getItem('userid');
      var head = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      app.$http.put('/api/v1/experts/' + opid + '/photo', userInfo, head).then(function (response) {
        app.$vux.loading.hide();
        app.$vux.alert.show({
          title: '',
          content: '图片保存成功',
          onHide: function onHide() {
            app.sequence += 1;
          }
        });
      }).catch(function (error) {
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          } else {
            app.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.alert.show({
            title: '',
            content: '服务器错误，请稍后重试'
          });
          console.log('Error', error.message);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this3;
      _this3.$http.get('static/config.json').then(function (response) {
        var config = response.data;

        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var expertdata = localStorage.getItem('expertdata');
    var token = localStorage.getItem('token');
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: token,
        opid: opid
      }
    };
    if (expertdata != null) {
      var data = JSON.parse(expertdata);
      if (data) {
        next(function (vm) {
          vm.idphoto = data.idphoto;
          vm.idphoto2 = data.idphoto2;
          vm.account = data.account;
          vm.sequence = data.sequence;
          if (data.idphoto.thumb) {
            var arr = [];
            vm.imgflag = true;
            vm.$vux.loading.show();
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.idphoto.thumb, header).then(function (res) {
              arr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.arr = arr;
          }
          if (data.idphoto2.thumb) {
            var brr = [];
            vm.imgflag1 = true;
            vm.$vux.loading.show();
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.idphoto2.thumb, header).then(function (res) {
              brr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.brr = brr;
          }
          if (data.result === 'APPROVED') {
            vm.flag = false;
          }
        });
      }
    } else {
      next({
        path: '/'
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.idphoto = this.idphoto;
        data.idphoto2 = this.idphoto2;
        data.sequence = this.sequence;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3d3739a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/idPhoto.vue
var idPhoto_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("身份证照片")]),_vm._v(" "),_c('p',{staticClass:"p-padding"},[_vm._v("特别说明：这是一个共享的有偿服务平台，应税务部门要求，必须上传身份证材料，以便代扣人工缴个人所得税等业务时使用，您的信息将严格保密，建议增加水印上传。")]),_vm._v(" "),_c('card',{attrs:{"header":{title: '身份证正面'}}},_vm._l((_vm.arr),function(val,index){return _c('div',{key:index,staticStyle:{"height":"200px","width":"80%","border":"1px solid black","margin-left":"10%","text-align":"center"},attrs:{"slot":"content"},slot:"content"},[_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.imgflag ? 'data:image/jpeg;base64,'+val.value : _vm.img1,"name":"image1"},on:{"click":_vm.upload}})])})),_vm._v(" "),_c('card',{attrs:{"header":{title: '身份证反面'}}},_vm._l((_vm.brr),function(val,index){return _c('div',{key:index,staticStyle:{"height":"200px","width":"80%","border":"1px solid black","margin-left":"10%","text-align":"center"},attrs:{"slot":"content"},slot:"content"},[_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.imgflag1 ? 'data:image/jpeg;base64,'+val.value : _vm.img2,"name":"image2"},on:{"click":_vm.upload}})])})),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定")])],1)}
var idPhoto_staticRenderFns = []
var idPhoto_esExports = { render: idPhoto_render, staticRenderFns: idPhoto_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_idPhoto = (idPhoto_esExports);
// CONCATENATED MODULE: ./src/components/idPhoto.vue
function idPhoto_injectStyle (ssrContext) {
  __webpack_require__("oIkO")
  __webpack_require__("4JsM")
}
var idPhoto_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var idPhoto___vue_template_functional__ = false
/* styles */
var idPhoto___vue_styles__ = idPhoto_injectStyle
/* scopeId */
var idPhoto___vue_scopeId__ = "data-v-e3d3739a"
/* moduleIdentifier (server only) */
var idPhoto___vue_module_identifier__ = null
var idPhoto_Component = idPhoto_normalizeComponent(
  components_idPhoto,
  selectortype_template_index_0_src_components_idPhoto,
  idPhoto___vue_template_functional__,
  idPhoto___vue_styles__,
  idPhoto___vue_scopeId__,
  idPhoto___vue_module_identifier__
)

/* harmony default export */ var src_components_idPhoto = (idPhoto_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/eduPhoto.vue










/* harmony default export */ var eduPhoto = ({
  components: {
    Card: vux_src_components_card,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button
  },
  name: 'eduPhoto',
  data: function data() {
    return {
      company: '',
      starttime: '',
      endtime: '',
      title: '',
      img1: '/static/img/diploma.png',
      img2: '/static/img/diploma.png',
      eduphoto: { 'origin': '', 'thumb': '', 'origin_serverid': '' },
      diploma: { 'origin': '', 'thumb': '', 'origin_serverid': '' },
      account: '',
      sequence: '',
      imgflag: false,
      imgflag1: false,
      result: localStorage.getItem('result'),
      arr: [{ 'value': '' }],
      brr: [{ 'value': '' }]
    };
  },

  methods: {
    confirm: function confirm() {
      this.$router.push({ name: 'expertInfo' });
    },
    upload: function upload(event) {
      var _this = this;

      var name = event.currentTarget.name;
      if (this.result === 'TO_BE_APPROVE') {
        this.uploadImg(name);
      } else {
        this.$vux.confirm.show({
          title: '',
          content: '修改信息需要重新进行审核,将会影响接单等功能,确认修改？',
          onConfirm: function onConfirm() {
            _this.uploadImg(name);
          }
        });
      }
    },
    uploadImg: function uploadImg(name) {
      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          if (name === 'image1') {
            app.img1 = localIds[0];
          } else {
            app.img2 = localIds[0];
          }
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                if (name === 'image1') {
                  app.img1 = res.localData;
                } else {
                  app.img2 = res.localData;
                }
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              var serverId = res.serverId;
              var userInfo;
              var obj = {
                photo: []
              };
              app.$vux.loading.show();
              if (name === 'image1') {
                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  for (var i in res.data) {
                    app.eduphoto.origin = res.data[i].origin;
                    app.eduphoto.thumb = res.data[i].thumb;
                    var arr = [];
                    ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.eduphoto.origin, header).then(function (res) {
                      arr.push(res.data);
                    });
                    app.arr = arr;
                  }
                  userInfo = {
                    sequence: app.sequence,
                    eduphoto: app.eduphoto
                  };
                  app.submitImage(userInfo);
                }).catch(function (error) {
                  if (error.response) {
                    app.$vux.loading.hide();
                    if (error.response.data.error_message) {
                      app.$vux.alert.show({
                        title: '',
                        content: JSON.parse(error.response.data.error_message).zh_string
                      });
                    } else {
                      app.$vux.alert.show({
                        title: '',
                        content: '服务器错误，请稍后重试'
                      });
                    }
                  } else {
                    app.$vux.loading.hide();
                    app.$vux.alert.show({
                      title: '',
                      content: '服务器错误，请稍后重试'
                    });
                    console.log('Error', error.message);
                  }
                });
              } else {

                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  for (var i in res.data) {
                    app.diploma.origin = res.data[i].origin;
                    app.diploma.thumb = res.data[i].thumb;

                    var brr = [];
                    ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.diploma.thumb, header).then(function (res) {
                      brr.push(res.data);
                    });
                    app.brr = brr;
                  }
                  userInfo = {
                    sequence: app.sequence,
                    diploma: app.diploma
                  };
                  app.submitImage(userInfo);
                });
              }
            }
          }), 100);
        }
      });
    },
    submitImage: function submitImage(userInfo) {
      var app = this;
      var opid = localStorage.getItem('userid');
      var head = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      app.$http.put('/api/v1/experts/' + opid + '/photo', userInfo, head).then(function (response) {
        app.$vux.loading.hide();
        app.$vux.alert.show({
          title: '',
          content: '图片保存成功',
          onHide: function onHide() {
            app.sequence += 1;
          }
        });
      }).catch(function (error) {
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          } else {
            app.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.alert.show({
            title: '',
            content: '服务器错误，请稍后重试'
          });
          console.log('Error', error.message);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this2;
      _this2.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {

    var expertdata = localStorage.getItem('expertdata');
    var token = localStorage.getItem('token');
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: token,
        opid: opid
      }
    };
    if (expertdata != null) {
      var data = JSON.parse(expertdata);
      if (data) {
        next(function (vm) {
          vm.eduphoto = data.eduphoto;
          vm.diploma = data.diploma;
          vm.account = data.account;
          vm.sequence = data.sequence;
          if (data.eduphoto.thumb) {
            var arr = [];
            vm.$vux.loading.show();
            vm.imgflag = true;
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.eduphoto.thumb, header).then(function (res) {
              arr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.arr = arr;
          }
          if (data.diploma.thumb) {
            var brr = [];
            vm.imgflag1 = true;
            vm.$vux.loading.show();
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.diploma.thumb, header).then(function (res) {
              brr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.brr = brr;
          }
          if (data.result === 'APPROVED') {
            vm.flag = false;
          }
        });
      }
    } else {
      next({
        path: '/'
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.eduphoto = this.eduphoto;
        data.diploma = this.diploma;
        data.sequence = this.sequence;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/eduPhoto.vue










/* harmony default export */ var components_eduPhoto = ({
  components: {
    Card: vux_src_components_card,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button
  },
  name: 'eduPhoto',
  data: function data() {
    return {
      company: '',
      starttime: '',
      endtime: '',
      title: '',
      img1: '/static/img/diploma.png',
      img2: '/static/img/diploma.png',
      eduphoto: { 'origin': '', 'thumb': '', 'origin_serverid': '' },
      diploma: { 'origin': '', 'thumb': '', 'origin_serverid': '' },
      account: '',
      sequence: '',
      imgflag: false,
      imgflag1: false,
      result: localStorage.getItem('result'),
      arr: [{ 'value': '' }],
      brr: [{ 'value': '' }]
    };
  },

  methods: {
    confirm: function confirm() {
      this.$router.push({ name: 'expertInfo' });
    },
    upload: function upload(event) {
      var _this = this;

      var name = event.currentTarget.name;
      if (this.result === 'TO_BE_APPROVE') {
        this.uploadImg(name);
      } else {
        this.$vux.confirm.show({
          title: '',
          content: '修改信息需要重新进行审核,将会影响接单等功能,确认修改？',
          onConfirm: function onConfirm() {
            _this.uploadImg(name);
          }
        });
      }
    },
    uploadImg: function uploadImg(name) {
      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          if (name === 'image1') {
            app.img1 = localIds[0];
          } else {
            app.img2 = localIds[0];
          }
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                if (name === 'image1') {
                  app.img1 = res.localData;
                } else {
                  app.img2 = res.localData;
                }
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              var serverId = res.serverId;
              var userInfo;
              var obj = {
                photo: []
              };
              app.$vux.loading.show();
              if (name === 'image1') {
                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  for (var i in res.data) {
                    app.eduphoto.origin = res.data[i].origin;
                    app.eduphoto.thumb = res.data[i].thumb;
                    var arr = [];
                    ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.eduphoto.origin, header).then(function (res) {
                      arr.push(res.data);
                    });
                    app.arr = arr;
                  }
                  userInfo = {
                    sequence: app.sequence,
                    eduphoto: app.eduphoto
                  };
                  app.submitImage(userInfo);
                }).catch(function (error) {
                  if (error.response) {
                    app.$vux.loading.hide();
                    if (error.response.data.error_message) {
                      app.$vux.alert.show({
                        title: '',
                        content: JSON.parse(error.response.data.error_message).zh_string
                      });
                    } else {
                      app.$vux.alert.show({
                        title: '',
                        content: '服务器错误，请稍后重试'
                      });
                    }
                  } else {
                    app.$vux.loading.hide();
                    app.$vux.alert.show({
                      title: '',
                      content: '服务器错误，请稍后重试'
                    });
                    console.log('Error', error.message);
                  }
                });
              } else {

                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  for (var i in res.data) {
                    app.diploma.origin = res.data[i].origin;
                    app.diploma.thumb = res.data[i].thumb;

                    var brr = [];
                    ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.diploma.thumb, header).then(function (res) {
                      brr.push(res.data);
                    });
                    app.brr = brr;
                  }
                  userInfo = {
                    sequence: app.sequence,
                    diploma: app.diploma
                  };
                  app.submitImage(userInfo);
                });
              }
            }
          }), 100);
        }
      });
    },
    submitImage: function submitImage(userInfo) {
      var app = this;
      var opid = localStorage.getItem('userid');
      var head = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      app.$http.put('/api/v1/experts/' + opid + '/photo', userInfo, head).then(function (response) {
        app.$vux.loading.hide();
        app.$vux.alert.show({
          title: '',
          content: '图片保存成功',
          onHide: function onHide() {
            app.sequence += 1;
          }
        });
      }).catch(function (error) {
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          } else {
            app.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.alert.show({
            title: '',
            content: '服务器错误，请稍后重试'
          });
          console.log('Error', error.message);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this2;
      _this2.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {

    var expertdata = localStorage.getItem('expertdata');
    var token = localStorage.getItem('token');
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: token,
        opid: opid
      }
    };
    if (expertdata != null) {
      var data = JSON.parse(expertdata);
      if (data) {
        next(function (vm) {
          vm.eduphoto = data.eduphoto;
          vm.diploma = data.diploma;
          vm.account = data.account;
          vm.sequence = data.sequence;
          if (data.eduphoto.thumb) {
            var arr = [];
            vm.$vux.loading.show();
            vm.imgflag = true;
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.eduphoto.thumb, header).then(function (res) {
              arr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.arr = arr;
          }
          if (data.diploma.thumb) {
            var brr = [];
            vm.imgflag1 = true;
            vm.$vux.loading.show();
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.diploma.thumb, header).then(function (res) {
              brr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.brr = brr;
          }
          if (data.result === 'APPROVED') {
            vm.flag = false;
          }
        });
      }
    } else {
      next({
        path: '/'
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.eduphoto = this.eduphoto;
        data.diploma = this.diploma;
        data.sequence = this.sequence;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f447298","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eduPhoto.vue
var eduPhoto_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("学历及学位证书照片")]),_vm._v(" "),_c('p',{staticClass:"p-padding"},[_vm._v("特别说明：请保证上传信息的真实性！上传的资料精一科技将于第三方平台进行核验，以保证专家认证的严肃性。")]),_vm._v(" "),_c('card',{attrs:{"header":{title: '学历证书照片'}}},_vm._l((_vm.arr),function(val,index){return _c('div',{key:index,staticStyle:{"height":"200px","width":"80%","border":"1px solid black","margin-left":"10%","text-align":"center"},attrs:{"slot":"content"},slot:"content"},[_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.imgflag ? 'data:image/jpeg;base64,'+val.value : _vm.img1,"name":"image1"},on:{"click":_vm.upload}})])})),_vm._v(" "),_c('card',{attrs:{"header":{title: '学位证书照片'}}},_vm._l((_vm.brr),function(val,index){return _c('div',{key:index,staticStyle:{"height":"200px","width":"80%","border":"1px solid black","margin-left":"10%","text-align":"center"},attrs:{"slot":"content"},slot:"content"},[_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.imgflag1 ? 'data:image/jpeg;base64,'+val.value : _vm.img2,"name":"image2"},on:{"click":_vm.upload}})])})),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定")])],1)}
var eduPhoto_staticRenderFns = []
var eduPhoto_esExports = { render: eduPhoto_render, staticRenderFns: eduPhoto_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_eduPhoto = (eduPhoto_esExports);
// CONCATENATED MODULE: ./src/components/eduPhoto.vue
function eduPhoto_injectStyle (ssrContext) {
  __webpack_require__("7c/E")
  __webpack_require__("u1Nj")
}
var eduPhoto_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var eduPhoto___vue_template_functional__ = false
/* styles */
var eduPhoto___vue_styles__ = eduPhoto_injectStyle
/* scopeId */
var eduPhoto___vue_scopeId__ = "data-v-9f447298"
/* moduleIdentifier (server only) */
var eduPhoto___vue_module_identifier__ = null
var eduPhoto_Component = eduPhoto_normalizeComponent(
  components_eduPhoto,
  selectortype_template_index_0_src_components_eduPhoto,
  eduPhoto___vue_template_functional__,
  eduPhoto___vue_styles__,
  eduPhoto___vue_scopeId__,
  eduPhoto___vue_module_identifier__
)

/* harmony default export */ var src_components_eduPhoto = (eduPhoto_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/skillPhoto.vue










/* harmony default export */ var skillPhoto = ({
  components: {
    Card: vux_src_components_card,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button
  },
  name: 'skillPhoto',
  data: function data() {
    return {
      company: '',
      starttime: '',
      endtime: '',
      title: '',
      img1: '/static/img/skill.png',
      img2: '/static/img/skill.png',
      skillphoto: [],
      account: '',
      sequence: '',
      imgflag: false,
      imgflag1: false,
      result: localStorage.getItem('result'),
      arr: [{ 'value': '' }],
      brr: [{ 'value': '' }]
    };
  },

  methods: {
    confirm: function confirm() {
      this.$router.push({ name: 'expertInfo' });
    },
    upload: function upload(event) {
      var _this = this;

      var name = event.currentTarget.name;
      if (this.result === 'TO_BE_APPROVE') {
        this.uploadImg(name);
      } else {
        this.$vux.confirm.show({
          title: '',
          content: '修改信息需要重新进行审核,将会影响接单等功能,确认修改？',
          onConfirm: function onConfirm() {
            _this.uploadImg(name);
          }
        });
      }
    },
    uploadImg: function uploadImg(name) {
      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          if (name === 'image1') {
            app.img1 = localIds[0];
          } else {
            app.img2 = localIds[0];
          }
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                if (name === 'image1') {
                  app.img1 = res.localData;
                } else {
                  app.img2 = res.localData;
                }
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              app.$vux.loading.show();
              var serverId = res.serverId;
              var userInfo;
              var obj = {
                photo: []
              };
              if (name === 'image1') {
                obj.photo.push(serverId);

                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  var info = {
                    'origin': '',
                    'thumb': ''
                  };
                  for (var i in res.data) {
                    info.origin = res.data[i].origin;
                    info.thumb = res.data[i].thumb;
                  }
                  app.skillphoto = [];
                  app.skillphoto.push(info);
                  var arr = [];
                  ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.skillphoto[0].thumb, header).then(function (res) {
                    arr.push(res.data);
                  });
                  app.arr = arr;

                  userInfo = {
                    sequence: app.sequence,
                    skillphoto: app.skillphoto
                  };
                  app.submitImage(userInfo);
                }).catch(function (error) {
                  if (error.response) {
                    app.$vux.loading.hide();
                    if (error.response.data.error_message) {
                      app.$vux.alert.show({
                        title: '',
                        content: JSON.parse(error.response.data.error_message).zh_string
                      });
                    } else {
                      app.$vux.alert.show({
                        title: '',
                        content: '服务器错误，请稍后重试'
                      });
                    }
                  } else {
                    app.$vux.loading.hide();
                    app.$vux.alert.show({
                      title: '',
                      content: '服务器错误，请稍后重试'
                    });
                    console.log('Error', error.message);
                  }
                });
              } else {
                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  var info = {
                    'origin': '',
                    'thumb': ''
                  };
                  for (var i in res.data) {
                    app.skillphoto[1].origin = res.data[i].origin;
                    app.skillphoto[1].thumb = res.data[i].thumb;
                  }

                  var brr = [];
                  ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.skillphoto[1].thumb, header).then(function (res) {
                    brr.push(res.data);
                  });
                  app.brr = brr;

                  userInfo = {
                    sequence: app.sequence,
                    skillphoto: app.skillphoto
                  };
                  app.submitImage(userInfo);
                });
              }
            }
          }), 100);
        }
      });
    },
    submitImage: function submitImage(userInfo) {
      var app = this;
      var opid = localStorage.getItem('userid');
      var head = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      app.$http.put('/api/v1/experts/' + opid + '/photo', userInfo, head).then(function (response) {
        app.$vux.loading.hide();
        app.$vux.alert.show({
          title: '',
          content: '图片保存成功',
          onHide: function onHide() {
            app.sequence += 1;
          }
        });
      }).catch(function (error) {
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          } else {
            app.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.alert.show({
            title: '',
            content: '服务器错误，请稍后重试'
          });
          console.log('Error', error.message);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this2;
      _this2.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {

    var expertdata = localStorage.getItem('expertdata');
    var token = localStorage.getItem('token');
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: token,
        opid: opid
      }
    };
    if (expertdata != null) {
      var data = JSON.parse(expertdata);
      if (data) {
        next(function (vm) {
          vm.skillphoto = data.skillphoto;
          vm.account = data.account;
          vm.sequence = data.sequence;
          console.log(data.skillphoto);
          if (vm.skillphoto.length === 1) {
            var arr = [];
            vm.imgflag = true;
            vm.$vux.loading.show();
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.skillphoto[0].thumb, header).then(function (res) {
              arr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.arr = arr;
          } else if (vm.skillphoto.length === 2) {
            var arr = [],
                brr = [];
            vm.$vux.loading.show();
            vm.imgflag = true;
            vm.imgflag1 = true;
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.skillphoto[0].thumb, header).then(function (res) {
              arr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.arr = arr;
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.skillphoto[1].thumb, header).then(function (res) {
              brr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.brr = brr;
          }
        });
      }
    } else {
      next({
        path: '/'
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.skillphoto = this.skillphoto;
        data.sequence = this.sequence;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/skillPhoto.vue










/* harmony default export */ var components_skillPhoto = ({
  components: {
    Card: vux_src_components_card,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button
  },
  name: 'skillPhoto',
  data: function data() {
    return {
      company: '',
      starttime: '',
      endtime: '',
      title: '',
      img1: '/static/img/skill.png',
      img2: '/static/img/skill.png',
      skillphoto: [],
      account: '',
      sequence: '',
      imgflag: false,
      imgflag1: false,
      result: localStorage.getItem('result'),
      arr: [{ 'value': '' }],
      brr: [{ 'value': '' }]
    };
  },

  methods: {
    confirm: function confirm() {
      this.$router.push({ name: 'expertInfo' });
    },
    upload: function upload(event) {
      var _this = this;

      var name = event.currentTarget.name;
      if (this.result === 'TO_BE_APPROVE') {
        this.uploadImg(name);
      } else {
        this.$vux.confirm.show({
          title: '',
          content: '修改信息需要重新进行审核,将会影响接单等功能,确认修改？',
          onConfirm: function onConfirm() {
            _this.uploadImg(name);
          }
        });
      }
    },
    uploadImg: function uploadImg(name) {
      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          if (name === 'image1') {
            app.img1 = localIds[0];
          } else {
            app.img2 = localIds[0];
          }
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                if (name === 'image1') {
                  app.img1 = res.localData;
                } else {
                  app.img2 = res.localData;
                }
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              app.$vux.loading.show();
              var serverId = res.serverId;
              var userInfo;
              var obj = {
                photo: []
              };
              if (name === 'image1') {
                obj.photo.push(serverId);

                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  var info = {
                    'origin': '',
                    'thumb': ''
                  };
                  for (var i in res.data) {
                    info.origin = res.data[i].origin;
                    info.thumb = res.data[i].thumb;
                  }
                  app.skillphoto = [];
                  app.skillphoto.push(info);
                  var arr = [];
                  ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.skillphoto[0].thumb, header).then(function (res) {
                    arr.push(res.data);
                  });
                  app.arr = arr;

                  userInfo = {
                    sequence: app.sequence,
                    skillphoto: app.skillphoto
                  };
                  app.submitImage(userInfo);
                }).catch(function (error) {
                  if (error.response) {
                    app.$vux.loading.hide();
                    if (error.response.data.error_message) {
                      app.$vux.alert.show({
                        title: '',
                        content: JSON.parse(error.response.data.error_message).zh_string
                      });
                    } else {
                      app.$vux.alert.show({
                        title: '',
                        content: '服务器错误，请稍后重试'
                      });
                    }
                  } else {
                    app.$vux.loading.hide();
                    app.$vux.alert.show({
                      title: '',
                      content: '服务器错误，请稍后重试'
                    });
                    console.log('Error', error.message);
                  }
                });
              } else {
                obj.photo.push(serverId);
                ajax["a" /* default */].$http.post('/api/v1/photos/wechat', obj, header).then(function (res) {
                  var info = {
                    'origin': '',
                    'thumb': ''
                  };
                  for (var i in res.data) {
                    app.skillphoto[1].origin = res.data[i].origin;
                    app.skillphoto[1].thumb = res.data[i].thumb;
                  }

                  var brr = [];
                  ajax["a" /* default */].$http.get('api/v1/photos?path=' + app.skillphoto[1].thumb, header).then(function (res) {
                    brr.push(res.data);
                  });
                  app.brr = brr;

                  userInfo = {
                    sequence: app.sequence,
                    skillphoto: app.skillphoto
                  };
                  app.submitImage(userInfo);
                });
              }
            }
          }), 100);
        }
      });
    },
    submitImage: function submitImage(userInfo) {
      var app = this;
      var opid = localStorage.getItem('userid');
      var head = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      app.$http.put('/api/v1/experts/' + opid + '/photo', userInfo, head).then(function (response) {
        app.$vux.loading.hide();
        app.$vux.alert.show({
          title: '',
          content: '图片保存成功',
          onHide: function onHide() {
            app.sequence += 1;
          }
        });
      }).catch(function (error) {
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          } else {
            app.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.alert.show({
            title: '',
            content: '服务器错误，请稍后重试'
          });
          console.log('Error', error.message);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this2;
      _this2.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {

    var expertdata = localStorage.getItem('expertdata');
    var token = localStorage.getItem('token');
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: token,
        opid: opid
      }
    };
    if (expertdata != null) {
      var data = JSON.parse(expertdata);
      if (data) {
        next(function (vm) {
          vm.skillphoto = data.skillphoto;
          vm.account = data.account;
          vm.sequence = data.sequence;
          console.log(data.skillphoto);
          if (vm.skillphoto.length === 1) {
            var arr = [];
            vm.imgflag = true;
            vm.$vux.loading.show();
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.skillphoto[0].thumb, header).then(function (res) {
              arr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.arr = arr;
          } else if (vm.skillphoto.length === 2) {
            var arr = [],
                brr = [];
            vm.$vux.loading.show();
            vm.imgflag = true;
            vm.imgflag1 = true;
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.skillphoto[0].thumb, header).then(function (res) {
              arr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.arr = arr;
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + data.skillphoto[1].thumb, header).then(function (res) {
              brr.push(res.data);
              vm.$vux.loading.hide();
            });
            vm.brr = brr;
          }
        });
      }
    } else {
      next({
        path: '/'
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.skillphoto = this.skillphoto;
        data.sequence = this.sequence;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319d7c0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skillPhoto.vue
var skillPhoto_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("技能证书照片")]),_vm._v(" "),_c('p',{staticClass:"p-padding"},[_vm._v("特别说明：上传的相关专业技能证书越多，将有利于专家定级！同时请确保真实性。")]),_vm._v(" "),_c('card',{attrs:{"header":{title: '技能证书照片1'}}},_vm._l((_vm.arr),function(val,index){return _c('div',{key:index,staticStyle:{"height":"200px","width":"80%","border":"1px solid black","margin-left":"10%","text-align":"center"},attrs:{"slot":"content"},slot:"content"},[_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.imgflag ? 'data:image/jpeg;base64,'+val.value : _vm.img1,"name":"image1"},on:{"click":_vm.upload}})])})),_vm._v(" "),_c('card',{attrs:{"header":{title: '技能证书照片2'}}},_vm._l((_vm.brr),function(val,index){return _c('div',{key:index,staticStyle:{"height":"200px","width":"80%","border":"1px solid black","margin-left":"10%","text-align":"center"},attrs:{"slot":"content"},slot:"content"},[_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.imgflag1 ? 'data:image/jpeg;base64,'+val.value : _vm.img2,"name":"image2"},on:{"click":_vm.upload}})])})),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定")])],1)}
var skillPhoto_staticRenderFns = []
var skillPhoto_esExports = { render: skillPhoto_render, staticRenderFns: skillPhoto_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_skillPhoto = (skillPhoto_esExports);
// CONCATENATED MODULE: ./src/components/skillPhoto.vue
function skillPhoto_injectStyle (ssrContext) {
  __webpack_require__("UsvW")
  __webpack_require__("IXeR")
}
var skillPhoto_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var skillPhoto___vue_template_functional__ = false
/* styles */
var skillPhoto___vue_styles__ = skillPhoto_injectStyle
/* scopeId */
var skillPhoto___vue_scopeId__ = "data-v-319d7c0c"
/* moduleIdentifier (server only) */
var skillPhoto___vue_module_identifier__ = null
var skillPhoto_Component = skillPhoto_normalizeComponent(
  components_skillPhoto,
  selectortype_template_index_0_src_components_skillPhoto,
  skillPhoto___vue_template_functional__,
  skillPhoto___vue_styles__,
  skillPhoto___vue_scopeId__,
  skillPhoto___vue_module_identifier__
)

/* harmony default export */ var src_components_skillPhoto = (skillPhoto_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09e4095d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tip/index.vue
var tip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-group-tip",style:({'text-align':_vm.align})},[_vm._t("default")],2)}
var tip_staticRenderFns = []
var tip_esExports = { render: tip_render, staticRenderFns: tip_staticRenderFns }
/* harmony default export */ var src_components_tip = (tip_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tip/index.vue
function tip_injectStyle (ssrContext) {
  __webpack_require__("dpWl")
}
var tip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tip___vue_template_functional__ = false
/* styles */
var tip___vue_styles__ = tip_injectStyle
/* scopeId */
var tip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tip___vue_module_identifier__ = null
var tip_Component = tip_normalizeComponent(
  components_tip,
  src_components_tip,
  tip___vue_template_functional__,
  tip___vue_styles__,
  tip___vue_scopeId__,
  tip___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_tip = (tip_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/array-shuffle/index.js
var array_shuffle = __webpack_require__("HHx2");
var array_shuffle_default = /*#__PURE__*/__webpack_require__.n(array_shuffle);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = checklist_pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = checklist_pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function checklist_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */]
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = components_checklist_pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = components_checklist_pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function components_checklist_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4e59bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checklist/index.vue
var checklist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disabled ? 'vux-checklist-disabled' : ''},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}],staticClass:"weui-cells__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("after-title"),_vm._v(" "),_c('div',{staticClass:"weui-cells weui-cells_checkbox"},_vm._l((_vm.currentOptions),function(one,index){return _c('label',{staticClass:"weui-cell weui-check_label",class:{
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },attrs:{"for":("checkbox_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__hd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"checkbox","name":("vux-checkbox-" + _vm.uuid),"id":_vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),"disabled":_vm.isDisabled(_vm.getKey(one))},domProps:{"value":_vm.getKey(one),"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,_vm.getKey(one))>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.getKey(one),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),_c('i',{staticClass:"weui-icon-checked vux-checklist-icon-checked"})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getValue(one))}}),_vm._v(" "),(_vm.getInlineDesc(one))?_c('inline-desc',[_vm._v(_vm._s(_vm.getInlineDesc(one)))]):_vm._e()],1)])})),_vm._v(" "),_vm._t("footer")],2)}
var checklist_staticRenderFns = []
var checklist_esExports = { render: checklist_render, staticRenderFns: checklist_staticRenderFns }
/* harmony default export */ var src_components_checklist = (checklist_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checklist/index.vue
function checklist_injectStyle (ssrContext) {
  __webpack_require__("jQI1")
}
var checklist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checklist___vue_template_functional__ = false
/* styles */
var checklist___vue_styles__ = checklist_injectStyle
/* scopeId */
var checklist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checklist___vue_module_identifier__ = null
var checklist_Component = checklist_normalizeComponent(
  components_checklist,
  src_components_checklist,
  checklist___vue_template_functional__,
  checklist___vue_styles__,
  checklist___vue_scopeId__,
  checklist___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_checklist = (checklist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/skill.vue











function sortNumber(a, b) {
  return b - a;
}

/* harmony default export */ var skill = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    FormPreview: vux_src_components_form_preview,
    Checklist: vux_src_components_checklist
  },
  name: 'skill',
  data: function data() {
    return {
      speciality: [],
      specList: [],
      dellist: []
    };
  },

  methods: {
    delSkill: function delSkill() {
      this.dellist.sort(sortNumber);
      for (var i = 0; i < this.dellist.length; i++) {
        this.speciality.splice(this.dellist[i], 1);
        this.specList.splice(this.dellist[i], 1);
      }
      for (var j = 0; j < this.specList.length; j++) {
        this.specList[j].key = j;
      }
      this.dellist = [];
    },
    addSkill: function addSkill() {
      this.$router.push({ name: 'singleSkill' });
    },
    save: function save() {
      this.$router.push({ name: 'expertInfo' });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo' || to.name === 'singleSkill') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.speciality = this.speciality;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  },
  created: function created() {
    var expertdata = localStorage.getItem('expertdata');
    if (expertdata != null) {
      var data = JSON.parse(expertdata);
      this.speciality = data.speciality;
      for (var i = 0; i < this.speciality.length; i++) {
        var spec = this.speciality[i].superClass + '-' + this.speciality[i].subClass;
        this.specList.push({
          key: i,
          value: spec
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/skill.vue











function skill_sortNumber(a, b) {
  return b - a;
}

/* harmony default export */ var components_skill = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    FormPreview: vux_src_components_form_preview,
    Checklist: vux_src_components_checklist
  },
  name: 'skill',
  data: function data() {
    return {
      speciality: [],
      specList: [],
      dellist: []
    };
  },

  methods: {
    delSkill: function delSkill() {
      this.dellist.sort(skill_sortNumber);
      for (var i = 0; i < this.dellist.length; i++) {
        this.speciality.splice(this.dellist[i], 1);
        this.specList.splice(this.dellist[i], 1);
      }
      for (var j = 0; j < this.specList.length; j++) {
        this.specList[j].key = j;
      }
      this.dellist = [];
    },
    addSkill: function addSkill() {
      this.$router.push({ name: 'singleSkill' });
    },
    save: function save() {
      this.$router.push({ name: 'expertInfo' });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'expertInfo' || to.name === 'singleSkill') {
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        data.speciality = this.speciality;
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
    } else {
      localStorage.removeItem('expertdata');
    }
    next();
  },
  created: function created() {
    var expertdata = localStorage.getItem('expertdata');
    if (expertdata != null) {
      var data = JSON.parse(expertdata);
      this.speciality = data.speciality;
      for (var i = 0; i < this.speciality.length; i++) {
        var spec = this.speciality[i].superClass + '-' + this.speciality[i].subClass;
        this.specList.push({
          key: i,
          value: spec
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9461d460","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skill.vue
var skill_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("专业特长")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('checklist',{attrs:{"title":_vm.专业特长,"label-position":_vm.left,"required":"","options":_vm.specList},model:{value:(_vm.dellist),callback:function ($$v) {_vm.dellist=$$v},expression:"dellist"}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.addSkill($event)}}},[_vm._v("添加")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.delSkill($event)}}},[_vm._v("删除")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("完成")])],1)}
var skill_staticRenderFns = []
var skill_esExports = { render: skill_render, staticRenderFns: skill_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_skill = (skill_esExports);
// CONCATENATED MODULE: ./src/components/skill.vue
var skill_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var skill___vue_template_functional__ = false
/* styles */
var skill___vue_styles__ = null
/* scopeId */
var skill___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var skill___vue_module_identifier__ = null
var skill_Component = skill_normalizeComponent(
  components_skill,
  selectortype_template_index_0_src_components_skill,
  skill___vue_template_functional__,
  skill___vue_styles__,
  skill___vue_scopeId__,
  skill___vue_module_identifier__
)

/* harmony default export */ var src_components_skill = (skill_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/singleSkill.vue










/* harmony default export */ var singleSkill = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Alert: components_alert["a" /* default */]
  },
  name: 'singleSkill',
  data: function data() {
    return {
      list1: ['存储', '网络', '服务器/工作站', '数据库', '中间件', '云计算', 'Harmonic', 'ROSS', '其他IT专业'],
      superClass: '存储',
      list2: ['精一F1S2000', '精一F1S3000', '精一F1S5000', '精一F1S9000', '精一云汉', '精一海德/领航'],
      subClass1: '精一F1S2000',
      selisShow: true,
      inputisShow: false,
      subClass: ''
    };
  },

  methods: {
    addSkill: function addSkill() {
      var spec = {
        'superClass': this.superClass,
        'subClass': ''
      };
      spec.subClass = this.selisShow ? this.subClass1 : this.subClass2;
      var quit = false;
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        if (data.speciality === null) {
          data.speciality = [];
        }
        for (var i = 0; i < data.speciality.length; i++) {
          if (spec.superClass === data.speciality[i].superClass && spec.subClass === data.speciality[i].subClass) {
            quit = true;
            this.$vux.alert.show({
              title: '',
              content: '专业特长已存在，不能重复添加'
            });
            break;
          }
        }
        if (quit) {
          return;
        }
        data.speciality.push(spec);
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
      this.$router.push({ name: 'skill' });
    },
    superclassChange: function superclassChange(val) {
      switch (val) {
        case '存储':
          this.list2 = ['精一F1S2000', '精一F1S3000', '精一F1S5000', '精一F1S9000', '精一云汉', '精一海德/领航'];
          this.subClass1 = '精一F1S2000';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '网络':
          this.list2 = ['H3C盒式交换机', '锐捷盒式交换机'];
          this.subClass1 = 'H3C盒式交换机';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '服务器/工作站':
          this.list2 = ['精一云际'];
          this.subClass1 = '精一云际';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '数据库':
          this.list2 = ['微软SQLServer', '甲骨文Oracle', 'IBM DB2'];
          this.subClass1 = '微软SQLServer';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '中间件':
          this.list2 = ['Apache/Tomcat'];
          this.subClass1 = 'Apache/Tomcat';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '云计算':
          this.list2 = ['Vmware vSphere'];
          this.subClass1 = 'Vmware vSphere';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case 'Harmonic':
          this.list2 = ['视频服务器'];
          this.subClass1 = '视频服务器';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case 'ROSS':
          this.list2 = ['视频服务器', '矩阵及周边'];
          this.subClass1 = '视频服务器';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '其他IT专业':
          this.selisShow = false;
          this.inputisShow = true;

          break;

        default:
          break;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/singleSkill.vue










/* harmony default export */ var components_singleSkill = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Alert: components_alert["a" /* default */]
  },
  name: 'singleSkill',
  data: function data() {
    return {
      list1: ['存储', '网络', '服务器/工作站', '数据库', '中间件', '云计算', 'Harmonic', 'ROSS', '其他IT专业'],
      superClass: '存储',
      list2: ['精一F1S2000', '精一F1S3000', '精一F1S5000', '精一F1S9000', '精一云汉', '精一海德/领航'],
      subClass1: '精一F1S2000',
      selisShow: true,
      inputisShow: false,
      subClass: ''
    };
  },

  methods: {
    addSkill: function addSkill() {
      var spec = {
        'superClass': this.superClass,
        'subClass': ''
      };
      spec.subClass = this.selisShow ? this.subClass1 : this.subClass2;
      var quit = false;
      var expertdata = localStorage.getItem('expertdata');
      if (expertdata != null) {
        var data = JSON.parse(expertdata);
        if (data.speciality === null) {
          data.speciality = [];
        }
        for (var i = 0; i < data.speciality.length; i++) {
          if (spec.superClass === data.speciality[i].superClass && spec.subClass === data.speciality[i].subClass) {
            quit = true;
            this.$vux.alert.show({
              title: '',
              content: '专业特长已存在，不能重复添加'
            });
            break;
          }
        }
        if (quit) {
          return;
        }
        data.speciality.push(spec);
        expertdata = stringify_default()(data);
        localStorage.setItem('expertdata', expertdata);
      }
      this.$router.push({ name: 'skill' });
    },
    superclassChange: function superclassChange(val) {
      switch (val) {
        case '存储':
          this.list2 = ['精一F1S2000', '精一F1S3000', '精一F1S5000', '精一F1S9000', '精一云汉', '精一海德/领航'];
          this.subClass1 = '精一F1S2000';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '网络':
          this.list2 = ['H3C盒式交换机', '锐捷盒式交换机'];
          this.subClass1 = 'H3C盒式交换机';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '服务器/工作站':
          this.list2 = ['精一云际'];
          this.subClass1 = '精一云际';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '数据库':
          this.list2 = ['微软SQLServer', '甲骨文Oracle', 'IBM DB2'];
          this.subClass1 = '微软SQLServer';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '中间件':
          this.list2 = ['Apache/Tomcat'];
          this.subClass1 = 'Apache/Tomcat';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '云计算':
          this.list2 = ['Vmware vSphere'];
          this.subClass1 = 'Vmware vSphere';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case 'Harmonic':
          this.list2 = ['视频服务器'];
          this.subClass1 = '视频服务器';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case 'ROSS':
          this.list2 = ['视频服务器', '矩阵及周边'];
          this.subClass1 = '视频服务器';
          this.selisShow = true;
          this.inputisShow = false;
          break;
        case '其他IT专业':
          this.selisShow = false;
          this.inputisShow = true;

          break;

        default:
          break;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff840cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/singleSkill.vue
var singleSkill_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("添加专业特长")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('group',{attrs:{"title":"专业类别"}},[_c('selector',{attrs:{"options":_vm.list1},on:{"on-change":_vm.superclassChange},model:{value:(_vm.superClass),callback:function ($$v) {_vm.superClass=$$v},expression:"superClass"}})],1),_vm._v(" "),_c('group',{directives:[{name:"show",rawName:"v-show",value:(_vm.selisShow),expression:"selisShow"}],attrs:{"title":"子类"}},[_c('selector',{attrs:{"placeholder":"请选择子类","options":_vm.list2},model:{value:(_vm.subClass1),callback:function ($$v) {_vm.subClass1=$$v},expression:"subClass1"}})],1),_vm._v(" "),_c('group',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputisShow),expression:"inputisShow"}],attrs:{"title":"自定义"}},[_c('x-input',{attrs:{"placeholder":"请输入自定义类型"},model:{value:(_vm.subClass2),callback:function ($$v) {_vm.subClass2=$$v},expression:"subClass2"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.addSkill($event)}}},[_vm._v("确定")])],1)}
var singleSkill_staticRenderFns = []
var singleSkill_esExports = { render: singleSkill_render, staticRenderFns: singleSkill_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_singleSkill = (singleSkill_esExports);
// CONCATENATED MODULE: ./src/components/singleSkill.vue
var singleSkill_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var singleSkill___vue_template_functional__ = false
/* styles */
var singleSkill___vue_styles__ = null
/* scopeId */
var singleSkill___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var singleSkill___vue_module_identifier__ = null
var singleSkill_Component = singleSkill_normalizeComponent(
  components_singleSkill,
  selectortype_template_index_0_src_components_singleSkill,
  singleSkill___vue_template_functional__,
  singleSkill___vue_styles__,
  singleSkill___vue_scopeId__,
  singleSkill___vue_module_identifier__
)

/* harmony default export */ var src_components_singleSkill = (singleSkill_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/sticky/sticky.js
var sticky = __webpack_require__("58JO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var src_components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02f41544","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/sticky/index.vue
var sticky_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-sticky-box"},[_vm._t("default")],2)}
var sticky_staticRenderFns = []
var sticky_esExports = { render: sticky_render, staticRenderFns: sticky_staticRenderFns }
/* harmony default export */ var vux_src_components_sticky = (sticky_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/sticky/index.vue
function sticky_injectStyle (ssrContext) {
  __webpack_require__("ukTf")
}
var sticky_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sticky___vue_template_functional__ = false
/* styles */
var sticky___vue_styles__ = sticky_injectStyle
/* scopeId */
var sticky___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sticky___vue_module_identifier__ = null
var sticky_Component = sticky_normalizeComponent(
  src_components_sticky,
  vux_src_components_sticky,
  sticky___vue_template_functional__,
  sticky___vue_styles__,
  sticky___vue_scopeId__,
  sticky___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_sticky = (sticky_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe8f518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){_vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){_vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}))])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("d1Im")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd6837a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ad2681","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("WDiO")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b8ab944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/invitation.vue










/* harmony default export */ var invitation = ({
  components: {
    XHeader: vux_src_components_x_header,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Sticky: node_modules_vux_src_components_sticky,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  name: 'invitation',
  data: function data() {
    return {

      list: [],
      select: '',
      index: 0,
      auditlist: [],
      needAuditlist: []
    };
  },
  created: function created() {
    var opid = localStorage.getItem('userid');
    var head = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    var app = this;
    this.$http.get('/api/v1/accounts/' + opid + '/recommend', head).then(function (response) {
      for (var i = 0; i < response.data.length; i++) {
        if (response.data[i].need_audit === false) {
          app.auditlist.push(response.data[i]);
        } else {
          app.needAuditlist.push(response.data[i]);
        }
      }
      app.list.push('审核通过（' + app.auditlist.length + ')');
      app.list.push('待审核（' + app.needAuditlist.length + ')');
      app.select = app.list[0];
    }).catch(function (error) {
      if (error.response) {
        if (error.response.data.error_message) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        } else {
          app.$vux.alert.show({
            title: '',
            content: '服务器错误，请稍后重试'
          });
        }
      } else {
        app.$vux.alert.show({
          title: '',
          content: '服务器错误，请稍后重试'
        });
        console.log('Error', error.message);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/invitation.vue










/* harmony default export */ var components_invitation = ({
  components: {
    XHeader: vux_src_components_x_header,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Sticky: node_modules_vux_src_components_sticky,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  name: 'invitation',
  data: function data() {
    return {

      list: [],
      select: '',
      index: 0,
      auditlist: [],
      needAuditlist: []
    };
  },
  created: function created() {
    var opid = localStorage.getItem('userid');
    var head = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    var app = this;
    this.$http.get('/api/v1/accounts/' + opid + '/recommend', head).then(function (response) {
      for (var i = 0; i < response.data.length; i++) {
        if (response.data[i].need_audit === false) {
          app.auditlist.push(response.data[i]);
        } else {
          app.needAuditlist.push(response.data[i]);
        }
      }
      app.list.push('审核通过（' + app.auditlist.length + ')');
      app.list.push('待审核（' + app.needAuditlist.length + ')');
      app.select = app.list[0];
    }).catch(function (error) {
      if (error.response) {
        if (error.response.data.error_message) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        } else {
          app.$vux.alert.show({
            title: '',
            content: '服务器错误，请稍后重试'
          });
        }
      } else {
        app.$vux.alert.show({
          title: '',
          content: '服务器错误，请稍后重试'
        });
        console.log('Error', error.message);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7906ea20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/invitation.vue
var invitation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("我的推荐")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('tab',{attrs:{"line-width":2,"active-color":"#fc378c"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.list),function(item,index){return _c('tab-item',{key:index,staticClass:"vux-center",attrs:{"selected":_vm.select === item},on:{"click":function($event){_vm.select = item}}},[_vm._v(_vm._s(item)+"\n            ")])})),_vm._v(" "),(_vm.index === 0)?_c('div',{staticClass:"tab-swiper vux-center"},_vm._l((_vm.auditlist),function(account,index){return _c('p',{key:index},[_vm._v("姓名："+_vm._s(account.name)+" 手机号："+_vm._s(account.account))])})):_vm._e(),_vm._v(" "),(_vm.index === 1)?_c('div',{staticClass:"tab-swiper vux-center"},_vm._l((_vm.needAuditlist),function(account,index){return _c('p',{key:index},[_vm._v("姓名："+_vm._s(account.name)+"\n                手机号："+_vm._s(account.account))])})):_vm._e()],1)],1)}
var invitation_staticRenderFns = []
var invitation_esExports = { render: invitation_render, staticRenderFns: invitation_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_invitation = (invitation_esExports);
// CONCATENATED MODULE: ./src/components/invitation.vue
var invitation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var invitation___vue_template_functional__ = false
/* styles */
var invitation___vue_styles__ = null
/* scopeId */
var invitation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var invitation___vue_module_identifier__ = null
var invitation_Component = invitation_normalizeComponent(
  components_invitation,
  selectortype_template_index_0_src_components_invitation,
  invitation___vue_template_functional__,
  invitation___vue_styles__,
  invitation___vue_scopeId__,
  invitation___vue_module_identifier__
)

/* harmony default export */ var src_components_invitation = (invitation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/protocal.vue







/* harmony default export */ var protocal = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */]
  },
  name: 'protocal'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/protocal.vue







/* harmony default export */ var components_protocal = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */]
  },
  name: 'protocal'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b6917ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/protocal.vue
var protocal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("云帷合作协议")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0)],1)}
var protocal_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-left":"10px"}},[_c('p',[_vm._v("\n        “好云帷”是专业IT产品运维平台，致力于为IT专业产品用户提供专业化、本地化、共享化的专家服务，为明确各签约个人专家（以下简称您）的权利和义务关系，特制订本协议。您在点击‘同意’之前，请认真阅读以下条款，点击同意之后，方可进行下一步个人专家注册工作。"),_c('br'),_vm._v("\n        1、基于对专业用户服务质量的保证，您必须保证所提交的注册信息的真实性。我方有权对任何提交不真实信息的个人申请者不予审核通过，或在合作过程中发现存在不真实信息情况，予以随时中止合作；"),_c('br'),_vm._v("\n        2、您所提交的信息，我方不会透露给任何第三方。在您未提供任何专业服务的情况下，或您提供专业服务并取得用户验收报告3个月后，您有权随时退出本协议，您的信息我方将永久性删除；"),_c('br'),_vm._v("\n        3、您所提供的专业服务均为有偿服务，我方有权利对您的服务能力进行评级，并根据评级，进行工作任务分派；"),_c('br'),_vm._v("\n        4、在您根据委托提供专业服务时，必须严格按照提供的操作规范进行，提醒现场用户进行必要的数据保护、备份等工作，否则产生的纠纷或损失您将负有连带责任；"),_c('br'),_vm._v("\n        5、除您获得劳务报酬外，您的每一次专业服务的质量将成为您在好云帷的信用积分，这有可能转化为将来好云帷的股份，具体标准视好云帷发展情况制订并公布；"),_c('br'),_vm._v("\n        6、其他更详细的业务规则，请注册后仔细查阅。"),_c('br')])])}]
var protocal_esExports = { render: protocal_render, staticRenderFns: protocal_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_protocal = (protocal_esExports);
// CONCATENATED MODULE: ./src/components/protocal.vue
var protocal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var protocal___vue_template_functional__ = false
/* styles */
var protocal___vue_styles__ = null
/* scopeId */
var protocal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var protocal___vue_module_identifier__ = null
var protocal_Component = protocal_normalizeComponent(
  components_protocal,
  selectortype_template_index_0_src_components_protocal,
  protocal___vue_template_functional__,
  protocal___vue_styles__,
  protocal___vue_scopeId__,
  protocal___vue_module_identifier__
)

/* harmony default export */ var src_components_protocal = (protocal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/wallet.vue










/* harmony default export */ var wallet = ({
  name: 'wallet',
  components: {
    Card: vux_src_components_card,
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    Badge: vux_src_components_badge,
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      account: '',
      withdraw: 0.00,
      availwd: 0.00,
      nowithdraw: 0.00,
      show3: false
    };
  },

  methods: {
    recharge: function recharge() {
      this.show3 = true;
    }
  },
  created: function created() {
    var opid = localStorage.getItem('userid');
    var obj = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    var app = this;
    this.$http.get('/api/v1/payments/' + opid + '/wallet', obj).then(function (response) {
      console.log(response.data);
      app.availwd = parseFloat(response.data.availwd);
      app.withdraw = parseFloat(response.data.withdraw);
      app.nowithdraw = parseFloat(response.data.nowithdraw);
    }).catch(function (error) {
      if (error.response) {

        console.log(error.response.data);
        if (error.response.data.error_message) {
          app.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).faultstring,
            type: 'cancel',
            time: '1000'
          });
        }
      } else if (error.request) {

        console.log(error.request);
      } else {

        console.log('Error', error.message);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/wallet.vue










/* harmony default export */ var components_wallet = ({
  name: 'wallet',
  components: {
    Card: vux_src_components_card,
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    Badge: vux_src_components_badge,
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      account: '',
      withdraw: 0.00,
      availwd: 0.00,
      nowithdraw: 0.00,
      show3: false
    };
  },

  methods: {
    recharge: function recharge() {
      this.show3 = true;
    }
  },
  created: function created() {
    var opid = localStorage.getItem('userid');
    var obj = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    var app = this;
    this.$http.get('/api/v1/payments/' + opid + '/wallet', obj).then(function (response) {
      console.log(response.data);
      app.availwd = parseFloat(response.data.availwd);
      app.withdraw = parseFloat(response.data.withdraw);
      app.nowithdraw = parseFloat(response.data.nowithdraw);
    }).catch(function (error) {
      if (error.response) {

        console.log(error.response.data);
        if (error.response.data.error_message) {
          app.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).faultstring,
            type: 'cancel',
            time: '1000'
          });
        }
      } else if (error.request) {

        console.log(error.request);
      } else {

        console.log('Error', error.message);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-513d8d18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wallet.vue
var wallet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card',[_c('div',{staticClass:"divWallet",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticStyle:{"width":"100%","height":"100px","text-align":"center","padding":"30px 0"}},[_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("个人账户")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"4em"}},[_vm._v(_vm._s((_vm.withdraw + _vm.nowithdraw).toFixed(2)))])]),_vm._v(" "),_c('div',{staticClass:"divWalletBottom"},[_c('div',{staticClass:"vux-1px-r"},[_c('span',[_vm._v(_vm._s(_vm.availwd.toFixed(2)))]),_vm._v(" "),_c('br'),_vm._v("\n          可提现金额\n        ")]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r"},[_c('span',[_vm._v(_vm._s((_vm.withdraw + _vm.nowithdraw - _vm.availwd).toFixed(2)))]),_vm._v(" "),_c('br'),_vm._v("\n          不可提现金额\n        ")])])])]),_vm._v(" "),_c('group',[_c('cell',{attrs:{"title":"充值","is-link":"","link":{ name: 'recharge'}}}),_vm._v(" "),_c('cell',{attrs:{"title":"提现","is-link":"","link":{ name: 'withdraw'}}}),_vm._v(" "),_c('cell',{attrs:{"title":"零钱明细","is-link":"","link":{ name: 'orders'}}}),_vm._v(" "),_c('cell',{attrs:{"title":"待支付订单","is-link":"","link":{ name: 'needpay'}}})],1)],1)}
var wallet_staticRenderFns = []
var wallet_esExports = { render: wallet_render, staticRenderFns: wallet_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_wallet = (wallet_esExports);
// CONCATENATED MODULE: ./src/components/wallet.vue
function wallet_injectStyle (ssrContext) {
  __webpack_require__("8eG9")
}
var wallet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var wallet___vue_template_functional__ = false
/* styles */
var wallet___vue_styles__ = wallet_injectStyle
/* scopeId */
var wallet___vue_scopeId__ = "data-v-513d8d18"
/* moduleIdentifier (server only) */
var wallet___vue_module_identifier__ = null
var wallet_Component = wallet_normalizeComponent(
  components_wallet,
  selectortype_template_index_0_src_components_wallet,
  wallet___vue_template_functional__,
  wallet___vue_styles__,
  wallet___vue_scopeId__,
  wallet___vue_module_identifier__
)

/* harmony default export */ var src_components_wallet = (wallet_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/recharge.vue















/* harmony default export */ var components_recharge = ({
  name: 'recharge',
  components: {
    Group: group["a" /* default */],
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input,
    CheckIcon: vux_src_components_check_icon,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Selector: vux_src_components_selector,
    Card: vux_src_components_card
  },
  data: function data() {
    return {
      opid: '',
      amount: '',
      issue: false,
      invoiceType: 1,
      invoiceTitle: 2,
      invoice: {
        content: {
          company: '',
          taxNumber: '',
          bank: '',
          bankAccount: '',
          address: '',
          tel: ''
        },
        type: ''
      },
      type: 'online',
      type_list: [{ key: 'online', value: '微信充值' }, { key: 'offline', value: '线下充值' }],
      img: '/static/img/bill.png',
      bill: '',
      invoice_first: false,
      invoice_or_bill: 2,
      account_type: 'person'
    };
  },

  methods: {
    invoice_or_bill_change: function invoice_or_bill_change() {
      if (this.invoice_or_bill === 1) {
        this.invoice_first = true;
        this.issue = true;
      } else {
        this.invoice_first = false;
        this.issue = false;
      }
    },
    recharge: function recharge() {
      if (this.amount === '') {
        this.$vux.alert.show({
          title: '',
          content: '请输入充值金额'
        });
        return;
      }
      console.log(this.invoice);
      if (this.issue) {
        if (this.invoiceTitle === 2) {
          if (this.invoice.content.company === '' || this.invoice.content.taxNumber === '') {
            this.$vux.alert.show({
              title: '',
              content: '请补全发票信息后再提交'
            });
            return;
          }
        }
        if (this.invoiceType === 2) {
          if (this.invoice.content.bank === '' || this.invoice.content.bankAccount === '' || this.invoice.content.address === '' || this.invoice.content.tel === '') {
            this.$vux.alert.show({
              title: '',
              content: '请补全发票信息后再提交'
            });
            return;
          }
        }
      }
      var obj = {
        headers: {
          token: localStorage.getItem('token'),
          opid: this.opid
        }
      };
      var app = this;
      var data;
      if (this.type === 'online') {
        data = {
          body: '云帷充值',
          amount: this.amount,
          openid: localStorage.getItem('openid'),
          issue: this.issue,
          invoice: {
            content: {
              company: '',
              taxNumber: '',
              bank: '',
              bankAccount: '',
              address: '',
              tel: ''
            },
            type: ''
          },
          userip: '127.0.0.1'
        };
        if (this.issue) {
          data.invoice.content = this.invoice.content;
          switch (this.invoiceType) {
            case 1:
              data.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit';
              break;
            default:
              data.invoice.type = 'VatSpecialInvoice';
              break;
          }
        }
        this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=wx_recharge', data, obj).then(function (response) {
          weixin_js_sdk_default.a.chooseWXPay({
            timestamp: response.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: response.data.nonceStr, // 支付签名随机串，不长于 32 位
            package: response.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: response.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: response.data.paySign, // 支付签名
            success: function success(res) {
              app.$router.push({ name: 'wallet' });
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data.error_message) {
              app.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      } else {
        if (this.bill === '') {
          this.$vux.alert.show({
            title: '',
            content: '请上传发票凭据后再提交'
          });
          return;
        }
        data = {
          amount: this.amount,
          bill: this.bill,
          invoice_first: this.invoice_first,
          issue: this.issue,
          invoice: {
            content: {
              company: '',
              taxNumber: '',
              bank: '',
              bankAccount: '',
              address: '',
              tel: ''
            },
            type: ''
          }
        };
        if (this.invoice_first && !this.issue) {
          this.$vux.alert.show({
            title: '',
            content: '请填写发票信息后再提交'
          });
          return;
        }
        if (this.issue) {
          data.invoice.content = this.invoice.content;
          switch (this.invoiceType) {
            case 1:
              data.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit';
              break;
            default:
              data.invoice.type = 'VatSpecialInvoice';
              break;
          }
        }
        var obj = {
          headers: {
            token: localStorage.getItem('token'),
            opid: this.opid
          }
        };
        this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=bank_recharge', data, obj).then(function (response) {
          if (data.invoice_first) {
            app.$vux.alert.show({
              title: '',
              content: '提交成功，请收到发票后尽快汇款，并上传汇款凭据'
            });
          } else {
            app.$vux.alert.show({
              title: '',
              content: '充值请求提交成功，请等待后台审核'
            });
          }
          app.$router.push({ name: 'wallet' });
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            if (error.response.data.error_message) {
              app.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }
    },

    upload: function upload(event) {
      var app = this;
      var obj = {
        headers: {
          token: localStorage.getItem('token'),
          opid: this.opid
        }
      };
      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          app.img = localIds[0];
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                app.img = res.localData;
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              var serverId = res.serverId;
              app.$http.get('/api/v1/payments/' + app.opid + '/orders?type=bill&serverid=' + serverId, obj).then(function (response) {
                app.bill = response.data[0];
              }).catch(function (error) {
                alert('服务器错误，请稍后重试');
                if (error.response) {
                  console.log(error.response.data);
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
              });
            }
          }), 100);
        }

      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.opid = localStorage.getItem('userid');
    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this;
      _this.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/recharge.vue















/* harmony default export */ var selectortype_script_index_0_src_components_recharge = ({
  name: 'recharge',
  components: {
    Group: group["a" /* default */],
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input,
    CheckIcon: vux_src_components_check_icon,
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    Selector: vux_src_components_selector,
    Card: vux_src_components_card
  },
  data: function data() {
    return {
      opid: '',
      amount: '',
      issue: false,
      invoiceType: 1,
      invoiceTitle: 2,
      invoice: {
        content: {
          company: '',
          taxNumber: '',
          bank: '',
          bankAccount: '',
          address: '',
          tel: ''
        },
        type: ''
      },
      type: 'online',
      type_list: [{ key: 'online', value: '微信充值' }, { key: 'offline', value: '线下充值' }],
      img: '/static/img/bill.png',
      bill: '',
      invoice_first: false,
      invoice_or_bill: 2,
      account_type: 'person'
    };
  },

  methods: {
    invoice_or_bill_change: function invoice_or_bill_change() {
      if (this.invoice_or_bill === 1) {
        this.invoice_first = true;
        this.issue = true;
      } else {
        this.invoice_first = false;
        this.issue = false;
      }
    },
    recharge: function recharge() {
      if (this.amount === '') {
        this.$vux.alert.show({
          title: '',
          content: '请输入充值金额'
        });
        return;
      }
      console.log(this.invoice);
      if (this.issue) {
        if (this.invoiceTitle === 2) {
          if (this.invoice.content.company === '' || this.invoice.content.taxNumber === '') {
            this.$vux.alert.show({
              title: '',
              content: '请补全发票信息后再提交'
            });
            return;
          }
        }
        if (this.invoiceType === 2) {
          if (this.invoice.content.bank === '' || this.invoice.content.bankAccount === '' || this.invoice.content.address === '' || this.invoice.content.tel === '') {
            this.$vux.alert.show({
              title: '',
              content: '请补全发票信息后再提交'
            });
            return;
          }
        }
      }
      var obj = {
        headers: {
          token: localStorage.getItem('token'),
          opid: this.opid
        }
      };
      var app = this;
      var data;
      if (this.type === 'online') {
        data = {
          body: '云帷充值',
          amount: this.amount,
          openid: localStorage.getItem('openid'),
          issue: this.issue,
          invoice: {
            content: {
              company: '',
              taxNumber: '',
              bank: '',
              bankAccount: '',
              address: '',
              tel: ''
            },
            type: ''
          },
          userip: '127.0.0.1'
        };
        if (this.issue) {
          data.invoice.content = this.invoice.content;
          switch (this.invoiceType) {
            case 1:
              data.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit';
              break;
            default:
              data.invoice.type = 'VatSpecialInvoice';
              break;
          }
        }
        this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=wx_recharge', data, obj).then(function (response) {
          weixin_js_sdk_default.a.chooseWXPay({
            timestamp: response.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: response.data.nonceStr, // 支付签名随机串，不长于 32 位
            package: response.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: response.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: response.data.paySign, // 支付签名
            success: function success(res) {
              app.$router.push({ name: 'wallet' });
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data.error_message) {
              app.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      } else {
        if (this.bill === '') {
          this.$vux.alert.show({
            title: '',
            content: '请上传发票凭据后再提交'
          });
          return;
        }
        data = {
          amount: this.amount,
          bill: this.bill,
          invoice_first: this.invoice_first,
          issue: this.issue,
          invoice: {
            content: {
              company: '',
              taxNumber: '',
              bank: '',
              bankAccount: '',
              address: '',
              tel: ''
            },
            type: ''
          }
        };
        if (this.invoice_first && !this.issue) {
          this.$vux.alert.show({
            title: '',
            content: '请填写发票信息后再提交'
          });
          return;
        }
        if (this.issue) {
          data.invoice.content = this.invoice.content;
          switch (this.invoiceType) {
            case 1:
              data.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit';
              break;
            default:
              data.invoice.type = 'VatSpecialInvoice';
              break;
          }
        }
        var obj = {
          headers: {
            token: localStorage.getItem('token'),
            opid: this.opid
          }
        };
        this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=bank_recharge', data, obj).then(function (response) {
          if (data.invoice_first) {
            app.$vux.alert.show({
              title: '',
              content: '提交成功，请收到发票后尽快汇款，并上传汇款凭据'
            });
          } else {
            app.$vux.alert.show({
              title: '',
              content: '充值请求提交成功，请等待后台审核'
            });
          }
          app.$router.push({ name: 'wallet' });
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            if (error.response.data.error_message) {
              app.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }
    },

    upload: function upload(event) {
      var app = this;
      var obj = {
        headers: {
          token: localStorage.getItem('token'),
          opid: this.opid
        }
      };
      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          app.img = localIds[0];
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                app.img = res.localData;
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              var serverId = res.serverId;
              app.$http.get('/api/v1/payments/' + app.opid + '/orders?type=bill&serverid=' + serverId, obj).then(function (response) {
                app.bill = response.data[0];
              }).catch(function (error) {
                alert('服务器错误，请稍后重试');
                if (error.response) {
                  console.log(error.response.data);
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
              });
            }
          }), 100);
        }

      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.opid = localStorage.getItem('userid');
    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this;
      _this.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cd7b5b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recharge.vue
var recharge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('selector',{attrs:{"title":"充值方式","options":_vm.type_list},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}}),_vm._v(" "),((_vm.type === 'offline') && (_vm.account_type === 'company'))?_c('checker',{attrs:{"default-item-class":"type-check-item","selected-item-class":"check-item-selected","radio-required":""},on:{"on-change":_vm.invoice_or_bill_change},model:{value:(_vm.invoice_or_bill),callback:function ($$v) {_vm.invoice_or_bill=$$v},expression:"invoice_or_bill"}},[_c('checker-item',{attrs:{"value":1}},[_vm._v("先开发票")]),_vm._v(" "),_c('checker-item',{attrs:{"value":2}},[_vm._v("上传汇款凭据")])],1):_vm._e(),_vm._v(" "),((_vm.type === 'offline') && (_vm.invoice_or_bill === 2))?_c('card',{attrs:{"header":{title: '请上传汇款凭据'}}},[_c('div',{staticStyle:{"height":"200px","width":"80%","border":"1px solid black","margin-left":"10%","text-align":"center","margin-bottom":"20px"},attrs:{"slot":"content"},slot:"content"},[_c('img',{staticStyle:{"width":"auto","height":"auto","max-width":"100%","max-height":"100%"},attrs:{"src":_vm.img,"name":"image"},on:{"click":_vm.upload}})])]):_vm._e()],1),_vm._v(" "),_c('group',{attrs:{"title":"充值金额"}},[_c('x-input',{attrs:{"title":"￥","type":"number","required":""},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1),_vm._v(" "),_c('check-icon',{attrs:{"value":_vm.issue},on:{"update:value":function($event){_vm.issue=$event}}},[_vm._v("开具发票")]),_vm._v(" "),(_vm.issue)?_c('div',{staticStyle:{"padding":"15px"}},[_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("发票类型")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"type-check-item","selected-item-class":"check-item-selected","radio-required":""},model:{value:(_vm.invoiceType),callback:function ($$v) {_vm.invoiceType=$$v},expression:"invoiceType"}},[_c('checker-item',{attrs:{"value":1}},[_vm._v("增值税普通发票")]),_vm._v(" "),_c('checker-item',{attrs:{"value":2}},[_vm._v("增值税专用发票")])],1),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("发票抬头")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"title-check-item","selected-item-class":"check-item-selected","radio-required":""},model:{value:(_vm.invoiceTitle),callback:function ($$v) {_vm.invoiceTitle=$$v},expression:"invoiceTitle"}},[(_vm.invoiceType == 1)?_c('checker-item',{attrs:{"value":1}},[_vm._v("个人")]):_vm._e(),_vm._v(" "),_c('checker-item',{attrs:{"value":2}},[_vm._v("单位")])],1),_vm._v(" "),(_vm.invoiceTitle == 2)?_c('group',[_c('x-input',{attrs:{"title":"单位名称","type":"text"},model:{value:(_vm.invoice.content.company),callback:function ($$v) {_vm.$set(_vm.invoice.content, "company", $$v)},expression:"invoice.content.company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"纳税人识别号","type":"text"},model:{value:(_vm.invoice.content.taxNumber),callback:function ($$v) {_vm.$set(_vm.invoice.content, "taxNumber", $$v)},expression:"invoice.content.taxNumber"}}),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"开户银行","type":"text"},model:{value:(_vm.invoice.content.bank),callback:function ($$v) {_vm.$set(_vm.invoice.content, "bank", $$v)},expression:"invoice.content.bank"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"账号","type":"number"},model:{value:(_vm.invoice.content.bankAccount),callback:function ($$v) {_vm.$set(_vm.invoice.content, "bankAccount", $$v)},expression:"invoice.content.bankAccount"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"地址","type":"text"},model:{value:(_vm.invoice.content.address),callback:function ($$v) {_vm.$set(_vm.invoice.content, "address", $$v)},expression:"invoice.content.address"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"电话","type":"tel"},model:{value:(_vm.invoice.content.tel),callback:function ($$v) {_vm.$set(_vm.invoice.content, "tel", $$v)},expression:"invoice.content.tel"}}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.recharge($event)}}},[_vm._v("确定")])],1)}
var recharge_staticRenderFns = []
var recharge_esExports = { render: recharge_render, staticRenderFns: recharge_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_recharge = (recharge_esExports);
// CONCATENATED MODULE: ./src/components/recharge.vue
function recharge_injectStyle (ssrContext) {
  __webpack_require__("AxHB")
}
var recharge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recharge___vue_template_functional__ = false
/* styles */
var recharge___vue_styles__ = recharge_injectStyle
/* scopeId */
var recharge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var recharge___vue_module_identifier__ = null
var recharge_Component = recharge_normalizeComponent(
  selectortype_script_index_0_src_components_recharge,
  selectortype_template_index_0_src_components_recharge,
  recharge___vue_template_functional__,
  recharge___vue_styles__,
  recharge___vue_scopeId__,
  recharge___vue_module_identifier__
)

/* harmony default export */ var src_components_recharge = (recharge_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/withdraw.vue










/* harmony default export */ var withdraw = ({
  name: 'widhdraw',
  components: {
    Group: group["a" /* default */],
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      isShow: false,
      opid: '',
      amount: '',
      fee: 0.00,
      availwd: 0.00,
      showAvailwd: true,
      showFee: false,
      showAlert: false,
      disableButton: false,
      type: 'wallet_withdraw',
      type_list: [{ key: 'wallet_withdraw', value: '微信零钱' }, { key: 'bank_withdraw', value: '银行卡' }],
      bname: '',
      baccount: '',
      bank: '',
      bank_list: ['工商银行', '农业银行', '中国银行', '建设银行', '招商银行', '邮储银行', '交通银行', '浦发银行', '民生银行', '兴业银行', '平安银行', '中信银行', '华夏银行', '广发银行', '光大银行', '北京银行', '宁波银行']
    };
  },

  methods: {
    amountChange: function amountChange() {
      if (this.amount == '') {
        this.showAvailwd = true;
        this.showFee = false;
        this.showAlert = false;
        this.disableButton = true;
        this.showAlertWechat = false;
        this.showAlertBank = false;
        this.isShow = false;
      } else if (this.amount % 1 == 0) {
        if ((parseFloat(this.amount) < 1.00 || parseFloat(this.amount) > 10000.00) && this.type === 'wallet_withdraw') {
          this.showAlert = false;
          this.showAvailwd = false;
          this.showFee = false;
          this.disableButton = true;
          this.showAlertWechat = true;
          this.showAlertBank = false;
          this.isShow = false;
        } else if ((parseFloat(this.amount) < 500.00 || parseFloat(this.amount) > 50000.00) && this.type === 'bank_withdraw') {
          this.showAlert = false;
          this.showAvailwd = false;
          this.showFee = false;
          this.disableButton = true;
          this.showAlertWechat = false;
          this.showAlertBank = true;
          this.isShow = false;
        } else if (parseFloat(this.amount) <= parseFloat(this.availwd)) {
          this.fee = parseFloat(this.amount) * 0.01 < 50 ? parseFloat(this.amount) * 0.01 : 50;
          this.showAvailwd = false;
          this.showFee = true;
          this.showAlert = false;
          this.disableButton = false;
          this.showAlertWechat = false;
          this.showAlertBank = false;
          this.isShow = false;
        } else if (parseFloat(this.amount) > parseFloat(this.availwd)) {
          this.showAlert = true;
          this.showAvailwd = false;
          this.showFee = false;
          this.disableButton = true;
          this.showAlertWechat = false;
          this.showAlertBank = false;
          this.isShow = false;
        }
      } else {
        this.showAvailwd = false;
        this.showFee = false;
        this.showAlert = false;
        this.disableButton = true;
        this.showAlertWechat = false;
        this.showAlertBank = false;
        this.isShow = true;
      }
    },
    withdraw: function withdraw() {
      if (parseFloat(this.amount) + parseFloat(this.fee) > parseFloat(this.availwd)) {
        this.$vux.confirm.show({
          title: '',
          content: '剩余金额不足以支付提现手续费￥' + this.fee + '当前最大可提现金额为￥' + parseFloat(this.availwd) * 0.99 + '，是否要全部提现？',
          onConfirm: function onConfirm() {
            this.opid = localStorage.getItem('userid');
            var obj = {
              headers: {
                token: localStorage.getItem('token'),
                opid: this.opid
              }
            };
            var app = this;
            var data;
            if (this.type === 'wallet_withdraw') {
              data = {
                amount: String(parseFloat(this.availwd) * 0.99),
                fee: String(parseFloat(this.availwd) * 0.01) < 50 ? String(parseFloat(this.availwd) * 0.01) : 50
              };
            } else if (this.type === 'bank_withdraw') {
              data = {
                amount: String(parseFloat(this.availwd) * 0.99),
                fee: String(parseFloat(this.availwd) * 0.01) < 50 ? String(parseFloat(this.availwd) * 0.01) : 50,
                bname: this.bname,
                bank: this.bank,
                baccount: this.baccount
              };
            }
            this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=' + app.type, data, obj).then(function (response) {
              app.$vux.alert.show({
                title: '',
                content: '提现请求提交成功'
              });
              app.$router.push({ name: 'wallet' });
            }).catch(function (error) {
              if (error.response) {
                console.log(error.response.data);
                if (error.response.data.error_message) {
                  app.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                }
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log('Error', error.message);
              }
            });
          }
        });
      } else {
        this.opid = localStorage.getItem('userid');
        var obj = {
          headers: {
            token: localStorage.getItem('token'),
            opid: this.opid
          }
        };
        var app = this;
        var data;
        if (this.type === 'wallet_withdraw') {
          data = {
            amount: String(this.amount),
            fee: String(this.fee)
          };
        } else if (this.type === 'bank_withdraw') {
          data = {
            amount: String(this.amount),
            fee: String(this.fee),
            bname: this.bname,
            bank: this.bank,
            baccount: this.baccount
          };
        }
        this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=' + app.type, data, obj).then(function (response) {
          app.$vux.alert.show({
            title: '',
            content: '提现请求提交成功'
          });
          app.$router.push({ name: 'wallet' });
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            if (error.response.data.error_message) {
              app.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this;
      _this.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    this.opid = localStorage.getItem('userid');
    var obj = {
      headers: {
        token: localStorage.getItem('token'),
        opid: this.opid
      }
    };
    var app = this;
    this.$http.get('/api/v1/payments/' + app.opid + '/wallet', obj).then(function (response) {
      app.availwd = parseFloat(response.data.availwd);
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.data.error_message) {
          app.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).faultstring,
            type: 'cancel',
            time: '1000'
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
    var url = '/api/v1/experts/';
    this.$http.get(url + app.opid, obj).then(function (response) {
      if (response.data.detail) {
        app.bname = response.data.detail.name;
      }
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/withdraw.vue










/* harmony default export */ var components_withdraw = ({
  name: 'widhdraw',
  components: {
    Group: group["a" /* default */],
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      isShow: false,
      opid: '',
      amount: '',
      fee: 0.00,
      availwd: 0.00,
      showAvailwd: true,
      showFee: false,
      showAlert: false,
      disableButton: false,
      type: 'wallet_withdraw',
      type_list: [{ key: 'wallet_withdraw', value: '微信零钱' }, { key: 'bank_withdraw', value: '银行卡' }],
      bname: '',
      baccount: '',
      bank: '',
      bank_list: ['工商银行', '农业银行', '中国银行', '建设银行', '招商银行', '邮储银行', '交通银行', '浦发银行', '民生银行', '兴业银行', '平安银行', '中信银行', '华夏银行', '广发银行', '光大银行', '北京银行', '宁波银行']
    };
  },

  methods: {
    amountChange: function amountChange() {
      if (this.amount == '') {
        this.showAvailwd = true;
        this.showFee = false;
        this.showAlert = false;
        this.disableButton = true;
        this.showAlertWechat = false;
        this.showAlertBank = false;
        this.isShow = false;
      } else if (this.amount % 1 == 0) {
        if ((parseFloat(this.amount) < 1.00 || parseFloat(this.amount) > 10000.00) && this.type === 'wallet_withdraw') {
          this.showAlert = false;
          this.showAvailwd = false;
          this.showFee = false;
          this.disableButton = true;
          this.showAlertWechat = true;
          this.showAlertBank = false;
          this.isShow = false;
        } else if ((parseFloat(this.amount) < 500.00 || parseFloat(this.amount) > 50000.00) && this.type === 'bank_withdraw') {
          this.showAlert = false;
          this.showAvailwd = false;
          this.showFee = false;
          this.disableButton = true;
          this.showAlertWechat = false;
          this.showAlertBank = true;
          this.isShow = false;
        } else if (parseFloat(this.amount) <= parseFloat(this.availwd)) {
          this.fee = parseFloat(this.amount) * 0.01 < 50 ? parseFloat(this.amount) * 0.01 : 50;
          this.showAvailwd = false;
          this.showFee = true;
          this.showAlert = false;
          this.disableButton = false;
          this.showAlertWechat = false;
          this.showAlertBank = false;
          this.isShow = false;
        } else if (parseFloat(this.amount) > parseFloat(this.availwd)) {
          this.showAlert = true;
          this.showAvailwd = false;
          this.showFee = false;
          this.disableButton = true;
          this.showAlertWechat = false;
          this.showAlertBank = false;
          this.isShow = false;
        }
      } else {
        this.showAvailwd = false;
        this.showFee = false;
        this.showAlert = false;
        this.disableButton = true;
        this.showAlertWechat = false;
        this.showAlertBank = false;
        this.isShow = true;
      }
    },
    withdraw: function withdraw() {
      if (parseFloat(this.amount) + parseFloat(this.fee) > parseFloat(this.availwd)) {
        this.$vux.confirm.show({
          title: '',
          content: '剩余金额不足以支付提现手续费￥' + this.fee + '当前最大可提现金额为￥' + parseFloat(this.availwd) * 0.99 + '，是否要全部提现？',
          onConfirm: function onConfirm() {
            this.opid = localStorage.getItem('userid');
            var obj = {
              headers: {
                token: localStorage.getItem('token'),
                opid: this.opid
              }
            };
            var app = this;
            var data;
            if (this.type === 'wallet_withdraw') {
              data = {
                amount: String(parseFloat(this.availwd) * 0.99),
                fee: String(parseFloat(this.availwd) * 0.01) < 50 ? String(parseFloat(this.availwd) * 0.01) : 50
              };
            } else if (this.type === 'bank_withdraw') {
              data = {
                amount: String(parseFloat(this.availwd) * 0.99),
                fee: String(parseFloat(this.availwd) * 0.01) < 50 ? String(parseFloat(this.availwd) * 0.01) : 50,
                bname: this.bname,
                bank: this.bank,
                baccount: this.baccount
              };
            }
            this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=' + app.type, data, obj).then(function (response) {
              app.$vux.alert.show({
                title: '',
                content: '提现请求提交成功'
              });
              app.$router.push({ name: 'wallet' });
            }).catch(function (error) {
              if (error.response) {
                console.log(error.response.data);
                if (error.response.data.error_message) {
                  app.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                }
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log('Error', error.message);
              }
            });
          }
        });
      } else {
        this.opid = localStorage.getItem('userid');
        var obj = {
          headers: {
            token: localStorage.getItem('token'),
            opid: this.opid
          }
        };
        var app = this;
        var data;
        if (this.type === 'wallet_withdraw') {
          data = {
            amount: String(this.amount),
            fee: String(this.fee)
          };
        } else if (this.type === 'bank_withdraw') {
          data = {
            amount: String(this.amount),
            fee: String(this.fee),
            bname: this.bname,
            bank: this.bank,
            baccount: this.baccount
          };
        }
        this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=' + app.type, data, obj).then(function (response) {
          app.$vux.alert.show({
            title: '',
            content: '提现请求提交成功'
          });
          app.$router.push({ name: 'wallet' });
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            if (error.response.data.error_message) {
              app.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this;
      _this.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    this.opid = localStorage.getItem('userid');
    var obj = {
      headers: {
        token: localStorage.getItem('token'),
        opid: this.opid
      }
    };
    var app = this;
    this.$http.get('/api/v1/payments/' + app.opid + '/wallet', obj).then(function (response) {
      app.availwd = parseFloat(response.data.availwd);
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.data.error_message) {
          app.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).faultstring,
            type: 'cancel',
            time: '1000'
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
    var url = '/api/v1/experts/';
    this.$http.get(url + app.opid, obj).then(function (response) {
      if (response.data.detail) {
        app.bname = response.data.detail.name;
      }
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed933dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/withdraw.vue
var withdraw_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('selector',{attrs:{"title":"提现到","options":_vm.type_list},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}}),_vm._v(" "),(_vm.type === 'bank_withdraw')?_c('div',[_c('x-input',{attrs:{"title":"户名","required":"type === 'bank_withdraw'","disabled":""},model:{value:(_vm.bname),callback:function ($$v) {_vm.bname=$$v},expression:"bname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"账号","required":"type === 'bank_withdraw'"},model:{value:(_vm.baccount),callback:function ($$v) {_vm.baccount=$$v},expression:"baccount"}}),_vm._v(" "),_c('selector',{attrs:{"title":"银行","options":_vm.bank_list},model:{value:(_vm.bank),callback:function ($$v) {_vm.bank=$$v},expression:"bank"}})],1):_vm._e()],1),_vm._v(" "),_c('group',{attrs:{"title":"提现金额"}},[_c('x-input',{attrs:{"title":"￥","type":"number","required":""},on:{"on-change":_vm.amountChange},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1),_vm._v(" "),(_vm.showAvailwd)?_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("可提现金额￥"+_vm._s(_vm.availwd.toFixed(2)))]):_vm._e(),_vm._v(" "),(_vm.showFee)?_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("额外扣除￥"+_vm._s(_vm.fee.toFixed(2))+"手续费（费率1%）")]):_vm._e(),_vm._v(" "),(_vm.showAlert)?_c('span',{staticStyle:{"font-size":"0.8em","color":"red"}},[_vm._v("输入金额超过可提现余额")]):_vm._e(),_vm._v(" "),(_vm.showAlertWechat)?_c('span',{staticStyle:{"font-size":"0.8em","color":"red"}},[_vm._v("提现到微信零钱，限额50元~1万元")]):_vm._e(),_vm._v(" "),(_vm.showAlertBank)?_c('span',{staticStyle:{"font-size":"0.8em","color":"red"}},[_vm._v("提现到银行卡，限额500元~5万元")]):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('span',{staticStyle:{"font-size":"0.8em","color":"red"}},[_vm._v("提现金额为50的整数倍")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v("提现到微信零钱，限额50元~1万元，手续费1%,50元封顶；提现到银行卡，限额500元~5万元，手续费1%,50元封顶，仅支持提现到本人名下银行卡")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.withdraw($event)}}},[_vm._v("确定")])],1)}
var withdraw_staticRenderFns = []
var withdraw_esExports = { render: withdraw_render, staticRenderFns: withdraw_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_withdraw = (withdraw_esExports);
// CONCATENATED MODULE: ./src/components/withdraw.vue
function withdraw_injectStyle (ssrContext) {
  __webpack_require__("XAbY")
}
var withdraw_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var withdraw___vue_template_functional__ = false
/* styles */
var withdraw___vue_styles__ = withdraw_injectStyle
/* scopeId */
var withdraw___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var withdraw___vue_module_identifier__ = null
var withdraw_Component = withdraw_normalizeComponent(
  components_withdraw,
  selectortype_template_index_0_src_components_withdraw,
  withdraw___vue_template_functional__,
  withdraw___vue_styles__,
  withdraw___vue_scopeId__,
  withdraw___vue_module_identifier__
)

/* harmony default export */ var src_components_withdraw = (withdraw_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orders.vue












/* harmony default export */ var orders = ({
  name: 'orders',
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      select: '',
      opid: '',

      orders_closed: [],
      orders_unclosed: [],
      list: ['未完成', '已完成'],
      index: 0,
      loadmoreone: '加载更多',
      loadmoretwo: '加载更多',
      show: true,
      hide: true,
      isDisabled: false
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      var offset;
      var closed;
      this.isDisabled = true;
      if (this.index === 1) {
        offset = this.orders_closed.length;
        closed = true;
      } else {
        offset = this.orders_unclosed.length;
        closed = false;
      }
      var obj = {
        headers: {
          token: localStorage.getItem('token'),
          opid: this.opid
        }
      };
      var app = this;
      var date = new Date();
      var myDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      this.$http.get('/api/v1/payments/' + app.opid + '/orders?type=orders&before=' + myDate + '&offset=' + offset + '&count=10&closed=' + closed, obj).then(function (response) {
        app.isDisabled = false;
        if (app.index === 1) {
          app.loadmoretwo = '加载中';
          if (response.data.length > 0) {
            app.loadmoretwo = '加载更多';
          } else {
            app.hide = false;
          }
        } else {
          app.loadmoreone = '加载中';
          if (response.data.length > 0) {
            app.loadmoreone = '加载更多';
          } else {
            app.show = false;
          }
        }
        var orders = [];
        orders = response.data;
        for (var i = 0; i < orders.length; i++) {
          switch (orders[i]['type']) {
            case 'TX':
              orders[i]['type'] = '提现';
              break;
            case 'CZ':
              orders[i]['type'] = '充值';
              break;
            case 'JL':
              orders[i]['type'] = '奖励';
              break;
            case 'ZF':
              orders[i]['type'] = '服务费';
              break;
            case 'FO':
              orders[i]['type'] = '维修费用支出';
              break;
            default:
              break;
          }
          if (app.index === 0) {
            switch (orders[i]['state']) {
              case 'SUCCESS':
                orders[i]['state'] = '交易成功';
                break;
              case 'FAIL':
                orders[i]['state'] = '交易失败';
                break;
              case 'REJECT':
                orders[i]['state'] = '交易驳回';
                break;
              case 'USERCANCEL':
                orders[i]['state'] = '交易取消';
                break;
              case 'BALSUCCESS':
                orders[i]['state'] = '交易成功';
                break;
              case 'BALFAIL':
                orders[i]['state'] = '交易失败';
                break;
              default:
                break;
            }
          }
          if (app.index === 1) {
            app.orders_closed.push(orders[i]);
          } else {
            app.orders_unclosed.push(orders[i]);
          }
        }
      }).catch(function (error) {
        app.isDisabled = false;
        if (error.response) {
          console.log(error.response.data);
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).faultstring
            });
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
      });
    }
  },
  created: function created() {
    this.opid = localStorage.getItem('userid');
    var obj = {
      headers: {
        token: localStorage.getItem('token'),
        opid: this.opid
      }
    };
    var app = this;
    var date = new Date();
    var myDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.$http.get('/api/v1/payments/' + app.opid + '/orders?type=orders&before=' + myDate + '&offset=0&count=10&closed=true', obj).then(function (response) {
      app.orders_closed = response.data;
      for (var i = 0; i < app.orders_closed.length; i++) {
        switch (app.orders_closed[i]['type']) {
          case 'TX':
            app.orders_closed[i]['type'] = '提现';
            break;
          case 'CZ':
            app.orders_closed[i]['type'] = '充值';
            break;
          case 'JL':
            app.orders_closed[i]['type'] = '奖励';
            break;
          case 'ZF':
            app.orders_closed[i]['type'] = '服务费';
            break;
          case 'FO':
            app.orders_closed[i].type = '维修费用支出';
            break;
          default:
            break;
        }
        switch (app.orders_closed[i]['state']) {
          case 'SUCCESS':
            app.orders_closed[i]['state'] = '交易成功';
            break;
          case 'FAIL':
            app.orders_closed[i]['state'] = '交易失败';
            break;
          case 'REJECT':
            app.orders_closed[i]['state'] = '交易驳回';
            break;
          case 'USERCANCEL':
            app.orders_closed[i]['state'] = '交易取消';
            break;
          case 'BALSUCCESS':
            app.orders_closed[i]['state'] = '交易成功';
            break;
          case 'BALFAIL':
            app.orders_closed[i]['state'] = '交易失败';
            break;
          default:
            break;
        }
      }
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.data.error_message) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).faultstring
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
    this.$http.get('/api/v1/payments/' + app.opid + '/orders?type=orders&before=' + myDate + '&offset=0&count=20&closed=false', obj).then(function (response) {
      console.log(response.data);
      app.orders_unclosed = response.data;
      for (var i = 0; i < app.orders_unclosed.length; i++) {
        switch (app.orders_unclosed[i]['type']) {
          case 'TX':
            app.orders_unclosed[i]['type'] = '提现';
            break;
          case 'CZ':
            app.orders_unclosed[i]['type'] = '充值';
            break;
          case 'JL':
            app.orders_unclosed[i]['type'] = '奖励';
            break;
          case 'ZF':
            app.orders_unclosed[i]['type'] = '服务费';
            break;
          case 'FO':
            app.orders_unclosed[i].type = '维修费用支出';
            break;
          default:
            break;
        }
      }
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.data.error_message) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).faultstring
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orders.vue












/* harmony default export */ var components_orders = ({
  name: 'orders',
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      select: '',
      opid: '',

      orders_closed: [],
      orders_unclosed: [],
      list: ['未完成', '已完成'],
      index: 0,
      loadmoreone: '加载更多',
      loadmoretwo: '加载更多',
      show: true,
      hide: true,
      isDisabled: false
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      var offset;
      var closed;
      this.isDisabled = true;
      if (this.index === 1) {
        offset = this.orders_closed.length;
        closed = true;
      } else {
        offset = this.orders_unclosed.length;
        closed = false;
      }
      var obj = {
        headers: {
          token: localStorage.getItem('token'),
          opid: this.opid
        }
      };
      var app = this;
      var date = new Date();
      var myDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      this.$http.get('/api/v1/payments/' + app.opid + '/orders?type=orders&before=' + myDate + '&offset=' + offset + '&count=10&closed=' + closed, obj).then(function (response) {
        app.isDisabled = false;
        if (app.index === 1) {
          app.loadmoretwo = '加载中';
          if (response.data.length > 0) {
            app.loadmoretwo = '加载更多';
          } else {
            app.hide = false;
          }
        } else {
          app.loadmoreone = '加载中';
          if (response.data.length > 0) {
            app.loadmoreone = '加载更多';
          } else {
            app.show = false;
          }
        }
        var orders = [];
        orders = response.data;
        for (var i = 0; i < orders.length; i++) {
          switch (orders[i]['type']) {
            case 'TX':
              orders[i]['type'] = '提现';
              break;
            case 'CZ':
              orders[i]['type'] = '充值';
              break;
            case 'JL':
              orders[i]['type'] = '奖励';
              break;
            case 'ZF':
              orders[i]['type'] = '服务费';
              break;
            case 'FO':
              orders[i]['type'] = '维修费用支出';
              break;
            default:
              break;
          }
          if (app.index === 0) {
            switch (orders[i]['state']) {
              case 'SUCCESS':
                orders[i]['state'] = '交易成功';
                break;
              case 'FAIL':
                orders[i]['state'] = '交易失败';
                break;
              case 'REJECT':
                orders[i]['state'] = '交易驳回';
                break;
              case 'USERCANCEL':
                orders[i]['state'] = '交易取消';
                break;
              case 'BALSUCCESS':
                orders[i]['state'] = '交易成功';
                break;
              case 'BALFAIL':
                orders[i]['state'] = '交易失败';
                break;
              default:
                break;
            }
          }
          if (app.index === 1) {
            app.orders_closed.push(orders[i]);
          } else {
            app.orders_unclosed.push(orders[i]);
          }
        }
      }).catch(function (error) {
        app.isDisabled = false;
        if (error.response) {
          console.log(error.response.data);
          if (error.response.data.error_message) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).faultstring
            });
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
      });
    }
  },
  created: function created() {
    this.opid = localStorage.getItem('userid');
    var obj = {
      headers: {
        token: localStorage.getItem('token'),
        opid: this.opid
      }
    };
    var app = this;
    var date = new Date();
    var myDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.$http.get('/api/v1/payments/' + app.opid + '/orders?type=orders&before=' + myDate + '&offset=0&count=10&closed=true', obj).then(function (response) {
      app.orders_closed = response.data;
      for (var i = 0; i < app.orders_closed.length; i++) {
        switch (app.orders_closed[i]['type']) {
          case 'TX':
            app.orders_closed[i]['type'] = '提现';
            break;
          case 'CZ':
            app.orders_closed[i]['type'] = '充值';
            break;
          case 'JL':
            app.orders_closed[i]['type'] = '奖励';
            break;
          case 'ZF':
            app.orders_closed[i]['type'] = '服务费';
            break;
          case 'FO':
            app.orders_closed[i].type = '维修费用支出';
            break;
          default:
            break;
        }
        switch (app.orders_closed[i]['state']) {
          case 'SUCCESS':
            app.orders_closed[i]['state'] = '交易成功';
            break;
          case 'FAIL':
            app.orders_closed[i]['state'] = '交易失败';
            break;
          case 'REJECT':
            app.orders_closed[i]['state'] = '交易驳回';
            break;
          case 'USERCANCEL':
            app.orders_closed[i]['state'] = '交易取消';
            break;
          case 'BALSUCCESS':
            app.orders_closed[i]['state'] = '交易成功';
            break;
          case 'BALFAIL':
            app.orders_closed[i]['state'] = '交易失败';
            break;
          default:
            break;
        }
      }
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.data.error_message) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).faultstring
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
    this.$http.get('/api/v1/payments/' + app.opid + '/orders?type=orders&before=' + myDate + '&offset=0&count=20&closed=false', obj).then(function (response) {
      console.log(response.data);
      app.orders_unclosed = response.data;
      for (var i = 0; i < app.orders_unclosed.length; i++) {
        switch (app.orders_unclosed[i]['type']) {
          case 'TX':
            app.orders_unclosed[i]['type'] = '提现';
            break;
          case 'CZ':
            app.orders_unclosed[i]['type'] = '充值';
            break;
          case 'JL':
            app.orders_unclosed[i]['type'] = '奖励';
            break;
          case 'ZF':
            app.orders_unclosed[i]['type'] = '服务费';
            break;
          case 'FO':
            app.orders_unclosed[i].type = '维修费用支出';
            break;
          default:
            break;
        }
      }
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.data.error_message) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).faultstring
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2085bcf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders.vue
var orders_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('tab',{attrs:{"line-width":2,"active-color":"#fc378c"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.list),function(item,index){return _c('tab-item',{key:index,staticClass:"vux-center",attrs:{"selected":_vm.select === item},on:{"click":function($event){_vm.select = item}}},[_vm._v(_vm._s(item)+"\n    ")])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 1),expression:"index === 1"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.orders_closed),function(order,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'orderDetail', params: { order: order }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.type))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.start))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v("￥"+_vm._s(order.detail.amount))]),_vm._v(" "),_c('br'),_vm._v(" "),(order.state != '交易成功')?_c('span',{staticStyle:{"font-size":"0.6em","color":"red"}},[_vm._v(_vm._s(order.state))]):_vm._e(),_vm._v(" "),(order.state === '交易成功')?_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.state))]):_vm._e()])])}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v("\n      "+_vm._s(_vm.loadmoretwo)+"\n    ")])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 0),expression:"index === 0"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.orders_unclosed),function(order,index){return _c('cell',{key:index,attrs:{"value":'￥' + order.detail.amount,"is-link":"","link":{ name: 'orderDetail', params: { order: order }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.type))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.start))])])])}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v("\n      "+_vm._s(_vm.loadmoreone)+"\n    ")])],2)],1)}
var orders_staticRenderFns = []
var orders_esExports = { render: orders_render, staticRenderFns: orders_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_orders = (orders_esExports);
// CONCATENATED MODULE: ./src/components/orders.vue
var orders_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var orders___vue_template_functional__ = false
/* styles */
var orders___vue_styles__ = null
/* scopeId */
var orders___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var orders___vue_module_identifier__ = null
var orders_Component = orders_normalizeComponent(
  components_orders,
  selectortype_template_index_0_src_components_orders,
  orders___vue_template_functional__,
  orders___vue_styles__,
  orders___vue_scopeId__,
  orders___vue_module_identifier__
)

/* harmony default export */ var src_components_orders = (orders_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cell_form_preview = ({
  name: 'cell-form-preview',
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_cell_form_preview = ({
  name: 'cell-form-preview',
  props: {
    list: Array,
    borderIntent: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91b5af26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-form-preview/index.vue
var cell_form_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-cell-form-preview",class:{'vux-cell-no-border-intent': !_vm.borderIntent}},[_c('div',{staticClass:"weui-form-preview__bd"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-form-preview__item"},[_c('label',{staticClass:"weui-form-preview__label",domProps:{"innerHTML":_vm._s(item.label)}}),_vm._v(" "),_c('span',{staticClass:"weui-form-preview__value",domProps:{"innerHTML":_vm._s(item.value)}})])}))])}
var cell_form_preview_staticRenderFns = []
var cell_form_preview_esExports = { render: cell_form_preview_render, staticRenderFns: cell_form_preview_staticRenderFns }
/* harmony default export */ var src_components_cell_form_preview = (cell_form_preview_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-form-preview/index.vue
function cell_form_preview_injectStyle (ssrContext) {
  __webpack_require__("wHqe")
}
var cell_form_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell_form_preview___vue_template_functional__ = false
/* styles */
var cell_form_preview___vue_styles__ = cell_form_preview_injectStyle
/* scopeId */
var cell_form_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell_form_preview___vue_module_identifier__ = null
var cell_form_preview_Component = cell_form_preview_normalizeComponent(
  components_cell_form_preview,
  src_components_cell_form_preview,
  cell_form_preview___vue_template_functional__,
  cell_form_preview___vue_styles__,
  cell_form_preview___vue_scopeId__,
  cell_form_preview___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_form_preview = (cell_form_preview_Component.exports);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__("i7N3");
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__("72M0");
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7c4f396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/previewer/index.vue
var previewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp vux-previewer",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"pswp__bg"}),_vm._v(" "),_c('div',{staticClass:"pswp__scroll-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pswp__ui pswp__ui--hidden"},[_c('div',{staticClass:"pswp__top-bar"},[_c('div',{staticClass:"pswp__counter"}),_vm._v(" "),_vm._t("button-after"),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--close",attrs:{"title":"Close (Esc)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--share",attrs:{"title":"Share"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--fs",attrs:{"title":"Toggle fullscreen"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--zoom",attrs:{"title":"Zoom in/out"}}),_vm._v(" "),_vm._t("button-before"),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--left",attrs:{"title":"Previous (arrow left)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--right",attrs:{"title":"Next (arrow right)"}}),_vm._v(" "),_vm._m(3)])])])}
var previewer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__container"},[_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__preloader"},[_c('div',{staticClass:"pswp__preloader__icn"},[_c('div',{staticClass:"pswp__preloader__cut"},[_c('div',{staticClass:"pswp__preloader__donut"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__share-modal pswp__share-modal--hidden pswp__single-tap"},[_c('div',{staticClass:"pswp__share-tooltip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__caption"},[_c('div',{staticClass:"pswp__caption__center"})])}]
var previewer_esExports = { render: previewer_render, staticRenderFns: previewer_staticRenderFns }
/* harmony default export */ var src_components_previewer = (previewer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/previewer/index.vue
function previewer_injectStyle (ssrContext) {
  __webpack_require__("fMNz")
  __webpack_require__("NhlS")
}
var previewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var previewer___vue_template_functional__ = false
/* styles */
var previewer___vue_styles__ = previewer_injectStyle
/* scopeId */
var previewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewer___vue_module_identifier__ = null
var previewer_Component = previewer_normalizeComponent(
  components_previewer,
  src_components_previewer,
  previewer___vue_template_functional__,
  previewer___vue_styles__,
  previewer___vue_scopeId__,
  previewer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_previewer = (previewer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orderDetail.vue











/* harmony default export */ var orderDetail = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    CellFormPreview: vux_src_components_cell_form_preview,
    Cell: vux_src_components_cell,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  name: "orderDetail",
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      value: "",
      src: '',
      list: [],
      showTitle: false,
      fdetailList: [],
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      orderDetail: this.$route.params.order
    };
  },

  methods: {
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    getPhoto: function getPhoto() {
      var _this = this;

      return new promise_default.a(function (resolve) {
        _this.$http.get('/api/photos?path=' + _this.orderDetail['detail']['bphoto'], _this.header).then(function (response) {
          resolve(response.data);
        });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var orderDetail = this.$route.params.order;
    switch (orderDetail["type"]) {
      case "提现":
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "类型",
          value: "提现"
        }, {
          label: "提现金额",
          value: orderDetail["detail"]["amount"]
        }, {
          label: "提现手续费",
          value: orderDetail["detail"]["fee"]
        }];
        var tmp = {};
        if (orderDetail["detail"]["method"] === "WX") {
          tmp = { label: "提现方式", value: "微信零钱" };
          this.list.push(tmp);
        } else if (orderDetail["detail"]["method"] === "BANK") {
          tmp = { label: "提现方式", value: "银行" };
          this.list.push(tmp);
          tmp = {
            label: "提现银行账户",
            value: orderDetail["detail"]["baccount"]
          };
          this.list.push(tmp);
        }
        tmp = { label: "发起时间", value: orderDetail["start"] };
        this.list.push(tmp);
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["detail"]["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = (parseFloat(orderDetail["amount"]) + parseFloat(orderDetail["fee"])).toFixed(2);
          } else {
            this.value = 0.0;
          }
        }
        break;
      case "充值":
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "类型",
          value: "充值"
        }, {
          label: "充值金额",
          value: orderDetail["detail"]["amount"]
        }];
        if (orderDetail["detail"]["method"] === "WX") {
          tmp = { label: "充值方式", value: "微信支付" };
          this.list.push(tmp);
        } else if (orderDetail["detail"]["method"] === "BANK") {
          tmp = { label: "充值方式", value: "银行汇款" };
          this.list.push(tmp);
        }
        tmp = { label: "发起时间", value: orderDetail["start"] };
        this.list.push(tmp);
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = orderDetail["detail"]["amount"];
          } else {
            this.value = "0.00";
          }
        }
        if (orderDetail["detail"]["instate"] === "ISSUE" || orderDetail["detail"]["instate"] === "ISSUEPRE") {
          tmp = { label: "发票", value: "未开票" };
        } else if (orderDetail["detail"]["instate"] === "NOISSUE") {
          tmp = { label: "发票", value: "不需要开票" };
        } else if (orderDetail["detail"]["instate"] === "FINISHED") {
          tmp = { label: "发票", value: "已开具开票" };
        }
        this.list.push(tmp);
        break;
      case "奖励":
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "类型",
          value: "奖励"
        }, {
          label: "奖励金额",
          value: orderDetail["detail"]["amount"]
        }];
        if (orderDetail["detail"]["type"] === "EXPTREG") {
          tmp = { label: "奖励类型", value: "专家注册成功奖励" };
        } else if (orderDetail["detail"]["type"] === "RCMDEXPT") {
          tmp = { label: "奖励类型", value: "推荐专家注册成功奖励" };
        }
        this.list.push(tmp);
        tmp = { label: "发起时间", value: orderDetail["start"] };
        this.list.push(tmp);
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = orderDetail["detail"]["amount"];
          } else {
            this.value = "0.00";
          }
        }
        break;
      case '服务费':
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "报修单号",
          value: orderDetail["detail"]["order"]
        }, {
          label: "类型",
          value: "服务费"
        }, {
          label: "服务费用",
          value: orderDetail["detail"]["amount"]
        }];
        this.list.push({ label: "发起时间", value: orderDetail["start"] });
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = orderDetail["detail"]["amount"];
          } else {
            this.value = "0.00";
          }
        }
        break;
      case '维修费用支出':
        if (orderDetail['detail']['bphoto']) {
          this.getPhoto().then(function (response) {
            _this2.fdetailList.push({ src: 'data:image/jpeg;base64,' + response['value'] });
            _this2.src = 'data:image/jpeg;base64,' + response['value'];
          });
        }
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "报修单号",
          value: orderDetail["detail"]["gseq"]
        }, {
          label: "类型",
          value: "维修费用支出"
        }, {
          label: "支出费用",
          value: orderDetail["detail"]["amount"]
        }];
        this.list.push({ label: "发起时间", value: orderDetail["start"] });
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = orderDetail["detail"]["amount"];
          } else {
            this.value = "0.00";
          }
        }
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orderDetail.vue











/* harmony default export */ var components_orderDetail = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    CellFormPreview: vux_src_components_cell_form_preview,
    Cell: vux_src_components_cell,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  name: "orderDetail",
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      value: "",
      src: '',
      list: [],
      showTitle: false,
      fdetailList: [],
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      orderDetail: this.$route.params.order
    };
  },

  methods: {
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    getPhoto: function getPhoto() {
      var _this = this;

      return new promise_default.a(function (resolve) {
        _this.$http.get('/api/photos?path=' + _this.orderDetail['detail']['bphoto'], _this.header).then(function (response) {
          resolve(response.data);
        });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var orderDetail = this.$route.params.order;
    switch (orderDetail["type"]) {
      case "提现":
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "类型",
          value: "提现"
        }, {
          label: "提现金额",
          value: orderDetail["detail"]["amount"]
        }, {
          label: "提现手续费",
          value: orderDetail["detail"]["fee"]
        }];
        var tmp = {};
        if (orderDetail["detail"]["method"] === "WX") {
          tmp = { label: "提现方式", value: "微信零钱" };
          this.list.push(tmp);
        } else if (orderDetail["detail"]["method"] === "BANK") {
          tmp = { label: "提现方式", value: "银行" };
          this.list.push(tmp);
          tmp = {
            label: "提现银行账户",
            value: orderDetail["detail"]["baccount"]
          };
          this.list.push(tmp);
        }
        tmp = { label: "发起时间", value: orderDetail["start"] };
        this.list.push(tmp);
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["detail"]["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = (parseFloat(orderDetail["amount"]) + parseFloat(orderDetail["fee"])).toFixed(2);
          } else {
            this.value = 0.0;
          }
        }
        break;
      case "充值":
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "类型",
          value: "充值"
        }, {
          label: "充值金额",
          value: orderDetail["detail"]["amount"]
        }];
        if (orderDetail["detail"]["method"] === "WX") {
          tmp = { label: "充值方式", value: "微信支付" };
          this.list.push(tmp);
        } else if (orderDetail["detail"]["method"] === "BANK") {
          tmp = { label: "充值方式", value: "银行汇款" };
          this.list.push(tmp);
        }
        tmp = { label: "发起时间", value: orderDetail["start"] };
        this.list.push(tmp);
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = orderDetail["detail"]["amount"];
          } else {
            this.value = "0.00";
          }
        }
        if (orderDetail["detail"]["instate"] === "ISSUE" || orderDetail["detail"]["instate"] === "ISSUEPRE") {
          tmp = { label: "发票", value: "未开票" };
        } else if (orderDetail["detail"]["instate"] === "NOISSUE") {
          tmp = { label: "发票", value: "不需要开票" };
        } else if (orderDetail["detail"]["instate"] === "FINISHED") {
          tmp = { label: "发票", value: "已开具开票" };
        }
        this.list.push(tmp);
        break;
      case "奖励":
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "类型",
          value: "奖励"
        }, {
          label: "奖励金额",
          value: orderDetail["detail"]["amount"]
        }];
        if (orderDetail["detail"]["type"] === "EXPTREG") {
          tmp = { label: "奖励类型", value: "专家注册成功奖励" };
        } else if (orderDetail["detail"]["type"] === "RCMDEXPT") {
          tmp = { label: "奖励类型", value: "推荐专家注册成功奖励" };
        }
        this.list.push(tmp);
        tmp = { label: "发起时间", value: orderDetail["start"] };
        this.list.push(tmp);
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = orderDetail["detail"]["amount"];
          } else {
            this.value = "0.00";
          }
        }
        break;
      case '服务费':
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "报修单号",
          value: orderDetail["detail"]["order"]
        }, {
          label: "类型",
          value: "服务费"
        }, {
          label: "服务费用",
          value: orderDetail["detail"]["amount"]
        }];
        this.list.push({ label: "发起时间", value: orderDetail["start"] });
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = orderDetail["detail"]["amount"];
          } else {
            this.value = "0.00";
          }
        }
        break;
      case '维修费用支出':
        if (orderDetail['detail']['bphoto']) {
          this.getPhoto().then(function (response) {
            _this2.fdetailList.push({ src: 'data:image/jpeg;base64,' + response['value'] });
            _this2.src = 'data:image/jpeg;base64,' + response['value'];
          });
        }
        this.list = [{
          label: "交易单号",
          value: orderDetail["seq"]
        }, {
          label: "报修单号",
          value: orderDetail["detail"]["gseq"]
        }, {
          label: "类型",
          value: "维修费用支出"
        }, {
          label: "支出费用",
          value: orderDetail["detail"]["amount"]
        }];
        this.list.push({ label: "发起时间", value: orderDetail["start"] });
        if (orderDetail["state"] === "START") {
          this.showTitle = false;
        } else {
          this.showTitle = true;
          tmp = { label: "结束时间", value: orderDetail["end"] };
          this.list.push(tmp);
          tmp = { label: "交易状态", value: orderDetail["state"] };
          this.list.push(tmp);
          if (orderDetail["state"] === "交易成功") {
            this.value = orderDetail["detail"]["amount"];
          } else {
            this.value = "0.00";
          }
        }
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04fe8a74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderDetail.vue
var orderDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[(_vm.showTitle)?_c('cell',{attrs:{"title":"出账金额","value":_vm.value}}):_vm._e(),_vm._v(" "),_c('cell-form-preview',{attrs:{"list":_vm.list}})],1),_vm._v(" "),_c('img',{staticClass:"previewer-demo-img",staticStyle:{"height":"300px"},attrs:{"src":_vm.src},on:{"click":function($event){_vm.show(0)}}}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.fdetailList,"options":_vm.options}})],1)],1)}
var orderDetail_staticRenderFns = []
var orderDetail_esExports = { render: orderDetail_render, staticRenderFns: orderDetail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_orderDetail = (orderDetail_esExports);
// CONCATENATED MODULE: ./src/components/orderDetail.vue
function orderDetail_injectStyle (ssrContext) {
  __webpack_require__("u8xQ")
}
var orderDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var orderDetail___vue_template_functional__ = false
/* styles */
var orderDetail___vue_styles__ = orderDetail_injectStyle
/* scopeId */
var orderDetail___vue_scopeId__ = "data-v-04fe8a74"
/* moduleIdentifier (server only) */
var orderDetail___vue_module_identifier__ = null
var orderDetail_Component = orderDetail_normalizeComponent(
  components_orderDetail,
  selectortype_template_index_0_src_components_orderDetail,
  orderDetail___vue_template_functional__,
  orderDetail___vue_styles__,
  orderDetail___vue_scopeId__,
  orderDetail___vue_module_identifier__
)

/* harmony default export */ var src_components_orderDetail = (orderDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/glzh.vue






/* harmony default export */ var glzh = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    Confirm: components_confirm["a" /* default */]
  },
  data: function data() {
    return {
      account: "",
      imgUrl: "/static/img/vip.png",
      name: "",
      mobile: "",
      showContent004: false,
      list: [],
      isShow: false,
      username: "",
      pwd: "",
      signoutShow: false
    };
  },

  methods: {
    signout: function signout() {
      var _this = this;

      var openid = localStorage.getItem("openid");
      var unionid = localStorage.getItem('unionid');
      var that = this;
      switch (this.list.length) {
        case 3:
          this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.list[2] }).then(function (res) {
            var opid = res.data.userid;
            var obj = {
              headers: {
                token: res.data.token,
                opid: opid
              }
            };
            _this.$http.delete("/api/v1/wechat/" + unionid + "?userid=" + opid, obj).then(function (res) {});
          });
        case 2:
          this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.list[1] }).then(function (res) {
            var opid = res.data.userid;
            var obj = {
              headers: {
                token: res.data.token,
                opid: opid
              }
            };
            _this.$http.delete("/api/v1/wechat/" + unionid + "?userid=" + opid, obj).then(function (res) {});
          });
        case 1:
          this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.list[0] }).then(function (res) {
            var opid = res.data.userid;
            var obj = {
              headers: {
                token: res.data.token,
                opid: opid
              }
            };
            _this.$http.delete("/api/v1/wechat/" + unionid + "?userid=" + opid, obj).then(function (res) {});
          });
          break;
      }
      setTimeout(function () {
        localStorage.clear();
        that.$router.push({ name: "login" });
      }, 500);
    },
    onShow: function onShow() {
      this.signoutShow = true;
    },
    onHide: function onHide() {
      this.signoutShow = false;
    },
    show: function show() {
      this.isShow = !this.isShow;
    },
    hide: function hide() {
      this.isShow = !this.isShow;
    },
    add: function add() {
      var _this2 = this;

      var userInfo = {
        passwd: this.pwd,
        account: this.username,
        is_passwd: true,
        tp: 'mobile'
      };
      this.isShow = !this.isShow;
      var roles = [];
      JSON.parse(localStorage.getItem('account')).forEach(function (item) {
        roles.push(item.role);
      });
      this.$http.post("/api/v1/accounts", userInfo).then(function (res) {
        var head = { headers: { token: res.data.token, opid: res.data.userid } };
        _this2.$http.get('/api/v1/accounts/' + res.data.userid, head).then(function (res1) {
          res1.data.forEach(function (item) {
            console.log(roles);
            if (roles.indexOf('ADMIN') !== -1) {
              if (item.type !== 'ADMIN' && item.type !== 'INDV' && item.type !== 'EXPT' && item.type !== 'ENTP') {
                console.log("bind");
                _this2.bind(res.data.userid, head);
              } else {
                _this2.$vux.toast.show({
                  text: '不可绑定相同权限账号',
                  type: 'cancel',
                  time: '1000'
                });
              }
            } else if (roles.indexOf('SRVP') !== -1) {
              if (item.type !== 'SRVP' && item.type !== 'INDV' && item.type !== 'EXPT' && item.type !== 'ENTP') {
                _this2.bind(res.data.userid, head);
              } else {
                _this2.$vux.toast.show({
                  text: '不可绑定相同权限账号',
                  type: 'cancel',
                  time: '1000'
                });
              }
            } else if (item.type !== 'INDV' && item.type !== 'EXPT' && item.type !== 'ENTP') {
              _this2.bind(res.data.userid, head);
            }
          });
        });
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    bind: function bind(userid, head) {
      var _this3 = this;

      var openid = localStorage.getItem("openid");
      var unionid = localStorage.getItem('unionid');
      var nickname = localStorage.getItem('nickname');
      var imgurl = localStorage.getItem('imgurl');
      var obj = {
        account: userid.toString(),
        unionid: unionid,
        nickname: nickname,
        imgurl: imgurl,
        otp: 'official'
      };
      this.$http.post("/api/v1/wechat/" + openid, obj, head).then(function () {
        _this3.$http.get("/api/v1/wechat/" + unionid).then(function (res) {
          res.data.forEach(function (item) {
            if (_this3.list.indexOf(item.account) === -1) {
              _this3.list.push(item.account);
            }
          });
          alert("绑定成功");
        });
      }).catch(function (error) {
        _this3.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    tobinding: function tobinding(id) {
      this.$router.push({
        name: "binding",
        params: { id: id }
      });
    }
  },
  created: function created() {
    var _this4 = this;

    var openid = localStorage.getItem("openid");
    var unionid = localStorage.getItem('unionid');
    this.$http.get("/api/v1/wechat/" + unionid).then(function (res) {
      res.data.forEach(function (item) {
        if (_this4.list.indexOf(item.account) === -1) {
          _this4.list.push(item.account);
        }
      });
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === "vip") {
      next(function (vm) {
        vm.name = vm.$route.params.obj.name;
        vm.mobile = vm.$route.params.obj.mobile;
        localStorage.setItem("name", vm.$route.params.obj.name);
        localStorage.setItem("mobile", vm.$route.params.obj.mobile);
      });
    } else {
      next(function (vm) {
        vm.name = localStorage.getItem("name");
        vm.mobile = localStorage.getItem("mobile");
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== "binding") {
      localStorage.removeItem("name");
      localStorage.removeItem("mobile");
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/glzh.vue






/* harmony default export */ var components_glzh = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    Confirm: components_confirm["a" /* default */]
  },
  data: function data() {
    return {
      account: "",
      imgUrl: "/static/img/vip.png",
      name: "",
      mobile: "",
      showContent004: false,
      list: [],
      isShow: false,
      username: "",
      pwd: "",
      signoutShow: false
    };
  },

  methods: {
    signout: function signout() {
      var _this = this;

      var openid = localStorage.getItem("openid");
      var unionid = localStorage.getItem('unionid');
      var that = this;
      switch (this.list.length) {
        case 3:
          this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.list[2] }).then(function (res) {
            var opid = res.data.userid;
            var obj = {
              headers: {
                token: res.data.token,
                opid: opid
              }
            };
            _this.$http.delete("/api/v1/wechat/" + unionid + "?userid=" + opid, obj).then(function (res) {});
          });
        case 2:
          this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.list[1] }).then(function (res) {
            var opid = res.data.userid;
            var obj = {
              headers: {
                token: res.data.token,
                opid: opid
              }
            };
            _this.$http.delete("/api/v1/wechat/" + unionid + "?userid=" + opid, obj).then(function (res) {});
          });
        case 1:
          this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.list[0] }).then(function (res) {
            var opid = res.data.userid;
            var obj = {
              headers: {
                token: res.data.token,
                opid: opid
              }
            };
            _this.$http.delete("/api/v1/wechat/" + unionid + "?userid=" + opid, obj).then(function (res) {});
          });
          break;
      }
      setTimeout(function () {
        localStorage.clear();
        that.$router.push({ name: "login" });
      }, 500);
    },
    onShow: function onShow() {
      this.signoutShow = true;
    },
    onHide: function onHide() {
      this.signoutShow = false;
    },
    show: function show() {
      this.isShow = !this.isShow;
    },
    hide: function hide() {
      this.isShow = !this.isShow;
    },
    add: function add() {
      var _this2 = this;

      var userInfo = {
        passwd: this.pwd,
        account: this.username,
        is_passwd: true,
        tp: 'mobile'
      };
      this.isShow = !this.isShow;
      var roles = [];
      JSON.parse(localStorage.getItem('account')).forEach(function (item) {
        roles.push(item.role);
      });
      this.$http.post("/api/v1/accounts", userInfo).then(function (res) {
        var head = { headers: { token: res.data.token, opid: res.data.userid } };
        _this2.$http.get('/api/v1/accounts/' + res.data.userid, head).then(function (res1) {
          res1.data.forEach(function (item) {
            console.log(roles);
            if (roles.indexOf('ADMIN') !== -1) {
              if (item.type !== 'ADMIN' && item.type !== 'INDV' && item.type !== 'EXPT' && item.type !== 'ENTP') {
                console.log("bind");
                _this2.bind(res.data.userid, head);
              } else {
                _this2.$vux.toast.show({
                  text: '不可绑定相同权限账号',
                  type: 'cancel',
                  time: '1000'
                });
              }
            } else if (roles.indexOf('SRVP') !== -1) {
              if (item.type !== 'SRVP' && item.type !== 'INDV' && item.type !== 'EXPT' && item.type !== 'ENTP') {
                _this2.bind(res.data.userid, head);
              } else {
                _this2.$vux.toast.show({
                  text: '不可绑定相同权限账号',
                  type: 'cancel',
                  time: '1000'
                });
              }
            } else if (item.type !== 'INDV' && item.type !== 'EXPT' && item.type !== 'ENTP') {
              _this2.bind(res.data.userid, head);
            }
          });
        });
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    bind: function bind(userid, head) {
      var _this3 = this;

      var openid = localStorage.getItem("openid");
      var unionid = localStorage.getItem('unionid');
      var nickname = localStorage.getItem('nickname');
      var imgurl = localStorage.getItem('imgurl');
      var obj = {
        account: userid.toString(),
        unionid: unionid,
        nickname: nickname,
        imgurl: imgurl,
        otp: 'official'
      };
      this.$http.post("/api/v1/wechat/" + openid, obj, head).then(function () {
        _this3.$http.get("/api/v1/wechat/" + unionid).then(function (res) {
          res.data.forEach(function (item) {
            if (_this3.list.indexOf(item.account) === -1) {
              _this3.list.push(item.account);
            }
          });
          alert("绑定成功");
        });
      }).catch(function (error) {
        _this3.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    tobinding: function tobinding(id) {
      this.$router.push({
        name: "binding",
        params: { id: id }
      });
    }
  },
  created: function created() {
    var _this4 = this;

    var openid = localStorage.getItem("openid");
    var unionid = localStorage.getItem('unionid');
    this.$http.get("/api/v1/wechat/" + unionid).then(function (res) {
      res.data.forEach(function (item) {
        if (_this4.list.indexOf(item.account) === -1) {
          _this4.list.push(item.account);
        }
      });
    });
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === "vip") {
      next(function (vm) {
        vm.name = vm.$route.params.obj.name;
        vm.mobile = vm.$route.params.obj.mobile;
        localStorage.setItem("name", vm.$route.params.obj.name);
        localStorage.setItem("mobile", vm.$route.params.obj.mobile);
      });
    } else {
      next(function (vm) {
        vm.name = localStorage.getItem("name");
        vm.mobile = localStorage.getItem("mobile");
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== "binding") {
      localStorage.removeItem("name");
      localStorage.removeItem("mobile");
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a8164c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/glzh.vue
var glzh_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"font-size":"14px","padding-left":"10px","margin-top":"10px"}},[_vm._v("当前登录账号")]),_vm._v(" "),_c('div',{staticClass:"divheader"},[_c('div',{staticStyle:{"float":"left"}},[_c('img',{staticClass:"vipImage",attrs:{"src":_vm.imgUrl}})]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","left":"60px","top":"50px"}},[_c('span',{staticStyle:{"font-size":"0.85em"}},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.85em"}},[_vm._v(_vm._s(_vm.mobile))])])]),_vm._v(" "),_c('group',[_c('cell',{attrs:{"title":('我的账号'),"arrow-direction":_vm.showContent004?'up':'down',"is-link":"","border-intent":false},nativeOn:{"click":function($event){_vm.showContent004 = !_vm.showContent004}}}),_vm._v(" "),_c('ul',{staticClass:"slide",class:_vm.showContent004?'animate':''},_vm._l((_vm.list),function(item){return _c('li',{key:item,staticStyle:{"border-bottom":"1px solid gray"},on:{"click":function($event){_vm.tobinding(item)}}},[_vm._v(_vm._s(item)+"\n      ")])})),_vm._v(" "),_c('cell',{attrs:{"title":('退出登录')},nativeOn:{"click":function($event){return _vm.onShow($event)}}}),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{on:{"on-confirm":_vm.signout,"on-hide":_vm.onHide},model:{value:(_vm.signoutShow),callback:function ($$v) {_vm.signoutShow=$$v},expression:"signoutShow"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("退出后你将接收不到此微信号所绑定账号相关微信通知消息，是否退出？")])])],1)],1)],1)}
var glzh_staticRenderFns = []
var glzh_esExports = { render: glzh_render, staticRenderFns: glzh_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_glzh = (glzh_esExports);
// CONCATENATED MODULE: ./src/components/glzh.vue
function glzh_injectStyle (ssrContext) {
  __webpack_require__("jjCP")
}
var glzh_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var glzh___vue_template_functional__ = false
/* styles */
var glzh___vue_styles__ = glzh_injectStyle
/* scopeId */
var glzh___vue_scopeId__ = "data-v-63a8164c"
/* moduleIdentifier (server only) */
var glzh___vue_module_identifier__ = null
var glzh_Component = glzh_normalizeComponent(
  components_glzh,
  selectortype_template_index_0_src_components_glzh,
  glzh___vue_template_functional__,
  glzh___vue_styles__,
  glzh___vue_scopeId__,
  glzh___vue_module_identifier__
)

/* harmony default export */ var src_components_glzh = (glzh_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/xgmm.vue





/* harmony default export */ var xgmm = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button
  },
  name: "changepassword",
  data: function data() {
    return {
      oldpasswd: "",
      newpasswdone: "",
      newpasswdtwo: ""
    };
  },

  methods: {
    changepassword: function changepassword() {
      var that = this;
      var account = this.$route.params.id;
      var userInfo = {
        passwd: this.oldpasswd,
        account: account,
        is_passwd: true,
        tp: 'mobile'
      };
      var newUserInfo = {
        passwd: this.newpasswdtwo
      };
      this.$http.post("/api/v1/accounts", userInfo).then(function (res) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('userid', res.data.userid);
        var obj = {
          headers: {
            token: res.data.token,
            opid: res.data.userid
          }
        };

        if (that.newpasswdone !== that.newpasswdtwo) {
          that.$vux.toast.show({
            text: '密码不一致,请重新输入',
            type: 'cancel',
            time: '1000'
          });
        } else if (that.newpasswdone.length < 6) {
          that.$vux.toast.show({
            text: '密码长度不能少于6位',
            type: 'cancel',
            time: '1000'
          });
        } else {
          that.$http.put("/api/v1/accounts/" + res.data.userid, newUserInfo, obj).then(function (res) {
            that.$vux.toast.show({
              text: '修改成功',
              type: 'success',
              time: '1000'
            });
            that.$router.push({ path: "/" });
          });
        }
      }).catch(function (error) {
        if (error.response) {
          if (error.response.data.error_message) {
            that.$vux.toast.show({
              text: '原密码错误,请重新输入',
              type: 'cancel',
              time: '1000'
            });
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/xgmm.vue





/* harmony default export */ var components_xgmm = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button
  },
  name: "changepassword",
  data: function data() {
    return {
      oldpasswd: "",
      newpasswdone: "",
      newpasswdtwo: ""
    };
  },

  methods: {
    changepassword: function changepassword() {
      var that = this;
      var account = this.$route.params.id;
      var userInfo = {
        passwd: this.oldpasswd,
        account: account,
        is_passwd: true,
        tp: 'mobile'
      };
      var newUserInfo = {
        passwd: this.newpasswdtwo
      };
      this.$http.post("/api/v1/accounts", userInfo).then(function (res) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('userid', res.data.userid);
        var obj = {
          headers: {
            token: res.data.token,
            opid: res.data.userid
          }
        };

        if (that.newpasswdone !== that.newpasswdtwo) {
          that.$vux.toast.show({
            text: '密码不一致,请重新输入',
            type: 'cancel',
            time: '1000'
          });
        } else if (that.newpasswdone.length < 6) {
          that.$vux.toast.show({
            text: '密码长度不能少于6位',
            type: 'cancel',
            time: '1000'
          });
        } else {
          that.$http.put("/api/v1/accounts/" + res.data.userid, newUserInfo, obj).then(function (res) {
            that.$vux.toast.show({
              text: '修改成功',
              type: 'success',
              time: '1000'
            });
            that.$router.push({ path: "/" });
          });
        }
      }).catch(function (error) {
        if (error.response) {
          if (error.response.data.error_message) {
            that.$vux.toast.show({
              text: '原密码错误,请重新输入',
              type: 'cancel',
              time: '1000'
            });
          }
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3da3ed0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xgmm.vue
var xgmm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('group',[_c('x-input',{attrs:{"title":"原密码","required":"","type":"password","placeholder":"请输入原密码"},model:{value:(_vm.oldpasswd),callback:function ($$v) {_vm.oldpasswd=$$v},expression:"oldpasswd"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"请输入密码","required":"","type":"password","placeholder":"请输入新密码","min":6,"show-clear":false},model:{value:(_vm.newpasswdone),callback:function ($$v) {_vm.newpasswdone=$$v},expression:"newpasswdone"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"请确认密码","required":"","type":"password","placeholder":"再次输入新密码","equal-with":_vm.newpasswdone,"show-clear":false},model:{value:(_vm.newpasswdtwo),callback:function ($$v) {_vm.newpasswdtwo=$$v},expression:"newpasswdtwo"}})],1),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changepassword($event)}}},[_vm._v("确定修改")])],1)])}
var xgmm_staticRenderFns = []
var xgmm_esExports = { render: xgmm_render, staticRenderFns: xgmm_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_xgmm = (xgmm_esExports);
// CONCATENATED MODULE: ./src/components/xgmm.vue
var xgmm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var xgmm___vue_template_functional__ = false
/* styles */
var xgmm___vue_styles__ = null
/* scopeId */
var xgmm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var xgmm___vue_module_identifier__ = null
var xgmm_Component = xgmm_normalizeComponent(
  components_xgmm,
  selectortype_template_index_0_src_components_xgmm,
  xgmm___vue_template_functional__,
  xgmm___vue_styles__,
  xgmm___vue_scopeId__,
  xgmm___vue_module_identifier__
)

/* harmony default export */ var src_components_xgmm = (xgmm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/enterpriseUsers.vue

















/* harmony default export */ var enterpriseUsers = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address
  },
  data: function data() {
    return {
      enterpriseusers: {}
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$http.get('/api/v1/companys/mmm005').then(function (response) {
        if (response.data.detail) {
          vm.enterpriseusers = response.data;
        }
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/enterpriseUsers.vue

















/* harmony default export */ var components_enterpriseUsers = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address
  },
  data: function data() {
    return {
      enterpriseusers: {}
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$http.get('/api/v1/companys/mmm005').then(function (response) {
        if (response.data.detail) {
          vm.enterpriseusers = response.data;
        }
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe22300","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseUsers.vue
var enterpriseUsers_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("企业用户")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"姓名","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.account),callback:function ($$v) {_vm.$set(_vm.enterpriseusers, "account", $$v)},expression:"enterpriseusers.account"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"组织机构代码","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.orgcode),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "orgcode", $$v)},expression:"enterpriseusers.detail.orgcode"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"公司名","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.company),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "company", $$v)},expression:"enterpriseusers.detail.company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"成立日期","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.estdate),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "estdate", $$v)},expression:"enterpriseusers.detail.estdate"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"营业地址","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.busaddress),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "busaddress", $$v)},expression:"enterpriseusers.detail.busaddress"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"员工人数","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.Staffnum),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "Staffnum", $$v)},expression:"enterpriseusers.detail.Staffnum"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"所在行业","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.industry),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "industry", $$v)},expression:"enterpriseusers.detail.industry"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"法人","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.legalperson),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "legalperson", $$v)},expression:"enterpriseusers.detail.legalperson"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"法人手机","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.legalmobile),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "legalmobile", $$v)},expression:"enterpriseusers.detail.legalmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"法人座机","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.legalphone),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "legalphone", $$v)},expression:"enterpriseusers.detail.legalphone"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"实际负责人","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.actualperson),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "actualperson", $$v)},expression:"enterpriseusers.detail.actualperson"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"实际负责人手机","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.actualmobile),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "actualmobile", $$v)},expression:"enterpriseusers.detail.actualmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"实际负责人座机","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.actualphone),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "actualphone", $$v)},expression:"enterpriseusers.detail.actualphone"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"云帷负责人","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.yunperson),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "yunperson", $$v)},expression:"enterpriseusers.detail.yunperson"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"云帷负责人手机","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.Yunmobile),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "Yunmobile", $$v)},expression:"enterpriseusers.detail.Yunmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"云帷负责人座机","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.yunphone),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "yunphone", $$v)},expression:"enterpriseusers.detail.yunphone"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"收货地址","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.delvaddress),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "delvaddress", $$v)},expression:"enterpriseusers.detail.delvaddress"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"发票信息","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.invoice.origin),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail.invoice, "origin", $$v)},expression:"enterpriseusers.detail.invoice.origin"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"执行书","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.execert.origin),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail.execert, "origin", $$v)},expression:"enterpriseusers.detail.execert.origin"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"授权书","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.authcert.origin),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail.authcert, "origin", $$v)},expression:"enterpriseusers.detail.authcert.origin"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请人","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.Name),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "Name", $$v)},expression:"enterpriseusers.detail.Name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请人手机","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.mobile),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "mobile", $$v)},expression:"enterpriseusers.detail.mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请人email","type":"text","readonly":""},model:{value:(_vm.enterpriseusers.detail.email),callback:function ($$v) {_vm.$set(_vm.enterpriseusers.detail, "email", $$v)},expression:"enterpriseusers.detail.email"}})],1),_vm._v(" "),_c('footer',[_vm._v("如发现信息有误,请联系客服人员")])],1)}
var enterpriseUsers_staticRenderFns = []
var enterpriseUsers_esExports = { render: enterpriseUsers_render, staticRenderFns: enterpriseUsers_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_enterpriseUsers = (enterpriseUsers_esExports);
// CONCATENATED MODULE: ./src/components/enterpriseUsers.vue
function enterpriseUsers_injectStyle (ssrContext) {
  __webpack_require__("Qy6+")
}
var enterpriseUsers_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var enterpriseUsers___vue_template_functional__ = false
/* styles */
var enterpriseUsers___vue_styles__ = enterpriseUsers_injectStyle
/* scopeId */
var enterpriseUsers___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var enterpriseUsers___vue_module_identifier__ = null
var enterpriseUsers_Component = enterpriseUsers_normalizeComponent(
  components_enterpriseUsers,
  selectortype_template_index_0_src_components_enterpriseUsers,
  enterpriseUsers___vue_template_functional__,
  enterpriseUsers___vue_styles__,
  enterpriseUsers___vue_scopeId__,
  enterpriseUsers___vue_module_identifier__
)

/* harmony default export */ var src_components_enterpriseUsers = (enterpriseUsers_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/attention.vue





/* harmony default export */ var attention = ({
  name: 'attention',
  data: function data() {
    return {
      imgUrl: '/static/img/qrcode.jpg',
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        url = isiOS ? window.location.href : config.host + app.$route.path;
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode']
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {

          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var openid = localStorage.getItem('openid');
    next(function (vm) {
      ajax["a" /* default */].$http.get('/api/v1/wechat/' + openid + '/Info').then(function (response) {
        if (response.data.subscribe) {
          vm.$router.push({ path: 'sbxx' });
        } else {
          vm.isShow = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/attention.vue





/* harmony default export */ var components_attention = ({
  name: 'attention',
  data: function data() {
    return {
      imgUrl: '/static/img/qrcode.jpg',
      isShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        url = isiOS ? window.location.href : config.host + app.$route.path;
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode']
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {

          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var openid = localStorage.getItem('openid');
    next(function (vm) {
      ajax["a" /* default */].$http.get('/api/v1/wechat/' + openid + '/Info').then(function (response) {
        if (response.data.subscribe) {
          vm.$router.push({ path: 'sbxx' });
        } else {
          vm.isShow = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c91652c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/attention.vue
var attention_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}]},[_c('div',{staticClass:"canyinzhang"},[_vm._v("请先扫描下方二维码关注公众号")]),_vm._v(" "),_c('img',{staticStyle:{"width":"60%","height":"auto","margin-left":"20%"},attrs:{"src":_vm.imgUrl}})])])}
var attention_staticRenderFns = []
var attention_esExports = { render: attention_render, staticRenderFns: attention_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_attention = (attention_esExports);
// CONCATENATED MODULE: ./src/components/attention.vue
function attention_injectStyle (ssrContext) {
  __webpack_require__("pmvC")
}
var attention_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var attention___vue_template_functional__ = false
/* styles */
var attention___vue_styles__ = attention_injectStyle
/* scopeId */
var attention___vue_scopeId__ = "data-v-3c91652c"
/* moduleIdentifier (server only) */
var attention___vue_module_identifier__ = null
var attention_Component = attention_normalizeComponent(
  components_attention,
  selectortype_template_index_0_src_components_attention,
  attention___vue_template_functional__,
  attention___vue_styles__,
  attention___vue_scopeId__,
  attention___vue_module_identifier__
)

/* harmony default export */ var src_components_attention = (attention_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sbxx.vue










/* harmony default export */ var sbxx = ({
  name: 'sbxx',
  data: function data() {
    return {
      data: {
        extname: '',
        sn: '',
        seq: ''
      },
      flag: true,
      state: '未绑定',
      status: '',
      statusflag: false
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector
  },
  methods: {
    recordlist: function recordlist() {
      this.$router.push({ name: 'recordlist', params: { data: this.data } });
    },
    bind: function bind() {
      this.$router.push({ name: 'smallbox', params: { order: this.data, role: this.role } });
    },
    repairs: function repairs() {
      this.$router.push({ name: 'normalrepairs', params: { obj: this.data, isviwo: '是' } });
    }
  },
  created: function created() {
    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    var that = this;
    this.$http.get("api/v1/wechat/" + unionid).then(function (res) {

      if (res.data.length) {
        var account = res.data[0].account;
        that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };
          that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                that.role = response.data[i].type;
                break;
              }
              if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                that.isid = response.data[i].type;
              }
            }

            if (that.role == 'INDV' || that.role == 'ENTP') {

              that.$http.get('api/v1/users/' + opid + '/devices', obj).then(function (res) {
                var data = res.data.monitors;
                if (data.length !== 0) {
                  for (var _i = 0; _i < data.length; _i++) {
                    if (data[_i].seq == that.data.seq) {
                      that.flag = false;
                      that.state = '已绑定';
                      that.statusflag = true;
                      that.status = data[0].connected == 'YES' ? '正常' : '断开链接';
                      break;
                    } else {
                      if (data[_i].devices.length !== 0) {
                        for (var j = 0; j < data[_i].devices.length; j++) {
                          if (data[_i].devices[j].hasOwnProperty('nodes')) {
                            for (var k = 0; k < data[_i].devices[j].nodes.length; k++) {
                              if (data[_i].devices[j].nodes[k].seq === that.data.seq && data[_i].devices[j].nodes[k].bonded === 'YES') {
                                that.flag = false;
                                that.state = '已绑定';
                                that.statusflag = true;
                                switch (data[_i].devices[j].nodes[k].status) {
                                  case 'OK':
                                    that.status = '正常';
                                    break;
                                  case 'WARN':
                                    that.status = '警告';
                                    break;
                                  case 'ERROR':
                                    that.status = '故障';
                                    break;
                                  case 'Disconnect':
                                    that.status = '断开连接';
                                    break;
                                }
                                break;
                              }
                            }
                          } else {
                            if (data[_i].devices[j].node.seq == that.data.seq && data[_i].devices[j].node.bonded === 'YES') {
                              that.flag = false;
                              that.state = '已绑定';
                              that.statusflag = true;
                              switch (data[_i].devices[j].node.status) {
                                case 'OK':
                                  that.status = '正常';
                                  break;
                                case 'WARN':
                                  that.status = '警告';
                                  break;
                                case 'ERROR':
                                  that.status = '故障';
                                  break;
                                case 'Disconnect':
                                  that.status = '断开连接';
                                  break;
                              }
                              break;
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  that.flag = true;
                  that.state = '未绑定';
                }
              }).catch(function (err) {
                console.log(err);
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      } else {
        that.flag = true;
        that.state = '未绑定';
      }
    });
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name !== 'normalrepairs') {
      next(function (vm) {
        ajax["a" /* default */].$http.get('/api/v1/devices/' + from.query.id + '/wechat?type=USER&role=INDV').then(function (response) {
          if (response.data) {
            vm.data = response.data;
            localStorage.removeItem('history');
          }
        }).catch(function (error) {
          vm.$vux.alert.show({
            title: '',
            content: '无法识别编码,请确定是否扫描云帷编码?'
          });
          vm.data = {};
        });
      });
    } else {
      next(function (vm) {
        var obj = {};
        obj.extname = vm.$route.params.extname;
        obj.sn = vm.$route.params.sn;
        obj.seq = vm.$route.params.seq;
        vm.data = obj;
        localStorage.removeItem('history');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sbxx.vue










/* harmony default export */ var components_sbxx = ({
  name: 'sbxx',
  data: function data() {
    return {
      data: {
        extname: '',
        sn: '',
        seq: ''
      },
      flag: true,
      state: '未绑定',
      status: '',
      statusflag: false
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector
  },
  methods: {
    recordlist: function recordlist() {
      this.$router.push({ name: 'recordlist', params: { data: this.data } });
    },
    bind: function bind() {
      this.$router.push({ name: 'smallbox', params: { order: this.data, role: this.role } });
    },
    repairs: function repairs() {
      this.$router.push({ name: 'normalrepairs', params: { obj: this.data, isviwo: '是' } });
    }
  },
  created: function created() {
    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    var that = this;
    this.$http.get("api/v1/wechat/" + unionid).then(function (res) {

      if (res.data.length) {
        var account = res.data[0].account;
        that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };
          that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                that.role = response.data[i].type;
                break;
              }
              if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                that.isid = response.data[i].type;
              }
            }

            if (that.role == 'INDV' || that.role == 'ENTP') {

              that.$http.get('api/v1/users/' + opid + '/devices', obj).then(function (res) {
                var data = res.data.monitors;
                if (data.length !== 0) {
                  for (var _i = 0; _i < data.length; _i++) {
                    if (data[_i].seq == that.data.seq) {
                      that.flag = false;
                      that.state = '已绑定';
                      that.statusflag = true;
                      that.status = data[0].connected == 'YES' ? '正常' : '断开链接';
                      break;
                    } else {
                      if (data[_i].devices.length !== 0) {
                        for (var j = 0; j < data[_i].devices.length; j++) {
                          if (data[_i].devices[j].hasOwnProperty('nodes')) {
                            for (var k = 0; k < data[_i].devices[j].nodes.length; k++) {
                              if (data[_i].devices[j].nodes[k].seq === that.data.seq && data[_i].devices[j].nodes[k].bonded === 'YES') {
                                that.flag = false;
                                that.state = '已绑定';
                                that.statusflag = true;
                                switch (data[_i].devices[j].nodes[k].status) {
                                  case 'OK':
                                    that.status = '正常';
                                    break;
                                  case 'WARN':
                                    that.status = '警告';
                                    break;
                                  case 'ERROR':
                                    that.status = '故障';
                                    break;
                                  case 'Disconnect':
                                    that.status = '断开连接';
                                    break;
                                }
                                break;
                              }
                            }
                          } else {
                            if (data[_i].devices[j].node.seq == that.data.seq && data[_i].devices[j].node.bonded === 'YES') {
                              that.flag = false;
                              that.state = '已绑定';
                              that.statusflag = true;
                              switch (data[_i].devices[j].node.status) {
                                case 'OK':
                                  that.status = '正常';
                                  break;
                                case 'WARN':
                                  that.status = '警告';
                                  break;
                                case 'ERROR':
                                  that.status = '故障';
                                  break;
                                case 'Disconnect':
                                  that.status = '断开连接';
                                  break;
                              }
                              break;
                            }
                          }
                        }
                      }
                    }
                  }
                } else {
                  that.flag = true;
                  that.state = '未绑定';
                }
              }).catch(function (err) {
                console.log(err);
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      } else {
        that.flag = true;
        that.state = '未绑定';
      }
    });
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name !== 'normalrepairs') {
      next(function (vm) {
        ajax["a" /* default */].$http.get('/api/v1/devices/' + from.query.id + '/wechat?type=USER&role=INDV').then(function (response) {
          if (response.data) {
            vm.data = response.data;
            localStorage.removeItem('history');
          }
        }).catch(function (error) {
          vm.$vux.alert.show({
            title: '',
            content: '无法识别编码,请确定是否扫描云帷编码?'
          });
          vm.data = {};
        });
      });
    } else {
      next(function (vm) {
        var obj = {};
        obj.extname = vm.$route.params.extname;
        obj.sn = vm.$route.params.sn;
        obj.seq = vm.$route.params.seq;
        vm.data = obj;
        localStorage.removeItem('history');
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e5b7f6f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sbxx.vue
var sbxx_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"设备名称","type":"text","readonly":""},model:{value:(_vm.data.extname),callback:function ($$v) {_vm.$set(_vm.data, "extname", $$v)},expression:"data.extname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.data.sn),callback:function ($$v) {_vm.$set(_vm.data, "sn", $$v)},expression:"data.sn"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备绑定","type":"text","readonly":""},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}}),_vm._v(" "),(!_vm.flag)?_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center","margin-left":"15px","border-top":"1px solid #666","line-height":"45px"}},[_c('div',[_c('span',{staticStyle:{"color":"#999"}},[_vm._v("设备状态")]),_vm._v(" "),(_vm.statusflag)?_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.status))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"Triangle",on:{"click":_vm.recordlist}})]):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[(_vm.flag)?_c('x-button',{staticStyle:{"margin":"10px"},attrs:{"mini":"","plain":"","type":"primary"},nativeOn:{"click":function($event){return _vm.bind($event)}}},[_vm._v("绑定")]):_vm._e(),_vm._v(" "),_c('x-button',{staticStyle:{"margin":"10px"},attrs:{"mini":"","plain":"","type":"primary"},nativeOn:{"click":function($event){return _vm.repairs($event)}}},[_vm._v("报修")])],1)],1)}
var sbxx_staticRenderFns = []
var sbxx_esExports = { render: sbxx_render, staticRenderFns: sbxx_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_sbxx = (sbxx_esExports);
// CONCATENATED MODULE: ./src/components/sbxx.vue
function sbxx_injectStyle (ssrContext) {
  __webpack_require__("o2+o")
}
var sbxx_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sbxx___vue_template_functional__ = false
/* styles */
var sbxx___vue_styles__ = sbxx_injectStyle
/* scopeId */
var sbxx___vue_scopeId__ = "data-v-0e5b7f6f"
/* moduleIdentifier (server only) */
var sbxx___vue_module_identifier__ = null
var sbxx_Component = sbxx_normalizeComponent(
  components_sbxx,
  selectortype_template_index_0_src_components_sbxx,
  sbxx___vue_template_functional__,
  sbxx___vue_styles__,
  sbxx___vue_scopeId__,
  sbxx___vue_module_identifier__
)

/* harmony default export */ var src_components_sbxx = (sbxx_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forgetpassword.vue






/* harmony default export */ var forgetpassword = ({
  data: function data() {
    return {
      buttonText: '获取验证码',
      SmsCode: '',
      mobile: '',
      newpasswdone: '',
      newpasswdtwo: '',
      aa: '',
      smsDisabled: false
    };
  },

  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button
  },
  methods: {
    getcode: function getcode() {
      var that = this;
      var obj = {
        nationcode: '86',
        mobile: this.mobile
      };
      if (this.mobile) {
        this.$http.post('/api/v1/accounts/sms', obj).then(function (response) {
          that.aa = response.data.data;
          if (response.data.result === 0) {
            var validateCode = {
              timestamp: parseInt(new Date().getTime() / 1000),
              code: response.data.data
            };
            localStorage.setItem('validateCode', stringify_default()(validateCode));
          } else {
            that.$vux.alert.show({
              title: '',
              content: response.data.errmsg
            });
          }
        });
        localStorage.setItem('countDown', 60);
        that.timeKeeping();
      }
    },
    changepassword: function changepassword() {
      var _this = this;

      var newUserInfo = {
        passwd: this.newpasswdtwo
      };
      var that = this;
      if (this.newpasswdone !== this.newpasswdtwo) {
        // 新密码不一致
        this.$vux.toast.show({
          text: "密码不一致,请重新输入",
          type: "cancel",
          time: "1000"
        });
      } else {
        // 新密码一致
        this.$http.put('/api/v1/accounts/' + this.mobile + '/checksms', {
          code: this.SmsCode,
          passwd: this.newpasswdtwo
        }).then(function (res) {
          that.$vux.toast.show({
            text: "修改成功",
            type: "success",
            time: "1000"
          });
          that.$router.push({ path: "login" });
        }).catch(function (error) {
          _this.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      }
    },
    timeKeeping: function timeKeeping() {
      this.smsDisabled = true;
      var app = this;
      var interval = setInterval(function () {

        var countDown = parseInt(localStorage.getItem('countDown'));

        app.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          localStorage.removeItem('countDown');
          app.buttonText = '重新发送';
          app.smsDisabled = false;
        } else {
          countDown--;
          localStorage.setItem('countDown', countDown);
        }
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/forgetpassword.vue






/* harmony default export */ var components_forgetpassword = ({
  data: function data() {
    return {
      buttonText: '获取验证码',
      SmsCode: '',
      mobile: '',
      newpasswdone: '',
      newpasswdtwo: '',
      aa: '',
      smsDisabled: false
    };
  },

  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button
  },
  methods: {
    getcode: function getcode() {
      var that = this;
      var obj = {
        nationcode: '86',
        mobile: this.mobile
      };
      if (this.mobile) {
        this.$http.post('/api/v1/accounts/sms', obj).then(function (response) {
          that.aa = response.data.data;
          if (response.data.result === 0) {
            var validateCode = {
              timestamp: parseInt(new Date().getTime() / 1000),
              code: response.data.data
            };
            localStorage.setItem('validateCode', stringify_default()(validateCode));
          } else {
            that.$vux.alert.show({
              title: '',
              content: response.data.errmsg
            });
          }
        });
        localStorage.setItem('countDown', 60);
        that.timeKeeping();
      }
    },
    changepassword: function changepassword() {
      var _this = this;

      var newUserInfo = {
        passwd: this.newpasswdtwo
      };
      var that = this;
      if (this.newpasswdone !== this.newpasswdtwo) {
        // 新密码不一致
        this.$vux.toast.show({
          text: "密码不一致,请重新输入",
          type: "cancel",
          time: "1000"
        });
      } else {
        // 新密码一致
        this.$http.put('/api/v1/accounts/' + this.mobile + '/checksms', {
          code: this.SmsCode,
          passwd: this.newpasswdtwo
        }).then(function (res) {
          that.$vux.toast.show({
            text: "修改成功",
            type: "success",
            time: "1000"
          });
          that.$router.push({ path: "login" });
        }).catch(function (error) {
          _this.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      }
    },
    timeKeeping: function timeKeeping() {
      this.smsDisabled = true;
      var app = this;
      var interval = setInterval(function () {

        var countDown = parseInt(localStorage.getItem('countDown'));

        app.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          localStorage.removeItem('countDown');
          app.buttonText = '重新发送';
          app.smsDisabled = false;
        } else {
          countDown--;
          localStorage.setItem('countDown', countDown);
        }
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a0345b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forgetpassword.vue
var forgetpassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{ref:"input2",attrs:{"title":"注册手机号码","required":"","max":13,"is-type":"china-mobile","placeholder":"请输入手机号码","show-clear":false},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}),_vm._v(" "),_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"验证码"},model:{value:(_vm.SmsCode),callback:function ($$v) {_vm.SmsCode=$$v},expression:"SmsCode"}},[_c('x-button',{attrs:{"slot":"right","type":"primary","mini":"","disabled":_vm.smsDisabled,"text":_vm.buttonText},nativeOn:{"click":function($event){return _vm.getcode($event)}},slot:"right"})],1),_vm._v(" "),_c('x-input',{attrs:{"title":"请输入密码","required":"","type":"password","placeholder":"请输入密码","min":6,"show-clear":false},model:{value:(_vm.newpasswdone),callback:function ($$v) {_vm.newpasswdone=$$v},expression:"newpasswdone"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"请确认密码","required":"","type":"password","placeholder":"请确认密码","equal-with":_vm.newpasswdone,"show-clear":false},model:{value:(_vm.newpasswdtwo),callback:function ($$v) {_vm.newpasswdtwo=$$v},expression:"newpasswdtwo"}}),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.changepassword($event)}}},[_vm._v("确认修改")])],1)],1)}
var forgetpassword_staticRenderFns = []
var forgetpassword_esExports = { render: forgetpassword_render, staticRenderFns: forgetpassword_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_forgetpassword = (forgetpassword_esExports);
// CONCATENATED MODULE: ./src/components/forgetpassword.vue
function forgetpassword_injectStyle (ssrContext) {
  __webpack_require__("pi9w")
}
var forgetpassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var forgetpassword___vue_template_functional__ = false
/* styles */
var forgetpassword___vue_styles__ = forgetpassword_injectStyle
/* scopeId */
var forgetpassword___vue_scopeId__ = "data-v-26a0345b"
/* moduleIdentifier (server only) */
var forgetpassword___vue_module_identifier__ = null
var forgetpassword_Component = forgetpassword_normalizeComponent(
  components_forgetpassword,
  selectortype_template_index_0_src_components_forgetpassword,
  forgetpassword___vue_template_functional__,
  forgetpassword___vue_styles__,
  forgetpassword___vue_scopeId__,
  forgetpassword___vue_module_identifier__
)

/* harmony default export */ var src_components_forgetpassword = (forgetpassword_Component.exports);

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("JnrT");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1665f55a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-textarea/index.vue
var x_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){_vm.$emit('on-focus')},"blur":function($event){_vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var x_textarea_staticRenderFns = []
var x_textarea_esExports = { render: x_textarea_render, staticRenderFns: x_textarea_staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (x_textarea_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-textarea/index.vue
function x_textarea_injectStyle (ssrContext) {
  __webpack_require__("9TJo")
}
var x_textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_textarea___vue_template_functional__ = false
/* styles */
var x_textarea___vue_styles__ = x_textarea_injectStyle
/* scopeId */
var x_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_textarea___vue_module_identifier__ = null
var x_textarea_Component = x_textarea_normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  x_textarea___vue_template_functional__,
  x_textarea___vue_styles__,
  x_textarea___vue_scopeId__,
  x_textarea___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_textarea = (x_textarea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/rapidrepairs.vue



















/* harmony default export */ var rapidrepairs = ({
  data: function data() {
    return {
      isviwo: false,
      devseq: "",
      devname: "",
      devmodel: '',
      producer: '',
      buyfrom: "",
      company: '',
      ftype: '',
      name: '',
      mobile: '',
      fdesc: "",
      title: '默认为空',
      value_0_1: [],
      value: [],
      showLoading: false,
      title2: '设置值',
      value2: ['天津市', '市辖区', '和平区'],
      value3: ['广东省', '中山市', '--'],
      addressData: china_address_v4_default.a,
      value4: [],
      value5: ['广东省', '深圳 市', '南山区'],
      showAddress: false,
      address: [],
      address2: '',
      viwoList: [{ key: true, value: '是' }, { key: false, value: '否' }],
      eduList: [{ key: 1, value: '设备启动故障' }, { key: 2, value: '设备死机故障' }, { key: 3, value: '设备显示故障' }, {
        key: 4,
        value: '设备识别故障'
      }, { key: 5, value: '设备输入输出故障' }, { key: 6, value: '设备音频故障' }, { key: 7, value: '设备其他故障' }],
      imgUrl: '/static/img/flick.png',
      imgList: {
        version: '1.0',
        content: []
      },
      isProducer: false,
      producerList: []
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    XTextarea: vux_src_components_x_textarea,
    Alert: components_alert["a" /* default */],
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector,
    XButton: vux_src_components_x_button
  },
  methods: {
    faultType: function faultType() {
      var obj = {
        isviwo: this.isviwo,
        sevenday: this.sevenday,
        devseq: this.devseq,
        devname: this.devname,
        devmodel: this.devmodel,
        producer: this.producer,
        buyfrom: this.buyfrom,
        company: this.company,
        name: this.name,
        mobile: this.mobile,
        address: Object(value2name["a" /* default */])(this.address, china_address_v4_default.a),
        address2: this.address2,
        fdetail: this.imgList.content,
        ftype: this.ftype,
        fdesc: this.fdesc
      };
      localStorage.setItem('fault', stringify_default()(obj));
      this.$router.push({ name: 'faultType', params: { repair: 'rapid' } });
    },
    findSrvp: function findSrvp() {
      var _this = this;

      this.$http.get('/api/v1/devices/companies?value=' + this.producer).then(function (response) {
        _this.producerList = response.data;
        if (_this.producerList.length === 1) {
          if (_this.producer !== _this.producerList[0]) {
            _this.isProducer = true;
          }
        } else {
          _this.isProducer = true;
        }
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'warn',
          position: 'top',
          time: '10000'
        });
      });
    },
    chose: function chose(producer) {
      this.producer = producer;
      this.isProducer = false;
    },
    submit: function submit() {
      var _this2 = this;

      this.showLoading = true;
      var address = {
        address1: Object(value2name["a" /* default */])(this.address, china_address_v4_default.a),
        address2: this.address2
      };
      address.address1 = address.address1.split(' ');
      if (this.ftype === '' || this.fdesc === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写故障信息',
          type: 'cancel'
        });
        return;
      }
      if (this.name === '' || this.mobile === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写报修人信息',
          type: 'cancel'
        });
        return;
      }
      if (this.address1 === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写详细地址',
          type: 'cancel'
        });
        return;
      }
      if (this.ftype != '' && this.fdesc != '' && this.name != '' && this.mobile != '' && address.address1 != '' && address.devseq != '' && address.devname != '') {
        var openid = localStorage.getItem("openid");
        var unionid = localStorage.getItem('unionid');
        var nickname = localStorage.getItem('nickname');
        var imgurl = localStorage.getItem('imgurl');
        var obj = {
          openid: openid,
          unionid: unionid,
          otp: 'official',
          nickname: nickname,
          imgurl: imgurl,
          isviwo: this.isviwo,
          devseq: this.devseq,
          devname: this.devname,
          devmodel: this.devmodel,
          producer: this.producer,
          buyfrom: this.buyfrom,
          company: this.company,
          name: this.name,
          mobile: this.mobile,
          ftype: this.ftype,
          fdesc: this.fdesc,
          province: address.address1[0],
          city: address.address1[1],
          district: address.address1[2],
          address: address.address2,
          fdetail: this.imgList
        };
        var that = this;
        this.$http.post("api/v1/fastrepairs", obj).then(function (res) {
          if (res.status == 201) {
            _this2.showLoading = false;
            that.$router.push({ name: 'rapidrepairslist' });
          }
        }).catch(function (error) {
          this.showLoading = false;
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            } else {
              that.$vux.alert.show({
                title: '',
                content: '服务器错误，请稍后重试'
              });
            }
          } else if (error.request) {
            that.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
            console.log(error.request);
          } else {
            that.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
            console.log('Error', error.message);
          }
        });
      } else {
        this.showLoading = false;
        this.$vux.alert.show({
          text: '输入信息不完整，请补全后再提交',
          type: 'cancel'
        });
      }
    },

    sys_click: function sys_click() {
      var that = this;
      weixin_js_sdk_default.a.error(function (res) {
        alert(res.errMsg);
      });
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.checkJsApi({
          jsApiList: ['scanQRCode'],
          success: function success(res) {}
        });
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function success(res) {
            var result = res.resultStr;

            var url = result.substring(result.lastIndexOf('?') + 1, result.length);
            var loc = url.substring(url.lastIndexOf('=') + 1, url.length);
            ajax["a" /* default */].$http.get('/api/v1/devices/' + loc + '/wechat?type=USER').then(function (response) {
              if (response.data) {
                that.devname = response.data.extname;
                that.devseq = response.data.sn;
              } else {
                that.$vux.alert.show({
                  title: '',
                  content: '无法识别编码,请确定是否扫描编码?'
                });
              }
            }).catch(function (err) {
              that.$vux.confirm.show({
                title: '',
                content: '非云帷设备,请手动输入设备序列号和设备名称',
                onConfirm: function onConfirm() {
                  that.devname = '';
                  that.devseq = '';
                  that.$refs.content.focus();
                }
              });
            });
          }
        });
      });
    },
    back: function back() {
      this.$router.push({ name: 'rapidrepairslist' });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this3;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {

          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode']
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {

          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'faultType') {
      next(function (vm) {
        if (vm.$route.params.obj) {
          vm.devseq = vm.$route.params.obj.devseq;
          vm.devname = vm.$route.params.obj.devname;
          vm.devmodel = vm.$route.params.obj.devmodel;
          vm.producer = vm.$route.params.obj.producer;
          vm.buyfrom = vm.$route.params.obj.buyfrom;
          vm.company = vm.$route.params.obj.company;
          vm.ftype = vm.$route.params.obj.ftype;
          vm.name = vm.$route.params.obj.name;
          vm.mobile = vm.$route.params.obj.mobile;
          vm.fdesc = vm.$route.params.obj.fdesc;
          vm.address = vm.$route.params.obj.address.split(' ');
          vm.address2 = vm.$route.params.obj.address2;
          vm.isviwo = vm.$route.params.obj.isviwo;
          vm.imgList.content = vm.$route.params.obj.fdetail;
        } else {
          var fault = localStorage.getItem('fault');
          var obj = JSON.parse(fault);
          vm.devseq = obj.devseq;
          vm.devname = obj.devname;
          vm.devmodel = obj.devmodel;
          vm.producer = obj.producer;
          vm.buyfrom = obj.buyfrom;
          vm.company = obj.company;
          vm.ftype = obj.ftype;
          vm.name = obj.name;
          vm.mobile = obj.mobile;
          vm.fdesc = obj.fdesc;
          vm.address = obj.address.split(' ');
          vm.address2 = obj.address2;
          vm.isviwo = obj.isviwo;
          vm.imgList.content = obj.fdetail;
        }
      });
    } else if (from.name == 'sbxx') {
      next(function (vm) {
        vm.devname = vm.$route.params.obj.extname;
        vm.devseq = vm.$route.params.obj.sn;
      });
    } else {
      next();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'faultType') {
      next();
    } else {
      localStorage.removeItem('obj');
      localStorage.removeItem('ftype');
      localStorage.removeItem('subClass1');
      localStorage.removeItem('subClass2');
      localStorage.removeItem('fdesc');
      localStorage.removeItem('fault');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/rapidrepairs.vue



















/* harmony default export */ var components_rapidrepairs = ({
  data: function data() {
    return {
      isviwo: false,
      devseq: "",
      devname: "",
      devmodel: '',
      producer: '',
      buyfrom: "",
      company: '',
      ftype: '',
      name: '',
      mobile: '',
      fdesc: "",
      title: '默认为空',
      value_0_1: [],
      value: [],
      showLoading: false,
      title2: '设置值',
      value2: ['天津市', '市辖区', '和平区'],
      value3: ['广东省', '中山市', '--'],
      addressData: china_address_v4_default.a,
      value4: [],
      value5: ['广东省', '深圳 市', '南山区'],
      showAddress: false,
      address: [],
      address2: '',
      viwoList: [{ key: true, value: '是' }, { key: false, value: '否' }],
      eduList: [{ key: 1, value: '设备启动故障' }, { key: 2, value: '设备死机故障' }, { key: 3, value: '设备显示故障' }, {
        key: 4,
        value: '设备识别故障'
      }, { key: 5, value: '设备输入输出故障' }, { key: 6, value: '设备音频故障' }, { key: 7, value: '设备其他故障' }],
      imgUrl: '/static/img/flick.png',
      imgList: {
        version: '1.0',
        content: []
      },
      isProducer: false,
      producerList: []
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    XTextarea: vux_src_components_x_textarea,
    Alert: components_alert["a" /* default */],
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector,
    XButton: vux_src_components_x_button
  },
  methods: {
    faultType: function faultType() {
      var obj = {
        isviwo: this.isviwo,
        sevenday: this.sevenday,
        devseq: this.devseq,
        devname: this.devname,
        devmodel: this.devmodel,
        producer: this.producer,
        buyfrom: this.buyfrom,
        company: this.company,
        name: this.name,
        mobile: this.mobile,
        address: Object(value2name["a" /* default */])(this.address, china_address_v4_default.a),
        address2: this.address2,
        fdetail: this.imgList.content,
        ftype: this.ftype,
        fdesc: this.fdesc
      };
      localStorage.setItem('fault', stringify_default()(obj));
      this.$router.push({ name: 'faultType', params: { repair: 'rapid' } });
    },
    findSrvp: function findSrvp() {
      var _this = this;

      this.$http.get('/api/v1/devices/companies?value=' + this.producer).then(function (response) {
        _this.producerList = response.data;
        if (_this.producerList.length === 1) {
          if (_this.producer !== _this.producerList[0]) {
            _this.isProducer = true;
          }
        } else {
          _this.isProducer = true;
        }
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'warn',
          position: 'top',
          time: '10000'
        });
      });
    },
    chose: function chose(producer) {
      this.producer = producer;
      this.isProducer = false;
    },
    submit: function submit() {
      var _this2 = this;

      this.showLoading = true;
      var address = {
        address1: Object(value2name["a" /* default */])(this.address, china_address_v4_default.a),
        address2: this.address2
      };
      address.address1 = address.address1.split(' ');
      if (this.ftype === '' || this.fdesc === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写故障信息',
          type: 'cancel'
        });
        return;
      }
      if (this.name === '' || this.mobile === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写报修人信息',
          type: 'cancel'
        });
        return;
      }
      if (this.address1 === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写详细地址',
          type: 'cancel'
        });
        return;
      }
      if (this.ftype != '' && this.fdesc != '' && this.name != '' && this.mobile != '' && address.address1 != '' && address.devseq != '' && address.devname != '') {
        var openid = localStorage.getItem("openid");
        var unionid = localStorage.getItem('unionid');
        var nickname = localStorage.getItem('nickname');
        var imgurl = localStorage.getItem('imgurl');
        var obj = {
          openid: openid,
          unionid: unionid,
          otp: 'official',
          nickname: nickname,
          imgurl: imgurl,
          isviwo: this.isviwo,
          devseq: this.devseq,
          devname: this.devname,
          devmodel: this.devmodel,
          producer: this.producer,
          buyfrom: this.buyfrom,
          company: this.company,
          name: this.name,
          mobile: this.mobile,
          ftype: this.ftype,
          fdesc: this.fdesc,
          province: address.address1[0],
          city: address.address1[1],
          district: address.address1[2],
          address: address.address2,
          fdetail: this.imgList
        };
        var that = this;
        this.$http.post("api/v1/fastrepairs", obj).then(function (res) {
          if (res.status == 201) {
            _this2.showLoading = false;
            that.$router.push({ name: 'rapidrepairslist' });
          }
        }).catch(function (error) {
          this.showLoading = false;
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            } else {
              that.$vux.alert.show({
                title: '',
                content: '服务器错误，请稍后重试'
              });
            }
          } else if (error.request) {
            that.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
            console.log(error.request);
          } else {
            that.$vux.alert.show({
              title: '',
              content: '服务器错误，请稍后重试'
            });
            console.log('Error', error.message);
          }
        });
      } else {
        this.showLoading = false;
        this.$vux.alert.show({
          text: '输入信息不完整，请补全后再提交',
          type: 'cancel'
        });
      }
    },

    sys_click: function sys_click() {
      var that = this;
      weixin_js_sdk_default.a.error(function (res) {
        alert(res.errMsg);
      });
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.checkJsApi({
          jsApiList: ['scanQRCode'],
          success: function success(res) {}
        });
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function success(res) {
            var result = res.resultStr;

            var url = result.substring(result.lastIndexOf('?') + 1, result.length);
            var loc = url.substring(url.lastIndexOf('=') + 1, url.length);
            ajax["a" /* default */].$http.get('/api/v1/devices/' + loc + '/wechat?type=USER').then(function (response) {
              if (response.data) {
                that.devname = response.data.extname;
                that.devseq = response.data.sn;
              } else {
                that.$vux.alert.show({
                  title: '',
                  content: '无法识别编码,请确定是否扫描编码?'
                });
              }
            }).catch(function (err) {
              that.$vux.confirm.show({
                title: '',
                content: '非云帷设备,请手动输入设备序列号和设备名称',
                onConfirm: function onConfirm() {
                  that.devname = '';
                  that.devseq = '';
                  that.$refs.content.focus();
                }
              });
            });
          }
        });
      });
    },
    back: function back() {
      this.$router.push({ name: 'rapidrepairslist' });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this3;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {

          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode']
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {

          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'faultType') {
      next(function (vm) {
        if (vm.$route.params.obj) {
          vm.devseq = vm.$route.params.obj.devseq;
          vm.devname = vm.$route.params.obj.devname;
          vm.devmodel = vm.$route.params.obj.devmodel;
          vm.producer = vm.$route.params.obj.producer;
          vm.buyfrom = vm.$route.params.obj.buyfrom;
          vm.company = vm.$route.params.obj.company;
          vm.ftype = vm.$route.params.obj.ftype;
          vm.name = vm.$route.params.obj.name;
          vm.mobile = vm.$route.params.obj.mobile;
          vm.fdesc = vm.$route.params.obj.fdesc;
          vm.address = vm.$route.params.obj.address.split(' ');
          vm.address2 = vm.$route.params.obj.address2;
          vm.isviwo = vm.$route.params.obj.isviwo;
          vm.imgList.content = vm.$route.params.obj.fdetail;
        } else {
          var fault = localStorage.getItem('fault');
          var obj = JSON.parse(fault);
          vm.devseq = obj.devseq;
          vm.devname = obj.devname;
          vm.devmodel = obj.devmodel;
          vm.producer = obj.producer;
          vm.buyfrom = obj.buyfrom;
          vm.company = obj.company;
          vm.ftype = obj.ftype;
          vm.name = obj.name;
          vm.mobile = obj.mobile;
          vm.fdesc = obj.fdesc;
          vm.address = obj.address.split(' ');
          vm.address2 = obj.address2;
          vm.isviwo = obj.isviwo;
          vm.imgList.content = obj.fdetail;
        }
      });
    } else if (from.name == 'sbxx') {
      next(function (vm) {
        vm.devname = vm.$route.params.obj.extname;
        vm.devseq = vm.$route.params.obj.sn;
      });
    } else {
      next();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'faultType') {
      next();
    } else {
      localStorage.removeItem('obj');
      localStorage.removeItem('ftype');
      localStorage.removeItem('subClass1');
      localStorage.removeItem('subClass2');
      localStorage.removeItem('fdesc');
      localStorage.removeItem('fault');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7536d55e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rapidrepairs.vue
var rapidrepairs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"message"},[_vm._v("序列号信息")]),_vm._v(" "),_c('group',[_c('div',{staticStyle:{"padding":"15px"},on:{"click":_vm.sys_click}},[_c('img',{staticStyle:{"width":"15px","height":"15px","padding-right":"4px","cursor":"pointer"},attrs:{"src":_vm.imgUrl}}),_vm._v("点击进行二维码扫描"),_c('br'),_vm._v("\n            注:点击放大镜扫描机器铭牌中的二维码,自动识别机器序列号&型号等信息,方便您进行报修咨询,欢迎使用!\n        ")]),_vm._v(" "),_c('x-input',{attrs:{"title":"序列号*","type":"text","max":40},model:{value:(_vm.devseq),callback:function ($$v) {_vm.devseq=$$v},expression:"devseq"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备名称*","show-counter":false,"max":32,"autosize":""},model:{value:(_vm.devname),callback:function ($$v) {_vm.devname=$$v},expression:"devname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"型号","type":"text","max":32},model:{value:(_vm.devmodel),callback:function ($$v) {_vm.devmodel=$$v},expression:"devmodel"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备生产商","max":32,"autosize":"","show-counter":false},on:{"on-change":_vm.findSrvp},model:{value:(_vm.producer),callback:function ($$v) {_vm.producer=$$v},expression:"producer"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProducer),expression:"isProducer"}],staticClass:"producer-wrap"},_vm._l((_vm.producerList),function(item,index){return _c('p',{key:index,staticClass:"producer-p",on:{"click":function($event){_vm.chose(item)}}},[_vm._v("\n                "+_vm._s(item))])})),_vm._v(" "),_c('selector',{attrs:{"title":"是否云帷设备","placeholder":"是否云帷设备","options":_vm.viwoList},model:{value:(_vm.isviwo),callback:function ($$v) {_vm.isviwo=$$v},expression:"isviwo"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备何处购入","show-counter":false,"max":32,"autosize":""},model:{value:(_vm.buyfrom),callback:function ($$v) {_vm.buyfrom=$$v},expression:"buyfrom"}}),_vm._v(" "),_c('cell',{attrs:{"title":('故障详情*'),"is-link":""},nativeOn:{"click":function($event){return _vm.faultType($event)}}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人姓名*","type":"text","max":8},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人电话*","type":"text","max":16,"is-type":"china-mobile","show-clear":false},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}),_vm._v(" "),_c('x-address',{attrs:{"title":"地址*","raw-value":"","list":_vm.addressData,"value-text-align":"right","placeholder":"请选择省-市-区"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('x-input',{ref:"input2",attrs:{"min":3,"max":32,"type":"text","show-clear":false,"placeholder":"详细地址"},model:{value:(_vm.address2),callback:function ($$v) {_vm.address2=$$v},expression:"address2"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"show-counter":false,"title":"报修人公司","max":32,"autosize":""},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1),_vm._v(" "),_c('div',{staticClass:"btnbox"},[_c('x-button',{staticClass:"btn",attrs:{"show-loading":_vm.showLoading},nativeOn:{"click":function($event){_vm.submit()}}},[_vm._v("提交")]),_vm._v(" "),_c('x-button',{staticClass:"btn",nativeOn:{"click":function($event){_vm.$router.back(-1)}}},[_vm._v("返回")])],1)],1)}
var rapidrepairs_staticRenderFns = []
var rapidrepairs_esExports = { render: rapidrepairs_render, staticRenderFns: rapidrepairs_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_rapidrepairs = (rapidrepairs_esExports);
// CONCATENATED MODULE: ./src/components/rapidrepairs.vue
function rapidrepairs_injectStyle (ssrContext) {
  __webpack_require__("985r")
}
var rapidrepairs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var rapidrepairs___vue_template_functional__ = false
/* styles */
var rapidrepairs___vue_styles__ = rapidrepairs_injectStyle
/* scopeId */
var rapidrepairs___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var rapidrepairs___vue_module_identifier__ = null
var rapidrepairs_Component = rapidrepairs_normalizeComponent(
  components_rapidrepairs,
  selectortype_template_index_0_src_components_rapidrepairs,
  rapidrepairs___vue_template_functional__,
  rapidrepairs___vue_styles__,
  rapidrepairs___vue_scopeId__,
  rapidrepairs___vue_module_identifier__
)

/* harmony default export */ var src_components_rapidrepairs = (rapidrepairs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/rapidrepairslist.vue













/* harmony default export */ var rapidrepairslist = ({
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  name: 'invitation',
  data: function data() {
    return {
      select: '',
      account: '',
      orders_closed: [],
      orders_unclosed: [],
      list: ['未完成', '已完成'],
      index: 0,
      loadmoreone: '加载更多',
      loadmoretwo: '加载更多',
      show: true,
      hide: true,
      isDisabled: false
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      var offset;
      var closed;
      this.isDisabled = true;
      if (this.index === 1) {
        offset = this.orders_closed.length;
        closed = true;
      } else {
        offset = this.orders_unclosed.length;
        closed = false;
      }
      var app = this;
      var openid = localStorage.getItem('openid');

      ajax["a" /* default */].$http.get('/api/v1/fastrepairs?openid=' + openid + '&offset=' + offset + '&count=10&closed=' + closed).then(function (response) {
        app.isDisabled = false;
        if (app.index === 1) {
          app.loadmoretwo = '加载中';
          if (response.data.content.length > 0) {
            app.loadmoretwo = '加载更多';
          } else {
            app.hide = false;
          }
        } else {
          app.loadmoreone = '加载中';
          if (response.data.content.length > 0) {
            app.loadmoreone = '加载更多';
          } else {
            app.show = false;
          }
        }
        var orders = [];
        orders = response.data.content;
        for (var i = 0; i < orders.length; i++) {
          if (app.index === 0) {
            switch (orders[i]['confirm']) {
              case 'YES':
                orders[i]['confirm'] = '已确认';
                break;
              case 'NO':
                orders[i]['confirm'] = '未确认';
                break;
              case 'INVALID':
                orders[i]['confirm'] = '无效';
                break;
              case 'FAIL':
                orders[i]['confirm'] = '处理失败';
                break;
              case 'SUCCESS':
                orders[i]['confirm'] = '处理成功';
                break;
              default:
                break;
            }
          }
          if (app.index === 1) {
            app.orders_closed.push(orders[i]);
          } else {
            app.orders_unclosed.push(orders[i]);
          }
        }
      }).catch(function (error) {
        app.isDisabled = false;
        if (error.response) {
          console.log(error.response.data);
          if (error.response.data) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
      });
    }
  },
  created: function created() {
    var app = this;
    var openid = localStorage.getItem('openid');

    ajax["a" /* default */].$http.get('/api/v1/fastrepairs?openid=' + openid + '&offset=0&count=10&closed=true').then(function (response) {
      app.orders_closed = response.data.content;
      for (var i = 0; i < app.orders_closed.length; i++) {
        switch (app.orders_closed[i]['confirm']) {
          case 'YES':
            app.orders_closed[i]['confirm'] = '已确认';
            break;
          case 'NO':
            app.orders_closed[i]['confirm'] = '未确认';
            break;
          case 'FAIL':
            app.orders_closed[i]['confirm'] = '处理失败';
            break;
          case 'INVALID':
            app.orders_closed[i]['confirm'] = '无效';
            break;
          case 'SUCCESS':
            app.orders_closed[i]['confirm'] = '处理成功';
            break;
          default:
            break;
        }
      }
    }).catch(function (error) {
      if (error.response) {
        if (error.response.data) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });

    ajax["a" /* default */].$http.get('/api/v1/fastrepairs?openid=' + openid + '&offset=0&count=10&closed=false').then(function (response) {
      app.orders_unclosed = response.data.content;

      console.log(app.orders_unclosed);
      for (var i = 0; i < app.orders_unclosed.length; i++) {
        switch (app.orders_unclosed[i]['confirm']) {
          case 'YES':
            app.orders_unclosed[i]['confirm'] = '已确认';
            break;
          case 'NO':
            app.orders_unclosed[i]['confirm'] = '未确认';
            break;
          case 'FAIL':
            app.orders_unclosed[i]['confirm'] = '处理失败';
            break;
          case 'INVALID':
            app.orders_unclosed[i]['confirm'] = '无效';
            break;
          case 'SUCCESS':
            app.orders_unclosed[i]['confirm'] = '处理成功';
            break;
          default:
            break;
        }
      }
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.data) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'quicklycomplete') {
      next();
    } else {
      localStorage.removeItem('order');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/rapidrepairslist.vue













/* harmony default export */ var components_rapidrepairslist = ({
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  name: 'invitation',
  data: function data() {
    return {
      select: '',
      account: '',
      orders_closed: [],
      orders_unclosed: [],
      list: ['未完成', '已完成'],
      index: 0,
      loadmoreone: '加载更多',
      loadmoretwo: '加载更多',
      show: true,
      hide: true,
      isDisabled: false
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      var offset;
      var closed;
      this.isDisabled = true;
      if (this.index === 1) {
        offset = this.orders_closed.length;
        closed = true;
      } else {
        offset = this.orders_unclosed.length;
        closed = false;
      }
      var app = this;
      var openid = localStorage.getItem('openid');

      ajax["a" /* default */].$http.get('/api/v1/fastrepairs?openid=' + openid + '&offset=' + offset + '&count=10&closed=' + closed).then(function (response) {
        app.isDisabled = false;
        if (app.index === 1) {
          app.loadmoretwo = '加载中';
          if (response.data.content.length > 0) {
            app.loadmoretwo = '加载更多';
          } else {
            app.hide = false;
          }
        } else {
          app.loadmoreone = '加载中';
          if (response.data.content.length > 0) {
            app.loadmoreone = '加载更多';
          } else {
            app.show = false;
          }
        }
        var orders = [];
        orders = response.data.content;
        for (var i = 0; i < orders.length; i++) {
          if (app.index === 0) {
            switch (orders[i]['confirm']) {
              case 'YES':
                orders[i]['confirm'] = '已确认';
                break;
              case 'NO':
                orders[i]['confirm'] = '未确认';
                break;
              case 'INVALID':
                orders[i]['confirm'] = '无效';
                break;
              case 'FAIL':
                orders[i]['confirm'] = '处理失败';
                break;
              case 'SUCCESS':
                orders[i]['confirm'] = '处理成功';
                break;
              default:
                break;
            }
          }
          if (app.index === 1) {
            app.orders_closed.push(orders[i]);
          } else {
            app.orders_unclosed.push(orders[i]);
          }
        }
      }).catch(function (error) {
        app.isDisabled = false;
        if (error.response) {
          console.log(error.response.data);
          if (error.response.data) {
            app.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
      });
    }
  },
  created: function created() {
    var app = this;
    var openid = localStorage.getItem('openid');

    ajax["a" /* default */].$http.get('/api/v1/fastrepairs?openid=' + openid + '&offset=0&count=10&closed=true').then(function (response) {
      app.orders_closed = response.data.content;
      for (var i = 0; i < app.orders_closed.length; i++) {
        switch (app.orders_closed[i]['confirm']) {
          case 'YES':
            app.orders_closed[i]['confirm'] = '已确认';
            break;
          case 'NO':
            app.orders_closed[i]['confirm'] = '未确认';
            break;
          case 'FAIL':
            app.orders_closed[i]['confirm'] = '处理失败';
            break;
          case 'INVALID':
            app.orders_closed[i]['confirm'] = '无效';
            break;
          case 'SUCCESS':
            app.orders_closed[i]['confirm'] = '处理成功';
            break;
          default:
            break;
        }
      }
    }).catch(function (error) {
      if (error.response) {
        if (error.response.data) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });

    ajax["a" /* default */].$http.get('/api/v1/fastrepairs?openid=' + openid + '&offset=0&count=10&closed=false').then(function (response) {
      app.orders_unclosed = response.data.content;

      console.log(app.orders_unclosed);
      for (var i = 0; i < app.orders_unclosed.length; i++) {
        switch (app.orders_unclosed[i]['confirm']) {
          case 'YES':
            app.orders_unclosed[i]['confirm'] = '已确认';
            break;
          case 'NO':
            app.orders_unclosed[i]['confirm'] = '未确认';
            break;
          case 'FAIL':
            app.orders_unclosed[i]['confirm'] = '处理失败';
            break;
          case 'INVALID':
            app.orders_unclosed[i]['confirm'] = '无效';
            break;
          case 'SUCCESS':
            app.orders_unclosed[i]['confirm'] = '处理成功';
            break;
          default:
            break;
        }
      }
    }).catch(function (error) {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.data) {
          app.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log('Error', error.message);
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'quicklycomplete') {
      next();
    } else {
      localStorage.removeItem('order');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c27b0f5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rapidrepairslist.vue
var rapidrepairslist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('tab',{attrs:{"line-width":2,"active-color":"#fc378c"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.list),function(item,index){return _c('tab-item',{key:index,staticClass:"vux-center",attrs:{"selected":_vm.select === item},on:{"click":function($event){_vm.select = item}}},[_vm._v(_vm._s(item))])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 1),expression:"index === 1"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.orders_closed),function(order,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'quicksetup', params: { order: order }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.devname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.start))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.confirm))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.end))])])])}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v(_vm._s(_vm.loadmoretwo))])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 0),expression:"index === 0"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.orders_unclosed),function(order,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'quicklycomplete', query: { seq: order['seq'] }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.devname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.start))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v("处理中")])])])}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v(_vm._s(_vm.loadmoreone))])],2)],1)}
var rapidrepairslist_staticRenderFns = []
var rapidrepairslist_esExports = { render: rapidrepairslist_render, staticRenderFns: rapidrepairslist_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_rapidrepairslist = (rapidrepairslist_esExports);
// CONCATENATED MODULE: ./src/components/rapidrepairslist.vue
function rapidrepairslist_injectStyle (ssrContext) {
  __webpack_require__("UzTD")
}
var rapidrepairslist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var rapidrepairslist___vue_template_functional__ = false
/* styles */
var rapidrepairslist___vue_styles__ = rapidrepairslist_injectStyle
/* scopeId */
var rapidrepairslist___vue_scopeId__ = "data-v-7c27b0f5"
/* moduleIdentifier (server only) */
var rapidrepairslist___vue_module_identifier__ = null
var rapidrepairslist_Component = rapidrepairslist_normalizeComponent(
  components_rapidrepairslist,
  selectortype_template_index_0_src_components_rapidrepairslist,
  rapidrepairslist___vue_template_functional__,
  rapidrepairslist___vue_styles__,
  rapidrepairslist___vue_scopeId__,
  rapidrepairslist___vue_module_identifier__
)

/* harmony default export */ var src_components_rapidrepairslist = (rapidrepairslist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/quicksetup.vue









/* harmony default export */ var quicksetup = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */]
  },
  name: 'orderDetail',
  data: function data() {
    return {
      orderDetail: {},
      address: ''
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'rapidrepairslist') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        console.log(vm.orderDetail);
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/quicksetup.vue









/* harmony default export */ var components_quicksetup = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */]
  },
  name: 'orderDetail',
  data: function data() {
    return {
      orderDetail: {},
      address: ''
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'rapidrepairslist') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        console.log(vm.orderDetail);
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7df5bc8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/quicksetup.vue
var quicksetup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"账号","type":"text","readonly":""},model:{value:(_vm.orderDetail.admin.account),callback:function ($$v) {_vm.$set(_vm.orderDetail.admin, "account", $$v)},expression:"orderDetail.admin.account"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"管理员姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.admin.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.admin, "name", $$v)},expression:"orderDetail.admin.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否云帷设备","type":"text","readonly":""},model:{value:(_vm.orderDetail.isviwo),callback:function ($$v) {_vm.$set(_vm.orderDetail, "isviwo", $$v)},expression:"orderDetail.isviwo"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devseq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devseq", $$v)},expression:"orderDetail.devseq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.devname),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devname", $$v)},expression:"orderDetail.devname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备型号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devmodel),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devmodel", $$v)},expression:"orderDetail.devmodel"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备生产商","type":"text","readonly":""},model:{value:(_vm.orderDetail.producer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "producer", $$v)},expression:"orderDetail.producer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备何处购入","type":"text","readonly":""},model:{value:(_vm.orderDetail.buyfrom),callback:function ($$v) {_vm.$set(_vm.orderDetail, "buyfrom", $$v)},expression:"orderDetail.buyfrom"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人公司","type":"text","readonly":""},model:{value:(_vm.orderDetail.company),callback:function ($$v) {_vm.$set(_vm.orderDetail, "company", $$v)},expression:"orderDetail.company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.name),callback:function ($$v) {_vm.$set(_vm.orderDetail, "name", $$v)},expression:"orderDetail.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "mobile", $$v)},expression:"orderDetail.mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请开始时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.start),callback:function ($$v) {_vm.$set(_vm.orderDetail, "start", $$v)},expression:"orderDetail.start"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.ftype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "ftype", $$v)},expression:"orderDetail.ftype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障具体描述","type":"text","readonly":""},model:{value:(_vm.orderDetail.fdesc),callback:function ($$v) {_vm.$set(_vm.orderDetail, "fdesc", $$v)},expression:"orderDetail.fdesc"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请结束时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.end),callback:function ($$v) {_vm.$set(_vm.orderDetail, "end", $$v)},expression:"orderDetail.end"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"地址","type":"text","readonly":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"详细地址","type":"text","readonly":""},model:{value:(_vm.orderDetail.address),callback:function ($$v) {_vm.$set(_vm.orderDetail, "address", $$v)},expression:"orderDetail.address"}})],1)],1)}
var quicksetup_staticRenderFns = []
var quicksetup_esExports = { render: quicksetup_render, staticRenderFns: quicksetup_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_quicksetup = (quicksetup_esExports);
// CONCATENATED MODULE: ./src/components/quicksetup.vue
function quicksetup_injectStyle (ssrContext) {
  __webpack_require__("j0Yn")
}
var quicksetup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var quicksetup___vue_template_functional__ = false
/* styles */
var quicksetup___vue_styles__ = quicksetup_injectStyle
/* scopeId */
var quicksetup___vue_scopeId__ = "data-v-7df5bc8e"
/* moduleIdentifier (server only) */
var quicksetup___vue_module_identifier__ = null
var quicksetup_Component = quicksetup_normalizeComponent(
  components_quicksetup,
  selectortype_template_index_0_src_components_quicksetup,
  quicksetup___vue_template_functional__,
  quicksetup___vue_styles__,
  quicksetup___vue_scopeId__,
  quicksetup___vue_module_identifier__
)

/* harmony default export */ var src_components_quicksetup = (quicksetup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/quicklycomplete.vue








/* harmony default export */ var quicklycomplete = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XTextarea: vux_src_components_x_textarea
  },
  name: 'orderDetail',
  data: function data() {
    return {
      orderDetail: {},
      address: ''
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var obj = {
        headers: {
          opid: 1
        }
      };
      ajax["a" /* default */].$http.get('api/v1/fastrepairs/' + to.query.seq, obj).then(function (response) {
        localStorage.setItem('order', stringify_default()(response.data.detail));
        vm.orderDetail = response.data.detail;
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
      }).catch(function (error) {
        console.log(error);
        vm.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/quicklycomplete.vue








/* harmony default export */ var components_quicklycomplete = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XTextarea: vux_src_components_x_textarea
  },
  name: 'orderDetail',
  data: function data() {
    return {
      orderDetail: {},
      address: ''
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var obj = {
        headers: {
          opid: 1
        }
      };
      ajax["a" /* default */].$http.get('api/v1/fastrepairs/' + to.query.seq, obj).then(function (response) {
        localStorage.setItem('order', stringify_default()(response.data.detail));
        vm.orderDetail = response.data.detail;
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
      }).catch(function (error) {
        console.log(error);
        vm.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-537c3ee7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/quicklycomplete.vue
var quicklycomplete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报修订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否云帷设备","type":"text","readonly":""},model:{value:(_vm.orderDetail.isviwo),callback:function ($$v) {_vm.$set(_vm.orderDetail, "isviwo", $$v)},expression:"orderDetail.isviwo"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devseq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devseq", $$v)},expression:"orderDetail.devseq"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备名称","show-counter":false,"max":32,"autosize":"","readonly":""},model:{value:(_vm.orderDetail.devname),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devname", $$v)},expression:"orderDetail.devname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备型号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devmodel),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devmodel", $$v)},expression:"orderDetail.devmodel"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备生产商","max":32,"autosize":"","show-counter":false,"readonly":""},model:{value:(_vm.orderDetail.producer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "producer", $$v)},expression:"orderDetail.producer"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备何处购入","show-counter":false,"max":32,"autosize":"","readonly":""},model:{value:(_vm.orderDetail.buyfrom),callback:function ($$v) {_vm.$set(_vm.orderDetail, "buyfrom", $$v)},expression:"orderDetail.buyfrom"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"show-counter":false,"title":"报修人公司","max":32,"autosize":"","readonly":""},model:{value:(_vm.orderDetail.company),callback:function ($$v) {_vm.$set(_vm.orderDetail, "company", $$v)},expression:"orderDetail.company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.name),callback:function ($$v) {_vm.$set(_vm.orderDetail, "name", $$v)},expression:"orderDetail.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "mobile", $$v)},expression:"orderDetail.mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请开始时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.start),callback:function ($$v) {_vm.$set(_vm.orderDetail, "start", $$v)},expression:"orderDetail.start"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.ftype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "ftype", $$v)},expression:"orderDetail.ftype"}}),_vm._v(" "),_c('x-textarea',{attrs:{"show-counter":false,"title":"故障具体描述","type":"text","autosize":"","readonly":""},model:{value:(_vm.orderDetail.fdesc),callback:function ($$v) {_vm.$set(_vm.orderDetail, "fdesc", $$v)},expression:"orderDetail.fdesc"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"地址","type":"text","readonly":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"详细地址","type":"text","readonly":""},model:{value:(_vm.orderDetail.address),callback:function ($$v) {_vm.$set(_vm.orderDetail, "address", $$v)},expression:"orderDetail.address"}})],1)],1)}
var quicklycomplete_staticRenderFns = []
var quicklycomplete_esExports = { render: quicklycomplete_render, staticRenderFns: quicklycomplete_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_quicklycomplete = (quicklycomplete_esExports);
// CONCATENATED MODULE: ./src/components/quicklycomplete.vue
function quicklycomplete_injectStyle (ssrContext) {
  __webpack_require__("ClLx")
}
var quicklycomplete_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var quicklycomplete___vue_template_functional__ = false
/* styles */
var quicklycomplete___vue_styles__ = quicklycomplete_injectStyle
/* scopeId */
var quicklycomplete___vue_scopeId__ = "data-v-537c3ee7"
/* moduleIdentifier (server only) */
var quicklycomplete___vue_module_identifier__ = null
var quicklycomplete_Component = quicklycomplete_normalizeComponent(
  components_quicklycomplete,
  selectortype_template_index_0_src_components_quicklycomplete,
  quicklycomplete___vue_template_functional__,
  quicklycomplete___vue_styles__,
  quicklycomplete___vue_scopeId__,
  quicklycomplete___vue_module_identifier__
)

/* harmony default export */ var src_components_quicklycomplete = (quicklycomplete_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/normalrepairs.vue
























/* harmony default export */ var normalrepairs = ({
  data: function data() {
    return {
      num: 6,
      imgRepairList: [],
      router: '',
      buttonText: '发送验证码',
      smsDisabled: false,
      isSend: false,
      code: '',
      fastrepairshow: false,
      reptype: '最终用户报修',
      reptypelist: [{ key: '最终用户报修', value: '最终用户报修' }, { key: '服务商代报修', value: '服务商代报修' }, { key: '其他代报修', value: '其他代报修' }],
      enduser: '',
      endmobile: '',
      lservice: '',
      lsmobile: '',
      save_info: this.$route.params.save_info,
      isviwo: this.$route.params.isviwo ? '是' : '否',
      sevenday: false,
      devseq: "",
      devname: "",
      devmodel: '',
      userInfo: {},
      producer: '',
      buyfrom: "",
      company: '',
      ftype: '使用问题',
      name: '',
      mobile: '',
      fdesc: "",
      showLoading: false,
      imgList: {
        version: '1.1',
        content: []
      },
      size: 0,
      starttime: '',
      endtime: '',
      img1: '/static/img/idcard1.png',
      imgUrl: '/static/img/flick.png',
      photo: { 'path': '', 'serverid': '' },
      account: '',
      username: '',
      sequence: '',

      title: '默认为空',
      value_0_1: [],
      value: [],
      title2: '设置值',
      value2: ['天津市', '市辖区', '和平区'],
      value3: ['广东省', '中山市', '--'],
      addressData: china_address_v4_default.a,
      value4: [],
      value5: ['广东省', '深圳 市', '南山区'],
      showAddress: false,
      address: [],
      address2: '',
      token: '',
      eduList: [{ key: 1, value: '设备启动故障' }, { key: 2, value: '设备死机故障' }, { key: 3, value: '设备显示故障' }, {
        key: 4,
        value: '设备识别故障'
      }, { key: 5, value: '设备输入输出故障' }, { key: 6, value: '设备音频故障' }, { key: 7, value: '设备其他故障' }],
      boolList: [{ key: true, value: '是' }, { key: false, value: '否' }],
      viwoList: [{ key: true, value: '是' }, { key: false, value: '否' }],
      ject: {},
      role: '',
      isid: '',
      isProducer: false,
      producerList: [],
      isFastReapir: true,
      vwarranty: '',
      list1: ['使用问题', '软件问题', '运输问题', '硬件问题', '其他问题'],
      show: true
    };
  },

  components: { XInput: vux_src_components_x_input, Group: group["a" /* default */], XTextarea: vux_src_components_x_textarea, XAddress: vux_src_components_x_address, Card: vux_src_components_card, Alert: components_alert["a" /* default */], Cell: vux_src_components_cell, Selector: vux_src_components_selector, XButton: vux_src_components_x_button, Toast: toast["a" /* default */], Confirm: components_confirm["a" /* default */] },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  methods: {
    isCheck: function isCheck() {
      if (this.address.length === 0) {
        this.$vux.alert.show({
          content: '请填写设备所在地',
          type: 'cancel'
        });
        return;
      }
      var address = {
        address1: Object(value2name["a" /* default */])(this.address, china_address_v4_default.a),
        address2: this.address2
      };
      address.address1 = address.address1.split(' ');
      if (!this.devseq) {
        this.$vux.alert.show({
          content: '请填写序列号',
          type: 'cancel'
        });
        return;
      }
      if (!this.devname) {
        this.$vux.alert.show({
          content: '请填写设备名称',
          type: 'cancel'
        });
        return;
      }
      if (this.ftype === '' || this.fdesc === '') {
        this.$vux.alert.show({
          content: '请填写故障描述信息',
          type: 'cancel'
        });
        return;
      }
      if (this.name === '' || this.mobile === '') {
        this.$vux.alert.show({
          content: '请填写报修人信息',
          type: 'cancel'
        });
        return;
      }
      if (this.company === '') {
        this.$vux.alert.show({
          content: '请填写报修人单位',
          type: 'cancel'
        });
        return;
      }
      this.fastrepairshow = true;
    },
    findInfo: function findInfo() {
      var _this = this;

      this.$http.get('/api/v1/devices/' + this.devseq + '/wechat?type=USER&role=INDV').then(function (response) {
        _this.devname = response.data.extname;
        _this.isviwo = '是';
        if (new Date(response.data['vwarranty']).getTime() < new Date().getTime()) {
          var content = response.data.repaired ? '您报修的设备已超出保修服务约定，请联系您的供应商，或直接购买云帷保修服务，联系方式：18270332937（黄先生）' : '您报修的设备已超出保修约定，请及时联系您的供应商或原厂商核实相关情况，本次业务继续受理，可能需支付检测服务等相关费用，请知晓！';
          _this.$vux.confirm.show({
            content: content,
            cancelText: '继续报修按次付费',

            showConfirmButton: false,
            onConfirm: function onConfirm() {
              that.$vux.alert.show({
                content: '暂不支持该服务'
              });
            }
          });
        }
      }).catch(function (error) {
        _this.isviwo = '否';
        _this.$vux.alert.show({
          content: '您填入的设备序列号不正确或为其他厂家设备，将按三方设备报修流程处理，可能将收取检修费用。(请检查并输入以“FH”或“VW”起始的编号)'
        });
      });
    },
    findSrvp: function findSrvp() {
      var _this2 = this;

      this.$http.get('/api/v1/devices/companies?value=' + this.producer).then(function (response) {
        _this2.producerList = response.data;
        if (_this2.producerList.length === 1) {
          if (_this2.producer !== _this2.producerList[0]) {
            _this2.isProducer = true;
          }
        } else {
          _this2.isProducer = true;
        }
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'warn',
          position: 'top',
          time: '10000'
        });
      });
    },
    cancelAlarm: function cancelAlarm() {
      this.$vux.toast.hide();
    },
    chose: function chose(producer) {
      this.producer = producer;
      this.isProducer = false;
    },
    fileDel: function fileDel(index) {
      this.imgRepairList.splice(index, 1);
      this.imgList.content[0].path.splice(index, 1);
    },
    upload: function upload() {
      var _this3 = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: this.num - this.imgRepairList.length, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          var localIds = res.localIds;
          var i = 0;
          var length = localIds.length;
          var uploadImg = function uploadImg() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {
                _this3.$vux.loading.show({
                  text: 'Loading'
                });
                obj.photo.push(res.serverId);
                i++;
                _this3.num--;
                if (i < length) {
                  uploadImg();
                } else {
                  _this3.submitImage(obj);
                }
                console.log(res);
              },
              fail: function fail(error) {
                console.log(error);
                _this3.$vux.loading.hide();
              }
            });
          };
          uploadImg();
        },
        fail: function fail(error) {
          _this3.$vux.loading.hide();
        }
      });
    },
    submitImage: function submitImage(photo) {
      var _this4 = this;

      this.$http.post('/api/v1/photos/wechat', photo).then(function (res) {
        var _imgList$content$0$pa;

        _this4.imgList.content = [{ path: [] }];
        (_imgList$content$0$pa = _this4.imgList.content[0].path).push.apply(_imgList$content$0$pa, toConsumableArray_default()(res.data));
        if (_this4.imgList.content[0].path.length === 6) {
          _this4.show = false;
        }
        res.data.forEach(function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(item, index) {
            var img;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this4.$http.get('api/v1/photos?path=' + item.origin);

                  case 2:
                    img = _context.sent;

                    _this4.imgRepairList.push({ src: 'data:image/jpeg;base64,' + img.data.value });
                    if (index + 1 === res.data.length) {
                      _this4.$vux.loading.hide();
                    }

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this4);
          }));

          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }());
      }).catch(function (error) {
        _this4.$vux.loading.hide();
        _this4.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    submit: function submit() {
      var _this5 = this;

      if (!this.role) {
        alert('您的身份不支持报修，请添加个人用户');
      }
      if (this.isSend) {
        this.$vux.alert.show({
          content: '订单已提交，请稍后',
          type: 'cancel'
        });
        return;
      }
      this.showLoading = true;
      if (this.address.length === 0) {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写设备所在地',
          type: 'cancel'
        });
        return;
      }
      var address = {
        address1: Object(value2name["a" /* default */])(this.address, china_address_v4_default.a),
        address2: this.address2
      };
      address.address1 = address.address1.split(' ');
      if (this.ftype === '' || this.fdesc === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写故障描述信息',
          type: 'cancel'
        });
        return;
      }
      if (this.name === '' || this.mobile === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写报修人信息',
          type: 'cancel'
        });
        return;
      }
      if (this.company === '') {
        this.$vux.alert.show({
          content: '请填写报修人单位',
          type: 'cancel'
        });
        return;
      }
      if (this.devname !== '' && this.devseq !== '' && this.ftype !== '' && this.fdesc !== '' && this.name !== '' && this.mobile !== '' && address.address1 !== '' && this.company) {
        var that = this;
        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var newobj = {
          headers: {
            token: token,
            opid: opid
          }
        };
        if (this.name === this.save_info.name && this.mobile === this.save_info.mobile) {
          if (!this.save_info.company) {
            this.$http.put('/api/v1/users/' + opid + '/add_company_info', extends_default()({}, this.userInfo, {
              company: this.company
            }), newobj).then(function (response) {});
          }
        }
        var obj = {
          account: opid,
          role: this.role,
          isviwo: this.isviwo === '是',
          sevenday: this.sevenday,
          devseq: this.devseq,
          devname: this.devname,
          devmodel: this.devmodel,
          producer: this.producer,
          buyfrom: this.buyfrom,
          company: this.company,
          name: this.name,
          mobile: this.mobile,
          ftype: this.ftype,
          fdesc: this.fdesc,
          province: address.address1[0],
          city: address.address1[1],
          district: address.address1[2],
          address: address.address2,
          fdetail: this.imgList,
          lsmobile: this.lsmobile,
          lservice: this.lservice,
          enduser: this.enduser,
          endmobile: this.endmobile,
          reptype: this.reptype
        };
        this.isSend = true;
        this.$http.post("api/v1/normalrepairs", obj, newobj).then(function (res) {
          _this5.showLoading = false;
          _this5.isSend = false;
          if (res.status == 201) {
            that.$router.push({ name: 'normalrepairslist' });
          }
        }).catch(function (error) {
          _this5.showLoading = false;
          _this5.isSend = false;
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            } else {
              that.$vux.toast.show({
                text: '服务器错误，请稍后重试',
                type: 'cancel',
                time: '1000'
              });
            }
          } else if (error.request) {
            that.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          } else {
            that.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          }
        });
      } else {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '输入信息不完整，请补全后再提交',
          type: 'cancel'
        });
      }
    },

    sys_click: function sys_click() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.checkJsApi({
          jsApiList: ['scanQRCode'],
          success: function success(res) {}
        });
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function success(res) {
            var result = res.resultStr;

            var url = result.substring(result.lastIndexOf('?') + 1, result.length);
            var loc = url.substring(url.lastIndexOf('=') + 1, url.length);
            ajax["a" /* default */].$http.get('/api/v1/devices/' + loc + '/wechat?type=USER&role=INDV').then(function (response) {
              if (response.data) {
                that.devname = response.data.extname;
                that.devseq = response.data.seq;
                that.repaired = response.data.repaired;
                that.isviwo = '是';
                if (new Date(response.data['vwarranty']).getTime() < new Date().getTime()) {
                  var content = that.repaired ? '您报修的设备已超出保修服务约定，请联系您的供应商，或直接购买云帷保修服务，联系方式：18270332937（黄先生）' : '您报修的设备已超出保修约定，请及时联系您的供应商或原厂商核实相关情况，本次业务继续受理，可能需支付检测服务等相关费用，请知晓！';
                  that.$vux.confirm.show({
                    content: content,
                    cancelText: '继续报修按次付费',

                    showConfirmButton: false,
                    onConfirm: function onConfirm() {
                      that.$vux.alert.show({
                        content: '暂不支持该服务'
                      });
                    }
                  });
                }
              } else {
                that.isviwo = '否';
                that.$vux.alert.show({
                  title: '',
                  content: '无法识别编码,请确定是否扫描编码?'
                });
              }
            }).catch(function (err) {
              that.isviwo = '否';
              that.$vux.confirm.show({
                title: '',
                content: '您填入的设备序列号不正确或为其他厂家设备，将按三方设备报修流程处理，可能将收取检修费用。(请检查并输入以“FH”或“VW”起始的编号)',
                onConfirm: function onConfirm() {
                  that.devname = '';
                  that.devseq = '';
                  that.$refs.content.focus();
                }
              });
            });
          }
        });
      });
    },
    back: function back() {
      this.$router.push({ name: 'normalrepairslist' });
    },
    sendCode: function sendCode() {
      var _this6 = this;

      var obj = {
        nationcode: '86',
        mobile: this.mobile
      };
      if (this.mobile) {
        this.$http.post('/api/v1/accounts/sms', obj).then(function (response) {
          if (response.data.result !== 0) {
            _this6.$vux.alert.show({
              title: '',
              content: response.data.errmsg
            });
          }
        });
        localStorage.setItem('countDown', 60);
        this.timeKeeping();
      }
    },
    timeKeeping: function timeKeeping() {
      var _this7 = this;

      this.smsDisabled = true;
      var interval = setInterval(function () {

        var countDown = parseInt(localStorage.getItem('countDown'));

        _this7.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          localStorage.removeItem('countDown');
          _this7.buttonText = '重新发送';
          _this7.smsDisabled = false;
        } else {
          countDown--;
          localStorage.setItem('countDown', countDown);
        }
      }, 1000);
    },
    onCancel: function onCancel() {
      this.fastrepairshow = false;
    },
    onConfirm: function onConfirm() {
      var _this8 = this;

      if (this.isSend) {
        this.$vux.alert.show({
          content: '订单已提交，请稍后',
          type: 'cancel'
        });
        return;
      }
      var info = {
        code: this.code,
        mobile: this.mobile
      };
      this.isSend = true;
      this.$http.put('/api/v1/accounts/checksms', info).then(function (response) {
        var address = {
          address1: Object(value2name["a" /* default */])(_this8.address, china_address_v4_default.a),
          address2: _this8.address2
        };
        address.address1 = address.address1.split(' ');
        if (_this8.ftype === '' || _this8.fdesc === '') {
          _this8.showLoading = false;
          _this8.$vux.alert.show({
            content: '请填写故障描述信息',
            type: 'cancel'
          });
          return;
        }
        if (_this8.name === '' || _this8.mobile === '') {
          _this8.showLoading = false;
          _this8.$vux.alert.show({
            content: '请填写报修人信息',
            type: 'cancel'
          });
          return;
        }
        if (_this8.address1 === '') {
          _this8.showLoading = false;
          _this8.$vux.alert.show({
            content: '请填写详细设备所在地',
            type: 'cancel'
          });
          return;
        }
        if (_this8.company === '') {
          _this8.$vux.alert.show({
            content: '请填写报修人单位',
            type: 'cancel'
          });
          return;
        }
        if (_this8.devname !== '' && _this8.devseq !== '' && _this8.ftype !== '' && _this8.fdesc !== '' && _this8.name !== '' && _this8.mobile !== '' && address.address1 !== '' && _this8.company) {
          var data = {
            isviwo: _this8.isviwo === '是',
            sevenday: _this8.sevenday,
            devseq: _this8.devseq,
            devname: _this8.devname,
            devmodel: _this8.devmodel,
            producer: _this8.producer,
            buyfrom: _this8.buyfrom,
            company: _this8.company,
            name: _this8.name,
            mobile: _this8.mobile,
            ftype: _this8.ftype,
            fdesc: _this8.fdesc,
            province: address.address1[0],
            city: address.address1[1],
            district: address.address1[2],
            address: address.address2,
            fdetail: _this8.imgList,
            lsmobile: _this8.lsmobile,
            lservice: _this8.lservice,
            enduser: _this8.enduser,
            endmobile: _this8.endmobile,
            reptype: _this8.reptype,
            openid: localStorage.getItem('openid'),
            unionid: localStorage.getItem('unionid'),
            nickname: localStorage.getItem('nickname'),
            imgurl: localStorage.getItem('imgurl'),
            otp: 'official'

          };
          _this8.$http.post('api/v1/normalrepairs/fast_add_repair', data).then(function (response) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userid', response.data.userid);
            _this8.$router.push({ name: 'normalrepairslist' });
            _this8.code = '';
            _this8.isSend = false;
            setTimeout(function () {
              _this8.fastrepairshow = false;
              _this8.showLoading = false;
            }, 1000);
          }).catch(function (error) {
            _this8.showLoading = false;
            _this8.isSend = false;
            _this8.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        } else {
          _this8.isSend = false;
          alert('请填写必填项');
        }
      }).catch(function (error) {
        _this8.showLoading = false;
        _this8.isSend = false;
        alert(JSON.parse(error.response.data.error_message).zh_string);
      });
    },
    getSaveInfo: function getSaveInfo() {
      var _this9 = this;

      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var that = this;
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

        var account = void 0;
        res.data.forEach(function (item) {
          if (item.role === 'INDV') {
            account = item.account;
          }
        });
        if (account) {
          _this9.isFastReapir = false;
          localStorage.setItem('account', account);
          that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            var opid = res.data.userid;
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };

            that.$http.get('api/v1/accounts/' + opid, obj).then(function (response) {
              for (var i = 0; i < response.data.length; i++) {
                if (response.data[i].type === 'INDV' || response.data[i].type === 'ENTP') {
                  that.role = response.data[i].type;
                  break;
                }
                if (response.data[i].type === 'EXPT' || response.data[i].type === 'SRVP') {
                  that.isid = response.data[i].type;
                }
              }
              if (that.role === 'INDV' || that.role === 'ENTP') {
                ajax["a" /* default */].$http.get('/api/v1/users/' + opid, obj).then(function (res) {
                  if (res.data.detail) {
                    that.userInfo = res.data.detail;
                    delete _this9.userInfo.time;
                    delete _this9.userInfo.result;
                    delete _this9.userInfo.advice;
                    that.userInfo.sequence = res.data.sequence;
                    if (!(_this9.mobile || _this9.name)) {
                      that.name = res.data.detail.name;
                      that.mobile = res.data.detail.mobile;
                      that.company = res.data.detail.company;
                    }
                    that.save_info = {
                      company: res.data.detail.company,
                      name: res.data.detail.name,
                      mobile: res.data.detail.mobile
                    };
                    console.log(that.save_info);
                    try {
                      var address = JSON.parse(res.data.detail.address);
                      that.address = address.address1.split(' ');
                      that.address2 = address.address2;
                    } catch (e) {}
                  }
                });
              }
            }).catch(function (error) {
              if (error.response) {
                if (error.response.data) {
                  that.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                }
              }
            });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        } else {
          _this9.isFastReapir = true;
        }
      }).catch(function (error) {
        if (error.response) {
          if (error.response.data) {
            that.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      _this10.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        url = isiOS ? config.host + src_components_global.entryUrl.split('?')[0] : config.host + _this10.$route.path;
        var noncestr = Math.random().toString(36).substr(2);
        _this10.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode']
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    this.getSaveInfo();
    if (this.$route.params.obj) {
      this.devname = this.$route.params.obj.extname.replace('\n', '');
      this.devseq = this.$route.params.obj.seq;
      this.username = this.$route.params.username;
      this.findInfo();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/normalrepairs.vue
























/* harmony default export */ var components_normalrepairs = ({
  data: function data() {
    return {
      num: 6,
      imgRepairList: [],
      router: '',
      buttonText: '发送验证码',
      smsDisabled: false,
      isSend: false,
      code: '',
      fastrepairshow: false,
      reptype: '最终用户报修',
      reptypelist: [{ key: '最终用户报修', value: '最终用户报修' }, { key: '服务商代报修', value: '服务商代报修' }, { key: '其他代报修', value: '其他代报修' }],
      enduser: '',
      endmobile: '',
      lservice: '',
      lsmobile: '',
      save_info: this.$route.params.save_info,
      isviwo: this.$route.params.isviwo ? '是' : '否',
      sevenday: false,
      devseq: "",
      devname: "",
      devmodel: '',
      userInfo: {},
      producer: '',
      buyfrom: "",
      company: '',
      ftype: '使用问题',
      name: '',
      mobile: '',
      fdesc: "",
      showLoading: false,
      imgList: {
        version: '1.1',
        content: []
      },
      size: 0,
      starttime: '',
      endtime: '',
      img1: '/static/img/idcard1.png',
      imgUrl: '/static/img/flick.png',
      photo: { 'path': '', 'serverid': '' },
      account: '',
      username: '',
      sequence: '',

      title: '默认为空',
      value_0_1: [],
      value: [],
      title2: '设置值',
      value2: ['天津市', '市辖区', '和平区'],
      value3: ['广东省', '中山市', '--'],
      addressData: china_address_v4_default.a,
      value4: [],
      value5: ['广东省', '深圳 市', '南山区'],
      showAddress: false,
      address: [],
      address2: '',
      token: '',
      eduList: [{ key: 1, value: '设备启动故障' }, { key: 2, value: '设备死机故障' }, { key: 3, value: '设备显示故障' }, {
        key: 4,
        value: '设备识别故障'
      }, { key: 5, value: '设备输入输出故障' }, { key: 6, value: '设备音频故障' }, { key: 7, value: '设备其他故障' }],
      boolList: [{ key: true, value: '是' }, { key: false, value: '否' }],
      viwoList: [{ key: true, value: '是' }, { key: false, value: '否' }],
      ject: {},
      role: '',
      isid: '',
      isProducer: false,
      producerList: [],
      isFastReapir: true,
      vwarranty: '',
      list1: ['使用问题', '软件问题', '运输问题', '硬件问题', '其他问题'],
      show: true
    };
  },

  components: { XInput: vux_src_components_x_input, Group: group["a" /* default */], XTextarea: vux_src_components_x_textarea, XAddress: vux_src_components_x_address, Card: vux_src_components_card, Alert: components_alert["a" /* default */], Cell: vux_src_components_cell, Selector: vux_src_components_selector, XButton: vux_src_components_x_button, Toast: toast["a" /* default */], Confirm: components_confirm["a" /* default */] },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  methods: {
    isCheck: function isCheck() {
      if (this.address.length === 0) {
        this.$vux.alert.show({
          content: '请填写设备所在地',
          type: 'cancel'
        });
        return;
      }
      var address = {
        address1: Object(value2name["a" /* default */])(this.address, china_address_v4_default.a),
        address2: this.address2
      };
      address.address1 = address.address1.split(' ');
      if (!this.devseq) {
        this.$vux.alert.show({
          content: '请填写序列号',
          type: 'cancel'
        });
        return;
      }
      if (!this.devname) {
        this.$vux.alert.show({
          content: '请填写设备名称',
          type: 'cancel'
        });
        return;
      }
      if (this.ftype === '' || this.fdesc === '') {
        this.$vux.alert.show({
          content: '请填写故障描述信息',
          type: 'cancel'
        });
        return;
      }
      if (this.name === '' || this.mobile === '') {
        this.$vux.alert.show({
          content: '请填写报修人信息',
          type: 'cancel'
        });
        return;
      }
      if (this.company === '') {
        this.$vux.alert.show({
          content: '请填写报修人单位',
          type: 'cancel'
        });
        return;
      }
      this.fastrepairshow = true;
    },
    findInfo: function findInfo() {
      var _this = this;

      this.$http.get('/api/v1/devices/' + this.devseq + '/wechat?type=USER&role=INDV').then(function (response) {
        _this.devname = response.data.extname;
        _this.isviwo = '是';
        if (new Date(response.data['vwarranty']).getTime() < new Date().getTime()) {
          var content = response.data.repaired ? '您报修的设备已超出保修服务约定，请联系您的供应商，或直接购买云帷保修服务，联系方式：18270332937（黄先生）' : '您报修的设备已超出保修约定，请及时联系您的供应商或原厂商核实相关情况，本次业务继续受理，可能需支付检测服务等相关费用，请知晓！';
          _this.$vux.confirm.show({
            content: content,
            cancelText: '继续报修按次付费',

            showConfirmButton: false,
            onConfirm: function onConfirm() {
              that.$vux.alert.show({
                content: '暂不支持该服务'
              });
            }
          });
        }
      }).catch(function (error) {
        _this.isviwo = '否';
        _this.$vux.alert.show({
          content: '您填入的设备序列号不正确或为其他厂家设备，将按三方设备报修流程处理，可能将收取检修费用。(请检查并输入以“FH”或“VW”起始的编号)'
        });
      });
    },
    findSrvp: function findSrvp() {
      var _this2 = this;

      this.$http.get('/api/v1/devices/companies?value=' + this.producer).then(function (response) {
        _this2.producerList = response.data;
        if (_this2.producerList.length === 1) {
          if (_this2.producer !== _this2.producerList[0]) {
            _this2.isProducer = true;
          }
        } else {
          _this2.isProducer = true;
        }
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'warn',
          position: 'top',
          time: '10000'
        });
      });
    },
    cancelAlarm: function cancelAlarm() {
      this.$vux.toast.hide();
    },
    chose: function chose(producer) {
      this.producer = producer;
      this.isProducer = false;
    },
    fileDel: function fileDel(index) {
      this.imgRepairList.splice(index, 1);
      this.imgList.content[0].path.splice(index, 1);
    },
    upload: function upload() {
      var _this3 = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: this.num - this.imgRepairList.length, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          var localIds = res.localIds;
          var i = 0;
          var length = localIds.length;
          var uploadImg = function uploadImg() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {
                _this3.$vux.loading.show({
                  text: 'Loading'
                });
                obj.photo.push(res.serverId);
                i++;
                _this3.num--;
                if (i < length) {
                  uploadImg();
                } else {
                  _this3.submitImage(obj);
                }
                console.log(res);
              },
              fail: function fail(error) {
                console.log(error);
                _this3.$vux.loading.hide();
              }
            });
          };
          uploadImg();
        },
        fail: function fail(error) {
          _this3.$vux.loading.hide();
        }
      });
    },
    submitImage: function submitImage(photo) {
      var _this4 = this;

      this.$http.post('/api/v1/photos/wechat', photo).then(function (res) {
        var _imgList$content$0$pa;

        _this4.imgList.content = [{ path: [] }];
        (_imgList$content$0$pa = _this4.imgList.content[0].path).push.apply(_imgList$content$0$pa, toConsumableArray_default()(res.data));
        if (_this4.imgList.content[0].path.length === 6) {
          _this4.show = false;
        }
        res.data.forEach(function () {
          var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(item, index) {
            var img;
            return regenerator_default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return _this4.$http.get('api/v1/photos?path=' + item.origin);

                  case 2:
                    img = _context.sent;

                    _this4.imgRepairList.push({ src: 'data:image/jpeg;base64,' + img.data.value });
                    if (index + 1 === res.data.length) {
                      _this4.$vux.loading.hide();
                    }

                  case 5:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this4);
          }));

          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }());
      }).catch(function (error) {
        _this4.$vux.loading.hide();
        _this4.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    submit: function submit() {
      var _this5 = this;

      if (!this.role) {
        alert('您的身份不支持报修，请添加个人用户');
      }
      if (this.isSend) {
        this.$vux.alert.show({
          content: '订单已提交，请稍后',
          type: 'cancel'
        });
        return;
      }
      this.showLoading = true;
      if (this.address.length === 0) {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写设备所在地',
          type: 'cancel'
        });
        return;
      }
      var address = {
        address1: Object(value2name["a" /* default */])(this.address, china_address_v4_default.a),
        address2: this.address2
      };
      address.address1 = address.address1.split(' ');
      if (this.ftype === '' || this.fdesc === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写故障描述信息',
          type: 'cancel'
        });
        return;
      }
      if (this.name === '' || this.mobile === '') {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '请填写报修人信息',
          type: 'cancel'
        });
        return;
      }
      if (this.company === '') {
        this.$vux.alert.show({
          content: '请填写报修人单位',
          type: 'cancel'
        });
        return;
      }
      if (this.devname !== '' && this.devseq !== '' && this.ftype !== '' && this.fdesc !== '' && this.name !== '' && this.mobile !== '' && address.address1 !== '' && this.company) {
        var that = this;
        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var newobj = {
          headers: {
            token: token,
            opid: opid
          }
        };
        if (this.name === this.save_info.name && this.mobile === this.save_info.mobile) {
          if (!this.save_info.company) {
            this.$http.put('/api/v1/users/' + opid + '/add_company_info', extends_default()({}, this.userInfo, {
              company: this.company
            }), newobj).then(function (response) {});
          }
        }
        var obj = {
          account: opid,
          role: this.role,
          isviwo: this.isviwo === '是',
          sevenday: this.sevenday,
          devseq: this.devseq,
          devname: this.devname,
          devmodel: this.devmodel,
          producer: this.producer,
          buyfrom: this.buyfrom,
          company: this.company,
          name: this.name,
          mobile: this.mobile,
          ftype: this.ftype,
          fdesc: this.fdesc,
          province: address.address1[0],
          city: address.address1[1],
          district: address.address1[2],
          address: address.address2,
          fdetail: this.imgList,
          lsmobile: this.lsmobile,
          lservice: this.lservice,
          enduser: this.enduser,
          endmobile: this.endmobile,
          reptype: this.reptype
        };
        this.isSend = true;
        this.$http.post("api/v1/normalrepairs", obj, newobj).then(function (res) {
          _this5.showLoading = false;
          _this5.isSend = false;
          if (res.status == 201) {
            that.$router.push({ name: 'normalrepairslist' });
          }
        }).catch(function (error) {
          _this5.showLoading = false;
          _this5.isSend = false;
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            } else {
              that.$vux.toast.show({
                text: '服务器错误，请稍后重试',
                type: 'cancel',
                time: '1000'
              });
            }
          } else if (error.request) {
            that.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          } else {
            that.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          }
        });
      } else {
        this.showLoading = false;
        this.$vux.alert.show({
          content: '输入信息不完整，请补全后再提交',
          type: 'cancel'
        });
      }
    },

    sys_click: function sys_click() {
      var that = this;
      weixin_js_sdk_default.a.ready(function () {
        weixin_js_sdk_default.a.checkJsApi({
          jsApiList: ['scanQRCode'],
          success: function success(res) {}
        });
        weixin_js_sdk_default.a.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function success(res) {
            var result = res.resultStr;

            var url = result.substring(result.lastIndexOf('?') + 1, result.length);
            var loc = url.substring(url.lastIndexOf('=') + 1, url.length);
            ajax["a" /* default */].$http.get('/api/v1/devices/' + loc + '/wechat?type=USER&role=INDV').then(function (response) {
              if (response.data) {
                that.devname = response.data.extname;
                that.devseq = response.data.seq;
                that.repaired = response.data.repaired;
                that.isviwo = '是';
                if (new Date(response.data['vwarranty']).getTime() < new Date().getTime()) {
                  var content = that.repaired ? '您报修的设备已超出保修服务约定，请联系您的供应商，或直接购买云帷保修服务，联系方式：18270332937（黄先生）' : '您报修的设备已超出保修约定，请及时联系您的供应商或原厂商核实相关情况，本次业务继续受理，可能需支付检测服务等相关费用，请知晓！';
                  that.$vux.confirm.show({
                    content: content,
                    cancelText: '继续报修按次付费',

                    showConfirmButton: false,
                    onConfirm: function onConfirm() {
                      that.$vux.alert.show({
                        content: '暂不支持该服务'
                      });
                    }
                  });
                }
              } else {
                that.isviwo = '否';
                that.$vux.alert.show({
                  title: '',
                  content: '无法识别编码,请确定是否扫描编码?'
                });
              }
            }).catch(function (err) {
              that.isviwo = '否';
              that.$vux.confirm.show({
                title: '',
                content: '您填入的设备序列号不正确或为其他厂家设备，将按三方设备报修流程处理，可能将收取检修费用。(请检查并输入以“FH”或“VW”起始的编号)',
                onConfirm: function onConfirm() {
                  that.devname = '';
                  that.devseq = '';
                  that.$refs.content.focus();
                }
              });
            });
          }
        });
      });
    },
    back: function back() {
      this.$router.push({ name: 'normalrepairslist' });
    },
    sendCode: function sendCode() {
      var _this6 = this;

      var obj = {
        nationcode: '86',
        mobile: this.mobile
      };
      if (this.mobile) {
        this.$http.post('/api/v1/accounts/sms', obj).then(function (response) {
          if (response.data.result !== 0) {
            _this6.$vux.alert.show({
              title: '',
              content: response.data.errmsg
            });
          }
        });
        localStorage.setItem('countDown', 60);
        this.timeKeeping();
      }
    },
    timeKeeping: function timeKeeping() {
      var _this7 = this;

      this.smsDisabled = true;
      var interval = setInterval(function () {

        var countDown = parseInt(localStorage.getItem('countDown'));

        _this7.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          localStorage.removeItem('countDown');
          _this7.buttonText = '重新发送';
          _this7.smsDisabled = false;
        } else {
          countDown--;
          localStorage.setItem('countDown', countDown);
        }
      }, 1000);
    },
    onCancel: function onCancel() {
      this.fastrepairshow = false;
    },
    onConfirm: function onConfirm() {
      var _this8 = this;

      if (this.isSend) {
        this.$vux.alert.show({
          content: '订单已提交，请稍后',
          type: 'cancel'
        });
        return;
      }
      var info = {
        code: this.code,
        mobile: this.mobile
      };
      this.isSend = true;
      this.$http.put('/api/v1/accounts/checksms', info).then(function (response) {
        var address = {
          address1: Object(value2name["a" /* default */])(_this8.address, china_address_v4_default.a),
          address2: _this8.address2
        };
        address.address1 = address.address1.split(' ');
        if (_this8.ftype === '' || _this8.fdesc === '') {
          _this8.showLoading = false;
          _this8.$vux.alert.show({
            content: '请填写故障描述信息',
            type: 'cancel'
          });
          return;
        }
        if (_this8.name === '' || _this8.mobile === '') {
          _this8.showLoading = false;
          _this8.$vux.alert.show({
            content: '请填写报修人信息',
            type: 'cancel'
          });
          return;
        }
        if (_this8.address1 === '') {
          _this8.showLoading = false;
          _this8.$vux.alert.show({
            content: '请填写详细设备所在地',
            type: 'cancel'
          });
          return;
        }
        if (_this8.company === '') {
          _this8.$vux.alert.show({
            content: '请填写报修人单位',
            type: 'cancel'
          });
          return;
        }
        if (_this8.devname !== '' && _this8.devseq !== '' && _this8.ftype !== '' && _this8.fdesc !== '' && _this8.name !== '' && _this8.mobile !== '' && address.address1 !== '' && _this8.company) {
          var data = {
            isviwo: _this8.isviwo === '是',
            sevenday: _this8.sevenday,
            devseq: _this8.devseq,
            devname: _this8.devname,
            devmodel: _this8.devmodel,
            producer: _this8.producer,
            buyfrom: _this8.buyfrom,
            company: _this8.company,
            name: _this8.name,
            mobile: _this8.mobile,
            ftype: _this8.ftype,
            fdesc: _this8.fdesc,
            province: address.address1[0],
            city: address.address1[1],
            district: address.address1[2],
            address: address.address2,
            fdetail: _this8.imgList,
            lsmobile: _this8.lsmobile,
            lservice: _this8.lservice,
            enduser: _this8.enduser,
            endmobile: _this8.endmobile,
            reptype: _this8.reptype,
            openid: localStorage.getItem('openid'),
            unionid: localStorage.getItem('unionid'),
            nickname: localStorage.getItem('nickname'),
            imgurl: localStorage.getItem('imgurl'),
            otp: 'official'

          };
          _this8.$http.post('api/v1/normalrepairs/fast_add_repair', data).then(function (response) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userid', response.data.userid);
            _this8.$router.push({ name: 'normalrepairslist' });
            _this8.code = '';
            _this8.isSend = false;
            setTimeout(function () {
              _this8.fastrepairshow = false;
              _this8.showLoading = false;
            }, 1000);
          }).catch(function (error) {
            _this8.showLoading = false;
            _this8.isSend = false;
            _this8.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        } else {
          _this8.isSend = false;
          alert('请填写必填项');
        }
      }).catch(function (error) {
        _this8.showLoading = false;
        _this8.isSend = false;
        alert(JSON.parse(error.response.data.error_message).zh_string);
      });
    },
    getSaveInfo: function getSaveInfo() {
      var _this9 = this;

      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var that = this;
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

        var account = void 0;
        res.data.forEach(function (item) {
          if (item.role === 'INDV') {
            account = item.account;
          }
        });
        if (account) {
          _this9.isFastReapir = false;
          localStorage.setItem('account', account);
          that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            var opid = res.data.userid;
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };

            that.$http.get('api/v1/accounts/' + opid, obj).then(function (response) {
              for (var i = 0; i < response.data.length; i++) {
                if (response.data[i].type === 'INDV' || response.data[i].type === 'ENTP') {
                  that.role = response.data[i].type;
                  break;
                }
                if (response.data[i].type === 'EXPT' || response.data[i].type === 'SRVP') {
                  that.isid = response.data[i].type;
                }
              }
              if (that.role === 'INDV' || that.role === 'ENTP') {
                ajax["a" /* default */].$http.get('/api/v1/users/' + opid, obj).then(function (res) {
                  if (res.data.detail) {
                    that.userInfo = res.data.detail;
                    delete _this9.userInfo.time;
                    delete _this9.userInfo.result;
                    delete _this9.userInfo.advice;
                    that.userInfo.sequence = res.data.sequence;
                    if (!(_this9.mobile || _this9.name)) {
                      that.name = res.data.detail.name;
                      that.mobile = res.data.detail.mobile;
                      that.company = res.data.detail.company;
                    }
                    that.save_info = {
                      company: res.data.detail.company,
                      name: res.data.detail.name,
                      mobile: res.data.detail.mobile
                    };
                    console.log(that.save_info);
                    try {
                      var address = JSON.parse(res.data.detail.address);
                      that.address = address.address1.split(' ');
                      that.address2 = address.address2;
                    } catch (e) {}
                  }
                });
              }
            }).catch(function (error) {
              if (error.response) {
                if (error.response.data) {
                  that.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                }
              }
            });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        } else {
          _this9.isFastReapir = true;
        }
      }).catch(function (error) {
        if (error.response) {
          if (error.response.data) {
            that.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      _this10.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        url = isiOS ? config.host + src_components_global.entryUrl.split('?')[0] : config.host + _this10.$route.path;
        var noncestr = Math.random().toString(36).substr(2);
        _this10.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode']
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    this.getSaveInfo();
    if (this.$route.params.obj) {
      this.devname = this.$route.params.obj.extname.replace('\n', '');
      this.devseq = this.$route.params.obj.seq;
      this.username = this.$route.params.username;
      this.findInfo();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de453cd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/normalrepairs.vue
var normalrepairs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.cancelAlarm}},[_c('div',{staticClass:"message"},[_vm._v("序列号信息")]),_vm._v(" "),_c('group',[_c('div',{staticStyle:{"padding":"15px","cursor":"pointer"},on:{"click":_vm.sys_click}},[_c('x-button',{staticStyle:{"width":"15px","height":"15px","background":"rgba(0,0,0,0)","position":"relative","display":"inline","margin-right":"-10px","border-radius":"0"}},[_c('img',{staticStyle:{"width":"15px","height":"15px","position":"absolute","left":"0","top":"0"},attrs:{"src":_vm.imgUrl}})]),_vm._v("\n        点击进行二维码扫描"),_c('br'),_vm._v("\n        注:点击放大镜扫描机器铭牌中的二维码,自动识别机器序列号&型号等信息,方便您进行报修咨询,欢迎使用!\n      ")],1),_vm._v(" "),_c('x-input',{ref:"content",attrs:{"title":"序列号*","type":"text","max":40,"auto-scroll-to-top":""},on:{"on-blur":_vm.findInfo},model:{value:(_vm.devseq),callback:function ($$v) {_vm.devseq=$$v},expression:"devseq"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备名称*","show-counter":false,"max":32,"autosize":"","auto-scroll-to-top":""},model:{value:(_vm.devname),callback:function ($$v) {_vm.devname=$$v},expression:"devname"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备生产商","max":32,"autosize":"","auto-scroll-to-top":"","show-counter":false},on:{"on-change":_vm.findSrvp},model:{value:(_vm.producer),callback:function ($$v) {_vm.producer=$$v},expression:"producer"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProducer),expression:"isProducer"}],staticClass:"producer-wrap"},_vm._l((_vm.producerList),function(item,index){return _c('p',{key:index,staticClass:"producer-p",on:{"click":function($event){_vm.chose(item)}}},[_vm._v("\n          "+_vm._s(item))])})),_vm._v(" "),_c('x-input',{attrs:{"title":"是否云帷设备","disabled":""},model:{value:(_vm.isviwo),callback:function ($$v) {_vm.isviwo=$$v},expression:"isviwo"}}),_vm._v(" "),_c('selector',{attrs:{"title":"是否1次开箱","placeholder":"是否1次开箱","options":_vm.boolList},model:{value:(_vm.sevenday),callback:function ($$v) {_vm.sevenday=$$v},expression:"sevenday"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备何处购入","show-counter":false,"max":32,"autosize":""},model:{value:(_vm.buyfrom),callback:function ($$v) {_vm.buyfrom=$$v},expression:"buyfrom"}}),_vm._v(" "),_c('x-address',{attrs:{"title":"设备所在地*","raw-value":"","list":_vm.addressData,"value-text-align":"right","placeholder":"请选择省-市-区"},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('x-input',{ref:"input2",attrs:{"min":3,"max":32,"type":"text","placeholder":"详细地址"},model:{value:(_vm.address2),callback:function ($$v) {_vm.address2=$$v},expression:"address2"}}),_vm._v(" "),_c('selector',{attrs:{"title":"故障类型*","options":_vm.list1},model:{value:(_vm.ftype),callback:function ($$v) {_vm.ftype=$$v},expression:"ftype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障描述*","max":256},model:{value:(_vm.fdesc),callback:function ($$v) {_vm.fdesc=$$v},expression:"fdesc"}}),_vm._v(" "),_c('div',{staticClass:"weui-cell"},[_c('label',{staticStyle:{"color":"grey"}},[_vm._v("故障照片")]),_vm._v(" "),_c('div',{staticClass:"upload_warp_img"},[_vm._l((_vm.imgRepairList),function(val,index){return _c('div',{key:index,staticClass:"upload_warp_img_div"},[_c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"src":val.src}})]),_vm._v(" "),_c('div',{staticClass:"upload_warp_img_div_top"},[_c('span',{staticClass:"upload_warp_img_div_del",on:{"click":function($event){_vm.fileDel(index)}}},[_vm._v("×")])])])}),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"upload_warp"},[_c('div',{staticClass:"upload_warp_left",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.upload()}}},[_c('div',{staticClass:"icon-add-50"})])]):_vm._e()],2)]),_vm._v(" "),_c('selector',{attrs:{"title":"报修类型","options":_vm.reptypelist},model:{value:(_vm.reptype),callback:function ($$v) {_vm.reptype=$$v},expression:"reptype"}}),_vm._v(" "),(_vm.reptype === '最终用户报修')?[_c('x-input',{attrs:{"title":"本地服务商","auto-scroll-to-top":""},model:{value:(_vm.lservice),callback:function ($$v) {_vm.lservice=$$v},expression:"lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","is-type":"china-mobile","auto-scroll-to-top":""},model:{value:(_vm.lsmobile),callback:function ($$v) {_vm.lsmobile=$$v},expression:"lsmobile"}})]:_vm._e(),_vm._v(" "),(_vm.reptype === '服务商代报修')?[_c('x-input',{attrs:{"title":"最终用户","auto-scroll-to-top":""},model:{value:(_vm.enduser),callback:function ($$v) {_vm.enduser=$$v},expression:"enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","is-type":"china-mobile","auto-scroll-to-top":""},model:{value:(_vm.endmobile),callback:function ($$v) {_vm.endmobile=$$v},expression:"endmobile"}})]:_vm._e(),_vm._v(" "),(_vm.reptype === '其他代报修')?[_c('x-input',{attrs:{"title":"最终用户","auto-scroll-to-top":""},model:{value:(_vm.enduser),callback:function ($$v) {_vm.enduser=$$v},expression:"enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","is-type":"china-mobile","auto-scroll-to-top":""},model:{value:(_vm.endmobile),callback:function ($$v) {_vm.endmobile=$$v},expression:"endmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商","auto-scroll-to-top":""},model:{value:(_vm.lservice),callback:function ($$v) {_vm.lservice=$$v},expression:"lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","is-type":"china-mobile","auto-scroll-to-top":""},model:{value:(_vm.lsmobile),callback:function ($$v) {_vm.lsmobile=$$v},expression:"lsmobile"}})]:_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人姓名*","type":"text","max":8,"auto-scroll-to-top":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人电话*","type":"text","max":16,"is-type":"china-mobile","auto-scroll-to-top":""},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"show-counter":false,"title":"报修人公司*","max":32,"auto-scroll-to-top":"","autosize":""},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],2),_vm._v(" "),_c('div',{staticClass:"btnbox"},[(!_vm.isFastReapir)?_c('x-button',{staticClass:"btn",attrs:{"show-loading":_vm.showLoading,"disabled":_vm.showLoading},nativeOn:{"click":function($event){_vm.submit()}}},[_vm._v("提交\n      ")]):_vm._e(),_vm._v(" "),(_vm.isFastReapir)?_c('x-button',{staticClass:"btn",attrs:{"show-loading":_vm.showLoading,"disabled":_vm.showLoading},nativeOn:{"click":function($event){_vm.isCheck()}}},[_vm._v("提交\n      ")]):_vm._e(),_vm._v(" "),_c('x-button',{staticClass:"btn",nativeOn:{"click":function($event){_vm.back()}}},[_vm._v("返回")])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{attrs:{"theme":"android","title":"提示信息","close-on-confirm":false},on:{"on-cancel":function($event){_vm.fastrepairshow = false},"on-confirm":_vm.onConfirm},model:{value:(_vm.fastrepairshow),callback:function ($$v) {_vm.fastrepairshow=$$v},expression:"fastrepairshow"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("您不是好云帷注册用户，为保证报修响应的时效，需用报修联系人手机号进行验证")]),_vm._v(" "),_c('group',[_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"验证码"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}},[_c('x-button',{attrs:{"slot":"right","type":"primary","mini":"","text":_vm.buttonText,"disabled":_vm.smsDisabled},nativeOn:{"click":function($event){return _vm.sendCode($event)}},slot:"right"})],1)],1)],1)],1)],1)}
var normalrepairs_staticRenderFns = []
var normalrepairs_esExports = { render: normalrepairs_render, staticRenderFns: normalrepairs_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_normalrepairs = (normalrepairs_esExports);
// CONCATENATED MODULE: ./src/components/normalrepairs.vue
function normalrepairs_injectStyle (ssrContext) {
  __webpack_require__("gXUh")
}
var normalrepairs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var normalrepairs___vue_template_functional__ = false
/* styles */
var normalrepairs___vue_styles__ = normalrepairs_injectStyle
/* scopeId */
var normalrepairs___vue_scopeId__ = "data-v-de453cd0"
/* moduleIdentifier (server only) */
var normalrepairs___vue_module_identifier__ = null
var normalrepairs_Component = normalrepairs_normalizeComponent(
  components_normalrepairs,
  selectortype_template_index_0_src_components_normalrepairs,
  normalrepairs___vue_template_functional__,
  normalrepairs___vue_styles__,
  normalrepairs___vue_scopeId__,
  normalrepairs___vue_module_identifier__
)

/* harmony default export */ var src_components_normalrepairs = (normalrepairs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/normalrepairslist.vue














/* harmony default export */ var normalrepairslist = ({
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  name: 'invitation',
  data: function data() {
    return {
      select: '',
      account: '',
      orders_closed: [],
      orders_unclosed: [],
      payList: [],
      list: ['待付费', '未完成', '已完成'],
      arr: [0, 0, 0],
      index: 1,
      role: '',
      loadmoreone: '加载更多',
      loadmoretwo: '加载更多',
      show: false,
      hide: false,
      isDisabled: false,
      isid: '',
      isPage: false
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      var _this = this;

      var offset;
      var closed;
      var username = void 0,
          role = void 0;

      this.isDisabled = true;
      if (this.index === 1) {
        offset = this.orders_unclosed.length;
        closed = false;
      } else if (this.index === 0) {
        offset = this.payList.length;
      } else {
        offset = this.orders_closed.length;
        closed = true;
      }
      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var obj = {
        headers: {
          token: token,
          opid: opid
        }
      };

      ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, obj).then(function (res) {
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].type === 'INDV') {
            role = 'INDV';
          } else if (res.data[i].type === 'ENTP') {
            role = 'ENTP';
          }
        }

        if (_this.select === '待付费') {
          _this.$http.get('/api/v1/payments/' + opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=' + offset + '&count=10', obj).then(function (response) {
            _this.payList = [].concat(toConsumableArray_default()(_this.payList), toConsumableArray_default()(response.data.content));
            _this.isPage = response.data.total !== _this.payList;
          });
        } else {
          ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + role + '&offset=' + offset + '&count=10&closed=' + closed, obj).then(function (response) {
            app.isDisabled = false;
            if (app.index === 1) {
              app.loadmoretwo = '加载中';
              if (response.data.content.length === 10) {
                app.loadmoretwo = '加载更多';
              } else {
                app.show = false;
              }
            } else {
              app.loadmoreone = '加载中';
              if (response.data.content.length === 10) {
                app.loadmoreone = '加载更多';
              } else {
                app.hide = false;
              }
            }
            var orders = [];
            orders = response.data.content;
            for (var i = 0; i < orders.length; i++) {
              if (app.index === 1) {
                switch (orders[i]['state']) {
                  case 'WAIT':
                    orders[i]['state'] = '待派单';
                    break;
                  case 'PROCESS':
                    orders[i]['state'] = '处理中';
                    break;
                  case 'FAIL':
                    orders[i]['state'] = '处理失败';
                    break;
                  case 'SUCCESS':
                    orders[i]['state'] = '处理成功';
                    break;
                  default:
                    break;
                }
                switch (orders[i]['canstate']) {
                  case 'REQUEST':
                    orders[i]['state'] = '取消待确认';
                    break;
                }
                if (orders[i]['resstate'] === 'WAIT') {
                  orders[i]['state'] = '待接单';
                }
              }
              if (app.index === 2) {
                switch (orders[i]['state']) {
                  case 'WAIT':
                    orders[i]['state'] = '待派单';
                    break;
                  case 'PROCESS':
                    orders[i]['state'] = '处理中';
                    break;
                  case 'FAIL':
                    orders[i]['state'] = '处理失败';
                    break;
                  case 'SUCCESS':
                    orders[i]['state'] = '处理成功';
                    break;
                  default:
                    break;
                }
                if (orders[i]['resstate'] === 'WAIT') {
                  orders[i]['state'] = '待接单';
                }
              }
              if (app.index === 1) {
                app.orders_unclosed.push(orders[i]);
              } else {
                app.orders_closed.push(orders[i]);
              }
            }
          }).catch(function (error) {
            app.isDisabled = false;
            if (error.response) {
              console.log(error.response.data);
              if (error.response.data) {
                app.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log('Error', error.message);
            }
          });
        }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    var that = this;
    var app = this;
    var role;
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      if (res.data.length !== 0) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };

          that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {

              if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                role = response.data[i].type;
                break;
              }
              if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                that.isid = response.data[i].type;
              }
            }

            if (role == 'INDV' || role == 'ENTP') {

              ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + role + '&offset=0&count=10&closed=true', obj).then(function (response) {
                app.orders_closed = response.data.content;
                app.arr[2] = response.data.total;
                if (response.data.total > 10) {
                  app.hide = true;
                }
                for (var i = 0; i < app.orders_closed.length; i++) {
                  switch (app.orders_closed[i]['state']) {
                    case 'WAIT':
                      app.orders_closed[i]['state'] = '待派单';
                      break;
                    case 'PROCESS':
                      app.orders_closed[i]['state'] = '处理中';
                      break;
                    case 'FAIL':
                      app.orders_closed[i]['state'] = '处理失败';
                      break;
                    case 'SUCCESS':
                      app.orders_closed[i]['state'] = '处理成功';
                      break;
                    default:
                      break;
                  }
                  if (app.orders_closed[i]['resstate'] === 'WAIT') {
                    app.orders_closed[i]['state'] = '待接单';
                  }
                }
              });

              ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + role + '&offset=0&count=10&closed=false', obj).then(function (response) {
                app.orders_unclosed = response.data.content;
                app.arr[1] = response.data.total;
                if (response.data.total > 10) {
                  app.show = true;
                }
                for (var i = 0; i < app.orders_unclosed.length; i++) {
                  switch (app.orders_unclosed[i]['state']) {
                    case 'WAIT':
                      app.orders_unclosed[i]['state'] = '待派单';
                      break;
                    case 'PROCESS':
                      app.orders_unclosed[i]['state'] = '处理中';
                      break;
                    case 'FAIL':
                      app.orders_unclosed[i]['state'] = '处理失败';
                      break;
                    case 'SUCCESS':
                      app.orders_unclosed[i]['state'] = '处理成功';
                      break;
                    default:
                      break;
                  }
                  if (app.orders_unclosed[i]['resstate'] === 'WAIT') {
                    app.orders_unclosed[i]['state'] = '待接单';
                  }
                  switch (app.orders_unclosed[i]['canstate']) {
                    case 'REQUEST':
                      app.orders_unclosed[i]['state'] = '取消待确认';
                      break;
                  }
                }
              });
              ajax["a" /* default */].$http.get('/api/v1/payments/' + opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=0&count=10', obj).then(function (response) {
                _this2.payList = response.data.content;
                app.arr[0] = response.data.total;
                if (response.data.total > 10) {
                  _this2.isPage = true;
                }
              });
            } else {
              var iden;
              if (that.isid == 'EXPT') {
                iden = '个人用户';
              }
              if (that.isid == 'SRVP') {
                iden = '企业用户';
              }
              that.$vux.confirm.show({
                title: '',
                content: '您的身份不符合该功能,如需用该功能,请添加' + iden,
                onConfirm: function onConfirm() {
                  that.$router.push({ name: 'addmyInfo' });
                },
                onCancel: function onCancel() {
                  WeixinJSBridge.call('closeWindow');
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      } else {
        localStorage.setItem('repair', 'normalrepairslist');
        that.$router.push({ name: 'login' });
      }
    }).catch(function (error) {
      console.log(error.response);
      if (error.response) {
        if (error.response.data) {
          that.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'normalcomplete') {
      next();
    } else {
      localStorage.removeItem('order');
    }
    localStorage.removeItem('list');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/normalrepairslist.vue














/* harmony default export */ var components_normalrepairslist = ({
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  name: 'invitation',
  data: function data() {
    return {
      select: '',
      account: '',
      orders_closed: [],
      orders_unclosed: [],
      payList: [],
      list: ['待付费', '未完成', '已完成'],
      arr: [0, 0, 0],
      index: 1,
      role: '',
      loadmoreone: '加载更多',
      loadmoretwo: '加载更多',
      show: false,
      hide: false,
      isDisabled: false,
      isid: '',
      isPage: false
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      var _this = this;

      var offset;
      var closed;
      var username = void 0,
          role = void 0;

      this.isDisabled = true;
      if (this.index === 1) {
        offset = this.orders_unclosed.length;
        closed = false;
      } else if (this.index === 0) {
        offset = this.payList.length;
      } else {
        offset = this.orders_closed.length;
        closed = true;
      }
      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var obj = {
        headers: {
          token: token,
          opid: opid
        }
      };

      ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, obj).then(function (res) {
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].type === 'INDV') {
            role = 'INDV';
          } else if (res.data[i].type === 'ENTP') {
            role = 'ENTP';
          }
        }

        if (_this.select === '待付费') {
          _this.$http.get('/api/v1/payments/' + opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=' + offset + '&count=10', obj).then(function (response) {
            _this.payList = [].concat(toConsumableArray_default()(_this.payList), toConsumableArray_default()(response.data.content));
            _this.isPage = response.data.total !== _this.payList;
          });
        } else {
          ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + role + '&offset=' + offset + '&count=10&closed=' + closed, obj).then(function (response) {
            app.isDisabled = false;
            if (app.index === 1) {
              app.loadmoretwo = '加载中';
              if (response.data.content.length === 10) {
                app.loadmoretwo = '加载更多';
              } else {
                app.show = false;
              }
            } else {
              app.loadmoreone = '加载中';
              if (response.data.content.length === 10) {
                app.loadmoreone = '加载更多';
              } else {
                app.hide = false;
              }
            }
            var orders = [];
            orders = response.data.content;
            for (var i = 0; i < orders.length; i++) {
              if (app.index === 1) {
                switch (orders[i]['state']) {
                  case 'WAIT':
                    orders[i]['state'] = '待派单';
                    break;
                  case 'PROCESS':
                    orders[i]['state'] = '处理中';
                    break;
                  case 'FAIL':
                    orders[i]['state'] = '处理失败';
                    break;
                  case 'SUCCESS':
                    orders[i]['state'] = '处理成功';
                    break;
                  default:
                    break;
                }
                switch (orders[i]['canstate']) {
                  case 'REQUEST':
                    orders[i]['state'] = '取消待确认';
                    break;
                }
                if (orders[i]['resstate'] === 'WAIT') {
                  orders[i]['state'] = '待接单';
                }
              }
              if (app.index === 2) {
                switch (orders[i]['state']) {
                  case 'WAIT':
                    orders[i]['state'] = '待派单';
                    break;
                  case 'PROCESS':
                    orders[i]['state'] = '处理中';
                    break;
                  case 'FAIL':
                    orders[i]['state'] = '处理失败';
                    break;
                  case 'SUCCESS':
                    orders[i]['state'] = '处理成功';
                    break;
                  default:
                    break;
                }
                if (orders[i]['resstate'] === 'WAIT') {
                  orders[i]['state'] = '待接单';
                }
              }
              if (app.index === 1) {
                app.orders_unclosed.push(orders[i]);
              } else {
                app.orders_closed.push(orders[i]);
              }
            }
          }).catch(function (error) {
            app.isDisabled = false;
            if (error.response) {
              console.log(error.response.data);
              if (error.response.data) {
                app.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log('Error', error.message);
            }
          });
        }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    var that = this;
    var app = this;
    var role;
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      if (res.data.length !== 0) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };

          that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {

              if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                role = response.data[i].type;
                break;
              }
              if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                that.isid = response.data[i].type;
              }
            }

            if (role == 'INDV' || role == 'ENTP') {

              ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + role + '&offset=0&count=10&closed=true', obj).then(function (response) {
                app.orders_closed = response.data.content;
                app.arr[2] = response.data.total;
                if (response.data.total > 10) {
                  app.hide = true;
                }
                for (var i = 0; i < app.orders_closed.length; i++) {
                  switch (app.orders_closed[i]['state']) {
                    case 'WAIT':
                      app.orders_closed[i]['state'] = '待派单';
                      break;
                    case 'PROCESS':
                      app.orders_closed[i]['state'] = '处理中';
                      break;
                    case 'FAIL':
                      app.orders_closed[i]['state'] = '处理失败';
                      break;
                    case 'SUCCESS':
                      app.orders_closed[i]['state'] = '处理成功';
                      break;
                    default:
                      break;
                  }
                  if (app.orders_closed[i]['resstate'] === 'WAIT') {
                    app.orders_closed[i]['state'] = '待接单';
                  }
                }
              });

              ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + role + '&offset=0&count=10&closed=false', obj).then(function (response) {
                app.orders_unclosed = response.data.content;
                app.arr[1] = response.data.total;
                if (response.data.total > 10) {
                  app.show = true;
                }
                for (var i = 0; i < app.orders_unclosed.length; i++) {
                  switch (app.orders_unclosed[i]['state']) {
                    case 'WAIT':
                      app.orders_unclosed[i]['state'] = '待派单';
                      break;
                    case 'PROCESS':
                      app.orders_unclosed[i]['state'] = '处理中';
                      break;
                    case 'FAIL':
                      app.orders_unclosed[i]['state'] = '处理失败';
                      break;
                    case 'SUCCESS':
                      app.orders_unclosed[i]['state'] = '处理成功';
                      break;
                    default:
                      break;
                  }
                  if (app.orders_unclosed[i]['resstate'] === 'WAIT') {
                    app.orders_unclosed[i]['state'] = '待接单';
                  }
                  switch (app.orders_unclosed[i]['canstate']) {
                    case 'REQUEST':
                      app.orders_unclosed[i]['state'] = '取消待确认';
                      break;
                  }
                }
              });
              ajax["a" /* default */].$http.get('/api/v1/payments/' + opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=0&count=10', obj).then(function (response) {
                _this2.payList = response.data.content;
                app.arr[0] = response.data.total;
                if (response.data.total > 10) {
                  _this2.isPage = true;
                }
              });
            } else {
              var iden;
              if (that.isid == 'EXPT') {
                iden = '个人用户';
              }
              if (that.isid == 'SRVP') {
                iden = '企业用户';
              }
              that.$vux.confirm.show({
                title: '',
                content: '您的身份不符合该功能,如需用该功能,请添加' + iden,
                onConfirm: function onConfirm() {
                  that.$router.push({ name: 'addmyInfo' });
                },
                onCancel: function onCancel() {
                  WeixinJSBridge.call('closeWindow');
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      } else {
        localStorage.setItem('repair', 'normalrepairslist');
        that.$router.push({ name: 'login' });
      }
    }).catch(function (error) {
      console.log(error.response);
      if (error.response) {
        if (error.response.data) {
          that.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'normalcomplete') {
      next();
    } else {
      localStorage.removeItem('order');
    }
    localStorage.removeItem('list');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2217e2e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/normalrepairslist.vue
var normalrepairslist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('tab',{attrs:{"line-width":2,"active-color":"#fc378c"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.list),function(item,index){return _c('tab-item',{key:index,staticClass:"vux-center",attrs:{"selected":_vm.select === item},on:{"click":function($event){_vm.select = item}}},[_vm._v(_vm._s(item)),_c('span',{staticClass:"title_total"},[_vm._v("("+_vm._s(_vm.arr[index])+")")])])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 0),expression:"index === 0"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.payList),function(item,index){return _c('cell',{key:index,attrs:{"is-link":"","title":item.seq,"link":{ name: 'Payinfo',query:{seq:item.seq,role:'INDV'}}}})}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPage),expression:"isPage"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v("\n      "+_vm._s(_vm.loadmoretwo)+"\n    ")])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 2),expression:"index === 2"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.orders_closed),function(order,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'normalcomplete',query: { seq: order['seq'] }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.devname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.start))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.state))])])])}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v("\n      "+_vm._s(_vm.loadmoretwo)+"\n    ")])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 1),expression:"index === 1"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.orders_unclosed),function(order,index){return _c('cell',{key:index,attrs:{"value":order.state,"is-link":"","link":{ name: 'normalcomplete', query: { seq: order['seq'] }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.devname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.start))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.state))])])])}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v("\n      "+_vm._s(_vm.loadmoreone)+"\n    ")])],2)],1)}
var normalrepairslist_staticRenderFns = []
var normalrepairslist_esExports = { render: normalrepairslist_render, staticRenderFns: normalrepairslist_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_normalrepairslist = (normalrepairslist_esExports);
// CONCATENATED MODULE: ./src/components/normalrepairslist.vue
function normalrepairslist_injectStyle (ssrContext) {
  __webpack_require__("7ZcN")
}
var normalrepairslist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var normalrepairslist___vue_template_functional__ = false
/* styles */
var normalrepairslist___vue_styles__ = normalrepairslist_injectStyle
/* scopeId */
var normalrepairslist___vue_scopeId__ = "data-v-2217e2e4"
/* moduleIdentifier (server only) */
var normalrepairslist___vue_module_identifier__ = null
var normalrepairslist_Component = normalrepairslist_normalizeComponent(
  components_normalrepairslist,
  selectortype_template_index_0_src_components_normalrepairslist,
  normalrepairslist___vue_template_functional__,
  normalrepairslist___vue_styles__,
  normalrepairslist___vue_scopeId__,
  normalrepairslist___vue_module_identifier__
)

/* harmony default export */ var src_components_normalrepairslist = (normalrepairslist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/normalcomplete.vue














/* harmony default export */ var normalcomplete = ({
  components: { XHeader: vux_src_components_x_header, XInput: vux_src_components_x_input, Group: group["a" /* default */], XButton: vux_src_components_x_button, Cell: vux_src_components_cell, XTextarea: vux_src_components_x_textarea, Confirm: components_confirm["a" /* default */], Selector: vux_src_components_selector, Previewer: vux_src_components_previewer },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      orderDetail: {},
      isHide: false,
      iden: '',
      address: '',
      isCancel: false,
      resultshow: false,
      fastshow: false,
      fast_advice: '',
      solutionv: 1,
      reason: [{ key: 'ACCEPT', value: '接受' }, { key: 'REJECT', value: '拒绝' }],
      confirm: 'ACCEPT',
      advice: '',
      list: [],
      isAssis: false,
      role: this.$route.query.role,
      closed: false,
      filename: '',
      filepath: ''
    };
  },

  methods: {
    userevaluation: function userevaluation() {
      this.$router.push({ name: 'userevaluation', params: { obj: this.orderDetail } });
    },
    downloadFile: function downloadFile() {
      this.$router.push({
        name: "Download",
        query: { path: this.filepath, suffix: this.filename }
      });
    },
    bxjl: function bxjl() {
      this.$router.push({ name: 'makeMemo', params: { iden: 'EXPT', solutionv: this.solutionv } });
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    cancel: function cancel() {
      this.$router.push({ name: 'cancelCause', params: { obj: this.orderDetail } });
    },
    addphoto: function addphoto() {
      this.$router.push({ name: 'addphoto', params: { isAssis: !this.isAssis } });
    },
    cancelResult: function cancelResult(seq) {
      var that = this;
      if (this.orderDetail.userconfirm === '待处理') {
        if (this.confirm === 'REJECT') {
          this.$vux.confirm.show({
            content: '如再次拒绝，将会进入仲裁流程',
            theme: 'android',
            onCancel: function onCancel() {},
            onConfirm: function onConfirm() {
              that.close(seq);
            }
          });
        } else {
          this.close(seq);
        }
      } else {
        this.close(seq);
      }
    },
    fastResult: function fastResult(seq) {
      var _this = this;

      this.$http.get('/api/v1/normalrepairs/' + seq + '/urge?role=EXPT&type=detail&advice=' + this.fast_advice, this.header).then(function () {
        _this.fastshow = false;
        alert('催单成功');
        _this.$router.back();
      }).catch(function (err) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    close: function close(seq) {
      var _this2 = this;

      this.$http.put('/api/normalrepairs/' + seq + '/user_confirm', {
        role: 'INDV',
        confirm: this.confirm,
        advice: this.advice
      }, this.header).then(function (response) {
        _this2.resultshow = false;
        _this2.$router.push({ name: 'normalrepairslist' });
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (to.query.role) {
      next(function (vm) {
        vm.isAssis = true;
        ajax["a" /* default */].$http.get('/api/v1/normalrepairs/' + to.query.seq + '?role=EXPT&type=detail', vm.header).then(function (response) {
          localStorage.setItem('order', stringify_default()(response.data.detail));
          vm.orderDetail = response.data.detail;
          vm.isCancel = vm.orderDetail.userconfirm === 'WAIT1' || vm.orderDetail.userconfirm === 'WAIT2';
          vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
          if (vm.orderDetail.confirm === "WAIT") {
            vm.isHide = true;
          }
          if (vm.orderDetail.canstate === 'REQUEST') {
            vm.isHide = false;
          }
          vm.orderDetail.isviwo = vm.orderDetail.isviwo ? '是' : '否';
          vm.orderDetail.sevenday = vm.orderDetail.sevenday ? '是' : '否';
          vm.solutionv = vm.orderDetail.solutionv;
          switch (vm.orderDetail.userconfirm) {
            case "ACCEPT":
              vm.orderDetail.userconfirm = '接受';
              break;
            case "REJECT":
              vm.orderDetail.userconfirm = '拒绝';
              break;
            case "ARBIT":
              vm.orderDetail.userconfirm = '仲裁';
              break;
            case 'WAIT1':
              vm.orderDetail.userconfirm = '等待处理';
              break;
            case 'WAIT2':
              vm.orderDetail.userconfirm = '待处理';
              break;
            case 'A_ACCEPT':
              vm.orderDetail.userconfirm = '自动确认';
              break;
            default:
              vm.orderDetail.userconfirm = '等待处理';
              break;
          }
          vm.list = [];
          console.log(vm.orderDetail.signature);
          if (vm.orderDetail.signature && vm.orderDetail.signature.content.length !== 0) {
            if (vm.orderDetail.signature.content[0].describe == "") {
              vm.orderDetail.signature.content[0].path.forEach(function (item) {
                var path = vm.orderDetail.signature.version === '1.0' ? item : item['origin'];
                ajax["a" /* default */].$http.get('/api/photos?path=' + path, header).then(function (paths) {
                  vm.list.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
                });
              });
            } else {

              vm.filename = vm.orderDetail.signature.content[0].describe;
              vm.filepath = vm.orderDetail.signature.content[0].path[0].origin;
            }
          }
        });
      });
    } else {
      next(function (vm) {
        var openid = localStorage.getItem('openid');
        var unionid = localStorage.getItem('unionid');
        var account = void 0;
        ajax["a" /* default */].$http.get('api/v1/wechat/' + unionid).then(function (res) {

          res.data.forEach(function (item) {
            if (item.role === 'INDV') {
              account = item.account;
            }
          });
          ajax["a" /* default */].$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (response) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userid', response.data.userid);
            vm.header = {
              headers: {
                token: response.data.token,
                opid: response.data.userid
              }
            };
            ajax["a" /* default */].$http.get('/api/v1/normalrepairs/' + to.query.seq + '?role=INDV&type=detail', vm.header).then(function (response) {
              localStorage.setItem('order', stringify_default()(response.data.detail));
              vm.closed = response.data.closed;
              vm.orderDetail = response.data.detail;
              vm.isCancel = vm.orderDetail.userconfirm === 'WAIT1' || vm.orderDetail.userconfirm === 'WAIT2';
              vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
              if (vm.orderDetail.confirm === "WAIT") {
                vm.isHide = true;
              }
              if (vm.orderDetail.canstate === 'REQUEST') {
                vm.isHide = false;
              }
              vm.orderDetail.isviwo = vm.orderDetail.isviwo ? '是' : '否';
              vm.orderDetail.sevenday = vm.orderDetail.sevenday ? '是' : '否';
              switch (vm.orderDetail.userconfirm) {
                case "ACCEPT":
                  vm.orderDetail.userconfirm = '接受';
                  break;
                case "REJECT":
                  vm.orderDetail.userconfirm = '拒绝';
                  break;
                case "ARBIT":
                  vm.orderDetail.userconfirm = '仲裁';
                  break;
                case 'WAIT1':
                  vm.orderDetail.userconfirm = '等待处理';
                  break;
                case 'WAIT2':
                  vm.orderDetail.userconfirm = '待处理';
                  break;
                case 'A_ACCEPT':
                  vm.orderDetail.userconfirm = '自动确认';
                  break;
                default:
                  vm.orderDetail.userconfirm = '等待处理';
                  break;
              }
              vm.list = [];
              if (vm.orderDetail.signature && vm.orderDetail.signature.content.length !== 0) {
                if (vm.orderDetail.signature.content[0].describe == "") {
                  vm.orderDetail.signature.content[0].path.forEach(function (item) {
                    var path = vm.orderDetail.signature.version === '1.0' ? item : item['origin'];
                    ajax["a" /* default */].$http.get('/api/photos?path=' + path, header).then(function (paths) {
                      vm.list.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
                    });
                  });
                } else {

                  vm.filename = vm.orderDetail.signature.content[0].describe;
                  vm.filepath = vm.orderDetail.signature.content[0].path[0].origin;
                }
              }
            });
          });
        });
      });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/normalcomplete.vue














/* harmony default export */ var components_normalcomplete = ({
  components: { XHeader: vux_src_components_x_header, XInput: vux_src_components_x_input, Group: group["a" /* default */], XButton: vux_src_components_x_button, Cell: vux_src_components_cell, XTextarea: vux_src_components_x_textarea, Confirm: components_confirm["a" /* default */], Selector: vux_src_components_selector, Previewer: vux_src_components_previewer },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      orderDetail: {},
      isHide: false,
      iden: '',
      address: '',
      isCancel: false,
      resultshow: false,
      fastshow: false,
      fast_advice: '',
      solutionv: 1,
      reason: [{ key: 'ACCEPT', value: '接受' }, { key: 'REJECT', value: '拒绝' }],
      confirm: 'ACCEPT',
      advice: '',
      list: [],
      isAssis: false,
      role: this.$route.query.role,
      closed: false,
      filename: '',
      filepath: ''
    };
  },

  methods: {
    userevaluation: function userevaluation() {
      this.$router.push({ name: 'userevaluation', params: { obj: this.orderDetail } });
    },
    downloadFile: function downloadFile() {
      this.$router.push({
        name: "Download",
        query: { path: this.filepath, suffix: this.filename }
      });
    },
    bxjl: function bxjl() {
      this.$router.push({ name: 'makeMemo', params: { iden: 'EXPT', solutionv: this.solutionv } });
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    cancel: function cancel() {
      this.$router.push({ name: 'cancelCause', params: { obj: this.orderDetail } });
    },
    addphoto: function addphoto() {
      this.$router.push({ name: 'addphoto', params: { isAssis: !this.isAssis } });
    },
    cancelResult: function cancelResult(seq) {
      var that = this;
      if (this.orderDetail.userconfirm === '待处理') {
        if (this.confirm === 'REJECT') {
          this.$vux.confirm.show({
            content: '如再次拒绝，将会进入仲裁流程',
            theme: 'android',
            onCancel: function onCancel() {},
            onConfirm: function onConfirm() {
              that.close(seq);
            }
          });
        } else {
          this.close(seq);
        }
      } else {
        this.close(seq);
      }
    },
    fastResult: function fastResult(seq) {
      var _this = this;

      this.$http.get('/api/v1/normalrepairs/' + seq + '/urge?role=EXPT&type=detail&advice=' + this.fast_advice, this.header).then(function () {
        _this.fastshow = false;
        alert('催单成功');
        _this.$router.back();
      }).catch(function (err) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    close: function close(seq) {
      var _this2 = this;

      this.$http.put('/api/normalrepairs/' + seq + '/user_confirm', {
        role: 'INDV',
        confirm: this.confirm,
        advice: this.advice
      }, this.header).then(function (response) {
        _this2.resultshow = false;
        _this2.$router.push({ name: 'normalrepairslist' });
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (to.query.role) {
      next(function (vm) {
        vm.isAssis = true;
        ajax["a" /* default */].$http.get('/api/v1/normalrepairs/' + to.query.seq + '?role=EXPT&type=detail', vm.header).then(function (response) {
          localStorage.setItem('order', stringify_default()(response.data.detail));
          vm.orderDetail = response.data.detail;
          vm.isCancel = vm.orderDetail.userconfirm === 'WAIT1' || vm.orderDetail.userconfirm === 'WAIT2';
          vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
          if (vm.orderDetail.confirm === "WAIT") {
            vm.isHide = true;
          }
          if (vm.orderDetail.canstate === 'REQUEST') {
            vm.isHide = false;
          }
          vm.orderDetail.isviwo = vm.orderDetail.isviwo ? '是' : '否';
          vm.orderDetail.sevenday = vm.orderDetail.sevenday ? '是' : '否';
          vm.solutionv = vm.orderDetail.solutionv;
          switch (vm.orderDetail.userconfirm) {
            case "ACCEPT":
              vm.orderDetail.userconfirm = '接受';
              break;
            case "REJECT":
              vm.orderDetail.userconfirm = '拒绝';
              break;
            case "ARBIT":
              vm.orderDetail.userconfirm = '仲裁';
              break;
            case 'WAIT1':
              vm.orderDetail.userconfirm = '等待处理';
              break;
            case 'WAIT2':
              vm.orderDetail.userconfirm = '待处理';
              break;
            case 'A_ACCEPT':
              vm.orderDetail.userconfirm = '自动确认';
              break;
            default:
              vm.orderDetail.userconfirm = '等待处理';
              break;
          }
          vm.list = [];
          console.log(vm.orderDetail.signature);
          if (vm.orderDetail.signature && vm.orderDetail.signature.content.length !== 0) {
            if (vm.orderDetail.signature.content[0].describe == "") {
              vm.orderDetail.signature.content[0].path.forEach(function (item) {
                var path = vm.orderDetail.signature.version === '1.0' ? item : item['origin'];
                ajax["a" /* default */].$http.get('/api/photos?path=' + path, header).then(function (paths) {
                  vm.list.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
                });
              });
            } else {

              vm.filename = vm.orderDetail.signature.content[0].describe;
              vm.filepath = vm.orderDetail.signature.content[0].path[0].origin;
            }
          }
        });
      });
    } else {
      next(function (vm) {
        var openid = localStorage.getItem('openid');
        var unionid = localStorage.getItem('unionid');
        var account = void 0;
        ajax["a" /* default */].$http.get('api/v1/wechat/' + unionid).then(function (res) {

          res.data.forEach(function (item) {
            if (item.role === 'INDV') {
              account = item.account;
            }
          });
          ajax["a" /* default */].$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (response) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userid', response.data.userid);
            vm.header = {
              headers: {
                token: response.data.token,
                opid: response.data.userid
              }
            };
            ajax["a" /* default */].$http.get('/api/v1/normalrepairs/' + to.query.seq + '?role=INDV&type=detail', vm.header).then(function (response) {
              localStorage.setItem('order', stringify_default()(response.data.detail));
              vm.closed = response.data.closed;
              vm.orderDetail = response.data.detail;
              vm.isCancel = vm.orderDetail.userconfirm === 'WAIT1' || vm.orderDetail.userconfirm === 'WAIT2';
              vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
              if (vm.orderDetail.confirm === "WAIT") {
                vm.isHide = true;
              }
              if (vm.orderDetail.canstate === 'REQUEST') {
                vm.isHide = false;
              }
              vm.orderDetail.isviwo = vm.orderDetail.isviwo ? '是' : '否';
              vm.orderDetail.sevenday = vm.orderDetail.sevenday ? '是' : '否';
              switch (vm.orderDetail.userconfirm) {
                case "ACCEPT":
                  vm.orderDetail.userconfirm = '接受';
                  break;
                case "REJECT":
                  vm.orderDetail.userconfirm = '拒绝';
                  break;
                case "ARBIT":
                  vm.orderDetail.userconfirm = '仲裁';
                  break;
                case 'WAIT1':
                  vm.orderDetail.userconfirm = '等待处理';
                  break;
                case 'WAIT2':
                  vm.orderDetail.userconfirm = '待处理';
                  break;
                case 'A_ACCEPT':
                  vm.orderDetail.userconfirm = '自动确认';
                  break;
                default:
                  vm.orderDetail.userconfirm = '等待处理';
                  break;
              }
              vm.list = [];
              if (vm.orderDetail.signature && vm.orderDetail.signature.content.length !== 0) {
                if (vm.orderDetail.signature.content[0].describe == "") {
                  vm.orderDetail.signature.content[0].path.forEach(function (item) {
                    var path = vm.orderDetail.signature.version === '1.0' ? item : item['origin'];
                    ajax["a" /* default */].$http.get('/api/photos?path=' + path, header).then(function (paths) {
                      vm.list.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
                    });
                  });
                } else {

                  vm.filename = vm.orderDetail.signature.content[0].describe;
                  vm.filepath = vm.orderDetail.signature.content[0].path[0].origin;
                }
              }
            });
          });
        });
      });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6de7388","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/normalcomplete.vue
var normalcomplete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报修订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否云帷设备","type":"text","readonly":""},model:{value:(_vm.orderDetail.isviwo),callback:function ($$v) {_vm.$set(_vm.orderDetail, "isviwo", $$v)},expression:"orderDetail.isviwo"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否1次开箱","type":"text","readonly":""},model:{value:(_vm.orderDetail.sevenday),callback:function ($$v) {_vm.$set(_vm.orderDetail, "sevenday", $$v)},expression:"orderDetail.sevenday"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devseq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devseq", $$v)},expression:"orderDetail.devseq"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备名称","show-counter":false,"max":32,"autosize":"","readonly":""},model:{value:(_vm.orderDetail.devname),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devname", $$v)},expression:"orderDetail.devname"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备生产商","max":32,"autosize":"","show-counter":false,"readonly":""},model:{value:(_vm.orderDetail.producer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "producer", $$v)},expression:"orderDetail.producer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备所在地","type":"text","readonly":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"详细地址","type":"text","readonly":""},model:{value:(_vm.orderDetail.address),callback:function ($$v) {_vm.$set(_vm.orderDetail, "address", $$v)},expression:"orderDetail.address"}}),_vm._v(" "),_c('cell',{attrs:{"title":('故障详情'),"is-link":""},nativeOn:{"click":function($event){return _vm.addphoto($event)}}}),_vm._v(" "),(!_vm.isAssis)?_c('cell',{attrs:{"title":('支付订单'),"is-link":"","link":{name:'Userpay',params:{info:_vm.orderDetail.user_pays}}}}):_vm._e(),_vm._v(" "),_c('cell',{attrs:{"title":('管理员联系方式'),"is-link":"","link":{name:'srvprepairinfo',params:{info:_vm.orderDetail.contact}}}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备何处购入","show-counter":false,"max":32,"autosize":"","readonly":""},model:{value:(_vm.orderDetail.buyfrom),callback:function ($$v) {_vm.$set(_vm.orderDetail, "buyfrom", $$v)},expression:"orderDetail.buyfrom"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.reptype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "reptype", $$v)},expression:"orderDetail.reptype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.name),callback:function ($$v) {_vm.$set(_vm.orderDetail, "name", $$v)},expression:"orderDetail.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "mobile", $$v)},expression:"orderDetail.mobile"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"show-counter":false,"title":"报修人公司","max":32,"autosize":"","readonly":""},model:{value:(_vm.orderDetail.company),callback:function ($$v) {_vm.$set(_vm.orderDetail, "company", $$v)},expression:"orderDetail.company"}}),_vm._v(" "),(_vm.orderDetail.reptype === '最终用户报修')?[_c('x-input',{attrs:{"title":"本地服务商","readonly":""},model:{value:(_vm.orderDetail.lservice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lservice", $$v)},expression:"orderDetail.lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","readonly":""},model:{value:(_vm.orderDetail.lsmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lsmobile", $$v)},expression:"orderDetail.lsmobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.reptype === '服务商代报修')?[_c('x-input',{attrs:{"title":"最终用户","readonly":""},model:{value:(_vm.orderDetail.enduser),callback:function ($$v) {_vm.$set(_vm.orderDetail, "enduser", $$v)},expression:"orderDetail.enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","readonly":""},model:{value:(_vm.orderDetail.endmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "endmobile", $$v)},expression:"orderDetail.endmobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.reptype === '其他代报修')?[_c('x-input',{attrs:{"title":"最终用户","readonly":""},model:{value:(_vm.orderDetail.enduser),callback:function ($$v) {_vm.$set(_vm.orderDetail, "enduser", $$v)},expression:"orderDetail.enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","readonly":""},model:{value:(_vm.orderDetail.endmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "endmobile", $$v)},expression:"orderDetail.endmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商","readonly":""},model:{value:(_vm.orderDetail.lservice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lservice", $$v)},expression:"orderDetail.lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","readonly":""},model:{value:(_vm.orderDetail.lsmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lsmobile", $$v)},expression:"orderDetail.lsmobile"}})]:_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"申请开始时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.start),callback:function ($$v) {_vm.$set(_vm.orderDetail, "start", $$v)},expression:"orderDetail.start"}}),_vm._v(" "),(_vm.orderDetail.userconfirm)?_c('x-input',{attrs:{"title":"用户确认维修结果","type":"text","readonly":""},model:{value:(_vm.orderDetail.userconfirm),callback:function ($$v) {_vm.$set(_vm.orderDetail, "userconfirm", $$v)},expression:"orderDetail.userconfirm"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.useradvice)?_c('x-textarea',{attrs:{"title":"用户反馈意见","rows":1,"cols":10,"autosize":"","show-counter":false,"readonly":""},model:{value:(_vm.orderDetail.useradvice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "useradvice", $$v)},expression:"orderDetail.useradvice"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.responsible && _vm.orderDetail.responsible.type ==='SRVP')?[(_vm.orderDetail.expert)?_c('x-input',{attrs:{"title":"专家姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.expert.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.expert, "name", $$v)},expression:"orderDetail.expert.name"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.expert)?_c('x-input',{attrs:{"title":"专家电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.expert.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.expert, "mobile", $$v)},expression:"orderDetail.expert.mobile"}}):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.orderDetail.responsible && _vm.orderDetail.responsible.type ==='EXPT')?[_c('x-input',{attrs:{"title":"工程师姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "name", $$v)},expression:"orderDetail.responsible.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"工程师电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "mobile", $$v)},expression:"orderDetail.responsible.mobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.assit && _vm.orderDetail.assitstate !== 'WAIT')?[(_vm.orderDetail.assit)?_c('x-input',{attrs:{"title":"第三方专家姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.assit.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.assit, "name", $$v)},expression:"orderDetail.assit.name"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.assit)?_c('x-input',{attrs:{"title":"第三方专家电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.assit.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.assit, "mobile", $$v)},expression:"orderDetail.assit.mobile"}}):_vm._e()]:_vm._e(),_vm._v(" "),_c('cell',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAssis),expression:"isAssis"}],attrs:{"is-link":""},nativeOn:{"click":function($event){return _vm.bxjl($event)}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v("维修进度")])])]),_vm._v(" "),(_vm.orderDetail.conclusion)?_c('x-textarea',{attrs:{"title":"维修结论","type":"text","readonly":""},model:{value:(_vm.orderDetail.conclusion),callback:function ($$v) {_vm.$set(_vm.orderDetail, "conclusion", $$v)},expression:"orderDetail.conclusion"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.addition)?_c('x-input',{attrs:{"title":"附加说明","type":"text","readonly":""},model:{value:(_vm.orderDetail.addition),callback:function ($$v) {_vm.$set(_vm.orderDetail, "addition", $$v)},expression:"orderDetail.addition"}}):_vm._e(),_vm._v(" "),_c('cell',{attrs:{"title":"用户确认单"}},[_c('div',[_vm._l((_vm.list),function(item,index){return _c('img',{key:index,staticClass:"previewer-demo-img",staticStyle:{"height":"90px"},attrs:{"src":item.src},on:{"click":function($event){_vm.show(index)}}})}),_vm._v(" "),(_vm.filename)?_c('x-button',{nativeOn:{"click":function($event){return _vm.downloadFile($event)}}},[_vm._v(_vm._s(_vm.filename))]):_vm._e()],2)]),_vm._v(" "),(!_vm.isAssis && _vm.closed)?_c('cell',{attrs:{"title":"评价","is-link":""},nativeOn:{"click":function($event){return _vm.userevaluation($event)}}}):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHide && !_vm.isAssis),expression:"isHide && !isAssis"}],staticClass:"btnbox"},[_c('x-button',{staticClass:"btn",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v("取消任务")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCancel && !_vm.isAssis),expression:"isCancel && !isAssis"}],staticClass:"btnbox"},[_c('x-button',{staticClass:"btn",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.resultshow = true}}},[_vm._v("确认维修结果")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAssis),expression:"isAssis"}],staticClass:"btnbox"},[_c('x-button',{staticClass:"btn",attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.fastshow = true}}},[_vm._v("催单")])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.list,"options":_vm.options}})],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"确认维修结果"},on:{"on-cancel":function($event){_vm.resultshow = false},"on-confirm":function($event){_vm.cancelResult(_vm.orderDetail.seq)}},model:{value:(_vm.resultshow),callback:function ($$v) {_vm.resultshow=$$v},expression:"resultshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"确认结果","options":_vm.reason},model:{value:(_vm.confirm),callback:function ($$v) {_vm.confirm=$$v},expression:"confirm"}}),_vm._v(" "),_c('x-textarea',{staticClass:"white-textarea",attrs:{"rows":1,"cols":10,"title":"确认意见","max":60,"autosize":"","show-counter":false},model:{value:(_vm.advice),callback:function ($$v) {_vm.advice=$$v},expression:"advice"}})],1)],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"催单"},on:{"on-cancel":function($event){_vm.fastshow = false},"on-confirm":function($event){_vm.fastResult(_vm.orderDetail.seq)}},model:{value:(_vm.fastshow),callback:function ($$v) {_vm.fastshow=$$v},expression:"fastshow"}},[_c('group',[_c('x-textarea',{staticClass:"white-textarea",attrs:{"rows":1,"cols":10,"title":"提醒内容","max":60,"autosize":"","show-counter":false},model:{value:(_vm.fast_advice),callback:function ($$v) {_vm.fast_advice=$$v},expression:"fast_advice"}})],1)],1)],1)],1)}
var normalcomplete_staticRenderFns = []
var normalcomplete_esExports = { render: normalcomplete_render, staticRenderFns: normalcomplete_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_normalcomplete = (normalcomplete_esExports);
// CONCATENATED MODULE: ./src/components/normalcomplete.vue
function normalcomplete_injectStyle (ssrContext) {
  __webpack_require__("nXml")
}
var normalcomplete_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var normalcomplete___vue_template_functional__ = false
/* styles */
var normalcomplete___vue_styles__ = normalcomplete_injectStyle
/* scopeId */
var normalcomplete___vue_scopeId__ = "data-v-e6de7388"
/* moduleIdentifier (server only) */
var normalcomplete___vue_module_identifier__ = null
var normalcomplete_Component = normalcomplete_normalizeComponent(
  components_normalcomplete,
  selectortype_template_index_0_src_components_normalcomplete,
  normalcomplete___vue_template_functional__,
  normalcomplete___vue_styles__,
  normalcomplete___vue_scopeId__,
  normalcomplete___vue_module_identifier__
)

/* harmony default export */ var src_components_normalcomplete = (normalcomplete_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/normaldone.vue







/* harmony default export */ var normaldone = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    Cell: vux_src_components_cell
  },
  name: 'orderDetail',
  data: function data() {
    return {
      title: '评论',
      orderDetail: {},
      address: '',
      flag: true
    };
  },

  methods: {
    userevaluation: function userevaluation() {
      this.$router.push({ name: 'userevaluation', params: { obj: this.orderDetail } });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'normalrepairslist') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
        if (vm.orderDetail.sevenday) {
          vm.orderDetail.sevenday = '是';
        } else {
          vm.orderDetail.sevenday = '否';
        }
        if (!vm.orderDetail.responsible) {
          vm.flag = false;
        }
        if (vm.orderDetail.rating) {
          vm.title = '查看评论';
        }
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        console.log(vm.orderDetail);
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
        if (vm.orderDetail.sevenday) {
          vm.orderDetail.sevenday = '是';
        } else {
          vm.orderDetail.sevenday = '否';
        }
        if (!vm.orderDetail.responsible) {
          vm.flag = false;
        }
        if (vm.orderDetail.rating) {
          vm.title = '查看评论';
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/normaldone.vue







/* harmony default export */ var components_normaldone = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    Cell: vux_src_components_cell
  },
  name: 'orderDetail',
  data: function data() {
    return {
      title: '评论',
      orderDetail: {},
      address: '',
      flag: true
    };
  },

  methods: {
    userevaluation: function userevaluation() {
      this.$router.push({ name: 'userevaluation', params: { obj: this.orderDetail } });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'normalrepairslist') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
        if (vm.orderDetail.sevenday) {
          vm.orderDetail.sevenday = '是';
        } else {
          vm.orderDetail.sevenday = '否';
        }
        if (!vm.orderDetail.responsible) {
          vm.flag = false;
        }
        if (vm.orderDetail.rating) {
          vm.title = '查看评论';
        }
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        console.log(vm.orderDetail);
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.isviwo) {
          vm.orderDetail.isviwo = '是';
        } else {
          vm.orderDetail.isviwo = '否';
        }
        if (vm.orderDetail.sevenday) {
          vm.orderDetail.sevenday = '是';
        } else {
          vm.orderDetail.sevenday = '否';
        }
        if (!vm.orderDetail.responsible) {
          vm.flag = false;
        }
        if (vm.orderDetail.rating) {
          vm.title = '查看评论';
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b2ed4ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/normaldone.vue
var normaldone_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报修订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否云帷设备","type":"text","readonly":""},model:{value:(_vm.orderDetail.isviwo),callback:function ($$v) {_vm.$set(_vm.orderDetail, "isviwo", $$v)},expression:"orderDetail.isviwo"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否1次开箱","type":"text","readonly":""},model:{value:(_vm.orderDetail.sevenday),callback:function ($$v) {_vm.$set(_vm.orderDetail, "sevenday", $$v)},expression:"orderDetail.sevenday"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devseq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devseq", $$v)},expression:"orderDetail.devseq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.devname),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devname", $$v)},expression:"orderDetail.devname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备生产商","type":"text","readonly":""},model:{value:(_vm.orderDetail.producer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "producer", $$v)},expression:"orderDetail.producer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.ftype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "ftype", $$v)},expression:"orderDetail.ftype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障具体描述","type":"text","readonly":""},model:{value:(_vm.orderDetail.fdesc),callback:function ($$v) {_vm.$set(_vm.orderDetail, "fdesc", $$v)},expression:"orderDetail.fdesc"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备何处购入","type":"text","readonly":""},model:{value:(_vm.orderDetail.buyfrom),callback:function ($$v) {_vm.$set(_vm.orderDetail, "buyfrom", $$v)},expression:"orderDetail.buyfrom"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备所在地","type":"text","readonly":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"详细地址","type":"text","readonly":""},model:{value:(_vm.orderDetail.address),callback:function ($$v) {_vm.$set(_vm.orderDetail, "address", $$v)},expression:"orderDetail.address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.reptype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "reptype", $$v)},expression:"orderDetail.reptype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.name),callback:function ($$v) {_vm.$set(_vm.orderDetail, "name", $$v)},expression:"orderDetail.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "mobile", $$v)},expression:"orderDetail.mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人公司","type":"text","readonly":""},model:{value:(_vm.orderDetail.company),callback:function ($$v) {_vm.$set(_vm.orderDetail, "company", $$v)},expression:"orderDetail.company"}}),_vm._v(" "),(_vm.orderDetail.reptype === '最终用户报修')?[_c('x-input',{attrs:{"title":"本地服务商","readonly":""},model:{value:(_vm.orderDetail.lservice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lservice", $$v)},expression:"orderDetail.lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","readonly":""},model:{value:(_vm.orderDetail.lsmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lsmobile", $$v)},expression:"orderDetail.lsmobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.reptype === '服务商代报修')?[_c('x-input',{attrs:{"title":"最终用户","readonly":""},model:{value:(_vm.orderDetail.enduser),callback:function ($$v) {_vm.$set(_vm.orderDetail, "enduser", $$v)},expression:"orderDetail.enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","readonly":""},model:{value:(_vm.orderDetail.endmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "endmobile", $$v)},expression:"orderDetail.endmobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.reptype === '其他代报修')?[_c('x-input',{attrs:{"title":"最终用户","readonly":""},model:{value:(_vm.orderDetail.enduser),callback:function ($$v) {_vm.$set(_vm.orderDetail, "enduser", $$v)},expression:"orderDetail.enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","readonly":""},model:{value:(_vm.orderDetail.endmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "endmobile", $$v)},expression:"orderDetail.endmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商","readonly":""},model:{value:(_vm.orderDetail.lservice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lservice", $$v)},expression:"orderDetail.lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","readonly":""},model:{value:(_vm.orderDetail.lsmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lsmobile", $$v)},expression:"orderDetail.lsmobile"}})]:_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"申请开始时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.start),callback:function ($$v) {_vm.$set(_vm.orderDetail, "start", $$v)},expression:"orderDetail.start"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请结束时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.end),callback:function ($$v) {_vm.$set(_vm.orderDetail, "end", $$v)},expression:"orderDetail.end"}}),_vm._v(" "),(_vm.orderDetail.responsible&&_vm.orderDetail.responsible.type ==='SRVP')?[_c('x-input',{attrs:{"title":"服务商负责人姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "name", $$v)},expression:"orderDetail.responsible.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"服务商负责人电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "mobile", $$v)},expression:"orderDetail.responsible.mobile"}}),_vm._v(" "),(_vm.orderDetail.expert)?_c('x-input',{attrs:{"title":"工程师姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.expert.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.expert, "name", $$v)},expression:"orderDetail.expert.name"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.expert)?_c('x-input',{attrs:{"title":"工程师电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.expert.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.expert, "mobile", $$v)},expression:"orderDetail.expert.mobile"}}):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.orderDetail.responsible&&_vm.orderDetail.responsible.type ==='EXPT')?[_c('x-input',{attrs:{"title":"工程师姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "name", $$v)},expression:"orderDetail.responsible.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"工程师电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "mobile", $$v)},expression:"orderDetail.responsible.mobile"}})]:_vm._e(),_vm._v(" "),_c('cell',{attrs:{"title":(_vm.title),"is-link":""},nativeOn:{"click":function($event){return _vm.userevaluation($event)}}})],2)],1)}
var normaldone_staticRenderFns = []
var normaldone_esExports = { render: normaldone_render, staticRenderFns: normaldone_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_normaldone = (normaldone_esExports);
// CONCATENATED MODULE: ./src/components/normaldone.vue
function normaldone_injectStyle (ssrContext) {
  __webpack_require__("YgVi")
}
var normaldone_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var normaldone___vue_template_functional__ = false
/* styles */
var normaldone___vue_styles__ = normaldone_injectStyle
/* scopeId */
var normaldone___vue_scopeId__ = "data-v-5b2ed4ac"
/* moduleIdentifier (server only) */
var normaldone___vue_module_identifier__ = null
var normaldone_Component = normaldone_normalizeComponent(
  components_normaldone,
  selectortype_template_index_0_src_components_normaldone,
  normaldone___vue_template_functional__,
  normaldone___vue_styles__,
  normaldone___vue_scopeId__,
  normaldone___vue_module_identifier__
)

/* harmony default export */ var src_components_normaldone = (normaldone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userhomepage.vue













/* harmony default export */ var userhomepage = ({
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Toast: toast["a" /* default */]
  },
  data: function data() {
    return {
      select: this.$route.query.select ? this.$route.query.select : '',
      list: ['用户'],
      index: 0,
      flag: false,
      imgUrl: '/static/img/home.png',
      isid: '',
      role: ''
    };
  },

  methods: {
    ordermanage: function ordermanage() {
      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var that = this;
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

        if (res.data.length > 0) {
          var account = res.data[0].account;
          that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };
            that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
              for (var i = 0; i < response.data.length; i++) {
                if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                  that.isid = response.data[i].type;
                }
              }
              if (that.isid == 'INDV' || that.isid == 'ENTP') {
                that.$router.push({ name: 'normalrepairslist' });
              } else {
                that.$vux.alert.show({
                  title: '',
                  content: '您的身份不符合该功能'
                });
              }
            });
            that.$router.push({ name: 'normalrepairslist' });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        } else {
          localStorage.setItem('list', 'true');
          localStorage.setItem('repair', 'normalrepairslist');
          that.$router.push({ name: 'login' });
        }
      });
    },
    assistantorder: function assistantorder() {
      var _this = this;

      this.$http.get('api/v1/wechat/' + localStorage.getItem('unionid')).then(function (res) {
        var len = res.data.length;
        if (len) {
          _this.$router.push({ name: 'assistantorder' });
        } else {
          localStorage.setItem('repair', 'assistantorder');
          localStorage.setItem('repairtype', 'EXPT');
          _this.$router.push({ name: 'login' });
        }
      });
    },
    engineer: function engineer() {
      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var that = this;
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

        if (res.data.length > 0) {
          var account = res.data[0].account;
          localStorage.setItem('account', account);

          that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };

            that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
              for (var i = 0; i < response.data.length; i++) {
                console.log(response.data[i].type);

                if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                  that.isid = response.data[i].type;
                }
              }

              if (that.isid == 'EXPT' || that.isid == 'SRVP') {
                that.$router.push({ name: 'engineer' });
              } else {
                that.$vux.alert.show({
                  title: '',
                  content: '您的身份不符合该功能'
                });
              }
            }).catch(function (error) {
              if (error.response) {
                if (error.response.data) {
                  that.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                }
              }
            });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        } else {
          localStorage.setItem('repair', 'engineer');
          that.$router.push({ name: 'login' });
        }
      }).catch(function (error) {
        console.log(error.response);
        if (error.response) {
          if (error.response.data) {
            that.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          }
        }
      });
    },
    solution_logs: function solution_logs() {
      var _this2 = this;

      this.$http.get('api/v1/wechat/' + localStorage.getItem('unionid')).then(function (res) {
        var len = res.data.length;
        if (len) {
          _this2.$router.push({ name: 'solution_logs', params: { role: 'EXPT' } });
        } else {
          localStorage.setItem('repair', 'solution_logs');
          localStorage.setItem('repairtype', 'EXPT');
          _this2.$router.push({ name: 'login' });
        }
      });
    },
    gohome: function gohome() {
      this.$router.push({ name: 'vip' });
    },
    baoxiu: function baoxiu() {
      this.$router.push({ name: 'normalrepairs' });
    },
    equipment: function equipment() {
      var _this3 = this;

      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var that = this;
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

        if (res.data.length > 0) {
          var account = res.data[0].account;
          localStorage.setItem('account', account);

          that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };

            that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
              for (var i = 0; i < response.data.length; i++) {

                if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                  that.role = response.data[i].type;
                  break;
                }
                if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                  that.isid = response.data[i].type;
                }
              }

              if (that.role == 'INDV' || that.role == 'ENTP') {
                that.$router.push({ name: 'Devicelist' });
              } else {
                var iden;
                if (that.isid == 'EXPT') {
                  iden = '个人用户';
                }
                if (that.isid == 'SRVP') {
                  iden = '企业用户';
                }

                that.$vux.confirm.show({
                  title: '',
                  content: '您的身份不符合该功能,如需用该功能,请添加' + iden,
                  onConfirm: function onConfirm() {
                    that.$router.push({ name: 'addmyInfo' });
                  }
                });
              }
            }).catch(function (error) {
              if (error.response) {
                if (error.response.data) {
                  that.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                }
              }
            });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        } else {
          localStorage.setItem('repair', 'Devicelist');
          _this3.$router.push({ name: 'login' });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userhomepage.vue













/* harmony default export */ var components_userhomepage = ({
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item,
    Toast: toast["a" /* default */]
  },
  data: function data() {
    return {
      select: this.$route.query.select ? this.$route.query.select : '',
      list: ['用户'],
      index: 0,
      flag: false,
      imgUrl: '/static/img/home.png',
      isid: '',
      role: ''
    };
  },

  methods: {
    ordermanage: function ordermanage() {
      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var that = this;
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

        if (res.data.length > 0) {
          var account = res.data[0].account;
          that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };
            that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
              for (var i = 0; i < response.data.length; i++) {
                if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                  that.isid = response.data[i].type;
                }
              }
              if (that.isid == 'INDV' || that.isid == 'ENTP') {
                that.$router.push({ name: 'normalrepairslist' });
              } else {
                that.$vux.alert.show({
                  title: '',
                  content: '您的身份不符合该功能'
                });
              }
            });
            that.$router.push({ name: 'normalrepairslist' });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        } else {
          localStorage.setItem('list', 'true');
          localStorage.setItem('repair', 'normalrepairslist');
          that.$router.push({ name: 'login' });
        }
      });
    },
    assistantorder: function assistantorder() {
      var _this = this;

      this.$http.get('api/v1/wechat/' + localStorage.getItem('unionid')).then(function (res) {
        var len = res.data.length;
        if (len) {
          _this.$router.push({ name: 'assistantorder' });
        } else {
          localStorage.setItem('repair', 'assistantorder');
          localStorage.setItem('repairtype', 'EXPT');
          _this.$router.push({ name: 'login' });
        }
      });
    },
    engineer: function engineer() {
      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var that = this;
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

        if (res.data.length > 0) {
          var account = res.data[0].account;
          localStorage.setItem('account', account);

          that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };

            that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
              for (var i = 0; i < response.data.length; i++) {
                console.log(response.data[i].type);

                if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                  that.isid = response.data[i].type;
                }
              }

              if (that.isid == 'EXPT' || that.isid == 'SRVP') {
                that.$router.push({ name: 'engineer' });
              } else {
                that.$vux.alert.show({
                  title: '',
                  content: '您的身份不符合该功能'
                });
              }
            }).catch(function (error) {
              if (error.response) {
                if (error.response.data) {
                  that.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                }
              }
            });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        } else {
          localStorage.setItem('repair', 'engineer');
          that.$router.push({ name: 'login' });
        }
      }).catch(function (error) {
        console.log(error.response);
        if (error.response) {
          if (error.response.data) {
            that.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          }
        }
      });
    },
    solution_logs: function solution_logs() {
      var _this2 = this;

      this.$http.get('api/v1/wechat/' + localStorage.getItem('unionid')).then(function (res) {
        var len = res.data.length;
        if (len) {
          _this2.$router.push({ name: 'solution_logs', params: { role: 'EXPT' } });
        } else {
          localStorage.setItem('repair', 'solution_logs');
          localStorage.setItem('repairtype', 'EXPT');
          _this2.$router.push({ name: 'login' });
        }
      });
    },
    gohome: function gohome() {
      this.$router.push({ name: 'vip' });
    },
    baoxiu: function baoxiu() {
      this.$router.push({ name: 'normalrepairs' });
    },
    equipment: function equipment() {
      var _this3 = this;

      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var that = this;
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

        if (res.data.length > 0) {
          var account = res.data[0].account;
          localStorage.setItem('account', account);

          that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };

            that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
              for (var i = 0; i < response.data.length; i++) {

                if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                  that.role = response.data[i].type;
                  break;
                }
                if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                  that.isid = response.data[i].type;
                }
              }

              if (that.role == 'INDV' || that.role == 'ENTP') {
                that.$router.push({ name: 'Devicelist' });
              } else {
                var iden;
                if (that.isid == 'EXPT') {
                  iden = '个人用户';
                }
                if (that.isid == 'SRVP') {
                  iden = '企业用户';
                }

                that.$vux.confirm.show({
                  title: '',
                  content: '您的身份不符合该功能,如需用该功能,请添加' + iden,
                  onConfirm: function onConfirm() {
                    that.$router.push({ name: 'addmyInfo' });
                  }
                });
              }
            }).catch(function (error) {
              if (error.response) {
                if (error.response.data) {
                  that.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                }
              }
            });
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        } else {
          localStorage.setItem('repair', 'Devicelist');
          _this3.$router.push({ name: 'login' });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49648956","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userhomepage.vue
var userhomepage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('div',{staticClass:"headbox"},[_c('div',{staticStyle:{"height":"44px"},on:{"click":_vm.gohome}},[_c('img',{staticStyle:{"width":"25px","height":"25px","padding":"10px"},attrs:{"src":_vm.imgUrl}})]),_vm._v(" "),_c('tab',{staticStyle:{"flex":"8"},attrs:{"line-width":2,"active-color":"#fc378c"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.list),function(item,index){return _c('tab-item',{key:index,staticClass:"vux-center",attrs:{"selected":_vm.select === item},on:{"click":function($event){_vm.select = item}}},[_vm._v(_vm._s(item)+"\n        ")])})),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 0),expression:"index === 0"}],staticClass:"tab-swiper vux-center"},[_c('cell',{attrs:{"is-link":""},nativeOn:{"click":function($event){return _vm.baoxiu($event)}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v("立即报修")])])]),_vm._v(" "),_c('cell',{attrs:{"is-link":""},nativeOn:{"click":function($event){return _vm.ordermanage($event)}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v("订单管理")])])])],1)])],1)}
var userhomepage_staticRenderFns = []
var userhomepage_esExports = { render: userhomepage_render, staticRenderFns: userhomepage_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_userhomepage = (userhomepage_esExports);
// CONCATENATED MODULE: ./src/components/userhomepage.vue
function userhomepage_injectStyle (ssrContext) {
  __webpack_require__("KU+f")
}
var userhomepage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var userhomepage___vue_template_functional__ = false
/* styles */
var userhomepage___vue_styles__ = userhomepage_injectStyle
/* scopeId */
var userhomepage___vue_scopeId__ = "data-v-49648956"
/* moduleIdentifier (server only) */
var userhomepage___vue_module_identifier__ = null
var userhomepage_Component = userhomepage_normalizeComponent(
  components_userhomepage,
  selectortype_template_index_0_src_components_userhomepage,
  userhomepage___vue_template_functional__,
  userhomepage___vue_styles__,
  userhomepage___vue_scopeId__,
  userhomepage___vue_module_identifier__
)

/* harmony default export */ var src_components_userhomepage = (userhomepage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/solution/solution_logs.vue








/* harmony default export */ var solution_logs = ({
  name: "solution_logs",
  components: { XInput: vux_src_components_x_input, Cell: vux_src_components_cell, Group: group["a" /* default */], Selector: vux_src_components_selector, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      type: '',
      value: '',
      solutionData: [],
      typeList: [{ key: 'ftype', value: '故障类型' }, { key: 'fdesc', value: '故障描述' }, { key: 'solution', value: '日志内容' }],
      header: null,
      role: this.$route.params.role | 'EXPT'
    };
  },

  methods: {
    search: function search() {
      var _this = this;

      this.$http.get('/api/v1/normalrepairs?type=' + this.type + '&value=' + this.value + '&offset=0&count=10&role=' + this.role, this.header).then(function (response) {
        if (response.data.total === 0) {
          _this.$vux.alert.show({
            title: '',
            content: '结果未找到'
          });
        } else {
          _this.solutionData = response.data.content;
        }
      });
    },
    viewSolution: function viewSolution(seq) {
      var _this2 = this;

      if (this.role === 'EXPT') {
        this.$http.get('/api/v1/normalrepairs/' + seq + '?role=EXPT&type=detail', this.header).then(function (response) {
          localStorage.setItem('order', stringify_default()(response.data.detail));
          _this2.$router.push({ name: 'makeMemo', params: { iden: 'EXPT', solutionv: 2 } });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.role === 'EXPT') {
      var unionid = localStorage.getItem('unionid');
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {
        if (res.data.length !== 0) {
          var account = res.data[0].account;
          localStorage.setItem('account', account);
          _this3.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            _this3.header = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };
          });
        }
      });
    } else {
      this.header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/solution/solution_logs.vue








/* harmony default export */ var solution_solution_logs = ({
  name: "solution_logs",
  components: { XInput: vux_src_components_x_input, Cell: vux_src_components_cell, Group: group["a" /* default */], Selector: vux_src_components_selector, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      type: '',
      value: '',
      solutionData: [],
      typeList: [{ key: 'ftype', value: '故障类型' }, { key: 'fdesc', value: '故障描述' }, { key: 'solution', value: '日志内容' }],
      header: null,
      role: this.$route.params.role | 'EXPT'
    };
  },

  methods: {
    search: function search() {
      var _this = this;

      this.$http.get('/api/v1/normalrepairs?type=' + this.type + '&value=' + this.value + '&offset=0&count=10&role=' + this.role, this.header).then(function (response) {
        if (response.data.total === 0) {
          _this.$vux.alert.show({
            title: '',
            content: '结果未找到'
          });
        } else {
          _this.solutionData = response.data.content;
        }
      });
    },
    viewSolution: function viewSolution(seq) {
      var _this2 = this;

      if (this.role === 'EXPT') {
        this.$http.get('/api/v1/normalrepairs/' + seq + '?role=EXPT&type=detail', this.header).then(function (response) {
          localStorage.setItem('order', stringify_default()(response.data.detail));
          _this2.$router.push({ name: 'makeMemo', params: { iden: 'EXPT', solutionv: 2 } });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    if (this.role === 'EXPT') {
      var unionid = localStorage.getItem('unionid');
      this.$http.get('api/v1/wechat/' + unionid).then(function (res) {
        if (res.data.length !== 0) {
          var account = res.data[0].account;
          localStorage.setItem('account', account);
          _this3.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            _this3.header = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };
          });
        }
      });
    } else {
      this.header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a41524","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/solution/solution_logs.vue
var solution_logs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('selector',{attrs:{"title":"查询类型","options":_vm.typeList},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"查询内容"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('x-button',{nativeOn:{"click":function($event){return _vm.search($event)}}},[_vm._v("查询")]),_vm._v(" "),_vm._l((_vm.solutionData),function(item,index){return _c('cell',{key:index,attrs:{"title":item.seq,"is-link":""},nativeOn:{"click":function($event){_vm.viewSolution(item.seq)}}})})],2)}
var solution_logs_staticRenderFns = []
var solution_logs_esExports = { render: solution_logs_render, staticRenderFns: solution_logs_staticRenderFns }
/* harmony default export */ var components_solution_solution_logs = (solution_logs_esExports);
// CONCATENATED MODULE: ./src/components/solution/solution_logs.vue
function solution_logs_injectStyle (ssrContext) {
  __webpack_require__("NBdk")
}
var solution_logs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var solution_logs___vue_template_functional__ = false
/* styles */
var solution_logs___vue_styles__ = solution_logs_injectStyle
/* scopeId */
var solution_logs___vue_scopeId__ = "data-v-26a41524"
/* moduleIdentifier (server only) */
var solution_logs___vue_module_identifier__ = null
var solution_logs_Component = solution_logs_normalizeComponent(
  solution_solution_logs,
  components_solution_solution_logs,
  solution_logs___vue_template_functional__,
  solution_logs___vue_styles__,
  solution_logs___vue_scopeId__,
  solution_logs___vue_module_identifier__
)

/* harmony default export */ var src_components_solution_solution_logs = (solution_logs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/photo.vue
















/* harmony default export */ var components_photo = ({
  data: function data() {
    return {
      devseq: "",
      devname: "",
      devmodel: '',
      producer: '',
      buyfrom: "",
      company: '',
      ftype: '',
      name: '',
      mobile: '',
      fdesc: "",
      imgList: [],
      size: 0,
      starttime: '',
      endtime: '',
      photo: { 'path': '', 'serverid': '' },
      account: '',
      username: '',
      sequence: '',

      title: '默认为空',
      value_0_1: [],
      value: [],
      title2: '设置值',
      value2: ['天津市', '市辖区', '和平区'],
      value3: ['广东省', '中山市', '--'],
      addressData: china_address_v4_default.a,
      value4: [],
      value5: ['广东省', '深圳 市', '南山区'],
      showAddress: false,
      address: [],
      address2: '',
      obj: {},
      list: [],
      num: 6,
      show: true,
      newobj: {
        photo: []
      },
      index: 0,
      flag: true,
      repair: this.$route.params.repair
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Alert: components_alert["a" /* default */],
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button
  },
  methods: {
    fileDel: function fileDel(val, key) {
      var index;
      for (var j = 0; j < this.imgList.length; j++) {
        if (this.imgList[j].path == key) {
          this.imgList.splice(j, 1);
        }
      }

      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i] == key) {
          index = i;
          this.list.splice(i, 1);
          this.num++;
          this.index--;
        }
      }
      this.newobj.photo.splice(index, 1);
      if (this.num < 6) {
        this.show = true;
      }
    },
    confirm: function confirm() {
      var obj = {
        path: this.list
      };
      var list = [];
      list.push(obj);
      this.obj.fdetail = list;
      this.$router.push({ name: 'faultType', params: { obj: this.obj, repair: this.repair } });
    },
    upload: function upload() {
      var _this = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: this.num, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          var localIds = res.localIds;
          var i = 0;
          length = localIds.length;
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {

                _this.$vux.loading.show({
                  text: 'Loading'
                });
                _this.flag = false;
                if (!_this.list || _this.list.length === 0) {
                  _this.newobj.photo.push(res.serverId);
                } else {
                  obj.photo.push(res.serverId);
                }
                i++;
                _this.num--;
                if (i < length) {
                  upload();
                } else {
                  if (!_this.list || _this.list.length === 0) {
                    _this.submitImage(_this.newobj);
                  } else {
                    _this.submitImage(obj);
                  }
                }
              },
              fail: function fail(error) {
                console.log(error);
              }
            });
          };
          upload();
        },
        fail: function fail(error) {
          console.log(error);
        }
      });
    },
    submitImage: function submitImage(userInfo) {
      var _this2 = this;

      ajax["a" /* default */].$http.post('/api/v1/photos/wechat', userInfo).then(function (response) {
        _this2.flag = true;
        _this2.list = [].concat(toConsumableArray_default()(_this2.list), toConsumableArray_default()(response.data));
        _this2.decrypt();
        /*
        if (this.list.length === 0) {
        response.data.forEach(item => {
        this.list.push(item.thumb.toString())
        })
        this.decrypt()
        } else {
        for (let i = 0; i < response.data.length; i++) {
        this.list.push(response.data[i].thumb.toString())
        }
        this.decrypt()
        }
        */
        if (_this2.list.length === 6) {
          _this2.show = false;
        }
      }).catch(function (error) {
        _this2.flag = true;
        alert(error);
        if (error.response) {
          if (error.response.data.error_message) {
            _this2.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          } else {
            _this2.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          }
        } else {
          _this2.$vux.toast.show({
            text: '服务器错误，请稍后重试',
            type: 'cancel',
            time: '1000'
          });
        }
      });
    },
    decrypt: function decrypt() {
      var _this3 = this;

      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var that = this;
      ajax["a" /* default */].$http.get('api/v1/photos?path=' + this.list[this.index]['thumb']).then(function (res) {
        that.imgList.push(res.data);
        that.index++;
        _this3.$vux.loading.hide();
        if (that.index < that.list.length) {
          that.decrypt();
        }
      });
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this4;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'faultType') {
      next(function (vm) {
        var arr = [];
        var brr = [];
        var index = 0;
        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        vm.obj = vm.$route.params.obj;
        var length = vm.$route.params.obj.fdetail.length;
        if (length > 0) {
          arr = vm.$route.params.obj.fdetail[0].path;
          if (arr.length == 6) {
            vm.show = false;
          }
          vm.index = arr.length;
          vm.num = 6 - arr.length;

          vm.list = arr;
          var decrypt = function decrypt() {
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + arr[index]).then(function (res) {
              brr.push(res.data);
              index++;
              if (index < arr.length) {
                decrypt();
              }
            });
          };
          decrypt();
          vm.imgList = brr;
        }

        console.log(vm.obj);
      });
    } else {
      next(function (vm) {
        var obj = localStorage.getItem('obj');
        vm.obj = JSON.parse(obj);
        console.log(vm.obj);
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'faultType') {
      to.params.repair = this.repair;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/photo.vue
















/* harmony default export */ var selectortype_script_index_0_src_components_photo = ({
  data: function data() {
    return {
      devseq: "",
      devname: "",
      devmodel: '',
      producer: '',
      buyfrom: "",
      company: '',
      ftype: '',
      name: '',
      mobile: '',
      fdesc: "",
      imgList: [],
      size: 0,
      starttime: '',
      endtime: '',
      photo: { 'path': '', 'serverid': '' },
      account: '',
      username: '',
      sequence: '',

      title: '默认为空',
      value_0_1: [],
      value: [],
      title2: '设置值',
      value2: ['天津市', '市辖区', '和平区'],
      value3: ['广东省', '中山市', '--'],
      addressData: china_address_v4_default.a,
      value4: [],
      value5: ['广东省', '深圳 市', '南山区'],
      showAddress: false,
      address: [],
      address2: '',
      obj: {},
      list: [],
      num: 6,
      show: true,
      newobj: {
        photo: []
      },
      index: 0,
      flag: true,
      repair: this.$route.params.repair
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Alert: components_alert["a" /* default */],
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button
  },
  methods: {
    fileDel: function fileDel(val, key) {
      var index;
      for (var j = 0; j < this.imgList.length; j++) {
        if (this.imgList[j].path == key) {
          this.imgList.splice(j, 1);
        }
      }

      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i] == key) {
          index = i;
          this.list.splice(i, 1);
          this.num++;
          this.index--;
        }
      }
      this.newobj.photo.splice(index, 1);
      if (this.num < 6) {
        this.show = true;
      }
    },
    confirm: function confirm() {
      var obj = {
        path: this.list
      };
      var list = [];
      list.push(obj);
      this.obj.fdetail = list;
      this.$router.push({ name: 'faultType', params: { obj: this.obj, repair: this.repair } });
    },
    upload: function upload() {
      var _this = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: this.num, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          var localIds = res.localIds;
          var i = 0;
          length = localIds.length;
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {

                _this.$vux.loading.show({
                  text: 'Loading'
                });
                _this.flag = false;
                if (!_this.list || _this.list.length === 0) {
                  _this.newobj.photo.push(res.serverId);
                } else {
                  obj.photo.push(res.serverId);
                }
                i++;
                _this.num--;
                if (i < length) {
                  upload();
                } else {
                  if (!_this.list || _this.list.length === 0) {
                    _this.submitImage(_this.newobj);
                  } else {
                    _this.submitImage(obj);
                  }
                }
              },
              fail: function fail(error) {
                console.log(error);
              }
            });
          };
          upload();
        },
        fail: function fail(error) {
          console.log(error);
        }
      });
    },
    submitImage: function submitImage(userInfo) {
      var _this2 = this;

      ajax["a" /* default */].$http.post('/api/v1/photos/wechat', userInfo).then(function (response) {
        _this2.flag = true;
        _this2.list = [].concat(toConsumableArray_default()(_this2.list), toConsumableArray_default()(response.data));
        _this2.decrypt();
        /*
        if (this.list.length === 0) {
        response.data.forEach(item => {
        this.list.push(item.thumb.toString())
        })
        this.decrypt()
        } else {
        for (let i = 0; i < response.data.length; i++) {
        this.list.push(response.data[i].thumb.toString())
        }
        this.decrypt()
        }
        */
        if (_this2.list.length === 6) {
          _this2.show = false;
        }
      }).catch(function (error) {
        _this2.flag = true;
        alert(error);
        if (error.response) {
          if (error.response.data.error_message) {
            _this2.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          } else {
            _this2.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          }
        } else {
          _this2.$vux.toast.show({
            text: '服务器错误，请稍后重试',
            type: 'cancel',
            time: '1000'
          });
        }
      });
    },
    decrypt: function decrypt() {
      var _this3 = this;

      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var that = this;
      ajax["a" /* default */].$http.get('api/v1/photos?path=' + this.list[this.index]['thumb']).then(function (res) {
        that.imgList.push(res.data);
        that.index++;
        _this3.$vux.loading.hide();
        if (that.index < that.list.length) {
          that.decrypt();
        }
      });
    }
  },

  mounted: function mounted() {
    var _this4 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this4;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'faultType') {
      next(function (vm) {
        var arr = [];
        var brr = [];
        var index = 0;
        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        vm.obj = vm.$route.params.obj;
        var length = vm.$route.params.obj.fdetail.length;
        if (length > 0) {
          arr = vm.$route.params.obj.fdetail[0].path;
          if (arr.length == 6) {
            vm.show = false;
          }
          vm.index = arr.length;
          vm.num = 6 - arr.length;

          vm.list = arr;
          var decrypt = function decrypt() {
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + arr[index]).then(function (res) {
              brr.push(res.data);
              index++;
              if (index < arr.length) {
                decrypt();
              }
            });
          };
          decrypt();
          vm.imgList = brr;
        }

        console.log(vm.obj);
      });
    } else {
      next(function (vm) {
        var obj = localStorage.getItem('obj');
        vm.obj = JSON.parse(obj);
        console.log(vm.obj);
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'faultType') {
      to.params.repair = this.repair;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7291a7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/photo.vue
var photo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"upload_warp_img"},[_vm._l((_vm.imgList),function(val,index){return _c('div',{key:index,staticClass:"upload_warp_img_div"},[_c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"width":"100px","height":"75px"},attrs:{"src":'data:image/jpeg;base64,'+val.value}})]),_vm._v(" "),_c('div',{staticClass:"upload_warp_img_div_top"},[_c('span',{staticClass:"upload_warp_img_div_del",on:{"click":function($event){_vm.fileDel(val.value,val.path)}}},[_vm._v("×")])])])}),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"upload_warp"},[_c('div',{staticClass:"upload_warp_left",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.flag&&_vm.upload()}}},[_c('div',{staticClass:"icon-add-50"})])]):_vm._e()],2),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定")])],1)}
var photo_staticRenderFns = []
var photo_esExports = { render: photo_render, staticRenderFns: photo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_photo = (photo_esExports);
// CONCATENATED MODULE: ./src/components/photo.vue
function photo_injectStyle (ssrContext) {
  __webpack_require__("IXTg")
}
var photo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var photo___vue_template_functional__ = false
/* styles */
var photo___vue_styles__ = photo_injectStyle
/* scopeId */
var photo___vue_scopeId__ = "data-v-b7291a7c"
/* moduleIdentifier (server only) */
var photo___vue_module_identifier__ = null
var photo_Component = photo_normalizeComponent(
  selectortype_script_index_0_src_components_photo,
  selectortype_template_index_0_src_components_photo,
  photo___vue_template_functional__,
  photo___vue_styles__,
  photo___vue_scopeId__,
  photo___vue_module_identifier__
)

/* harmony default export */ var src_components_photo = (photo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/engineer.vue








/* harmony default export */ var engineer = ({
  components: {
    Group: group["a" /* default */],
    Tab: src_components_tab_tab,
    Cell: vux_src_components_cell,
    TabItem: src_components_tab_tab_item,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      select: '',
      list: ['未完成', '已完成'],
      index: 0,
      orders_closed: [],
      orders_unclosed: [],
      role: '',
      isid: '',
      loadmoreone: '加载更多',
      loadmoretwo: '加载更多',
      show: false,
      hide: false,
      isDisabled: false
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      var offset;
      var closed;
      var app = this;
      this.isDisabled = true;
      if (this.index === 1) {
        offset = this.orders_closed.length;
        closed = true;
      } else {
        offset = this.orders_unclosed.length;
        closed = false;
      }

      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');

      var obj = {
        headers: {
          token: token,
          opid: opid
        }
      };

      ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + this.role + '&offset=' + offset + '&count=10&closed=' + closed, obj).then(function (response) {
        app.isDisabled = false;
        if (app.index === 1) {
          app.loadmoretwo = '加载中';
          if (response.data.content.length > 0) {
            app.loadmoretwo = '加载更多';
          } else {
            app.hide = false;
          }
        } else {
          app.loadmoreone = '加载中';
          if (response.data.content.length > 0) {
            app.loadmoreone = '加载更多';
          } else {
            app.show = false;
          }
        }
        var orders = [];
        orders = response.data.content;
        for (var i = 0; i < orders.length; i++) {
          if (app.index === 0) {
            switch (orders[i]['state']) {
              case 'WAIT':
                orders[i]['state'] = '待处理';
                break;
              case 'PROCESS':
                orders[i]['state'] = '处理中';
                break;
              case 'FAIL':
                orders[i]['state'] = '处理失败,待审核';
                break;
              case 'SUCCESS':
                orders[i]['state'] = '处理成功,待审核';
                break;
              default:
                break;
            }

            switch (orders[i]['canstate']) {
              case 'REQUEST':
                orders[i]['state'] = '用户取消,待确认';
                break;
            }
          }
          if (app.index === 1) {
            switch (orders[i]['state']) {
              case 'WAIT':
                orders[i]['state'] = '待处理';
                break;
              case 'PROCESS':
                orders[i]['state'] = '处理中';
                break;
              case 'FAIL':
                orders[i]['state'] = '处理失败';
                break;
              case 'SUCCESS':
                orders[i]['state'] = '处理成功';
                break;
              default:
                break;
            }
          }
          if (app.index === 1) {
            app.orders_closed.push(orders[i]);
          } else {
            app.orders_unclosed.push(orders[i]);
          }
        }
      }).catch(function (err) {
        that.isDisabled = false;
      });
    }
  },
  created: function created() {
    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    var that = this;
    var app = this;
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      if (res.data.length !== 0) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };
          that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {

              if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                that.role = response.data[i].type;
                break;
              }
              if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                that.isid = response.data[i].type;
              }
            }

            if (that.role == 'EXPT' || that.role == 'SRVP') {

              ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + app.role + '&offset=0&count=10&closed=true', obj).then(function (response) {

                app.orders_closed = response.data.content;
                if (response.data.total > 10) {
                  app.hide = true;
                }
                for (var i = 0; i < app.orders_closed.length; i++) {
                  switch (app.orders_closed[i]['state']) {
                    case 'WAIT':
                      app.orders_closed[i]['state'] = '待处理';
                      break;
                    case 'PROCESS':
                      app.orders_closed[i]['state'] = '处理中';
                      break;
                    case 'FAIL':
                      app.orders_closed[i]['state'] = '处理失败';
                      break;
                    case 'SUCCESS':
                      app.orders_closed[i]['state'] = '处理成功';
                      break;
                    default:
                      break;
                  }
                }
              });

              ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + app.role + '&offset=0&count=10&closed=false', obj).then(function (response) {

                app.orders_unclosed = response.data.content;
                if (response.data.total > 10) {
                  app.show = true;
                }
                for (var i = 0; i < app.orders_unclosed.length; i++) {
                  switch (app.orders_unclosed[i]['state']) {
                    case 'WAIT':
                      app.orders_unclosed[i]['state'] = '待处理';
                      break;
                    case 'PROCESS':
                      app.orders_unclosed[i]['state'] = '处理中';
                      break;
                    case 'FAIL':
                      app.orders_unclosed[i]['state'] = '处理失败,待审核';
                      break;
                    case 'SUCCESS':
                      app.orders_unclosed[i]['state'] = '处理成功,待审核';
                      break;
                    default:
                      break;
                  }
                  switch (app.orders_unclosed[i]['canstate']) {
                    case 'REQUEST':
                      app.orders_unclosed[i]['state'] = '用户取消,待确认';
                      break;
                  }
                }
              });
            } else {
              var iden;
              if (that.isid == 'INDV') {
                iden = '个人专家';
              }

              that.$vux.confirm.show({
                title: '',
                content: '您的身份不符合该功能,如需用该功能,请添加' + iden,
                onConfirm: function onConfirm() {
                  that.$router.push({ name: 'addexpertInfo' });
                },
                onCancel: function onCancel() {
                  WeixinJSBridge.call('closeWindow');
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      } else {
        localStorage.setItem('repair', 'engineer');
        that.$router.push({ name: 'login' });
      }
    }).catch(function (error) {
      console.log(error.response);
      if (error.response) {
        if (error.response.data) {
          that.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'records') {
      next();
    } else {
      localStorage.removeItem('order');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/engineer.vue








/* harmony default export */ var components_engineer = ({
  components: {
    Group: group["a" /* default */],
    Tab: src_components_tab_tab,
    Cell: vux_src_components_cell,
    TabItem: src_components_tab_tab_item,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      select: '',
      list: ['未完成', '已完成'],
      index: 0,
      orders_closed: [],
      orders_unclosed: [],
      role: '',
      isid: '',
      loadmoreone: '加载更多',
      loadmoretwo: '加载更多',
      show: false,
      hide: false,
      isDisabled: false
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      var offset;
      var closed;
      var app = this;
      this.isDisabled = true;
      if (this.index === 1) {
        offset = this.orders_closed.length;
        closed = true;
      } else {
        offset = this.orders_unclosed.length;
        closed = false;
      }

      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');

      var obj = {
        headers: {
          token: token,
          opid: opid
        }
      };

      ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + this.role + '&offset=' + offset + '&count=10&closed=' + closed, obj).then(function (response) {
        app.isDisabled = false;
        if (app.index === 1) {
          app.loadmoretwo = '加载中';
          if (response.data.content.length > 0) {
            app.loadmoretwo = '加载更多';
          } else {
            app.hide = false;
          }
        } else {
          app.loadmoreone = '加载中';
          if (response.data.content.length > 0) {
            app.loadmoreone = '加载更多';
          } else {
            app.show = false;
          }
        }
        var orders = [];
        orders = response.data.content;
        for (var i = 0; i < orders.length; i++) {
          if (app.index === 0) {
            switch (orders[i]['state']) {
              case 'WAIT':
                orders[i]['state'] = '待处理';
                break;
              case 'PROCESS':
                orders[i]['state'] = '处理中';
                break;
              case 'FAIL':
                orders[i]['state'] = '处理失败,待审核';
                break;
              case 'SUCCESS':
                orders[i]['state'] = '处理成功,待审核';
                break;
              default:
                break;
            }

            switch (orders[i]['canstate']) {
              case 'REQUEST':
                orders[i]['state'] = '用户取消,待确认';
                break;
            }
          }
          if (app.index === 1) {
            switch (orders[i]['state']) {
              case 'WAIT':
                orders[i]['state'] = '待处理';
                break;
              case 'PROCESS':
                orders[i]['state'] = '处理中';
                break;
              case 'FAIL':
                orders[i]['state'] = '处理失败';
                break;
              case 'SUCCESS':
                orders[i]['state'] = '处理成功';
                break;
              default:
                break;
            }
          }
          if (app.index === 1) {
            app.orders_closed.push(orders[i]);
          } else {
            app.orders_unclosed.push(orders[i]);
          }
        }
      }).catch(function (err) {
        that.isDisabled = false;
      });
    }
  },
  created: function created() {
    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    var that = this;
    var app = this;
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      if (res.data.length !== 0) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        that.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };
          that.$http.get('api/v1/accounts/' + res.data.userid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {

              if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
                that.role = response.data[i].type;
                break;
              }
              if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                that.isid = response.data[i].type;
              }
            }

            if (that.role == 'EXPT' || that.role == 'SRVP') {

              ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + app.role + '&offset=0&count=10&closed=true', obj).then(function (response) {

                app.orders_closed = response.data.content;
                if (response.data.total > 10) {
                  app.hide = true;
                }
                for (var i = 0; i < app.orders_closed.length; i++) {
                  switch (app.orders_closed[i]['state']) {
                    case 'WAIT':
                      app.orders_closed[i]['state'] = '待处理';
                      break;
                    case 'PROCESS':
                      app.orders_closed[i]['state'] = '处理中';
                      break;
                    case 'FAIL':
                      app.orders_closed[i]['state'] = '处理失败';
                      break;
                    case 'SUCCESS':
                      app.orders_closed[i]['state'] = '处理成功';
                      break;
                    default:
                      break;
                  }
                }
              });

              ajax["a" /* default */].$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + app.role + '&offset=0&count=10&closed=false', obj).then(function (response) {

                app.orders_unclosed = response.data.content;
                if (response.data.total > 10) {
                  app.show = true;
                }
                for (var i = 0; i < app.orders_unclosed.length; i++) {
                  switch (app.orders_unclosed[i]['state']) {
                    case 'WAIT':
                      app.orders_unclosed[i]['state'] = '待处理';
                      break;
                    case 'PROCESS':
                      app.orders_unclosed[i]['state'] = '处理中';
                      break;
                    case 'FAIL':
                      app.orders_unclosed[i]['state'] = '处理失败,待审核';
                      break;
                    case 'SUCCESS':
                      app.orders_unclosed[i]['state'] = '处理成功,待审核';
                      break;
                    default:
                      break;
                  }
                  switch (app.orders_unclosed[i]['canstate']) {
                    case 'REQUEST':
                      app.orders_unclosed[i]['state'] = '用户取消,待确认';
                      break;
                  }
                }
              });
            } else {
              var iden;
              if (that.isid == 'INDV') {
                iden = '个人专家';
              }

              that.$vux.confirm.show({
                title: '',
                content: '您的身份不符合该功能,如需用该功能,请添加' + iden,
                onConfirm: function onConfirm() {
                  that.$router.push({ name: 'addexpertInfo' });
                },
                onCancel: function onCancel() {
                  WeixinJSBridge.call('closeWindow');
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                that.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      } else {
        localStorage.setItem('repair', 'engineer');
        that.$router.push({ name: 'login' });
      }
    }).catch(function (error) {
      console.log(error.response);
      if (error.response) {
        if (error.response.data) {
          that.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'records') {
      next();
    } else {
      localStorage.removeItem('order');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e74e2c8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/engineer.vue
var engineer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('tab',{attrs:{"line-width":2,"active-color":"#fc378c"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.list),function(item,index){return _c('tab-item',{key:index,staticClass:"vux-center",attrs:{"selected":_vm.select === item},on:{"click":function($event){_vm.select = item}}},[_vm._v(_vm._s(item)+"\n            ")])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 1),expression:"index === 1"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.orders_closed),function(order,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'detaillist', params: { order: order,index:1}}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.devname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.start))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.state))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.end))])])])}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v("\n                "+_vm._s(_vm.loadmoretwo)+"\n            ")])],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 0),expression:"index === 0"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.orders_unclosed),function(order,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'records', query: { seq: order.seq }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.devname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.start))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.state))])])])}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v("\n                "+_vm._s(_vm.loadmoreone)+"\n            ")])],2)],1)],1)}
var engineer_staticRenderFns = []
var engineer_esExports = { render: engineer_render, staticRenderFns: engineer_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_engineer = (engineer_esExports);
// CONCATENATED MODULE: ./src/components/engineer.vue
var engineer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var engineer___vue_template_functional__ = false
/* styles */
var engineer___vue_styles__ = null
/* scopeId */
var engineer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var engineer___vue_module_identifier__ = null
var engineer_Component = engineer_normalizeComponent(
  components_engineer,
  selectortype_template_index_0_src_components_engineer,
  engineer___vue_template_functional__,
  engineer___vue_styles__,
  engineer___vue_scopeId__,
  engineer___vue_module_identifier__
)

/* harmony default export */ var src_components_engineer = (engineer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addmyInfo.vue














/* harmony default export */ var addmyInfo = ({
  components: {
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    CheckIcon: vux_src_components_check_icon,
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    XAddress: vux_src_components_x_address,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      issue: false,
      invoiceType: 1,
      invoiceTitle: 2,
      invoice: {
        company: "",
        taxNumber: "",
        bank: "",
        bankAccount: "",
        address: "",
        tel: ""
      },
      type: "",
      name: "",
      idcard: "",
      mobile: "",
      ename: "",
      emobile: "",
      etelephone: "",
      email: '',
      address1: [],
      address2: "",
      zipcode: "",

      addressData: china_address_v4_default.a,
      eduList: [{ key: "是", value: "是" }, { key: "否", value: "否" }],
      company: ''
    };
  },

  methods: {
    save: function save() {
      if (!this.company) {
        this.$vux.alert.show({
          title: "",
          content: "请填写工作单位"
        });
        return;
      }
      if (this.ename != "" && this.emobile != "") {
        var invoiceAll = {};
        if (this.issue) {
          if (this.invoiceType == 1) {
            this.invoice.bank = "";
            this.invoice.bankAccount = "";
            this.invoice.address = "";
            this.invoice.tel = "";
            this.type = "ValueAddedTaxInvoiceUnit";
            if (this.invoiceTitle == 1) {
              this.invoice.company = "";
              this.invoice.taxNumber = "";
              this.type = "ValueAddedTaxInvoiceOne";
            }
          } else {
            this.type = "VatSpecialInvoice";
          }
          invoiceAll = {
            "content": this.invoice,
            "type": this.type
          };
        } else {
          invoiceAll = {
            "content": null,
            "type": ''
          };
        }
        if (this.address1.length !== 3 || !this.address2) {
          alert('请填写通讯地址');
          return;
        }
        var address = Object(value2name["a" /* default */])(this.address1, china_address_v4_default.a);
        address = address.split(' ');
        var obj = {

          name: this.name,
          idcard: this.idcard,
          mobile: this.mobile,
          ename: this.ename,
          emobile: this.emobile,
          etelephone: this.etelephone,
          province: address[0],
          city: address[1],
          district: address[2],
          daddress: this.address2,
          zipcode: this.zipcode,
          email: this.email,
          invoice: invoiceAll,
          company: this.company,
          sequence: 0
        };
        var opid = localStorage.getItem("userid");
        var head = {
          headers: {
            token: localStorage.getItem("token"),
            opid: opid
          }
        };
        var that = this;
        this.$http.post("/api/v1/users/" + opid, obj, head).then(function (res) {
          that.$router.push({ name: "vip" });
        }).catch(function (error) {
          that.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: "cancel",
            time: "1000"
          });
        });
      } else {
        this.$vux.alert.show({
          title: "",
          content: "输入信息不完整，请补全后再提交"
        });
      }
    }
  },
  created: function created() {
    var _this = this;

    var opid = localStorage.getItem("userid");
    var obj = {
      headers: {
        token: localStorage.getItem("token"),
        opid: opid
      }
    };
    this.$http.get("/api/v1/experts/" + opid, obj).then(function (res) {
      _this.name = res.data.detail.name;
      _this.idcard = res.data.detail.idcard;
      _this.mobile = res.data.detail.mobile;
      _this.ename = res.data.detail.ename;
      _this.emobile = res.data.detail.emobile;
      _this.email = res.data.detail.email;
      _this.company = res.data.detail.company;
      _this.address1 = [res.data.detail.province, res.data.detail.city, res.data.detail.district];
      _this.address2 = res.data.detail.daddress;
    }).catch(function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addmyInfo.vue














/* harmony default export */ var components_addmyInfo = ({
  components: {
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item,
    CheckIcon: vux_src_components_check_icon,
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    XAddress: vux_src_components_x_address,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      issue: false,
      invoiceType: 1,
      invoiceTitle: 2,
      invoice: {
        company: "",
        taxNumber: "",
        bank: "",
        bankAccount: "",
        address: "",
        tel: ""
      },
      type: "",
      name: "",
      idcard: "",
      mobile: "",
      ename: "",
      emobile: "",
      etelephone: "",
      email: '',
      address1: [],
      address2: "",
      zipcode: "",

      addressData: china_address_v4_default.a,
      eduList: [{ key: "是", value: "是" }, { key: "否", value: "否" }],
      company: ''
    };
  },

  methods: {
    save: function save() {
      if (!this.company) {
        this.$vux.alert.show({
          title: "",
          content: "请填写工作单位"
        });
        return;
      }
      if (this.ename != "" && this.emobile != "") {
        var invoiceAll = {};
        if (this.issue) {
          if (this.invoiceType == 1) {
            this.invoice.bank = "";
            this.invoice.bankAccount = "";
            this.invoice.address = "";
            this.invoice.tel = "";
            this.type = "ValueAddedTaxInvoiceUnit";
            if (this.invoiceTitle == 1) {
              this.invoice.company = "";
              this.invoice.taxNumber = "";
              this.type = "ValueAddedTaxInvoiceOne";
            }
          } else {
            this.type = "VatSpecialInvoice";
          }
          invoiceAll = {
            "content": this.invoice,
            "type": this.type
          };
        } else {
          invoiceAll = {
            "content": null,
            "type": ''
          };
        }
        if (this.address1.length !== 3 || !this.address2) {
          alert('请填写通讯地址');
          return;
        }
        var address = Object(value2name["a" /* default */])(this.address1, china_address_v4_default.a);
        address = address.split(' ');
        var obj = {

          name: this.name,
          idcard: this.idcard,
          mobile: this.mobile,
          ename: this.ename,
          emobile: this.emobile,
          etelephone: this.etelephone,
          province: address[0],
          city: address[1],
          district: address[2],
          daddress: this.address2,
          zipcode: this.zipcode,
          email: this.email,
          invoice: invoiceAll,
          company: this.company,
          sequence: 0
        };
        var opid = localStorage.getItem("userid");
        var head = {
          headers: {
            token: localStorage.getItem("token"),
            opid: opid
          }
        };
        var that = this;
        this.$http.post("/api/v1/users/" + opid, obj, head).then(function (res) {
          that.$router.push({ name: "vip" });
        }).catch(function (error) {
          that.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: "cancel",
            time: "1000"
          });
        });
      } else {
        this.$vux.alert.show({
          title: "",
          content: "输入信息不完整，请补全后再提交"
        });
      }
    }
  },
  created: function created() {
    var _this = this;

    var opid = localStorage.getItem("userid");
    var obj = {
      headers: {
        token: localStorage.getItem("token"),
        opid: opid
      }
    };
    this.$http.get("/api/v1/experts/" + opid, obj).then(function (res) {
      _this.name = res.data.detail.name;
      _this.idcard = res.data.detail.idcard;
      _this.mobile = res.data.detail.mobile;
      _this.ename = res.data.detail.ename;
      _this.emobile = res.data.detail.emobile;
      _this.email = res.data.detail.email;
      _this.company = res.data.detail.company;
      _this.address1 = [res.data.detail.province, res.data.detail.city, res.data.detail.district];
      _this.address2 = res.data.detail.daddress;
    }).catch(function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50268f36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addmyInfo.vue
var addmyInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('x-header',[_vm._v("添加个人用户")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"姓名*","type":"text","readonly":"","max":16},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身份证号码*","readonly":"","max":18},model:{value:(_vm.idcard),callback:function ($$v) {_vm.idcard=$$v},expression:"idcard"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手机号码*","readonly":"","is-type":"china-mobile"},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"工作单位*","max":20},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}}),_vm._v(" "),_c('x-address',{attrs:{"title":"通讯地址*","raw-value":"","list":_vm.addressData,"value-text-align":"right","placeholder":"请选择省-市-区"},model:{value:(_vm.address1),callback:function ($$v) {_vm.address1=$$v},expression:"address1"}}),_vm._v(" "),_c('x-input',{ref:"input2",attrs:{"min":3,"type":"text","show-clear":false,"placeholder":"详细地址"},model:{value:(_vm.address2),callback:function ($$v) {_vm.address2=$$v},expression:"address2"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"邮编","type":"number","mask":"999999","show-clear":false},model:{value:(_vm.zipcode),callback:function ($$v) {_vm.zipcode=$$v},expression:"zipcode"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"邮箱"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"紧急联系人*","required":"","show-clear":false},model:{value:(_vm.ename),callback:function ($$v) {_vm.ename=$$v},expression:"ename"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"紧急联系人手机*","type":"text","is-type":"china-mobile","max":13,"required":"","show-clear":false},model:{value:(_vm.emobile),callback:function ($$v) {_vm.emobile=$$v},expression:"emobile"}}),_vm._v(" "),_c('x-input',{staticClass:"l1",attrs:{"title":"紧急联系人座机","show-clear":false},model:{value:(_vm.etelephone),callback:function ($$v) {_vm.etelephone=$$v},expression:"etelephone"}}),_vm._v(" "),_c('check-icon',{attrs:{"value":_vm.issue},on:{"update:value":function($event){_vm.issue=$event}}},[_vm._v("开具发票")]),_vm._v(" "),(_vm.issue)?_c('div',{staticStyle:{"padding":"15px"}},[_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("发票类型")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"type-check-item","selected-item-class":"check-item-selected"},model:{value:(_vm.invoiceType),callback:function ($$v) {_vm.invoiceType=$$v},expression:"invoiceType"}},[_c('checker-item',{attrs:{"value":1}},[_vm._v("增值税普通发票")]),_vm._v(" "),_c('checker-item',{attrs:{"value":2}},[_vm._v("增值税专用发票")])],1),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("发票抬头")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"title-check-item","selected-item-class":"check-item-selected"},model:{value:(_vm.invoiceTitle),callback:function ($$v) {_vm.invoiceTitle=$$v},expression:"invoiceTitle"}},[(_vm.invoiceType == 1)?_c('checker-item',{attrs:{"value":1}},[_vm._v("个人")]):_vm._e(),_vm._v(" "),_c('checker-item',{attrs:{"value":2}},[_vm._v("单位")])],1),_vm._v(" "),(_vm.invoiceTitle == 2)?_c('group',[_c('x-input',{attrs:{"title":"单位名称","type":"text","required":""},model:{value:(_vm.invoice.company),callback:function ($$v) {_vm.$set(_vm.invoice, "company", $$v)},expression:"invoice.company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"纳税人识别号","type":"text","required":""},model:{value:(_vm.invoice.taxNumber),callback:function ($$v) {_vm.$set(_vm.invoice, "taxNumber", $$v)},expression:"invoice.taxNumber"}}),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"开户银行","type":"text","required":""},model:{value:(_vm.invoice.bank),callback:function ($$v) {_vm.$set(_vm.invoice, "bank", $$v)},expression:"invoice.bank"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"账号","type":"number","required":""},model:{value:(_vm.invoice.bankAccount),callback:function ($$v) {_vm.$set(_vm.invoice, "bankAccount", $$v)},expression:"invoice.bankAccount"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"地址","type":"text","required":""},model:{value:(_vm.invoice.address),callback:function ($$v) {_vm.$set(_vm.invoice, "address", $$v)},expression:"invoice.address"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType == 2)?_c('x-input',{attrs:{"title":"电话","type":"tel","required":""},model:{value:(_vm.invoice.tel),callback:function ($$v) {_vm.$set(_vm.invoice, "tel", $$v)},expression:"invoice.tel"}}):_vm._e()],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("添加个人用户")])],1)}
var addmyInfo_staticRenderFns = []
var addmyInfo_esExports = { render: addmyInfo_render, staticRenderFns: addmyInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_addmyInfo = (addmyInfo_esExports);
// CONCATENATED MODULE: ./src/components/addmyInfo.vue
function addmyInfo_injectStyle (ssrContext) {
  __webpack_require__("msxG")
}
var addmyInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addmyInfo___vue_template_functional__ = false
/* styles */
var addmyInfo___vue_styles__ = addmyInfo_injectStyle
/* scopeId */
var addmyInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addmyInfo___vue_module_identifier__ = null
var addmyInfo_Component = addmyInfo_normalizeComponent(
  components_addmyInfo,
  selectortype_template_index_0_src_components_addmyInfo,
  addmyInfo___vue_template_functional__,
  addmyInfo___vue_styles__,
  addmyInfo___vue_scopeId__,
  addmyInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_addmyInfo = (addmyInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/detaillist.vue












/* harmony default export */ var detaillist = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Previewer: vux_src_components_previewer,
    XTextarea: vux_src_components_x_textarea
  },
  name: 'orderDetail',
  data: function data() {
    return {
      orderDetail: {},
      arr: [],
      fdetailList: [],
      address: '',

      flag: false,
      solutionv: 1,
      imgsrc: '',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },

  methods: {
    bxjl: function bxjl() {
      this.$router.push({ name: 'makeMemo', params: { iden: 'EXPT', solutionv: this.solutionv, isHide: true } });
    },
    userevaluation: function userevaluation() {
      this.$router.push({ name: 'userevaluation', params: { obj: this.orderDetail } });
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    logIndexChange: function logIndexChange(arg) {}
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var ind = vm.$route.params.index;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      if (ind) {
        vm.orderDetail = vm.$route.params.order;
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        vm.solutionv = vm.orderDetail.solutionv;
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        if (vm.orderDetail.rating) {
          vm.flag = true;
        }
        var arr = [],
            brr = [],
            index = 0;
        if (vm.orderDetail.fdetail.content.length > 0) {
          arr = vm.orderDetail.fdetail.content[0].path;
          var decrypt = function decrypt() {
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + arr[index]['origin'], header).then(function (res) {
              brr.push({ src: 'data:image/jpeg;base64,' + res.data.value });
              index++;
              if (index < arr.length) {
                decrypt();
              }
            });
          };
          decrypt();
          vm.arr = brr;
        }
      } else {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);

        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.rating) {
          vm.flag = true;
        }
        var arr = [],
            brr = [],
            index = 0;
        if (vm.orderDetail.fdetail.content.length > 0) {
          arr = vm.orderDetail.fdetail.content[0].path;
          var decrypt = function decrypt() {
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + arr[index]['origin'], header).then(function (res) {
              brr.push({ src: 'data:image/jpeg;base64,' + res.data.value });
              index++;
              if (index < arr.length) {
                decrypt();
              }
            });
          };
          decrypt();
          vm.arr = brr;
        }
      }

      if (vm.orderDetail.isviwo) {
        vm.orderDetail.isviwo = '是';
      } else {
        vm.orderDetail.isviwo = '否';
      }
      if (vm.orderDetail.sevenday) {
        vm.orderDetail.sevenday = '是';
      } else {
        vm.orderDetail.sevenday = '否';
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/detaillist.vue












/* harmony default export */ var components_detaillist = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Previewer: vux_src_components_previewer,
    XTextarea: vux_src_components_x_textarea
  },
  name: 'orderDetail',
  data: function data() {
    return {
      orderDetail: {},
      arr: [],
      fdetailList: [],
      address: '',

      flag: false,
      solutionv: 1,
      imgsrc: '',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      }
    };
  },

  methods: {
    bxjl: function bxjl() {
      this.$router.push({ name: 'makeMemo', params: { iden: 'EXPT', solutionv: this.solutionv, isHide: true } });
    },
    userevaluation: function userevaluation() {
      this.$router.push({ name: 'userevaluation', params: { obj: this.orderDetail } });
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    logIndexChange: function logIndexChange(arg) {}
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var ind = vm.$route.params.index;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      if (ind) {
        vm.orderDetail = vm.$route.params.order;
        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        vm.solutionv = vm.orderDetail.solutionv;
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        if (vm.orderDetail.rating) {
          vm.flag = true;
        }
        var arr = [],
            brr = [],
            index = 0;
        if (vm.orderDetail.fdetail.content.length > 0) {
          arr = vm.orderDetail.fdetail.content[0].path;
          var decrypt = function decrypt() {
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + arr[index]['origin'], header).then(function (res) {
              brr.push({ src: 'data:image/jpeg;base64,' + res.data.value });
              index++;
              if (index < arr.length) {
                decrypt();
              }
            });
          };
          decrypt();
          vm.arr = brr;
        }
      } else {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);

        vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district;
        if (vm.orderDetail.rating) {
          vm.flag = true;
        }
        var arr = [],
            brr = [],
            index = 0;
        if (vm.orderDetail.fdetail.content.length > 0) {
          arr = vm.orderDetail.fdetail.content[0].path;
          var decrypt = function decrypt() {
            ajax["a" /* default */].$http.get('api/v1/photos?path=' + arr[index]['origin'], header).then(function (res) {
              brr.push({ src: 'data:image/jpeg;base64,' + res.data.value });
              index++;
              if (index < arr.length) {
                decrypt();
              }
            });
          };
          decrypt();
          vm.arr = brr;
        }
      }

      if (vm.orderDetail.isviwo) {
        vm.orderDetail.isviwo = '是';
      } else {
        vm.orderDetail.isviwo = '否';
      }
      if (vm.orderDetail.sevenday) {
        vm.orderDetail.sevenday = '是';
      } else {
        vm.orderDetail.sevenday = '否';
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9472d114","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detaillist.vue
var detaillist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报修订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否云帷设备","type":"text","readonly":""},model:{value:(_vm.orderDetail.isviwo),callback:function ($$v) {_vm.$set(_vm.orderDetail, "isviwo", $$v)},expression:"orderDetail.isviwo"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否1次开箱","type":"text","readonly":""},model:{value:(_vm.orderDetail.sevenday),callback:function ($$v) {_vm.$set(_vm.orderDetail, "sevenday", $$v)},expression:"orderDetail.sevenday"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devseq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devseq", $$v)},expression:"orderDetail.devseq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.devname),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devname", $$v)},expression:"orderDetail.devname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备型号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devmodel),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devmodel", $$v)},expression:"orderDetail.devmodel"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备生产商","type":"text","readonly":""},model:{value:(_vm.orderDetail.producer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "producer", $$v)},expression:"orderDetail.producer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.ftype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "ftype", $$v)},expression:"orderDetail.ftype"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"故障具体描述","show-counter":false,"type":"text","autosize":"","readonly":""},model:{value:(_vm.orderDetail.fdesc),callback:function ($$v) {_vm.$set(_vm.orderDetail, "fdesc", $$v)},expression:"orderDetail.fdesc"}}),_vm._v(" "),_c('cell',{attrs:{"title":"故障图片"}},[_c('div',_vm._l((_vm.arr),function(item,index){return _c('img',{key:index,staticClass:"previewer-demo-img",staticStyle:{"height":"90px"},attrs:{"src":item.src},on:{"click":function($event){_vm.show(index)}}})}))]),_vm._v(" "),_c('x-input',{attrs:{"title":"设备何处购入","type":"text","readonly":""},model:{value:(_vm.orderDetail.buyfrom),callback:function ($$v) {_vm.$set(_vm.orderDetail, "buyfrom", $$v)},expression:"orderDetail.buyfrom"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备所在地","type":"text","readonly":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"详细地址","type":"text","readonly":""},model:{value:(_vm.orderDetail.address),callback:function ($$v) {_vm.$set(_vm.orderDetail, "address", $$v)},expression:"orderDetail.address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.reptype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "reptype", $$v)},expression:"orderDetail.reptype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.name),callback:function ($$v) {_vm.$set(_vm.orderDetail, "name", $$v)},expression:"orderDetail.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "mobile", $$v)},expression:"orderDetail.mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人公司","type":"text","readonly":""},model:{value:(_vm.orderDetail.company),callback:function ($$v) {_vm.$set(_vm.orderDetail, "company", $$v)},expression:"orderDetail.company"}}),_vm._v(" "),(_vm.orderDetail.reptype === '最终用户报修')?[_c('x-input',{attrs:{"title":"本地服务商","readonly":""},model:{value:(_vm.orderDetail.lservice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lservice", $$v)},expression:"orderDetail.lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","readonly":""},model:{value:(_vm.orderDetail.lsmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lsmobile", $$v)},expression:"orderDetail.lsmobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.reptype === '服务商代报修')?[_c('x-input',{attrs:{"title":"最终用户","readonly":""},model:{value:(_vm.orderDetail.enduser),callback:function ($$v) {_vm.$set(_vm.orderDetail, "enduser", $$v)},expression:"orderDetail.enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","readonly":""},model:{value:(_vm.orderDetail.endmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "endmobile", $$v)},expression:"orderDetail.endmobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.reptype === '其他代报修')?[_c('x-input',{attrs:{"title":"最终用户","readonly":""},model:{value:(_vm.orderDetail.enduser),callback:function ($$v) {_vm.$set(_vm.orderDetail, "enduser", $$v)},expression:"orderDetail.enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","readonly":""},model:{value:(_vm.orderDetail.endmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "endmobile", $$v)},expression:"orderDetail.endmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商","readonly":""},model:{value:(_vm.orderDetail.lservice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lservice", $$v)},expression:"orderDetail.lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","readonly":""},model:{value:(_vm.orderDetail.lsmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lsmobile", $$v)},expression:"orderDetail.lsmobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.assit)?_c('x-input',{attrs:{"title":"第三方专家姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.assit.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.assit, "name", $$v)},expression:"orderDetail.assit.name"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.assit)?_c('x-input',{attrs:{"title":"第三方专家电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.assit.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.assit, "mobile", $$v)},expression:"orderDetail.assit.mobile"}}):_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"申请开始时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.start),callback:function ($$v) {_vm.$set(_vm.orderDetail, "start", $$v)},expression:"orderDetail.start"}}),_vm._v(" "),_c('cell',{attrs:{"is-link":""},nativeOn:{"click":function($event){return _vm.bxjl($event)}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v("维修进度")])])]),_vm._v(" "),_c('cell',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}],attrs:{"title":('查看评论'),"is-link":""},nativeOn:{"click":function($event){return _vm.userevaluation($event)}}})],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.arr,"options":_vm.options},on:{"on-index-change":_vm.logIndexChange}})],1),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.$router.back(-1)}}},[_vm._v("返回")])],1)}
var detaillist_staticRenderFns = []
var detaillist_esExports = { render: detaillist_render, staticRenderFns: detaillist_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_detaillist = (detaillist_esExports);
// CONCATENATED MODULE: ./src/components/detaillist.vue
function detaillist_injectStyle (ssrContext) {
  __webpack_require__("9qti")
}
var detaillist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var detaillist___vue_template_functional__ = false
/* styles */
var detaillist___vue_styles__ = detaillist_injectStyle
/* scopeId */
var detaillist___vue_scopeId__ = "data-v-9472d114"
/* moduleIdentifier (server only) */
var detaillist___vue_module_identifier__ = null
var detaillist_Component = detaillist_normalizeComponent(
  components_detaillist,
  selectortype_template_index_0_src_components_detaillist,
  detaillist___vue_template_functional__,
  detaillist___vue_styles__,
  detaillist___vue_scopeId__,
  detaillist___vue_module_identifier__
)

/* harmony default export */ var src_components_detaillist = (detaillist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addfirmInfo.vue

















/* harmony default export */ var addfirmInfo = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    XAddress: vux_src_components_x_address,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      orgcode: "",
      company: '',
      estdate: '',
      busaddress: '',
      Staffnum: '',
      industry: '',
      legalperson: '',
      legalmobile: '',
      legalphone: '',
      actualperson: '',
      actualmobile: '',
      actualphone: '',
      yunperson: '',
      Yunmobile: '',
      yunphone: '',
      Delvaddress: '',
      invoice: {},
      execert: '',
      authcert: '',
      Name: '',
      mobile: '',
      email: '',
      Sequence: '',
      eduList: [{ key: '是', value: '是' }, { key: '否', value: '否' }]
    };
  },

  methods: {
    save: function save() {
      if (this.Name != '' && this.mobile != '' && this.email != '' && this.company != '' && this.estdate != '' && this.busaddress != '' && this.Staffnum != '' && this.legalperson != '' && this.legalmobile != '' && this.actualperson != '' && this.actualmobile != '' && this.yunperson != '' && this.Yunmobile != '' && this.Delvaddress != '' && this.invoice != '' && this.Name != '' && this.Name != '') {} else {}
    }
  },
  created: function created() {
    var account = localStorage.getItem('account');
    var that = this;
    this.$http.get('/api/v1/agencies/' + account).then(function (res) {
      that.Name = res.data.detail.name;
      that.idcard = res.data.detail.idcard;
      that.mobile = res.data.detail.mobile;
    }).catch(function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addfirmInfo.vue

















/* harmony default export */ var components_addfirmInfo = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    XAddress: vux_src_components_x_address,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      orgcode: "",
      company: '',
      estdate: '',
      busaddress: '',
      Staffnum: '',
      industry: '',
      legalperson: '',
      legalmobile: '',
      legalphone: '',
      actualperson: '',
      actualmobile: '',
      actualphone: '',
      yunperson: '',
      Yunmobile: '',
      yunphone: '',
      Delvaddress: '',
      invoice: {},
      execert: '',
      authcert: '',
      Name: '',
      mobile: '',
      email: '',
      Sequence: '',
      eduList: [{ key: '是', value: '是' }, { key: '否', value: '否' }]
    };
  },

  methods: {
    save: function save() {
      if (this.Name != '' && this.mobile != '' && this.email != '' && this.company != '' && this.estdate != '' && this.busaddress != '' && this.Staffnum != '' && this.legalperson != '' && this.legalmobile != '' && this.actualperson != '' && this.actualmobile != '' && this.yunperson != '' && this.Yunmobile != '' && this.Delvaddress != '' && this.invoice != '' && this.Name != '' && this.Name != '') {} else {}
    }
  },
  created: function created() {
    var account = localStorage.getItem('account');
    var that = this;
    this.$http.get('/api/v1/agencies/' + account).then(function (res) {
      that.Name = res.data.detail.name;
      that.idcard = res.data.detail.idcard;
      that.mobile = res.data.detail.mobile;
    }).catch(function (err) {
      console.log(err);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8e658b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addfirmInfo.vue
var addfirmInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('x-header',[_vm._v("添加企业用户")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"申请人*","type":"text","readonly":""},model:{value:(_vm.Name),callback:function ($$v) {_vm.Name=$$v},expression:"Name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请人手机*","type":"text","readonly":""},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请人email*","type":"text","readonly":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"组织机构代码","type":"text","readonly":""},model:{value:(_vm.orgcode),callback:function ($$v) {_vm.orgcode=$$v},expression:"orgcode"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"公司名*","type":"text","readonly":""},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"成立日期*","type":"text","readonly":""},model:{value:(_vm.estdate),callback:function ($$v) {_vm.estdate=$$v},expression:"estdate"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"营业地址*","type":"text","readonly":""},model:{value:(_vm.busaddress),callback:function ($$v) {_vm.busaddress=$$v},expression:"busaddress"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"员工人数*","type":"text","readonly":""},model:{value:(_vm.Staffnum),callback:function ($$v) {_vm.Staffnum=$$v},expression:"Staffnum"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"所在行业","type":"text","readonly":""},model:{value:(_vm.industry),callback:function ($$v) {_vm.industry=$$v},expression:"industry"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"法人*","type":"text","readonly":""},model:{value:(_vm.legalperson),callback:function ($$v) {_vm.legalperson=$$v},expression:"legalperson"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"法人手机*","type":"text","readonly":""},model:{value:(_vm.legalmobile),callback:function ($$v) {_vm.legalmobile=$$v},expression:"legalmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"法人座机","type":"text"},model:{value:(_vm.legalphone),callback:function ($$v) {_vm.legalphone=$$v},expression:"legalphone"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"实际负责人*","type":"text"},model:{value:(_vm.actualperson),callback:function ($$v) {_vm.actualperson=$$v},expression:"actualperson"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"实际负责人手机*","type":"text","readonly":""},model:{value:(_vm.actualmobile),callback:function ($$v) {_vm.actualmobile=$$v},expression:"actualmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"实际负责人座机","type":"text","readonly":""},model:{value:(_vm.actualphone),callback:function ($$v) {_vm.actualphone=$$v},expression:"actualphone"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"云帷负责人*","type":"text","readonly":""},model:{value:(_vm.yunperson),callback:function ($$v) {_vm.yunperson=$$v},expression:"yunperson"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"云帷负责人手机*","type":"text","readonly":""},model:{value:(_vm.Yunmobile),callback:function ($$v) {_vm.Yunmobile=$$v},expression:"Yunmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"云帷负责人座机","type":"text","readonly":""},model:{value:(_vm.yunphone),callback:function ($$v) {_vm.yunphone=$$v},expression:"yunphone"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"收货地址*","type":"text","readonly":""},model:{value:(_vm.Delvaddress),callback:function ($$v) {_vm.Delvaddress=$$v},expression:"Delvaddress"}}),_vm._v(" "),_c('selector',{attrs:{"title":"发票信息","placeholder":"是否需要发票","options":_vm.eduList},model:{value:(_vm.invoice),callback:function ($$v) {_vm.invoice=$$v},expression:"invoice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"执行书*","type":"text","readonly":""},model:{value:(_vm.execert),callback:function ($$v) {_vm.execert=$$v},expression:"execert"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"授权书*","type":"text","readonly":""},model:{value:(_vm.authcert),callback:function ($$v) {_vm.authcert=$$v},expression:"authcert"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("添加企业用户")])],1)}
var addfirmInfo_staticRenderFns = []
var addfirmInfo_esExports = { render: addfirmInfo_render, staticRenderFns: addfirmInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_addfirmInfo = (addfirmInfo_esExports);
// CONCATENATED MODULE: ./src/components/addfirmInfo.vue
var addfirmInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addfirmInfo___vue_template_functional__ = false
/* styles */
var addfirmInfo___vue_styles__ = null
/* scopeId */
var addfirmInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addfirmInfo___vue_module_identifier__ = null
var addfirmInfo_Component = addfirmInfo_normalizeComponent(
  components_addfirmInfo,
  selectortype_template_index_0_src_components_addfirmInfo,
  addfirmInfo___vue_template_functional__,
  addfirmInfo___vue_styles__,
  addfirmInfo___vue_scopeId__,
  addfirmInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_addfirmInfo = (addfirmInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/records.vue















/* harmony default export */ var records = ({
  components: {
    Selector: vux_src_components_selector,
    Confirm: components_confirm["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    Group: group["a" /* default */],
    Tab: src_components_tab_tab,
    Cell: vux_src_components_cell,
    TabItem: src_components_tab_tab_item,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      clean_reason: '',
      clean_detail: '',
      reason: [{ key: 'REJECT', value: '拒绝' }, { key: 'REGRET', value: '反悔' }, {
        key: 'UNQUAL',
        value: '不合格'
      }, { key: 'TIMEOUT', value: '超时' }, { key: 'UCANCLR', value: '用户取消' }],
      clearotherdesignateshow: false,
      roleType: '',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      list: ['详情信息', '报修记录'],
      index: 0,
      orderDetail: {},
      showLoading: false,
      isShow: false,
      imgList: [],
      filename: '',
      filepath: '',

      iden: '',
      solutionv: 1,
      isFault: false,
      istoggle: false,
      iswait: true,
      show: false,
      flag: true,
      class_a: 'active',
      task: true,
      confirmFault: '修改故障',
      isTwo: true
    };
  },

  methods: {
    desiginate: function desiginate() {
      this.$router.push({ name: 'Desiginate', query: { role: 'EXPT', seq: this.orderDetail.seq } });
    },
    downloadFile: function downloadFile() {
      this.$router.push({
        name: "Download",
        query: { path: this.filepath, suffix: this.filename }
      });
    },
    cleardesiginate: function cleardesiginate() {
      var _this = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.post('/api/v1/normalrepairs/' + this.orderDetail.seq + '/clear_assign_to_assist', {
        "reason": this.clean_reason,
        "detail": this.clean_detail,
        role: 'EXPT'
      }, header).then(function () {
        alert('清除成功');
        _this.$router.push({ name: 'engineer' });
      });
    },
    more: function more() {
      this.show = !this.show;
    },
    showx: function showx(index) {
      this.$refs.previewer.show(index);
    },
    success: function success() {
      this.$router.push({ name: 'finish', params: { obj: this.orderDetail, role: 'EXPT' } });
    },
    Confirmfault: function Confirmfault() {
      this.$router.push({ name: 'confirmfault', params: { obj: this.orderDetail } });
    },
    detail: function detail() {
      this.$router.push({ name: 'detaillist' });
    },
    assistantinfo: function assistantinfo() {
      this.$router.push({ name: 'assistantinfo', query: { seq: this.orderDetail.seq, role: 'EXPT' } });
    },
    bxjl: function bxjl() {
      if (this.isShow) {
        this.$vux.toast.show({
          text: '无权限查看报修进度信息，请先接受订单',
          type: 'cancel',
          time: '1000'
        });
      } else {
        this.$router.push({ name: 'makeMemo', params: { iden: this.iden, solutionv: this.solutionv } });
      }
    },
    agree: function agree() {
      this.showLoading = true;
      var obj = {
        role: this.iden,
        op: 'ACCEPT',
        comment: ''
      };
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      var that = this;
      this.$http.post('/api/v1/normalrepairs/' + this.orderDetail.seq + '/order', obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'engineer' });
      }).catch(function (error) {
        that.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
        this.showLoading = false;
      });
    },
    reject: function reject() {
      this.$router.push({ name: "cancel", params: { name: 'reject' } });
    },
    cancel: function cancel() {
      this.$router.push({ name: "cancel", params: { name: 'cancel' } });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var account = void 0;
      ajax["a" /* default */].$http.get('api/v1/wechat/' + unionid).then(function (res) {

        res.data.forEach(function (item) {
          if (item.role === 'EXPT') {
            account = item.account;
          }
        });
        ajax["a" /* default */].$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (response) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userid', response.data.userid);
          var userid = response.data.userid;
          var header = {
            headers: {
              token: response.data.token,
              opid: response.data.userid
            }
          };
          ajax["a" /* default */].$http.get('/api/v1/normalrepairs/' + to.query.seq + '?role=EXPT&type=detail', header).then(function (response) {
            localStorage.setItem('order', stringify_default()(response.data.detail));
            vm.orderDetail = response.data.detail;
            if (vm.orderDetail.state === 'WAIT') {
              vm.isShow = !vm.orderDetail.canstate;
            }
            if (vm.orderDetail.confirm === 'WAIT') {
              vm.iswait = false;
              vm.flag = false;
              vm.task = false;
              vm.confirmFault = '确认故障';
            }
            if (vm.orderDetail.state === "PROCESS") {
              vm.isFault = true;
            }
            if (vm.orderDetail.expert) {
              if (userid === vm.orderDetail.expert.userid) {
                vm.roleType = 'self';
                if (vm.orderDetail.exptstate === 'WAIT') {
                  vm.isShow = true;
                  vm.isFault = false;
                }
              }
            }
            if (vm.orderDetail.assit) {
              if (userid === vm.orderDetail.assit.userid) {
                vm.roleType = 'other';
                if (vm.orderDetail.assitstate === 'WAIT') {
                  vm.isShow = true;
                  vm.isFault = false;
                }
              }
            }
            switch (vm.orderDetail.assitstate) {
              case 'WAIT':
                vm.orderDetail.assitstate = '待接受';
                break;
              case 'ACCEPT':
                vm.orderDetail.assitstate = '接受';
                break;
              case 'REJECT':
                vm.orderDetail.assitstate = '拒绝';
                break;
              default:
                vm.orderDetail.assitstate = '反悔';
                break;
            }
            switch (vm.orderDetail.userconfirm) {
              case 'ACCEPT':
                vm.orderDetail.userconfirm = '接受';
                break;
              case 'REJECT':
                vm.orderDetail.userconfirm = '拒绝';
                break;
              default:
                vm.orderDetail.userconfirm = '';
                break;
            }
            vm.solutionv = vm.orderDetail.solutionv;
            vm.iden = 'EXPT';
            vm.imgList = [];

            if (vm.orderDetail.signature && vm.orderDetail.signature.content.length !== 0) {
              if (vm.orderDetail.signature.content[0].describe == "") {
                vm.orderDetail.signature.content[0].path.forEach(function (item) {
                  var path = vm.orderDetail.signature.version === '1.0' ? item : item['origin'];
                  ajax["a" /* default */].$http.get('/api/photos?path=' + path, header).then(function (paths) {
                    vm.imgList.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
                  });
                });
              } else {

                vm.filename = vm.orderDetail.signature.content[0].describe;
                vm.filepath = vm.orderDetail.signature.content[0].path[0].origin;
              }
            }
          });
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/records.vue















/* harmony default export */ var components_records = ({
  components: {
    Selector: vux_src_components_selector,
    Confirm: components_confirm["a" /* default */],
    XTextarea: vux_src_components_x_textarea,
    Group: group["a" /* default */],
    Tab: src_components_tab_tab,
    Cell: vux_src_components_cell,
    TabItem: src_components_tab_tab_item,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      clean_reason: '',
      clean_detail: '',
      reason: [{ key: 'REJECT', value: '拒绝' }, { key: 'REGRET', value: '反悔' }, {
        key: 'UNQUAL',
        value: '不合格'
      }, { key: 'TIMEOUT', value: '超时' }, { key: 'UCANCLR', value: '用户取消' }],
      clearotherdesignateshow: false,
      roleType: '',
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      list: ['详情信息', '报修记录'],
      index: 0,
      orderDetail: {},
      showLoading: false,
      isShow: false,
      imgList: [],
      filename: '',
      filepath: '',

      iden: '',
      solutionv: 1,
      isFault: false,
      istoggle: false,
      iswait: true,
      show: false,
      flag: true,
      class_a: 'active',
      task: true,
      confirmFault: '修改故障',
      isTwo: true
    };
  },

  methods: {
    desiginate: function desiginate() {
      this.$router.push({ name: 'Desiginate', query: { role: 'EXPT', seq: this.orderDetail.seq } });
    },
    downloadFile: function downloadFile() {
      this.$router.push({
        name: "Download",
        query: { path: this.filepath, suffix: this.filename }
      });
    },
    cleardesiginate: function cleardesiginate() {
      var _this = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.post('/api/v1/normalrepairs/' + this.orderDetail.seq + '/clear_assign_to_assist', {
        "reason": this.clean_reason,
        "detail": this.clean_detail,
        role: 'EXPT'
      }, header).then(function () {
        alert('清除成功');
        _this.$router.push({ name: 'engineer' });
      });
    },
    more: function more() {
      this.show = !this.show;
    },
    showx: function showx(index) {
      this.$refs.previewer.show(index);
    },
    success: function success() {
      this.$router.push({ name: 'finish', params: { obj: this.orderDetail, role: 'EXPT' } });
    },
    Confirmfault: function Confirmfault() {
      this.$router.push({ name: 'confirmfault', params: { obj: this.orderDetail } });
    },
    detail: function detail() {
      this.$router.push({ name: 'detaillist' });
    },
    assistantinfo: function assistantinfo() {
      this.$router.push({ name: 'assistantinfo', query: { seq: this.orderDetail.seq, role: 'EXPT' } });
    },
    bxjl: function bxjl() {
      if (this.isShow) {
        this.$vux.toast.show({
          text: '无权限查看报修进度信息，请先接受订单',
          type: 'cancel',
          time: '1000'
        });
      } else {
        this.$router.push({ name: 'makeMemo', params: { iden: this.iden, solutionv: this.solutionv } });
      }
    },
    agree: function agree() {
      this.showLoading = true;
      var obj = {
        role: this.iden,
        op: 'ACCEPT',
        comment: ''
      };
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      var that = this;
      this.$http.post('/api/v1/normalrepairs/' + this.orderDetail.seq + '/order', obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'engineer' });
      }).catch(function (error) {
        that.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
        this.showLoading = false;
      });
    },
    reject: function reject() {
      this.$router.push({ name: "cancel", params: { name: 'reject' } });
    },
    cancel: function cancel() {
      this.$router.push({ name: "cancel", params: { name: 'cancel' } });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      var account = void 0;
      ajax["a" /* default */].$http.get('api/v1/wechat/' + unionid).then(function (res) {

        res.data.forEach(function (item) {
          if (item.role === 'EXPT') {
            account = item.account;
          }
        });
        ajax["a" /* default */].$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (response) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userid', response.data.userid);
          var userid = response.data.userid;
          var header = {
            headers: {
              token: response.data.token,
              opid: response.data.userid
            }
          };
          ajax["a" /* default */].$http.get('/api/v1/normalrepairs/' + to.query.seq + '?role=EXPT&type=detail', header).then(function (response) {
            localStorage.setItem('order', stringify_default()(response.data.detail));
            vm.orderDetail = response.data.detail;
            if (vm.orderDetail.state === 'WAIT') {
              vm.isShow = !vm.orderDetail.canstate;
            }
            if (vm.orderDetail.confirm === 'WAIT') {
              vm.iswait = false;
              vm.flag = false;
              vm.task = false;
              vm.confirmFault = '确认故障';
            }
            if (vm.orderDetail.state === "PROCESS") {
              vm.isFault = true;
            }
            if (vm.orderDetail.expert) {
              if (userid === vm.orderDetail.expert.userid) {
                vm.roleType = 'self';
                if (vm.orderDetail.exptstate === 'WAIT') {
                  vm.isShow = true;
                  vm.isFault = false;
                }
              }
            }
            if (vm.orderDetail.assit) {
              if (userid === vm.orderDetail.assit.userid) {
                vm.roleType = 'other';
                if (vm.orderDetail.assitstate === 'WAIT') {
                  vm.isShow = true;
                  vm.isFault = false;
                }
              }
            }
            switch (vm.orderDetail.assitstate) {
              case 'WAIT':
                vm.orderDetail.assitstate = '待接受';
                break;
              case 'ACCEPT':
                vm.orderDetail.assitstate = '接受';
                break;
              case 'REJECT':
                vm.orderDetail.assitstate = '拒绝';
                break;
              default:
                vm.orderDetail.assitstate = '反悔';
                break;
            }
            switch (vm.orderDetail.userconfirm) {
              case 'ACCEPT':
                vm.orderDetail.userconfirm = '接受';
                break;
              case 'REJECT':
                vm.orderDetail.userconfirm = '拒绝';
                break;
              default:
                vm.orderDetail.userconfirm = '';
                break;
            }
            vm.solutionv = vm.orderDetail.solutionv;
            vm.iden = 'EXPT';
            vm.imgList = [];

            if (vm.orderDetail.signature && vm.orderDetail.signature.content.length !== 0) {
              if (vm.orderDetail.signature.content[0].describe == "") {
                vm.orderDetail.signature.content[0].path.forEach(function (item) {
                  var path = vm.orderDetail.signature.version === '1.0' ? item : item['origin'];
                  ajax["a" /* default */].$http.get('/api/photos?path=' + path, header).then(function (paths) {
                    vm.imgList.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
                  });
                });
              } else {

                vm.filename = vm.orderDetail.signature.content[0].describe;
                vm.filepath = vm.orderDetail.signature.content[0].path[0].origin;
              }
            }
          });
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-556a23c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/records.vue
var records_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报修订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devseq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devseq", $$v)},expression:"orderDetail.devseq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.devname),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devname", $$v)},expression:"orderDetail.devname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.ftype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "ftype", $$v)},expression:"orderDetail.ftype"}}),_vm._v(" "),(_vm.roleType === 'other')?_c('x-input',{attrs:{"title":"专家名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.expert.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.expert, "name", $$v)},expression:"orderDetail.expert.name"}}):_vm._e(),_vm._v(" "),(_vm.roleType === 'other')?_c('x-input',{attrs:{"title":"专家手机","type":"text","readonly":""},model:{value:(_vm.orderDetail.expert.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.expert, "mobile", $$v)},expression:"orderDetail.expert.mobile"}}):_vm._e(),_vm._v(" "),(_vm.roleType === 'self' && _vm.orderDetail.assit)?_c('x-input',{attrs:{"title":"第三方专家名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.assit.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.assit, "name", $$v)},expression:"orderDetail.assit.name"}}):_vm._e(),_vm._v(" "),(_vm.roleType === 'self' && _vm.orderDetail.assit)?_c('x-input',{attrs:{"title":"第三方专家手机","type":"text","readonly":""},model:{value:(_vm.orderDetail.assit.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.assit, "mobile", $$v)},expression:"orderDetail.assit.mobile"}}):_vm._e(),_vm._v(" "),(_vm.roleType === 'self' && _vm.orderDetail.assit)?_c('x-input',{attrs:{"title":"第三方专家状态","type":"text","readonly":""},model:{value:(_vm.orderDetail.assitstate),callback:function ($$v) {_vm.$set(_vm.orderDetail, "assitstate", $$v)},expression:"orderDetail.assitstate"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.needpay!=='NO'&&_vm.orderDetail.needpay !== '---')?_c('x-input',{attrs:{"title":"服务费用","type":"text","readonly":""},model:{value:(_vm.orderDetail.initpay),callback:function ($$v) {_vm.$set(_vm.orderDetail, "initpay", $$v)},expression:"orderDetail.initpay"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.aneedpay!=='NO'&&_vm.orderDetail.aneedpay !== '---')?_c('x-input',{attrs:{"title":"第三方专家服务费用","type":"text","readonly":""},model:{value:(_vm.orderDetail.ainitpay),callback:function ($$v) {_vm.$set(_vm.orderDetail, "ainitpay", $$v)},expression:"orderDetail.ainitpay"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.conclusion)?_c('x-textarea',{attrs:{"title":"维修结论","type":"text","autosize":"","readonly":""},model:{value:(_vm.orderDetail.conclusion),callback:function ($$v) {_vm.$set(_vm.orderDetail, "conclusion", $$v)},expression:"orderDetail.conclusion"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.addition)?_c('x-input',{attrs:{"title":"附加说明","type":"text","readonly":""},model:{value:(_vm.orderDetail.addition),callback:function ($$v) {_vm.$set(_vm.orderDetail, "addition", $$v)},expression:"orderDetail.addition"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.userconfirm)?_c('x-input',{attrs:{"title":"用户确认维修结果","type":"text","readonly":""},model:{value:(_vm.orderDetail.userconfirm),callback:function ($$v) {_vm.$set(_vm.orderDetail, "userconfirm", $$v)},expression:"orderDetail.userconfirm"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.useradvice)?_c('x-textarea',{attrs:{"title":"用户反馈意见","rows":1,"cols":10,"autosize":"","show-counter":false,"readonly":""},model:{value:(_vm.orderDetail.useradvice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "useradvice", $$v)},expression:"orderDetail.useradvice"}}):_vm._e(),_vm._v(" "),_c('cell',{attrs:{"title":"用户确认单"}},[_c('div',[_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,staticClass:"previewer-demo-img",staticStyle:{"height":"90px"},attrs:{"src":item.src},on:{"click":function($event){_vm.showx(index)}}})}),_vm._v(" "),(_vm.filename)?_c('x-button',{nativeOn:{"click":function($event){return _vm.downloadFile($event)}}},[_vm._v(_vm._s(_vm.filename))]):_vm._e()],2)]),_vm._v(" "),_c('cell',{attrs:{"is-link":""},nativeOn:{"click":function($event){return _vm.detail($event)}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v("详细信息")])])]),_vm._v(" "),_c('cell',{directives:[{name:"show",rawName:"v-show",value:(_vm.iswait),expression:"iswait"}],attrs:{"is-link":""},nativeOn:{"click":function($event){return _vm.bxjl($event)}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v("维修进度")])])]),_vm._v(" "),(_vm.task && _vm.roleType === 'self')?_c('cell',{attrs:{"is-link":""},nativeOn:{"click":function($event){return _vm.assistantinfo($event)}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v("协助人信息")])])]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"btnbox"},[(_vm.roleType === 'other')?_c('x-button',{staticClass:"btn",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.reject($event)}}},[_vm._v("拒绝")]):_vm._e(),_vm._v(" "),_c('x-button',{staticClass:"btn",attrs:{"type":"primary","show-loading":_vm.showLoading,"disabled":_vm.showLoading},nativeOn:{"click":function($event){return _vm.agree($event)}}},[_vm._v("接受\n      ")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFault),expression:"isFault"}],staticClass:"btnbox"},[_c('div',{staticStyle:{"display":"flex","flex":"8"}},[_c('div',{staticStyle:{"text-align":"center","margin-left":"20px"}},[_c('span',{staticClass:"active",on:{"click":_vm.Confirmfault}},[_vm._v(_vm._s(_vm.confirmFault))])]),_vm._v(" "),(!_vm.orderDetail.assit && _vm.orderDetail.responsible.type === 'SRVP' && _vm.task && _vm.roleType === 'self')?_c('div',{staticStyle:{"text-align":"center","margin-left":"20px"}},[_c('span',{staticClass:"active",on:{"click":_vm.desiginate}},[_vm._v("指派三方专家")])]):_vm._e(),_vm._v(" "),(_vm.orderDetail.assit && _vm.roleType === 'self')?_c('div',{staticStyle:{"text-align":"center","margin-left":"20px"}},[_c('span',{staticClass:"active",on:{"click":function($event){_vm.clearotherdesignateshow = true}}},[_vm._v("清除指派专家")])]):_vm._e()]),_vm._v(" "),(_vm.roleType === 'other')?_c('div',{staticStyle:{"position":"relative","line-height":"35px","text-align":"center","flex":"2"}},[_c('span',{staticStyle:{"text-align":"center"},on:{"click":_vm.more}},[_vm._v("更多")]),_vm._v(" "),(_vm.show)?_c('span',{staticClass:"cancel",staticStyle:{"width":"80px"},on:{"click":_vm.cancel}},[_vm._v("取消任务")]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.isFault&&_vm.task)?_c('x-button',{staticStyle:{"margin-top":"1rem"},attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.flag && _vm.success()}}},[_vm._v("提交用户验收\n    ")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.imgList,"options":_vm.options}})],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"清除第三方专家指派"},on:{"on-cancel":function($event){_vm.clearotherdesignateshow = false},"on-confirm":_vm.cleardesiginate},model:{value:(_vm.clearotherdesignateshow),callback:function ($$v) {_vm.clearotherdesignateshow=$$v},expression:"clearotherdesignateshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"清除原因","options":_vm.reason},model:{value:(_vm.clean_reason),callback:function ($$v) {_vm.clean_reason=$$v},expression:"clean_reason"}}),_vm._v(" "),_c('x-textarea',{staticClass:"white-textarea",attrs:{"rows":1,"cols":10,"title":"具体原因","max":255,"autosize":"","show-counter":false},model:{value:(_vm.clean_detail),callback:function ($$v) {_vm.clean_detail=$$v},expression:"clean_detail"}})],1)],1)],1)],1)}
var records_staticRenderFns = []
var records_esExports = { render: records_render, staticRenderFns: records_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_records = (records_esExports);
// CONCATENATED MODULE: ./src/components/records.vue
function records_injectStyle (ssrContext) {
  __webpack_require__("dWIQ")
}
var records_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var records___vue_template_functional__ = false
/* styles */
var records___vue_styles__ = records_injectStyle
/* scopeId */
var records___vue_scopeId__ = "data-v-556a23c8"
/* moduleIdentifier (server only) */
var records___vue_module_identifier__ = null
var records_Component = records_normalizeComponent(
  components_records,
  selectortype_template_index_0_src_components_records,
  records___vue_template_functional__,
  records___vue_styles__,
  records___vue_scopeId__,
  records___vue_module_identifier__
)

/* harmony default export */ var src_components_records = (records_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/makeMemo.vue










/* harmony default export */ var makeMemo = ({
  data: function data() {
    return {
      photo: { 'path': '', 'serverid': '' },
      account: '',
      username: '',
      sequence: '',
      orderDetail: {},
      cont: '',
      iden: '',
      imgList: [],
      orders_closed: [],
      isHide: true,
      solutionv: this.$route.params.solutionv,
      url: ''
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Alert: components_alert["a" /* default */],
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button
  },
  methods: {
    addrate: function addrate() {
      this.$router.push({
        name: 'addrate',
        params: { rate: this.orders_closed, solutionv: this.solutionv, url: this.url }
      });
    },
    showSolution: function showSolution() {
      var _this = this;

      this.$http.get('/api/v1/normalrepairs/' + this.orderDetail.seq + '/list_solutions?role=EXPT&offset=0&count=999', {
        headers: {
          token: localStorage.getItem("token"),
          opid: localStorage.getItem("userid")
        }
      }).then(function (resposne) {
        _this.orders_closed = resposne.data.content;
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: "cancel",
          time: "1000"
        });
      });
    }
  },
  created: function created() {
    var arr;
    var order = localStorage.getItem('order');
    this.orderDetail = JSON.parse(order);
    if (this.orderDetail.state === '处理失败,待审核' || this.orderDetail.state === '处理成功,待审核' || this.orderDetail.state === 'SUCCESS' || this.orderDetail.state === 'FAIL' || this.orderDetail.state === '成功') {
      this.isHide = false;
    }
    if (this.orderDetail.solutionv === 1) {
      if (this.orderDetail.solution) {
        arr = this.orderDetail.solution.content;
        this.orders_closed = arr;
      }
    } else {
      this.showSolution();
    }
    this.iden = this.$route.params.iden;
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'solution_logs') {
      to.params.role = this.iden;
    }
    next();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === 'normalcomplete') {
      next(function (vm) {
        vm.url = 'normalcomplete';
        vm.isHide = false;
      });
    } else {
      if (to.params.isHide) {
        next(function (vm) {
          vm.isHide = false;
        });
      } else {
        next();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/makeMemo.vue










/* harmony default export */ var components_makeMemo = ({
  data: function data() {
    return {
      photo: { 'path': '', 'serverid': '' },
      account: '',
      username: '',
      sequence: '',
      orderDetail: {},
      cont: '',
      iden: '',
      imgList: [],
      orders_closed: [],
      isHide: true,
      solutionv: this.$route.params.solutionv,
      url: ''
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Alert: components_alert["a" /* default */],
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button
  },
  methods: {
    addrate: function addrate() {
      this.$router.push({
        name: 'addrate',
        params: { rate: this.orders_closed, solutionv: this.solutionv, url: this.url }
      });
    },
    showSolution: function showSolution() {
      var _this = this;

      this.$http.get('/api/v1/normalrepairs/' + this.orderDetail.seq + '/list_solutions?role=EXPT&offset=0&count=999', {
        headers: {
          token: localStorage.getItem("token"),
          opid: localStorage.getItem("userid")
        }
      }).then(function (resposne) {
        _this.orders_closed = resposne.data.content;
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: "cancel",
          time: "1000"
        });
      });
    }
  },
  created: function created() {
    var arr;
    var order = localStorage.getItem('order');
    this.orderDetail = JSON.parse(order);
    if (this.orderDetail.state === '处理失败,待审核' || this.orderDetail.state === '处理成功,待审核' || this.orderDetail.state === 'SUCCESS' || this.orderDetail.state === 'FAIL' || this.orderDetail.state === '成功') {
      this.isHide = false;
    }
    if (this.orderDetail.solutionv === 1) {
      if (this.orderDetail.solution) {
        arr = this.orderDetail.solution.content;
        this.orders_closed = arr;
      }
    } else {
      this.showSolution();
    }
    this.iden = this.$route.params.iden;
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'solution_logs') {
      to.params.role = this.iden;
    }
    next();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === 'normalcomplete') {
      next(function (vm) {
        vm.url = 'normalcomplete';
        vm.isHide = false;
      });
    } else {
      if (to.params.isHide) {
        next(function (vm) {
          vm.isHide = false;
        });
      } else {
        next();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3460d3d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/makeMemo.vue
var makeMemo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("维修进度信息")]),_vm._v(" "),_c('group',_vm._l((_vm.orders_closed),function(order,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'prgsdetail', params: { order: order,solutionv: _vm.solutionv,isHide:!_vm.isHide}}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n        "+_vm._s(order.time)+"--"+_vm._s(order.describe ? order.describe : order.operator.name + '--' + order.record)+"\n      ")])])})),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHide),expression:"isHide"}],attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.addrate($event)}}},[_vm._v("添加维修进度")])],1)}
var makeMemo_staticRenderFns = []
var makeMemo_esExports = { render: makeMemo_render, staticRenderFns: makeMemo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_makeMemo = (makeMemo_esExports);
// CONCATENATED MODULE: ./src/components/makeMemo.vue
var makeMemo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var makeMemo___vue_template_functional__ = false
/* styles */
var makeMemo___vue_styles__ = null
/* scopeId */
var makeMemo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var makeMemo___vue_module_identifier__ = null
var makeMemo_Component = makeMemo_normalizeComponent(
  components_makeMemo,
  selectortype_template_index_0_src_components_makeMemo,
  makeMemo___vue_template_functional__,
  makeMemo___vue_styles__,
  makeMemo___vue_scopeId__,
  makeMemo___vue_module_identifier__
)

/* harmony default export */ var src_components_makeMemo = (makeMemo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addrate.vue














/* harmony default export */ var addrate = ({
  data: function data() {
    return {
      showLoading: false,
      photo: { path: "", serverid: "" },
      account: "",
      username: "",
      sequence: "",
      cont: "",
      iden: "",
      rateList: {
        version: "1.0",
        content: []
      },
      rate: [],
      list: [],
      imgList: [],
      newobj: {
        photo: []
      },
      num: 6,
      show: true,
      index: 0,
      flag: true,
      solutionv: this.$route.params.solutionv,
      url: this.$route.params.url
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Alert: components_alert["a" /* default */],
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button
  },
  methods: {
    fileDel: function fileDel(key) {
      var index;
      for (var j = 0; j < this.imgList.length; j++) {
        if (this.imgList[j].path == key) {
          this.imgList.splice(j, 1);
        }
      }

      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i] == key) {
          index = i;
          this.list.splice(i, 1);
          this.num++;
          this.index--;
        }
      }
      this.newobj.photo.splice(index, 1);
      if (this.num < 6) {
        this.show = true;
      }
    },
    confirm: function confirm() {
      var _this = this;

      this.showLoading = true;
      var header = {
        headers: {
          token: localStorage.getItem("token"),
          opid: localStorage.getItem("userid")
        }
      };
      if (this.solutionv === 1) {
        var obj = {
          role: this.iden,
          solution: this.rateList,
          solutionv: 1
        };
        var that = this;
        var arr = [];
        if (this.cont !== "") {
          var target = {
            path: [],
            describe: "",
            time: ""
          };
          this.list.forEach(function (item) {
            arr.push(item);
          });
          target.path = arr;
          target.describe = (this.orderDetail.expert ? this.orderDetail.expert.name : this.orderDetail.responsible.name) + '--' + this.cont;
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var d = date.getDate();
          var hours = date.getHours();
          var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
          var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
          target.time = year + "-" + month + "-" + d + " " + hours + ":" + minutes + ":" + seconds;

          if (this.rate != null) {
            for (var i = 0; i < this.rate.length; i++) {
              this.rateList.content.push(this.rate[i]);
            }
          }
          this.rateList.content.unshift(target);
          that.$http.put("/api/v1/normalrepairs/" + this.orderDetail.seq + "/solution", obj, header).then(function (res) {
            if (that.url) {
              that.$router.push({ name: _this.url, query: { seq: _this.orderDetail.seq } });
            } else {
              switch (_this.iden) {
                case "EXPT":
                  that.$router.push({ name: "records", query: { seq: _this.orderDetail.seq } });
                  break;
                case "SRVP":
                  that.$router.push({ name: "RepairOrder", params: { isAdmin: false } });
                  break;
                case "ADMIN":
                  that.$router.push({ name: "RepairOrder", params: { isAdmin: true } });
                  break;
              }
            }
          }).catch(function (error) {
            _this.showLoading = false;
            that.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: "cancel",
              time: "1000"
            });
          });
        } else {
          this.showLoading = false;
          this.$vux.alert.show({
            title: "",
            content: "描述信息不能为空"
          });
        }
      } else {
        var path = [];
        this.list.forEach(function (item) {
          path.push(item);
        });
        var _obj = {
          role: this.iden,
          solutionv: 2,
          record: this.cont,
          path: path
        };
        this.$http.put("/api/v1/normalrepairs/" + this.orderDetail.seq + "/solution", _obj, header).then(function (res) {
          if (_this.url) {
            _this.$router.push({ name: _this.url, query: { seq: _this.orderDetail.seq, role: 'EXPT' } });
          } else {
            _this.$router.push({ name: "records", query: { seq: _this.orderDetail.seq } });
          }
        }).catch(function (error) {
          _this.showLoading = false;
          _this.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: "cancel",
            time: "1000"
          });
        });
      }
    },

    upload: function upload() {
      var app = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: app.num, // 默认9
        sizeType: ["compressed"],
        sourceType: ["album", "camera"],
        success: function success(res) {
          var localIds = res.localIds;

          var i = 0;
          length = localIds.length;
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {
                app.flag = false;
                if (app.list.length == 0) {
                  app.newobj.photo.push(res.serverId);
                } else {
                  obj.photo.push(res.serverId);
                }
                i++;
                app.num--;
                if (i < length) {
                  upload();
                } else {

                  if (app.list.length == 0) {
                    app.submitImage(app.newobj);
                  } else {
                    app.submitImage(obj);
                  }
                }
              }
            });
          };
          upload();
        }
      });
    },
    submitImage: function submitImage(obj) {
      var app = this;
      var token = localStorage.getItem("token");
      var opid = localStorage.getItem("userid");
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      ajax["a" /* default */].$http.post("/api/v1/photos/wechat", obj, header).then(function (response) {
        app.flag = true;
        if (app.list.length === 0) {
          app.list = response.data;
          app.decrypt();
        } else {
          for (var i = 0; i < response.data.length; i++) {
            app.list.push(response.data[i]);
          }
          app.decrypt();
        }
        if (app.list.length === 6) {
          app.show = false;
        }
      }).catch(function (error) {
        app.flag = true;
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: "cancel",
              time: "1000"
            });
          } else {
            app.$vux.toast.show({
              text: "服务器错误，请稍后重试",
              type: "cancel",
              time: "1000"
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.toast.show({
            text: "服务器错误，请稍后重试",
            type: "cancel",
            time: "1000"
          });
          console.log("Error", error.message);
        }
      });
    },
    decrypt: function decrypt() {
      var _this2 = this;

      var token = localStorage.getItem("token");
      var opid = localStorage.getItem("userid");
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      ajax["a" /* default */].$http.get("api/v1/photos?path=" + this.list[this.index].thumb, header).then(function (res) {
        _this2.imgList.push(res.data);
        _this2.index++;
        if (_this2.index < _this2.list.length) {
          _this2.decrypt();
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this3;
      app.$http.get("static/config.json").then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get("/api/v1/wechat/jsApiTicket?timestamp=" + timestamp + "&noncestr=" + noncestr + "&url=" + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ["chooseImage", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getLocalImgData", "checkJsApi"] // 必填，需要使用的JS接口列表
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {

          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        });
      }, function (response) {
        console.log("数据加载失败");
      });
    }, 500);
  },
  created: function created() {
    var that = this;
    var order = localStorage.getItem("order");
    this.orderDetail = JSON.parse(order);
    this.rate = this.$route.params.rate;
    console.log(this.rate);

    var opid = localStorage.getItem("userid");
    var obj = {
      headers: {
        token: localStorage.getItem("token"),
        opid: opid
      }
    };
    this.$http.get("/api/v1/accounts/" + opid, obj).then(function (res) {
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == "EXPT") {
          that.iden = "EXPT";
        }
        if (res.data[i].type == "SRVP") {
          that.iden = "SRVP";
        }
        if (res.data[i].type == "ADMIN") {
          that.iden = "ADMIN";
        }
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'makeMemo') {
      to.params.solutionv = this.solutionv;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addrate.vue














/* harmony default export */ var components_addrate = ({
  data: function data() {
    return {
      showLoading: false,
      photo: { path: "", serverid: "" },
      account: "",
      username: "",
      sequence: "",
      cont: "",
      iden: "",
      rateList: {
        version: "1.0",
        content: []
      },
      rate: [],
      list: [],
      imgList: [],
      newobj: {
        photo: []
      },
      num: 6,
      show: true,
      index: 0,
      flag: true,
      solutionv: this.$route.params.solutionv,
      url: this.$route.params.url
    };
  },

  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Alert: components_alert["a" /* default */],
    Cell: vux_src_components_cell,
    XButton: vux_src_components_x_button
  },
  methods: {
    fileDel: function fileDel(key) {
      var index;
      for (var j = 0; j < this.imgList.length; j++) {
        if (this.imgList[j].path == key) {
          this.imgList.splice(j, 1);
        }
      }

      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i] == key) {
          index = i;
          this.list.splice(i, 1);
          this.num++;
          this.index--;
        }
      }
      this.newobj.photo.splice(index, 1);
      if (this.num < 6) {
        this.show = true;
      }
    },
    confirm: function confirm() {
      var _this = this;

      this.showLoading = true;
      var header = {
        headers: {
          token: localStorage.getItem("token"),
          opid: localStorage.getItem("userid")
        }
      };
      if (this.solutionv === 1) {
        var obj = {
          role: this.iden,
          solution: this.rateList,
          solutionv: 1
        };
        var that = this;
        var arr = [];
        if (this.cont !== "") {
          var target = {
            path: [],
            describe: "",
            time: ""
          };
          this.list.forEach(function (item) {
            arr.push(item);
          });
          target.path = arr;
          target.describe = (this.orderDetail.expert ? this.orderDetail.expert.name : this.orderDetail.responsible.name) + '--' + this.cont;
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var d = date.getDate();
          var hours = date.getHours();
          var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
          var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
          target.time = year + "-" + month + "-" + d + " " + hours + ":" + minutes + ":" + seconds;

          if (this.rate != null) {
            for (var i = 0; i < this.rate.length; i++) {
              this.rateList.content.push(this.rate[i]);
            }
          }
          this.rateList.content.unshift(target);
          that.$http.put("/api/v1/normalrepairs/" + this.orderDetail.seq + "/solution", obj, header).then(function (res) {
            if (that.url) {
              that.$router.push({ name: _this.url, query: { seq: _this.orderDetail.seq } });
            } else {
              switch (_this.iden) {
                case "EXPT":
                  that.$router.push({ name: "records", query: { seq: _this.orderDetail.seq } });
                  break;
                case "SRVP":
                  that.$router.push({ name: "RepairOrder", params: { isAdmin: false } });
                  break;
                case "ADMIN":
                  that.$router.push({ name: "RepairOrder", params: { isAdmin: true } });
                  break;
              }
            }
          }).catch(function (error) {
            _this.showLoading = false;
            that.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: "cancel",
              time: "1000"
            });
          });
        } else {
          this.showLoading = false;
          this.$vux.alert.show({
            title: "",
            content: "描述信息不能为空"
          });
        }
      } else {
        var path = [];
        this.list.forEach(function (item) {
          path.push(item);
        });
        var _obj = {
          role: this.iden,
          solutionv: 2,
          record: this.cont,
          path: path
        };
        this.$http.put("/api/v1/normalrepairs/" + this.orderDetail.seq + "/solution", _obj, header).then(function (res) {
          if (_this.url) {
            _this.$router.push({ name: _this.url, query: { seq: _this.orderDetail.seq, role: 'EXPT' } });
          } else {
            _this.$router.push({ name: "records", query: { seq: _this.orderDetail.seq } });
          }
        }).catch(function (error) {
          _this.showLoading = false;
          _this.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: "cancel",
            time: "1000"
          });
        });
      }
    },

    upload: function upload() {
      var app = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: app.num, // 默认9
        sizeType: ["compressed"],
        sourceType: ["album", "camera"],
        success: function success(res) {
          var localIds = res.localIds;

          var i = 0;
          length = localIds.length;
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {
                app.flag = false;
                if (app.list.length == 0) {
                  app.newobj.photo.push(res.serverId);
                } else {
                  obj.photo.push(res.serverId);
                }
                i++;
                app.num--;
                if (i < length) {
                  upload();
                } else {

                  if (app.list.length == 0) {
                    app.submitImage(app.newobj);
                  } else {
                    app.submitImage(obj);
                  }
                }
              }
            });
          };
          upload();
        }
      });
    },
    submitImage: function submitImage(obj) {
      var app = this;
      var token = localStorage.getItem("token");
      var opid = localStorage.getItem("userid");
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      ajax["a" /* default */].$http.post("/api/v1/photos/wechat", obj, header).then(function (response) {
        app.flag = true;
        if (app.list.length === 0) {
          app.list = response.data;
          app.decrypt();
        } else {
          for (var i = 0; i < response.data.length; i++) {
            app.list.push(response.data[i]);
          }
          app.decrypt();
        }
        if (app.list.length === 6) {
          app.show = false;
        }
      }).catch(function (error) {
        app.flag = true;
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: "cancel",
              time: "1000"
            });
          } else {
            app.$vux.toast.show({
              text: "服务器错误，请稍后重试",
              type: "cancel",
              time: "1000"
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.toast.show({
            text: "服务器错误，请稍后重试",
            type: "cancel",
            time: "1000"
          });
          console.log("Error", error.message);
        }
      });
    },
    decrypt: function decrypt() {
      var _this2 = this;

      var token = localStorage.getItem("token");
      var opid = localStorage.getItem("userid");
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      ajax["a" /* default */].$http.get("api/v1/photos?path=" + this.list[this.index].thumb, header).then(function (res) {
        _this2.imgList.push(res.data);
        _this2.index++;
        if (_this2.index < _this2.list.length) {
          _this2.decrypt();
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this3;
      app.$http.get("static/config.json").then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get("/api/v1/wechat/jsApiTicket?timestamp=" + timestamp + "&noncestr=" + noncestr + "&url=" + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ["chooseImage", "previewImage", "uploadImage", "downloadImage", "translateVoice", "getLocalImgData", "checkJsApi"] // 必填，需要使用的JS接口列表
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {

          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        });
      }, function (response) {
        console.log("数据加载失败");
      });
    }, 500);
  },
  created: function created() {
    var that = this;
    var order = localStorage.getItem("order");
    this.orderDetail = JSON.parse(order);
    this.rate = this.$route.params.rate;
    console.log(this.rate);

    var opid = localStorage.getItem("userid");
    var obj = {
      headers: {
        token: localStorage.getItem("token"),
        opid: opid
      }
    };
    this.$http.get("/api/v1/accounts/" + opid, obj).then(function (res) {
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == "EXPT") {
          that.iden = "EXPT";
        }
        if (res.data[i].type == "SRVP") {
          that.iden = "SRVP";
        }
        if (res.data[i].type == "ADMIN") {
          that.iden = "ADMIN";
        }
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'makeMemo') {
      to.params.solutionv = this.solutionv;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bfd1a83","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addrate.vue
var addrate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"upload_warp_img"},[_vm._l((_vm.imgList),function(val,index){return _c('div',{key:index,staticClass:"upload_warp_img_div"},[_c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"width":"100px","height":"75px"},attrs:{"src":'data:image/jpeg;base64,'+val.value}})]),_vm._v(" "),_c('div',{staticClass:"upload_warp_img_div_top"},[_c('span',{staticClass:"upload_warp_img_div_del",on:{"click":function($event){_vm.fileDel(val.path)}}},[_vm._v("×")])])])}),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"upload_warp"},[_c('div',{staticClass:"upload_warp_left",on:{"click":function($event){_vm.flag&&_vm.upload()}}},[_c('div',{staticClass:"icon-add-50"})])]):_vm._e()],2),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cont),expression:"cont"}],staticClass:"text",attrs:{"maxlength":"500","placeholder":"描述信息..."},domProps:{"value":(_vm.cont)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cont=$event.target.value}}}),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","show-loading":_vm.showLoading,"disabled":_vm.showLoading},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定\n  ")])],1)}
var addrate_staticRenderFns = []
var addrate_esExports = { render: addrate_render, staticRenderFns: addrate_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_addrate = (addrate_esExports);
// CONCATENATED MODULE: ./src/components/addrate.vue
function addrate_injectStyle (ssrContext) {
  __webpack_require__("HHkT")
}
var addrate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addrate___vue_template_functional__ = false
/* styles */
var addrate___vue_styles__ = addrate_injectStyle
/* scopeId */
var addrate___vue_scopeId__ = "data-v-4bfd1a83"
/* moduleIdentifier (server only) */
var addrate___vue_module_identifier__ = null
var addrate_Component = addrate_normalizeComponent(
  components_addrate,
  selectortype_template_index_0_src_components_addrate,
  addrate___vue_template_functional__,
  addrate___vue_styles__,
  addrate___vue_scopeId__,
  addrate___vue_module_identifier__
)

/* harmony default export */ var src_components_addrate = (addrate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-loading/index.vue
//
//
//
//

/* harmony default export */ var components_inline_loading = ({
  name: 'inline-loading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-137803b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-loading/index.vue
var inline_loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"weui-loading"})}
var inline_loading_staticRenderFns = []
var inline_loading_esExports = { render: inline_loading_render, staticRenderFns: inline_loading_staticRenderFns }
/* harmony default export */ var src_components_inline_loading = (inline_loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-loading/index.vue
function inline_loading_injectStyle (ssrContext) {
  __webpack_require__("c9+y")
}
var inline_loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_loading___vue_template_functional__ = false
/* styles */
var inline_loading___vue_styles__ = inline_loading_injectStyle
/* scopeId */
var inline_loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_loading___vue_module_identifier__ = null
var inline_loading_Component = inline_loading_normalizeComponent(
  components_inline_loading,
  src_components_inline_loading,
  inline_loading___vue_template_functional__,
  inline_loading___vue_styles__,
  inline_loading___vue_scopeId__,
  inline_loading___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_loading = (inline_loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/prgsdetail.vue






/* harmony default export */ var prgsdetail = ({
  components: {
    InlineLoading: vux_src_components_inline_loading,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      isShow: false,
      list: [],
      arr: [],
      solutionv: this.$route.params.solutionv,
      isHide: this.$route.params.isHide
    };
  },

  methods: {
    show: function show(index) {
      var _this = this;

      if (this.arr[index].hasOwnProperty('src')) {
        this.$refs.previewer.show(index);
        return;
      }
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var arr = this.list.path;
      var order = this.$route.params.order;
      var path = this.solutionv === 1 ? arr[index]['origin'] ? arr[index]['origin'] : arr[index] : order.path[index]['origin'] ? order.path[index]['origin'] : order.path[index];
      this.$vux.loading.show({ text: '加载中' });
      this.$http.get('api/v1/photos?path=' + path, header).then(function (res) {
        _this.$vux.loading.hide();
        _this.arr[index].src = 'data:image/jpeg;base64,' + res.data['value'];
        _this.$refs.previewer.show(index);
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var token = localStorage.getItem('token');
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: token,
        opid: opid
      }
    };
    if (this.solutionv === 1) {
      this.list = this.$route.params.order;

      var arr = [],
          brr = [],
          index = 0;
      arr = this.list.path;
      if (this.list.path.length !== 0) {
        this.isShow = true;
        var decrypt = function decrypt() {
          var path = arr[index]['thumb'] ? arr[index]['thumb'] : arr[index];
          ajax["a" /* default */].$http.get('api/v1/photos?path=' + path, header).then(function (res) {
            brr.push({ msrc: 'data:image/jpeg;base64,' + res.data['value'] });
            index++;
            if (index < arr.length) {
              decrypt();
            } else {
              _this2.isShow = false;
            }
          });
        };
        decrypt();
        this.arr = brr;
      }
    } else {
      var order = this.$route.params.order;
      this.list.describe = order.operator.name + '--' + order.record;
      if (order.path.length !== 0) {
        this.isShow = true;
        order.path.forEach(function (item) {
          var path = item['thumb'] ? item['thumb'] : item;
          _this2.$http.get('api/v1/photos?path=' + path, header).then(function (res) {
            _this2.arr.push({ msrc: 'data:image/jpeg;base64,' + res.data['value'] });
            _this2.isShow = _this2.arr.length !== order.path.length;
          });
        });
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'makeMemo') {
      to.params.solutionv = this.solutionv;
      to.params.isHide = this.isHide;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/prgsdetail.vue






/* harmony default export */ var components_prgsdetail = ({
  components: {
    InlineLoading: vux_src_components_inline_loading,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      isShow: false,
      list: [],
      arr: [],
      solutionv: this.$route.params.solutionv,
      isHide: this.$route.params.isHide
    };
  },

  methods: {
    show: function show(index) {
      var _this = this;

      if (this.arr[index].hasOwnProperty('src')) {
        this.$refs.previewer.show(index);
        return;
      }
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var arr = this.list.path;
      var order = this.$route.params.order;
      var path = this.solutionv === 1 ? arr[index]['origin'] ? arr[index]['origin'] : arr[index] : order.path[index]['origin'] ? order.path[index]['origin'] : order.path[index];
      this.$vux.loading.show({ text: '加载中' });
      this.$http.get('api/v1/photos?path=' + path, header).then(function (res) {
        _this.$vux.loading.hide();
        _this.arr[index].src = 'data:image/jpeg;base64,' + res.data['value'];
        _this.$refs.previewer.show(index);
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var token = localStorage.getItem('token');
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: token,
        opid: opid
      }
    };
    if (this.solutionv === 1) {
      this.list = this.$route.params.order;

      var arr = [],
          brr = [],
          index = 0;
      arr = this.list.path;
      if (this.list.path.length !== 0) {
        this.isShow = true;
        var decrypt = function decrypt() {
          var path = arr[index]['thumb'] ? arr[index]['thumb'] : arr[index];
          ajax["a" /* default */].$http.get('api/v1/photos?path=' + path, header).then(function (res) {
            brr.push({ msrc: 'data:image/jpeg;base64,' + res.data['value'] });
            index++;
            if (index < arr.length) {
              decrypt();
            } else {
              _this2.isShow = false;
            }
          });
        };
        decrypt();
        this.arr = brr;
      }
    } else {
      var order = this.$route.params.order;
      this.list.describe = order.operator.name + '--' + order.record;
      if (order.path.length !== 0) {
        this.isShow = true;
        order.path.forEach(function (item) {
          var path = item['thumb'] ? item['thumb'] : item;
          _this2.$http.get('api/v1/photos?path=' + path, header).then(function (res) {
            _this2.arr.push({ msrc: 'data:image/jpeg;base64,' + res.data['value'] });
            _this2.isShow = _this2.arr.length !== order.path.length;
          });
        });
      }
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'makeMemo') {
      to.params.solutionv = this.solutionv;
      to.params.isHide = this.isHide;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-272ab50e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prgsdetail.vue
var prgsdetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrap"},[_c('p',[_vm._v("图片：")]),_vm._v(" "),(_vm.isShow)?_c('div',[_c('span',[_vm._v("加载中  ")]),_vm._v(" "),_c('inline-loading')],1):_vm._e(),_vm._v(" "),(!_vm.isShow)?_c('div',_vm._l((_vm.arr),function(item,index){return _c('img',{key:index,staticClass:"previewer-demo-img",staticStyle:{"max-width":"15%","margin-left":"5px"},attrs:{"src":item.msrc},on:{"click":function($event){_vm.show(index)}}})})):_vm._e()]),_vm._v(" "),_c('div',[_c('p',[_vm._v("描述：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.list.describe))])]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.arr,"options":_vm.options}})],1)])}
var prgsdetail_staticRenderFns = []
var prgsdetail_esExports = { render: prgsdetail_render, staticRenderFns: prgsdetail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_prgsdetail = (prgsdetail_esExports);
// CONCATENATED MODULE: ./src/components/prgsdetail.vue
function prgsdetail_injectStyle (ssrContext) {
  __webpack_require__("wIxn")
}
var prgsdetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var prgsdetail___vue_template_functional__ = false
/* styles */
var prgsdetail___vue_styles__ = prgsdetail_injectStyle
/* scopeId */
var prgsdetail___vue_scopeId__ = "data-v-272ab50e"
/* moduleIdentifier (server only) */
var prgsdetail___vue_module_identifier__ = null
var prgsdetail_Component = prgsdetail_normalizeComponent(
  components_prgsdetail,
  selectortype_template_index_0_src_components_prgsdetail,
  prgsdetail___vue_template_functional__,
  prgsdetail___vue_styles__,
  prgsdetail___vue_scopeId__,
  prgsdetail___vue_module_identifier__
)

/* harmony default export */ var src_components_prgsdetail = (prgsdetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cancelCause.vue














/* harmony default export */ var cancelCause = ({
  components: {
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      iden: '',
      cont: '',
      orderDetail: {}
    };
  },

  methods: {
    confirm: function confirm() {

      var that = this;
      var obj = {
        role: this.iden,
        reason: this.cont
      };
      console.log(obj);
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      console.log(header);
      if (this.cont != '') {
        this.$http.put('/api/v1/normalrepairs/' + this.orderDetail.seq + '/cancel', obj, header).then(function (res) {
          console.log(res);
          that.$router.push({ name: 'normalrepairslist' });
        }).catch(function (error) {
          console.log(error.response);
          that.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      } else {
        this.$vux.toast.show({
          text: '描述信息不能为空',
          type: 'cancel',
          time: '1000'
        });
      }
    }
  },
  created: function created() {
    this.orderDetail = this.$route.params.obj;
    var that = this;
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
      console.log(res);
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == 'INDV') {
          that.iden = 'INDV';
        }
        if (res.data[i].type == 'ENTP') {
          that.iden = 'ENTP';
        }
      }
    }).catch(function (error) {
      that.$vux.toast.show({
        text: JSON.parse(error.response.data.error_message).zh_string,
        type: 'cancel',
        time: '1000'
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cancelCause.vue














/* harmony default export */ var components_cancelCause = ({
  components: {
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      iden: '',
      cont: '',
      orderDetail: {}
    };
  },

  methods: {
    confirm: function confirm() {

      var that = this;
      var obj = {
        role: this.iden,
        reason: this.cont
      };
      console.log(obj);
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      console.log(header);
      if (this.cont != '') {
        this.$http.put('/api/v1/normalrepairs/' + this.orderDetail.seq + '/cancel', obj, header).then(function (res) {
          console.log(res);
          that.$router.push({ name: 'normalrepairslist' });
        }).catch(function (error) {
          console.log(error.response);
          that.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      } else {
        this.$vux.toast.show({
          text: '描述信息不能为空',
          type: 'cancel',
          time: '1000'
        });
      }
    }
  },
  created: function created() {
    this.orderDetail = this.$route.params.obj;
    var that = this;
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
      console.log(res);
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == 'INDV') {
          that.iden = 'INDV';
        }
        if (res.data[i].type == 'ENTP') {
          that.iden = 'ENTP';
        }
      }
    }).catch(function (error) {
      that.$vux.toast.show({
        text: JSON.parse(error.response.data.error_message).zh_string,
        type: 'cancel',
        time: '1000'
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97ca65dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cancelCause.vue
var cancelCause_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cont),expression:"cont"}],staticClass:"text",attrs:{"maxlength":"200","placeholder":"描述信息..."},domProps:{"value":(_vm.cont)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cont=$event.target.value}}},[_vm._v(">")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定")])],1)}
var cancelCause_staticRenderFns = []
var cancelCause_esExports = { render: cancelCause_render, staticRenderFns: cancelCause_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_cancelCause = (cancelCause_esExports);
// CONCATENATED MODULE: ./src/components/cancelCause.vue
function cancelCause_injectStyle (ssrContext) {
  __webpack_require__("r7UK")
}
var cancelCause_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cancelCause___vue_template_functional__ = false
/* styles */
var cancelCause___vue_styles__ = cancelCause_injectStyle
/* scopeId */
var cancelCause___vue_scopeId__ = "data-v-97ca65dc"
/* moduleIdentifier (server only) */
var cancelCause___vue_module_identifier__ = null
var cancelCause_Component = cancelCause_normalizeComponent(
  components_cancelCause,
  selectortype_template_index_0_src_components_cancelCause,
  cancelCause___vue_template_functional__,
  cancelCause___vue_styles__,
  cancelCause___vue_scopeId__,
  cancelCause___vue_module_identifier__
)

/* harmony default export */ var src_components_cancelCause = (cancelCause_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addexpertInfo.vue

















/* harmony default export */ var addexpertInfo = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    XAddress: vux_src_components_x_address,
    XSwitch: vux_src_components_x_switch
  },
  name: "expertInfo",
  data: function data() {
    return {
      name: "",
      idcard: "",
      mobile: "",
      ename: "",
      emobile: "",
      etelephone: "",
      zipcode: "",
      eduList: [{ key: 1, value: "博士研究生" }, { key: 2, value: "硕士研究生" }, { key: 3, value: "本科" }, { key: 4, value: "专科" }, { key: 5, value: "其他" }],
      addressData: china_address_v4_default.a,
      showAddress: false,
      address1: [],
      address2: "",
      result: "",
      isVisible: false,
      isShow: false,
      strInfo: "",
      company: '',
      isReadonly: true
    };
  },

  methods: {
    save: function save() {
      if (this.ename === '') {
        alert('紧急联系人不能为空');
        return;
      }
      if (this.emobile === '') {
        alert('紧急联系人手机不能为空');
        return;
      }
      if (this.address1.length !== 3 && !this.address2) {
        alert('地址不能为空');
        return;
      }
      if (this.company === '') {
        alert('请填写就职公司');
        return;
      }
      var address = Object(value2name["a" /* default */])(this.address1, china_address_v4_default.a);
      address = address.split(' ');
      var obj = {
        name: this.name,
        idcard: this.idcard,
        mobile: this.mobile,
        ename: this.ename,
        emobile: this.emobile,
        etelephone: this.etelephone,
        province: address[0],
        city: address[1],
        district: address[2],
        daddress: this.address2,
        zipcode: this.zipcode,
        company: this.company,
        sequence: 0
      };
      var opid = localStorage.getItem("userid");
      var head = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      var that = this;
      this.$http.post("/api/v1/experts/" + opid, obj, head).then(function (res) {
        var visible = that.isVisible ? "yes" : "no";
        that.$http.put("/api/v1/experts/" + opid + "/visible", { visible: visible }, head).then(function (res) {
          that.$router.push({ name: "vip" });
        }).catch(function (error) {
          that.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: "cancel",
            time: "1000"
          });
        });
      }).catch(function (error) {
        that.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: "cancel",
          time: "1000"
        });
      });
    },
    updateVisible: function updateVisible() {
      this.isShow = true;
      if (this.isVisible) {
        this.strInfo = "已设置可见";
      } else {
        this.strInfo = "已设置不可见";
      }
    }
  },
  created: function created() {
    var _this = this;

    var opid = localStorage.getItem("userid");
    var obj = {
      headers: {
        token: localStorage.getItem("token"),
        opid: opid
      }
    };
    this.$http.get("/api/v1/users/" + opid, obj).then(function (res) {
      _this.name = res.data.detail.name;
      _this.idcard = res.data.detail.idcard;
      _this.mobile = res.data.detail.mobile;
      _this.company = res.data.detail.company;
      _this.address1 = [res.data.detail.province, res.data.detail.city, res.data.detail.district];
      _this.address2 = res.data.detail.daddress;
      if (!res.data.detail.idcard) {
        _this.isReadonly = false;
      }
    }).catch(function (error) {
      _this.$vux.toast.show({
        text: JSON.parse(error.response.data.error_message).zh_string,
        type: "cancel",
        time: "1000"
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addexpertInfo.vue

















/* harmony default export */ var components_addexpertInfo = ({
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Toast: toast["a" /* default */],
    Selector: vux_src_components_selector,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    GroupTitle: vux_src_components_group_title,
    Cell: vux_src_components_cell,
    Alert: components_alert["a" /* default */],
    XAddress: vux_src_components_x_address,
    XSwitch: vux_src_components_x_switch
  },
  name: "expertInfo",
  data: function data() {
    return {
      name: "",
      idcard: "",
      mobile: "",
      ename: "",
      emobile: "",
      etelephone: "",
      zipcode: "",
      eduList: [{ key: 1, value: "博士研究生" }, { key: 2, value: "硕士研究生" }, { key: 3, value: "本科" }, { key: 4, value: "专科" }, { key: 5, value: "其他" }],
      addressData: china_address_v4_default.a,
      showAddress: false,
      address1: [],
      address2: "",
      result: "",
      isVisible: false,
      isShow: false,
      strInfo: "",
      company: '',
      isReadonly: true
    };
  },

  methods: {
    save: function save() {
      if (this.ename === '') {
        alert('紧急联系人不能为空');
        return;
      }
      if (this.emobile === '') {
        alert('紧急联系人手机不能为空');
        return;
      }
      if (this.address1.length !== 3 && !this.address2) {
        alert('地址不能为空');
        return;
      }
      if (this.company === '') {
        alert('请填写就职公司');
        return;
      }
      var address = Object(value2name["a" /* default */])(this.address1, china_address_v4_default.a);
      address = address.split(' ');
      var obj = {
        name: this.name,
        idcard: this.idcard,
        mobile: this.mobile,
        ename: this.ename,
        emobile: this.emobile,
        etelephone: this.etelephone,
        province: address[0],
        city: address[1],
        district: address[2],
        daddress: this.address2,
        zipcode: this.zipcode,
        company: this.company,
        sequence: 0
      };
      var opid = localStorage.getItem("userid");
      var head = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      var that = this;
      this.$http.post("/api/v1/experts/" + opid, obj, head).then(function (res) {
        var visible = that.isVisible ? "yes" : "no";
        that.$http.put("/api/v1/experts/" + opid + "/visible", { visible: visible }, head).then(function (res) {
          that.$router.push({ name: "vip" });
        }).catch(function (error) {
          that.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: "cancel",
            time: "1000"
          });
        });
      }).catch(function (error) {
        that.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: "cancel",
          time: "1000"
        });
      });
    },
    updateVisible: function updateVisible() {
      this.isShow = true;
      if (this.isVisible) {
        this.strInfo = "已设置可见";
      } else {
        this.strInfo = "已设置不可见";
      }
    }
  },
  created: function created() {
    var _this = this;

    var opid = localStorage.getItem("userid");
    var obj = {
      headers: {
        token: localStorage.getItem("token"),
        opid: opid
      }
    };
    this.$http.get("/api/v1/users/" + opid, obj).then(function (res) {
      _this.name = res.data.detail.name;
      _this.idcard = res.data.detail.idcard;
      _this.mobile = res.data.detail.mobile;
      _this.company = res.data.detail.company;
      _this.address1 = [res.data.detail.province, res.data.detail.city, res.data.detail.district];
      _this.address2 = res.data.detail.daddress;
      if (!res.data.detail.idcard) {
        _this.isReadonly = false;
      }
    }).catch(function (error) {
      _this.$vux.toast.show({
        text: JSON.parse(error.response.data.error_message).zh_string,
        type: "cancel",
        time: "1000"
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f09d0f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addexpertInfo.vue
var addexpertInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("个人专家")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"姓名*","type":"text","readonly":"","max":16},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身份证号码*","readonly":_vm.isReadonly,"max":18},model:{value:(_vm.idcard),callback:function ($$v) {_vm.idcard=$$v},expression:"idcard"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手机号码*","readonly":"","is-type":"china-mobile"},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"现就职公司*","max":20},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}}),_vm._v(" "),_c('x-address',{attrs:{"title":"通讯地址*","raw-value":"","list":_vm.addressData,"value-text-align":"right","placeholder":"请选择省-市-区"},model:{value:(_vm.address1),callback:function ($$v) {_vm.address1=$$v},expression:"address1"}}),_vm._v(" "),_c('x-input',{ref:"input2",attrs:{"min":3,"type":"text","show-clear":false,"placeholder":"详细地址*"},model:{value:(_vm.address2),callback:function ($$v) {_vm.address2=$$v},expression:"address2"}}),_vm._v(" "),_c('x-input',{ref:"input3",attrs:{"title":"邮编","min":6,"max":6,"type":"number","show-clear":false},model:{value:(_vm.zipcode),callback:function ($$v) {_vm.zipcode=$$v},expression:"zipcode"}}),_vm._v(" "),_c('x-input',{ref:"input4",attrs:{"title":"紧急联系人*","show-clear":false,"required":"","max":"16"},model:{value:(_vm.ename),callback:function ($$v) {_vm.ename=$$v},expression:"ename"}}),_vm._v(" "),_c('x-input',{ref:"input5",attrs:{"title":"紧急联系人手机*","show-clear":false,"is-type":"china-mobile","required":""},model:{value:(_vm.emobile),callback:function ($$v) {_vm.emobile=$$v},expression:"emobile"}}),_vm._v(" "),_c('x-input',{ref:"input6",attrs:{"title":"紧急联系人座机","type":"tel","show-clear":false},model:{value:(_vm.etelephone),callback:function ($$v) {_vm.etelephone=$$v},expression:"etelephone"}}),_vm._v(" "),_c('x-switch',{attrs:{"title":"账户信息是否允许公司可见"},on:{"on-change":function($event){_vm.updateVisible()}},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}}),_vm._v(" "),_c('toast',{attrs:{"type":"text","text":_vm.strInfo},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("添加个人专家")])],1)}
var addexpertInfo_staticRenderFns = []
var addexpertInfo_esExports = { render: addexpertInfo_render, staticRenderFns: addexpertInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_addexpertInfo = (addexpertInfo_esExports);
// CONCATENATED MODULE: ./src/components/addexpertInfo.vue
var addexpertInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addexpertInfo___vue_template_functional__ = false
/* styles */
var addexpertInfo___vue_styles__ = null
/* scopeId */
var addexpertInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var addexpertInfo___vue_module_identifier__ = null
var addexpertInfo_Component = addexpertInfo_normalizeComponent(
  components_addexpertInfo,
  selectortype_template_index_0_src_components_addexpertInfo,
  addexpertInfo___vue_template_functional__,
  addexpertInfo___vue_styles__,
  addexpertInfo___vue_scopeId__,
  addexpertInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_addexpertInfo = (addexpertInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cancel.vue














/* harmony default export */ var cancel = ({
  components: {
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      iden: '',
      cont: '',
      orderDetail: {},
      name: ''
    };
  },

  methods: {
    confirm: function confirm() {
      var that = this;
      var obj = {};
      if (this.name == 'cancel') {
        obj = {
          role: this.iden,
          op: 'REGRET',
          comment: this.cont
        };
      }

      if (this.name == 'reject') {
        obj = {
          role: this.iden,
          op: 'REJECT',
          comment: this.cont
        };
      }

      console.log(obj);
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      console.log(header);
      if (this.cont != '') {
        this.$http.post('/api/v1/normalrepairs/' + this.orderDetail.seq + '/order', obj, header).then(function (res) {
          that.$router.push({ name: 'engineer' });
        }).catch(function (error) {
          that.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).faultstring,
            type: 'cancel',
            time: '1000'
          });
        });
      } else {
        this.$vux.toast.show({
          text: '描述信息不能为空',
          type: 'cancel',
          time: '1000'
        });
      }
    }
  },
  created: function created() {
    this.name = this.$route.params.name;
    var order = localStorage.getItem('order');
    this.orderDetail = JSON.parse(order);
    var that = this;
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
      console.log(res);

      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == 'EXPT') {
          that.iden = 'EXPT';
        }
        if (res.data[i].type == 'SRVP') {
          that.iden = 'SRVP';
        }
      }
    }).catch(function (error) {
      that.$vux.toast.show({
        text: JSON.parse(error.response.data.error_message).zh_string,
        type: 'cancel',
        time: '1000'
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cancel.vue














/* harmony default export */ var components_cancel = ({
  components: {
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      iden: '',
      cont: '',
      orderDetail: {},
      name: ''
    };
  },

  methods: {
    confirm: function confirm() {
      var that = this;
      var obj = {};
      if (this.name == 'cancel') {
        obj = {
          role: this.iden,
          op: 'REGRET',
          comment: this.cont
        };
      }

      if (this.name == 'reject') {
        obj = {
          role: this.iden,
          op: 'REJECT',
          comment: this.cont
        };
      }

      console.log(obj);
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      console.log(header);
      if (this.cont != '') {
        this.$http.post('/api/v1/normalrepairs/' + this.orderDetail.seq + '/order', obj, header).then(function (res) {
          that.$router.push({ name: 'engineer' });
        }).catch(function (error) {
          that.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).faultstring,
            type: 'cancel',
            time: '1000'
          });
        });
      } else {
        this.$vux.toast.show({
          text: '描述信息不能为空',
          type: 'cancel',
          time: '1000'
        });
      }
    }
  },
  created: function created() {
    this.name = this.$route.params.name;
    var order = localStorage.getItem('order');
    this.orderDetail = JSON.parse(order);
    var that = this;
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
      console.log(res);

      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == 'EXPT') {
          that.iden = 'EXPT';
        }
        if (res.data[i].type == 'SRVP') {
          that.iden = 'SRVP';
        }
      }
    }).catch(function (error) {
      that.$vux.toast.show({
        text: JSON.parse(error.response.data.error_message).zh_string,
        type: 'cancel',
        time: '1000'
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d173ef8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cancel.vue
var cancel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cont),expression:"cont"}],staticClass:"text",attrs:{"maxlength":"200","placeholder":"描述信息..."},domProps:{"value":(_vm.cont)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cont=$event.target.value}}},[_vm._v(">")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定")])],1)}
var cancel_staticRenderFns = []
var cancel_esExports = { render: cancel_render, staticRenderFns: cancel_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_cancel = (cancel_esExports);
// CONCATENATED MODULE: ./src/components/cancel.vue
function cancel_injectStyle (ssrContext) {
  __webpack_require__("go8J")
}
var cancel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cancel___vue_template_functional__ = false
/* styles */
var cancel___vue_styles__ = cancel_injectStyle
/* scopeId */
var cancel___vue_scopeId__ = "data-v-5d173ef8"
/* moduleIdentifier (server only) */
var cancel___vue_module_identifier__ = null
var cancel_Component = cancel_normalizeComponent(
  components_cancel,
  selectortype_template_index_0_src_components_cancel,
  cancel___vue_template_functional__,
  cancel___vue_styles__,
  cancel___vue_scopeId__,
  cancel___vue_module_identifier__
)

/* harmony default export */ var src_components_cancel = (cancel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/confirmfault.vue















/* harmony default export */ var confirmfault = ({
  components: {
    Group: group["a" /* default */],
    Tab: src_components_tab_tab,
    Cell: vux_src_components_cell,
    TabItem: src_components_tab_tab_item,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      eduList: [{ key: 'YES', value: '确认故障' }, { key: "NO", value: '不是故障' }, { key: "INVALID", value: '无效' }],
      result: 'YES',
      iden: '',
      orderDetail: {},
      showLoading: false
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.showLoading = true;
      console.log(this.result);
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      var newobj = {
        role: this.iden,
        result: this.result
      };
      var that = this;

      this.$http.put('/api/v1/normalrepairs/' + this.orderDetail.seq + '/confirm', newobj, header).then(function (res) {
        that.$router.push({ name: 'engineer' });
      }).catch(function (error) {
        that.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
        _this.showLoading = false;
      });
    }
  },
  created: function created() {
    this.orderDetail = this.$route.params.obj;
    console.log(this.orderDetail);
    if (this.orderDetail.confirm != 'WAIT') {
      this.result = this.orderDetail.confirm;
    }
    var opid = localStorage.getItem('userid');
    var that = this;
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {

      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == 'EXPT') {
          that.iden = 'EXPT';
        }
        if (res.data[i].type == 'SRVP') {
          that.iden = 'SRVP';
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/confirmfault.vue















/* harmony default export */ var components_confirmfault = ({
  components: {
    Group: group["a" /* default */],
    Tab: src_components_tab_tab,
    Cell: vux_src_components_cell,
    TabItem: src_components_tab_tab_item,
    XButton: vux_src_components_x_button,
    XInput: vux_src_components_x_input,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      eduList: [{ key: 'YES', value: '确认故障' }, { key: "NO", value: '不是故障' }, { key: "INVALID", value: '无效' }],
      result: 'YES',
      iden: '',
      orderDetail: {},
      showLoading: false
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.showLoading = true;
      console.log(this.result);
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      var newobj = {
        role: this.iden,
        result: this.result
      };
      var that = this;

      this.$http.put('/api/v1/normalrepairs/' + this.orderDetail.seq + '/confirm', newobj, header).then(function (res) {
        that.$router.push({ name: 'engineer' });
      }).catch(function (error) {
        that.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
        _this.showLoading = false;
      });
    }
  },
  created: function created() {
    this.orderDetail = this.$route.params.obj;
    console.log(this.orderDetail);
    if (this.orderDetail.confirm != 'WAIT') {
      this.result = this.orderDetail.confirm;
    }
    var opid = localStorage.getItem('userid');
    var that = this;
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {

      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == 'EXPT') {
          that.iden = 'EXPT';
        }
        if (res.data[i].type == 'SRVP') {
          that.iden = 'SRVP';
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62d338e9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/confirmfault.vue
var confirmfault_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('selector',{attrs:{"title":"是否故障","placeholder":"是否故障","options":_vm.eduList},model:{value:(_vm.result),callback:function ($$v) {_vm.result=$$v},expression:"result"}})],1),_vm._v(" "),_c('div',{staticClass:"btnbox"},[_c('x-button',{staticClass:"btn",attrs:{"show-loading":_vm.showLoading,"disabled":_vm.showLoading},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("确认")]),_vm._v(" "),_c('x-button',{staticClass:"btn",nativeOn:{"click":function($event){_vm.$router.back(-1)}}},[_vm._v("取消")])],1)],1)}
var confirmfault_staticRenderFns = []
var confirmfault_esExports = { render: confirmfault_render, staticRenderFns: confirmfault_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_confirmfault = (confirmfault_esExports);
// CONCATENATED MODULE: ./src/components/confirmfault.vue
function confirmfault_injectStyle (ssrContext) {
  __webpack_require__("tUL0")
}
var confirmfault_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirmfault___vue_template_functional__ = false
/* styles */
var confirmfault___vue_styles__ = confirmfault_injectStyle
/* scopeId */
var confirmfault___vue_scopeId__ = "data-v-62d338e9"
/* moduleIdentifier (server only) */
var confirmfault___vue_module_identifier__ = null
var confirmfault_Component = confirmfault_normalizeComponent(
  components_confirmfault,
  selectortype_template_index_0_src_components_confirmfault,
  confirmfault___vue_template_functional__,
  confirmfault___vue_styles__,
  confirmfault___vue_scopeId__,
  confirmfault___vue_module_identifier__
)

/* harmony default export */ var src_components_confirmfault = (confirmfault_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/finish.vue












/* harmony default export */ var finish = ({
  components: { Group: group["a" /* default */], Selector: vux_src_components_selector, XTextarea: vux_src_components_x_textarea, XButton: vux_src_components_x_button, Cell: vux_src_components_cell },
  data: function data() {
    return {
      eduList: [{ key: 'SUCCESS', value: '成功' }, { key: "FAIL", value: '失败' }],
      result: 'SUCCESS',
      iden: this.$route.params.role,
      addition: '',
      conclusion: '',
      orderDetail: {},
      imgList: [],
      list: [],
      showLoading: false,
      appendix: [],
      filename: ''
    };
  },

  methods: {
    upload: function upload() {
      var _this = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          var localIds = res.localIds;
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {

                _this.$vux.loading.show();
                obj.photo.push(res.serverId);
                _this.submitImage(obj);
              },
              fail: function fail(error) {
                console.log(error);
              }
            });
          };
          upload();
        },
        fail: function fail(error) {
          console.log(error);
        }
      });
    },
    removeFile: function removeFile(index) {
      this.appendix = [];
      this.list = [];
      this.filename = '';
    },
    choseFile: function choseFile() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var fs, appendix, i, formData, d, arr, response;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fs = void 0;
                appendix = [];


                fs = _this2.$refs.file.files;

                _this2.$vux.loading.show({
                  text: 'Loading'
                });
                i = 0;

              case 5:
                if (!(i < fs.length)) {
                  _context.next = 24;
                  break;
                }

                formData = new FormData();
                d = fs[i];

                if (!(d.size <= 1024 * 1024 * 100)) {
                  _context.next = 19;
                  break;
                }

                //文件必须小于100M
                formData.append("file", fs[i]);
                arr = d.name;

                formData.append("name", arr);
                _context.next = 14;
                return _this2.$http.post('api/v1/photos/upload', formData);

              case 14:
                response = _context.sent;

                appendix.push({ origin: response.data.path, thumb: response.data.path });

                _this2.filename = arr;
                _context.next = 21;
                break;

              case 19:
                alert('上传文件过大！');
                return _context.abrupt('return', false);

              case 21:
                i++;
                _context.next = 5;
                break;

              case 24:
                _this2.$vux.loading.hide();

                _this2.appendix = appendix;
                _this2.list = appendix;

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    submitImage: function submitImage(userInfo) {
      var _this3 = this;

      this.$http.post('/api/v1/photos/wechat', userInfo).then(function (response) {
        _this3.list.push(response.data[0]);
        _this3.decrypt(response.data[0]);
      }).catch(function (error) {
        if (error.response) {
          if (error.response.data.error_message) {
            _this3.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          } else {
            _this3.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          }
        } else {
          _this3.$vux.toast.show({
            text: '服务器错误，请稍后重试',
            type: 'cancel',
            time: '1000'
          });
        }
      });
    },
    decrypt: function decrypt(path) {
      var _this4 = this;

      this.$http.get('api/v1/photos?path=' + path.thumb).then(function (res) {
        _this4.imgList.push(res.data);
        _this4.$vux.loading.hide();
      });
    },
    fileDel: function fileDel() {
      this.imgList = [];
      this.list = [];
      this.filename = '';
    },
    cancelResult: function cancelResult() {
      var that = this;
      if (this.orderDetail.userconfirm === '拒绝') {
        this.$vux.confirm.show({
          content: '如用户再次拒绝，将会进入仲裁流程',
          theme: 'android',
          onCancel: function onCancel() {},
          onConfirm: function onConfirm() {
            that.submit();
          }
        });
      } else {
        this.submit();
      }
    },
    submit: function submit() {
      var _this5 = this;

      this.showLoading = true;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      if (this.result === 'FAIL') {
        this.list = [];
      }
      if (this.list.length === 0 && this.conclusion.length < 20) {
        alert('请详细描述维修结论，不少于20字');
        this.showLoading = false;
        return;
      } else if (this.list.length !== 0 && this.conclusion.length <= 1) {
        alert('请填写维修结论');
        this.showLoading = false;
        return;
      }
      if (!this.orderDetail.has_log) {
        alert('请补充维修日志');
        return;
      }
      var newobj = {
        role: this.iden,
        result: this.result,
        addition: this.addition,
        conclusion: this.conclusion,
        signature: {
          version: '1.1',
          content: [{ path: this.list, describe: this.filename }]
        }
      };
      console.log(this.orderDetail);
      this.$http.put('/api/v1/normalrepairs/' + this.orderDetail.seq + '/result', newobj, header).then(function (res) {
        _this5.$router.push({ name: 'engineer' });
      }).catch(function (error) {
        _this5.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
        _this5.showLoading = false;
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this6;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    var _this7 = this;

    this.orderDetail = this.$route.params.obj;
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type === 'EXPT') {
          _this7.iden = 'EXPT';
        }
        if (res.data[i].type === 'SRVP') {
          _this7.iden = 'SRVP';
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/finish.vue












/* harmony default export */ var components_finish = ({
  components: { Group: group["a" /* default */], Selector: vux_src_components_selector, XTextarea: vux_src_components_x_textarea, XButton: vux_src_components_x_button, Cell: vux_src_components_cell },
  data: function data() {
    return {
      eduList: [{ key: 'SUCCESS', value: '成功' }, { key: "FAIL", value: '失败' }],
      result: 'SUCCESS',
      iden: this.$route.params.role,
      addition: '',
      conclusion: '',
      orderDetail: {},
      imgList: [],
      list: [],
      showLoading: false,
      appendix: [],
      filename: ''
    };
  },

  methods: {
    upload: function upload() {
      var _this = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          var localIds = res.localIds;
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {

                _this.$vux.loading.show();
                obj.photo.push(res.serverId);
                _this.submitImage(obj);
              },
              fail: function fail(error) {
                console.log(error);
              }
            });
          };
          upload();
        },
        fail: function fail(error) {
          console.log(error);
        }
      });
    },
    removeFile: function removeFile(index) {
      this.appendix = [];
      this.list = [];
      this.filename = '';
    },
    choseFile: function choseFile() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var fs, appendix, i, formData, d, arr, response;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fs = void 0;
                appendix = [];


                fs = _this2.$refs.file.files;

                _this2.$vux.loading.show({
                  text: 'Loading'
                });
                i = 0;

              case 5:
                if (!(i < fs.length)) {
                  _context.next = 24;
                  break;
                }

                formData = new FormData();
                d = fs[i];

                if (!(d.size <= 1024 * 1024 * 100)) {
                  _context.next = 19;
                  break;
                }

                //文件必须小于100M
                formData.append("file", fs[i]);
                arr = d.name;

                formData.append("name", arr);
                _context.next = 14;
                return _this2.$http.post('api/v1/photos/upload', formData);

              case 14:
                response = _context.sent;

                appendix.push({ origin: response.data.path, thumb: response.data.path });

                _this2.filename = arr;
                _context.next = 21;
                break;

              case 19:
                alert('上传文件过大！');
                return _context.abrupt('return', false);

              case 21:
                i++;
                _context.next = 5;
                break;

              case 24:
                _this2.$vux.loading.hide();

                _this2.appendix = appendix;
                _this2.list = appendix;

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    submitImage: function submitImage(userInfo) {
      var _this3 = this;

      this.$http.post('/api/v1/photos/wechat', userInfo).then(function (response) {
        _this3.list.push(response.data[0]);
        _this3.decrypt(response.data[0]);
      }).catch(function (error) {
        if (error.response) {
          if (error.response.data.error_message) {
            _this3.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          } else {
            _this3.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          }
        } else {
          _this3.$vux.toast.show({
            text: '服务器错误，请稍后重试',
            type: 'cancel',
            time: '1000'
          });
        }
      });
    },
    decrypt: function decrypt(path) {
      var _this4 = this;

      this.$http.get('api/v1/photos?path=' + path.thumb).then(function (res) {
        _this4.imgList.push(res.data);
        _this4.$vux.loading.hide();
      });
    },
    fileDel: function fileDel() {
      this.imgList = [];
      this.list = [];
      this.filename = '';
    },
    cancelResult: function cancelResult() {
      var that = this;
      if (this.orderDetail.userconfirm === '拒绝') {
        this.$vux.confirm.show({
          content: '如用户再次拒绝，将会进入仲裁流程',
          theme: 'android',
          onCancel: function onCancel() {},
          onConfirm: function onConfirm() {
            that.submit();
          }
        });
      } else {
        this.submit();
      }
    },
    submit: function submit() {
      var _this5 = this;

      this.showLoading = true;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      if (this.result === 'FAIL') {
        this.list = [];
      }
      if (this.list.length === 0 && this.conclusion.length < 20) {
        alert('请详细描述维修结论，不少于20字');
        this.showLoading = false;
        return;
      } else if (this.list.length !== 0 && this.conclusion.length <= 1) {
        alert('请填写维修结论');
        this.showLoading = false;
        return;
      }
      if (!this.orderDetail.has_log) {
        alert('请补充维修日志');
        return;
      }
      var newobj = {
        role: this.iden,
        result: this.result,
        addition: this.addition,
        conclusion: this.conclusion,
        signature: {
          version: '1.1',
          content: [{ path: this.list, describe: this.filename }]
        }
      };
      console.log(this.orderDetail);
      this.$http.put('/api/v1/normalrepairs/' + this.orderDetail.seq + '/result', newobj, header).then(function (res) {
        _this5.$router.push({ name: 'engineer' });
      }).catch(function (error) {
        _this5.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
        _this5.showLoading = false;
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this6;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    var _this7 = this;

    this.orderDetail = this.$route.params.obj;
    var opid = localStorage.getItem('userid');
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type === 'EXPT') {
          _this7.iden = 'EXPT';
        }
        if (res.data[i].type === 'SRVP') {
          _this7.iden = 'SRVP';
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ff64d1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/finish.vue
var finish_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('selector',{attrs:{"title":"维修结果","placeholder":"维修结果","options":_vm.eduList},model:{value:(_vm.result),callback:function ($$v) {_vm.result=$$v},expression:"result"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"维修结论","max":256},model:{value:(_vm.conclusion),callback:function ($$v) {_vm.conclusion=$$v},expression:"conclusion"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"附加说明","max":128},model:{value:(_vm.addition),callback:function ($$v) {_vm.addition=$$v},expression:"addition"}}),_vm._v(" "),_c('div',[_c('cell',{attrs:{"title":"用户确认单"}}),_vm._v(" "),_c('div',[_c('h4',[_vm._v("上传图片\n          "),(_vm.result === 'SUCCESS')?_c('div',{staticClass:"upload_warp_img"},[_vm._l((_vm.imgList),function(val,index){return _c('div',{key:index,staticClass:"upload_warp_img_div"},[_c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"width":"100px","height":"75px"},attrs:{"src":'data:image/jpeg;base64,'+val.value}})]),_vm._v(" "),_c('div',{staticClass:"upload_warp_img_div_top"},[_c('span',{staticClass:"upload_warp_img_div_del",on:{"click":function($event){_vm.fileDel(val.value,val.path)}}},[_vm._v("×")])])])}),_vm._v(" "),(_vm.list.length==0)?_c('div',{staticClass:"upload_warp"},[_c('div',{staticClass:"upload_warp_left",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.upload()}}},[_c('div',{staticClass:"icon-add-50"})])]):_vm._e()],2):_vm._e()])]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("上传附件\n          "),_c('input',{ref:"file",attrs:{"type":"file","id":"file"},on:{"change":function($event){_vm.choseFile()}}})])])],1)],1),_vm._v(" "),_c('div',{staticClass:"btnbox"},[_c('x-button',{staticClass:"btn",attrs:{"show-loading":_vm.showLoading,"disabled":_vm.showLoading},nativeOn:{"click":function($event){return _vm.cancelResult($event)}}},[_vm._v("确认\n    ")]),_vm._v(" "),_c('x-button',{staticClass:"btn",nativeOn:{"click":function($event){_vm.$router.back(-1)}}},[_vm._v("取消")])],1)],1)}
var finish_staticRenderFns = []
var finish_esExports = { render: finish_render, staticRenderFns: finish_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_finish = (finish_esExports);
// CONCATENATED MODULE: ./src/components/finish.vue
function finish_injectStyle (ssrContext) {
  __webpack_require__("AiL5")
}
var finish_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var finish___vue_template_functional__ = false
/* styles */
var finish___vue_styles__ = finish_injectStyle
/* scopeId */
var finish___vue_scopeId__ = "data-v-6ff64d1c"
/* moduleIdentifier (server only) */
var finish___vue_module_identifier__ = null
var finish_Component = finish_normalizeComponent(
  components_finish,
  selectortype_template_index_0_src_components_finish,
  finish___vue_template_functional__,
  finish___vue_styles__,
  finish___vue_scopeId__,
  finish___vue_module_identifier__
)

/* harmony default export */ var src_components_finish = (finish_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/rater/index.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var rater = ({
  name: 'rater',
  created: function created() {
    this.currentValue = parseFloat(this.value);
  },
  mounted: function mounted() {
    this.updateStyle();
  },

  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 5
    },
    value: {
      type: [Number, String],
      default: 0
    },
    disabled: Boolean,
    star: {
      type: String,
      default: '★'
    },
    activeColor: {
      type: String,
      default: '#fc6'
    },
    margin: {
      type: Number,
      default: 2
    },
    fontSize: {
      type: Number,
      default: 25
    }
  },
  computed: {
    sliceValue: function sliceValue() {
      var _val = this.currentValue.toFixed(2).split('.');
      return _val.length === 1 ? [_val[0], 0] : _val;
    },
    cutIndex: function cutIndex() {
      return this.sliceValue[0] * 1;
    },
    cutPercent: function cutPercent() {
      return this.sliceValue[1] * 1;
    }
  },
  methods: {
    handleClick: function handleClick(i, force) {
      if (!this.disabled || force) {
        if (this.currentValue === i + 1) {
          this.currentValue = i < this.min ? this.min : i;
          this.updateStyle();
        } else {
          this.currentValue = i + 1 < this.min ? this.min : i + 1;
        }
      }
    },
    updateStyle: function updateStyle() {
      for (var j = 0; j < this.max; j++) {
        if (j <= this.currentValue - 1) {
          this.$set(this.colors, j, this.activeColor);
        } else {
          this.$set(this.colors, j, '#ccc');
        }
      }
    }
  },
  data: function data() {
    return {
      colors: [],
      currentValue: 0
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      this.updateStyle();
      this.$emit('input', val);
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/rater/index.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_rater = ({
  name: 'rater',
  created: function created() {
    this.currentValue = parseFloat(this.value);
  },
  mounted: function mounted() {
    this.updateStyle();
  },

  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 5
    },
    value: {
      type: [Number, String],
      default: 0
    },
    disabled: Boolean,
    star: {
      type: String,
      default: '★'
    },
    activeColor: {
      type: String,
      default: '#fc6'
    },
    margin: {
      type: Number,
      default: 2
    },
    fontSize: {
      type: Number,
      default: 25
    }
  },
  computed: {
    sliceValue: function sliceValue() {
      var _val = this.currentValue.toFixed(2).split('.');
      return _val.length === 1 ? [_val[0], 0] : _val;
    },
    cutIndex: function cutIndex() {
      return this.sliceValue[0] * 1;
    },
    cutPercent: function cutPercent() {
      return this.sliceValue[1] * 1;
    }
  },
  methods: {
    handleClick: function handleClick(i, force) {
      if (!this.disabled || force) {
        if (this.currentValue === i + 1) {
          this.currentValue = i < this.min ? this.min : i;
          this.updateStyle();
        } else {
          this.currentValue = i + 1 < this.min ? this.min : i + 1;
        }
      }
    },
    updateStyle: function updateStyle() {
      for (var j = 0; j < this.max; j++) {
        if (j <= this.currentValue - 1) {
          this.$set(this.colors, j, this.activeColor);
        } else {
          this.$set(this.colors, j, '#ccc');
        }
      }
    }
  },
  data: function data() {
    return {
      colors: [],
      currentValue: 0
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      this.updateStyle();
      this.$emit('input', val);
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fab7b050","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/rater/index.vue
var rater_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-rater"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticStyle:{"display":"none"},domProps:{"value":(_vm.currentValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_vm._l((_vm.max),function(i){return _c('a',{staticClass:"vux-rater-box",class:{'is-active':_vm.currentValue > i-1},style:({color: _vm.colors && _vm.colors[i-1] ? _vm.colors[i-1] : '#ccc',marginRight:_vm.margin+'px',fontSize: _vm.fontSize + 'px', width: _vm.fontSize + 'px', height: _vm.fontSize + 'px', lineHeight: _vm.fontSize + 'px'}),on:{"click":function($event){_vm.handleClick(i-1)}}},[_c('span',{staticClass:"vux-rater-inner"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.star)}}),(_vm.cutPercent > 0 && _vm.cutIndex === i-1)?_c('span',{staticClass:"vux-rater-outer",style:({color: _vm.activeColor, width: _vm.cutPercent + '%'}),domProps:{"innerHTML":_vm._s(_vm.star)}}):_vm._e()])])})],2)}
var rater_staticRenderFns = []
var rater_esExports = { render: rater_render, staticRenderFns: rater_staticRenderFns }
/* harmony default export */ var src_components_rater = (rater_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/rater/index.vue
function rater_injectStyle (ssrContext) {
  __webpack_require__("mfyC")
}
var rater_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var rater___vue_template_functional__ = false
/* styles */
var rater___vue_styles__ = rater_injectStyle
/* scopeId */
var rater___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var rater___vue_module_identifier__ = null
var rater_Component = rater_normalizeComponent(
  components_rater,
  src_components_rater,
  rater___vue_template_functional__,
  rater___vue_styles__,
  rater___vue_scopeId__,
  rater___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_rater = (rater_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userevaluation.vue













/* harmony default export */ var userevaluation = ({
  components: {
    XButton: vux_src_components_x_button,
    Group: group["a" /* default */],
    Cell: vux_src_components_cell,
    Rater: vux_src_components_rater
  },
  data: function data() {
    return {
      data: 0,
      cont: '',
      orderDetail: {},
      flag: true,
      disabled: false,
      showLoading: false
    };
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      this.showLoading = true;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      var obj = {
        star: this.data,
        rating: this.cont
      };
      var that = this;
      console.log(obj);
      if (this.cont != '') {
        this.$http.put('/api/v1/normalrepairs/' + this.orderDetail.seq + '/comment', obj, header).then(function (res) {
          console.log(res);
          that.$router.push({ name: 'normalrepairslist' });
        }).catch(function (err) {
          console.log(err.response);
          _this.showLoading = false;
        });
      } else {
        this.$vux.alert.show({
          title: '',
          content: '评论信息不能为空'
        });
        this.showLoading = false;
      }
    }
  },
  created: function created() {
    this.orderDetail = this.$route.params.obj;
    if (this.orderDetail.rating) {
      this.data = this.orderDetail.star;
      this.cont = this.orderDetail.rating;
      this.flag = false;
      this.disabled = true;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name != 'normaldone') {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        if (vm.orderDetail.rating) {
          vm.data = vm.orderDetail.star;
          vm.cont = vm.orderDetail.rating;
          vm.flag = false;
          vm.disabled = true;
        }
      });
    } else {
      next();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/userevaluation.vue













/* harmony default export */ var components_userevaluation = ({
  components: {
    XButton: vux_src_components_x_button,
    Group: group["a" /* default */],
    Cell: vux_src_components_cell,
    Rater: vux_src_components_rater
  },
  data: function data() {
    return {
      data: 0,
      cont: '',
      orderDetail: {},
      flag: true,
      disabled: false,
      showLoading: false
    };
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      this.showLoading = true;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      var obj = {
        star: this.data,
        rating: this.cont
      };
      var that = this;
      console.log(obj);
      if (this.cont != '') {
        this.$http.put('/api/v1/normalrepairs/' + this.orderDetail.seq + '/comment', obj, header).then(function (res) {
          console.log(res);
          that.$router.push({ name: 'normalrepairslist' });
        }).catch(function (err) {
          console.log(err.response);
          _this.showLoading = false;
        });
      } else {
        this.$vux.alert.show({
          title: '',
          content: '评论信息不能为空'
        });
        this.showLoading = false;
      }
    }
  },
  created: function created() {
    this.orderDetail = this.$route.params.obj;
    if (this.orderDetail.rating) {
      this.data = this.orderDetail.star;
      this.cont = this.orderDetail.rating;
      this.flag = false;
      this.disabled = true;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name != 'normaldone') {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        if (vm.orderDetail.rating) {
          vm.data = vm.orderDetail.star;
          vm.cont = vm.orderDetail.rating;
          vm.flag = false;
          vm.disabled = true;
        }
      });
    } else {
      next();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44fbb4fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userevaluation.vue
var userevaluation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('cell',{attrs:{"title":"服务态度"}},[_c('rater',{attrs:{"disabled":_vm.disabled},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)],1),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cont),expression:"cont"}],staticClass:"text",attrs:{"maxlength":"200","placeholder":"评论信息...","disabled":_vm.disabled},domProps:{"value":(_vm.cont)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cont=$event.target.value}}}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}],attrs:{"type":"primary","show-loading":_vm.showLoading,"disabled":_vm.showLoading},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定")])],1)}
var userevaluation_staticRenderFns = []
var userevaluation_esExports = { render: userevaluation_render, staticRenderFns: userevaluation_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_userevaluation = (userevaluation_esExports);
// CONCATENATED MODULE: ./src/components/userevaluation.vue
function userevaluation_injectStyle (ssrContext) {
  __webpack_require__("S3+C")
}
var userevaluation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var userevaluation___vue_template_functional__ = false
/* styles */
var userevaluation___vue_styles__ = userevaluation_injectStyle
/* scopeId */
var userevaluation___vue_scopeId__ = "data-v-44fbb4fc"
/* moduleIdentifier (server only) */
var userevaluation___vue_module_identifier__ = null
var userevaluation_Component = userevaluation_normalizeComponent(
  components_userevaluation,
  selectortype_template_index_0_src_components_userevaluation,
  userevaluation___vue_template_functional__,
  userevaluation___vue_styles__,
  userevaluation___vue_scopeId__,
  userevaluation___vue_module_identifier__
)

/* harmony default export */ var src_components_userevaluation = (userevaluation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myrecordcomplete.vue










/* harmony default export */ var myrecordcomplete = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      flag: false,
      orderDetail: {},
      role: ''
    };
  },

  methods: {
    confirm: function confirm() {
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var obj = {
        role: this.role
      };
      this.$http.post('api/v1/projects/' + this.orderDetail.seq + '/refresh', obj, header).then(function (res) {
        that.$router.push({ name: 'myrecord' });
        console.log(res);
      }).catch(function (error) {
        console.log(error.response);
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'myrecord') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        console.log(vm.orderDetail);
        if (vm.orderDetail.state == '备案超时') {
          vm.flag = true;
        }
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);

        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.role = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.role = 'ENTP';
            }
            if (res.data[i].type == 'EXPT') {
              vm.role = 'EXPT';
            }
            if (res.data[i].type == 'SRVP') {
              vm.role = 'SRVP';
            }
          }
        });
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);

        if (vm.orderDetail.state == '备案超时') {
          vm.flag = true;
        }
        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.role = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.role = 'ENTP';
            }
            if (res.data[i].type == 'EXPT') {
              vm.role = 'EXPT';
            }
            if (res.data[i].type == 'SRVP') {
              vm.role = 'SRVP';
            }
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myrecordcomplete.vue










/* harmony default export */ var components_myrecordcomplete = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      flag: false,
      orderDetail: {},
      role: ''
    };
  },

  methods: {
    confirm: function confirm() {
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var obj = {
        role: this.role
      };
      this.$http.post('api/v1/projects/' + this.orderDetail.seq + '/refresh', obj, header).then(function (res) {
        that.$router.push({ name: 'myrecord' });
        console.log(res);
      }).catch(function (error) {
        console.log(error.response);
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'myrecord') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        console.log(vm.orderDetail);
        if (vm.orderDetail.state == '备案超时') {
          vm.flag = true;
        }
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);

        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.role = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.role = 'ENTP';
            }
            if (res.data[i].type == 'EXPT') {
              vm.role = 'EXPT';
            }
            if (res.data[i].type == 'SRVP') {
              vm.role = 'SRVP';
            }
          }
        });
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);

        if (vm.orderDetail.state == '备案超时') {
          vm.flag = true;
        }
        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.role = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.role = 'ENTP';
            }
            if (res.data[i].type == 'EXPT') {
              vm.role = 'EXPT';
            }
            if (res.data[i].type == 'SRVP') {
              vm.role = 'SRVP';
            }
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce42dc16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myrecordcomplete.vue
var myrecordcomplete_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报备订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"用户名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.customer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "customer", $$v)},expression:"orderDetail.customer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.devtype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devtype", $$v)},expression:"orderDetail.devtype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"推荐代理商","type":"text","readonly":""},model:{value:(_vm.orderDetail.agent),callback:function ($$v) {_vm.$set(_vm.orderDetail, "agent", $$v)},expression:"orderDetail.agent"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报备时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.recordt),callback:function ($$v) {_vm.$set(_vm.orderDetail, "recordt", $$v)},expression:"orderDetail.recordt"}})],1),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}],attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("重新备案")])],1)}
var myrecordcomplete_staticRenderFns = []
var myrecordcomplete_esExports = { render: myrecordcomplete_render, staticRenderFns: myrecordcomplete_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_myrecordcomplete = (myrecordcomplete_esExports);
// CONCATENATED MODULE: ./src/components/myrecordcomplete.vue
var myrecordcomplete_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myrecordcomplete___vue_template_functional__ = false
/* styles */
var myrecordcomplete___vue_styles__ = null
/* scopeId */
var myrecordcomplete___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var myrecordcomplete___vue_module_identifier__ = null
var myrecordcomplete_Component = myrecordcomplete_normalizeComponent(
  components_myrecordcomplete,
  selectortype_template_index_0_src_components_myrecordcomplete,
  myrecordcomplete___vue_template_functional__,
  myrecordcomplete___vue_styles__,
  myrecordcomplete___vue_scopeId__,
  myrecordcomplete___vue_module_identifier__
)

/* harmony default export */ var src_components_myrecordcomplete = (myrecordcomplete_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myrecorddone.vue










/* harmony default export */ var myrecorddone = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      orderDetail: {},
      show: false,
      flag: false,
      hide: true,
      role: ''
    };
  },

  methods: {
    reward: function reward() {
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var obj = {
        role: this.role
      };
      this.$http.post('api/v1/projects/' + this.orderDetail.seq, obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'myrecord' });
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    confirm: function confirm() {
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var obj = {
        role: this.role
      };
      this.$http.post('api/v1/projects/' + this.orderDetail.seq + '/refresh', obj, header).then(function (res) {
        that.$router.push({ name: 'myrecord' });
        console.log(res);
      }).catch(function (error) {
        console.log(error.response);
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'myrecord') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        if (vm.orderDetail.state == '备案审批通过') {
          vm.show = true;
        }
        if (vm.orderDetail.state == '备案超时') {
          vm.flag = true;
        }
        if (!vm.orderDetail.detail) {
          vm.hide = false;
        }
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.role = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.role = 'ENTP';
            }
            if (res.data[i].type == 'EXPT') {
              vm.role = 'EXPT';
            }
            if (res.data[i].type == 'SRVP') {
              vm.role = 'SRVP';
            }
          }
        });
        console.log(vm.orderDetail);
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);

        if (vm.orderDetail.state == '备案审批通过') {
          vm.show = true;
        }
        if (vm.orderDetail.state == '备案超时') {
          vm.flag = true;
        }
        if (!vm.orderDetail.detail) {
          vm.hide = false;
        }

        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.role = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.role = 'ENTP';
            }
            if (res.data[i].type == 'EXPT') {
              vm.role = 'EXPT';
            }
            if (res.data[i].type == 'SRVP') {
              vm.role = 'SRVP';
            }
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myrecorddone.vue










/* harmony default export */ var components_myrecorddone = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      orderDetail: {},
      show: false,
      flag: false,
      hide: true,
      role: ''
    };
  },

  methods: {
    reward: function reward() {
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var obj = {
        role: this.role
      };
      this.$http.post('api/v1/projects/' + this.orderDetail.seq, obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'myrecord' });
      }).catch(function (error) {
        console.log(error.response);
      });
    },
    confirm: function confirm() {
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var obj = {
        role: this.role
      };
      this.$http.post('api/v1/projects/' + this.orderDetail.seq + '/refresh', obj, header).then(function (res) {
        that.$router.push({ name: 'myrecord' });
        console.log(res);
      }).catch(function (error) {
        console.log(error.response);
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'myrecord') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        if (vm.orderDetail.state == '备案审批通过') {
          vm.show = true;
        }
        if (vm.orderDetail.state == '备案超时') {
          vm.flag = true;
        }
        if (!vm.orderDetail.detail) {
          vm.hide = false;
        }
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.role = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.role = 'ENTP';
            }
            if (res.data[i].type == 'EXPT') {
              vm.role = 'EXPT';
            }
            if (res.data[i].type == 'SRVP') {
              vm.role = 'SRVP';
            }
          }
        });
        console.log(vm.orderDetail);
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);

        if (vm.orderDetail.state == '备案审批通过') {
          vm.show = true;
        }
        if (vm.orderDetail.state == '备案超时') {
          vm.flag = true;
        }
        if (!vm.orderDetail.detail) {
          vm.hide = false;
        }

        var token = localStorage.getItem('token');
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: token,
            opid: opid
          }
        };
        ajax["a" /* default */].$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.role = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.role = 'ENTP';
            }
            if (res.data[i].type == 'EXPT') {
              vm.role = 'EXPT';
            }
            if (res.data[i].type == 'SRVP') {
              vm.role = 'SRVP';
            }
          }
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dc0cd30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myrecorddone.vue
var myrecorddone_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报备订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"用户名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.customer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "customer", $$v)},expression:"orderDetail.customer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.devtype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devtype", $$v)},expression:"orderDetail.devtype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"推荐代理商","type":"text","readonly":""},model:{value:(_vm.orderDetail.agent),callback:function ($$v) {_vm.$set(_vm.orderDetail, "agent", $$v)},expression:"orderDetail.agent"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报备时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.recordt),callback:function ($$v) {_vm.$set(_vm.orderDetail, "recordt", $$v)},expression:"orderDetail.recordt"}}),_vm._v(" "),_c('x-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.hide),expression:"hide"}],attrs:{"title":"审核意见","type":"text","readonly":""},model:{value:(_vm.orderDetail.detail),callback:function ($$v) {_vm.$set(_vm.orderDetail, "detail", $$v)},expression:"orderDetail.detail"}})],1),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.reward($event)}}},[_vm._v("申请备案奖励")]),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}],attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("重新备案")])],1)}
var myrecorddone_staticRenderFns = []
var myrecorddone_esExports = { render: myrecorddone_render, staticRenderFns: myrecorddone_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_myrecorddone = (myrecorddone_esExports);
// CONCATENATED MODULE: ./src/components/myrecorddone.vue
var myrecorddone_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myrecorddone___vue_template_functional__ = false
/* styles */
var myrecorddone___vue_styles__ = null
/* scopeId */
var myrecorddone___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var myrecorddone___vue_module_identifier__ = null
var myrecorddone_Component = myrecorddone_normalizeComponent(
  components_myrecorddone,
  selectortype_template_index_0_src_components_myrecorddone,
  myrecorddone___vue_template_functional__,
  myrecorddone___vue_styles__,
  myrecorddone___vue_scopeId__,
  myrecorddone___vue_module_identifier__
)

/* harmony default export */ var src_components_myrecorddone = (myrecorddone_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8e11956","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/panel/index.vue
var panel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header)},on:{"click":_vm.onClickHeader}},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_vm._t("body",[(_vm.type === '1')?_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-media-box weui-media-box_appmsg",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){_vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])])}):_vm._e(),_vm._v(" "),(_vm.type === '2')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])}):_vm._e(),_vm._v(" "),(_vm.type === '3')?[_c('div',{staticClass:"weui-media-box weui-media-box_small-appmsg"},[_c('div',{staticClass:"weui-cells"},_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-cell__hd"},[_c('img',{staticStyle:{"width":"20px","margin-right":"5px","display":"block"},attrs:{"src":item.src,"alt":""},on:{"error":function($event){_vm.onImgError(item, $event)}}})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(item.title)}})]),_vm._v(" "),_c('span',{staticClass:"weui-cell__ft"})])}))])]:_vm._e(),_vm._v(" "),(_vm.type === '4')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}}),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e(),_vm._v(" "),(_vm.type === '5')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();_vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-media-box_appmsg"},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){_vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])]),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title && _vm.type !== '3')?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":_vm.getUrl(_vm.footer.url)},on:{"click":function($event){$event.preventDefault();return _vm.onClickFooter($event)}}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()])])}
var panel_staticRenderFns = []
var panel_esExports = { render: panel_render, staticRenderFns: panel_staticRenderFns }
/* harmony default export */ var src_components_panel = (panel_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/panel/index.vue
function panel_injectStyle (ssrContext) {
  __webpack_require__("429B")
}
var panel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var panel___vue_template_functional__ = false
/* styles */
var panel___vue_styles__ = panel_injectStyle
/* scopeId */
var panel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var panel___vue_module_identifier__ = null
var panel_Component = panel_normalizeComponent(
  components_panel,
  src_components_panel,
  panel___vue_template_functional__,
  panel___vue_styles__,
  panel___vue_scopeId__,
  panel___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_panel = (panel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var radio_props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-956dfba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])],{icon:one.icon,label:_vm.getValue(one),index:index,selected:_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){_vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("1Ahr")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/faultType.vue













/* harmony default export */ var components_faultType = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector,
    Panel: vux_src_components_panel,
    Radio: node_modules_vux_src_components_radio,
    XButton: vux_src_components_x_button,
    CellBox: vux_src_components_cell_box
  },
  data: function data() {
    return {
      fdesc: '',
      ftype: '使用问题',
      subClass1: '无法登陆管理界面',
      subClass2: '',
      selisShow: true,
      flag: false,
      inputisShow: false,
      list1: ['使用问题', '软件问题', '运输问题', '硬件问题', '其他问题'],
      list2: ['无法登陆管理界面', '无法修改配置', '客户端无法挂载', '存储无法访问', '非编回放/采集丢帧/彩条', '存储性能不佳', '数据丢失', '数据无法读写', '其他问题'],
      list3: [],
      obj: {
        ftype: '',
        fdesc: ""
      },
      lastflag: true,
      repair: this.$route.params.repair,
      save_info: this.$route.params.save_info
    };
  },

  methods: {
    confirm: function confirm() {
      if (this.selisShow) {
        this.obj.ftype = this.ftype + ',' + this.subClass1;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', this.subClass1);
      } else {
        this.obj.ftype = this.ftype;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', '');
      }
      if (this.flag) {
        this.obj.fdesc = this.subClass2;
        localStorage.setItem('subClass2', this.subClass2);
      } else {
        this.obj.fdesc = this.fdesc;
        localStorage.setItem('fdesc', this.fdesc);
        localStorage.setItem('subClass2', '');
      }
      if (this.obj.fdesc === '' || this.obj.ftype === '') {
        alert('请填写故障信息');
        return;
      }
      if (this.repair === 'rapid') {
        this.$router.push({ name: 'rapidrepairs', params: { obj: this.obj } });
      } else {
        this.$router.push({ name: 'normalrepairs', params: { obj: this.obj, save_info: this.save_info } });
      }
    },
    superclassChange: function superclassChange(val) {
      switch (val) {
        case '硬件问题':
          this.list2 = ['设备启动故障', '设备死机故障', '设备显示故障', '设备识别故障', '设备输入输出故障', '设备音频故障', '其他问题'];
          this.subClass1 = this.lastflag ? '设备启动故障' : this.subClass1;
          this.selisShow = true;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '软件问题':
          this.list3 = ['无法登陆管理界面', '无法修改配置', '客户端无法挂载', '存储无法访问', '非编回放/采集丢帧/彩条', '存储性能不佳', '数据丢失', '数据无法读写', '其他问题'];
          this.subClass2 = this.lastflag ? '无法登陆管理界面' : this.subClass2;
          this.selisShow = false;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '运输问题':
          this.list3 = ['机箱变形', '元器件脱落', '机箱内有异物', '前面板脱落', '其他问题'];
          this.subClass2 = this.lastflag ? '机箱变形' : this.subClass2;
          this.selisShow = false;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '其他问题':
          this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障', '板载插槽故障', '其他问题'];
          this.subClass2 = this.lastflag ? '物理损伤' : this.subClass2;
          this.selisShow = false;
          this.lastflag = true;
          break;
        case '使用问题':
          this.selisShow = false;
          this.flag = false;
          this.inputisShow = true;
          break;
        default:
          break;
      }
    },
    superclassChange1: function superclassChange1(val) {
      switch (val) {
        case '设备启动故障':
          this.list3 = ['无法开机', '无法显示', '无法自动重启', '无法进入操作系统', '开机自动断电', '其他问题'];
          this.subClass2 = !this.subClass2 ? '无法开机' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备死机故障':
          this.list3 = ['开机自检死机', '进入操作系统死机', '复制文件死机', '运行软件死机', '蓝屏死机', '其他问题'];
          this.subClass2 = !this.subClass2 ? '开机自检死机' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备显示故障':
          this.list3 = ['开机花屏', '显示偏色', '进入操作系统花屏', '显示马赛克', '其他问题'];
          this.subClass2 = !this.subClass2 ? '开机花屏' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备识别故障':
          this.list3 = ['板卡无法识别', 'USB无法识别', '硬盘无法识别', 'RAID卡无法识别', '光驱无法识别', '其他问题'];
          this.subClass2 = !this.subClass2 ? '板卡无法识别' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备输入输出故障':
          this.list3 = ['显卡无输出', 'SDI无输入输出', 'CVBS无输出', 'HDMI无输入输出', '输入绿屏', '其他问题'];
          this.subClass2 = !this.subClass2 ? '显卡无输出' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备音频故障':
          this.list3 = ['板卡音频无输出', '板卡音频无输入', '音频输出单声道', '板载音频无输出', '其他问题'];
          this.subClass2 = !this.subClass2 ? '板卡音频无输出' : this.subClass2;
          this.lastflag = true;
          break;
        case '其他问题':
          this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障', '板载插槽故障', '其他问题'];
          this.subClass2 = !this.subClass2 ? '物理损伤' : this.subClass2;
          this.lastflag = true;
          this.selisShow = false;
          break;
        default:
          break;
      }
    },
    superclassChange2: function superclassChange2(val) {
      switch (val) {
        case '其他问题':
          this.flag = false;
          this.inputisShow = true;
          break;
        default:
          this.flag = true;
          this.inputisShow = false;
          break;
      }
    },
    sbphoto: function sbphoto() {
      if (this.selisShow) {
        this.obj.ftype = this.ftype + ',' + this.subClass1;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', this.subClass1);
      } else {
        this.obj.ftype = this.ftype;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', '');
      }
      if (this.flag) {
        this.obj.fdesc = this.subClass2;
        localStorage.setItem('subClass2', this.subClass2);
      } else {
        this.obj.fdesc = this.fdesc;
        localStorage.setItem('fdesc', this.fdesc);
        localStorage.setItem('subClass2', '');
      }
      localStorage.setItem('obj', stringify_default()(this.obj));
      this.$router.push({ name: 'photo', params: { obj: this.obj, repair: this.repair } });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === 'normalrepairs' || from.name === 'rapidrepairs') {
      next(function (vm) {
        var fault = localStorage.getItem('fault');
        var obj = JSON.parse(fault);

        vm.obj = obj;
        if (obj.ftype) {
          var ftype = localStorage.getItem('ftype');
          var subClass1 = localStorage.getItem('subClass1');
          var subClass2 = localStorage.getItem('subClass2');
          var fdesc = localStorage.getItem('fdesc');
          vm.lastflag = false;
          vm.ftype = ftype;
          if (subClass1) {
            vm.subClass1 = subClass1;
          } else {
            vm.subClass1 = '';
            vm.selisShow = false;
          }
          if (subClass2) {
            vm.subClass2 = subClass2;
          } else {
            vm.subClass2 = '其他问题';
            vm.fdesc = fdesc;
          }
        }
        localStorage.setItem('obj', stringify_default()(obj));
      });
    } else if (from.name === 'photo') {
      next(function (vm) {
        var obj;
        obj = vm.$route.params.obj;
        if (obj) {
          vm.obj = obj;
          localStorage.setItem('obj', stringify_default()(obj));
        } else {
          obj = localStorage.getItem('obj');
          vm.obj = JSON.parse(obj);
        }
        var ftype = localStorage.getItem('ftype');
        var subClass1 = localStorage.getItem('subClass1');
        var subClass2 = localStorage.getItem('subClass2');
        var fdesc = localStorage.getItem('fdesc');
        vm.lastflag = false;
        vm.ftype = ftype;
        if (subClass1) {
          vm.subClass1 = subClass1;
        } else {
          vm.subClass1 = '';
          vm.selisShow = false;
        }
        if (subClass2) {
          vm.subClass2 = subClass2;
        } else {
          vm.subClass2 = '其他问题';
          vm.fdesc = fdesc;
        }
      });
    } else {
      next(function (vm) {
        var obj = localStorage.getItem('obj');
        vm.obj = JSON.parse(obj);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/faultType.vue













/* harmony default export */ var selectortype_script_index_0_src_components_faultType = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector,
    Panel: vux_src_components_panel,
    Radio: node_modules_vux_src_components_radio,
    XButton: vux_src_components_x_button,
    CellBox: vux_src_components_cell_box
  },
  data: function data() {
    return {
      fdesc: '',
      ftype: '使用问题',
      subClass1: '无法登陆管理界面',
      subClass2: '',
      selisShow: true,
      flag: false,
      inputisShow: false,
      list1: ['使用问题', '软件问题', '运输问题', '硬件问题', '其他问题'],
      list2: ['无法登陆管理界面', '无法修改配置', '客户端无法挂载', '存储无法访问', '非编回放/采集丢帧/彩条', '存储性能不佳', '数据丢失', '数据无法读写', '其他问题'],
      list3: [],
      obj: {
        ftype: '',
        fdesc: ""
      },
      lastflag: true,
      repair: this.$route.params.repair,
      save_info: this.$route.params.save_info
    };
  },

  methods: {
    confirm: function confirm() {
      if (this.selisShow) {
        this.obj.ftype = this.ftype + ',' + this.subClass1;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', this.subClass1);
      } else {
        this.obj.ftype = this.ftype;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', '');
      }
      if (this.flag) {
        this.obj.fdesc = this.subClass2;
        localStorage.setItem('subClass2', this.subClass2);
      } else {
        this.obj.fdesc = this.fdesc;
        localStorage.setItem('fdesc', this.fdesc);
        localStorage.setItem('subClass2', '');
      }
      if (this.obj.fdesc === '' || this.obj.ftype === '') {
        alert('请填写故障信息');
        return;
      }
      if (this.repair === 'rapid') {
        this.$router.push({ name: 'rapidrepairs', params: { obj: this.obj } });
      } else {
        this.$router.push({ name: 'normalrepairs', params: { obj: this.obj, save_info: this.save_info } });
      }
    },
    superclassChange: function superclassChange(val) {
      switch (val) {
        case '硬件问题':
          this.list2 = ['设备启动故障', '设备死机故障', '设备显示故障', '设备识别故障', '设备输入输出故障', '设备音频故障', '其他问题'];
          this.subClass1 = this.lastflag ? '设备启动故障' : this.subClass1;
          this.selisShow = true;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '软件问题':
          this.list3 = ['无法登陆管理界面', '无法修改配置', '客户端无法挂载', '存储无法访问', '非编回放/采集丢帧/彩条', '存储性能不佳', '数据丢失', '数据无法读写', '其他问题'];
          this.subClass2 = this.lastflag ? '无法登陆管理界面' : this.subClass2;
          this.selisShow = false;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '运输问题':
          this.list3 = ['机箱变形', '元器件脱落', '机箱内有异物', '前面板脱落', '其他问题'];
          this.subClass2 = this.lastflag ? '机箱变形' : this.subClass2;
          this.selisShow = false;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '其他问题':
          this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障', '板载插槽故障', '其他问题'];
          this.subClass2 = this.lastflag ? '物理损伤' : this.subClass2;
          this.selisShow = false;
          this.lastflag = true;
          break;
        case '使用问题':
          this.selisShow = false;
          this.flag = false;
          this.inputisShow = true;
          break;
        default:
          break;
      }
    },
    superclassChange1: function superclassChange1(val) {
      switch (val) {
        case '设备启动故障':
          this.list3 = ['无法开机', '无法显示', '无法自动重启', '无法进入操作系统', '开机自动断电', '其他问题'];
          this.subClass2 = !this.subClass2 ? '无法开机' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备死机故障':
          this.list3 = ['开机自检死机', '进入操作系统死机', '复制文件死机', '运行软件死机', '蓝屏死机', '其他问题'];
          this.subClass2 = !this.subClass2 ? '开机自检死机' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备显示故障':
          this.list3 = ['开机花屏', '显示偏色', '进入操作系统花屏', '显示马赛克', '其他问题'];
          this.subClass2 = !this.subClass2 ? '开机花屏' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备识别故障':
          this.list3 = ['板卡无法识别', 'USB无法识别', '硬盘无法识别', 'RAID卡无法识别', '光驱无法识别', '其他问题'];
          this.subClass2 = !this.subClass2 ? '板卡无法识别' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备输入输出故障':
          this.list3 = ['显卡无输出', 'SDI无输入输出', 'CVBS无输出', 'HDMI无输入输出', '输入绿屏', '其他问题'];
          this.subClass2 = !this.subClass2 ? '显卡无输出' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备音频故障':
          this.list3 = ['板卡音频无输出', '板卡音频无输入', '音频输出单声道', '板载音频无输出', '其他问题'];
          this.subClass2 = !this.subClass2 ? '板卡音频无输出' : this.subClass2;
          this.lastflag = true;
          break;
        case '其他问题':
          this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障', '板载插槽故障', '其他问题'];
          this.subClass2 = !this.subClass2 ? '物理损伤' : this.subClass2;
          this.lastflag = true;
          this.selisShow = false;
          break;
        default:
          break;
      }
    },
    superclassChange2: function superclassChange2(val) {
      switch (val) {
        case '其他问题':
          this.flag = false;
          this.inputisShow = true;
          break;
        default:
          this.flag = true;
          this.inputisShow = false;
          break;
      }
    },
    sbphoto: function sbphoto() {
      if (this.selisShow) {
        this.obj.ftype = this.ftype + ',' + this.subClass1;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', this.subClass1);
      } else {
        this.obj.ftype = this.ftype;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', '');
      }
      if (this.flag) {
        this.obj.fdesc = this.subClass2;
        localStorage.setItem('subClass2', this.subClass2);
      } else {
        this.obj.fdesc = this.fdesc;
        localStorage.setItem('fdesc', this.fdesc);
        localStorage.setItem('subClass2', '');
      }
      localStorage.setItem('obj', stringify_default()(this.obj));
      this.$router.push({ name: 'photo', params: { obj: this.obj, repair: this.repair } });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === 'normalrepairs' || from.name === 'rapidrepairs') {
      next(function (vm) {
        var fault = localStorage.getItem('fault');
        var obj = JSON.parse(fault);

        vm.obj = obj;
        if (obj.ftype) {
          var ftype = localStorage.getItem('ftype');
          var subClass1 = localStorage.getItem('subClass1');
          var subClass2 = localStorage.getItem('subClass2');
          var fdesc = localStorage.getItem('fdesc');
          vm.lastflag = false;
          vm.ftype = ftype;
          if (subClass1) {
            vm.subClass1 = subClass1;
          } else {
            vm.subClass1 = '';
            vm.selisShow = false;
          }
          if (subClass2) {
            vm.subClass2 = subClass2;
          } else {
            vm.subClass2 = '其他问题';
            vm.fdesc = fdesc;
          }
        }
        localStorage.setItem('obj', stringify_default()(obj));
      });
    } else if (from.name === 'photo') {
      next(function (vm) {
        var obj;
        obj = vm.$route.params.obj;
        if (obj) {
          vm.obj = obj;
          localStorage.setItem('obj', stringify_default()(obj));
        } else {
          obj = localStorage.getItem('obj');
          vm.obj = JSON.parse(obj);
        }
        var ftype = localStorage.getItem('ftype');
        var subClass1 = localStorage.getItem('subClass1');
        var subClass2 = localStorage.getItem('subClass2');
        var fdesc = localStorage.getItem('fdesc');
        vm.lastflag = false;
        vm.ftype = ftype;
        if (subClass1) {
          vm.subClass1 = subClass1;
        } else {
          vm.subClass1 = '';
          vm.selisShow = false;
        }
        if (subClass2) {
          vm.subClass2 = subClass2;
        } else {
          vm.subClass2 = '其他问题';
          vm.fdesc = fdesc;
        }
      });
    } else {
      next(function (vm) {
        var obj = localStorage.getItem('obj');
        vm.obj = JSON.parse(obj);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49ddfc51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faultType.vue
var faultType_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('selector',{attrs:{"title":"故障类型","options":_vm.list1},on:{"on-change":_vm.superclassChange},model:{value:(_vm.ftype),callback:function ($$v) {_vm.ftype=$$v},expression:"ftype"}}),_vm._v(" "),_c('selector',{directives:[{name:"show",rawName:"v-show",value:(_vm.selisShow),expression:"selisShow"}],attrs:{"title":"故障分类","options":_vm.list2},on:{"on-change":_vm.superclassChange1},model:{value:(_vm.subClass1),callback:function ($$v) {_vm.subClass1=$$v},expression:"subClass1"}}),_vm._v(" "),_c('selector',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}],attrs:{"title":"故障描述*","placeholder":"故障描述","options":_vm.list3},on:{"on-change":_vm.superclassChange2},model:{value:(_vm.subClass2),callback:function ($$v) {_vm.subClass2=$$v},expression:"subClass2"}}),_vm._v(" "),_c('x-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputisShow),expression:"inputisShow"}],attrs:{"placeholder":"请输入自定义类型","max":256},model:{value:(_vm.fdesc),callback:function ($$v) {_vm.fdesc=$$v},expression:"fdesc"}}),_vm._v(" "),_c('cell',{attrs:{"title":('故障照片'),"is-link":""},nativeOn:{"click":function($event){return _vm.sbphoto($event)}}})],1),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定")])],1)}
var faultType_staticRenderFns = []
var faultType_esExports = { render: faultType_render, staticRenderFns: faultType_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_faultType = (faultType_esExports);
// CONCATENATED MODULE: ./src/components/faultType.vue
var faultType_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var faultType___vue_template_functional__ = false
/* styles */
var faultType___vue_styles__ = null
/* scopeId */
var faultType___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var faultType___vue_module_identifier__ = null
var faultType_Component = faultType_normalizeComponent(
  selectortype_script_index_0_src_components_faultType,
  selectortype_template_index_0_src_components_faultType,
  faultType___vue_template_functional__,
  faultType___vue_styles__,
  faultType___vue_scopeId__,
  faultType___vue_module_identifier__
)

/* harmony default export */ var src_components_faultType = (faultType_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/faultType1.vue













/* harmony default export */ var faultType1 = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector,
    Panel: vux_src_components_panel,
    Radio: node_modules_vux_src_components_radio,
    XButton: vux_src_components_x_button,
    CellBox: vux_src_components_cell_box
  },
  data: function data() {
    return {
      fdesc: '',
      ftype: '硬件问题',
      subClass1: '设备启动故障',
      subClass2: '无法开机',
      selisShow: true,
      flag: true,
      inputisShow: false,
      list1: ['硬件问题', '软件问题', '运输问题', '其他问题'],
      list2: ['设备启动故障', '设备死机故障', '设备显示故障', '设备识别故障', '设备输入输出故障', '设备音频故障', '其他问题'],
      list3: ['无法开机', '无法显示', '无法自动重启', '无法进入操作系统', '开机自动断电', '其他问题'],
      obj: {
        ftype: '',
        fdesc: ""
      },
      lastflag: true
    };
  },

  methods: {
    confirm: function confirm() {
      var that = this;
      if (this.selisShow) {
        this.obj.ftype = this.ftype + ',' + this.subClass1;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', this.subClass1);
      } else {
        this.obj.ftype = this.ftype;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', '');
      }
      if (this.flag) {
        this.obj.fdesc = this.subClass2;
        localStorage.setItem('subClass2', this.subClass2);
      } else {
        this.obj.fdesc = this.fdesc;
        localStorage.setItem('fdesc', this.fdesc);
        localStorage.setItem('subClass2', '');
      }
      this.$router.push({ name: 'rapidrepairs', params: { obj: this.obj } });
    },
    superclassChange: function superclassChange(val) {
      switch (val) {
        case '硬件问题':
          this.list2 = ['设备启动故障', '设备死机故障', '设备显示故障', '设备识别故障', '设备输入输出故障', '设备音频故障', '其他问题'];
          this.subClass1 = this.lastflag ? '设备启动故障' : this.subClass1;
          this.selisShow = true;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '软件问题':
          this.list3 = ['无法登陆管理界面', '无法修改配置', '客户端无法挂载', '存储无法访问', '非编回放/采集丢帧/彩条', '存储性能不佳', '数据丢失', '数据无法读写', '其他问题'];
          this.subClass2 = this.lastflag ? '无法登陆管理界面' : this.subClass2;
          this.selisShow = false;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '运输问题':
          this.list3 = ['机箱变形', '元器件脱落', '机箱内有异物', '前面板脱落', '其他问题'];
          this.subClass2 = this.lastflag ? '机箱变形' : this.subClass2;
          this.selisShow = false;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '其他问题':
          this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障', '板载插槽故障', '其他问题'];
          this.subClass2 = this.lastflag ? '物理损伤' : this.subClass2;
          this.selisShow = false;
          this.lastflag = true;
          break;
        default:
          break;
      }
    },
    superclassChange1: function superclassChange1(val) {
      switch (val) {
        case '设备启动故障':
          this.list3 = ['无法开机', '无法显示', '无法自动重启', '无法进入操作系统', '开机自动断电', '其他问题'];
          this.subClass2 = this.lastflag ? '无法开机' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备死机故障':
          this.list3 = ['开机自检死机', '进入操作系统死机', '复制文件死机', '运行软件死机', '蓝屏死机', '其他问题'];
          this.subClass2 = this.lastflag ? '开机自检死机' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备显示故障':
          this.list3 = ['开机花屏', '显示偏色', '进入操作系统花屏', '显示马赛克', '其他问题'];
          this.subClass2 = this.lastflag ? '开机花屏' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备识别故障':
          this.list3 = ['板卡无法识别', 'USB无法识别', '硬盘无法识别', 'RAID卡无法识别', '光驱无法识别', '其他问题'];
          this.subClass2 = this.lastflag ? '板卡无法识别' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备输入输出故障':
          this.list3 = ['显卡无输出', 'SDI无输入输出', 'CVBS无输出', 'HDMI无输入输出', '输入绿屏', '其他问题'];
          this.subClass2 = this.lastflag ? '显卡无输出' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备音频故障':
          this.list3 = ['板卡音频无输出', '板卡音频无输入', '音频输出单声道', '板载音频无输出', '其他问题'];
          this.subClass2 = this.lastflag ? '板卡音频无输出' : this.subClass2;
          this.lastflag = true;
          break;
        case '其他问题':
          this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障', '板载插槽故障', '其他问题'];
          this.subClass2 = this.lastflag ? '物理损伤' : this.subClass2;
          this.lastflag = true;
          this.selisShow = false;
          break;
        default:
          break;
      }
    },
    superclassChange2: function superclassChange2(val) {
      switch (val) {
        case '其他问题':
          this.flag = false;
          this.inputisShow = true;
          break;
        default:
          this.flag = true;
          this.inputisShow = false;
          break;
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'rapidrepairs') {
      next(function (vm) {

        var fault = localStorage.getItem('fault');
        var obj = JSON.parse(fault);
        vm.obj = obj;
        if (obj.ftype) {

          var ftype = localStorage.getItem('ftype');
          var subClass1 = localStorage.getItem('subClass1');
          var subClass2 = localStorage.getItem('subClass2');
          var fdesc = localStorage.getItem('fdesc');
          vm.lastflag = false;
          vm.ftype = ftype;
          if (subClass1) {
            vm.subClass1 = subClass1;
          } else {
            vm.subClass1 = '';
            vm.selisShow = false;
          }
          if (subClass2) {
            vm.subClass2 = subClass2;
          } else {
            vm.subClass2 = '其他问题';
            vm.fdesc = fdesc;
          }
        }
        localStorage.setItem('obj', stringify_default()(obj));
        console.log(obj);
      });
    } else {
      next(function (vm) {
        var obj = localStorage.getItem('obj');
        vm.obj = JSON.parse(obj);
        console.log(vm.obj);
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'photo') {
      next();
    }

    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/faultType1.vue













/* harmony default export */ var components_faultType1 = ({
  components: {
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XAddress: vux_src_components_x_address,
    Card: vux_src_components_card,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector,
    Panel: vux_src_components_panel,
    Radio: node_modules_vux_src_components_radio,
    XButton: vux_src_components_x_button,
    CellBox: vux_src_components_cell_box
  },
  data: function data() {
    return {
      fdesc: '',
      ftype: '硬件问题',
      subClass1: '设备启动故障',
      subClass2: '无法开机',
      selisShow: true,
      flag: true,
      inputisShow: false,
      list1: ['硬件问题', '软件问题', '运输问题', '其他问题'],
      list2: ['设备启动故障', '设备死机故障', '设备显示故障', '设备识别故障', '设备输入输出故障', '设备音频故障', '其他问题'],
      list3: ['无法开机', '无法显示', '无法自动重启', '无法进入操作系统', '开机自动断电', '其他问题'],
      obj: {
        ftype: '',
        fdesc: ""
      },
      lastflag: true
    };
  },

  methods: {
    confirm: function confirm() {
      var that = this;
      if (this.selisShow) {
        this.obj.ftype = this.ftype + ',' + this.subClass1;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', this.subClass1);
      } else {
        this.obj.ftype = this.ftype;
        localStorage.setItem('ftype', this.ftype);
        localStorage.setItem('subClass1', '');
      }
      if (this.flag) {
        this.obj.fdesc = this.subClass2;
        localStorage.setItem('subClass2', this.subClass2);
      } else {
        this.obj.fdesc = this.fdesc;
        localStorage.setItem('fdesc', this.fdesc);
        localStorage.setItem('subClass2', '');
      }
      this.$router.push({ name: 'rapidrepairs', params: { obj: this.obj } });
    },
    superclassChange: function superclassChange(val) {
      switch (val) {
        case '硬件问题':
          this.list2 = ['设备启动故障', '设备死机故障', '设备显示故障', '设备识别故障', '设备输入输出故障', '设备音频故障', '其他问题'];
          this.subClass1 = this.lastflag ? '设备启动故障' : this.subClass1;
          this.selisShow = true;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '软件问题':
          this.list3 = ['无法登陆管理界面', '无法修改配置', '客户端无法挂载', '存储无法访问', '非编回放/采集丢帧/彩条', '存储性能不佳', '数据丢失', '数据无法读写', '其他问题'];
          this.subClass2 = this.lastflag ? '无法登陆管理界面' : this.subClass2;
          this.selisShow = false;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '运输问题':
          this.list3 = ['机箱变形', '元器件脱落', '机箱内有异物', '前面板脱落', '其他问题'];
          this.subClass2 = this.lastflag ? '机箱变形' : this.subClass2;
          this.selisShow = false;
          this.flag = true;
          this.inputisShow = false;
          this.lastflag = true;
          break;
        case '其他问题':
          this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障', '板载插槽故障', '其他问题'];
          this.subClass2 = this.lastflag ? '物理损伤' : this.subClass2;
          this.selisShow = false;
          this.lastflag = true;
          break;
        default:
          break;
      }
    },
    superclassChange1: function superclassChange1(val) {
      switch (val) {
        case '设备启动故障':
          this.list3 = ['无法开机', '无法显示', '无法自动重启', '无法进入操作系统', '开机自动断电', '其他问题'];
          this.subClass2 = this.lastflag ? '无法开机' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备死机故障':
          this.list3 = ['开机自检死机', '进入操作系统死机', '复制文件死机', '运行软件死机', '蓝屏死机', '其他问题'];
          this.subClass2 = this.lastflag ? '开机自检死机' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备显示故障':
          this.list3 = ['开机花屏', '显示偏色', '进入操作系统花屏', '显示马赛克', '其他问题'];
          this.subClass2 = this.lastflag ? '开机花屏' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备识别故障':
          this.list3 = ['板卡无法识别', 'USB无法识别', '硬盘无法识别', 'RAID卡无法识别', '光驱无法识别', '其他问题'];
          this.subClass2 = this.lastflag ? '板卡无法识别' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备输入输出故障':
          this.list3 = ['显卡无输出', 'SDI无输入输出', 'CVBS无输出', 'HDMI无输入输出', '输入绿屏', '其他问题'];
          this.subClass2 = this.lastflag ? '显卡无输出' : this.subClass2;
          this.lastflag = true;
          break;
        case '设备音频故障':
          this.list3 = ['板卡音频无输出', '板卡音频无输入', '音频输出单声道', '板载音频无输出', '其他问题'];
          this.subClass2 = this.lastflag ? '板卡音频无输出' : this.subClass2;
          this.lastflag = true;
          break;
        case '其他问题':
          this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障', '板载插槽故障', '其他问题'];
          this.subClass2 = this.lastflag ? '物理损伤' : this.subClass2;
          this.lastflag = true;
          this.selisShow = false;
          break;
        default:
          break;
      }
    },
    superclassChange2: function superclassChange2(val) {
      switch (val) {
        case '其他问题':
          this.flag = false;
          this.inputisShow = true;
          break;
        default:
          this.flag = true;
          this.inputisShow = false;
          break;
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'rapidrepairs') {
      next(function (vm) {

        var fault = localStorage.getItem('fault');
        var obj = JSON.parse(fault);
        vm.obj = obj;
        if (obj.ftype) {

          var ftype = localStorage.getItem('ftype');
          var subClass1 = localStorage.getItem('subClass1');
          var subClass2 = localStorage.getItem('subClass2');
          var fdesc = localStorage.getItem('fdesc');
          vm.lastflag = false;
          vm.ftype = ftype;
          if (subClass1) {
            vm.subClass1 = subClass1;
          } else {
            vm.subClass1 = '';
            vm.selisShow = false;
          }
          if (subClass2) {
            vm.subClass2 = subClass2;
          } else {
            vm.subClass2 = '其他问题';
            vm.fdesc = fdesc;
          }
        }
        localStorage.setItem('obj', stringify_default()(obj));
        console.log(obj);
      });
    } else {
      next(function (vm) {
        var obj = localStorage.getItem('obj');
        vm.obj = JSON.parse(obj);
        console.log(vm.obj);
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'photo') {
      next();
    }

    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54405e82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faultType1.vue
var faultType1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('selector',{attrs:{"title":"故障类型","options":_vm.list1},on:{"on-change":_vm.superclassChange},model:{value:(_vm.ftype),callback:function ($$v) {_vm.ftype=$$v},expression:"ftype"}}),_vm._v(" "),_c('selector',{directives:[{name:"show",rawName:"v-show",value:(_vm.selisShow),expression:"selisShow"}],attrs:{"title":"故障分类","options":_vm.list2},on:{"on-change":_vm.superclassChange1},model:{value:(_vm.subClass1),callback:function ($$v) {_vm.subClass1=$$v},expression:"subClass1"}}),_vm._v(" "),_c('selector',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}],attrs:{"title":"故障描述*","placeholder":"故障描述","options":_vm.list3},on:{"on-change":_vm.superclassChange2},model:{value:(_vm.subClass2),callback:function ($$v) {_vm.subClass2=$$v},expression:"subClass2"}}),_vm._v(" "),_c('x-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.inputisShow),expression:"inputisShow"}],attrs:{"placeholder":"请输入自定义类型","max":"256"},model:{value:(_vm.fdesc),callback:function ($$v) {_vm.fdesc=$$v},expression:"fdesc"}})],1),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm($event)}}},[_vm._v("确定")])],1)}
var faultType1_staticRenderFns = []
var faultType1_esExports = { render: faultType1_render, staticRenderFns: faultType1_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_faultType1 = (faultType1_esExports);
// CONCATENATED MODULE: ./src/components/faultType1.vue
var faultType1_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var faultType1___vue_template_functional__ = false
/* styles */
var faultType1___vue_styles__ = null
/* scopeId */
var faultType1___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var faultType1___vue_module_identifier__ = null
var faultType1_Component = faultType1_normalizeComponent(
  components_faultType1,
  selectortype_template_index_0_src_components_faultType1,
  faultType1___vue_template_functional__,
  faultType1___vue_styles__,
  faultType1___vue_scopeId__,
  faultType1___vue_module_identifier__
)

/* harmony default export */ var src_components_faultType1 = (faultType1_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/devices/DeviceInfo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var DeviceInfo = ({
  name: "DeviceInfo",
  props: {
    background: {
      type: String,
      default: '#43d841'
    },
    type: {
      type: String,
      default: ""
    },
    device: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    change: function change() {
      this.$emit("chose", this.index);
    },
    smallbox: function smallbox(data) {
      this.$router.push({ name: 'smallbox', params: { order: data } });
    },
    forward: function forward(data) {
      this.$router.push({ name: 'Devicedetails', params: { 'order': data } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/devices/DeviceInfo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var devices_DeviceInfo = ({
  name: "DeviceInfo",
  props: {
    background: {
      type: String,
      default: '#43d841'
    },
    type: {
      type: String,
      default: ""
    },
    device: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    change: function change() {
      this.$emit("chose", this.index);
    },
    smallbox: function smallbox(data) {
      this.$router.push({ name: 'smallbox', params: { order: data } });
    },
    forward: function forward(data) {
      this.$router.push({ name: 'Devicedetails', params: { 'order': data } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac913a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/devices/DeviceInfo.vue
var DeviceInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden"}},[(_vm.type === 'group'&& _vm.device.nodes.length > 0 &&_vm.device.gname === '环境监控')?_c('div',{staticClass:"group-wrap"},[_c('h4',{staticClass:"name group-name"},[_vm._v(_vm._s(_vm.device.gname))]),_vm._v(" "),_c('div',{staticClass:"environment"},[_vm._l((_vm.device.nodes),function(item,index){return [(item.type === 'TH Senser')?_c('div',{staticClass:"environment-item",style:({background:item.color})},[_c('object',{attrs:{"data":"static/img/wd.svg","type":"image/svg+xml"}}),_vm._v(" "),_c('div',{staticStyle:{"float":"left"}},[_c('h5',{staticClass:"environment-p"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticStyle:{"padding":"0 .5rem"}},[_vm._v(_vm._s(item.info.tem)),(item.info.tem)?_c('span',[_vm._v("℃")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(item.type === 'TH Senser')?_c('div',{staticClass:"environment-item",style:({background:item.color})},[_c('object',{attrs:{"data":"static/img/sd.svg","type":"image/svg+xml"}}),_vm._v(" "),_c('div',{staticStyle:{"float":"left"}},[_c('h5',{staticClass:"environment-p"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticStyle:{"padding":"0 .5rem"}},[_vm._v(_vm._s(item.info.hum)),(item.info.hum)?_c('span',[_vm._v("%rh")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(item.type === 'PowerOff Senser')?_c('div',{staticClass:"environment-item",style:({background:item.color})},[_c('object',{attrs:{"data":"static/img/dd.svg","type":"image/svg+xml"}}),_vm._v(" "),_c('div',{staticStyle:{"float":"left"}},[_c('h5',{staticClass:"environment-p"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticStyle:{"padding":"0 .5rem"}},[_vm._v(_vm._s(item.status))])])]):_vm._e(),_vm._v(" "),(item.type === 'Smoke Senser')?_c('div',{staticClass:"environment-item",style:({background:item.color})},[_c('object',{attrs:{"data":"static/img/yg.svg","type":"image/svg+xml"}}),_vm._v(" "),_c('div',{staticStyle:{"float":"left"}},[_c('h5',{staticClass:"environment-p"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticStyle:{"padding":"0 .5rem"}},[_vm._v(_vm._s(item.status))])])]):_vm._e(),_vm._v(" "),(item.type === 'Flood Senser')?_c('div',{staticClass:"environment-item",style:({background:item.color})},[_c('object',{attrs:{"data":"static/img/sj.svg","type":"image/svg+xml"}}),_vm._v(" "),_c('div',{staticStyle:{"float":"left"}},[_c('h5',{staticClass:"environment-p"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',{staticStyle:{"padding":"0 .5rem"}},[_vm._v(_vm._s(item.status))])])]):_vm._e()]})],2)]):_vm._e(),_vm._v(" "),(_vm.type === 'host')?_c('div',{staticClass:"wrap",style:({background: _vm.background}),on:{"click":function($event){$event.stopPropagation();_vm.forward(_vm.device)}}},[_c('h4',{staticClass:"name"},[_c('span',{staticClass:"desc"},[_vm._v(_vm._s(_vm.device.desc))]),_vm._v(" "),(_vm.device.tp)?_c('mark',{staticStyle:{"background":"#10aeff"}},[_vm._v(_vm._s(_vm.device.tp === 'unknown' ? '未知' : _vm.device.tp))]):_vm._e(),_vm._v(" "),_c('mark',{style:({background:_vm.device.connected==='已连接'?'#0bb20c':'#f43530'})},[_vm._v(_vm._s(_vm.device.connected))]),_vm._v(" "),_c('span',{staticStyle:{"padding-right":"0.3rem","margin-top":"5px","float":"right","font-size":"1rem"}},[_vm._v(" > ")]),_vm._v(" "),_c('span',{staticClass:"bonded"},[_vm._v(_vm._s(_vm.device.bonded))])]),_vm._v(" "),_c('p',[_vm._v("云帷编号："+_vm._s(_vm.device.seq))]),_vm._v(" "),(_vm.device.level)?_c('p',[_vm._v("故障等级："+_vm._s(_vm.device.level))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.type === 'group' && _vm.device.gname!=='环境监控' && _vm.device.gname!=='网络拓扑')?_c('div',{staticClass:"group-wrap"},[_c('h4',{staticClass:"name group-name"},[_vm._v(_vm._s(_vm.device.gname))]),_vm._v(" "),_vm._l((_vm.device.nodes),function(item,index){return _c('div',{staticClass:"wrap item",style:({background:item.color}),on:{"click":function($event){$event.stopPropagation();_vm.forward(item)}}},[_c('h4',{staticClass:"name"},[_c('span',{staticClass:"desc"},[_vm._v(_vm._s(item.desc))]),_vm._v(" "),(item.tp)?_c('mark',{staticStyle:{"background":"#10aeff"}},[_vm._v(_vm._s(item.tp === 'unknown' ? '未知' : item.tp))]):_vm._e(),_vm._v(" "),_c('mark',{style:({background:item.connected==='已连接'?'#0bb20c':'#f43530'})},[_vm._v(_vm._s(item.connected))]),_vm._v(" "),_c('span',{staticStyle:{"padding-right":"0.3rem","margin-top":"5px","float":"right","font-size":"1rem"}},[_vm._v(" > ")]),_vm._v(" "),_c('span',{staticClass:"bonded"},[_vm._v(_vm._s(item.bonded))])]),_vm._v(" "),_c('p',[_vm._v("云帷编号："+_vm._s(item.seq))]),_vm._v(" "),(item.level)?_c('p',[_vm._v("故障等级："+_vm._s(item.level))]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.type === 'box')?_c('div',{staticClass:"wrap",on:{"click":_vm.change}},[_c('h4',{staticClass:"name group-name"},[_vm._v(_vm._s(_vm.device.seq)+"\n      "),_c('b',{staticClass:"box-right",on:{"click":function($event){$event.stopPropagation();_vm.smallbox(_vm.device)}}},[_vm._v(" > ")])])]):_vm._e()])}
var DeviceInfo_staticRenderFns = []
var DeviceInfo_esExports = { render: DeviceInfo_render, staticRenderFns: DeviceInfo_staticRenderFns }
/* harmony default export */ var components_devices_DeviceInfo = (DeviceInfo_esExports);
// CONCATENATED MODULE: ./src/components/devices/DeviceInfo.vue
function DeviceInfo_injectStyle (ssrContext) {
  __webpack_require__("9o4/")
}
var DeviceInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var DeviceInfo___vue_template_functional__ = false
/* styles */
var DeviceInfo___vue_styles__ = DeviceInfo_injectStyle
/* scopeId */
var DeviceInfo___vue_scopeId__ = "data-v-3ac913a2"
/* moduleIdentifier (server only) */
var DeviceInfo___vue_module_identifier__ = null
var DeviceInfo_Component = DeviceInfo_normalizeComponent(
  devices_DeviceInfo,
  components_devices_DeviceInfo,
  DeviceInfo___vue_template_functional__,
  DeviceInfo___vue_styles__,
  DeviceInfo___vue_scopeId__,
  DeviceInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_devices_DeviceInfo = (DeviceInfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/topological.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var topological = ({
  name: "topological",
  props: {
    device: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      showList: []
    };
  },

  methods: {
    show: function show(index) {
      this.$set(this.showList, index, !this.showList[index]);
    },
    showRouteOrArp: function showRouteOrArp(index, key) {
      this.$set(this.device[index], key, !this.device[index][key]);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.device.forEach(function (item) {
      item.arpList = item.arpList.map(function (arp) {
        if (arp.tempid) {
          arp.color = '#4BF54BFF';
        }
        if (arp.alarm) {
          arp.color = '#E32020FF';
        }
        return arp;
      });
      _this.showList.push(false);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/topological.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_topological = ({
  name: "topological",
  props: {
    device: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      showList: []
    };
  },

  methods: {
    show: function show(index) {
      this.$set(this.showList, index, !this.showList[index]);
    },
    showRouteOrArp: function showRouteOrArp(index, key) {
      this.$set(this.device[index], key, !this.device[index][key]);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.device.forEach(function (item) {
      item.arpList = item.arpList.map(function (arp) {
        if (arp.tempid) {
          arp.color = '#4BF54BFF';
        }
        if (arp.alarm) {
          arp.color = '#E32020FF';
        }
        return arp;
      });
      _this.showList.push(false);
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599973d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topological.vue
var topological_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.device),function(item,index){return _c('div',{key:index,ref:"wrapref",refInFor:true,staticClass:"wrap"},[_c('p',{staticClass:"switch"},[(!_vm.showList[index])?_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-plus-empty",attrs:{"type":"ios-plus-empty","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.show(index)}}},[_c('path',{attrs:{"d":"M384 265H264v119h-17V265H128v-17h119V128h17v120h120v17z"}})]):_vm._e(),_vm._v(" "),(_vm.showList[index])?_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-minus-empty",attrs:{"type":"ios-minus-empty","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.show(index)}}},[_c('path',{attrs:{"d":"M384 265H128v-17h256v17z"}})]):_vm._e(),_vm._v("\n      "+_vm._s(item.ip)+"\n      "),_c('mark',{staticClass:"type"},[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),(_vm.showList[index])?_c('div',{staticClass:"devices"},[_c('p',{staticClass:"title-host"},[(!item.showRoute)?_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-plus-empty",attrs:{"type":"ios-plus-empty","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.showRouteOrArp(index,'showRoute')}}},[_c('path',{attrs:{"d":"M384 265H264v119h-17V265H128v-17h119V128h17v120h120v17z"}})]):_vm._e(),_vm._v(" "),(item.showRoute)?_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-minus-empty",attrs:{"type":"ios-minus-empty","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.showRouteOrArp(index,'showRoute')}}},[_c('path',{attrs:{"d":"M384 265H128v-17h256v17z"}})]):_vm._e(),_vm._v("\n        关联路由信息\n      ")]),_vm._v(" "),(item.showRoute)?_c('div',{staticClass:"devices"},_vm._l((item.routeList),function(route,index_route){return _c('p',{key:index_route,staticClass:"device"},[_c('span',{staticClass:"icon",staticStyle:{"background":"#4BF54BFF"}}),_vm._v("\n          "+_vm._s(route.ip)+"\n          "),(route.type)?_c('mark',{staticClass:"type"},[_vm._v(_vm._s(route.type))]):_vm._e(),_vm._v(" "),(route.name)?_c('span',{staticClass:"name"},[_vm._v(_vm._s(route.name))]):_vm._e()])})):_vm._e(),_vm._v(" "),_c('p',{staticClass:"title-host"},[(!item.showArp)?_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-plus-empty",attrs:{"type":"ios-plus-empty","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.showRouteOrArp(index,'showArp')}}},[_c('path',{attrs:{"d":"M384 265H264v119h-17V265H128v-17h119V128h17v120h120v17z"}})]):_vm._e(),_vm._v(" "),(item.showArp)?_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-minus-empty",attrs:{"type":"ios-minus-empty","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.showRouteOrArp(index,'showArp')}}},[_c('path',{attrs:{"d":"M384 265H128v-17h256v17z"}})]):_vm._e(),_vm._v("\n        直连设备信息\n      ")]),_vm._v(" "),(item.showArp)?_c('div',{staticClass:"devices"},_vm._l((item.arpList),function(arp,index_arp){return _c('p',{key:index_arp,staticClass:"device"},[_c('span',{staticClass:"icon",style:({background:arp.color})}),_vm._v("\n          "+_vm._s(arp.ip)+"\n          "),(arp.type)?_c('mark',{staticClass:"type"},[_vm._v(_vm._s(arp.type))]):_vm._e(),_vm._v(" "),(arp.name)?_c('span',{staticClass:"name"},[_vm._v(_vm._s(arp.name))]):_vm._e()])})):_vm._e()]):_vm._e()])}))}
var topological_staticRenderFns = []
var topological_esExports = { render: topological_render, staticRenderFns: topological_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_topological = (topological_esExports);
// CONCATENATED MODULE: ./src/components/topological.vue
function topological_injectStyle (ssrContext) {
  __webpack_require__("dKNu")
}
var topological_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var topological___vue_template_functional__ = false
/* styles */
var topological___vue_styles__ = topological_injectStyle
/* scopeId */
var topological___vue_scopeId__ = "data-v-599973d9"
/* moduleIdentifier (server only) */
var topological___vue_module_identifier__ = null
var topological_Component = topological_normalizeComponent(
  components_topological,
  selectortype_template_index_0_src_components_topological,
  topological___vue_template_functional__,
  topological___vue_styles__,
  topological___vue_scopeId__,
  topological___vue_module_identifier__
)

/* harmony default export */ var src_components_topological = (topological_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Devicelist.vue








/* harmony default export */ var Devicelist = ({
  components: {
    Topological: src_components_topological,
    DeviceInfo: src_components_devices_DeviceInfo,
    Group: group["a" /* default */],
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  name: 'invitation',
  data: function data() {
    return {
      isShow: true,
      select: '',
      index: 0,
      orders_closed: [],
      orders_unclosed: [],
      list: ['已监控设备', '未监控设备'],
      isNet: false
    };
  },

  methods: {
    showDevice: function showDevice(index) {
      this.orders_closed = this.orders_closed[index].devices.map(function (item) {
        if (item.hasOwnProperty('node')) {
          switch (item.node.bonded) {
            case 'NO':
              item.node.bonded = '未绑定';
              break;
            case 'YES':
              item.node.bonded = '已绑定';
              break;
            default:
              item.node.bonded = '未知';
          }
          switch (item.node.level) {
            case 1:
              item.node.level = '信息';
              break;
            case 2:
              item.node.level = '警告';
              break;
            case 3:
              item.node.level = '错误';
              break;
            case 4:
              item.node.level = '紧急';
              break;
            case 5:
              item.node.level = '灾难';
              break;
          }
          item.node.connected = item.node.connected === 'NO' ? '未连接' : '已连接';
          switch (item.node.status) {
            case 'OK':
              item.color = '#43d841';
              break;
            case 'WARN':
              item.color = '#ffbe00c2';
              break;
            case 'ERROR':
              item.color = '#ce2924e6';
              break;
          }
        } else if (item.hasOwnProperty('nodes')) {
          if (item.nodes.length !== 0) {
            if (item.nodes[0].hasOwnProperty('info')) {
              item.nodes.forEach(function (value) {
                switch (value.type) {
                  case 'PowerOff Senser':
                    value.status = value.info.tem === '-0.0' ? '闭合' : '断开';
                    break;
                  case 'Smoke Senser':
                    value.status = value.info.tem === '0.1' ? '正常' : '异常';
                    break;
                  case 'Flood Senser':
                    value.status = value.info.tem === '0.1' ? '正常' : '异常';
                    break;
                }
                value.color = value.info.conn ? '#ffffff87' : '#6f696987';
              });
            } else {
              item.nodes.forEach(function (value) {
                switch (value.bonded) {
                  case 'NO':
                    value.bonded = '未绑定';
                    break;
                  case 'YES':
                    value.bonded = '已绑定';
                    break;
                  default:
                    value.bonded = '未知';
                }
                switch (value.level) {
                  case 1:
                    value.level = '信息';
                    break;
                  case 2:
                    value.level = '警告';
                    break;
                  case 3:
                    value.level = '错误';
                    break;
                  case 4:
                    value.level = '紧急';
                    break;
                  case 5:
                    value.level = '灾难';
                    break;
                }
                value.connected = value.connected === 'NO' ? '未连接' : '已连接';
                switch (value.status) {
                  case 'OK':
                    value.color = '#43d841';
                    break;
                  case 'WARN':
                    value.color = '#ffbe00c2';
                    break;
                  case 'ERROR':
                    value.color = '#ce2924e6';
                    break;
                }
              });
            }
          }
        }
        return item;
      });
      this.isShow = false;
    },
    smallbox: function smallbox(data) {
      this.$router.push({ name: 'smallbox', params: { order: data } });
    },
    forward: function forward(data) {
      this.$router.push({ name: 'Devicedetails', params: { 'order': data } });
    },
    getData: function getData() {
      var _this = this;

      var opid = localStorage.getItem('userid');
      var obj = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('api/v1/users/' + opid + '/devices', obj).then(function (res) {

        _this.orders_closed = res.data.monitors;
        _this.isShow = true;

        _this.orders_unclosed = res.data.orphans;
      });
    },
    switchover: function switchover() {
      this.isNet = !this.isNet;
    }
  },
  created: function created() {
    var _this2 = this;

    localStorage.removeItem('equipment');
    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      if (res.data.length !== 0) {
        _this2.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': res.data[0].account }).then(function (response) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userid', response.data.userid);
          _this2.getData();
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Devicelist.vue








/* harmony default export */ var components_Devicelist = ({
  components: {
    Topological: src_components_topological,
    DeviceInfo: src_components_devices_DeviceInfo,
    Group: group["a" /* default */],
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item
  },
  name: 'invitation',
  data: function data() {
    return {
      isShow: true,
      select: '',
      index: 0,
      orders_closed: [],
      orders_unclosed: [],
      list: ['已监控设备', '未监控设备'],
      isNet: false
    };
  },

  methods: {
    showDevice: function showDevice(index) {
      this.orders_closed = this.orders_closed[index].devices.map(function (item) {
        if (item.hasOwnProperty('node')) {
          switch (item.node.bonded) {
            case 'NO':
              item.node.bonded = '未绑定';
              break;
            case 'YES':
              item.node.bonded = '已绑定';
              break;
            default:
              item.node.bonded = '未知';
          }
          switch (item.node.level) {
            case 1:
              item.node.level = '信息';
              break;
            case 2:
              item.node.level = '警告';
              break;
            case 3:
              item.node.level = '错误';
              break;
            case 4:
              item.node.level = '紧急';
              break;
            case 5:
              item.node.level = '灾难';
              break;
          }
          item.node.connected = item.node.connected === 'NO' ? '未连接' : '已连接';
          switch (item.node.status) {
            case 'OK':
              item.color = '#43d841';
              break;
            case 'WARN':
              item.color = '#ffbe00c2';
              break;
            case 'ERROR':
              item.color = '#ce2924e6';
              break;
          }
        } else if (item.hasOwnProperty('nodes')) {
          if (item.nodes.length !== 0) {
            if (item.nodes[0].hasOwnProperty('info')) {
              item.nodes.forEach(function (value) {
                switch (value.type) {
                  case 'PowerOff Senser':
                    value.status = value.info.tem === '-0.0' ? '闭合' : '断开';
                    break;
                  case 'Smoke Senser':
                    value.status = value.info.tem === '0.1' ? '正常' : '异常';
                    break;
                  case 'Flood Senser':
                    value.status = value.info.tem === '0.1' ? '正常' : '异常';
                    break;
                }
                value.color = value.info.conn ? '#ffffff87' : '#6f696987';
              });
            } else {
              item.nodes.forEach(function (value) {
                switch (value.bonded) {
                  case 'NO':
                    value.bonded = '未绑定';
                    break;
                  case 'YES':
                    value.bonded = '已绑定';
                    break;
                  default:
                    value.bonded = '未知';
                }
                switch (value.level) {
                  case 1:
                    value.level = '信息';
                    break;
                  case 2:
                    value.level = '警告';
                    break;
                  case 3:
                    value.level = '错误';
                    break;
                  case 4:
                    value.level = '紧急';
                    break;
                  case 5:
                    value.level = '灾难';
                    break;
                }
                value.connected = value.connected === 'NO' ? '未连接' : '已连接';
                switch (value.status) {
                  case 'OK':
                    value.color = '#43d841';
                    break;
                  case 'WARN':
                    value.color = '#ffbe00c2';
                    break;
                  case 'ERROR':
                    value.color = '#ce2924e6';
                    break;
                }
              });
            }
          }
        }
        return item;
      });
      this.isShow = false;
    },
    smallbox: function smallbox(data) {
      this.$router.push({ name: 'smallbox', params: { order: data } });
    },
    forward: function forward(data) {
      this.$router.push({ name: 'Devicedetails', params: { 'order': data } });
    },
    getData: function getData() {
      var _this = this;

      var opid = localStorage.getItem('userid');
      var obj = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('api/v1/users/' + opid + '/devices', obj).then(function (res) {

        _this.orders_closed = res.data.monitors;
        _this.isShow = true;

        _this.orders_unclosed = res.data.orphans;
      });
    },
    switchover: function switchover() {
      this.isNet = !this.isNet;
    }
  },
  created: function created() {
    var _this2 = this;

    localStorage.removeItem('equipment');
    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      if (res.data.length !== 0) {
        _this2.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': res.data[0].account }).then(function (response) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userid', response.data.userid);
          _this2.getData();
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-143d6837","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Devicelist.vue
var Devicelist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('tab',{attrs:{"line-width":2,"active-color":"#fc378c"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.list),function(item,index){return _c('tab-item',{key:index,staticClass:"vux-center",attrs:{"selected":_vm.select === item},on:{"on-item-click":function($event){_vm.select = item;_vm.getData()}}},[_vm._v(_vm._s(item)+"\n    ")])})),_vm._v(" "),(_vm.select==='已监控设备'||_vm.select === '')?_c('div',[(!_vm.isShow && !_vm.isNet)?_c('div',{staticClass:"title",on:{"click":_vm.switchover}},[_vm._v("切换网络拓扑显示")]):_vm._e(),_vm._v(" "),(!_vm.isShow && _vm.isNet)?_c('div',{staticClass:"title",on:{"click":_vm.switchover}},[_vm._v("切换设备列表显示")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),(!_vm.isNet)?_vm._l((_vm.orders_closed),function(item,index){return _c('div',{key:index},[(_vm.isShow)?_c('DeviceInfo',{attrs:{"type":"box","device":item,"index":index},on:{"chose":_vm.showDevice}}):_vm._e(),_vm._v(" "),(!_vm.isShow&&item.hasOwnProperty('node'))?_c('DeviceInfo',{attrs:{"type":"host","device":item.node,"background":item.color}}):_vm._e(),_vm._v(" "),(!_vm.isShow&&item.hasOwnProperty('nodes'))?_c('DeviceInfo',{attrs:{"type":"group","device":item}}):_vm._e()],1)}):_vm._e(),_vm._v(" "),(_vm.isNet)?_vm._l((_vm.orders_closed),function(item,index){return _c('div',{key:index},[(item.hasOwnProperty('nodes') && item.gname === '网络拓扑')?_c('topological',{attrs:{"device":item.nodes}}):_vm._e()],1)}):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.select==='未监控设备')?_c('div',_vm._l((_vm.orders_unclosed),function(item,index){return _c('div',{key:index},[_c('DeviceInfo',{attrs:{"type":"box","device":item}})],1)})):_vm._e()],1)}
var Devicelist_staticRenderFns = []
var Devicelist_esExports = { render: Devicelist_render, staticRenderFns: Devicelist_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Devicelist = (Devicelist_esExports);
// CONCATENATED MODULE: ./src/components/Devicelist.vue
function Devicelist_injectStyle (ssrContext) {
  __webpack_require__("da65")
}
var Devicelist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Devicelist___vue_template_functional__ = false
/* styles */
var Devicelist___vue_styles__ = Devicelist_injectStyle
/* scopeId */
var Devicelist___vue_scopeId__ = "data-v-143d6837"
/* moduleIdentifier (server only) */
var Devicelist___vue_module_identifier__ = null
var Devicelist_Component = Devicelist_normalizeComponent(
  components_Devicelist,
  selectortype_template_index_0_src_components_Devicelist,
  Devicelist___vue_template_functional__,
  Devicelist___vue_styles__,
  Devicelist___vue_scopeId__,
  Devicelist___vue_module_identifier__
)

/* harmony default export */ var src_components_Devicelist = (Devicelist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Devicedetails.vue









/* harmony default export */ var Devicedetails = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      orderDetail: {},
      iden: '',
      flag: false,
      ftype: '1',
      list: [{ key: 1, value: '信息' }, { key: 2, value: '警告' }, { key: 3, value: '错误' }, { key: 4, value: '紧急' }]
    };
  },

  methods: {
    faultRecord: function faultRecord() {
      this.$router.push({ name: 'recordlist' });
    },
    Revisionlevel: function Revisionlevel() {
      var _this = this;

      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden,
        'level': this.ftype
      };
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bondlevel', obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    Unbind: function Unbind() {
      var _this2 = this;

      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden
      };
      var that = this;
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/unbond', obj, header).then(function (res) {
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    binding: function binding() {
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden,
        'level': this.ftype
      };
      var that = this;
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bond', obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        if (error.response.data) {
          that.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === 'Devicelist') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        switch (vm.orderDetail.level) {
          case '信息':
            vm.ftype = 1;
            break;
          case '警告':
            vm.ftype = 2;
            break;
          case '错误':
            vm.ftype = 3;
            break;
          case '紧急':
            vm.ftype = 4;
            break;
        }
        vm.flag = vm.orderDetail.bonded === '已绑定';
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: localStorage.getItem('token'),
            opid: opid
          }
        };
        vm.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.iden = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.iden = 'ENTP';
            }
          }
        });
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        switch (vm.orderDetail.level) {
          case '信息':
            vm.ftype = 1;
            break;
          case '警告':
            vm.ftype = 2;
            break;
          case '错误':
            vm.ftype = 3;
            break;
          case '紧急':
            vm.ftype = 4;
            break;
        }
        vm.flag = vm.orderDetail.bonded === '已绑定';
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: localStorage.getItem('token'),
            opid: opid
          }
        };
        vm.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.iden = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.iden = 'ENTP';
            }
          }
        });
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== 'recordlist') {
      localStorage.removeItem('order');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Devicedetails.vue









/* harmony default export */ var components_Devicedetails = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      orderDetail: {},
      iden: '',
      flag: false,
      ftype: '1',
      list: [{ key: 1, value: '信息' }, { key: 2, value: '警告' }, { key: 3, value: '错误' }, { key: 4, value: '紧急' }]
    };
  },

  methods: {
    faultRecord: function faultRecord() {
      this.$router.push({ name: 'recordlist' });
    },
    Revisionlevel: function Revisionlevel() {
      var _this = this;

      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden,
        'level': this.ftype
      };
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bondlevel', obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    Unbind: function Unbind() {
      var _this2 = this;

      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden
      };
      var that = this;
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/unbond', obj, header).then(function (res) {
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    binding: function binding() {
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden,
        'level': this.ftype
      };
      var that = this;
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bond', obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        if (error.response.data) {
          that.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === 'Devicelist') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        switch (vm.orderDetail.level) {
          case '信息':
            vm.ftype = 1;
            break;
          case '警告':
            vm.ftype = 2;
            break;
          case '错误':
            vm.ftype = 3;
            break;
          case '紧急':
            vm.ftype = 4;
            break;
        }
        vm.flag = vm.orderDetail.bonded === '已绑定';
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: localStorage.getItem('token'),
            opid: opid
          }
        };
        vm.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.iden = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.iden = 'ENTP';
            }
          }
        });
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        switch (vm.orderDetail.level) {
          case '信息':
            vm.ftype = 1;
            break;
          case '警告':
            vm.ftype = 2;
            break;
          case '错误':
            vm.ftype = 3;
            break;
          case '紧急':
            vm.ftype = 4;
            break;
        }
        vm.flag = vm.orderDetail.bonded === '已绑定';
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: localStorage.getItem('token'),
            opid: opid
          }
        };
        vm.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.iden = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.iden = 'ENTP';
            }
          }
        });
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== 'recordlist') {
      localStorage.removeItem('order');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92bd6a96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Devicedetails.vue
var Devicedetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}]},[_c('group',[_c('x-input',{attrs:{"title":"设备编号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.tp),callback:function ($$v) {_vm.$set(_vm.orderDetail, "tp", $$v)},expression:"orderDetail.tp"}}),_vm._v(" "),_c('selector',{attrs:{"title":"设备故障等级","options":_vm.list},model:{value:(_vm.ftype),callback:function ($$v) {_vm.ftype=$$v},expression:"ftype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备描述","type":"text","readonly":""},model:{value:(_vm.orderDetail.desc),callback:function ($$v) {_vm.$set(_vm.orderDetail, "desc", $$v)},expression:"orderDetail.desc"}}),_vm._v(" "),_c('cell',{attrs:{"title":('故障记录'),"is-link":""},nativeOn:{"click":function($event){return _vm.faultRecord($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"btn_box"},[_c('x-button',{staticClass:"btn",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.Revisionlevel($event)}}},[_vm._v("修改故障等级")]),_vm._v(" "),_c('x-button',{staticClass:"btn",staticStyle:{"margin-top":"10px"},attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.Unbind($event)}}},[_vm._v("取消绑定")])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.flag),expression:"!flag"}]},[_c('group',[_c('x-input',{attrs:{"title":"设备编号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备描述","type":"text","readonly":""},model:{value:(_vm.orderDetail.desc),callback:function ($$v) {_vm.$set(_vm.orderDetail, "desc", $$v)},expression:"orderDetail.desc"}}),_vm._v(" "),_c('selector',{attrs:{"title":"设备故障等级","options":_vm.list},model:{value:(_vm.ftype),callback:function ($$v) {_vm.ftype=$$v},expression:"ftype"}})],1),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.binding($event)}}},[_vm._v("绑定设备")])],1)])}
var Devicedetails_staticRenderFns = []
var Devicedetails_esExports = { render: Devicedetails_render, staticRenderFns: Devicedetails_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Devicedetails = (Devicedetails_esExports);
// CONCATENATED MODULE: ./src/components/Devicedetails.vue
function Devicedetails_injectStyle (ssrContext) {
  __webpack_require__("S3ag")
}
var Devicedetails_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Devicedetails___vue_template_functional__ = false
/* styles */
var Devicedetails___vue_styles__ = Devicedetails_injectStyle
/* scopeId */
var Devicedetails___vue_scopeId__ = "data-v-92bd6a96"
/* moduleIdentifier (server only) */
var Devicedetails___vue_module_identifier__ = null
var Devicedetails_Component = Devicedetails_normalizeComponent(
  components_Devicedetails,
  selectortype_template_index_0_src_components_Devicedetails,
  Devicedetails___vue_template_functional__,
  Devicedetails___vue_styles__,
  Devicedetails___vue_scopeId__,
  Devicedetails___vue_module_identifier__
)

/* harmony default export */ var src_components_Devicedetails = (Devicedetails_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/recordlist.vue












/* harmony default export */ var recordlist = ({
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      select: '',
      orders_unclosed: [],
      list: ['故障记录'],
      index: 0,
      role: '',
      loadmoreone: '加载更多',
      isDisabled: false,
      iden: '',
      data: {},
      show: true
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      this.isDisabled = true;
      this.loadmoreone = '加载中';
      var offset = this.orders_unclosed.length;
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };

      this.$http.get('api/v1/devices/' + this.data.seq + '/warnings?offset=' + offset + '&count=10&role=' + this.iden, header).then(function (res) {
        console.log(res);
        that.isDisabled = false;

        if (res.data.contents.length > 0) {
          that.loadmoreone = '加载更多';
        } else {
          that.show = false;
        }
        var orders = [];
        orders = res.data.contents;

        for (var i = 0; i < orders.length; i++) {
          if (orders[i].level == 0) {
            orders[i].level = '未分类';
          }
          if (orders[i].level == 1) {
            orders[i].level = '信息';
          }
          if (orders[i].level == 2) {
            orders[i].level = '警告';
          }
          if (orders[i].level == 3) {
            orders[i].level = '错误';
          }
          if (orders[i].level == 4) {
            orders[i].level = '紧急';
          }
          if (orders[i].level == 5) {
            orders[i].level = '灾难';
          }

          if (orders[i].action == 0) {
            orders[i].action = '故障恢复';
          }
          if (orders[i].action == 1) {
            orders[i].action = '故障发生';
          }

          that.orders_unclosed.push(orders[i]);
        }
      }).catch(function (err) {
        console.log(err.response);
      });
    }
  },
  created: function created() {
    var opid = localStorage.getItem('userid');
    var order = localStorage.getItem('order');

    if (order) {
      this.data = JSON.parse(order);
    } else {
      this.data = this.$route.params.data;
    }
    console.log(this.data);
    var that = this;
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == 'INDV') {
          that.iden = 'INDV';
        }
        if (res.data[i].type == 'ENTP') {
          that.iden = 'ENTP';
        }
      }
      that.$http.get('api/v1/devices/' + that.data.seq + '/warnings?offset=0&count=10&role=' + that.iden, header).then(function (res) {
        that.orders_unclosed = res.data.contents;
        for (var i = 0; i < that.orders_unclosed.length; i++) {
          if (that.orders_unclosed[i].level == 0) {
            that.orders_unclosed[i].level = '未分类';
          }
          if (that.orders_unclosed[i].level == 1) {
            that.orders_unclosed[i].level = '信息';
          }
          if (that.orders_unclosed[i].level == 2) {
            that.orders_unclosed[i].level = '警告';
          }
          if (that.orders_unclosed[i].level == 3) {
            that.orders_unclosed[i].level = '错误';
          }
          if (that.orders_unclosed[i].level == 4) {
            that.orders_unclosed[i].level = '紧急';
          }
          if (that.orders_unclosed[i].level == 5) {
            that.orders_unclosed[i].level = '灾难';
          }

          if (that.orders_unclosed[i].action == 0) {
            that.orders_unclosed[i].action = '故障恢复';
          }
          if (that.orders_unclosed[i].action == 1) {
            that.orders_unclosed[i].action = '故障发生';
          }
        }
        console.log(res);
      }).catch(function (err) {
        console.log(err.response);
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/recordlist.vue












/* harmony default export */ var components_recordlist = ({
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */],
    CellBox: vux_src_components_cell_box,
    Confirm: components_confirm["a" /* default */],
    Alert: components_alert["a" /* default */],
    XButton: vux_src_components_x_button,
    Tab: src_components_tab_tab,
    TabItem: src_components_tab_tab_item,
    Swiper: vux_src_components_swiper_swiper,
    SwiperItem: src_components_swiper_swiper_item
  },
  data: function data() {
    return {
      select: '',
      orders_unclosed: [],
      list: ['故障记录'],
      index: 0,
      role: '',
      loadmoreone: '加载更多',
      isDisabled: false,
      iden: '',
      data: {},
      show: true
    };
  },

  methods: {
    showMoreorders: function showMoreorders() {
      this.isDisabled = true;
      this.loadmoreone = '加载中';
      var offset = this.orders_unclosed.length;
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };

      this.$http.get('api/v1/devices/' + this.data.seq + '/warnings?offset=' + offset + '&count=10&role=' + this.iden, header).then(function (res) {
        console.log(res);
        that.isDisabled = false;

        if (res.data.contents.length > 0) {
          that.loadmoreone = '加载更多';
        } else {
          that.show = false;
        }
        var orders = [];
        orders = res.data.contents;

        for (var i = 0; i < orders.length; i++) {
          if (orders[i].level == 0) {
            orders[i].level = '未分类';
          }
          if (orders[i].level == 1) {
            orders[i].level = '信息';
          }
          if (orders[i].level == 2) {
            orders[i].level = '警告';
          }
          if (orders[i].level == 3) {
            orders[i].level = '错误';
          }
          if (orders[i].level == 4) {
            orders[i].level = '紧急';
          }
          if (orders[i].level == 5) {
            orders[i].level = '灾难';
          }

          if (orders[i].action == 0) {
            orders[i].action = '故障恢复';
          }
          if (orders[i].action == 1) {
            orders[i].action = '故障发生';
          }

          that.orders_unclosed.push(orders[i]);
        }
      }).catch(function (err) {
        console.log(err.response);
      });
    }
  },
  created: function created() {
    var opid = localStorage.getItem('userid');
    var order = localStorage.getItem('order');

    if (order) {
      this.data = JSON.parse(order);
    } else {
      this.data = this.$route.params.data;
    }
    console.log(this.data);
    var that = this;
    var header = {
      headers: {
        token: localStorage.getItem('token'),
        opid: opid
      }
    };
    this.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].type == 'INDV') {
          that.iden = 'INDV';
        }
        if (res.data[i].type == 'ENTP') {
          that.iden = 'ENTP';
        }
      }
      that.$http.get('api/v1/devices/' + that.data.seq + '/warnings?offset=0&count=10&role=' + that.iden, header).then(function (res) {
        that.orders_unclosed = res.data.contents;
        for (var i = 0; i < that.orders_unclosed.length; i++) {
          if (that.orders_unclosed[i].level == 0) {
            that.orders_unclosed[i].level = '未分类';
          }
          if (that.orders_unclosed[i].level == 1) {
            that.orders_unclosed[i].level = '信息';
          }
          if (that.orders_unclosed[i].level == 2) {
            that.orders_unclosed[i].level = '警告';
          }
          if (that.orders_unclosed[i].level == 3) {
            that.orders_unclosed[i].level = '错误';
          }
          if (that.orders_unclosed[i].level == 4) {
            that.orders_unclosed[i].level = '紧急';
          }
          if (that.orders_unclosed[i].level == 5) {
            that.orders_unclosed[i].level = '灾难';
          }

          if (that.orders_unclosed[i].action == 0) {
            that.orders_unclosed[i].action = '故障恢复';
          }
          if (that.orders_unclosed[i].action == 1) {
            that.orders_unclosed[i].action = '故障发生';
          }
        }
        console.log(res);
      }).catch(function (err) {
        console.log(err.response);
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db4090cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/recordlist.vue
var recordlist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('tab',{attrs:{"line-width":2,"active-color":"#fc378c"},model:{value:(_vm.index),callback:function ($$v) {_vm.index=$$v},expression:"index"}},_vm._l((_vm.list),function(item,index){return _c('tab-item',{key:index,staticClass:"vux-center",attrs:{"selected":_vm.select === item},on:{"click":function($event){_vm.select = item}}},[_vm._v(_vm._s(item)+"\n        ")])})),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 0),expression:"index === 0"}],staticClass:"tab-swiper vux-center"},[_vm._l((_vm.orders_unclosed),function(order,index){return _c('cell',{key:index},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.device))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.occourTime))])]),_vm._v(" "),_c('div',{staticStyle:{"word-wrap":"break-word","width":"210px"}},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(order.level)+","+_vm._s(order.action))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(order.detail))])])])}),_vm._v(" "),_c('x-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"type":"default","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.showMoreorders($event)}}},[_vm._v("\n            "+_vm._s(_vm.loadmoreone)+"\n        ")])],2)],1)}
var recordlist_staticRenderFns = []
var recordlist_esExports = { render: recordlist_render, staticRenderFns: recordlist_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_recordlist = (recordlist_esExports);
// CONCATENATED MODULE: ./src/components/recordlist.vue
var recordlist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var recordlist___vue_template_functional__ = false
/* styles */
var recordlist___vue_styles__ = null
/* scopeId */
var recordlist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var recordlist___vue_module_identifier__ = null
var recordlist_Component = recordlist_normalizeComponent(
  components_recordlist,
  selectortype_template_index_0_src_components_recordlist,
  recordlist___vue_template_functional__,
  recordlist___vue_styles__,
  recordlist___vue_scopeId__,
  recordlist___vue_module_identifier__
)

/* harmony default export */ var src_components_recordlist = (recordlist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/smallbox.vue









/* harmony default export */ var smallbox = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      orderDetail: {},
      iden: '',
      ftype: '1',
      flag: false,
      list: [{ key: 1, value: '信息' }, { key: 2, value: '警告' }, { key: 3, value: '错误' }, { key: 4, value: '紧急' }]
    };
  },

  methods: {
    faultRecord: function faultRecord() {
      this.$router.push({ name: 'recordlist' });
    },
    Revisionlevel: function Revisionlevel() {
      var _this = this;

      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden,
        'level': this.ftype
      };
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bondlevel', obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (err) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    Unbind: function Unbind() {
      var _this2 = this;

      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden
      };
      var that = this;
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/unbond', obj, header).then(function (res) {
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    binding: function binding() {
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      if (!opid) {
        this.$vux.alert.show({
          title: '',
          content: '请先登录，然后再进行绑定，如果您还没有注册，请先注册为个人用户。'
        });
        this.$router.push({ name: 'register', query: { role: 'users' } });
        return;
      }
      if (!this.iden) {
        this.$vux.alert.show({
          title: '',
          content: '您还没有个人用户身份，请先添加个人用户身份，然后再进行绑定。'
        });
        this.$router.push({ name: 'vip' });
        return;
      }
      var obj = {
        'userid': opid,
        'role': this.iden,
        'level': this.ftype
      };
      var that = this;
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bond', obj, header).then(function (res) {
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        if (error.response.data) {
          that.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'Devicelist') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        vm.ftype = vm.orderDetail.level;
        vm.flag = true;
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        localStorage.setItem('flag', true);

        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: localStorage.getItem('token'),
            opid: opid
          }
        };
        vm.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.iden = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.iden = 'ENTP';
            }
          }
        });
      });
    } else if (from.name == 'sbxx') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        localStorage.setItem('flag', false);
        var role = vm.$route.params.role;
        vm.iden = role;
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        vm.flag = localStorage.getItem('flag');
        if (vm.orderDetail.level) {
          vm.ftype = vm.orderDetail.level;
        }
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: localStorage.getItem('token'),
            opid: opid
          }
        };
        vm.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.iden = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.iden = 'ENTP';
            }
          }
        });
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'recordlist') {
      next();
    } else {
      localStorage.removeItem('order');
      localStorage.removeItem('flag');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/smallbox.vue









/* harmony default export */ var components_smallbox = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    Selector: vux_src_components_selector
  },
  data: function data() {
    return {
      orderDetail: {},
      iden: '',
      ftype: '1',
      flag: false,
      list: [{ key: 1, value: '信息' }, { key: 2, value: '警告' }, { key: 3, value: '错误' }, { key: 4, value: '紧急' }]
    };
  },

  methods: {
    faultRecord: function faultRecord() {
      this.$router.push({ name: 'recordlist' });
    },
    Revisionlevel: function Revisionlevel() {
      var _this = this;

      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden,
        'level': this.ftype
      };
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bondlevel', obj, header).then(function (res) {
        console.log(res);
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (err) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    Unbind: function Unbind() {
      var _this2 = this;

      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      var obj = {
        'userid': opid,
        'role': this.iden
      };
      var that = this;
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/unbond', obj, header).then(function (res) {
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        _this2.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    binding: function binding() {
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: opid
        }
      };
      if (!opid) {
        this.$vux.alert.show({
          title: '',
          content: '请先登录，然后再进行绑定，如果您还没有注册，请先注册为个人用户。'
        });
        this.$router.push({ name: 'register', query: { role: 'users' } });
        return;
      }
      if (!this.iden) {
        this.$vux.alert.show({
          title: '',
          content: '您还没有个人用户身份，请先添加个人用户身份，然后再进行绑定。'
        });
        this.$router.push({ name: 'vip' });
        return;
      }
      var obj = {
        'userid': opid,
        'role': this.iden,
        'level': this.ftype
      };
      var that = this;
      this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bond', obj, header).then(function (res) {
        that.$router.push({ name: 'Devicelist' });
      }).catch(function (error) {
        if (error.response.data) {
          that.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        }
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'Devicelist') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        vm.ftype = vm.orderDetail.level;
        vm.flag = true;
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        localStorage.setItem('flag', true);

        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: localStorage.getItem('token'),
            opid: opid
          }
        };
        vm.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.iden = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.iden = 'ENTP';
            }
          }
        });
      });
    } else if (from.name == 'sbxx') {
      next(function (vm) {
        vm.orderDetail = vm.$route.params.order;
        var order = stringify_default()(vm.orderDetail);
        localStorage.setItem('order', order);
        localStorage.setItem('flag', false);
        var role = vm.$route.params.role;
        vm.iden = role;
      });
    } else {
      next(function (vm) {
        var order = localStorage.getItem('order');
        vm.orderDetail = JSON.parse(order);
        vm.flag = localStorage.getItem('flag');
        if (vm.orderDetail.level) {
          vm.ftype = vm.orderDetail.level;
        }
        var opid = localStorage.getItem('userid');
        var header = {
          headers: {
            token: localStorage.getItem('token'),
            opid: opid
          }
        };
        vm.$http.get('/api/v1/accounts/' + opid, header).then(function (res) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type == 'INDV') {
              vm.iden = 'INDV';
            }
            if (res.data[i].type == 'ENTP') {
              vm.iden = 'ENTP';
            }
          }
        });
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name == 'recordlist') {
      next();
    } else {
      localStorage.removeItem('order');
      localStorage.removeItem('flag');
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b534450","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/smallbox.vue
var smallbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag),expression:"flag"}]},[_c('group',[_c('x-input',{attrs:{"title":"设备编号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('selector',{attrs:{"title":"设备故障等级","options":_vm.list},model:{value:(_vm.ftype),callback:function ($$v) {_vm.ftype=$$v},expression:"ftype"}}),_vm._v(" "),_c('cell',{attrs:{"title":('故障记录'),"is-link":""},nativeOn:{"click":function($event){return _vm.faultRecord($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"btn_box"},[_c('x-button',{staticClass:"btn",attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.Revisionlevel($event)}}},[_vm._v("修改故障等级")]),_vm._v(" "),_c('x-button',{staticClass:"btn",staticStyle:{"margin-top":"10px"},attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.Unbind($event)}}},[_vm._v("取消绑定")])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.flag),expression:"!flag"}]},[_c('group',[_c('x-input',{attrs:{"title":"设备名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.extname),callback:function ($$v) {_vm.$set(_vm.orderDetail, "extname", $$v)},expression:"orderDetail.extname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.orderDetail.sn),callback:function ($$v) {_vm.$set(_vm.orderDetail, "sn", $$v)},expression:"orderDetail.sn"}}),_vm._v(" "),_c('selector',{attrs:{"title":"设备故障等级","options":_vm.list},model:{value:(_vm.ftype),callback:function ($$v) {_vm.ftype=$$v},expression:"ftype"}})],1),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.binding($event)}}},[_vm._v("绑定设备")])],1)])}
var smallbox_staticRenderFns = []
var smallbox_esExports = { render: smallbox_render, staticRenderFns: smallbox_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_smallbox = (smallbox_esExports);
// CONCATENATED MODULE: ./src/components/smallbox.vue
function smallbox_injectStyle (ssrContext) {
  __webpack_require__("15Az")
}
var smallbox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var smallbox___vue_template_functional__ = false
/* styles */
var smallbox___vue_styles__ = smallbox_injectStyle
/* scopeId */
var smallbox___vue_scopeId__ = "data-v-5b534450"
/* moduleIdentifier (server only) */
var smallbox___vue_module_identifier__ = null
var smallbox_Component = smallbox_normalizeComponent(
  components_smallbox,
  selectortype_template_index_0_src_components_smallbox,
  smallbox___vue_template_functional__,
  smallbox___vue_styles__,
  smallbox___vue_scopeId__,
  smallbox___vue_module_identifier__
)

/* harmony default export */ var src_components_smallbox = (smallbox_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addphoto.vue


















/* harmony default export */ var addphoto = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    XTextarea: vux_src_components_x_textarea,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      role: '',
      order: '',
      imgList: [],
      show: true,
      flag: true,
      num: 0,
      list: [],
      index: 0,
      newobj: { photo: [] },
      fdetail_version: '1.1',
      isAssis: this.$route.params.isAssis || false,
      parhList: []
    };
  },

  methods: {
    shows: function shows(index) {
      var _this = this;

      if (this.imgList[index].hasOwnProperty('src')) {
        this.$refs.previewer.show(index);
      } else {
        var path = this.parhList[index].origin;
        this.$vux.loading.show({ text: '加载中' });
        this.$http.get('api/v1/photos?path=' + path).then(function (res) {
          _this.$vux.loading.hide();
          _this.imgList[index].src = 'data:image/jpeg;base64,' + res.data['value'];
          _this.$refs.previewer.show(index);
        });
      }
    },
    confirm: function confirm() {
      var _this2 = this;

      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var data = {
        role: this.role,
        fdetail: {
          version: this.fdetail_version,
          content: [{ path: this.list }]
        }
      };
      ajax["a" /* default */].$http.put('api/v1/normalrepairs/' + this.order.seq + '/fdetail', data, header).then(function (res) {
        that.$router.push({ name: 'normalcomplete', query: { seq: _this2.order.seq } });
      }).catch(function (error) {
        that.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: "cancel",
          time: "1000"
        });
      });
    },
    upload: function upload() {
      var app = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: app.num, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          var localIds = res.localIds;
          var i = 0;
          length = localIds.length;
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {
                app.$vux.loading.show();

                app.flag = false;
                if (app.list.length === 0) {
                  app.newobj.photo.push(res.serverId);
                } else {
                  obj.photo.push(res.serverId);
                }
                i++;
                app.num--;
                if (i < length) {
                  upload();
                } else {
                  if (app.list.length === 0) {
                    app.submitImage(app.newobj);
                  } else {
                    app.submitImage(obj);
                  }
                }
              }
            });
          };
          upload();
        }
      });
    },
    submitImage: function submitImage(userInfo) {
      var _this3 = this;

      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      ajax["a" /* default */].$http.post('/api/v1/photos/wechat', userInfo, header).then(function (response) {
        app.flag = true;
        app.imgList = [];
        if (_this3.fdetail_version === '1.1') {
          app.list = [].concat(toConsumableArray_default()(app.list), toConsumableArray_default()(response.data));
          _this3.parhList = [].concat(toConsumableArray_default()(_this3.list));
          app.decrypt();
        } else {
          if (app.list.length === 0) {
            response.data.forEach(function (item) {
              _this3.list.push(item.origin.toString());
            });
            _this3.decrypt();
            app.list = response.data;
            app.decrypt();
          } else {
            for (var i = 0; i < response.data.length; i++) {
              app.list.push(response.data[i].origin);
            }
            app.decrypt();
          }
        }
        if (app.list.length === 6) {
          app.show = false;
        }
      }).catch(function (error) {
        app.flag = true;
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          } else {
            app.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.toast.show({
            text: '服务器错误，请稍后重试',
            type: 'cancel',
            time: '1000'
          });
          console.log('Error', error.message);
        }
      });
    },
    decrypt: function decrypt() {
      var _this4 = this;

      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var that = this;
      var path = void 0;
      path = this.fdetail_version === '1.1' ? this.list[this.index]['thumb'] : this.list[this.index];
      ajax["a" /* default */].$http.get('api/v1/photos?path=' + path, header).then(function (res) {
        that.imgList.push({ msrc: 'data:image/jpeg;base64,' + res.data.value });
        that.index++;
        _this4.$vux.loading.hide();
        if (that.index < that.list.length) {
          that.decrypt();
        }
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this5;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {

          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    var _this6 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var that, token, opid, header, data, order, arr, brr, path, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = _this6;
              token = localStorage.getItem('token');
              opid = localStorage.getItem('userid');
              header = {
                headers: {
                  token: token,
                  opid: opid
                }
              };
              data = localStorage.getItem('order');
              order = JSON.parse(data);

              _this6.order = order;
              arr = [], brr = [];

              if (!(order.fdetail.content.length > 0)) {
                _context.next = 46;
                break;
              }

              _this6.num = 6 - order.fdetail.content[0].path.length;
              _this6.list = order.fdetail.content[0].path;
              if (_this6.list.length === 6) {
                _this6.show = false;
              }
              arr = order.fdetail.content[0].path;
              _this6.fdetail_version = order.fdetail.version;
              _this6.parhList = [].concat(toConsumableArray_default()(arr));
              path = void 0;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 19;
              _iterator = get_iterator_default()(arr);

            case 21:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 29;
                break;
              }

              item = _step.value;

              path = _this6.fdetail_version === '1.1' ? item['thumb'] : item;
              _context.next = 26;
              return _this6.$http.get('api/v1/photos?path=' + path, header).then(function (res) {
                brr.push({ msrc: 'data:image/jpeg;base64,' + res.data.value });
              });

            case 26:
              _iteratorNormalCompletion = true;
              _context.next = 21;
              break;

            case 29:
              _context.next = 35;
              break;

            case 31:
              _context.prev = 31;
              _context.t0 = _context['catch'](19);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 35:
              _context.prev = 35;
              _context.prev = 36;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 38:
              _context.prev = 38;

              if (!_didIteratorError) {
                _context.next = 41;
                break;
              }

              throw _iteratorError;

            case 41:
              return _context.finish(38);

            case 42:
              return _context.finish(35);

            case 43:
              _this6.imgList = brr;
              _context.next = 47;
              break;

            case 46:
              _this6.num = 6;

            case 47:

              _this6.$http.get('api/v1/accounts/' + opid, header).then(function (response) {
                for (var i = 0; i < response.data.length; i++) {
                  if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                    that.role = response.data[i].type;
                  }
                }
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.data) {
                    that.$vux.alert.show({
                      title: '',
                      content: JSON.parse(error.response.data.error_message).zh_string
                    });
                  }
                }
              });
              console.log(order);

            case 49:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this6, [[19, 31, 35, 43], [36,, 38, 42]]);
    }))();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/addphoto.vue


















/* harmony default export */ var components_addphoto = ({
  components: {
    XHeader: vux_src_components_x_header,
    XInput: vux_src_components_x_input,
    Group: group["a" /* default */],
    XButton: vux_src_components_x_button,
    Cell: vux_src_components_cell,
    XTextarea: vux_src_components_x_textarea,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      role: '',
      order: '',
      imgList: [],
      show: true,
      flag: true,
      num: 0,
      list: [],
      index: 0,
      newobj: { photo: [] },
      fdetail_version: '1.1',
      isAssis: this.$route.params.isAssis || false,
      parhList: []
    };
  },

  methods: {
    shows: function shows(index) {
      var _this = this;

      if (this.imgList[index].hasOwnProperty('src')) {
        this.$refs.previewer.show(index);
      } else {
        var path = this.parhList[index].origin;
        this.$vux.loading.show({ text: '加载中' });
        this.$http.get('api/v1/photos?path=' + path).then(function (res) {
          _this.$vux.loading.hide();
          _this.imgList[index].src = 'data:image/jpeg;base64,' + res.data['value'];
          _this.$refs.previewer.show(index);
        });
      }
    },
    confirm: function confirm() {
      var _this2 = this;

      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var that = this;
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var data = {
        role: this.role,
        fdetail: {
          version: this.fdetail_version,
          content: [{ path: this.list }]
        }
      };
      ajax["a" /* default */].$http.put('api/v1/normalrepairs/' + this.order.seq + '/fdetail', data, header).then(function (res) {
        that.$router.push({ name: 'normalcomplete', query: { seq: _this2.order.seq } });
      }).catch(function (error) {
        that.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: "cancel",
          time: "1000"
        });
      });
    },
    upload: function upload() {
      var app = this;

      var obj = {
        photo: []
      };

      weixin_js_sdk_default.a.chooseImage({
        count: app.num, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          var localIds = res.localIds;
          var i = 0;
          length = localIds.length;
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function success(res) {
                app.$vux.loading.show();

                app.flag = false;
                if (app.list.length === 0) {
                  app.newobj.photo.push(res.serverId);
                } else {
                  obj.photo.push(res.serverId);
                }
                i++;
                app.num--;
                if (i < length) {
                  upload();
                } else {
                  if (app.list.length === 0) {
                    app.submitImage(app.newobj);
                  } else {
                    app.submitImage(obj);
                  }
                }
              }
            });
          };
          upload();
        }
      });
    },
    submitImage: function submitImage(userInfo) {
      var _this3 = this;

      var app = this;
      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      ajax["a" /* default */].$http.post('/api/v1/photos/wechat', userInfo, header).then(function (response) {
        app.flag = true;
        app.imgList = [];
        if (_this3.fdetail_version === '1.1') {
          app.list = [].concat(toConsumableArray_default()(app.list), toConsumableArray_default()(response.data));
          _this3.parhList = [].concat(toConsumableArray_default()(_this3.list));
          app.decrypt();
        } else {
          if (app.list.length === 0) {
            response.data.forEach(function (item) {
              _this3.list.push(item.origin.toString());
            });
            _this3.decrypt();
            app.list = response.data;
            app.decrypt();
          } else {
            for (var i = 0; i < response.data.length; i++) {
              app.list.push(response.data[i].origin);
            }
            app.decrypt();
          }
        }
        if (app.list.length === 6) {
          app.show = false;
        }
      }).catch(function (error) {
        app.flag = true;
        if (error.response) {
          app.$vux.loading.hide();
          if (error.response.data.error_message) {
            app.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          } else {
            app.$vux.toast.show({
              text: '服务器错误，请稍后重试',
              type: 'cancel',
              time: '1000'
            });
          }
        } else {
          app.$vux.loading.hide();
          app.$vux.toast.show({
            text: '服务器错误，请稍后重试',
            type: 'cancel',
            time: '1000'
          });
          console.log('Error', error.message);
        }
      });
    },
    decrypt: function decrypt() {
      var _this4 = this;

      var token = localStorage.getItem('token');
      var opid = localStorage.getItem('userid');
      var header = {
        headers: {
          token: token,
          opid: opid
        }
      };
      var that = this;
      var path = void 0;
      path = this.fdetail_version === '1.1' ? this.list[this.index]['thumb'] : this.list[this.index];
      ajax["a" /* default */].$http.get('api/v1/photos?path=' + path, header).then(function (res) {
        that.imgList.push({ msrc: 'data:image/jpeg;base64,' + res.data.value });
        that.index++;
        _this4.$vux.loading.hide();
        if (that.index < that.list.length) {
          that.decrypt();
        }
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this5;
      app.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.path;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {});
        }).catch(function (error) {

          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    var _this6 = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var that, token, opid, header, data, order, arr, brr, path, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = _this6;
              token = localStorage.getItem('token');
              opid = localStorage.getItem('userid');
              header = {
                headers: {
                  token: token,
                  opid: opid
                }
              };
              data = localStorage.getItem('order');
              order = JSON.parse(data);

              _this6.order = order;
              arr = [], brr = [];

              if (!(order.fdetail.content.length > 0)) {
                _context.next = 46;
                break;
              }

              _this6.num = 6 - order.fdetail.content[0].path.length;
              _this6.list = order.fdetail.content[0].path;
              if (_this6.list.length === 6) {
                _this6.show = false;
              }
              arr = order.fdetail.content[0].path;
              _this6.fdetail_version = order.fdetail.version;
              _this6.parhList = [].concat(toConsumableArray_default()(arr));
              path = void 0;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 19;
              _iterator = get_iterator_default()(arr);

            case 21:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 29;
                break;
              }

              item = _step.value;

              path = _this6.fdetail_version === '1.1' ? item['thumb'] : item;
              _context.next = 26;
              return _this6.$http.get('api/v1/photos?path=' + path, header).then(function (res) {
                brr.push({ msrc: 'data:image/jpeg;base64,' + res.data.value });
              });

            case 26:
              _iteratorNormalCompletion = true;
              _context.next = 21;
              break;

            case 29:
              _context.next = 35;
              break;

            case 31:
              _context.prev = 31;
              _context.t0 = _context['catch'](19);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 35:
              _context.prev = 35;
              _context.prev = 36;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 38:
              _context.prev = 38;

              if (!_didIteratorError) {
                _context.next = 41;
                break;
              }

              throw _iteratorError;

            case 41:
              return _context.finish(38);

            case 42:
              return _context.finish(35);

            case 43:
              _this6.imgList = brr;
              _context.next = 47;
              break;

            case 46:
              _this6.num = 6;

            case 47:

              _this6.$http.get('api/v1/accounts/' + opid, header).then(function (response) {
                for (var i = 0; i < response.data.length; i++) {
                  if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
                    that.role = response.data[i].type;
                  }
                }
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.data) {
                    that.$vux.alert.show({
                      title: '',
                      content: JSON.parse(error.response.data.error_message).zh_string
                    });
                  }
                }
              });
              console.log(order);

            case 49:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this6, [[19, 31, 35, 43], [36,, 38, 42]]);
    }))();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3597f8d9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addphoto.vue
var addphoto_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("故障详情")]),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"故障类型","type":"text","readonly":""},model:{value:(_vm.order.ftype),callback:function ($$v) {_vm.$set(_vm.order, "ftype", $$v)},expression:"order.ftype"}}),_vm._v(" "),_c('x-textarea',{attrs:{"show-counter":false,"title":"故障描述","type":"text","autosize":"","readonly":""},model:{value:(_vm.order.fdesc),callback:function ($$v) {_vm.$set(_vm.order, "fdesc", $$v)},expression:"order.fdesc"}})],1),_vm._v(" "),_c('p',{staticStyle:{"padding":"10px 15px","color":"gray","font-size":"17px"}},[_vm._v("故障图片")]),_vm._v(" "),_c('div',{staticClass:"upload_warp_img"},[_vm._l((_vm.imgList),function(val,index){return _c('div',{key:index,staticClass:"upload_warp_img_div"},[_c('div',{staticStyle:{"width":"100%"}},[_c('img',{staticClass:"previewer-demo-img",staticStyle:{"width":"100px","height":"75px"},attrs:{"src":val.msrc},on:{"click":function($event){_vm.shows(index)}}})])])}),_vm._v(" "),(_vm.show && _vm.isAssis)?_c('div',{staticClass:"upload_warp"},[_c('div',{staticClass:"upload_warp_left;cursor:pointer;",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.flag&&_vm.upload()}}},[_c('div',{staticClass:"icon-add-50"})])]):_vm._e()],2),_vm._v(" "),(_vm.isAssis)?_c('div',{staticClass:"btnbox"},[_c('div',{staticClass:"btn",on:{"click":_vm.confirm}},[_vm._v("提交")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){_vm.$router.back(-1)}}},[_vm._v("返回")])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.imgList,"options":_vm.options}})],1)],1)}
var addphoto_staticRenderFns = []
var addphoto_esExports = { render: addphoto_render, staticRenderFns: addphoto_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_addphoto = (addphoto_esExports);
// CONCATENATED MODULE: ./src/components/addphoto.vue
function addphoto_injectStyle (ssrContext) {
  __webpack_require__("6oUx")
}
var addphoto_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addphoto___vue_template_functional__ = false
/* styles */
var addphoto___vue_styles__ = addphoto_injectStyle
/* scopeId */
var addphoto___vue_scopeId__ = "data-v-3597f8d9"
/* moduleIdentifier (server only) */
var addphoto___vue_module_identifier__ = null
var addphoto_Component = addphoto_normalizeComponent(
  components_addphoto,
  selectortype_template_index_0_src_components_addphoto,
  addphoto___vue_template_functional__,
  addphoto___vue_styles__,
  addphoto___vue_scopeId__,
  addphoto___vue_module_identifier__
)

/* harmony default export */ var src_components_addphoto = (addphoto_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/binding.vue




/* harmony default export */ var binding = ({
  name: "binding",
  components: {
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      id: "",
      isShow: false
    };
  },

  methods: {
    xgmm: function xgmm() {
      this.$router.push({ name: "xgmm", params: { id: this.id } });
    },
    closeaccount: function closeaccount() {
      var _this = this;
      var unionid = localStorage.getItem('unionid');
      var opid = void 0;
      var obj = {};
      this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.id }).then(function (res) {
        opid = res.data.userid;
        obj = {
          headers: {
            token: res.data.token,
            opid: opid
          }
        };
      });

      this.$vux.confirm.show({
        title: "",
        content: "删除账号后，您的所有信息将被删除，是否确认删除账号？",
        onConfirm: function onConfirm() {
          _this.$http.delete("/api/v1/accounts/" + opid, obj).then(function (response) {
            if (response.status === 204) {
              _this.$vux.alert.show({
                title: "",
                content: "删除成功",
                onHide: function onHide() {
                  location.reload();
                  _this.show ? this.$router.push({ path: '/glzh' }) : this.$router.push({ path: '/login' });
                }
              });
            }
          }).catch(function (error) {
            _this.$vux.alert.show({
              title: "",
              content: "服务器错误，请稍后重试"
            });
            if (JSON.parse(error.response.data.error_message).faultcode == "11011") {
              _this.$vux.alert.show({
                title: "",
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            } else if (error.response) {
              console.log(error.response.data);
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log("Error", error.message);
            }
          });
        }
      });
    },
    unbound: function unbound() {
      var _this2 = this;

      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.id }).then(function (res) {
        var opid = res.data.userid;
        var obj = {
          headers: {
            token: res.data.token,
            opid: opid
          }
        };
        _this2.$http.delete('/api/v1/wechat/' + unionid + '?userid=' + opid, obj).then(function (res) {
          console.log(res);
          _this2.$router.push({ path: '/glzh' });
        });
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === "glzh") {
      next(function (vm) {
        vm.id = vm.$route.params.id;
        ajax["a" /* default */].$http.post('/api/v1/wechat/' + localStorage.getItem('unionid') + '/token', { 'account': vm.id }).then(function (res) {
          var opid = res.data.userid;
          var obj = { headers: { token: res.data.token, opid: opid } };
          ajax["a" /* default */].$http.get('/api/v1/accounts/' + res.data.userid, obj).then(function (res) {
            res.data.forEach(function (item) {
              if (item.type === 'ADMIN' || item.type === 'SRVP') {
                vm.isShow = true;
              }
            });
          });
        });
      });
    } else {
      next();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/binding.vue




/* harmony default export */ var components_binding = ({
  name: "binding",
  components: {
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      id: "",
      isShow: false
    };
  },

  methods: {
    xgmm: function xgmm() {
      this.$router.push({ name: "xgmm", params: { id: this.id } });
    },
    closeaccount: function closeaccount() {
      var _this = this;
      var unionid = localStorage.getItem('unionid');
      var opid = void 0;
      var obj = {};
      this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.id }).then(function (res) {
        opid = res.data.userid;
        obj = {
          headers: {
            token: res.data.token,
            opid: opid
          }
        };
      });

      this.$vux.confirm.show({
        title: "",
        content: "删除账号后，您的所有信息将被删除，是否确认删除账号？",
        onConfirm: function onConfirm() {
          _this.$http.delete("/api/v1/accounts/" + opid, obj).then(function (response) {
            if (response.status === 204) {
              _this.$vux.alert.show({
                title: "",
                content: "删除成功",
                onHide: function onHide() {
                  location.reload();
                  _this.show ? this.$router.push({ path: '/glzh' }) : this.$router.push({ path: '/login' });
                }
              });
            }
          }).catch(function (error) {
            _this.$vux.alert.show({
              title: "",
              content: "服务器错误，请稍后重试"
            });
            if (JSON.parse(error.response.data.error_message).faultcode == "11011") {
              _this.$vux.alert.show({
                title: "",
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            } else if (error.response) {
              console.log(error.response.data);
            } else if (error.request) {
              console.log(error.request);
            } else {
              console.log("Error", error.message);
            }
          });
        }
      });
    },
    unbound: function unbound() {
      var _this2 = this;

      var openid = localStorage.getItem('openid');
      var unionid = localStorage.getItem('unionid');
      this.$http.post('/api/v1/wechat/' + unionid + '/token', { 'account': this.id }).then(function (res) {
        var opid = res.data.userid;
        var obj = {
          headers: {
            token: res.data.token,
            opid: opid
          }
        };
        _this2.$http.delete('/api/v1/wechat/' + unionid + '?userid=' + opid, obj).then(function (res) {
          console.log(res);
          _this2.$router.push({ path: '/glzh' });
        });
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name === "glzh") {
      next(function (vm) {
        vm.id = vm.$route.params.id;
        ajax["a" /* default */].$http.post('/api/v1/wechat/' + localStorage.getItem('unionid') + '/token', { 'account': vm.id }).then(function (res) {
          var opid = res.data.userid;
          var obj = { headers: { token: res.data.token, opid: opid } };
          ajax["a" /* default */].$http.get('/api/v1/accounts/' + res.data.userid, obj).then(function (res) {
            res.data.forEach(function (item) {
              if (item.type === 'ADMIN' || item.type === 'SRVP') {
                vm.isShow = true;
              }
            });
          });
        });
      });
    } else {
      next();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96c19ae8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/binding.vue
var binding_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"font-size":"14px","padding-left":"10px","margin-top":"10px"}},[_vm._v("\n        当前操作账号：\n        "),_c('span',{staticStyle:{"font-size":"0.85em","color":"white","font-weight":"900"}},[_vm._v(_vm._s(_vm.id))])]),_vm._v(" "),_c('x-button',{nativeOn:{"click":function($event){return _vm.xgmm($event)}}},[_vm._v("修改密码")]),_vm._v(" "),_c('x-button',{nativeOn:{"click":function($event){_vm.closeaccount()}}},[_vm._v("删除账号")]),_vm._v(" "),(_vm.isShow)?_c('x-button',{nativeOn:{"click":function($event){_vm.unbound()}}},[_vm._v("取消绑定")]):_vm._e()],1)}
var binding_staticRenderFns = []
var binding_esExports = { render: binding_render, staticRenderFns: binding_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_binding = (binding_esExports);
// CONCATENATED MODULE: ./src/components/binding.vue
var binding_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var binding___vue_template_functional__ = false
/* styles */
var binding___vue_styles__ = null
/* scopeId */
var binding___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var binding___vue_module_identifier__ = null
var binding_Component = binding_normalizeComponent(
  components_binding,
  selectortype_template_index_0_src_components_binding,
  binding___vue_template_functional__,
  binding___vue_styles__,
  binding___vue_scopeId__,
  binding___vue_module_identifier__
)

/* harmony default export */ var src_components_binding = (binding_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Administrator/list.vue




/* harmony default export */ var Administrator_list = ({
  name: "list",
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */]
  },
  data: function data() {
    return {
      role: this.$route.query.role,
      isAdminRepair: false,
      isSrvpRepair: false,
      isLog: true
    };
  },
  created: function created() {
    var _this = this;

    var account = void 0;
    JSON.parse(localStorage.getItem('account')).forEach(function (item) {
      if (item.role === _this.role) {
        account = item.account;
      }
    });
    this.$http.get('/api/v1/wechat/' + localStorage.getItem('unionid')).then(function (res) {
      res.data.forEach(function (item) {
        if (item.role === _this.role) {
          account = item.account;
        }
      });
      _this.$http.post('api/v1/wechat/' + localStorage.getItem('unionid') + '/token', { 'account': account }).then(function (response) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('userid', response.data.userid);
        _this.$http.get('api/v1/accounts/' + response.data.userid, {
          headers: {
            token: response.data.token,
            opid: response.data.userid
          }
        }).then(function (res) {
          res.data.forEach(function (item) {
            if (item.type === 'SRVP') {
              if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1) {
                _this.isSrvpRepair = true;
              }
              _this.isLog = item.supported.indexOf('log') !== -1;
            } else if (item.type === 'ADMIN') {
              if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1 || item.tasks.indexOf('SuperAdmin') !== -1) {
                _this.isAdminRepair = true;
              }
            }
          });
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Administrator/list.vue




/* harmony default export */ var components_Administrator_list = ({
  name: "list",
  components: {
    Cell: vux_src_components_cell,
    Group: group["a" /* default */]
  },
  data: function data() {
    return {
      role: this.$route.query.role,
      isAdminRepair: false,
      isSrvpRepair: false,
      isLog: true
    };
  },
  created: function created() {
    var _this = this;

    var account = void 0;
    JSON.parse(localStorage.getItem('account')).forEach(function (item) {
      if (item.role === _this.role) {
        account = item.account;
      }
    });
    this.$http.get('/api/v1/wechat/' + localStorage.getItem('unionid')).then(function (res) {
      res.data.forEach(function (item) {
        if (item.role === _this.role) {
          account = item.account;
        }
      });
      _this.$http.post('api/v1/wechat/' + localStorage.getItem('unionid') + '/token', { 'account': account }).then(function (response) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('userid', response.data.userid);
        _this.$http.get('api/v1/accounts/' + response.data.userid, {
          headers: {
            token: response.data.token,
            opid: response.data.userid
          }
        }).then(function (res) {
          res.data.forEach(function (item) {
            if (item.type === 'SRVP') {
              if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1) {
                _this.isSrvpRepair = true;
              }
              _this.isLog = item.supported.indexOf('log') !== -1;
            } else if (item.type === 'ADMIN') {
              if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1 || item.tasks.indexOf('SuperAdmin') !== -1) {
                _this.isAdminRepair = true;
              }
            }
          });
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b9cab18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrator/list.vue
var list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[(_vm.isSrvpRepair)?_c('cell',{attrs:{"title":('报修订单'),"is-link":"","link":{ name: 'RepairOrder',params:{isAdmin:false}}}}):_vm._e(),_vm._v(" "),(_vm.isSrvpRepair)?_c('cell',{attrs:{"title":('维修记录'),"is-link":"","link":{ name: 'solution_logs',params:{role:'SRVP'}}}}):_vm._e(),_vm._v(" "),(_vm.isLog)?_c('cell',{attrs:{"title":('日志管理'),"is-link":"","link":{ name: 'saleslog',params:{role:'SRVP'}}}}):_vm._e(),_vm._v(" "),(_vm.isAdminRepair)?_c('cell',{attrs:{"title":('正常报修订单'),"is-link":"","link":{ name: 'RepairOrder',params:{isAdmin:true}}}}):_vm._e()],1)],1)}
var list_staticRenderFns = []
var list_esExports = { render: list_render, staticRenderFns: list_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Administrator_list = (list_esExports);
// CONCATENATED MODULE: ./src/components/Administrator/list.vue
function list_injectStyle (ssrContext) {
  __webpack_require__("HDDp")
}
var list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var list___vue_template_functional__ = false
/* styles */
var list___vue_styles__ = list_injectStyle
/* scopeId */
var list___vue_scopeId__ = "data-v-3b9cab18"
/* moduleIdentifier (server only) */
var list___vue_module_identifier__ = null
var list_Component = list_normalizeComponent(
  components_Administrator_list,
  selectortype_template_index_0_src_components_Administrator_list,
  list___vue_template_functional__,
  list___vue_styles__,
  list___vue_scopeId__,
  list___vue_module_identifier__
)

/* harmony default export */ var src_components_Administrator_list = (list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Administrator/RepairOrder.vue









/* harmony default export */ var RepairOrder = ({
  name: "RepairOrder",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      type: 'accept',
      isAdmin: this.$route.params.isAdmin,
      typeadmin: 'assign'
    };
  },

  methods: {
    goToRepair: function goToRepair(seq) {
      this.$router.push({ name: 'RepairSrvp', query: { seq: seq, type: this.type, role: this.isAdmin ? 'ADMIN' : 'SRVP' } });
    },
    toAccept: function toAccept() {
      var _this = this;

      this.type = 'accept';
      this.dataList = [];
      this.total = 0;
      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=accept&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this.dataList = [].concat(toConsumableArray_default()(_this.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this.init(item);
        });
        _this.total = response.data.total;
      });
    },
    beingProcess: function beingProcess() {
      var _this2 = this;

      this.type = 'process';
      this.dataList = [];
      this.total = 0;
      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=process&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this2.dataList = [].concat(toConsumableArray_default()(_this2.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this2.init(item);
        });
        _this2.total = response.data.total;
      });
    },
    processed: function processed() {
      var _this3 = this;

      this.type = 'done';
      this.dataList = [];
      this.total = 0;
      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=done&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this3.init(item);
        });
        _this3.total = response.data.total;
      });
    },
    confirmed: function confirmed() {
      var _this4 = this;

      this.type = 'closed';
      this.dataList = [];
      this.total = 0;
      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=closed&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this4.dataList = [].concat(toConsumableArray_default()(_this4.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this4.init(item);
        });
        _this4.total = response.data.total;
      });
    },
    more: function more() {
      var _this5 = this;

      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=' + this.dataList.length + '&count=10&stage=' + this.type + '&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this5.dataList = [].concat(toConsumableArray_default()(_this5.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this5.init(item);
        });
        _this5.total = response.data.total;
      });
    },
    assignAdmin: function assignAdmin() {
      var _this6 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'false';
      this.typeadmin = 'assign';
      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=assign&offset=0&count=10', this.header).then(function (response) {
        _this6.dataList = [].concat(toConsumableArray_default()(_this6.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this6.init(item);
        });
        _this6.total = response.data.total;
      });
    },
    acceptAdmin: function acceptAdmin() {
      var _this7 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'false';
      this.typeadmin = 'accept';
      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=accept&offset=0&count=10', this.header).then(function (response) {
        _this7.dataList = [].concat(toConsumableArray_default()(_this7.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this7.init(item);
        });
        _this7.total = response.data.total;
      });
    },
    processAdmin: function processAdmin() {
      var _this8 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'false';
      this.typeadmin = 'process';
      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=process&offset=0&count=10', this.header).then(function (response) {
        _this8.dataList = [].concat(toConsumableArray_default()(_this8.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this8.init(item);
        });
        _this8.total = response.data.total;
      });
    },
    doneAdmin: function doneAdmin() {
      var _this9 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'true';
      this.typeadmin = 'done';
      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=done&offset=0&count=10', this.header).then(function (response) {
        _this9.dataList = [].concat(toConsumableArray_default()(_this9.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this9.init(item);
        });
        _this9.total = response.data.total;
      });
    },
    moreAdmin: function moreAdmin() {
      var _this10 = this;

      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=' + this.typeadmin + '&offset=' + this.dataList.length + '&count=10', this.header).then(function (response) {
        _this10.dataList = [].concat(toConsumableArray_default()(_this10.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this10.init(item);
        });
        _this10.total = response.data.total;
      });
    },
    init: function init(orderDetail) {
      if (this.isAdmin) {
        switch (orderDetail.overall_status) {
          case 'WAITPROCESS_WAITCONFIRM':
            orderDetail.overall_name = '待处理';
            break;
          case 'WAITPROCESS_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '待处理,用户已取消';
            break;
          case 'WAITPROCESS_CONFIRMED':
            orderDetail.overall_name = '待处理,故障已确认';
            break;
          case 'WAITPROCESS_CONFIRMED_CANCEL':
            orderDetail.overall_name = '待处理，故障已确认，用户已取消';
            break;
          case 'PROCESSING_WAITCONFIRM':
            orderDetail.overall_name = '处理中';
            break;
          case 'PROCESSING_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '处理中，用户已取消';
            break;
          case 'PROCESSING_CONFIRMED':
            orderDetail.overall_name = '处理中，故障已确认';
            break;
          case 'PROCESSING_CONFIRMED_CANCEL':
            orderDetail.overall_name = '处理中，故障已确认，用户已取消';
            break;
          case 'PROCESSED_CONFIRMED':
            orderDetail.overall_name = '处理完成，待关闭';
            break;
          case 'ASSIGNED':
            orderDetail.overall_name = '已指派，待接单';
            break;
          case 'ASSIGNED_CANCEL':
            orderDetail.overall_name = '已指派，用户已取消';
            break;
          case 'PROCESSED_WAIT':
            orderDetail.overall_name = '处理完成，等待用户确认';
            break;
          case 'PROCESSED_ARBIT':
            orderDetail.overall_name = '处理完成，等待仲裁';
            break;
          default:
            break;
        }
      } else {
        switch (orderDetail.overall_status) {
          case 'PROCESSING_WAITCONFIRM':
            orderDetail.overall_name = '处理中';
            break;
          case 'PROCESSING_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '处理中，用户已取消';
            break;
          case 'PROCESSING_CONFIRMED':
            orderDetail.overall_name = '处理中，故障已确认';
            break;
          case 'PROCESSING_CONFIRMED_CANCEL':
            orderDetail.overall_name = '处理中，故障已确认，用户已取消';
            break;
          case 'PROCESSED_CONFIRMED':
            orderDetail.overall_name = '处理完成';
            break;
          case 'ASSIGNED':
            orderDetail.overall_name = '待接单';
            break;
          case 'ASSIGNED_CANCEL':
            orderDetail.overall_name = '用户已取消';
            break;
          default:
            break;
        }
      }
      return orderDetail;
    }
  },
  created: function created() {
    var _this11 = this;

    var account = void 0;
    this.$http.get('/api/v1/wechat/' + localStorage.getItem('unionid')).then(function (res) {
      res.data.forEach(function (item) {
        if (item.role === (_this11.isAdmin ? 'ADMIN' : 'SRVP')) {
          account = item.account;
        }
      });
      _this11.$http.post('api/v1/wechat/' + localStorage.getItem('unionid') + '/token', { 'account': account }).then(function (response) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('userid', response.data.userid);
        _this11.header = {
          headers: {
            token: response.data.token,
            opid: response.data.userid
          }
        };
        _this11.$http.get('api/v1/accounts/' + response.data.userid, {
          headers: {
            token: response.data.token,
            opid: response.data.userid
          }
        }).then(function (res) {
          res.data.forEach(function (item) {
            if (item.type === 'SRVP') {
              if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1) {
                _this11.toAccept();
              }
            } else if (item.type === 'ADMIN') {
              if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1 || item.tasks.indexOf('SuperAdmin') !== -1) {
                _this11.assignAdmin();
              }
            }
          });
        });
      });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'list') {
      to.params.role = this.isAdmin ? 'ADMIN' : 'SRVP';
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Administrator/RepairOrder.vue









/* harmony default export */ var Administrator_RepairOrder = ({
  name: "RepairOrder",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      type: 'accept',
      isAdmin: this.$route.params.isAdmin,
      typeadmin: 'assign'
    };
  },

  methods: {
    goToRepair: function goToRepair(seq) {
      this.$router.push({ name: 'RepairSrvp', query: { seq: seq, type: this.type, role: this.isAdmin ? 'ADMIN' : 'SRVP' } });
    },
    toAccept: function toAccept() {
      var _this = this;

      this.type = 'accept';
      this.dataList = [];
      this.total = 0;
      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=accept&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this.dataList = [].concat(toConsumableArray_default()(_this.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this.init(item);
        });
        _this.total = response.data.total;
      });
    },
    beingProcess: function beingProcess() {
      var _this2 = this;

      this.type = 'process';
      this.dataList = [];
      this.total = 0;
      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=process&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this2.dataList = [].concat(toConsumableArray_default()(_this2.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this2.init(item);
        });
        _this2.total = response.data.total;
      });
    },
    processed: function processed() {
      var _this3 = this;

      this.type = 'done';
      this.dataList = [];
      this.total = 0;
      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=done&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this3.init(item);
        });
        _this3.total = response.data.total;
      });
    },
    confirmed: function confirmed() {
      var _this4 = this;

      this.type = 'closed';
      this.dataList = [];
      this.total = 0;
      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=0&count=10&stage=closed&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this4.dataList = [].concat(toConsumableArray_default()(_this4.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this4.init(item);
        });
        _this4.total = response.data.total;
      });
    },
    more: function more() {
      var _this5 = this;

      this.$http.get('api/v1/normalrepairs?account=' + localStorage.getItem('userid') + '&role=SRVP&offset=' + this.dataList.length + '&count=10&stage=' + this.type + '&crit=' + stringify_default()({
        user: '',
        device: '',
        expt: '',
        start: '',
        end: '',
        company: '',
        seq: ''
      }), this.header).then(function (response) {
        _this5.dataList = [].concat(toConsumableArray_default()(_this5.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this5.init(item);
        });
        _this5.total = response.data.total;
      });
    },
    assignAdmin: function assignAdmin() {
      var _this6 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'false';
      this.typeadmin = 'assign';
      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=assign&offset=0&count=10', this.header).then(function (response) {
        _this6.dataList = [].concat(toConsumableArray_default()(_this6.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this6.init(item);
        });
        _this6.total = response.data.total;
      });
    },
    acceptAdmin: function acceptAdmin() {
      var _this7 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'false';
      this.typeadmin = 'accept';
      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=accept&offset=0&count=10', this.header).then(function (response) {
        _this7.dataList = [].concat(toConsumableArray_default()(_this7.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this7.init(item);
        });
        _this7.total = response.data.total;
      });
    },
    processAdmin: function processAdmin() {
      var _this8 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'false';
      this.typeadmin = 'process';
      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=process&offset=0&count=10', this.header).then(function (response) {
        _this8.dataList = [].concat(toConsumableArray_default()(_this8.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this8.init(item);
        });
        _this8.total = response.data.total;
      });
    },
    doneAdmin: function doneAdmin() {
      var _this9 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'true';
      this.typeadmin = 'done';
      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=done&offset=0&count=10', this.header).then(function (response) {
        _this9.dataList = [].concat(toConsumableArray_default()(_this9.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this9.init(item);
        });
        _this9.total = response.data.total;
      });
    },
    moreAdmin: function moreAdmin() {
      var _this10 = this;

      this.$http.get('api/v1/normalrepairs/list_unclosed_repairs?stage=' + this.typeadmin + '&offset=' + this.dataList.length + '&count=10', this.header).then(function (response) {
        _this10.dataList = [].concat(toConsumableArray_default()(_this10.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this10.init(item);
        });
        _this10.total = response.data.total;
      });
    },
    init: function init(orderDetail) {
      if (this.isAdmin) {
        switch (orderDetail.overall_status) {
          case 'WAITPROCESS_WAITCONFIRM':
            orderDetail.overall_name = '待处理';
            break;
          case 'WAITPROCESS_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '待处理,用户已取消';
            break;
          case 'WAITPROCESS_CONFIRMED':
            orderDetail.overall_name = '待处理,故障已确认';
            break;
          case 'WAITPROCESS_CONFIRMED_CANCEL':
            orderDetail.overall_name = '待处理，故障已确认，用户已取消';
            break;
          case 'PROCESSING_WAITCONFIRM':
            orderDetail.overall_name = '处理中';
            break;
          case 'PROCESSING_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '处理中，用户已取消';
            break;
          case 'PROCESSING_CONFIRMED':
            orderDetail.overall_name = '处理中，故障已确认';
            break;
          case 'PROCESSING_CONFIRMED_CANCEL':
            orderDetail.overall_name = '处理中，故障已确认，用户已取消';
            break;
          case 'PROCESSED_CONFIRMED':
            orderDetail.overall_name = '处理完成，待关闭';
            break;
          case 'ASSIGNED':
            orderDetail.overall_name = '已指派，待接单';
            break;
          case 'ASSIGNED_CANCEL':
            orderDetail.overall_name = '已指派，用户已取消';
            break;
          case 'PROCESSED_WAIT':
            orderDetail.overall_name = '处理完成，等待用户确认';
            break;
          case 'PROCESSED_ARBIT':
            orderDetail.overall_name = '处理完成，等待仲裁';
            break;
          default:
            break;
        }
      } else {
        switch (orderDetail.overall_status) {
          case 'PROCESSING_WAITCONFIRM':
            orderDetail.overall_name = '处理中';
            break;
          case 'PROCESSING_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '处理中，用户已取消';
            break;
          case 'PROCESSING_CONFIRMED':
            orderDetail.overall_name = '处理中，故障已确认';
            break;
          case 'PROCESSING_CONFIRMED_CANCEL':
            orderDetail.overall_name = '处理中，故障已确认，用户已取消';
            break;
          case 'PROCESSED_CONFIRMED':
            orderDetail.overall_name = '处理完成';
            break;
          case 'ASSIGNED':
            orderDetail.overall_name = '待接单';
            break;
          case 'ASSIGNED_CANCEL':
            orderDetail.overall_name = '用户已取消';
            break;
          default:
            break;
        }
      }
      return orderDetail;
    }
  },
  created: function created() {
    var _this11 = this;

    var account = void 0;
    this.$http.get('/api/v1/wechat/' + localStorage.getItem('unionid')).then(function (res) {
      res.data.forEach(function (item) {
        if (item.role === (_this11.isAdmin ? 'ADMIN' : 'SRVP')) {
          account = item.account;
        }
      });
      _this11.$http.post('api/v1/wechat/' + localStorage.getItem('unionid') + '/token', { 'account': account }).then(function (response) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('userid', response.data.userid);
        _this11.header = {
          headers: {
            token: response.data.token,
            opid: response.data.userid
          }
        };
        _this11.$http.get('api/v1/accounts/' + response.data.userid, {
          headers: {
            token: response.data.token,
            opid: response.data.userid
          }
        }).then(function (res) {
          res.data.forEach(function (item) {
            if (item.type === 'SRVP') {
              if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1) {
                _this11.toAccept();
              }
            } else if (item.type === 'ADMIN') {
              if (item.tasks.indexOf('RootAdmin') !== -1 || item.tasks.indexOf('RepairAdmin') !== -1 || item.tasks.indexOf('SuperAdmin') !== -1) {
                _this11.assignAdmin();
              }
            }
          });
        });
      });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'list') {
      to.params.role = this.isAdmin ? 'ADMIN' : 'SRVP';
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-697b78ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrator/RepairOrder.vue
var RepairOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isAdmin)?_c('tab',[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.toAccept}},[_vm._v("待接受")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.beingProcess}},[_vm._v("处理中")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.processed}},[_vm._v("已处理")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.confirmed}},[_vm._v("已确认")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('tab',[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.assignAdmin}},[_vm._v("待指派")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.acceptAdmin}},[_vm._v("待接单")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.processAdmin}},[_vm._v("处理中")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.doneAdmin}},[_vm._v("处理完成")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"wrap",on:{"click":function($event){_vm.goToRepair(item.seq)}}},[_c('div',{staticClass:"left_box"},[_c('p',[_vm._v(_vm._s(item.seq))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name)+"-"+_vm._s(item.company))])]),_vm._v(" "),_c('span',{staticClass:"status_span"},[_vm._v(_vm._s(item.overall_name)+"    >")])])}),_vm._v(" "),(_vm.dataList.length !== _vm.total && !_vm.isAdmin)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){_vm.more()}}},[_vm._v("更多\n  ")]):_vm._e(),_vm._v(" "),(_vm.dataList.length !== _vm.total && _vm.isAdmin)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){_vm.moreAdmin()}}},[_vm._v("更多\n  ")]):_vm._e()],2)}
var RepairOrder_staticRenderFns = []
var RepairOrder_esExports = { render: RepairOrder_render, staticRenderFns: RepairOrder_staticRenderFns }
/* harmony default export */ var components_Administrator_RepairOrder = (RepairOrder_esExports);
// CONCATENATED MODULE: ./src/components/Administrator/RepairOrder.vue
function RepairOrder_injectStyle (ssrContext) {
  __webpack_require__("NEF7")
}
var RepairOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RepairOrder___vue_template_functional__ = false
/* styles */
var RepairOrder___vue_styles__ = RepairOrder_injectStyle
/* scopeId */
var RepairOrder___vue_scopeId__ = "data-v-697b78ac"
/* moduleIdentifier (server only) */
var RepairOrder___vue_module_identifier__ = null
var RepairOrder_Component = RepairOrder_normalizeComponent(
  Administrator_RepairOrder,
  components_Administrator_RepairOrder,
  RepairOrder___vue_template_functional__,
  RepairOrder___vue_styles__,
  RepairOrder___vue_scopeId__,
  RepairOrder___vue_module_identifier__
)

/* harmony default export */ var src_components_Administrator_RepairOrder = (RepairOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Administrator/FastRepairOrder.vue








/* harmony default export */ var FastRepairOrder = ({
  name: "FastRepairOrder",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      type: 'false',
      isAdmin: true,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    pendingAdmin: function pendingAdmin() {
      var _this = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'false';
      this.$http.get('api/v1/fastrepairs?offset=0&count=10&closed=false', this.header).then(function (response) {
        _this.dataList = [].concat(toConsumableArray_default()(_this.dataList), toConsumableArray_default()(response.data.content));
        _this.total = response.data.total;
      });
    },
    processedAdmin: function processedAdmin() {
      var _this2 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'true';
      this.$http.get('api/v1/fastrepairs?offset=0&count=10&closed=true', this.header).then(function (response) {
        _this2.dataList = [].concat(toConsumableArray_default()(_this2.dataList), toConsumableArray_default()(response.data.content));
        _this2.total = response.data.total;
      });
    },
    more: function more() {
      var _this3 = this;

      this.$http.get('api/v1/fastrepairs?offset=' + this.dataList.length + '&count=10&closed=' + this.type, this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content));
        _this3.total = response.data.total;
      });
    }
  },
  created: function created() {
    this.pendingAdmin();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Administrator/FastRepairOrder.vue








/* harmony default export */ var Administrator_FastRepairOrder = ({
  name: "FastRepairOrder",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      type: 'false',
      isAdmin: true,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    pendingAdmin: function pendingAdmin() {
      var _this = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'false';
      this.$http.get('api/v1/fastrepairs?offset=0&count=10&closed=false', this.header).then(function (response) {
        _this.dataList = [].concat(toConsumableArray_default()(_this.dataList), toConsumableArray_default()(response.data.content));
        _this.total = response.data.total;
      });
    },
    processedAdmin: function processedAdmin() {
      var _this2 = this;

      this.dataList = [];
      this.total = 0;
      this.type = 'true';
      this.$http.get('api/v1/fastrepairs?offset=0&count=10&closed=true', this.header).then(function (response) {
        _this2.dataList = [].concat(toConsumableArray_default()(_this2.dataList), toConsumableArray_default()(response.data.content));
        _this2.total = response.data.total;
      });
    },
    more: function more() {
      var _this3 = this;

      this.$http.get('api/v1/fastrepairs?offset=' + this.dataList.length + '&count=10&closed=' + this.type, this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content));
        _this3.total = response.data.total;
      });
    }
  },
  created: function created() {
    this.pendingAdmin();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58486418","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administrator/FastRepairOrder.vue
var FastRepairOrder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tab',[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.pendingAdmin}},[_vm._v("待处理")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.processedAdmin}},[_vm._v("已处理")])],1),_vm._v(" "),_c('group',_vm._l((_vm.dataList),function(item,index){return _c('cell',{key:index,attrs:{"is-link":"","title":item.seq,"link":{ name: 'RepairSrvp',query:{seq:item.seq,type:_vm.type === 'true'?'fast-true':'fast-false',role:_vm.isAdmin?'ADMIN':'SRVP'}}}})})),_vm._v(" "),(_vm.dataList.length !== _vm.total)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){_vm.more()}}},[_vm._v("更多\n    ")]):_vm._e()],1)}
var FastRepairOrder_staticRenderFns = []
var FastRepairOrder_esExports = { render: FastRepairOrder_render, staticRenderFns: FastRepairOrder_staticRenderFns }
/* harmony default export */ var components_Administrator_FastRepairOrder = (FastRepairOrder_esExports);
// CONCATENATED MODULE: ./src/components/Administrator/FastRepairOrder.vue
function FastRepairOrder_injectStyle (ssrContext) {
  __webpack_require__("YdJi")
}
var FastRepairOrder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FastRepairOrder___vue_template_functional__ = false
/* styles */
var FastRepairOrder___vue_styles__ = FastRepairOrder_injectStyle
/* scopeId */
var FastRepairOrder___vue_scopeId__ = "data-v-58486418"
/* moduleIdentifier (server only) */
var FastRepairOrder___vue_module_identifier__ = null
var FastRepairOrder_Component = FastRepairOrder_normalizeComponent(
  Administrator_FastRepairOrder,
  components_Administrator_FastRepairOrder,
  FastRepairOrder___vue_template_functional__,
  FastRepairOrder___vue_styles__,
  FastRepairOrder___vue_scopeId__,
  FastRepairOrder___vue_module_identifier__
)

/* harmony default export */ var src_components_Administrator_FastRepairOrder = (FastRepairOrder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairs/RepairSrvp.vue













/* harmony default export */ var RepairSrvp = ({
  name: "RepairSrvp",
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Confirm: components_confirm["a" /* default */],
    Selector: vux_src_components_selector,
    XTextarea: vux_src_components_x_textarea,
    Cell: vux_src_components_cell,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      clearotherdesignateshow: false,
      rejectshow: false,
      orderDetail: {},
      info: [],
      list: [],
      faststatusList: [{ key: 'YES', value: '是' }, { key: 'NO', value: '否' }, { key: 'INVALID', value: '无效的申请' }],
      faststatus: '',
      fastplan: '',
      roles: [{ key: 'EXPT', value: '专家' }, { key: 'SRVP', value: '服务商' }],
      reason: [{ key: 'REJECT', value: '拒绝' }, { key: 'REGRET', value: '反悔' }, {
        key: 'UNQUAL',
        value: '不合格'
      }, { key: 'TIMEOUT', value: '超时' }, { key: 'UCANCLR', value: '用户取消' }],
      pay: [{ key: 1, value: '是' }, { key: 0, value: '否' }],
      closeList: [{ key: '软件问题', value: '软件问题' }, { key: '网络问题', value: '网络问题' }, { key: '非正常使用导致的硬件损坏', value: '非正常使用导致的硬件损坏' }, { key: '正常使用时的硬件损坏', value: '正常使用时的硬件损坏' }, { key: '软硬件故障均有', value: '软硬件故障均有' }, { key: '技术咨询（如用户操作指导等）', value: '技术咨询（如用户操作指导等）' }, { key: '设备运输问题', value: '设备运输问题' }, { key: '外设、周边、附件问题', value: '外设、周边、附件问题' }, { key: '其他问题', value: '其他问题' }],
      needpay: 0,
      payment: '',
      payprice: 0,
      clean_reason: '',
      clean_detail: '',
      roleAccount: [],
      expert: '',
      confirminfo: '',
      imgList: [],
      filename: '',
      filepath: '',
      updateinfo: '',
      address: '',
      confirmshow: false,
      againdesignateshow: false,
      acceptshow: false,
      assignshow: false,
      updateshow: false,
      closeshow: false,
      close_advice: '',
      close_fconfirm: '',
      designateshow: false,
      cleardesignateshow: false,
      fastshow: false,
      seq: this.$route.query.seq,
      type: this.$route.query.type,
      role: this.$route.query.role,
      roleType: '',
      roleid: '',
      state: '',
      fdetailList: [],
      marketshow: false,
      marketlist: [],
      market: ''
    };
  },

  methods: {
    addMarket: function addMarket() {
      var _this = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/set_repair_visible_to', {
        role: 'ADMIN',
        userid: this.market.toString(),
        user_type: 'EXPT',
        visible: true
      }, this.header).then(function () {
        _this.marketshow = false;
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    downloadFile: function downloadFile() {
      this.$router.push({
        name: "Download",
        query: { path: this.filepath, suffix: this.filename }
      });
    },
    designateRouter: function designateRouter() {
      var bol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (bol) {
        this.$router.push({
          name: 'Desiginate',
          query: { seq: this.seq, role: this.role, type: this.type, roleType: 'false' }
        });
      } else {
        this.$router.push({
          name: 'Desiginate',
          query: { seq: this.seq, role: this.role, type: this.type, roleType: 'true' }
        });
      }
    },
    designateAgainRouter: function designateAgainRouter() {
      this.$router.push({ name: 'Desiginate', query: { seq: this.seq, role: this.role, type: this.type, again: true } });
    },
    format: function format(num) {
      return num.toLocaleString('zh', { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false });
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    callPhone: function callPhone(phoneNumber) {
      window.location.href = 'tel://' + phoneNumber;
    },
    priceChange: function priceChange() {
      try {
        this.payprice = parseFloat(this.payment).toFixed(2);
        this.payment = this.format(parseFloat(this.payment));
        if (isNaN(this.payment)) {
          alert('请输入正确价格');
          this.payment = '0.00';
          this.payprice = 0;
        }
        if (this.payprice === '0.00') {
          if (!confirm('确认该订单服务费用0元')) {
            this.payment = '';
            this.payprice = 0;
          }
        }
      } catch (e) {
        alert('请输入正确价格');
        this.payment = '0.00';
        this.payprice = 0;
      }
    },
    initView: function initView(orderDetail) {
      var _this2 = this;

      this.address = orderDetail.province + ' ' + orderDetail.city + ' ' + orderDetail.district;
      orderDetail.isviwo = orderDetail.isviwo ? '是' : '否';
      orderDetail.sevenday = orderDetail.sevenday ? '是' : '否';
      if (this.role === 'ADMIN') {
        switch (orderDetail.overall_status) {
          case 'WAITPROCESS_WAITCONFIRM':
            orderDetail.overall_name = '待处理';
            break;
          case 'WAITPROCESS_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '待处理,用户已取消';
            break;
          case 'WAITPROCESS_CONFIRMED':
            orderDetail.overall_name = '待处理,故障已确认';
            break;
          case 'WAITPROCESS_CONFIRMED_CANCEL':
            orderDetail.overall_name = '待处理，故障已确认，用户已取消';
            break;
          case 'PROCESSING_WAITCONFIRM':
            orderDetail.overall_name = '处理中';
            break;
          case 'PROCESSING_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '处理中，用户已取消';
            break;
          case 'PROCESSING_CONFIRMED':
            orderDetail.overall_name = '处理中，故障已确认';
            break;
          case 'PROCESSING_CONFIRMED_CANCEL':
            orderDetail.overall_name = '处理中，故障已确认，用户已取消';
            break;
          case 'PROCESSED_CONFIRMED':
            orderDetail.overall_name = '处理完成，待关闭';
            break;
          case 'ASSIGNED':
            orderDetail.overall_name = '已指派，待接单';
            break;
          case 'ASSIGNED_CANCEL':
            orderDetail.overall_name = '已指派，用户已取消';
            break;
          case 'PROCESSED_WAIT':
            orderDetail.overall_name = '处理完成，等待用户确认';
            break;
          case 'PROCESSED_ARBIT':
            orderDetail.overall_name = '处理完成，等待仲裁';
            break;
          default:
            break;
        }
      } else {
        switch (orderDetail.overall_status) {
          case 'PROCESSING_WAITCONFIRM':
            orderDetail.overall_name = '处理中';
            break;
          case 'PROCESSING_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '处理中，用户已取消';
            break;
          case 'PROCESSING_CONFIRMED':
            orderDetail.overall_name = '处理中，故障已确认';
            break;
          case 'PROCESSING_CONFIRMED_CANCEL':
            orderDetail.overall_name = '处理中，故障已确认，用户已取消';
            break;
          case 'PROCESSED_CONFIRMED':
            orderDetail.overall_name = '处理完成';
            break;
          case 'ASSIGNED':
            orderDetail.overall_name = '待接单';
            break;
          case 'ASSIGNED_CANCEL':
            orderDetail.overall_name = '用户已取消';
            break;
          default:
            break;
        }
      }
      switch (orderDetail.userconfirm) {
        case 'ACCEPT':
          orderDetail.userconfirm = '接受';
          break;
        case 'WAIT1':
          orderDetail.userconfirm = '等待确认';
          break;
        case 'WAIT2':
          orderDetail.userconfirm = '等待确认';
          break;
        case 'REJECT':
          orderDetail.userconfirm = '拒绝';
          break;
        case 'ARBIT':
          orderDetail.userconfirm = '提交仲裁';
          break;
        case 'A_ACCEPT':
          orderDetail.userconfirm = '后台自动确认';
          break;
      }
      switch (orderDetail.state) {
        case 'WAIT':
          this.state = '待处理';
          break;
        case 'PROCESS':
          this.state = '处理中';
          break;
        case 'FAIL':
          this.state = '失败';
          break;
        case 'SUCCESS':
          this.state = '成功';
          break;
      }
      if (!this.type) {
        if (this.role === 'ADMIN') {
          this.type = 'false';
        } else {
          switch (orderDetail.state) {
            case 'WAIT':
              this.type = 'accept';
              break;
            case 'PROCESS':
              this.type = 'process';
              break;
            case 'FAIL':
              this.type = 'done';
              break;
            case 'SUCCESS':
              this.type = 'done';
              break;
          }
        }
      }
      switch (orderDetail.needpay) {
        case 'WAIT':
          orderDetail.needpay = '待支付';
          break;
        case 'NO':
          orderDetail.needpay = '不需要支付';
          break;
        case 'PAYED':
          orderDetail.needpay = '已支付';
          break;
      }
      if (orderDetail.needpay) {
        orderDetail.initpay = this.format(orderDetail.initpay);
      }
      this.imgList = [];
      if (orderDetail.signature && orderDetail.signature.content.length !== 0) {
        if (orderDetail.signature.content[0].describe == "") {
          orderDetail.signature.content[0].path.forEach(function (item) {
            _this2.$http.get('/api/photos?path=' + item.thumb, _this2.header).then(function (paths) {
              _this2.imgList.push({ src: paths.data['value'] });
            });
          });
        } else {
          this.filename = orderDetail.signature.content[0].describe;
          this.filepath = orderDetail.signature.content[0].path[0].origin;
        }
      }
      this.fdetailList = [];
      if (orderDetail.fdetail && orderDetail.fdetail.content.length !== 0) {
        if (orderDetail.fdetail.version === '1.1') {
          orderDetail.fdetail.content[0].path.forEach(function (item) {
            _this2.$http.get('/api/photos?path=' + item['origin'], _this2.header).then(function (paths) {
              _this2.fdetailList.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
            });
          });
        } else {
          orderDetail.fdetail.content[0].path.forEach(function (item) {
            _this2.$http.get('/api/photos?path=' + item, _this2.header).then(function (paths) {
              _this2.fdetailList.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
            });
          });
        }
      }
      return orderDetail;
    },
    accpet: function accpet() {
      var _this3 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/order', {
        role: 'SRVP',
        op: 'ACCEPT',
        comment: this.comment
      }, this.header).then(function () {
        alert('已接受该订单');
        _this3.$router.push({ name: 'RepairOrder', params: { isAdmin: _this3.role === 'ADMIN' } });
      }).catch(function (error) {
        _this3.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    confirmRejct: function confirmRejct() {
      var _this4 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/reject_repair_result', { reason: this.$refs.rejectorder.msg }, this.header).then(function () {
        alert('已驳回该订单');
        _this4.$router.push({ name: 'RepairOrder', params: { isAdmin: _this4.role === 'ADMIN' } });
      }).catch(function (error) {
        _this4.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    reject: function reject() {
      var _this5 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/order', {
        role: 'SRVP',
        op: 'REJECT',
        comment: this.comment
      }, this.header).then(function () {
        alert('已拒绝该订单');
        _this5.$router.push({ name: 'RepairOrder', params: { isAdmin: _this5.role === 'ADMIN' } });
      }).catch(function (error) {
        _this5.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    assign: function assign() {
      var _this6 = this;

      var userid = void 0;
      this.info.forEach(function (item) {
        if (_this6.expert === item.name) {
          userid = item.userid;
        }
      });
      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/transfer', {
        role: 'SRVP',
        account: userid.toString()
      }, this.header).then(function () {
        alert('指派成功');
        _this6.$router.push({ name: 'RepairOrder', params: { isAdmin: _this6.role === 'ADMIN' } });
      }).catch(function (error) {
        _this6.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    confrm: function confrm() {
      var _this7 = this;

      var result = void 0;
      switch (this.confirminfo) {
        case '是':
          result = 'YES';
          break;
        case '否':
          result = 'NO';
          break;
        case '无效':
          result = 'INVALID';
          break;
        case '等待':
          result = 'WAIT';
          break;
      }
      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/confirm', { role: this.role, result: result }, this.header).then(function () {
        alert('确认故障成功');
        _this7.$router.push({ name: 'RepairOrder', params: { isAdmin: _this7.role === 'ADMIN' } });
      }).catch(function (error) {
        _this7.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    update: function update() {
      var _this8 = this;

      var result = this.updateinfo === '成功' ? 'SUCCESS' : 'FAIL';
      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/result', { role: this.role, result: result }, this.header).then(function () {
        alert('更新成功');
        _this8.$router.push({ name: 'RepairOrder', params: { isAdmin: _this8.role === 'ADMIN' } });
      }).catch(function (error) {
        _this8.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    searchType: function searchType(num) {
      if (this.type === 'accept') {
        this.acceptshow = true;
      } else if (this.type === 'process' || this.type === 'false') {
        switch (num) {
          case 1:
            this.list = [];
            this.designateRouter();
            break;
          case 2:
            this.confirmshow = true;
            break;
          case 3:
            this.$router.push({ name: 'finish', params: { obj: this.orderDetail, type: this.role } });
            /*this.updateshow = true;*/
            break;
          case 4:
            this.$router.push({ name: 'Askpay', params: { seq: this.seq, role: this.role, type: this.type } });
            break;
        }
      }
    },
    close: function close() {
      var _this9 = this;

      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/close?advice=' + this.close_advice + '&fconfirm=' + this.close_fconfirm, this.header).then(function () {
        alert("已关闭");
        _this9.$router.push({ name: 'RepairOrder', params: { isAdmin: _this9.role === 'ADMIN' } });
      }).catch(function (error) {
        _this9.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    designateChange: function designateChange() {
      var _this10 = this;

      this.roleAccount = [];
      if (this.roleType === 'EXPT') {
        this.$http.get('/api/v1/experts?offset=0&count=999&type=audit', this.header).then(function (response) {
          response.data['list'].forEach(function (item) {
            _this10.roleAccount.push({ value: item.detail.name, key: item.userid });
          });
        }).catch(function (error) {
          _this10.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      } else {
        this.$http.get('/api/v1/agencies?offset=0&count=999&type=audit', this.header).then(function (response) {
          response.data['list'].forEach(function (item) {
            _this10.roleAccount.push({ value: item.detail.company, key: item.userid });
          });
        }).catch(function (error) {
          _this10.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      }
    },
    designate: function designate() {
      var _this11 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq, {
        "account": this.roleid.toString(),
        "role": this.roleType,
        "needpay": this.needpay,
        "payment": this.payprice
      }, this.header).then(function () {
        alert("指派成功");
        _this11.$router.push({ name: 'RepairOrder', params: { isAdmin: _this11.role === 'ADMIN' } });
      }).catch(function (error) {
        _this11.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    cleardesignate: function cleardesignate() {
      var _this12 = this;

      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/clear', {
        "reason": this.clean_reason,
        "detail": this.clean_detail
      }, this.header).then(function () {
        alert('清除成功');
        _this12.$router.push({ name: 'RepairOrder', params: { isAdmin: _this12.role === 'ADMIN' } });
      }).catch(function (error) {
        _this12.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    clearotherdesignate: function clearotherdesignate() {
      var _this13 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/clear_assign_to_assist', {
        "reason": this.clean_reason,
        "detail": this.clean_detail,
        role: 'SRVP'
      }, this.header).then(function (response) {
        alert('清除成功');
        _this13.$router.push({ name: 'RepairOrder', params: { isAdmin: _this13.role === 'ADMIN' } });
      });
    },
    againdesignate: function againdesignate() {
      var _this14 = this;

      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/reassign', {
        'account': this.roleid.toString(),
        'role': this.roleType,
        needpay: this.needpay,
        payment: this.payprice,
        reason: this.clean_reason,
        detail: this.clean_detail
      }, this.header).then(function () {
        alert('改派成功');
        _this14.$router.push({ name: 'RepairOrder', params: { isAdmin: _this14.role === 'ADMIN' } });
      });
    },
    fast: function fast() {
      var _this15 = this;

      this.$http.put('/api/v1/fastrepairs/' + this.seq, {
        'confirm': this.faststatus,
        'solution': this.fastplan
      }, this.header).then(function () {
        alert('确认订单成功');
        _this15.$router.push({ name: 'FastRepairOrder' });
      }).catch(function (error) {
        _this15.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var unionid = localStorage.getItem('unionid');
      var account = void 0;
      ajax["a" /* default */].$http.get('api/v1/wechat/' + unionid).then(function (res) {
        res.data.forEach(function (item) {
          if (item.role === to.query.role) {
            account = item.account;
          }
        });
        ajax["a" /* default */].$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (response) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userid', response.data.userid);
          vm.header = {
            headers: {
              token: response.data.token,
              opid: response.data.userid
            }
          };
          if (to.query.type && (to.query.type === 'fast-false' || to.query.type === 'fast-true')) {
            ajax["a" /* default */].$http.get('api/v1/fastrepairs/' + to.query.seq, vm.header).then(function (response) {
              localStorage.setItem('order', stringify_default()(response.data.detail));
              vm.orderDetail = vm.initView(response.data.detail);
            }).catch(function (error) {
              console.log(error);
              vm.$vux.toast.show({
                text: JSON.parse(error.response.data.error_message).zh_string,
                type: 'cancel',
                time: '1000'
              });
            });
          } else {
            ajax["a" /* default */].$http.get('api/v1/normalrepairs/' + to.query.seq + '?role=' + to.query.role + '&type=detail', vm.header).then(function (response) {
              localStorage.setItem('order', stringify_default()(response.data.detail));
              vm.orderDetail = vm.initView(response.data.detail);
            }).catch(function (error) {
              console.log(error);
              vm.$vux.toast.show({
                text: JSON.parse(error.response.data.error_message).zh_string,
                type: 'cancel',
                time: '1000'
              });
            });
          }
        });
      });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'RepairOrder') {
      to.params.isAdmin = this.role === 'ADMIN';
    } else if (to.name === 'list') {
      to.params.role = this.isAdmin ? 'ADMIN' : 'SRVP';
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairs/RepairSrvp.vue













/* harmony default export */ var repairs_RepairSrvp = ({
  name: "RepairSrvp",
  components: {
    Group: group["a" /* default */],
    XInput: vux_src_components_x_input,
    XButton: vux_src_components_x_button,
    Confirm: components_confirm["a" /* default */],
    Selector: vux_src_components_selector,
    XTextarea: vux_src_components_x_textarea,
    Cell: vux_src_components_cell,
    Previewer: vux_src_components_previewer
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      clearotherdesignateshow: false,
      rejectshow: false,
      orderDetail: {},
      info: [],
      list: [],
      faststatusList: [{ key: 'YES', value: '是' }, { key: 'NO', value: '否' }, { key: 'INVALID', value: '无效的申请' }],
      faststatus: '',
      fastplan: '',
      roles: [{ key: 'EXPT', value: '专家' }, { key: 'SRVP', value: '服务商' }],
      reason: [{ key: 'REJECT', value: '拒绝' }, { key: 'REGRET', value: '反悔' }, {
        key: 'UNQUAL',
        value: '不合格'
      }, { key: 'TIMEOUT', value: '超时' }, { key: 'UCANCLR', value: '用户取消' }],
      pay: [{ key: 1, value: '是' }, { key: 0, value: '否' }],
      closeList: [{ key: '软件问题', value: '软件问题' }, { key: '网络问题', value: '网络问题' }, { key: '非正常使用导致的硬件损坏', value: '非正常使用导致的硬件损坏' }, { key: '正常使用时的硬件损坏', value: '正常使用时的硬件损坏' }, { key: '软硬件故障均有', value: '软硬件故障均有' }, { key: '技术咨询（如用户操作指导等）', value: '技术咨询（如用户操作指导等）' }, { key: '设备运输问题', value: '设备运输问题' }, { key: '外设、周边、附件问题', value: '外设、周边、附件问题' }, { key: '其他问题', value: '其他问题' }],
      needpay: 0,
      payment: '',
      payprice: 0,
      clean_reason: '',
      clean_detail: '',
      roleAccount: [],
      expert: '',
      confirminfo: '',
      imgList: [],
      filename: '',
      filepath: '',
      updateinfo: '',
      address: '',
      confirmshow: false,
      againdesignateshow: false,
      acceptshow: false,
      assignshow: false,
      updateshow: false,
      closeshow: false,
      close_advice: '',
      close_fconfirm: '',
      designateshow: false,
      cleardesignateshow: false,
      fastshow: false,
      seq: this.$route.query.seq,
      type: this.$route.query.type,
      role: this.$route.query.role,
      roleType: '',
      roleid: '',
      state: '',
      fdetailList: [],
      marketshow: false,
      marketlist: [],
      market: ''
    };
  },

  methods: {
    addMarket: function addMarket() {
      var _this = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/set_repair_visible_to', {
        role: 'ADMIN',
        userid: this.market.toString(),
        user_type: 'EXPT',
        visible: true
      }, this.header).then(function () {
        _this.marketshow = false;
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    downloadFile: function downloadFile() {
      this.$router.push({
        name: "Download",
        query: { path: this.filepath, suffix: this.filename }
      });
    },
    designateRouter: function designateRouter() {
      var bol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (bol) {
        this.$router.push({
          name: 'Desiginate',
          query: { seq: this.seq, role: this.role, type: this.type, roleType: 'false' }
        });
      } else {
        this.$router.push({
          name: 'Desiginate',
          query: { seq: this.seq, role: this.role, type: this.type, roleType: 'true' }
        });
      }
    },
    designateAgainRouter: function designateAgainRouter() {
      this.$router.push({ name: 'Desiginate', query: { seq: this.seq, role: this.role, type: this.type, again: true } });
    },
    format: function format(num) {
      return num.toLocaleString('zh', { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false });
    },
    show: function show(index) {
      this.$refs.previewer.show(index);
    },
    callPhone: function callPhone(phoneNumber) {
      window.location.href = 'tel://' + phoneNumber;
    },
    priceChange: function priceChange() {
      try {
        this.payprice = parseFloat(this.payment).toFixed(2);
        this.payment = this.format(parseFloat(this.payment));
        if (isNaN(this.payment)) {
          alert('请输入正确价格');
          this.payment = '0.00';
          this.payprice = 0;
        }
        if (this.payprice === '0.00') {
          if (!confirm('确认该订单服务费用0元')) {
            this.payment = '';
            this.payprice = 0;
          }
        }
      } catch (e) {
        alert('请输入正确价格');
        this.payment = '0.00';
        this.payprice = 0;
      }
    },
    initView: function initView(orderDetail) {
      var _this2 = this;

      this.address = orderDetail.province + ' ' + orderDetail.city + ' ' + orderDetail.district;
      orderDetail.isviwo = orderDetail.isviwo ? '是' : '否';
      orderDetail.sevenday = orderDetail.sevenday ? '是' : '否';
      if (this.role === 'ADMIN') {
        switch (orderDetail.overall_status) {
          case 'WAITPROCESS_WAITCONFIRM':
            orderDetail.overall_name = '待处理';
            break;
          case 'WAITPROCESS_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '待处理,用户已取消';
            break;
          case 'WAITPROCESS_CONFIRMED':
            orderDetail.overall_name = '待处理,故障已确认';
            break;
          case 'WAITPROCESS_CONFIRMED_CANCEL':
            orderDetail.overall_name = '待处理，故障已确认，用户已取消';
            break;
          case 'PROCESSING_WAITCONFIRM':
            orderDetail.overall_name = '处理中';
            break;
          case 'PROCESSING_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '处理中，用户已取消';
            break;
          case 'PROCESSING_CONFIRMED':
            orderDetail.overall_name = '处理中，故障已确认';
            break;
          case 'PROCESSING_CONFIRMED_CANCEL':
            orderDetail.overall_name = '处理中，故障已确认，用户已取消';
            break;
          case 'PROCESSED_CONFIRMED':
            orderDetail.overall_name = '处理完成，待关闭';
            break;
          case 'ASSIGNED':
            orderDetail.overall_name = '已指派，待接单';
            break;
          case 'ASSIGNED_CANCEL':
            orderDetail.overall_name = '已指派，用户已取消';
            break;
          case 'PROCESSED_WAIT':
            orderDetail.overall_name = '处理完成，等待用户确认';
            break;
          case 'PROCESSED_ARBIT':
            orderDetail.overall_name = '处理完成，等待仲裁';
            break;
          default:
            break;
        }
      } else {
        switch (orderDetail.overall_status) {
          case 'PROCESSING_WAITCONFIRM':
            orderDetail.overall_name = '处理中';
            break;
          case 'PROCESSING_WAITCONFIRM_CANCEL':
            orderDetail.overall_name = '处理中，用户已取消';
            break;
          case 'PROCESSING_CONFIRMED':
            orderDetail.overall_name = '处理中，故障已确认';
            break;
          case 'PROCESSING_CONFIRMED_CANCEL':
            orderDetail.overall_name = '处理中，故障已确认，用户已取消';
            break;
          case 'PROCESSED_CONFIRMED':
            orderDetail.overall_name = '处理完成';
            break;
          case 'ASSIGNED':
            orderDetail.overall_name = '待接单';
            break;
          case 'ASSIGNED_CANCEL':
            orderDetail.overall_name = '用户已取消';
            break;
          default:
            break;
        }
      }
      switch (orderDetail.userconfirm) {
        case 'ACCEPT':
          orderDetail.userconfirm = '接受';
          break;
        case 'WAIT1':
          orderDetail.userconfirm = '等待确认';
          break;
        case 'WAIT2':
          orderDetail.userconfirm = '等待确认';
          break;
        case 'REJECT':
          orderDetail.userconfirm = '拒绝';
          break;
        case 'ARBIT':
          orderDetail.userconfirm = '提交仲裁';
          break;
        case 'A_ACCEPT':
          orderDetail.userconfirm = '后台自动确认';
          break;
      }
      switch (orderDetail.state) {
        case 'WAIT':
          this.state = '待处理';
          break;
        case 'PROCESS':
          this.state = '处理中';
          break;
        case 'FAIL':
          this.state = '失败';
          break;
        case 'SUCCESS':
          this.state = '成功';
          break;
      }
      if (!this.type) {
        if (this.role === 'ADMIN') {
          this.type = 'false';
        } else {
          switch (orderDetail.state) {
            case 'WAIT':
              this.type = 'accept';
              break;
            case 'PROCESS':
              this.type = 'process';
              break;
            case 'FAIL':
              this.type = 'done';
              break;
            case 'SUCCESS':
              this.type = 'done';
              break;
          }
        }
      }
      switch (orderDetail.needpay) {
        case 'WAIT':
          orderDetail.needpay = '待支付';
          break;
        case 'NO':
          orderDetail.needpay = '不需要支付';
          break;
        case 'PAYED':
          orderDetail.needpay = '已支付';
          break;
      }
      if (orderDetail.needpay) {
        orderDetail.initpay = this.format(orderDetail.initpay);
      }
      this.imgList = [];
      if (orderDetail.signature && orderDetail.signature.content.length !== 0) {
        if (orderDetail.signature.content[0].describe == "") {
          orderDetail.signature.content[0].path.forEach(function (item) {
            _this2.$http.get('/api/photos?path=' + item.thumb, _this2.header).then(function (paths) {
              _this2.imgList.push({ src: paths.data['value'] });
            });
          });
        } else {
          this.filename = orderDetail.signature.content[0].describe;
          this.filepath = orderDetail.signature.content[0].path[0].origin;
        }
      }
      this.fdetailList = [];
      if (orderDetail.fdetail && orderDetail.fdetail.content.length !== 0) {
        if (orderDetail.fdetail.version === '1.1') {
          orderDetail.fdetail.content[0].path.forEach(function (item) {
            _this2.$http.get('/api/photos?path=' + item['origin'], _this2.header).then(function (paths) {
              _this2.fdetailList.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
            });
          });
        } else {
          orderDetail.fdetail.content[0].path.forEach(function (item) {
            _this2.$http.get('/api/photos?path=' + item, _this2.header).then(function (paths) {
              _this2.fdetailList.push({ src: 'data:image/jpeg;base64,' + paths.data['value'] });
            });
          });
        }
      }
      return orderDetail;
    },
    accpet: function accpet() {
      var _this3 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/order', {
        role: 'SRVP',
        op: 'ACCEPT',
        comment: this.comment
      }, this.header).then(function () {
        alert('已接受该订单');
        _this3.$router.push({ name: 'RepairOrder', params: { isAdmin: _this3.role === 'ADMIN' } });
      }).catch(function (error) {
        _this3.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    confirmRejct: function confirmRejct() {
      var _this4 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/reject_repair_result', { reason: this.$refs.rejectorder.msg }, this.header).then(function () {
        alert('已驳回该订单');
        _this4.$router.push({ name: 'RepairOrder', params: { isAdmin: _this4.role === 'ADMIN' } });
      }).catch(function (error) {
        _this4.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    reject: function reject() {
      var _this5 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/order', {
        role: 'SRVP',
        op: 'REJECT',
        comment: this.comment
      }, this.header).then(function () {
        alert('已拒绝该订单');
        _this5.$router.push({ name: 'RepairOrder', params: { isAdmin: _this5.role === 'ADMIN' } });
      }).catch(function (error) {
        _this5.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    assign: function assign() {
      var _this6 = this;

      var userid = void 0;
      this.info.forEach(function (item) {
        if (_this6.expert === item.name) {
          userid = item.userid;
        }
      });
      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/transfer', {
        role: 'SRVP',
        account: userid.toString()
      }, this.header).then(function () {
        alert('指派成功');
        _this6.$router.push({ name: 'RepairOrder', params: { isAdmin: _this6.role === 'ADMIN' } });
      }).catch(function (error) {
        _this6.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    confrm: function confrm() {
      var _this7 = this;

      var result = void 0;
      switch (this.confirminfo) {
        case '是':
          result = 'YES';
          break;
        case '否':
          result = 'NO';
          break;
        case '无效':
          result = 'INVALID';
          break;
        case '等待':
          result = 'WAIT';
          break;
      }
      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/confirm', { role: this.role, result: result }, this.header).then(function () {
        alert('确认故障成功');
        _this7.$router.push({ name: 'RepairOrder', params: { isAdmin: _this7.role === 'ADMIN' } });
      }).catch(function (error) {
        _this7.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    update: function update() {
      var _this8 = this;

      var result = this.updateinfo === '成功' ? 'SUCCESS' : 'FAIL';
      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/result', { role: this.role, result: result }, this.header).then(function () {
        alert('更新成功');
        _this8.$router.push({ name: 'RepairOrder', params: { isAdmin: _this8.role === 'ADMIN' } });
      }).catch(function (error) {
        _this8.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    searchType: function searchType(num) {
      if (this.type === 'accept') {
        this.acceptshow = true;
      } else if (this.type === 'process' || this.type === 'false') {
        switch (num) {
          case 1:
            this.list = [];
            this.designateRouter();
            break;
          case 2:
            this.confirmshow = true;
            break;
          case 3:
            this.$router.push({ name: 'finish', params: { obj: this.orderDetail, type: this.role } });
            /*this.updateshow = true;*/
            break;
          case 4:
            this.$router.push({ name: 'Askpay', params: { seq: this.seq, role: this.role, type: this.type } });
            break;
        }
      }
    },
    close: function close() {
      var _this9 = this;

      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/close?advice=' + this.close_advice + '&fconfirm=' + this.close_fconfirm, this.header).then(function () {
        alert("已关闭");
        _this9.$router.push({ name: 'RepairOrder', params: { isAdmin: _this9.role === 'ADMIN' } });
      }).catch(function (error) {
        _this9.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    designateChange: function designateChange() {
      var _this10 = this;

      this.roleAccount = [];
      if (this.roleType === 'EXPT') {
        this.$http.get('/api/v1/experts?offset=0&count=999&type=audit', this.header).then(function (response) {
          response.data['list'].forEach(function (item) {
            _this10.roleAccount.push({ value: item.detail.name, key: item.userid });
          });
        }).catch(function (error) {
          _this10.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      } else {
        this.$http.get('/api/v1/agencies?offset=0&count=999&type=audit', this.header).then(function (response) {
          response.data['list'].forEach(function (item) {
            _this10.roleAccount.push({ value: item.detail.company, key: item.userid });
          });
        }).catch(function (error) {
          _this10.$vux.toast.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      }
    },
    designate: function designate() {
      var _this11 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq, {
        "account": this.roleid.toString(),
        "role": this.roleType,
        "needpay": this.needpay,
        "payment": this.payprice
      }, this.header).then(function () {
        alert("指派成功");
        _this11.$router.push({ name: 'RepairOrder', params: { isAdmin: _this11.role === 'ADMIN' } });
      }).catch(function (error) {
        _this11.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    cleardesignate: function cleardesignate() {
      var _this12 = this;

      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/clear', {
        "reason": this.clean_reason,
        "detail": this.clean_detail
      }, this.header).then(function () {
        alert('清除成功');
        _this12.$router.push({ name: 'RepairOrder', params: { isAdmin: _this12.role === 'ADMIN' } });
      }).catch(function (error) {
        _this12.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    clearotherdesignate: function clearotherdesignate() {
      var _this13 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/clear_assign_to_assist', {
        "reason": this.clean_reason,
        "detail": this.clean_detail,
        role: 'SRVP'
      }, this.header).then(function (response) {
        alert('清除成功');
        _this13.$router.push({ name: 'RepairOrder', params: { isAdmin: _this13.role === 'ADMIN' } });
      });
    },
    againdesignate: function againdesignate() {
      var _this14 = this;

      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/reassign', {
        'account': this.roleid.toString(),
        'role': this.roleType,
        needpay: this.needpay,
        payment: this.payprice,
        reason: this.clean_reason,
        detail: this.clean_detail
      }, this.header).then(function () {
        alert('改派成功');
        _this14.$router.push({ name: 'RepairOrder', params: { isAdmin: _this14.role === 'ADMIN' } });
      });
    },
    fast: function fast() {
      var _this15 = this;

      this.$http.put('/api/v1/fastrepairs/' + this.seq, {
        'confirm': this.faststatus,
        'solution': this.fastplan
      }, this.header).then(function () {
        alert('确认订单成功');
        _this15.$router.push({ name: 'FastRepairOrder' });
      }).catch(function (error) {
        _this15.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      var unionid = localStorage.getItem('unionid');
      var account = void 0;
      ajax["a" /* default */].$http.get('api/v1/wechat/' + unionid).then(function (res) {
        res.data.forEach(function (item) {
          if (item.role === to.query.role) {
            account = item.account;
          }
        });
        ajax["a" /* default */].$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (response) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userid', response.data.userid);
          vm.header = {
            headers: {
              token: response.data.token,
              opid: response.data.userid
            }
          };
          if (to.query.type && (to.query.type === 'fast-false' || to.query.type === 'fast-true')) {
            ajax["a" /* default */].$http.get('api/v1/fastrepairs/' + to.query.seq, vm.header).then(function (response) {
              localStorage.setItem('order', stringify_default()(response.data.detail));
              vm.orderDetail = vm.initView(response.data.detail);
            }).catch(function (error) {
              console.log(error);
              vm.$vux.toast.show({
                text: JSON.parse(error.response.data.error_message).zh_string,
                type: 'cancel',
                time: '1000'
              });
            });
          } else {
            ajax["a" /* default */].$http.get('api/v1/normalrepairs/' + to.query.seq + '?role=' + to.query.role + '&type=detail', vm.header).then(function (response) {
              localStorage.setItem('order', stringify_default()(response.data.detail));
              vm.orderDetail = vm.initView(response.data.detail);
            }).catch(function (error) {
              console.log(error);
              vm.$vux.toast.show({
                text: JSON.parse(error.response.data.error_message).zh_string,
                type: 'cancel',
                time: '1000'
              });
            });
          }
        });
      });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'RepairOrder') {
      to.params.isAdmin = this.role === 'ADMIN';
    } else if (to.name === 'list') {
      to.params.role = this.isAdmin ? 'ADMIN' : 'SRVP';
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60eb6ce9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairs/RepairSrvp.vue
var RepairSrvp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报修订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否云帷设备","type":"text","readonly":""},model:{value:(_vm.orderDetail.isviwo),callback:function ($$v) {_vm.$set(_vm.orderDetail, "isviwo", $$v)},expression:"orderDetail.isviwo"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否1次开箱","type":"text","readonly":""},model:{value:(_vm.orderDetail.sevenday),callback:function ($$v) {_vm.$set(_vm.orderDetail, "sevenday", $$v)},expression:"orderDetail.sevenday"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devseq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devseq", $$v)},expression:"orderDetail.devseq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备名称","type":"text","readonly":""},model:{value:(_vm.orderDetail.devname),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devname", $$v)},expression:"orderDetail.devname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备所属生产线","type":"text","readonly":""},model:{value:(_vm.orderDetail.devmodel),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devmodel", $$v)},expression:"orderDetail.devmodel"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备生产商","type":"text","readonly":""},model:{value:(_vm.orderDetail.producer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "producer", $$v)},expression:"orderDetail.producer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.ftype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "ftype", $$v)},expression:"orderDetail.ftype"}}),_vm._v(" "),_c('x-textarea',{attrs:{"show-counter":false,"title":"故障具体描述","type":"text","autosize":"","readonly":""},model:{value:(_vm.orderDetail.fdesc),callback:function ($$v) {_vm.$set(_vm.orderDetail, "fdesc", $$v)},expression:"orderDetail.fdesc"}}),_vm._v(" "),_c('cell',{attrs:{"title":"故障图片"}},[_c('div',_vm._l((_vm.fdetailList),function(item,index){return _c('img',{key:index,staticClass:"previewer-demo-img",staticStyle:{"height":"90px"},attrs:{"src":item.src},on:{"click":function($event){_vm.show(index)}}})}))]),_vm._v(" "),(_vm.orderDetail.needpay!=='不需要支付'&&_vm.orderDetail.needpay !== '---')?_c('x-input',{attrs:{"title":"是否支付服务费用","type":"text","readonly":""},model:{value:(_vm.orderDetail.needpay),callback:function ($$v) {_vm.$set(_vm.orderDetail, "needpay", $$v)},expression:"orderDetail.needpay"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.needpay!=='不需要支付'&&_vm.orderDetail.needpay !== '---')?_c('x-input',{attrs:{"title":"服务费用","type":"text","readonly":""},model:{value:(_vm.orderDetail.initpay),callback:function ($$v) {_vm.$set(_vm.orderDetail, "initpay", $$v)},expression:"orderDetail.initpay"}}):_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"设备何处购入","type":"text","readonly":""},model:{value:(_vm.orderDetail.buyfrom),callback:function ($$v) {_vm.$set(_vm.orderDetail, "buyfrom", $$v)},expression:"orderDetail.buyfrom"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备所在地","type":"text","readonly":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"详细地址","type":"text","readonly":""},model:{value:(_vm.orderDetail.address),callback:function ($$v) {_vm.$set(_vm.orderDetail, "address", $$v)},expression:"orderDetail.address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.reptype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "reptype", $$v)},expression:"orderDetail.reptype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.name),callback:function ($$v) {_vm.$set(_vm.orderDetail, "name", $$v)},expression:"orderDetail.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "mobile", $$v)},expression:"orderDetail.mobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报修人所在单位","type":"text","readonly":""},model:{value:(_vm.orderDetail.company),callback:function ($$v) {_vm.$set(_vm.orderDetail, "company", $$v)},expression:"orderDetail.company"}}),_vm._v(" "),(_vm.orderDetail.reptype === '最终用户报修')?[_c('x-input',{attrs:{"title":"本地服务商","readonly":""},model:{value:(_vm.orderDetail.lservice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lservice", $$v)},expression:"orderDetail.lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","readonly":""},model:{value:(_vm.orderDetail.lsmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lsmobile", $$v)},expression:"orderDetail.lsmobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.reptype === '服务商代报修')?[_c('x-input',{attrs:{"title":"最终用户","readonly":""},model:{value:(_vm.orderDetail.enduser),callback:function ($$v) {_vm.$set(_vm.orderDetail, "enduser", $$v)},expression:"orderDetail.enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","readonly":""},model:{value:(_vm.orderDetail.endmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "endmobile", $$v)},expression:"orderDetail.endmobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.reptype === '其他代报修')?[_c('x-input',{attrs:{"title":"最终用户","readonly":""},model:{value:(_vm.orderDetail.enduser),callback:function ($$v) {_vm.$set(_vm.orderDetail, "enduser", $$v)},expression:"orderDetail.enduser"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"最终用户电话","readonly":""},model:{value:(_vm.orderDetail.endmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "endmobile", $$v)},expression:"orderDetail.endmobile"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商","readonly":""},model:{value:(_vm.orderDetail.lservice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lservice", $$v)},expression:"orderDetail.lservice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"本地服务商电话","readonly":""},model:{value:(_vm.orderDetail.lsmobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "lsmobile", $$v)},expression:"orderDetail.lsmobile"}})]:_vm._e(),_vm._v(" "),_c('cell',{attrs:{"title":('协助人信息'),"is-link":"","link":{name:'assistantinfo',query:{seq:_vm.orderDetail.seq,role:_vm.role,type:_vm.type}}}}),_vm._v(" "),_c('cell',{attrs:{"title":('支付订单'),"is-link":"","link":{name:'Userpay',params:{info:_vm.orderDetail.user_pays,role: _vm.role}}}}),_vm._v(" "),_c('x-input',{attrs:{"title":"申请开始时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.start),callback:function ($$v) {_vm.$set(_vm.orderDetail, "start", $$v)},expression:"orderDetail.start"}}),_vm._v(" "),(_vm.type.indexOf('fast') === -1)?_c('x-input',{attrs:{"title":"订单状态","type":"text","readonly":""},model:{value:(_vm.orderDetail.overall_name),callback:function ($$v) {_vm.$set(_vm.orderDetail, "overall_name", $$v)},expression:"orderDetail.overall_name"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.responsible&&_vm.orderDetail.responsible.type === 'SRVP' && _vm.role === 'ADMIN')?_c('x-input',{attrs:{"title":"责任人姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "name", $$v)},expression:"orderDetail.responsible.name"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.responsible&&_vm.orderDetail.responsible.type === 'SRVP' && _vm.role === 'ADMIN')?_c('x-input',{attrs:{"title":"责任人电话","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "mobile", $$v)},expression:"orderDetail.responsible.mobile"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.userconfirm)?_c('x-input',{attrs:{"title":"用户确认维修结果","type":"text","readonly":""},model:{value:(_vm.orderDetail.userconfirm),callback:function ($$v) {_vm.$set(_vm.orderDetail, "userconfirm", $$v)},expression:"orderDetail.userconfirm"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.useradvice)?_c('x-textarea',{attrs:{"title":"用户反馈意见","rows":1,"cols":10,"autosize":"","show-counter":false,"readonly":""},model:{value:(_vm.orderDetail.useradvice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "useradvice", $$v)},expression:"orderDetail.useradvice"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.expert)?[_c('x-input',{attrs:{"title":"工程师姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.expert.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.expert, "name", $$v)},expression:"orderDetail.expert.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"工程师电话","type":"text","readonly":""},nativeOn:{"click":function($event){_vm.callPhone(_vm.orderDetail.expert.mobile)}},model:{value:(_vm.orderDetail.expert.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.expert, "mobile", $$v)},expression:"orderDetail.expert.mobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.responsible&&_vm.orderDetail.responsible.type === 'EXPT')?[_c('x-input',{attrs:{"title":"工程师姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "name", $$v)},expression:"orderDetail.responsible.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"工程师电话","type":"text","readonly":""},nativeOn:{"click":function($event){_vm.callPhone(_vm.orderDetail.responsible.mobile)}},model:{value:(_vm.orderDetail.responsible.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "mobile", $$v)},expression:"orderDetail.responsible.mobile"}})]:_vm._e(),_vm._v(" "),(_vm.orderDetail.assit)?[_c('x-input',{attrs:{"title":"第三方工程师姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.assit.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.assit, "name", $$v)},expression:"orderDetail.assit.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"第三方工程师电话","type":"text","readonly":""},nativeOn:{"click":function($event){_vm.callPhone(_vm.orderDetail.assit.mobile)}},model:{value:(_vm.orderDetail.assit.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.assit, "mobile", $$v)},expression:"orderDetail.assit.mobile"}})]:_vm._e(),_vm._v(" "),(_vm.type.indexOf('fast') === -1)?_c('cell',{attrs:{"title":('维修进度'),"is-link":"","link":{ name: 'RepairSolution',params:{solution:_vm.orderDetail.solution,seq:_vm.orderDetail.seq,role: _vm.role,type: _vm.type,solutionv:_vm.orderDetail.solutionv,show:(_vm.type==='process'||_vm.type==='false')}}}}):_vm._e(),_vm._v(" "),(_vm.type === 'false' || _vm.type === 'true')?_c('cell',{attrs:{"title":('日志记录'),"is-link":"","link":{ name: 'RepairLog',params:{seq:_vm.orderDetail.seq,role: _vm.role,type: _vm.type}}}}):_vm._e(),_vm._v(" "),(_vm.state)?_c('x-input',{attrs:{"title":"维修结果","type":"text","readonly":""},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.conclusion)?_c('x-textarea',{attrs:{"title":"维修结论","type":"text","readonly":""},model:{value:(_vm.orderDetail.conclusion),callback:function ($$v) {_vm.$set(_vm.orderDetail, "conclusion", $$v)},expression:"orderDetail.conclusion"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.star)?_c('x-input',{attrs:{"title":"用户评价星级","type":"text","readonly":""},model:{value:(_vm.orderDetail.star),callback:function ($$v) {_vm.$set(_vm.orderDetail, "star", $$v)},expression:"orderDetail.star"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.rating)?_c('x-input',{attrs:{"title":"用户评价","type":"text","readonly":""},model:{value:(_vm.orderDetail.rating),callback:function ($$v) {_vm.$set(_vm.orderDetail, "rating", $$v)},expression:"orderDetail.rating"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,staticClass:"previewer-demo-img",attrs:{"src":'data:image/jpeg;base64,'+item.src}})}),_vm._v(" "),(_vm.filename)?_c('x-button',{nativeOn:{"click":function($event){return _vm.downloadFile($event)}}},[_vm._v(_vm._s(_vm.filename))]):_vm._e()],2),_vm._v(" "),(_vm.type==='accept')?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.searchType(0)}}},[_vm._v("处理该订单")]):_vm._e(),_vm._v(" "),(_vm.orderDetail.can_ask_user_pay)?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.searchType(4)}}},[_vm._v("用户支付\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='process'&&_vm.orderDetail.state === 'PROCESS')?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.searchType(1)}}},[_vm._v("\n    指派专家\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='process'&&_vm.orderDetail.state === 'PROCESS'&&_vm.orderDetail.expert&&!_vm.orderDetail.assit)?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.designateRouter(true)}}},[_vm._v("\n    指派第三方专家\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='process'&&( _vm.orderDetail.overall_status === 'PROCESSING_WAITCONFIRM' ||
              _vm.orderDetail.overall_status === 'PROCESSING_CONFIRMED' ||
              _vm.orderDetail.overall_status === 'PROCESSED_CONFIRMED'))?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.searchType(2)}}},[_vm._v("确认故障\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='process'&&_vm.orderDetail.assit)?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.clearotherdesignateshow=true}}},[_vm._v("\n    清除第三方专家\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='process'&&(_vm.orderDetail.overall_status === 'PROCESSING_CONFIRMED' || _vm.orderDetail.overall_status === 'PROCESSED_CONFIRMED'))?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.searchType(3)}}},[_vm._v("更新维修结果\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='false'&&(_vm.orderDetail.overall_status === 'WAITPROCESS_WAITCONFIRM'||_vm.orderDetail.overall_status==='WAITPROCESS_CONFIRMED'))?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.designateRouter()}}},[_vm._v("\n    指派服务商\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='false'&&(!(_vm.orderDetail.overall_status === 'WAITPROCESS_WAITCONFIRM' ||
                  _vm.orderDetail.overall_status === 'WAITPROCESS_WAITCONFIRM_CANCEL' ||
                  _vm.orderDetail.overall_status === 'WAITPROCESS_CONFIRMED' ||
                  _vm.orderDetail.overall_status === 'WAITPROCESS_CONFIRMED_CANCEL')))?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.designateAgainRouter()}}},[_vm._v("\n    改派服务商\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='false'&&(!(_vm.orderDetail.overall_status === 'WAITPROCESS_WAITCONFIRM' ||
                  _vm.orderDetail.overall_status === 'WAITPROCESS_WAITCONFIRM_CANCEL' ||
                  _vm.orderDetail.overall_status === 'WAITPROCESS_CONFIRMED' ||
                  _vm.orderDetail.overall_status === 'WAITPROCESS_CONFIRMED_CANCEL')))?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.cleardesignateshow = true}}},[_vm._v("\n    清除指派\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='false'&&(!(_vm.orderDetail.overall_status === 'ASSIGNED_CANCEL' || _vm.orderDetail.overall_status === 'PROCESSING_CONFIRMED_CANCEL')))?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.searchType(2)}}},[_vm._v("\n    确认故障\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='false'&&(_vm.orderDetail.overall_status === 'WAITPROCESS_CONFIRMED' ||
                  _vm.orderDetail.overall_status === 'WAITPROCESS_CONFIRMED_CANCEL' ||
                  _vm.orderDetail.overall_status === 'PROCESSING_CONFIRMED' ||
                  _vm.orderDetail.overall_status === 'PROCESSED_CONFIRMED'))?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.searchType(3)}}},[_vm._v("\n    更新维修结果\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='false'&& _vm.orderDetail.overall_status === 'PROCESSED_WAIT')?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.rejectshow = true}}},[_vm._v("\n    驳回订单\n  ")]):_vm._e(),_vm._v(" "),(_vm.type==='false'&&_vm.orderDetail.overall_status === 'PROCESSED_CONFIRMED')?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.closeshow = true}}},[_vm._v("\n    关闭报修申请\n  ")]):_vm._e(),_vm._v(" "),(_vm.type === 'fast-false')?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.fastshow = true}}},[_vm._v("\n    确认报修申请\n  ")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"确认故障"},on:{"on-cancel":function($event){_vm.confirmshow = false},"on-confirm":_vm.confrm},model:{value:(_vm.confirmshow),callback:function ($$v) {_vm.confirmshow=$$v},expression:"confirmshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"故障结果","options":['是','否','无效','等待']},model:{value:(_vm.confirminfo),callback:function ($$v) {_vm.confirminfo=$$v},expression:"confirminfo"}})],1)],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"添加协助专家"},on:{"on-cancel":function($event){_vm.marketshow = false},"on-confirm":_vm.addMarket},model:{value:(_vm.marketshow),callback:function ($$v) {_vm.marketshow=$$v},expression:"marketshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"协助专家","options":_vm.marketlist},model:{value:(_vm.market),callback:function ($$v) {_vm.market=$$v},expression:"market"}})],1)],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"更新维修结果"},on:{"on-cancel":function($event){_vm.updateshow = false},"on-confirm":_vm.update},model:{value:(_vm.updateshow),callback:function ($$v) {_vm.updateshow=$$v},expression:"updateshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"故障结果","options":['成功','失败']},model:{value:(_vm.updateinfo),callback:function ($$v) {_vm.updateinfo=$$v},expression:"updateinfo"}})],1)],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"show-input":"","title":"是否接受此订单","placeholder":"请输入原因","input-attrs":{type: 'text'},"confirm-text":"接受","cancel-text":"拒绝"},on:{"on-cancel":_vm.reject,"on-confirm":_vm.accpet},model:{value:(_vm.acceptshow),callback:function ($$v) {_vm.acceptshow=$$v},expression:"acceptshow"}}),_vm._v(" "),_c('confirm',{ref:"rejectorder",staticStyle:{"color":"#000"},attrs:{"show-input":"","title":"驳回订单","placeholder":"请输入原因","input-attrs":{type: 'textarea'}},on:{"on-cancel":function($event){_vm.rejectshow = false},"on-confirm":_vm.confirmRejct},model:{value:(_vm.rejectshow),callback:function ($$v) {_vm.rejectshow=$$v},expression:"rejectshow"}}),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"指派专家"},on:{"on-cancel":function($event){_vm.assignshow = false},"on-confirm":_vm.assign},model:{value:(_vm.assignshow),callback:function ($$v) {_vm.assignshow=$$v},expression:"assignshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"专家","options":_vm.list},model:{value:(_vm.expert),callback:function ($$v) {_vm.expert=$$v},expression:"expert"}})],1)],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"指派专家"},on:{"on-cancel":function($event){_vm.designateshow = false},"on-confirm":_vm.designate},model:{value:(_vm.designateshow),callback:function ($$v) {_vm.designateshow=$$v},expression:"designateshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"是否支付服务费用","options":_vm.pay},model:{value:(_vm.needpay),callback:function ($$v) {_vm.needpay=$$v},expression:"needpay"}}),_vm._v(" "),(_vm.needpay)?_c('x-input',{staticClass:"b-input",attrs:{"title":"服务费用","type":"number"},on:{"on-blur":_vm.priceChange},model:{value:(_vm.payment),callback:function ($$v) {_vm.payment=$$v},expression:"payment"}}):_vm._e(),_vm._v(" "),_c('selector',{attrs:{"title":"身份类型","options":_vm.roles},on:{"on-change":_vm.designateChange},model:{value:(_vm.roleType),callback:function ($$v) {_vm.roleType=$$v},expression:"roleType"}}),_vm._v(" "),_c('selector',{attrs:{"title":"用户名称","options":_vm.roleAccount},model:{value:(_vm.roleid),callback:function ($$v) {_vm.roleid=$$v},expression:"roleid"}})],1)],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"关闭报修"},on:{"on-cancel":function($event){_vm.closeshow = false},"on-confirm":_vm.close},model:{value:(_vm.closeshow),callback:function ($$v) {_vm.closeshow=$$v},expression:"closeshow"}},[_c('x-textarea',{staticClass:"white-textarea",attrs:{"title":"附加结论","rows":1,"cols":10,"max":255,"autosize":"","show-counter":false},model:{value:(_vm.close_advice),callback:function ($$v) {_vm.close_advice=$$v},expression:"close_advice"}}),_vm._v(" "),_c('selector',{staticClass:"b-select",attrs:{"title":"故障类别确认","options":_vm.closeList},model:{value:(_vm.close_fconfirm),callback:function ($$v) {_vm.close_fconfirm=$$v},expression:"close_fconfirm"}})],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"清除指派"},on:{"on-cancel":function($event){_vm.cleardesignateshow = false},"on-confirm":_vm.cleardesignate},model:{value:(_vm.cleardesignateshow),callback:function ($$v) {_vm.cleardesignateshow=$$v},expression:"cleardesignateshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"清除原因","options":_vm.reason},model:{value:(_vm.clean_reason),callback:function ($$v) {_vm.clean_reason=$$v},expression:"clean_reason"}}),_vm._v(" "),_c('x-textarea',{staticClass:"white-textarea",attrs:{"rows":1,"cols":10,"title":"具体原因","max":255,"autosize":"","show-counter":false},model:{value:(_vm.clean_detail),callback:function ($$v) {_vm.clean_detail=$$v},expression:"clean_detail"}})],1)],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"清除第三方专家指派"},on:{"on-cancel":function($event){_vm.clearotherdesignateshow = false},"on-confirm":_vm.clearotherdesignate},model:{value:(_vm.clearotherdesignateshow),callback:function ($$v) {_vm.clearotherdesignateshow=$$v},expression:"clearotherdesignateshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"清除原因","options":_vm.reason},model:{value:(_vm.clean_reason),callback:function ($$v) {_vm.clean_reason=$$v},expression:"clean_reason"}}),_vm._v(" "),_c('x-textarea',{staticClass:"white-textarea",attrs:{"rows":1,"cols":10,"title":"具体原因","max":255,"autosize":"","show-counter":false},model:{value:(_vm.clean_detail),callback:function ($$v) {_vm.clean_detail=$$v},expression:"clean_detail"}})],1)],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"改派专家"},on:{"on-cancel":function($event){_vm.againdesignateshow = false},"on-confirm":_vm.againdesignate},model:{value:(_vm.againdesignateshow),callback:function ($$v) {_vm.againdesignateshow=$$v},expression:"againdesignateshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"清除原因","options":_vm.reason},model:{value:(_vm.clean_reason),callback:function ($$v) {_vm.clean_reason=$$v},expression:"clean_reason"}}),_vm._v(" "),_c('x-textarea',{staticClass:"white-textarea",attrs:{"rows":1,"cols":10,"title":"具体原因","max":255,"autosize":"","show-counter":false},model:{value:(_vm.clean_detail),callback:function ($$v) {_vm.clean_detail=$$v},expression:"clean_detail"}}),_vm._v(" "),_c('selector',{staticClass:"b-select",attrs:{"title":"是否支付服务费用","options":_vm.pay},model:{value:(_vm.needpay),callback:function ($$v) {_vm.needpay=$$v},expression:"needpay"}}),_vm._v(" "),(_vm.needpay)?_c('x-input',{staticClass:"b-input",attrs:{"title":"服务费用","type":"number"},on:{"on-blur":_vm.priceChange},model:{value:(_vm.payment),callback:function ($$v) {_vm.payment=$$v},expression:"payment"}}):_vm._e(),_vm._v(" "),_c('selector',{attrs:{"title":"身份类型","options":_vm.roles},on:{"on-change":_vm.designateChange},model:{value:(_vm.roleType),callback:function ($$v) {_vm.roleType=$$v},expression:"roleType"}}),_vm._v(" "),_c('selector',{attrs:{"title":"用户名称","options":_vm.roleAccount},model:{value:(_vm.roleid),callback:function ($$v) {_vm.roleid=$$v},expression:"roleid"}})],1)],1),_vm._v(" "),_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"确认报修申请"},on:{"on-cancel":function($event){_vm.fastshow = false},"on-confirm":_vm.fast},model:{value:(_vm.fastshow),callback:function ($$v) {_vm.fastshow=$$v},expression:"fastshow"}},[_c('group',[_c('selector',{staticClass:"b-select",attrs:{"title":"故障状态","options":_vm.faststatusList},model:{value:(_vm.faststatus),callback:function ($$v) {_vm.faststatus=$$v},expression:"faststatus"}}),_vm._v(" "),_c('x-textarea',{staticClass:"white-textarea",attrs:{"rows":1,"cols":10,"title":"故障解决方案","max":255,"autosize":"","show-counter":false},model:{value:(_vm.fastplan),callback:function ($$v) {_vm.fastplan=$$v},expression:"fastplan"}})],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.fdetailList,"options":_vm.options}})],1)],1)}
var RepairSrvp_staticRenderFns = []
var RepairSrvp_esExports = { render: RepairSrvp_render, staticRenderFns: RepairSrvp_staticRenderFns }
/* harmony default export */ var components_repairs_RepairSrvp = (RepairSrvp_esExports);
// CONCATENATED MODULE: ./src/components/repairs/RepairSrvp.vue
function RepairSrvp_injectStyle (ssrContext) {
  __webpack_require__("vRTY")
}
var RepairSrvp_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RepairSrvp___vue_template_functional__ = false
/* styles */
var RepairSrvp___vue_styles__ = RepairSrvp_injectStyle
/* scopeId */
var RepairSrvp___vue_scopeId__ = "data-v-60eb6ce9"
/* moduleIdentifier (server only) */
var RepairSrvp___vue_module_identifier__ = null
var RepairSrvp_Component = RepairSrvp_normalizeComponent(
  repairs_RepairSrvp,
  components_repairs_RepairSrvp,
  RepairSrvp___vue_template_functional__,
  RepairSrvp___vue_styles__,
  RepairSrvp___vue_scopeId__,
  RepairSrvp___vue_module_identifier__
)

/* harmony default export */ var src_components_repairs_RepairSrvp = (RepairSrvp_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairs/RepairLog.vue



/* harmony default export */ var RepairLog = ({
  name: "RepairLog",
  components: { XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      logList: [],
      seq: this.$route.params.seq,
      role: this.$route.params.role,
      type: this.$route.params.type
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get('/api/v1/normalrepairs/' + this.seq + '?role=' + this.role + '&type=logs', this.header).then(function (logs) {
      _this.logList = logs.data;
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'RepairSrvp') {
      to.params.seq = this.seq;
      to.params.type = this.type;
      to.params.role = this.role;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairs/RepairLog.vue



/* harmony default export */ var repairs_RepairLog = ({
  name: "RepairLog",
  components: { XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      logList: [],
      seq: this.$route.params.seq,
      role: this.$route.params.role,
      type: this.$route.params.type
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get('/api/v1/normalrepairs/' + this.seq + '?role=' + this.role + '&type=logs', this.header).then(function (logs) {
      _this.logList = logs.data;
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'RepairSrvp') {
      to.params.seq = this.seq;
      to.params.type = this.type;
      to.params.role = this.role;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b62b91","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairs/RepairLog.vue
var RepairLog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("日志记录")]),_vm._v(" "),_vm._l((_vm.logList),function(log,index){return _c('p',{key:index},[_vm._v(_vm._s(log.log))])})],2)}
var RepairLog_staticRenderFns = []
var RepairLog_esExports = { render: RepairLog_render, staticRenderFns: RepairLog_staticRenderFns }
/* harmony default export */ var components_repairs_RepairLog = (RepairLog_esExports);
// CONCATENATED MODULE: ./src/components/repairs/RepairLog.vue
function RepairLog_injectStyle (ssrContext) {
  __webpack_require__("hKOj")
}
var RepairLog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RepairLog___vue_template_functional__ = false
/* styles */
var RepairLog___vue_styles__ = RepairLog_injectStyle
/* scopeId */
var RepairLog___vue_scopeId__ = "data-v-39b62b91"
/* moduleIdentifier (server only) */
var RepairLog___vue_module_identifier__ = null
var RepairLog_Component = RepairLog_normalizeComponent(
  repairs_RepairLog,
  components_repairs_RepairLog,
  RepairLog___vue_template_functional__,
  RepairLog___vue_styles__,
  RepairLog___vue_scopeId__,
  RepairLog___vue_module_identifier__
)

/* harmony default export */ var src_components_repairs_RepairLog = (RepairLog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repair.vue









/* harmony default export */ var repair = ({
  name: "repair",
  components: { XHeader: vux_src_components_x_header, XInput: vux_src_components_x_input, Group: group["a" /* default */], XButton: vux_src_components_x_button, Cell: vux_src_components_cell, XTextarea: vux_src_components_x_textarea, Previewer: vux_src_components_previewer },
  data: function data() {
    return {
      orderDetail: {},
      address: '',
      seq: this.$route.query.seq,
      role: this.$route.query.role,
      list: []
    };
  },

  methods: {
    callPhone: function callPhone(phoneNumber) {
      window.location.href = 'tel://' + phoneNumber;
    },
    goRepairSolution: function goRepairSolution() {
      this.$router.push({
        name: 'RepairSolution',
        params: {
          solution: this.orderDetail.solution,
          seq: this.orderDetail.seq,
          role: this.role,
          type: '',
          solutionv: this.orderDetail.solutionv,
          show: false
        }
      });
    }
  },
  created: function created() {
    var _this = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$http.get('/api/v1/wechat/' + unionid).then(function (response) {

      response.data.forEach(function (item) {
        if (item.role === _this.role) {
          _this.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': item.account }).then(function (res) {
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            _this.$http.get('api/v1/normalrepairs/' + _this.seq + '?role=' + _this.role + '&type=detail', obj).then(function (response) {
              _this.orderDetail = response.data.detail;
              _this.orderDetail.sevenday = _this.orderDetail.sevenday ? '是' : '否';
              _this.orderDetail.isviwo = _this.orderDetail.isviwo ? '是' : '否';
              _this.address = _this.orderDetail.province + ' ' + _this.orderDetail.city + " " + _this.orderDetail.district;
              switch (_this.orderDetail.userconfirm) {
                case 'ACCEPT':
                  _this.orderDetail.userconfirm = '接受';
                  break;
                case 'WAIT1':
                  _this.orderDetail.userconfirm = '等待确认';
                  break;
                case 'WAIT2':
                  _this.orderDetail.userconfirm = '等待确认';
                  break;
                case 'REJECT':
                  _this.orderDetail.userconfirm = '拒绝';
                  break;
                case 'ARBIT':
                  _this.orderDetail.userconfirm = '提交仲裁';
                  break;
                case 'A_ACCEPT':
                  _this.orderDetail.userconfirm = '后台自动确认';
                  break;
              }
              switch (_this.orderDetail.state) {
                case 'WAIT':
                  _this.orderDetail.state = '待处理';
                  break;
                case 'PROCESS':
                  _this.orderDetail.state = '处理中';
                  break;
                case 'FAIL':
                  _this.orderDetail.state = '失败';
                  break;
                case 'SUCCESS':
                  _this.orderDetail.state = '成功';
                  break;
              }
              _this.list = [];
              if (_this.orderDetail.signature && _this.orderDetail.signature.content.length !== 0) {
                _this.orderDetail.signature.content[0].path.forEach(function (item) {
                  _this.$http.get('/api/photos?path=' + item, obj).then(function (paths) {
                    _this.list.push({ src: paths.data['value'] });
                    console.log(_this.list);
                  });
                });
              }
            }).catch(function (error) {
              console.log(error);
            });
          }).catch(function (error) {
            _this.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).faultstring,
              type: 'cancel',
              time: '1000'
            });
          });
        }
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repair.vue









/* harmony default export */ var components_repair = ({
  name: "repair",
  components: { XHeader: vux_src_components_x_header, XInput: vux_src_components_x_input, Group: group["a" /* default */], XButton: vux_src_components_x_button, Cell: vux_src_components_cell, XTextarea: vux_src_components_x_textarea, Previewer: vux_src_components_previewer },
  data: function data() {
    return {
      orderDetail: {},
      address: '',
      seq: this.$route.query.seq,
      role: this.$route.query.role,
      list: []
    };
  },

  methods: {
    callPhone: function callPhone(phoneNumber) {
      window.location.href = 'tel://' + phoneNumber;
    },
    goRepairSolution: function goRepairSolution() {
      this.$router.push({
        name: 'RepairSolution',
        params: {
          solution: this.orderDetail.solution,
          seq: this.orderDetail.seq,
          role: this.role,
          type: '',
          solutionv: this.orderDetail.solutionv,
          show: false
        }
      });
    }
  },
  created: function created() {
    var _this = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$http.get('/api/v1/wechat/' + unionid).then(function (response) {

      response.data.forEach(function (item) {
        if (item.role === _this.role) {
          _this.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': item.account }).then(function (res) {
            var obj = {
              headers: {
                token: res.data.token,
                opid: res.data.userid
              }
            };
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('userid', res.data.userid);
            _this.$http.get('api/v1/normalrepairs/' + _this.seq + '?role=' + _this.role + '&type=detail', obj).then(function (response) {
              _this.orderDetail = response.data.detail;
              _this.orderDetail.sevenday = _this.orderDetail.sevenday ? '是' : '否';
              _this.orderDetail.isviwo = _this.orderDetail.isviwo ? '是' : '否';
              _this.address = _this.orderDetail.province + ' ' + _this.orderDetail.city + " " + _this.orderDetail.district;
              switch (_this.orderDetail.userconfirm) {
                case 'ACCEPT':
                  _this.orderDetail.userconfirm = '接受';
                  break;
                case 'WAIT1':
                  _this.orderDetail.userconfirm = '等待确认';
                  break;
                case 'WAIT2':
                  _this.orderDetail.userconfirm = '等待确认';
                  break;
                case 'REJECT':
                  _this.orderDetail.userconfirm = '拒绝';
                  break;
                case 'ARBIT':
                  _this.orderDetail.userconfirm = '提交仲裁';
                  break;
                case 'A_ACCEPT':
                  _this.orderDetail.userconfirm = '后台自动确认';
                  break;
              }
              switch (_this.orderDetail.state) {
                case 'WAIT':
                  _this.orderDetail.state = '待处理';
                  break;
                case 'PROCESS':
                  _this.orderDetail.state = '处理中';
                  break;
                case 'FAIL':
                  _this.orderDetail.state = '失败';
                  break;
                case 'SUCCESS':
                  _this.orderDetail.state = '成功';
                  break;
              }
              _this.list = [];
              if (_this.orderDetail.signature && _this.orderDetail.signature.content.length !== 0) {
                _this.orderDetail.signature.content[0].path.forEach(function (item) {
                  _this.$http.get('/api/photos?path=' + item, obj).then(function (paths) {
                    _this.list.push({ src: paths.data['value'] });
                    console.log(_this.list);
                  });
                });
              }
            }).catch(function (error) {
              console.log(error);
            });
          }).catch(function (error) {
            _this.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).faultstring,
              type: 'cancel',
              time: '1000'
            });
          });
        }
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-050e8208","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repair.vue
var repair_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报修订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否云帷设备","type":"text","readonly":""},model:{value:(_vm.orderDetail.isviwo),callback:function ($$v) {_vm.$set(_vm.orderDetail, "isviwo", $$v)},expression:"orderDetail.isviwo"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否1次开箱","type":"text","readonly":""},model:{value:(_vm.orderDetail.sevenday),callback:function ($$v) {_vm.$set(_vm.orderDetail, "sevenday", $$v)},expression:"orderDetail.sevenday"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备序列号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devseq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devseq", $$v)},expression:"orderDetail.devseq"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备名称","show-counter":false,"max":32,"autosize":"","readonly":""},model:{value:(_vm.orderDetail.devname),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devname", $$v)},expression:"orderDetail.devname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备型号","type":"text","readonly":""},model:{value:(_vm.orderDetail.devmodel),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devmodel", $$v)},expression:"orderDetail.devmodel"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备生产商","max":32,"autosize":"","show-counter":false,"readonly":""},model:{value:(_vm.orderDetail.producer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "producer", $$v)},expression:"orderDetail.producer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备所在地","type":"text","readonly":""},model:{value:(_vm.address),callback:function ($$v) {_vm.address=$$v},expression:"address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"详细地址","type":"text","readonly":""},model:{value:(_vm.orderDetail.address),callback:function ($$v) {_vm.$set(_vm.orderDetail, "address", $$v)},expression:"orderDetail.address"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障类型","type":"text","readonly":""},model:{value:(_vm.orderDetail.ftype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "ftype", $$v)},expression:"orderDetail.ftype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"故障具体描述","type":"text","readonly":""},model:{value:(_vm.orderDetail.fdesc),callback:function ($$v) {_vm.$set(_vm.orderDetail, "fdesc", $$v)},expression:"orderDetail.fdesc"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"设备何处购入","show-counter":false,"max":32,"autosize":"","readonly":""},model:{value:(_vm.orderDetail.buyfrom),callback:function ($$v) {_vm.$set(_vm.orderDetail, "buyfrom", $$v)},expression:"orderDetail.buyfrom"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"show-counter":false,"title":"报修人公司","max":32,"autosize":"","readonly":""},model:{value:(_vm.orderDetail.company),callback:function ($$v) {_vm.$set(_vm.orderDetail, "company", $$v)},expression:"orderDetail.company"}}),_vm._v(" "),(_vm.role==='EXPT')?_c('x-input',{attrs:{"title":"报修人姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.name),callback:function ($$v) {_vm.$set(_vm.orderDetail, "name", $$v)},expression:"orderDetail.name"}}):_vm._e(),_vm._v(" "),(_vm.role==='EXPT')?_c('x-input',{attrs:{"title":"报修人电话","type":"text","readonly":""},nativeOn:{"click":function($event){_vm.callPhone(_vm.orderDetail.mobile)}},model:{value:(_vm.orderDetail.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail, "mobile", $$v)},expression:"orderDetail.mobile"}}):_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"申请开始时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.start),callback:function ($$v) {_vm.$set(_vm.orderDetail, "start", $$v)},expression:"orderDetail.start"}}),_vm._v(" "),(_vm.orderDetail.userconfirm)?_c('x-input',{attrs:{"title":"用户确认维修结果","type":"text","readonly":""},model:{value:(_vm.orderDetail.userconfirm),callback:function ($$v) {_vm.$set(_vm.orderDetail, "userconfirm", $$v)},expression:"orderDetail.userconfirm"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.useradvice)?_c('x-textarea',{attrs:{"title":"用户反馈意见","rows":1,"cols":10,"autosize":"","show-counter":false,"readonly":""},model:{value:(_vm.orderDetail.useradvice),callback:function ($$v) {_vm.$set(_vm.orderDetail, "useradvice", $$v)},expression:"orderDetail.useradvice"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.responsible&&_vm.role==='INDV')?_c('x-input',{attrs:{"title":"工程师姓名","type":"text","readonly":""},model:{value:(_vm.orderDetail.responsible.name),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "name", $$v)},expression:"orderDetail.responsible.name"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.responsible&&_vm.role==='INDV')?_c('x-input',{attrs:{"title":"工程师电话","type":"text","readonly":""},nativeOn:{"click":function($event){_vm.callPhone(_vm.orderDetail.responsible.mobile)}},model:{value:(_vm.orderDetail.responsible.mobile),callback:function ($$v) {_vm.$set(_vm.orderDetail.responsible, "mobile", $$v)},expression:"orderDetail.responsible.mobile"}}):_vm._e(),_vm._v(" "),_c('cell',{attrs:{"title":('维修进度'),"is-link":""},nativeOn:{"click":function($event){return _vm.goRepairSolution($event)}}}),_vm._v(" "),(_vm.orderDetail.state)?_c('x-input',{attrs:{"title":"维修结果","type":"text","readonly":""},model:{value:(_vm.orderDetail.state),callback:function ($$v) {_vm.$set(_vm.orderDetail, "state", $$v)},expression:"orderDetail.state"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.conclusion)?_c('x-input',{attrs:{"title":"维修结论","type":"text","readonly":""},model:{value:(_vm.orderDetail.conclusion),callback:function ($$v) {_vm.$set(_vm.orderDetail, "conclusion", $$v)},expression:"orderDetail.conclusion"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.star)?_c('x-input',{attrs:{"title":"用户评价星级","type":"text","readonly":""},model:{value:(_vm.orderDetail.star),callback:function ($$v) {_vm.$set(_vm.orderDetail, "star", $$v)},expression:"orderDetail.star"}}):_vm._e(),_vm._v(" "),(_vm.orderDetail.rating)?_c('x-input',{attrs:{"title":"用户评价","type":"text","readonly":""},model:{value:(_vm.orderDetail.rating),callback:function ($$v) {_vm.$set(_vm.orderDetail, "rating", $$v)},expression:"orderDetail.rating"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('img',{key:index,staticClass:"previewer-demo-img",attrs:{"src":'data:image/jpeg;base64,'+item.src}})})],2)],1)}
var repair_staticRenderFns = []
var repair_esExports = { render: repair_render, staticRenderFns: repair_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_repair = (repair_esExports);
// CONCATENATED MODULE: ./src/components/repair.vue
function repair_injectStyle (ssrContext) {
  __webpack_require__("zntn")
}
var repair_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var repair___vue_template_functional__ = false
/* styles */
var repair___vue_styles__ = repair_injectStyle
/* scopeId */
var repair___vue_scopeId__ = "data-v-050e8208"
/* moduleIdentifier (server only) */
var repair___vue_module_identifier__ = null
var repair_Component = repair_normalizeComponent(
  components_repair,
  selectortype_template_index_0_src_components_repair,
  repair___vue_template_functional__,
  repair___vue_styles__,
  repair___vue_scopeId__,
  repair___vue_module_identifier__
)

/* harmony default export */ var src_components_repair = (repair_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairs/RepairSolution.vue





/* harmony default export */ var RepairSolution = ({
  name: "RepairSolution",
  components: { XHeader: vux_src_components_x_header, XButton: vux_src_components_x_button, Cell: vux_src_components_cell },
  data: function data() {
    return {
      solutionList: this.$route.params.solution,
      seq: this.$route.params.seq,
      role: this.$route.params.role,
      type: this.$route.params.type,
      solutionv: this.$route.params.solutionv,
      show: this.$route.params.show === false ? this.$route.params.show : true
    };
  },

  methods: {
    addRate: function addRate() {
      this.$router.push({
        name: 'addrate',
        params: { rate: this.solutionList ? this.solutionList.content : [], solutionv: this.solutionv }
      });
    }
  },
  created: function created() {
    var _this = this;

    if (this.solutionv === 2) {
      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_solutions?role=' + this.role + '&offset=0&count=999', {
        headers: {
          token: localStorage.getItem("token"),
          opid: localStorage.getItem("userid")
        }
      }).then(function (resposne) {
        _this.solutionList = resposne.data;
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: "cancel",
          time: "1000"
        });
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'RepairSrvp') {
      to.params.seq = this.seq;
      to.params.type = this.type;
      to.params.role = this.role;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairs/RepairSolution.vue





/* harmony default export */ var repairs_RepairSolution = ({
  name: "RepairSolution",
  components: { XHeader: vux_src_components_x_header, XButton: vux_src_components_x_button, Cell: vux_src_components_cell },
  data: function data() {
    return {
      solutionList: this.$route.params.solution,
      seq: this.$route.params.seq,
      role: this.$route.params.role,
      type: this.$route.params.type,
      solutionv: this.$route.params.solutionv,
      show: this.$route.params.show === false ? this.$route.params.show : true
    };
  },

  methods: {
    addRate: function addRate() {
      this.$router.push({
        name: 'addrate',
        params: { rate: this.solutionList ? this.solutionList.content : [], solutionv: this.solutionv }
      });
    }
  },
  created: function created() {
    var _this = this;

    if (this.solutionv === 2) {
      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_solutions?role=' + this.role + '&offset=0&count=999', {
        headers: {
          token: localStorage.getItem("token"),
          opid: localStorage.getItem("userid")
        }
      }).then(function (resposne) {
        _this.solutionList = resposne.data;
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: "cancel",
          time: "1000"
        });
      });
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'RepairSrvp') {
      to.params.seq = this.seq;
      to.params.type = this.type;
      to.params.role = this.role;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f495256","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairs/RepairSolution.vue
var RepairSolution_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("维修进度")]),_vm._v(" "),(_vm.solutionList)?_c('div',_vm._l((_vm.solutionList.content),function(solution,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'prgsdetail', params: { order: solution,solutionv: _vm.solutionv}}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("\n        "+_vm._s(solution.time)+"--"+_vm._s(solution.describe ? solution.describe : solution.operator.name + '--' + solution.record)+"\n      ")])])})):_vm._e(),_vm._v(" "),(_vm.show)?_c('x-button',{nativeOn:{"click":function($event){return _vm.addRate($event)}}},[_vm._v("添加维修进度")]):_vm._e()],1)}
var RepairSolution_staticRenderFns = []
var RepairSolution_esExports = { render: RepairSolution_render, staticRenderFns: RepairSolution_staticRenderFns }
/* harmony default export */ var components_repairs_RepairSolution = (RepairSolution_esExports);
// CONCATENATED MODULE: ./src/components/repairs/RepairSolution.vue
function RepairSolution_injectStyle (ssrContext) {
  __webpack_require__("MppL")
}
var RepairSolution_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RepairSolution___vue_template_functional__ = false
/* styles */
var RepairSolution___vue_styles__ = RepairSolution_injectStyle
/* scopeId */
var RepairSolution___vue_scopeId__ = "data-v-3f495256"
/* moduleIdentifier (server only) */
var RepairSolution___vue_module_identifier__ = null
var RepairSolution_Component = RepairSolution_normalizeComponent(
  repairs_RepairSolution,
  components_repairs_RepairSolution,
  RepairSolution___vue_template_functional__,
  RepairSolution___vue_styles__,
  RepairSolution___vue_scopeId__,
  RepairSolution___vue_module_identifier__
)

/* harmony default export */ var src_components_repairs_RepairSolution = (RepairSolution_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login/RegisterType.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var RegisterType = ({
    name: "RegisterType",
    methods: {
        indv: function indv() {
            this.$router.push({ name: 'register', query: { role: 'users' } }).catch(function (err) {
                console.log(err);
            });
        },
        expt: function expt() {
            this.$router.push({ name: 'register', query: { role: 'expert' } });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login/RegisterType.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var login_RegisterType = ({
    name: "RegisterType",
    methods: {
        indv: function indv() {
            this.$router.push({ name: 'register', query: { role: 'users' } }).catch(function (err) {
                console.log(err);
            });
        },
        expt: function expt() {
            this.$router.push({ name: 'register', query: { role: 'expert' } });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f0c31d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/RegisterType.vue
var RegisterType_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"indv",on:{"click":_vm.indv}},[_c('h4',[_vm._v("最终用户")]),_vm._v(" "),_c('p',[_vm._v("我是最终用户，我要提交报修申请")])]),_vm._v(" "),_c('div',{staticClass:"expt",on:{"click":_vm.expt}},[_c('h4',[_vm._v("技术专家")]),_vm._v(" "),_c('p',[_vm._v("我是技术专家，我能提供专业服务")])])])}
var RegisterType_staticRenderFns = []
var RegisterType_esExports = { render: RegisterType_render, staticRenderFns: RegisterType_staticRenderFns }
/* harmony default export */ var components_login_RegisterType = (RegisterType_esExports);
// CONCATENATED MODULE: ./src/components/login/RegisterType.vue
function RegisterType_injectStyle (ssrContext) {
  __webpack_require__("ATJE")
}
var RegisterType_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var RegisterType___vue_template_functional__ = false
/* styles */
var RegisterType___vue_styles__ = RegisterType_injectStyle
/* scopeId */
var RegisterType___vue_scopeId__ = "data-v-75f0c31d"
/* moduleIdentifier (server only) */
var RegisterType___vue_module_identifier__ = null
var RegisterType_Component = RegisterType_normalizeComponent(
  login_RegisterType,
  components_login_RegisterType,
  RegisterType___vue_template_functional__,
  RegisterType___vue_styles__,
  RegisterType___vue_scopeId__,
  RegisterType___vue_module_identifier__
)

/* harmony default export */ var src_components_login_RegisterType = (RegisterType_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairs/Desiginate.vue







/* harmony default export */ var Desiginate = ({
  name: "Desiginate",
  components: { Group: group["a" /* default */], Selector: vux_src_components_selector, XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, XTextarea: vux_src_components_x_textarea },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      isRole: false,
      pay: [{ key: 1, value: '是' }, { key: 0, value: '否' }],
      needpay: 0,
      payment: '',
      payprice: 0,
      roles: [{ key: 'EXPT', value: '专家' }, { key: 'SRVP', value: '服务商' }],
      rolesSrvp: [{ key: 'true', value: '本公司专家' }, { key: 'false', value: '非本公司专家' }],
      rolesExpt: [{ key: 'company', value: '公司' }, { key: 'name', value: '姓名' }],
      roleAccount: [],
      roleType: this.$route.query.roleType || '',
      roleid: '',
      seq: this.$route.query.seq,
      role: this.$route.query.role,
      type: this.$route.query.type,
      again: this.$route.query.again,
      name: '',
      reason: [{ key: 'REJECT', value: '拒绝' }, { key: 'REGRET', value: '反悔' }, {
        key: 'UNQUAL',
        value: '不合格'
      }, { key: 'TIMEOUT', value: '超时' }, { key: 'UCANCLR', value: '用户取消' }],
      clean_reason: '',
      clean_detail: ''
    };
  },

  methods: {
    changeSearchName: function changeSearchName() {
      var _this = this;

      this.$http.get('/api/v1/agencies/' + localStorage.getItem('userid') + '/experts?hint=' + this.name + '&offset=0&count=999&type=added', this.header).then(function (response) {
        _this.roleAccount = response.data['list'];
        if (_this.roleAccount.length === 1) {
          if (_this.name !== _this.roleAccount[0].value) {
            _this.isRole = true;
          }
        } else {
          _this.isRole = true;
        }
      });
    },
    changeSearchType: function changeSearchType() {
      var _this2 = this;

      this.roleAccount = [];
      this.$http.get('/api/v1/experts?name=' + this.name + '&offset=0&count=20&status=AUDITED', this.header).then(function (response) {
        _this2.roleAccount = response.data['list'];
        if (_this2.roleAccount.length === 1) {
          if (_this2.name !== _this2.roleAccount[0].value) {
            _this2.isRole = true;
          }
        } else {
          _this2.isRole = true;
        }
      });
    },
    format: function format(num) {
      return num.toLocaleString('zh', { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false });
    },
    priceChange: function priceChange() {
      try {
        this.payprice = parseFloat(this.payment).toFixed(2);
        this.payment = this.format(parseFloat(this.payment));
        if (isNaN(this.payment)) {
          alert('请输入正确价格');
          this.payment = '0.00';
          this.payprice = 0;
        }
        if (this.payprice === '0.00') {
          if (!confirm('确认该订单服务费用0元')) {
            this.payment = '';
            this.payprice = 0;
          }
        }
      } catch (e) {
        alert('请输入正确价格');
        this.payment = '0.00';
        this.payprice = 0;
      }
    },
    designate: function designate() {
      var _this3 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq, {
        "account": this.roleid.toString(),
        "role": 'SRVP',
        "needpay": this.needpay,
        "payment": this.payprice
      }, this.header).then(function () {
        alert("指派成功");
        _this3.$router.push({ name: 'RepairOrder', params: { isAdmin: _this3.role === 'ADMIN' } });
      }).catch(function (error) {
        _this3.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    againdesignate: function againdesignate() {
      var _this4 = this;

      if (!this.clean_reason) {
        alert('请说明具体原因');
        return;
      }
      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/reassign', {
        'account': this.roleid.toString(),
        'role': 'SRVP',
        needpay: this.needpay,
        payment: this.payprice,
        reason: this.clean_reason,
        detail: this.clean_detail
      }, this.header).then(function () {
        alert('改派成功');
        _this4.$router.push({ name: 'RepairOrder', params: { isAdmin: _this4.role === 'ADMIN' } });
      });
    },
    designateSrvp: function designateSrvp() {
      var _this5 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/transfer', {
        role: this.role,
        account: this.roleid.toString()
      }, this.header).then(function () {
        alert('指派成功');
        _this5.$router.push({ name: 'RepairOrder', params: { isAdmin: _this5.role === 'ADMIN' } });
      }).catch(function (error) {
        _this5.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    designateEXPT: function designateEXPT() {
      var _this6 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/assign_repair_to_assist', {
        account: this.roleid.toString(),
        role: this.role,
        needpay: !!this.needpay,
        payment: this.payprice
      }, this.header).then(function () {
        alert('指派成功');
        if (_this6.role === 'EXPT') {
          _this6.$router.push({ name: 'records', query: { seq: _this6.seq } });
        } else if (_this6.role === 'SRVP') {
          _this6.$router.push({ name: 'RepairSrvp', query: { seq: _this6.seq, role: _this6.role, type: _this6.type } });
        }
      });
    },
    cancel: function cancel() {
      this.$router.push({ name: 'RepairSrvp', query: { seq: this.seq, role: this.role, type: this.type } });
    },
    cancelExpt: function cancelExpt() {
      this.$router.push({ name: 'records', query: { seq: this.seq } });
    },
    change: function change() {
      var _this7 = this;

      this.roleAccount = [];
      this.$http.get('/api/v1/agencies?company=' + this.name + '&offset=0&count=999&status=APPROVED', this.header).then(function (response) {
        _this7.roleAccount = response.data['list'];
        if (_this7.roleAccount.length === 1) {
          if (_this7.name !== _this7.roleAccount[0].value) {
            _this7.isRole = true;
          }
        } else {
          _this7.isRole = true;
        }
      });
    },
    changeType: function changeType() {
      var _this8 = this;

      this.roleAccount = [];
      if (this.roleType === 'true') {
        this.$http.get('/api/v1/agencies/' + localStorage.getItem('userid') + '/experts?offset=0&count=999&type=added', this.header).then(function (response) {
          _this8.roleAccount = response.data['list'];
          if (_this8.roleAccount.length === 1) {
            if (_this8.name !== _this8.roleAccount[0].value) {
              _this8.isRole = true;
            }
          } else {
            _this8.isRole = true;
          }
        });
      }
    },
    chose: function chose(item) {
      this.roleid = item.userid;
      this.name = this.role === 'ADMIN' ? item.detail.company : item.hasOwnProperty('detail') ? item.detail.name : item.name;
      this.isRole = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/repairs/Desiginate.vue







/* harmony default export */ var repairs_Desiginate = ({
  name: "Desiginate",
  components: { Group: group["a" /* default */], Selector: vux_src_components_selector, XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, XTextarea: vux_src_components_x_textarea },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      isRole: false,
      pay: [{ key: 1, value: '是' }, { key: 0, value: '否' }],
      needpay: 0,
      payment: '',
      payprice: 0,
      roles: [{ key: 'EXPT', value: '专家' }, { key: 'SRVP', value: '服务商' }],
      rolesSrvp: [{ key: 'true', value: '本公司专家' }, { key: 'false', value: '非本公司专家' }],
      rolesExpt: [{ key: 'company', value: '公司' }, { key: 'name', value: '姓名' }],
      roleAccount: [],
      roleType: this.$route.query.roleType || '',
      roleid: '',
      seq: this.$route.query.seq,
      role: this.$route.query.role,
      type: this.$route.query.type,
      again: this.$route.query.again,
      name: '',
      reason: [{ key: 'REJECT', value: '拒绝' }, { key: 'REGRET', value: '反悔' }, {
        key: 'UNQUAL',
        value: '不合格'
      }, { key: 'TIMEOUT', value: '超时' }, { key: 'UCANCLR', value: '用户取消' }],
      clean_reason: '',
      clean_detail: ''
    };
  },

  methods: {
    changeSearchName: function changeSearchName() {
      var _this = this;

      this.$http.get('/api/v1/agencies/' + localStorage.getItem('userid') + '/experts?hint=' + this.name + '&offset=0&count=999&type=added', this.header).then(function (response) {
        _this.roleAccount = response.data['list'];
        if (_this.roleAccount.length === 1) {
          if (_this.name !== _this.roleAccount[0].value) {
            _this.isRole = true;
          }
        } else {
          _this.isRole = true;
        }
      });
    },
    changeSearchType: function changeSearchType() {
      var _this2 = this;

      this.roleAccount = [];
      this.$http.get('/api/v1/experts?name=' + this.name + '&offset=0&count=20&status=AUDITED', this.header).then(function (response) {
        _this2.roleAccount = response.data['list'];
        if (_this2.roleAccount.length === 1) {
          if (_this2.name !== _this2.roleAccount[0].value) {
            _this2.isRole = true;
          }
        } else {
          _this2.isRole = true;
        }
      });
    },
    format: function format(num) {
      return num.toLocaleString('zh', { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false });
    },
    priceChange: function priceChange() {
      try {
        this.payprice = parseFloat(this.payment).toFixed(2);
        this.payment = this.format(parseFloat(this.payment));
        if (isNaN(this.payment)) {
          alert('请输入正确价格');
          this.payment = '0.00';
          this.payprice = 0;
        }
        if (this.payprice === '0.00') {
          if (!confirm('确认该订单服务费用0元')) {
            this.payment = '';
            this.payprice = 0;
          }
        }
      } catch (e) {
        alert('请输入正确价格');
        this.payment = '0.00';
        this.payprice = 0;
      }
    },
    designate: function designate() {
      var _this3 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq, {
        "account": this.roleid.toString(),
        "role": 'SRVP',
        "needpay": this.needpay,
        "payment": this.payprice
      }, this.header).then(function () {
        alert("指派成功");
        _this3.$router.push({ name: 'RepairOrder', params: { isAdmin: _this3.role === 'ADMIN' } });
      }).catch(function (error) {
        _this3.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    againdesignate: function againdesignate() {
      var _this4 = this;

      if (!this.clean_reason) {
        alert('请说明具体原因');
        return;
      }
      this.$http.put('/api/v1/normalrepairs/' + this.seq + '/reassign', {
        'account': this.roleid.toString(),
        'role': 'SRVP',
        needpay: this.needpay,
        payment: this.payprice,
        reason: this.clean_reason,
        detail: this.clean_detail
      }, this.header).then(function () {
        alert('改派成功');
        _this4.$router.push({ name: 'RepairOrder', params: { isAdmin: _this4.role === 'ADMIN' } });
      });
    },
    designateSrvp: function designateSrvp() {
      var _this5 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/transfer', {
        role: this.role,
        account: this.roleid.toString()
      }, this.header).then(function () {
        alert('指派成功');
        _this5.$router.push({ name: 'RepairOrder', params: { isAdmin: _this5.role === 'ADMIN' } });
      }).catch(function (error) {
        _this5.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    designateEXPT: function designateEXPT() {
      var _this6 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/assign_repair_to_assist', {
        account: this.roleid.toString(),
        role: this.role,
        needpay: !!this.needpay,
        payment: this.payprice
      }, this.header).then(function () {
        alert('指派成功');
        if (_this6.role === 'EXPT') {
          _this6.$router.push({ name: 'records', query: { seq: _this6.seq } });
        } else if (_this6.role === 'SRVP') {
          _this6.$router.push({ name: 'RepairSrvp', query: { seq: _this6.seq, role: _this6.role, type: _this6.type } });
        }
      });
    },
    cancel: function cancel() {
      this.$router.push({ name: 'RepairSrvp', query: { seq: this.seq, role: this.role, type: this.type } });
    },
    cancelExpt: function cancelExpt() {
      this.$router.push({ name: 'records', query: { seq: this.seq } });
    },
    change: function change() {
      var _this7 = this;

      this.roleAccount = [];
      this.$http.get('/api/v1/agencies?company=' + this.name + '&offset=0&count=999&status=APPROVED', this.header).then(function (response) {
        _this7.roleAccount = response.data['list'];
        if (_this7.roleAccount.length === 1) {
          if (_this7.name !== _this7.roleAccount[0].value) {
            _this7.isRole = true;
          }
        } else {
          _this7.isRole = true;
        }
      });
    },
    changeType: function changeType() {
      var _this8 = this;

      this.roleAccount = [];
      if (this.roleType === 'true') {
        this.$http.get('/api/v1/agencies/' + localStorage.getItem('userid') + '/experts?offset=0&count=999&type=added', this.header).then(function (response) {
          _this8.roleAccount = response.data['list'];
          if (_this8.roleAccount.length === 1) {
            if (_this8.name !== _this8.roleAccount[0].value) {
              _this8.isRole = true;
            }
          } else {
            _this8.isRole = true;
          }
        });
      }
    },
    chose: function chose(item) {
      this.roleid = item.userid;
      this.name = this.role === 'ADMIN' ? item.detail.company : item.hasOwnProperty('detail') ? item.detail.name : item.name;
      this.isRole = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b2edec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repairs/Desiginate.vue
var Desiginate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',{staticStyle:{"height":"100%"}},[(_vm.role === 'ADMIN')?[(_vm.again)?[_c('selector',{attrs:{"title":"清除原因","options":_vm.reason},model:{value:(_vm.clean_reason),callback:function ($$v) {_vm.clean_reason=$$v},expression:"clean_reason"}}),_vm._v(" "),_c('x-textarea',{attrs:{"rows":1,"cols":10,"title":"具体原因*","max":255,"autosize":"","show-counter":false},model:{value:(_vm.clean_detail),callback:function ($$v) {_vm.clean_detail=$$v},expression:"clean_detail"}})]:_vm._e(),_vm._v(" "),_c('selector',{attrs:{"title":"是否支付服务费用","options":_vm.pay},model:{value:(_vm.needpay),callback:function ($$v) {_vm.needpay=$$v},expression:"needpay"}}),_vm._v(" "),(_vm.needpay)?_c('x-input',{staticClass:"b-input",attrs:{"title":"服务费用","type":"number"},on:{"on-blur":_vm.priceChange},model:{value:(_vm.payment),callback:function ($$v) {_vm.payment=$$v},expression:"payment"}}):_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"服务商名称"},on:{"on-change":_vm.change},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRole),expression:"isRole"}],staticClass:"producer-wrap"},_vm._l((_vm.roleAccount),function(item,index){return _c('p',{key:index,staticClass:"producer-p",on:{"click":function($event){_vm.chose(item)}}},[_vm._v("\n        "+_vm._s(item.detail.company))])})),_vm._v(" "),(_vm.again)?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.againdesignate($event)}}},[_vm._v("确定")]):_vm._e(),_vm._v(" "),(!_vm.again)?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.designate($event)}}},[_vm._v("确定")]):_vm._e(),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v("取消")])]:_vm._e(),_vm._v(" "),(_vm.role === 'SRVP')?[(_vm.roleType === 'true')?[_c('x-input',{attrs:{"title":"专家名称"},on:{"on-change":_vm.changeSearchName},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRole),expression:"isRole"}],staticClass:"producer-wrap"},_vm._l((_vm.roleAccount),function(item,index){return _c('p',{key:index,staticClass:"producer-p",on:{"click":function($event){_vm.chose(item)}}},[_vm._v("\n          "+_vm._s(item.name))])})),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.designateSrvp($event)}}},[_vm._v("确定")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v("取消")])]:_vm._e(),_vm._v(" "),(_vm.roleType === 'false')?[_c('selector',{attrs:{"title":"是否支付服务费用","options":_vm.pay},model:{value:(_vm.needpay),callback:function ($$v) {_vm.needpay=$$v},expression:"needpay"}}),_vm._v(" "),(_vm.needpay)?_c('x-input',{staticClass:"b-input",attrs:{"title":"服务费用","type":"number"},on:{"on-blur":_vm.priceChange},model:{value:(_vm.payment),callback:function ($$v) {_vm.payment=$$v},expression:"payment"}}):_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"专家名称"},on:{"on-change":_vm.changeSearchType},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRole),expression:"isRole"}],staticClass:"producer-wrap"},_vm._l((_vm.roleAccount),function(item,index){return _c('p',{key:index,staticClass:"producer-p",on:{"click":function($event){_vm.chose(item)}}},[_vm._v("\n          "+_vm._s(item.detail.name))])})),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.designateEXPT($event)}}},[_vm._v("确定")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.cancelExpt($event)}}},[_vm._v("取消")])]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.role === 'EXPT')?[_c('selector',{attrs:{"title":"是否支付服务费用","options":_vm.pay},model:{value:(_vm.needpay),callback:function ($$v) {_vm.needpay=$$v},expression:"needpay"}}),_vm._v(" "),(_vm.needpay)?_c('x-input',{staticClass:"b-input",attrs:{"title":"专家费用","type":"number"},on:{"on-blur":_vm.priceChange},model:{value:(_vm.payment),callback:function ($$v) {_vm.payment=$$v},expression:"payment"}}):_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"用户名称"},on:{"on-change":_vm.changeSearchType},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRole),expression:"isRole"}],staticClass:"producer-wrap"},_vm._l((_vm.roleAccount),function(item,index){return _c('p',{key:index,staticClass:"producer-p",on:{"click":function($event){_vm.chose(item)}}},[_vm._v("\n        "+_vm._s(item.detail.name)+"-"+_vm._s(item.detail.company))])})),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.designateEXPT($event)}}},[_vm._v("确定")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.cancelExpt($event)}}},[_vm._v("取消")])]:_vm._e()],2)}
var Desiginate_staticRenderFns = []
var Desiginate_esExports = { render: Desiginate_render, staticRenderFns: Desiginate_staticRenderFns }
/* harmony default export */ var components_repairs_Desiginate = (Desiginate_esExports);
// CONCATENATED MODULE: ./src/components/repairs/Desiginate.vue
function Desiginate_injectStyle (ssrContext) {
  __webpack_require__("ep0X")
}
var Desiginate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Desiginate___vue_template_functional__ = false
/* styles */
var Desiginate___vue_styles__ = Desiginate_injectStyle
/* scopeId */
var Desiginate___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Desiginate___vue_module_identifier__ = null
var Desiginate_Component = Desiginate_normalizeComponent(
  repairs_Desiginate,
  components_repairs_Desiginate,
  Desiginate___vue_template_functional__,
  Desiginate___vue_styles__,
  Desiginate___vue_scopeId__,
  Desiginate___vue_module_identifier__
)

/* harmony default export */ var src_components_repairs_Desiginate = (Desiginate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/Userpay.vue





/* harmony default export */ var Userpay = ({
  name: "Userpay",
  components: { Group: group["a" /* default */], Cell: vux_src_components_cell, XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      payList: [],
      role: this.$route.params.role
    };
  },
  created: function created() {
    this.payList = this.$route.params.info;
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/Userpay.vue





/* harmony default export */ var Pay_Userpay = ({
  name: "Userpay",
  components: { Group: group["a" /* default */], Cell: vux_src_components_cell, XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      payList: [],
      role: this.$route.params.role
    };
  },
  created: function created() {
    this.payList = this.$route.params.info;
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eec52574","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay/Userpay.vue
var Userpay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('x-header',[_vm._v("支付订单")]),_vm._v(" "),_vm._l((_vm.payList),function(item,index){return _c('cell',{key:index,attrs:{"title":item,"is-link":"","link":{name:'Payinfo',query:{seq:item,payList: _vm.payList,role: _vm.role}}}})})],2)}
var Userpay_staticRenderFns = []
var Userpay_esExports = { render: Userpay_render, staticRenderFns: Userpay_staticRenderFns }
/* harmony default export */ var components_Pay_Userpay = (Userpay_esExports);
// CONCATENATED MODULE: ./src/components/Pay/Userpay.vue
function Userpay_injectStyle (ssrContext) {
  __webpack_require__("GyPJ")
}
var Userpay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Userpay___vue_template_functional__ = false
/* styles */
var Userpay___vue_styles__ = Userpay_injectStyle
/* scopeId */
var Userpay___vue_scopeId__ = "data-v-eec52574"
/* moduleIdentifier (server only) */
var Userpay___vue_module_identifier__ = null
var Userpay_Component = Userpay_normalizeComponent(
  Pay_Userpay,
  components_Pay_Userpay,
  Userpay___vue_template_functional__,
  Userpay___vue_styles__,
  Userpay___vue_scopeId__,
  Userpay___vue_module_identifier__
)

/* harmony default export */ var src_components_Pay_Userpay = (Userpay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/Payinfo.vue








/* harmony default export */ var Payinfo = ({
  name: "Payinfo",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Confirm: components_confirm["a" /* default */], XTextarea: vux_src_components_x_textarea },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      opid: localStorage.getItem('userid'),
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      seq: this.$route.query.seq,
      payInfo: {},
      rejectshow: false,
      reject_advice: '',
      role: this.$route.query.role,
      payList: this.$route.query.payList
    };
  },

  methods: {
    payForAnother: function payForAnother() {
      var _this = this;

      this.$http.get("/api/v1/users/" + this.opid, this.header).then(function (response) {
        var company = response.data.detail.company;
        _this.$http.get('/api/v1/companies?company=' + company + '&offset=0&count=1&status=AUDITED').then(function (response) {
          if (response.data['list'].length === 0) {
            alert('未找到所属单位');
          } else {
            _this.$http.post('/api/v1/payments/' + _this.opid + '/orders/' + _this.seq + '/ask_other_pay_repair', {
              role: 'INDV',
              other_id: response.data['list'][0].userid.toString(),
              other_type: 'ENTP'
            }, _this.header).then(function (response) {
              _this.$vux.toast.show({
                text: '已转给该用户',
                type: 'success',
                time: '1000'
              });
            }).catch(function (err) {
              _this.$vux.toast.show({
                text: JSON.parse(err.response.data.error_message).zh_string,
                type: 'cancel',
                time: '1000'
              });
            });
          }
        }).catch(function (err) {
          _this.$vux.toast.show({
            text: JSON.parse(err.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      }).catch(function (err) {
        _this.$vux.toast.show({
          text: JSON.parse(err.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    rejectResult: function rejectResult(seq) {
      var _this2 = this;

      this.$http.post("/api/v1/payments/" + this.opid + "/orders/" + seq + "/user_reject_pay_repair", {
        role: 'INDV',
        reason: this.reject_advice
      }, this.header).then(function () {
        _this2.rejectshow = false;
        _this2.reload();
      }).catch(function (err) {
        _this2.$vux.toast.show({
          text: JSON.parse(err.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    reload: function reload() {
      var _this3 = this;

      this.$http.get('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/get_repair_wait_user_to_pay?role=INDV', this.header).then(function (response) {
        _this3.payInfo = response.data;
        _this3.payInfo.sbst = _this3.payInfo.sbst ? '是' : '否';
        switch (_this3.payInfo.state) {
          case 'WAIT':
            _this3.payInfo.state = '待支付';
            break;
          case 'SUCCESS':
            _this3.payInfo.state = '支付成功';
            break;
          case 'REJECT':
            _this3.payInfo.state = '拒绝支付';
            break;
          case 'FAIL':
            _this3.payInfo.state = '支付失败';
            break;
          case 'MAN_CONF':
            _this3.payInfo.state = '等待人工确认';
            break;
          case 'BG_CONF':
            _this3.payInfo.state = '等待后台确认';
            break;
        }
        switch (_this3.payInfo.pconfirm) {
          case 'WAIT':
            _this3.payInfo.pconfirm = '待确认';
            break;
          case 'CONFIRMED':
            _this3.payInfo.pconfirm = '已确认';
            break;
          case 'REJECT':
            _this3.payInfo.pconfirm = '拒绝';
            break;
        }
        switch (_this3.payInfo.sconfirm) {
          case 'WAIT':
            _this3.payInfo.sconfirm = '待确认';
            break;
          case 'CONFIRMED':
            _this3.payInfo.sconfirm = '已确认';
            break;
          case 'REJECT':
            _this3.payInfo.sconfirm = '拒绝';
            break;
        }
        switch (_this3.payInfo.method) {
          case 'CHANGE':
            _this3.payInfo.method = '零钱';
            break;
          case 'WX':
            _this3.payInfo.method = '微信';
            break;
          case 'BANK':
            _this3.payInfo.method = '线下转账';
            break;
        }
      }).catch(function (err) {
        _this3.$vux.toast.show({
          text: JSON.parse(err.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  created: function created() {
    this.reload();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'Userpay') {
      to.params.role = this.role;
      to.params.info = this.payList;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/Payinfo.vue








/* harmony default export */ var Pay_Payinfo = ({
  name: "Payinfo",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Confirm: components_confirm["a" /* default */], XTextarea: vux_src_components_x_textarea },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      opid: localStorage.getItem('userid'),
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      seq: this.$route.query.seq,
      payInfo: {},
      rejectshow: false,
      reject_advice: '',
      role: this.$route.query.role,
      payList: this.$route.query.payList
    };
  },

  methods: {
    payForAnother: function payForAnother() {
      var _this = this;

      this.$http.get("/api/v1/users/" + this.opid, this.header).then(function (response) {
        var company = response.data.detail.company;
        _this.$http.get('/api/v1/companies?company=' + company + '&offset=0&count=1&status=AUDITED').then(function (response) {
          if (response.data['list'].length === 0) {
            alert('未找到所属单位');
          } else {
            _this.$http.post('/api/v1/payments/' + _this.opid + '/orders/' + _this.seq + '/ask_other_pay_repair', {
              role: 'INDV',
              other_id: response.data['list'][0].userid.toString(),
              other_type: 'ENTP'
            }, _this.header).then(function (response) {
              _this.$vux.toast.show({
                text: '已转给该用户',
                type: 'success',
                time: '1000'
              });
            }).catch(function (err) {
              _this.$vux.toast.show({
                text: JSON.parse(err.response.data.error_message).zh_string,
                type: 'cancel',
                time: '1000'
              });
            });
          }
        }).catch(function (err) {
          _this.$vux.toast.show({
            text: JSON.parse(err.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      }).catch(function (err) {
        _this.$vux.toast.show({
          text: JSON.parse(err.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    rejectResult: function rejectResult(seq) {
      var _this2 = this;

      this.$http.post("/api/v1/payments/" + this.opid + "/orders/" + seq + "/user_reject_pay_repair", {
        role: 'INDV',
        reason: this.reject_advice
      }, this.header).then(function () {
        _this2.rejectshow = false;
        _this2.reload();
      }).catch(function (err) {
        _this2.$vux.toast.show({
          text: JSON.parse(err.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    reload: function reload() {
      var _this3 = this;

      this.$http.get('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/get_repair_wait_user_to_pay?role=INDV', this.header).then(function (response) {
        _this3.payInfo = response.data;
        _this3.payInfo.sbst = _this3.payInfo.sbst ? '是' : '否';
        switch (_this3.payInfo.state) {
          case 'WAIT':
            _this3.payInfo.state = '待支付';
            break;
          case 'SUCCESS':
            _this3.payInfo.state = '支付成功';
            break;
          case 'REJECT':
            _this3.payInfo.state = '拒绝支付';
            break;
          case 'FAIL':
            _this3.payInfo.state = '支付失败';
            break;
          case 'MAN_CONF':
            _this3.payInfo.state = '等待人工确认';
            break;
          case 'BG_CONF':
            _this3.payInfo.state = '等待后台确认';
            break;
        }
        switch (_this3.payInfo.pconfirm) {
          case 'WAIT':
            _this3.payInfo.pconfirm = '待确认';
            break;
          case 'CONFIRMED':
            _this3.payInfo.pconfirm = '已确认';
            break;
          case 'REJECT':
            _this3.payInfo.pconfirm = '拒绝';
            break;
        }
        switch (_this3.payInfo.sconfirm) {
          case 'WAIT':
            _this3.payInfo.sconfirm = '待确认';
            break;
          case 'CONFIRMED':
            _this3.payInfo.sconfirm = '已确认';
            break;
          case 'REJECT':
            _this3.payInfo.sconfirm = '拒绝';
            break;
        }
        switch (_this3.payInfo.method) {
          case 'CHANGE':
            _this3.payInfo.method = '零钱';
            break;
          case 'WX':
            _this3.payInfo.method = '微信';
            break;
          case 'BANK':
            _this3.payInfo.method = '线下转账';
            break;
        }
      }).catch(function (err) {
        _this3.$vux.toast.show({
          text: JSON.parse(err.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  created: function created() {
    this.reload();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'Userpay') {
      to.params.role = this.role;
      to.params.info = this.payList;
    }
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4cc1966","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay/Payinfo.vue
var Payinfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"订单编号","readonly":""},model:{value:(_vm.payInfo.seq),callback:function ($$v) {_vm.$set(_vm.payInfo, "seq", $$v)},expression:"payInfo.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"线下转账公司","readonly":""},model:{value:(_vm.payInfo.company),callback:function ($$v) {_vm.$set(_vm.payInfo, "company", $$v)},expression:"payInfo.company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"线下转账账户","readonly":""},model:{value:(_vm.payInfo.bank),callback:function ($$v) {_vm.$set(_vm.payInfo, "bank", $$v)},expression:"payInfo.bank"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"线下转账开户行","readonly":""},model:{value:(_vm.payInfo.baccount),callback:function ($$v) {_vm.$set(_vm.payInfo, "baccount", $$v)},expression:"payInfo.baccount"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"支付金额","readonly":""},model:{value:(_vm.payInfo.amount),callback:function ($$v) {_vm.$set(_vm.payInfo, "amount", $$v)},expression:"payInfo.amount"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"订单状态","readonly":""},model:{value:(_vm.payInfo.state),callback:function ($$v) {_vm.$set(_vm.payInfo, "state", $$v)},expression:"payInfo.state"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"订单创建时间","readonly":""},model:{value:(_vm.payInfo.ctime),callback:function ($$v) {_vm.$set(_vm.payInfo, "ctime", $$v)},expression:"payInfo.ctime"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"支付人名称","readonly":""},model:{value:(_vm.payInfo.payname),callback:function ($$v) {_vm.$set(_vm.payInfo, "payname", $$v)},expression:"payInfo.payname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"支付人确认状态","readonly":""},model:{value:(_vm.payInfo.pconfirm),callback:function ($$v) {_vm.$set(_vm.payInfo, "pconfirm", $$v)},expression:"payInfo.pconfirm"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"支付人确认意见","readonly":""},model:{value:(_vm.payInfo.padvice),callback:function ($$v) {_vm.$set(_vm.payInfo, "padvice", $$v)},expression:"payInfo.padvice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"支付人确认时间","readonly":""},model:{value:(_vm.payInfo.ptime),callback:function ($$v) {_vm.$set(_vm.payInfo, "ptime", $$v)},expression:"payInfo.ptime"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"是否申请代支付","readonly":""},model:{value:(_vm.payInfo.sbst),callback:function ($$v) {_vm.$set(_vm.payInfo, "sbst", $$v)},expression:"payInfo.sbst"}}),_vm._v(" "),(_vm.payInfo.sbst === '是')?_c('x-input',{attrs:{"title":"代支付人名称","readonly":""},model:{value:(_vm.payInfo.sbstname),callback:function ($$v) {_vm.$set(_vm.payInfo, "sbstname", $$v)},expression:"payInfo.sbstname"}}):_vm._e(),_vm._v(" "),(_vm.payInfo.sbst === '是')?_c('x-input',{attrs:{"title":"代支付人确认状态","readonly":""},model:{value:(_vm.payInfo.sconfirm),callback:function ($$v) {_vm.$set(_vm.payInfo, "sconfirm", $$v)},expression:"payInfo.sconfirm"}}):_vm._e(),_vm._v(" "),(_vm.payInfo.sbst === '是')?_c('x-input',{attrs:{"title":"代支付人确认意见","readonly":""},model:{value:(_vm.payInfo.sadvice),callback:function ($$v) {_vm.$set(_vm.payInfo, "sadvice", $$v)},expression:"payInfo.sadvice"}}):_vm._e(),_vm._v(" "),(_vm.payInfo.sbst === '是')?_c('x-input',{attrs:{"title":"代支付人确认时间","readonly":""},model:{value:(_vm.payInfo.stime),callback:function ($$v) {_vm.$set(_vm.payInfo, "stime", $$v)},expression:"payInfo.stime"}}):_vm._e(),_vm._v(" "),_c('x-input',{attrs:{"title":"支付方式","readonly":""},model:{value:(_vm.payInfo.method),callback:function ($$v) {_vm.$set(_vm.payInfo, "method", $$v)},expression:"payInfo.method"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"发起支付请求账户名称","readonly":""},model:{value:(_vm.payInfo.startname),callback:function ($$v) {_vm.$set(_vm.payInfo, "startname", $$v)},expression:"payInfo.startname"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"支出方交易订单编号","readonly":""},model:{value:(_vm.payInfo.srcrecord),callback:function ($$v) {_vm.$set(_vm.payInfo, "srcrecord", $$v)},expression:"payInfo.srcrecord"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"收入方交易订单编号","readonly":""},model:{value:(_vm.payInfo.tgtrecord),callback:function ($$v) {_vm.$set(_vm.payInfo, "tgtrecord", $$v)},expression:"payInfo.tgtrecord"}}),_vm._v(" "),(_vm.role !== 'ADMIN' && _vm.role !== 'SRVP')?[(_vm.payInfo.state === '待支付' && _vm.payInfo.sbst === '否')?_c('x-button',{attrs:{"type":"primary","link":{path:'/Pay',query:{seq:_vm.payInfo.seq}}}},[_vm._v("支付费用\n      ")]):_vm._e(),_vm._v(" "),(_vm.payInfo.state === '待支付'&& _vm.payInfo.sbst === '否')?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.payForAnother($event)}}},[_vm._v("\n        好友代付\n      ")]):_vm._e(),_vm._v(" "),(_vm.payInfo.state === '待支付'&& _vm.payInfo.sbst === '否')?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.rejectshow = true}}},[_vm._v("拒绝支付\n      ")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{staticStyle:{"color":"#000"},attrs:{"title":"拒绝支付"},on:{"on-cancel":function($event){_vm.rejectshow = false},"on-confirm":function($event){_vm.rejectResult(_vm.payInfo.seq)}},model:{value:(_vm.rejectshow),callback:function ($$v) {_vm.rejectshow=$$v},expression:"rejectshow"}},[_c('group',[_c('x-textarea',{staticClass:"white-textarea",attrs:{"rows":1,"cols":10,"title":"拒绝原因","max":60,"autosize":"","show-counter":false},model:{value:(_vm.reject_advice),callback:function ($$v) {_vm.reject_advice=$$v},expression:"reject_advice"}})],1)],1)],1)],1)}
var Payinfo_staticRenderFns = []
var Payinfo_esExports = { render: Payinfo_render, staticRenderFns: Payinfo_staticRenderFns }
/* harmony default export */ var components_Pay_Payinfo = (Payinfo_esExports);
// CONCATENATED MODULE: ./src/components/Pay/Payinfo.vue
function Payinfo_injectStyle (ssrContext) {
  __webpack_require__("yQe0")
}
var Payinfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Payinfo___vue_template_functional__ = false
/* styles */
var Payinfo___vue_styles__ = Payinfo_injectStyle
/* scopeId */
var Payinfo___vue_scopeId__ = "data-v-a4cc1966"
/* moduleIdentifier (server only) */
var Payinfo___vue_module_identifier__ = null
var Payinfo_Component = Payinfo_normalizeComponent(
  Pay_Payinfo,
  components_Pay_Payinfo,
  Payinfo___vue_template_functional__,
  Payinfo___vue_styles__,
  Payinfo___vue_scopeId__,
  Payinfo___vue_module_identifier__
)

/* harmony default export */ var src_components_Pay_Payinfo = (Payinfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _cellProps = Object(props["a" /* default */])();
delete _cellProps.value;

/* harmony default export */ var popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, Object(radio_props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var popup_radio__cellProps = Object(props["a" /* default */])();
delete popup_radio__cellProps.value;

/* harmony default export */ var components_popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, popup_radio__cellProps, Object(radio_props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e4c581","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-radio/index.vue
var popup_radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{attrs:{"title":_vm.title,"value":_vm.currentValue,"is-link":!_vm.readonly,"value-align":_vm.valueAlign,"border-intent":_vm.borderIntent},nativeOn:{"click":function($event){return _vm.show($event)}}},[(!_vm.displayValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.displayValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayValue))]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticStyle:{"background-color":"#fff"},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_vm._t("popup-header",null,{options:_vm.options,value:_vm.currentValue}),_vm._v(" "),_c('radio',{attrs:{"options":_vm.options,"fill-mode":false},on:{"on-change":_vm.onValueChange},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(props.icon),expression:"props.icon"}],staticClass:"vux-radio-icon",attrs:{"src":props.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label"},[_vm._v(_vm._s(props.label))])])],{icon:props.icon,label:props.label,index:props.index})]}}]),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)])}
var popup_radio_staticRenderFns = []
var popup_radio_esExports = { render: popup_radio_render, staticRenderFns: popup_radio_staticRenderFns }
/* harmony default export */ var src_components_popup_radio = (popup_radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-radio/index.vue
function popup_radio_injectStyle (ssrContext) {
  __webpack_require__("SREC")
}
var popup_radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_radio___vue_template_functional__ = false
/* styles */
var popup_radio___vue_styles__ = popup_radio_injectStyle
/* scopeId */
var popup_radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_radio___vue_module_identifier__ = null
var popup_radio_Component = popup_radio_normalizeComponent(
  components_popup_radio,
  src_components_popup_radio,
  popup_radio___vue_template_functional__,
  popup_radio___vue_styles__,
  popup_radio___vue_scopeId__,
  popup_radio___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_radio = (popup_radio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/Pay.vue












/* harmony default export */ var Pay = ({
  name: "Pay",
  components: { Group: group["a" /* default */], XButton: vux_src_components_x_button, PopupRadio: vux_src_components_popup_radio, CheckIcon: vux_src_components_check_icon, Checker: src_components_checker_checker, CheckerItem: src_components_checker_checker_item, XInput: vux_src_components_x_input },
  data: function data() {
    return {
      paymethod: ['微信支付', '零钱支付', '线下支付'],
      method: '微信支付',
      opid: localStorage.getItem('userid'),
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      seq: this.$route.query.seq,
      issue: false,
      img: '/static/img/bill.png',
      bill: '',
      invoiceTitle: '',
      invoiceType: '',
      invoice: {
        content: {
          company: '',
          taxNumber: '',
          bank: '',
          bankAccount: '',
          address: '',
          tel: ''
        },
        type: ''
      }
    };
  },

  methods: {
    pay: function pay() {
      var _this = this;

      switch (this.method) {
        case '微信支付':
          if (this.issue) {
            if (this.invoiceTitle === 2) {
              if (this.invoice.content.company === '' || this.invoice.content.taxNumber === '') {
                this.$vux.alert.show({
                  title: '',
                  content: '请补全发票信息后再提交'
                });
                return;
              }
            }
            if (this.invoiceType === 2) {
              if (this.invoice.content.bank === '' || this.invoice.content.bankAccount === '' || this.invoice.content.address === '' || this.invoice.content.tel === '') {
                this.$vux.alert.show({
                  title: '',
                  content: '请补全发票信息后再提交'
                });
                return;
              }
            }
            if (this.invoiceType === 1) {
              this.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit';
            } else {
              this.invoice.type = 'VatSpecialInvoice';
            }
          }
          this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/user_pay_repair_by_wx', {
            role: 'INDV',
            issue: this.issue ? 'True' : 'False',
            openid: localStorage.getItem('openid'),
            user_ip: '127.0.0.1',
            invoice_detail: this.issue ? this.invoice : null
          }, this.header).then(function (response) {
            weixin_js_sdk_default.a.chooseWXPay({
              timestamp: response.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: response.data.nonceStr, // 支付签名随机串，不长于 32 位
              package: response.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: response.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: response.data.paySign, // 支付签名
              success: function success(res) {
                console.log(res);
                _this.$router.push({ name: 'Payinfo', query: { seq: _this.seq, role: 'INDV' } });
              },
              fail: function fail(err) {
                console.log(err);
              }
            });
          }).catch(function (err) {
            _this.$vux.toast.show({
              text: JSON.parse(err.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
          break;
        case '零钱支付':
          this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/user_pay_repair_by_change', {
            role: 'INDV'
          }, this.header).then(function () {
            _this.$vux.toast.show({
              text: '交易成功',
              type: 'success',
              time: '1000'
            });
            _this.$router.push({ name: 'Payinfo', query: { seq: _this.seq, role: 'INDV' } });
          }).catch(function (err) {
            _this.$vux.toast.show({
              text: JSON.parse(err.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
          break;
        case '线下支付':
          if (this.issue) {
            if (this.invoiceTitle === 2) {
              if (this.invoice.content.company === '' || this.invoice.content.taxNumber === '') {
                this.$vux.alert.show({
                  title: '',
                  content: '请补全发票信息后再提交'
                });
                return;
              }
            }
            if (this.invoiceType === 2) {
              if (this.invoice.content.bank === '' || this.invoice.content.bankAccount === '' || this.invoice.content.address === '' || this.invoice.content.tel === '') {
                this.$vux.alert.show({
                  title: '',
                  content: '请补全发票信息后再提交'
                });
                return;
              }
            }
            if (this.invoiceType === 1) {
              this.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit';
            } else {
              this.invoice.type = 'VatSpecialInvoice';
            }
          }

          this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/user_pay_repair_by_bank', {
            role: 'INDV',
            issue: this.issue ? 'True' : 'False',
            invoice_detail: this.issue ? this.invoice : null,
            bill_photo: this.bill
          }, this.header).then(function () {
            _this.$vux.toast.show({
              text: '交易成功',
              type: 'success',
              time: '1000'
            });
            _this.$router.push({ name: 'Payinfo', query: { seq: _this.seq, role: 'INDV' } });
          }).catch(function (err) {
            _this.$vux.toast.show({
              text: JSON.parse(err.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
          break;
      }
    },
    upload: function upload() {
      var _this2 = this;

      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          _this2.img = localIds[0];
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                _this2.img = res.localData;
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              var serverId = res.serverId;
              _this2.$http.get('/api/v1/payments/' + _this2.opid + '/orders?type=bill&serverid=' + serverId, _this2.header).then(function (response) {
                _this2.bill = response.data[0];
              }).catch(function (error) {
                alert('服务器错误，请稍后重试');
                if (error.response) {
                  console.log(error.response.data);
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
              });
            }
          }), 100);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this3;
      _this3.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.fullPath;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/Pay.vue












/* harmony default export */ var Pay_Pay = ({
  name: "Pay",
  components: { Group: group["a" /* default */], XButton: vux_src_components_x_button, PopupRadio: vux_src_components_popup_radio, CheckIcon: vux_src_components_check_icon, Checker: src_components_checker_checker, CheckerItem: src_components_checker_checker_item, XInput: vux_src_components_x_input },
  data: function data() {
    return {
      paymethod: ['微信支付', '零钱支付', '线下支付'],
      method: '微信支付',
      opid: localStorage.getItem('userid'),
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      seq: this.$route.query.seq,
      issue: false,
      img: '/static/img/bill.png',
      bill: '',
      invoiceTitle: '',
      invoiceType: '',
      invoice: {
        content: {
          company: '',
          taxNumber: '',
          bank: '',
          bankAccount: '',
          address: '',
          tel: ''
        },
        type: ''
      }
    };
  },

  methods: {
    pay: function pay() {
      var _this = this;

      switch (this.method) {
        case '微信支付':
          if (this.issue) {
            if (this.invoiceTitle === 2) {
              if (this.invoice.content.company === '' || this.invoice.content.taxNumber === '') {
                this.$vux.alert.show({
                  title: '',
                  content: '请补全发票信息后再提交'
                });
                return;
              }
            }
            if (this.invoiceType === 2) {
              if (this.invoice.content.bank === '' || this.invoice.content.bankAccount === '' || this.invoice.content.address === '' || this.invoice.content.tel === '') {
                this.$vux.alert.show({
                  title: '',
                  content: '请补全发票信息后再提交'
                });
                return;
              }
            }
            if (this.invoiceType === 1) {
              this.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit';
            } else {
              this.invoice.type = 'VatSpecialInvoice';
            }
          }
          this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/user_pay_repair_by_wx', {
            role: 'INDV',
            issue: this.issue ? 'True' : 'False',
            openid: localStorage.getItem('openid'),
            user_ip: '127.0.0.1',
            invoice_detail: this.issue ? this.invoice : null
          }, this.header).then(function (response) {
            weixin_js_sdk_default.a.chooseWXPay({
              timestamp: response.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: response.data.nonceStr, // 支付签名随机串，不长于 32 位
              package: response.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: response.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: response.data.paySign, // 支付签名
              success: function success(res) {
                console.log(res);
                _this.$router.push({ name: 'Payinfo', query: { seq: _this.seq, role: 'INDV' } });
              },
              fail: function fail(err) {
                console.log(err);
              }
            });
          }).catch(function (err) {
            _this.$vux.toast.show({
              text: JSON.parse(err.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
          break;
        case '零钱支付':
          this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/user_pay_repair_by_change', {
            role: 'INDV'
          }, this.header).then(function () {
            _this.$vux.toast.show({
              text: '交易成功',
              type: 'success',
              time: '1000'
            });
            _this.$router.push({ name: 'Payinfo', query: { seq: _this.seq, role: 'INDV' } });
          }).catch(function (err) {
            _this.$vux.toast.show({
              text: JSON.parse(err.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
          break;
        case '线下支付':
          if (this.issue) {
            if (this.invoiceTitle === 2) {
              if (this.invoice.content.company === '' || this.invoice.content.taxNumber === '') {
                this.$vux.alert.show({
                  title: '',
                  content: '请补全发票信息后再提交'
                });
                return;
              }
            }
            if (this.invoiceType === 2) {
              if (this.invoice.content.bank === '' || this.invoice.content.bankAccount === '' || this.invoice.content.address === '' || this.invoice.content.tel === '') {
                this.$vux.alert.show({
                  title: '',
                  content: '请补全发票信息后再提交'
                });
                return;
              }
            }
            if (this.invoiceType === 1) {
              this.invoice.type = this.invoiceTitle === 1 ? 'ValueAddedTaxInvoiceOne' : 'ValueAddedTaxInvoiceUnit';
            } else {
              this.invoice.type = 'VatSpecialInvoice';
            }
          }

          this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/user_pay_repair_by_bank', {
            role: 'INDV',
            issue: this.issue ? 'True' : 'False',
            invoice_detail: this.issue ? this.invoice : null,
            bill_photo: this.bill
          }, this.header).then(function () {
            _this.$vux.toast.show({
              text: '交易成功',
              type: 'success',
              time: '1000'
            });
            _this.$router.push({ name: 'Payinfo', query: { seq: _this.seq, role: 'INDV' } });
          }).catch(function (err) {
            _this.$vux.toast.show({
              text: JSON.parse(err.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
          break;
      }
    },
    upload: function upload() {
      var _this2 = this;

      weixin_js_sdk_default.a.chooseImage({
        count: 1, // 默认9
        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function success(res) {
          var localIds = res.localIds;
          _this2.img = localIds[0];
          if (window.__wxjs_is_wkwebview) {
            weixin_js_sdk_default.a.getLocalImgData({
              localId: localIds[0],
              success: function success(res) {
                _this2.img = res.localData;
              }
            });
          }
          setTimeout(weixin_js_sdk_default.a.uploadImage({
            localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function success(res) {
              var serverId = res.serverId;
              _this2.$http.get('/api/v1/payments/' + _this2.opid + '/orders?type=bill&serverid=' + serverId, _this2.header).then(function (response) {
                _this2.bill = response.data[0];
              }).catch(function (error) {
                alert('服务器错误，请稍后重试');
                if (error.response) {
                  console.log(error.response.data);
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
              });
            }
          }), 100);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      var app = _this3;
      _this3.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        if (isiOS) {
          url = config.host + src_components_global.entryUrl;
        } else {
          url = config.host + app.$route.fullPath;
        }
        var noncestr = Math.random().toString(36).substr(2);
        app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi']
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b70ef4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay/Pay.vue
var Pay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('popup-radio',{attrs:{"title":"支付方式","options":_vm.paymethod},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"color":"#000"}},[_vm._v(_vm._s(props.label))])]}}]),model:{value:(_vm.method),callback:function ($$v) {_vm.method=$$v},expression:"method"}}),_vm._v(" "),(_vm.method === '线下支付')?_c('div',[_c('div',{staticClass:"img_wrap"},[_c('img',{staticStyle:{"max-height":"200px"},attrs:{"src":_vm.img,"alt":""},on:{"click":_vm.upload}})])]):_vm._e(),_vm._v(" "),(_vm.method !=='零钱支付' )?_c('div',{staticClass:"invocie_wrap"},[_c('check-icon',{attrs:{"value":_vm.issue,"type":"plain"},on:{"update:value":function($event){_vm.issue=$event}}},[_vm._v("开具发票")])],1):_vm._e(),_vm._v(" "),(_vm.issue)?_c('div',[_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("发票类型")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"type-check-item","selected-item-class":"check-item-selected","radio-required":""},model:{value:(_vm.invoiceType),callback:function ($$v) {_vm.invoiceType=$$v},expression:"invoiceType"}},[_c('checker-item',{attrs:{"value":1}},[_vm._v("增值税普通发票")]),_vm._v(" "),_c('checker-item',{attrs:{"value":2}},[_vm._v("增值税专用发票")])],1),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("发票抬头")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"title-check-item","selected-item-class":"check-item-selected","radio-required":""},model:{value:(_vm.invoiceTitle),callback:function ($$v) {_vm.invoiceTitle=$$v},expression:"invoiceTitle"}},[(_vm.invoiceType === 1)?_c('checker-item',{attrs:{"value":1}},[_vm._v("个人")]):_vm._e(),_vm._v(" "),_c('checker-item',{attrs:{"value":2}},[_vm._v("单位")])],1),_vm._v(" "),(_vm.invoiceTitle === 2)?_c('group',[_c('x-input',{attrs:{"title":"单位名称","type":"text"},model:{value:(_vm.invoice.content.company),callback:function ($$v) {_vm.$set(_vm.invoice.content, "company", $$v)},expression:"invoice.content.company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"纳税人识别号","type":"text"},model:{value:(_vm.invoice.content.taxNumber),callback:function ($$v) {_vm.$set(_vm.invoice.content, "taxNumber", $$v)},expression:"invoice.content.taxNumber"}}),_vm._v(" "),(_vm.invoiceType === 2)?_c('x-input',{attrs:{"title":"开户银行","type":"text"},model:{value:(_vm.invoice.content.bank),callback:function ($$v) {_vm.$set(_vm.invoice.content, "bank", $$v)},expression:"invoice.content.bank"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType === 2)?_c('x-input',{attrs:{"title":"账号","type":"number"},model:{value:(_vm.invoice.content.bankAccount),callback:function ($$v) {_vm.$set(_vm.invoice.content, "bankAccount", $$v)},expression:"invoice.content.bankAccount"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType === 2)?_c('x-input',{attrs:{"title":"地址","type":"text"},model:{value:(_vm.invoice.content.address),callback:function ($$v) {_vm.$set(_vm.invoice.content, "address", $$v)},expression:"invoice.content.address"}}):_vm._e(),_vm._v(" "),(_vm.invoiceType === 2)?_c('x-input',{attrs:{"title":"电话","type":"tel"},model:{value:(_vm.invoice.content.tel),callback:function ($$v) {_vm.$set(_vm.invoice.content, "tel", $$v)},expression:"invoice.content.tel"}}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.pay($event)}}},[_vm._v("确定支付")])],1)}
var Pay_staticRenderFns = []
var Pay_esExports = { render: Pay_render, staticRenderFns: Pay_staticRenderFns }
/* harmony default export */ var components_Pay_Pay = (Pay_esExports);
// CONCATENATED MODULE: ./src/components/Pay/Pay.vue
function Pay_injectStyle (ssrContext) {
  __webpack_require__("NMAk")
}
var Pay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Pay___vue_template_functional__ = false
/* styles */
var Pay___vue_styles__ = Pay_injectStyle
/* scopeId */
var Pay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Pay___vue_module_identifier__ = null
var Pay_Component = Pay_normalizeComponent(
  Pay_Pay,
  components_Pay_Pay,
  Pay___vue_template_functional__,
  Pay___vue_styles__,
  Pay___vue_scopeId__,
  Pay___vue_module_identifier__
)

/* harmony default export */ var src_components_Pay_Pay = (Pay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/needpay.vue






/* harmony default export */ var needpay = ({
  name: "needpay",
  components: { Cell: vux_src_components_cell, Group: group["a" /* default */], Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      opid: localStorage.getItem('userid'),
      payList: []
    };
  },

  methods: {
    needpay: function needpay() {
      var _this = this;

      this.$http.get('/api/v1/payments/' + this.opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=0&count=10', this.header).then(function (response) {
        console.log(response.data);
        _this.payList = response.data.content;
      });
    },
    yetpay: function yetpay() {
      var _this2 = this;

      this.$http.get('/api/v1/payments/' + this.opid + '/orders/user_list_repair_to_pay?role=INDV&payed=true&offset=0&count=10', this.header).then(function (response) {
        console.log(response.data);
        _this2.payList = response.data.content;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('/api/v1/payments/' + this.opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=0&count=10', this.header).then(function (response) {
      console.log(response.data);
      _this3.payList = response.data.content;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/needpay.vue






/* harmony default export */ var Pay_needpay = ({
  name: "needpay",
  components: { Cell: vux_src_components_cell, Group: group["a" /* default */], Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      opid: localStorage.getItem('userid'),
      payList: []
    };
  },

  methods: {
    needpay: function needpay() {
      var _this = this;

      this.$http.get('/api/v1/payments/' + this.opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=0&count=10', this.header).then(function (response) {
        console.log(response.data);
        _this.payList = response.data.content;
      });
    },
    yetpay: function yetpay() {
      var _this2 = this;

      this.$http.get('/api/v1/payments/' + this.opid + '/orders/user_list_repair_to_pay?role=INDV&payed=true&offset=0&count=10', this.header).then(function (response) {
        console.log(response.data);
        _this2.payList = response.data.content;
      });
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.get('/api/v1/payments/' + this.opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=0&count=10', this.header).then(function (response) {
      console.log(response.data);
      _this3.payList = response.data.content;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3689712","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay/needpay.vue
var needpay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tab',[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.needpay}},[_vm._v("待支付")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.yetpay}},[_vm._v("已支付")])],1),_vm._v(" "),_c('group',_vm._l((_vm.payList),function(item,index){return _c('cell',{key:index,attrs:{"is-link":"","title":item.seq,"link":{ name: 'Payinfo',query:{seq:item.seq,role:'INDV'}}}})}))],1)}
var needpay_staticRenderFns = []
var needpay_esExports = { render: needpay_render, staticRenderFns: needpay_staticRenderFns }
/* harmony default export */ var components_Pay_needpay = (needpay_esExports);
// CONCATENATED MODULE: ./src/components/Pay/needpay.vue
function needpay_injectStyle (ssrContext) {
  __webpack_require__("y3o/")
}
var needpay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var needpay___vue_template_functional__ = false
/* styles */
var needpay___vue_styles__ = needpay_injectStyle
/* scopeId */
var needpay___vue_scopeId__ = "data-v-e3689712"
/* moduleIdentifier (server only) */
var needpay___vue_module_identifier__ = null
var needpay_Component = needpay_normalizeComponent(
  Pay_needpay,
  components_Pay_needpay,
  needpay___vue_template_functional__,
  needpay___vue_styles__,
  needpay___vue_scopeId__,
  needpay___vue_module_identifier__
)

/* harmony default export */ var src_components_Pay_needpay = (needpay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/Askpay.vue






/* harmony default export */ var Askpay = ({
  name: "Askpay",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      payInfo: {
        amount: '',
        company: '',
        baccount: '',
        bank: ''
      },
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      seq: this.$route.params.seq,
      role: this.$route.params.role,
      type: this.$route.params.type
    };
  },

  methods: {
    confirmPay: function confirmPay() {
      var _this = this;

      if (!this.payInfo.amount || !this.payInfo.baccount || !this.payInfo.bank || !this.payInfo.company) {
        alert('请填写信息');
        return;
      }
      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/ask_user_pay_repair', extends_default()({ role: this.role }, this.payInfo), this.header).then(function () {
        alert('请求成功');
        _this.$router.push({ name: 'RepairSrvp', query: { seq: _this.seq, role: _this.role, type: _this.type } });
      }).catch(function (err) {
        _this.$vux.toast.show({
          text: JSON.parse(err.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    cancelPay: function cancelPay() {
      this.$router.push({ name: 'RepairSrvp', query: { seq: this.seq, role: this.role, type: this.type } });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('/api/v1/payments/' + localStorage.getItem('userid') + '/orders/get_latest_repair_bank?role=' + this.role, this.header).then(function (response) {
      if (response) {
        _this2.payInfo.baccount = response.data['baccount'];
        _this2.payInfo.bank = response.data['bank'];
        _this2.payInfo.company = response.data['company'];
      }
    }).catch(function (err) {
      _this2.$vux.toast.show({
        text: JSON.parse(err.response.data.error_message).zh_string,
        type: 'cancel',
        time: '1000'
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Pay/Askpay.vue






/* harmony default export */ var Pay_Askpay = ({
  name: "Askpay",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      payInfo: {
        amount: '',
        company: '',
        baccount: '',
        bank: ''
      },
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      seq: this.$route.params.seq,
      role: this.$route.params.role,
      type: this.$route.params.type
    };
  },

  methods: {
    confirmPay: function confirmPay() {
      var _this = this;

      if (!this.payInfo.amount || !this.payInfo.baccount || !this.payInfo.bank || !this.payInfo.company) {
        alert('请填写信息');
        return;
      }
      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/ask_user_pay_repair', extends_default()({ role: this.role }, this.payInfo), this.header).then(function () {
        alert('请求成功');
        _this.$router.push({ name: 'RepairSrvp', query: { seq: _this.seq, role: _this.role, type: _this.type } });
      }).catch(function (err) {
        _this.$vux.toast.show({
          text: JSON.parse(err.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    },
    cancelPay: function cancelPay() {
      this.$router.push({ name: 'RepairSrvp', query: { seq: this.seq, role: this.role, type: this.type } });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('/api/v1/payments/' + localStorage.getItem('userid') + '/orders/get_latest_repair_bank?role=' + this.role, this.header).then(function (response) {
      if (response) {
        _this2.payInfo.baccount = response.data['baccount'];
        _this2.payInfo.bank = response.data['bank'];
        _this2.payInfo.company = response.data['company'];
      }
    }).catch(function (err) {
      _this2.$vux.toast.show({
        text: JSON.parse(err.response.data.error_message).zh_string,
        type: 'cancel',
        time: '1000'
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f0f9980","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pay/Askpay.vue
var Askpay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',[_c('x-input',{attrs:{"title":"支付金额"},model:{value:(_vm.payInfo.amount),callback:function ($$v) {_vm.$set(_vm.payInfo, "amount", $$v)},expression:"payInfo.amount"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"公司"},model:{value:(_vm.payInfo.company),callback:function ($$v) {_vm.$set(_vm.payInfo, "company", $$v)},expression:"payInfo.company"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"账号"},model:{value:(_vm.payInfo.baccount),callback:function ($$v) {_vm.$set(_vm.payInfo, "baccount", $$v)},expression:"payInfo.baccount"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"银行"},model:{value:(_vm.payInfo.bank),callback:function ($$v) {_vm.$set(_vm.payInfo, "bank", $$v)},expression:"payInfo.bank"}}),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"5px"},attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirmPay($event)}}},[_vm._v("确定")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"5px"},attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.cancelPay($event)}}},[_vm._v("取消")])],1)}
var Askpay_staticRenderFns = []
var Askpay_esExports = { render: Askpay_render, staticRenderFns: Askpay_staticRenderFns }
/* harmony default export */ var components_Pay_Askpay = (Askpay_esExports);
// CONCATENATED MODULE: ./src/components/Pay/Askpay.vue
function Askpay_injectStyle (ssrContext) {
  __webpack_require__("+mqS")
}
var Askpay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Askpay___vue_template_functional__ = false
/* styles */
var Askpay___vue_styles__ = Askpay_injectStyle
/* scopeId */
var Askpay___vue_scopeId__ = "data-v-2f0f9980"
/* moduleIdentifier (server only) */
var Askpay___vue_module_identifier__ = null
var Askpay_Component = Askpay_normalizeComponent(
  Pay_Askpay,
  components_Pay_Askpay,
  Askpay___vue_template_functional__,
  Askpay___vue_styles__,
  Askpay___vue_scopeId__,
  Askpay___vue_module_identifier__
)

/* harmony default export */ var src_components_Pay_Askpay = (Askpay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Market.vue



/* harmony default export */ var Market = ({
  name: "Market",
  components: { Panel: vux_src_components_panel },
  data: function data() {
    return {
      offset: 0,
      seq: this.$route.params.seq,
      market: [],
      footer: {
        title: '更多'
      }
    };
  },

  methods: {
    pageChange: function pageChange() {
      var _this = this;

      if (this.markettotal <= this.offset) {
        return;
      }
      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=ADMIN&offset=' + this.offset + '&count=20', {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }).then(function (response) {
        response.data.content.forEach(function (item) {
          _this.market.push({ title: item.name, desc: item.mobile });
        });
        _this.offset += 20;
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=ADMIN&offset=' + this.offset + '&count=20', {
      headers: {
        token: localStorage.getItem('token'),
        opid: localStorage.getItem('userid')
      }
    }).then(function (response) {
      response.data.content.forEach(function (item) {
        _this2.market.push({ title: item.name, desc: item.mobile });
      });
      _this2.markettotal = response.data.total;
      _this2.offset += 20;
    }).catch(function (error) {
      _this2.$vux.toast.show({
        text: JSON.parse(error.response.data.error_message).zh_string,
        type: 'cancel',
        time: '1000'
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Market.vue



/* harmony default export */ var components_Market = ({
  name: "Market",
  components: { Panel: vux_src_components_panel },
  data: function data() {
    return {
      offset: 0,
      seq: this.$route.params.seq,
      market: [],
      footer: {
        title: '更多'
      }
    };
  },

  methods: {
    pageChange: function pageChange() {
      var _this = this;

      if (this.markettotal <= this.offset) {
        return;
      }
      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=ADMIN&offset=' + this.offset + '&count=20', {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }).then(function (response) {
        response.data.content.forEach(function (item) {
          _this.market.push({ title: item.name, desc: item.mobile });
        });
        _this.offset += 20;
      }).catch(function (error) {
        _this.$vux.toast.show({
          text: JSON.parse(error.response.data.error_message).zh_string,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=ADMIN&offset=' + this.offset + '&count=20', {
      headers: {
        token: localStorage.getItem('token'),
        opid: localStorage.getItem('userid')
      }
    }).then(function (response) {
      response.data.content.forEach(function (item) {
        _this2.market.push({ title: item.name, desc: item.mobile });
      });
      _this2.markettotal = response.data.total;
      _this2.offset += 20;
    }).catch(function (error) {
      _this2.$vux.toast.show({
        text: JSON.parse(error.response.data.error_message).zh_string,
        type: 'cancel',
        time: '1000'
      });
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694b1b06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Market.vue
var Market_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{staticClass:"max-height",attrs:{"header":"销售人员列表","footer":_vm.footer,"list":_vm.market},on:{"on-click-footer":_vm.pageChange}})}
var Market_staticRenderFns = []
var Market_esExports = { render: Market_render, staticRenderFns: Market_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Market = (Market_esExports);
// CONCATENATED MODULE: ./src/components/Market.vue
function Market_injectStyle (ssrContext) {
  __webpack_require__("Pqsh")
}
var Market_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Market___vue_template_functional__ = false
/* styles */
var Market___vue_styles__ = Market_injectStyle
/* scopeId */
var Market___vue_scopeId__ = "data-v-694b1b06"
/* moduleIdentifier (server only) */
var Market___vue_module_identifier__ = null
var Market_Component = Market_normalizeComponent(
  components_Market,
  selectortype_template_index_0_src_components_Market,
  Market___vue_template_functional__,
  Market___vue_styles__,
  Market___vue_scopeId__,
  Market___vue_module_identifier__
)

/* harmony default export */ var src_components_Market = (Market_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject/filing.vue








/* harmony default export */ var filing = ({
  name: "filing",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Confirm: components_confirm["a" /* default */], Checklist: vux_src_components_checklist },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      devtypeshow: false,
      smsDisabled: false,
      buttonText: '发送验证码',
      fastprojectshow: false,
      code: '',
      imgcode: '',
      imgCodeInput: '',
      imgCodeError: '',
      data: {
        customer: '',
        devtype: '',
        agent: '',
        company: '北京中广上洋科技股份有限公司'
      },
      devtypeOther: '',
      name: '',
      mobile: '',
      quoteLine: [],
      checklist001: [],
      isLogin: false,
      isDisabled: false
    };
  },

  methods: {
    clear: function clear() {
      this.data = {
        customer: '',
        devtype: '',
        agent: '',
        company: '北京中广上洋科技股份有限公司'
      };
      if (!this.isLogin) {
        this.name = '';
        this.mobile = '';
      }
      this.checklist001 = [];
    },
    goToList: function goToList() {
      if (this.isLogin) {
        this.$router.push({ name: 'filinglist' });
      } else {
        this.$vux.alert.show({
          title: "",
          content: "暂无订单信息"
        });
      }
    },
    sendCode: function sendCode() {
      var _this = this;

      if (!this.imgCodeInput) {
        this.imgCodeError = '请输入图形验证码';
        return;
      }

      var obj = {
        nationcode: '86',
        mobile: this.mobile,
        openid: localStorage.getItem('openid'),
        passwd: this.imgCodeInput
      };
      if (this.mobile) {
        this.$http.post('/api/v1/accounts/sms', obj).then(function (response) {
          if (response.data.result !== 0) {
            _this.imgCodeError = response.data.errmsg || '验证码发送失败';
          } else {
            _this.imgCodeError = '';
            localStorage.setItem('countDown', 60);
            _this.timeKeeping();
          }
        }).catch(function (error) {
          if (error.response && error.response.data) {
            _this.imgCodeError = error.response.data.errmsg || '图形验证码错误';
          } else {
            _this.imgCodeError = '发送失败，请重试';
          }
        });
      }
    },
    timeKeeping: function timeKeeping() {
      var _this2 = this;

      this.smsDisabled = true;
      var interval = setInterval(function () {

        var countDown = parseInt(localStorage.getItem('countDown'));

        _this2.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          localStorage.removeItem('countDown');
          _this2.buttonText = '重新发送';
          _this2.smsDisabled = false;
        } else {
          countDown--;
          localStorage.setItem('countDown', countDown);
        }
      }, 1000);
    },
    getImgCode: function getImgCode() {
      var _this3 = this;

      this.$http.get('/api/v1/photos/get_imgcode').then(function (response) {
        _this3.imgcode = response.data;
      }).catch(function () {
        _this3.imgCodeError = '获取图形验证码失败';
      });
    },
    refreshImgCode: function refreshImgCode() {
      this.imgCodeInput = '';
      this.imgCodeError = '';
      this.getImgCode();
    },
    onConfirm: function onConfirm() {
      var _this4 = this;

      var info = {
        code: this.code,
        mobile: this.mobile
      };
      this.$http.put('/api/v1/accounts/checksms', info).then(function () {
        _this4.$http.post('/api/v1/srvp_projects/report', {
          info: _this4.data,
          name: _this4.name,
          mobile: _this4.mobile,
          openid: localStorage.getItem('openid'),
          unionid: localStorage.getItem('unionid'),
          nickname: localStorage.getItem('nickname'),
          imgurl: localStorage.getItem('imgurl'),
          otp: 'official'
        }).then(function (response) {
          alert('提交成功');
          _this4.isDisabled = false;
          _this4.clear();
          _this4.$router.push({ name: 'filinglist' });
        }).catch(function (error) {
          _this4.isDisabled = false;
          _this4.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        });
      });
    },
    choseDevtype: function choseDevtype() {
      this.devtypeshow = true;
    },
    sureDevtype: function sureDevtype() {
      this.data.devtype = this.checklist001.join(',');
    },
    check: function check() {
      var _this5 = this;

      this.isDisabled = true;
      if (this.data.customer !== '' && this.data.devtype !== '' && this.data.agent !== '' && this.mobile && this.name) {
        if (this.isLogin) {
          var obj = {
            headers: {
              token: localStorage.getItem('token'),
              opid: localStorage.getItem('userid')
            }
          };
          this.$http.post('/api/v1/srvp_projects/admin_report', {
            role: 'INDV',
            info: this.data
          }, obj).then(function () {
            _this5.isDisabled = false;
            alert('提交成功');
            _this5.$router.push({ name: 'filinglist' });
          }).catch(function (error) {
            _this5.isDisabled = false;
            _this5.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        } else {
          this.fastprojectshow = true;
          this.refreshImgCode();
        }
      } else {
        alert('请补充信息');
        this.isDisabled = false;
      }
    }
  },
  computed: {
    fls: function fls() {
      return this.data.devtype === '其他';
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      _this6.$refs.devtype.$el.getElementsByClassName('weui-dialog')[0].setAttribute('id', 'auto');
    });
  },
  created: function created() {
    var _this7 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/srvp_products/user_list_cats?company=北京中广上洋科技股份有限公司&hint=').then(function (response) {
      _this7.quoteLine = response.data;
    });
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {
      var len = res.data.length;
      if (len) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        _this7.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };

          _this7.$http.get('api/v1/accounts/' + opid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].type === 'INDV' || response.data[i].type === 'ENTP') {
                _this7.role = response.data[i].type;
                break;
              }
            }
            if (_this7.role === 'INDV' || _this7.role === 'ENTP') {
              _this7.isLogin = true;
              _this7.$http.get('/api/v1/users/' + opid, obj).then(function (res) {
                if (res.data.detail) {
                  _this7.name = res.data.detail.name;
                  _this7.mobile = res.data.detail.mobile;
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                _this7.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject/filing.vue








/* harmony default export */ var srvpproject_filing = ({
  name: "filing",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Confirm: components_confirm["a" /* default */], Checklist: vux_src_components_checklist },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      devtypeshow: false,
      smsDisabled: false,
      buttonText: '发送验证码',
      fastprojectshow: false,
      code: '',
      imgcode: '',
      imgCodeInput: '',
      imgCodeError: '',
      data: {
        customer: '',
        devtype: '',
        agent: '',
        company: '北京中广上洋科技股份有限公司'
      },
      devtypeOther: '',
      name: '',
      mobile: '',
      quoteLine: [],
      checklist001: [],
      isLogin: false,
      isDisabled: false
    };
  },

  methods: {
    clear: function clear() {
      this.data = {
        customer: '',
        devtype: '',
        agent: '',
        company: '北京中广上洋科技股份有限公司'
      };
      if (!this.isLogin) {
        this.name = '';
        this.mobile = '';
      }
      this.checklist001 = [];
    },
    goToList: function goToList() {
      if (this.isLogin) {
        this.$router.push({ name: 'filinglist' });
      } else {
        this.$vux.alert.show({
          title: "",
          content: "暂无订单信息"
        });
      }
    },
    sendCode: function sendCode() {
      var _this = this;

      if (!this.imgCodeInput) {
        this.imgCodeError = '请输入图形验证码';
        return;
      }

      var obj = {
        nationcode: '86',
        mobile: this.mobile,
        openid: localStorage.getItem('openid'),
        passwd: this.imgCodeInput
      };
      if (this.mobile) {
        this.$http.post('/api/v1/accounts/sms', obj).then(function (response) {
          if (response.data.result !== 0) {
            _this.imgCodeError = response.data.errmsg || '验证码发送失败';
          } else {
            _this.imgCodeError = '';
            localStorage.setItem('countDown', 60);
            _this.timeKeeping();
          }
        }).catch(function (error) {
          if (error.response && error.response.data) {
            _this.imgCodeError = error.response.data.errmsg || '图形验证码错误';
          } else {
            _this.imgCodeError = '发送失败，请重试';
          }
        });
      }
    },
    timeKeeping: function timeKeeping() {
      var _this2 = this;

      this.smsDisabled = true;
      var interval = setInterval(function () {

        var countDown = parseInt(localStorage.getItem('countDown'));

        _this2.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          localStorage.removeItem('countDown');
          _this2.buttonText = '重新发送';
          _this2.smsDisabled = false;
        } else {
          countDown--;
          localStorage.setItem('countDown', countDown);
        }
      }, 1000);
    },
    getImgCode: function getImgCode() {
      var _this3 = this;

      this.$http.get('/api/v1/photos/get_imgcode').then(function (response) {
        _this3.imgcode = response.data;
      }).catch(function () {
        _this3.imgCodeError = '获取图形验证码失败';
      });
    },
    refreshImgCode: function refreshImgCode() {
      this.imgCodeInput = '';
      this.imgCodeError = '';
      this.getImgCode();
    },
    onConfirm: function onConfirm() {
      var _this4 = this;

      var info = {
        code: this.code,
        mobile: this.mobile
      };
      this.$http.put('/api/v1/accounts/checksms', info).then(function () {
        _this4.$http.post('/api/v1/srvp_projects/report', {
          info: _this4.data,
          name: _this4.name,
          mobile: _this4.mobile,
          openid: localStorage.getItem('openid'),
          unionid: localStorage.getItem('unionid'),
          nickname: localStorage.getItem('nickname'),
          imgurl: localStorage.getItem('imgurl'),
          otp: 'official'
        }).then(function (response) {
          alert('提交成功');
          _this4.isDisabled = false;
          _this4.clear();
          _this4.$router.push({ name: 'filinglist' });
        }).catch(function (error) {
          _this4.isDisabled = false;
          _this4.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        });
      });
    },
    choseDevtype: function choseDevtype() {
      this.devtypeshow = true;
    },
    sureDevtype: function sureDevtype() {
      this.data.devtype = this.checklist001.join(',');
    },
    check: function check() {
      var _this5 = this;

      this.isDisabled = true;
      if (this.data.customer !== '' && this.data.devtype !== '' && this.data.agent !== '' && this.mobile && this.name) {
        if (this.isLogin) {
          var obj = {
            headers: {
              token: localStorage.getItem('token'),
              opid: localStorage.getItem('userid')
            }
          };
          this.$http.post('/api/v1/srvp_projects/admin_report', {
            role: 'INDV',
            info: this.data
          }, obj).then(function () {
            _this5.isDisabled = false;
            alert('提交成功');
            _this5.$router.push({ name: 'filinglist' });
          }).catch(function (error) {
            _this5.isDisabled = false;
            _this5.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        } else {
          this.fastprojectshow = true;
          this.refreshImgCode();
        }
      } else {
        alert('请补充信息');
        this.isDisabled = false;
      }
    }
  },
  computed: {
    fls: function fls() {
      return this.data.devtype === '其他';
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      _this6.$refs.devtype.$el.getElementsByClassName('weui-dialog')[0].setAttribute('id', 'auto');
    });
  },
  created: function created() {
    var _this7 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/srvp_products/user_list_cats?company=北京中广上洋科技股份有限公司&hint=').then(function (response) {
      _this7.quoteLine = response.data;
    });
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {
      var len = res.data.length;
      if (len) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        _this7.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };

          _this7.$http.get('api/v1/accounts/' + opid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].type === 'INDV' || response.data[i].type === 'ENTP') {
                _this7.role = response.data[i].type;
                break;
              }
            }
            if (_this7.role === 'INDV' || _this7.role === 'ENTP') {
              _this7.isLogin = true;
              _this7.$http.get('/api/v1/users/' + opid, obj).then(function (res) {
                if (res.data.detail) {
                  _this7.name = res.data.detail.name;
                  _this7.mobile = res.data.detail.mobile;
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                _this7.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14bdb34e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/srvpproject/filing.vue
var filing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"message"},[_vm._v("报备信息")]),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"最终用户名称*","type":"text"},model:{value:(_vm.data.customer),callback:function ($$v) {_vm.$set(_vm.data, "customer", $$v)},expression:"data.customer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"拟采用产品类别*","type":"text"},nativeOn:{"click":function($event){return _vm.choseDevtype($event)}},model:{value:(_vm.data.devtype),callback:function ($$v) {_vm.$set(_vm.data, "devtype", $$v)},expression:"data.devtype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"拟推荐代理商*","type":"text"},model:{value:(_vm.data.agent),callback:function ($$v) {_vm.$set(_vm.data, "agent", $$v)},expression:"data.agent"}}),_vm._v(" "),(!_vm.isLogin)?_c('x-input',{attrs:{"title":"报备人姓名*","type":"text"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}):_vm._e(),_vm._v(" "),(!_vm.isLogin)?_c('x-input',{attrs:{"title":"报备人手机*","type":"number","is-type":"china-mobile"},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-around","margin":"1rem 0"}},[_c('x-button',{staticStyle:{"width":"40%"},attrs:{"type":"primary","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.check($event)}}},[_vm._v("提交")]),_vm._v(" "),_c('x-button',{staticStyle:{"width":"40%","margin-top":"0"},nativeOn:{"click":function($event){return _vm.clear($event)}}},[_vm._v("清除")])],1),_vm._v(" "),_c('x-button',{nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_vm._v("我的备案")]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{attrs:{"theme":"android","title":"提示信息"},on:{"on-cancel":function($event){_vm.fastprojectshow = false},"on-confirm":_vm.onConfirm},model:{value:(_vm.fastprojectshow),callback:function ($$v) {_vm.fastprojectshow=$$v},expression:"fastprojectshow"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("您第一次报备，请点击获取验证码，谢谢")]),_vm._v(" "),_c('group',[_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"图形验证码","type":"text","placeholder":"请输入图形验证码"},model:{value:(_vm.imgCodeInput),callback:function ($$v) {_vm.imgCodeInput=$$v},expression:"imgCodeInput"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"slot":"right"},slot:"right"},[_c('img',{staticStyle:{"height":"30px","cursor":"pointer","margin-right":"5px"},attrs:{"src":_vm.imgcode,"alt":"图形验证码"},on:{"click":_vm.refreshImgCode}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#3399ff","cursor":"pointer","font-size":"12px"},on:{"click":_vm.refreshImgCode}},[_vm._v("换一张")])])]),_vm._v(" "),_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"短信验证码","type":"number","placeholder":"请输入短信验证码"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}},[_c('x-button',{attrs:{"slot":"right","type":"primary","mini":"","text":_vm.buttonText,"disabled":_vm.smsDisabled},nativeOn:{"click":function($event){return _vm.sendCode($event)}},slot:"right"})],1)],1),_vm._v(" "),(_vm.imgCodeError)?_c('p',{staticStyle:{"color":"red","text-align":"center","font-size":"12px","margin-top":"5px"}},[_vm._v(_vm._s(_vm.imgCodeError))]):_vm._e()],1),_vm._v(" "),_c('confirm',{ref:"devtype",attrs:{"theme":"android"},on:{"on-cancel":function($event){_vm.devtypeshow = false},"on-confirm":_vm.sureDevtype},model:{value:(_vm.devtypeshow),callback:function ($$v) {_vm.devtypeshow=$$v},expression:"devtypeshow"}},[_c('checklist',{staticClass:"weui-vcode",attrs:{"title":"拟采用产品类别","required":"","options":_vm.quoteLine},model:{value:(_vm.checklist001),callback:function ($$v) {_vm.checklist001=$$v},expression:"checklist001"}})],1)],1)],1)}
var filing_staticRenderFns = []
var filing_esExports = { render: filing_render, staticRenderFns: filing_staticRenderFns }
/* harmony default export */ var components_srvpproject_filing = (filing_esExports);
// CONCATENATED MODULE: ./src/components/srvpproject/filing.vue
function filing_injectStyle (ssrContext) {
  __webpack_require__("qbUw")
}
var filing_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var filing___vue_template_functional__ = false
/* styles */
var filing___vue_styles__ = filing_injectStyle
/* scopeId */
var filing___vue_scopeId__ = "data-v-14bdb34e"
/* moduleIdentifier (server only) */
var filing___vue_module_identifier__ = null
var filing_Component = filing_normalizeComponent(
  srvpproject_filing,
  components_srvpproject_filing,
  filing___vue_template_functional__,
  filing___vue_styles__,
  filing___vue_scopeId__,
  filing___vue_module_identifier__
)

/* harmony default export */ var src_components_srvpproject_filing = (filing_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject/filinglist.vue








/* harmony default export */ var filinglist = ({
  name: "filinglist",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      type: false
    };
  },

  methods: {
    goToFiling: function goToFiling() {
      this.$router.push({ name: 'filing' });
    },
    init: function init(info) {
      switch (info['state']) {
        case 'COMPLETE':
          info['state'] = '备案待补充';
          break;
        case 'AUDIT':
          info['state'] = '备案待审批';
          break;
        case 'REAUDIT':
          info['state'] = '重新备案,待审批';
          break;
        case 'ASUCCESS':
          info['state'] = '备案审批通过';
          break;
        case 'AFAIL':
          info['state'] = '备案审批失败';
          break;
        case 'REWARD':
          info['state'] = '备案等待奖励审批';
          break;
        case 'RSUCCESS':
          info['state'] = '奖励审批通过';
          break;
        case 'RFAIL':
          info['state'] = '奖励审批失败';
          break;
        case 'EXPIRED':
          info['state'] = '备案超时';
          break;
        default:
          break;
      }
      return info;
    },
    toAudit: function toAudit() {
      var _this = this;

      this.type = false;
      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=false&company=北京中广上洋科技股份有限公司', this.header).then(function (response) {
        _this.dataList = response.data.content.map(function (item) {
          return _this.init(item);
        });
        _this.total = response.data.total;
      }).catch(function (error) {
        _this.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    auditEd: function auditEd() {
      var _this2 = this;

      this.type = true;
      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=true&company=北京中广上洋科技股份有限公司', this.header).then(function (response) {
        _this2.dataList = response.data.content.map(function (item) {
          return _this2.init(item);
        });
        _this2.total = response.data.total;
      }).catch(function (error) {
        _this2.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    more: function more() {
      var _this3 = this;

      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=' + this.dataList.length + '&count=10&closed=' + this.type + '&company=北京中广上洋科技股份有限公司', this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this3.init(item);
        });
        _this3.total = response.data.total;
      }).catch(function (error) {
        _this3.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    var _this4 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      var len = res.data.length;
      if (len) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        _this4.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          _this4.header = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };
          _this4.toAudit();
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject/filinglist.vue








/* harmony default export */ var srvpproject_filinglist = ({
  name: "filinglist",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      type: false
    };
  },

  methods: {
    goToFiling: function goToFiling() {
      this.$router.push({ name: 'filing' });
    },
    init: function init(info) {
      switch (info['state']) {
        case 'COMPLETE':
          info['state'] = '备案待补充';
          break;
        case 'AUDIT':
          info['state'] = '备案待审批';
          break;
        case 'REAUDIT':
          info['state'] = '重新备案,待审批';
          break;
        case 'ASUCCESS':
          info['state'] = '备案审批通过';
          break;
        case 'AFAIL':
          info['state'] = '备案审批失败';
          break;
        case 'REWARD':
          info['state'] = '备案等待奖励审批';
          break;
        case 'RSUCCESS':
          info['state'] = '奖励审批通过';
          break;
        case 'RFAIL':
          info['state'] = '奖励审批失败';
          break;
        case 'EXPIRED':
          info['state'] = '备案超时';
          break;
        default:
          break;
      }
      return info;
    },
    toAudit: function toAudit() {
      var _this = this;

      this.type = false;
      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=false&company=北京中广上洋科技股份有限公司', this.header).then(function (response) {
        _this.dataList = response.data.content.map(function (item) {
          return _this.init(item);
        });
        _this.total = response.data.total;
      }).catch(function (error) {
        _this.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    auditEd: function auditEd() {
      var _this2 = this;

      this.type = true;
      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=true&company=北京中广上洋科技股份有限公司', this.header).then(function (response) {
        _this2.dataList = response.data.content.map(function (item) {
          return _this2.init(item);
        });
        _this2.total = response.data.total;
      }).catch(function (error) {
        _this2.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    more: function more() {
      var _this3 = this;

      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=' + this.dataList.length + '&count=10&closed=' + this.type + '&company=北京中广上洋科技股份有限公司', this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this3.init(item);
        });
        _this3.total = response.data.total;
      }).catch(function (error) {
        _this3.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    var _this4 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      var len = res.data.length;
      if (len) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        _this4.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          _this4.header = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };
          _this4.toAudit();
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1203a910","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/srvpproject/filinglist.vue
var filinglist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tab',[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.toAudit}},[_vm._v("未审核")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.auditEd}},[_vm._v("已审核")])],1),_vm._v(" "),_c('group',_vm._l((_vm.dataList),function(item,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'filingorder', query: { order: item,closed:_vm.type }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(item.customer))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(item.recordt))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(item.state))])])])})),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-plus-outline icon-white",attrs:{"type":"ios-plus-outline","size":"50","xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 512 512"},on:{"click":_vm.goToFiling}},[_c('path',{attrs:{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 398.7c-105.1 0-190.7-85.5-190.7-190.7S150.9 65.3 256 65.3 446.7 150.9 446.7 256 361.1 446.7 256 446.7z"}}),_c('path',{attrs:{"d":"M264.1 128h-16.8v119.9H128v16.8h119.3V384h16.8V264.7H384v-16.8H264.1z"}})]),_vm._v(" "),(_vm.dataList.length !== _vm.total)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){_vm.more()}}},[_vm._v("更多")]):_vm._e()],1)}
var filinglist_staticRenderFns = []
var filinglist_esExports = { render: filinglist_render, staticRenderFns: filinglist_staticRenderFns }
/* harmony default export */ var components_srvpproject_filinglist = (filinglist_esExports);
// CONCATENATED MODULE: ./src/components/srvpproject/filinglist.vue
function filinglist_injectStyle (ssrContext) {
  __webpack_require__("3bhw")
}
var filinglist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var filinglist___vue_template_functional__ = false
/* styles */
var filinglist___vue_styles__ = filinglist_injectStyle
/* scopeId */
var filinglist___vue_scopeId__ = "data-v-1203a910"
/* moduleIdentifier (server only) */
var filinglist___vue_module_identifier__ = null
var filinglist_Component = filinglist_normalizeComponent(
  srvpproject_filinglist,
  components_srvpproject_filinglist,
  filinglist___vue_template_functional__,
  filinglist___vue_styles__,
  filinglist___vue_scopeId__,
  filinglist___vue_module_identifier__
)

/* harmony default export */ var src_components_srvpproject_filinglist = (filinglist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject/filingorder.vue








/* harmony default export */ var filingorder = ({
  name: "filingorder",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Checklist: vux_src_components_checklist, Confirm: components_confirm["a" /* default */] },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      orderDetail: this.$route.query.order,
      isReadonly: true,
      devtypeshow: false,
      checklist001: [],
      quoteLine: [],
      closed: this.$route.query.closed,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    choseDevtype: function choseDevtype() {
      if (this.isReadonly) {
        return;
      }
      this.checklist001 = this.orderDetail.devtype.split(',');
      this.devtypeshow = true;
    },
    sureDevtype: function sureDevtype() {
      this.orderDetail.devtype = this.checklist001.join(',');
    },
    deleteOrder: function deleteOrder() {
      var that = this;
      this.$vux.confirm.show({
        content: '确认删除此订单',
        theme: 'android',
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          that.$http.get('/api/v1/srvp_projects/' + that.orderDetail.seq + '/remove_my_project?role=INDV', that.header).then(function () {
            alert('删除成功');
            that.$router.push({ name: 'filinglist' });
          }).catch(function (error) {
            that.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        }
      });
    },
    saveOrder: function saveOrder() {
      var _this = this;

      this.$http.put('/api/v1/srvp_projects/' + this.orderDetail.seq + '/update_my_project', {
        role: 'INDV',
        info: {
          customer: this.orderDetail.customer,
          devtype: this.orderDetail.devtype,
          agent: this.orderDetail.agent,
          company: '北京中广上洋科技股份有限公司'
        }
      }, this.header).then(function () {
        alert('修改备案成功');
        _this.$router.push({ name: 'filinglist' });
      }).catch(function (error) {
        _this.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('api/v1/srvp_products/user_list_cats?company=北京中广上洋科技股份有限公司&hint=').then(function (response) {
      _this2.quoteLine = response.data;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject/filingorder.vue








/* harmony default export */ var srvpproject_filingorder = ({
  name: "filingorder",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Checklist: vux_src_components_checklist, Confirm: components_confirm["a" /* default */] },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      orderDetail: this.$route.query.order,
      isReadonly: true,
      devtypeshow: false,
      checklist001: [],
      quoteLine: [],
      closed: this.$route.query.closed,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    choseDevtype: function choseDevtype() {
      if (this.isReadonly) {
        return;
      }
      this.checklist001 = this.orderDetail.devtype.split(',');
      this.devtypeshow = true;
    },
    sureDevtype: function sureDevtype() {
      this.orderDetail.devtype = this.checklist001.join(',');
    },
    deleteOrder: function deleteOrder() {
      var that = this;
      this.$vux.confirm.show({
        content: '确认删除此订单',
        theme: 'android',
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          that.$http.get('/api/v1/srvp_projects/' + that.orderDetail.seq + '/remove_my_project?role=INDV', that.header).then(function () {
            alert('删除成功');
            that.$router.push({ name: 'filinglist' });
          }).catch(function (error) {
            that.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        }
      });
    },
    saveOrder: function saveOrder() {
      var _this = this;

      this.$http.put('/api/v1/srvp_projects/' + this.orderDetail.seq + '/update_my_project', {
        role: 'INDV',
        info: {
          customer: this.orderDetail.customer,
          devtype: this.orderDetail.devtype,
          agent: this.orderDetail.agent,
          company: '北京中广上洋科技股份有限公司'
        }
      }, this.header).then(function () {
        alert('修改备案成功');
        _this.$router.push({ name: 'filinglist' });
      }).catch(function (error) {
        _this.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('api/v1/srvp_products/user_list_cats?company=北京中广上洋科技股份有限公司&hint=').then(function (response) {
      _this2.quoteLine = response.data;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e41cc46c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/srvpproject/filingorder.vue
var filingorder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报备订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"用户名称","type":"text","readonly":_vm.isReadonly},model:{value:(_vm.orderDetail.customer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "customer", $$v)},expression:"orderDetail.customer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备类型","type":"text","readonly":_vm.isReadonly},nativeOn:{"click":function($event){return _vm.choseDevtype($event)}},model:{value:(_vm.orderDetail.devtype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devtype", $$v)},expression:"orderDetail.devtype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"推荐代理商","type":"text","readonly":_vm.isReadonly},model:{value:(_vm.orderDetail.agent),callback:function ($$v) {_vm.$set(_vm.orderDetail, "agent", $$v)},expression:"orderDetail.agent"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报备时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.recordt),callback:function ($$v) {_vm.$set(_vm.orderDetail, "recordt", $$v)},expression:"orderDetail.recordt"}})],1),_vm._v(" "),(_vm.isReadonly && !_vm.closed)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){_vm.isReadonly = false}}},[_vm._v("编辑")]):_vm._e(),_vm._v(" "),(!_vm.isReadonly && !_vm.closed)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){return _vm.saveOrder($event)}}},[_vm._v("保存")]):_vm._e(),_vm._v(" "),(!_vm.closed)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){return _vm.deleteOrder($event)}}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{attrs:{"theme":"android"},on:{"on-cancel":function($event){_vm.devtypeshow = false},"on-confirm":_vm.sureDevtype},model:{value:(_vm.devtypeshow),callback:function ($$v) {_vm.devtypeshow=$$v},expression:"devtypeshow"}},[_c('checklist',{staticClass:"weui-vcode",attrs:{"title":"拟采用产品类别","required":"","options":_vm.quoteLine},model:{value:(_vm.checklist001),callback:function ($$v) {_vm.checklist001=$$v},expression:"checklist001"}})],1)],1)],1)}
var filingorder_staticRenderFns = []
var filingorder_esExports = { render: filingorder_render, staticRenderFns: filingorder_staticRenderFns }
/* harmony default export */ var components_srvpproject_filingorder = (filingorder_esExports);
// CONCATENATED MODULE: ./src/components/srvpproject/filingorder.vue
function filingorder_injectStyle (ssrContext) {
  __webpack_require__("3+Ul")
}
var filingorder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var filingorder___vue_template_functional__ = false
/* styles */
var filingorder___vue_styles__ = filingorder_injectStyle
/* scopeId */
var filingorder___vue_scopeId__ = "data-v-e41cc46c"
/* moduleIdentifier (server only) */
var filingorder___vue_module_identifier__ = null
var filingorder_Component = filingorder_normalizeComponent(
  srvpproject_filingorder,
  components_srvpproject_filingorder,
  filingorder___vue_template_functional__,
  filingorder___vue_styles__,
  filingorder___vue_scopeId__,
  filingorder___vue_module_identifier__
)

/* harmony default export */ var src_components_srvpproject_filingorder = (filingorder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Indvrepair/srvprepairinfo.vue





/* harmony default export */ var srvprepairinfo = ({
  name: "srvprepairinfo",
  components: { Cell: vux_src_components_cell, Group: group["a" /* default */], XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      info: this.$route.params.info
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Indvrepair/srvprepairinfo.vue





/* harmony default export */ var Indvrepair_srvprepairinfo = ({
  name: "srvprepairinfo",
  components: { Cell: vux_src_components_cell, Group: group["a" /* default */], XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      info: this.$route.params.info
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e49c7f6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Indvrepair/srvprepairinfo.vue
var srvprepairinfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("管理员联系方式")]),_vm._v(" "),_c('group',_vm._l((_vm.info),function(item,index){return _c('cell',{key:index,attrs:{"title":item.name,"value":item.mobile}})}))],1)}
var srvprepairinfo_staticRenderFns = []
var srvprepairinfo_esExports = { render: srvprepairinfo_render, staticRenderFns: srvprepairinfo_staticRenderFns }
/* harmony default export */ var components_Indvrepair_srvprepairinfo = (srvprepairinfo_esExports);
// CONCATENATED MODULE: ./src/components/Indvrepair/srvprepairinfo.vue
function srvprepairinfo_injectStyle (ssrContext) {
  __webpack_require__("Wc+C")
}
var srvprepairinfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var srvprepairinfo___vue_template_functional__ = false
/* styles */
var srvprepairinfo___vue_styles__ = srvprepairinfo_injectStyle
/* scopeId */
var srvprepairinfo___vue_scopeId__ = "data-v-e49c7f6c"
/* moduleIdentifier (server only) */
var srvprepairinfo___vue_module_identifier__ = null
var srvprepairinfo_Component = srvprepairinfo_normalizeComponent(
  Indvrepair_srvprepairinfo,
  components_Indvrepair_srvprepairinfo,
  srvprepairinfo___vue_template_functional__,
  srvprepairinfo___vue_styles__,
  srvprepairinfo___vue_scopeId__,
  srvprepairinfo___vue_module_identifier__
)

/* harmony default export */ var src_components_Indvrepair_srvprepairinfo = (srvprepairinfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9205242a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();_vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"type":"search","autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){_vm.onComposition($event, 'start')},"compositionend":function($event){_vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){_vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){_vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("Ngll")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/assistantinfo/assistant.vue





/* harmony default export */ var assistant = ({
  name: "assistant",
  components: { Search: vux_src_components_search, Group: group["a" /* default */], Cell: vux_src_components_cell },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      nameList: [],
      name: '',
      seq: this.$route.query.seq,
      role: this.$route.query.role,
      type: this.$route.query.type,
      isSearch: false
    };
  },

  methods: {
    onFocus: function onFocus() {
      this.isSearch = true;
    },
    onCancel: function onCancel() {
      this.isSearch = false;
    },
    setFocus: function setFocus() {
      this.$refs.search.setFocus();
    },
    resultClick: function resultClick(userid) {
      var _this = this;

      this.$vux.confirm.show({
        title: '',
        content: '确认添加该专家为协助人',
        onConfirm: function onConfirm() {
          _this.$http.post('/api/v1/normalrepairs/' + _this.seq + '/set_repair_visible_to', {
            role: _this.role,
            userid: userid.toString(),
            user_type: 'EXPT',
            visible: true
          }, _this.header).then(function () {
            if (_this.role === 'EXPT') {
              _this.$router.push({ name: 'records', query: { seq: _this.seq } });
            } else {
              _this.$router.push({ name: 'RepairSrvp', query: { seq: _this.seq, role: 'SRVP', type: _this.type } });
            }
          }).catch(function (error) {
            _this.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).faultstring,
              type: 'cancel',
              time: '1000'
            });
          });
        }
      });
    },
    getResult: function getResult(val) {
      var _this2 = this;

      if (this.role === 'EXPT') {
        this.$http.get('/api/v1/experts/' + localStorage.getItem('userid') + '/list_my_colleagues?hint=' + val + '&offset=0&count=999', this.header).then(function (response) {
          _this2.nameList = response.data.list;
        });
      } else {
        this.$http.get('/api/v1/agencies/' + localStorage.getItem('userid') + '/experts?hint=' + val + '&offset=0&count=9999&type=added', this.header).then(function (response) {
          _this2.nameList = response.data.list;
        });
      }
    }
  },
  created: function created() {
    this.getResult('');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/assistantinfo/assistant.vue





/* harmony default export */ var assistantinfo_assistant = ({
  name: "assistant",
  components: { Search: vux_src_components_search, Group: group["a" /* default */], Cell: vux_src_components_cell },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      nameList: [],
      name: '',
      seq: this.$route.query.seq,
      role: this.$route.query.role,
      type: this.$route.query.type,
      isSearch: false
    };
  },

  methods: {
    onFocus: function onFocus() {
      this.isSearch = true;
    },
    onCancel: function onCancel() {
      this.isSearch = false;
    },
    setFocus: function setFocus() {
      this.$refs.search.setFocus();
    },
    resultClick: function resultClick(userid) {
      var _this = this;

      this.$vux.confirm.show({
        title: '',
        content: '确认添加该专家为协助人',
        onConfirm: function onConfirm() {
          _this.$http.post('/api/v1/normalrepairs/' + _this.seq + '/set_repair_visible_to', {
            role: _this.role,
            userid: userid.toString(),
            user_type: 'EXPT',
            visible: true
          }, _this.header).then(function () {
            if (_this.role === 'EXPT') {
              _this.$router.push({ name: 'records', query: { seq: _this.seq } });
            } else {
              _this.$router.push({ name: 'RepairSrvp', query: { seq: _this.seq, role: 'SRVP', type: _this.type } });
            }
          }).catch(function (error) {
            _this.$vux.toast.show({
              text: JSON.parse(error.response.data.error_message).faultstring,
              type: 'cancel',
              time: '1000'
            });
          });
        }
      });
    },
    getResult: function getResult(val) {
      var _this2 = this;

      if (this.role === 'EXPT') {
        this.$http.get('/api/v1/experts/' + localStorage.getItem('userid') + '/list_my_colleagues?hint=' + val + '&offset=0&count=999', this.header).then(function (response) {
          _this2.nameList = response.data.list;
        });
      } else {
        this.$http.get('/api/v1/agencies/' + localStorage.getItem('userid') + '/experts?hint=' + val + '&offset=0&count=9999&type=added', this.header).then(function (response) {
          _this2.nameList = response.data.list;
        });
      }
    }
  },
  created: function created() {
    this.getResult('');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c466f80a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assistantinfo/assistant.vue
var assistant_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",staticStyle:{"position":"relative"}},[_c('search',{ref:"search",attrs:{"auto-fixed":"false","auto-scroll-to-top":""},on:{"on-change":_vm.getResult,"on-focus":_vm.onFocus,"on-cancel":_vm.onCancel},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('group',{style:({marginTop: _vm.isSearch?'46px':'0'})},_vm._l((_vm.nameList),function(item,index){return _c('cell',{key:index,attrs:{"is-link":"","title":item.name},nativeOn:{"click":function($event){_vm.resultClick(item.userid)}}},[_vm._v(_vm._s(item.mobile)+"\n    ")])}))],1)}
var assistant_staticRenderFns = []
var assistant_esExports = { render: assistant_render, staticRenderFns: assistant_staticRenderFns }
/* harmony default export */ var components_assistantinfo_assistant = (assistant_esExports);
// CONCATENATED MODULE: ./src/components/assistantinfo/assistant.vue
function assistant_injectStyle (ssrContext) {
  __webpack_require__("3nWo")
}
var assistant_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var assistant___vue_template_functional__ = false
/* styles */
var assistant___vue_styles__ = assistant_injectStyle
/* scopeId */
var assistant___vue_scopeId__ = "data-v-c466f80a"
/* moduleIdentifier (server only) */
var assistant___vue_module_identifier__ = null
var assistant_Component = assistant_normalizeComponent(
  assistantinfo_assistant,
  components_assistantinfo_assistant,
  assistant___vue_template_functional__,
  assistant___vue_styles__,
  assistant___vue_scopeId__,
  assistant___vue_module_identifier__
)

/* harmony default export */ var src_components_assistantinfo_assistant = (assistant_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout.vue
//
//
//
//
//
//

/* harmony default export */ var swipeout = ({
  name: 'swipeout'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout.vue
//
//
//
//
//
//

/* harmony default export */ var swipeout_swipeout = ({
  name: 'swipeout'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-675a2dea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swipeout/swipeout.vue
var swipeout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swipeout"},[_vm._t("default")],2)}
var swipeout_staticRenderFns = []
var swipeout_esExports = { render: swipeout_render, staticRenderFns: swipeout_staticRenderFns }
/* harmony default export */ var components_swipeout_swipeout = (swipeout_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swipeout/swipeout.vue
function swipeout_injectStyle (ssrContext) {
  __webpack_require__("dPMr")
}
var swipeout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swipeout___vue_template_functional__ = false
/* styles */
var swipeout___vue_styles__ = swipeout_injectStyle
/* scopeId */
var swipeout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swipeout___vue_module_identifier__ = null
var swipeout_Component = swipeout_normalizeComponent(
  swipeout_swipeout,
  components_swipeout_swipeout,
  swipeout___vue_template_functional__,
  swipeout___vue_styles__,
  swipeout___vue_scopeId__,
  swipeout___vue_module_identifier__
)

/* harmony default export */ var src_components_swipeout_swipeout = (swipeout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-button.vue
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_button = ({
  name: 'swipeout-button',
  props: {
    text: String,
    backgroundColor: String,
    type: String,
    width: {
      type: Number,
      default: 80
    }
  },
  methods: {
    onButtonClick: function onButtonClick() {
      if (this.$parent.$options._componentTag === 'swipeout-item') {
        this.$parent.onItemClick(this.text);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-button.vue
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_swipeout_button = ({
  name: 'swipeout-button',
  props: {
    text: String,
    backgroundColor: String,
    type: String,
    width: {
      type: Number,
      default: 80
    }
  },
  methods: {
    onButtonClick: function onButtonClick() {
      if (this.$parent.$options._componentTag === 'swipeout-item') {
        this.$parent.onItemClick(this.text);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78513114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swipeout/swipeout-button.vue
var swipeout_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vux-swipeout-button",class:{'vux-swipeout-button-primary': _vm.type === 'primary', 'vux-swipeout-button-warn': _vm.type === 'warn', 'vux-swipeout-button-default': _vm.type === 'default'},style:({width: (_vm.width + "px"), backgroundColor: _vm.backgroundColor}),attrs:{"type":"button"},on:{"click":_vm.onButtonClick}},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var swipeout_button_staticRenderFns = []
var swipeout_button_esExports = { render: swipeout_button_render, staticRenderFns: swipeout_button_staticRenderFns }
/* harmony default export */ var components_swipeout_swipeout_button = (swipeout_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swipeout/swipeout-button.vue
var swipeout_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swipeout_button___vue_template_functional__ = false
/* styles */
var swipeout_button___vue_styles__ = null
/* scopeId */
var swipeout_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swipeout_button___vue_module_identifier__ = null
var swipeout_button_Component = swipeout_button_normalizeComponent(
  swipeout_swipeout_button,
  components_swipeout_swipeout_button,
  swipeout_button___vue_template_functional__,
  swipeout_button___vue_styles__,
  swipeout_button___vue_scopeId__,
  swipeout_button___vue_module_identifier__
)

/* harmony default export */ var src_components_swipeout_swipeout_button = (swipeout_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-item.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_item = ({
  name: 'swipeout-item',
  props: {
    sensitivity: {
      type: Number,
      default: 0
    },
    autoCloseOnButtonClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    threshold: {
      type: Number,
      default: 0.3
    },
    underlayColor: String,
    transitionMode: {
      type: String,
      default: 'reveal'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },

  methods: {
    render: function render() {
      this.target = this.$refs.content;
      if (this.$slots['left-menu']) {
        this.hasLeftMenu = true;
        this.caculateMenuWidth('left');
      }
      if (this.$slots['right-menu']) {
        this.hasRightMenu = true;
        this.caculateMenuWidth('right');
      }
    },
    caculateMenuWidth: function caculateMenuWidth(direction) {
      var list = this.$slots[direction + '-menu'][0].children.filter(function (one) {
        return one.tag;
      });
      var width = 0;
      list.forEach(function (one) {
        var propsData = one.componentOptions ? one.componentOptions.propsData : {};
        width += propsData.width || 80;
      });
      this[direction + 'MenuWidth'] = width;
    },
    onContentClick: function onContentClick() {
      if (this.styles.transform.indexOf('(0px, 0, 0)') === -1) {
        this._setClose(200);
      }
    },
    onItemClick: function onItemClick() {
      if (this.autoCloseOnButtonClick) {
        this._setClose();
      }
    },
    start: function start(ev) {
      if (this.disabled || this.isOpen || ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.$parent.$options._componentTag === 'swipeout') {
        var openItems = this.$parent.$children.filter(function (item) {
          return item.$data.styles.transform.indexOf('(0px, 0, 0)') === -1;
        });
        if (openItems.length > 0) {
          openItems.forEach(function (item) {
            item.setOffset(0, true);
          });
          ev.preventDefault();
          return;
        }
      }
      var touch = ev.touches ? ev.touches[0] : ev;
      this.pageX = touch.pageX;
      this.pageY = touch.pageY;
    },
    move: function move(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        ev.preventDefault();
        return;
      }
      if (this.pageX === undefined) {
        ev.preventDefault();
        return;
      }

      var touch = ev.touches ? ev.touches[0] : ev;
      this.distX = touch.pageX - this.pageX;
      this.distY = touch.pageY - this.pageY;

      if (!this.direction) {
        this.direction = this.distX > 0 ? 'left' : 'right';
      }

      if (this.direction === 'right' && this.distX > 0 && this.hasRightMenu || this.direction === 'left' && this.distX < 0 && this.hasLeftMenu) {
        this.valid = true;
        ev.preventDefault();
      }

      if (this.valid === undefined) {
        if (this.distX > 0 && this.hasLeftMenu === false) {
          this.valid = false;
        } else if (this.distX < 0 && this.hasRightMenu === false) {
          this.valid = false;
        } else if (Math.abs(this.distX) > this.sensitivity || Math.abs(this.distY) > this.sensitivity) {
          this.valid = Math.abs(this.distX) > Math.abs(this.distY);
        } else {
          ev.preventDefault();
        }
      }

      if (this.valid === true) {
        if (Math.abs(this.distX) <= this.menuWidth) {
          this.setOffset(this.distX, false);
        } else {
          var extra = (Math.abs(this.distX) - this.menuWidth) * 0.5;
          var offset = (this.menuWidth + extra) * (this.distX < 0 ? -1 : 1);
          this.setOffset(offset, false);
        }
        ev.preventDefault();
      }
    },
    end: function end(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.valid === true) {
        if (this.distX < 0 && this.direction === 'right') {
          var threshold = this.threshold <= 1 ? this.rightMenuWidth * this.threshold : this.threshold;

          if (this.distX < -threshold) {
            this.setOffset(-this.rightMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        } else if (this.distX > 0 && this.direction === 'left') {
          var _threshold = this.threshold <= 1 ? this.leftMenuWidth * this.threshold : this.threshold;

          if (this.distX > _threshold) {
            this.setOffset(this.leftMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        }
      } else if (this.pageX !== undefined) {}

      this.pageX = this.pageY = this.valid = undefined;
      this.direction = '';
    },
    setOffset: function setOffset(x) {
      var _this2 = this;

      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var force = arguments[2];

      this.isAnimated = animated;
      if (this.disabled && !force) {
        return;
      }
      if (this.direction === 'right' && x > 0 || this.direction === 'left' && x < 0) {
        x = 0;
      }

      if (x === 0) {
        setTimeout(function () {
          _this2.isOpen = false;
        }, 300);
      }

      if (x < 0 && Math.abs(x) === this.rightMenuWidth) {
        this.distX = -this.rightMenuWidth;
      } else if (x > 0 && Math.abs(x) === this.leftMenuWidth) {
        this.distX = this.leftMenuWidth;
      }
      if (animated && this.target) {
        this.target && this.target.classList.add('vux-swipeout-content-animated');
        var cb = function (self, target) {
          return function () {
            target.classList.remove('vux-swipeout-content-animated');
            self.isAnimated = false;
            target.removeEventListener('webkitTransitionEnd', cb);
            target.removeEventListener('transitionend', cb);
          };
        }(this, this.target);

        this.target.addEventListener('webkitTransitionEnd', cb);
        this.target.addEventListener('transitionend', cb);
      }
      this.styles.transform = 'translate3d(' + x + 'px, 0, 0)';
    },
    _setClose: function _setClose() {
      var _this3 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.setOffset(0, true);
      this.$emit('on-close');
      if (!delay) {
        this.isOpen = false;
      } else {
        setTimeout(function () {
          _this3.isOpen = false;
        }, delay);
      }
      this.distX = 0;
    },
    open: function open() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';

      this.setOffset(position === 'right' ? -this.rightMenuWidth : this.leftMenuWidth, true, true);
    },
    close: function close() {
      this.setOffset(0, true, true);
    }
  },
  computed: {
    menuWidth: function menuWidth() {
      if (!this.hasLeftMenu && this.hasRightMenu) {
        return this.rightMenuWidth;
      }
      if (this.hasLeftMenu && !this.hasRightMenu) {
        return this.leftMenuWidth;
      }
      if (this.hasLeftMenu && this.hasRightMenu) {
        return this.distX < 0 ? this.rightMenuWidth : this.leftMenuWidth;
      }
    },
    buttonBoxStyle: function buttonBoxStyle() {
      return {
        backgroundColor: this.underlayColor
      };
    },
    leftButtonBoxStyle: function leftButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.leftMenuWidth - this.distX : this.leftMenuWidth;
        styles.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      }
      return styles;
    },
    rightButtonBoxStyle: function rightButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.rightMenuWidth - Math.abs(this.distX) : this.rightMenuWidth;
        if (offset < 0) {
          offset = 0;
        }
        if (this.isAnimated) {
          styles.transition = 'transform 0.2s';
        }
        styles.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }
      return styles;
    }
  },
  data: function data() {
    return {
      pageX: undefined,
      pageY: undefined,
      distX: 0,
      distY: 0,
      hasLeftMenu: false,
      hasRightMenu: false,
      animated: false,
      isAnimated: false,
      isOpen: false,
      styles: {
        transform: 'translate3d(0px, 0, 0)'
      },
      direction: '',
      leftMenuWidth: 160,
      rightMenuWidth: 160
    };
  },

  watch: {
    disabled: function disabled(newVal, oldVal) {
      if (newVal === true && !oldVal) {
        this.setOffset(0, true, true);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swipeout/swipeout-item.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var swipeout_swipeout_item = ({
  name: 'swipeout-item',
  props: {
    sensitivity: {
      type: Number,
      default: 0
    },
    autoCloseOnButtonClick: {
      type: Boolean,
      default: true
    },
    disabled: Boolean,
    threshold: {
      type: Number,
      default: 0.3
    },
    underlayColor: String,
    transitionMode: {
      type: String,
      default: 'reveal'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },

  methods: {
    render: function render() {
      this.target = this.$refs.content;
      if (this.$slots['left-menu']) {
        this.hasLeftMenu = true;
        this.caculateMenuWidth('left');
      }
      if (this.$slots['right-menu']) {
        this.hasRightMenu = true;
        this.caculateMenuWidth('right');
      }
    },
    caculateMenuWidth: function caculateMenuWidth(direction) {
      var list = this.$slots[direction + '-menu'][0].children.filter(function (one) {
        return one.tag;
      });
      var width = 0;
      list.forEach(function (one) {
        var propsData = one.componentOptions ? one.componentOptions.propsData : {};
        width += propsData.width || 80;
      });
      this[direction + 'MenuWidth'] = width;
    },
    onContentClick: function onContentClick() {
      if (this.styles.transform.indexOf('(0px, 0, 0)') === -1) {
        this._setClose(200);
      }
    },
    onItemClick: function onItemClick() {
      if (this.autoCloseOnButtonClick) {
        this._setClose();
      }
    },
    start: function start(ev) {
      if (this.disabled || this.isOpen || ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.$parent.$options._componentTag === 'swipeout') {
        var openItems = this.$parent.$children.filter(function (item) {
          return item.$data.styles.transform.indexOf('(0px, 0, 0)') === -1;
        });
        if (openItems.length > 0) {
          openItems.forEach(function (item) {
            item.setOffset(0, true);
          });
          ev.preventDefault();
          return;
        }
      }
      var touch = ev.touches ? ev.touches[0] : ev;
      this.pageX = touch.pageX;
      this.pageY = touch.pageY;
    },
    move: function move(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        ev.preventDefault();
        return;
      }
      if (this.pageX === undefined) {
        ev.preventDefault();
        return;
      }

      var touch = ev.touches ? ev.touches[0] : ev;
      this.distX = touch.pageX - this.pageX;
      this.distY = touch.pageY - this.pageY;

      if (!this.direction) {
        this.direction = this.distX > 0 ? 'left' : 'right';
      }

      if (this.direction === 'right' && this.distX > 0 && this.hasRightMenu || this.direction === 'left' && this.distX < 0 && this.hasLeftMenu) {
        this.valid = true;
        ev.preventDefault();
      }

      if (this.valid === undefined) {
        if (this.distX > 0 && this.hasLeftMenu === false) {
          this.valid = false;
        } else if (this.distX < 0 && this.hasRightMenu === false) {
          this.valid = false;
        } else if (Math.abs(this.distX) > this.sensitivity || Math.abs(this.distY) > this.sensitivity) {
          this.valid = Math.abs(this.distX) > Math.abs(this.distY);
        } else {
          ev.preventDefault();
        }
      }

      if (this.valid === true) {
        if (Math.abs(this.distX) <= this.menuWidth) {
          this.setOffset(this.distX, false);
        } else {
          var extra = (Math.abs(this.distX) - this.menuWidth) * 0.5;
          var offset = (this.menuWidth + extra) * (this.distX < 0 ? -1 : 1);
          this.setOffset(offset, false);
        }
        ev.preventDefault();
      }
    },
    end: function end(ev) {
      if (this.disabled) {
        return;
      }
      if (ev.target.nodeName.toLowerCase() === 'button') {
        return;
      }
      if (this.valid === true) {
        if (this.distX < 0 && this.direction === 'right') {
          var threshold = this.threshold <= 1 ? this.rightMenuWidth * this.threshold : this.threshold;

          if (this.distX < -threshold) {
            this.setOffset(-this.rightMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        } else if (this.distX > 0 && this.direction === 'left') {
          var _threshold = this.threshold <= 1 ? this.leftMenuWidth * this.threshold : this.threshold;

          if (this.distX > _threshold) {
            this.setOffset(this.leftMenuWidth, true);
            this.$emit('on-open');
            this.isOpen = true;
          } else {
            this._setClose();
          }
        }
      } else if (this.pageX !== undefined) {}

      this.pageX = this.pageY = this.valid = undefined;
      this.direction = '';
    },
    setOffset: function setOffset(x) {
      var _this2 = this;

      var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var force = arguments[2];

      this.isAnimated = animated;
      if (this.disabled && !force) {
        return;
      }
      if (this.direction === 'right' && x > 0 || this.direction === 'left' && x < 0) {
        x = 0;
      }

      if (x === 0) {
        setTimeout(function () {
          _this2.isOpen = false;
        }, 300);
      }

      if (x < 0 && Math.abs(x) === this.rightMenuWidth) {
        this.distX = -this.rightMenuWidth;
      } else if (x > 0 && Math.abs(x) === this.leftMenuWidth) {
        this.distX = this.leftMenuWidth;
      }
      if (animated && this.target) {
        this.target && this.target.classList.add('vux-swipeout-content-animated');
        var cb = function (self, target) {
          return function () {
            target.classList.remove('vux-swipeout-content-animated');
            self.isAnimated = false;
            target.removeEventListener('webkitTransitionEnd', cb);
            target.removeEventListener('transitionend', cb);
          };
        }(this, this.target);

        this.target.addEventListener('webkitTransitionEnd', cb);
        this.target.addEventListener('transitionend', cb);
      }
      this.styles.transform = 'translate3d(' + x + 'px, 0, 0)';
    },
    _setClose: function _setClose() {
      var _this3 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.setOffset(0, true);
      this.$emit('on-close');
      if (!delay) {
        this.isOpen = false;
      } else {
        setTimeout(function () {
          _this3.isOpen = false;
        }, delay);
      }
      this.distX = 0;
    },
    open: function open() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';

      this.setOffset(position === 'right' ? -this.rightMenuWidth : this.leftMenuWidth, true, true);
    },
    close: function close() {
      this.setOffset(0, true, true);
    }
  },
  computed: {
    menuWidth: function menuWidth() {
      if (!this.hasLeftMenu && this.hasRightMenu) {
        return this.rightMenuWidth;
      }
      if (this.hasLeftMenu && !this.hasRightMenu) {
        return this.leftMenuWidth;
      }
      if (this.hasLeftMenu && this.hasRightMenu) {
        return this.distX < 0 ? this.rightMenuWidth : this.leftMenuWidth;
      }
    },
    buttonBoxStyle: function buttonBoxStyle() {
      return {
        backgroundColor: this.underlayColor
      };
    },
    leftButtonBoxStyle: function leftButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.leftMenuWidth - this.distX : this.leftMenuWidth;
        styles.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      }
      return styles;
    },
    rightButtonBoxStyle: function rightButtonBoxStyle() {
      var styles = JSON.parse(stringify_default()(this.buttonBoxStyle));
      if (this.transitionMode === 'follow') {
        var offset = this.styles.transform.indexOf('(0px, 0, 0)') === -1 ? this.rightMenuWidth - Math.abs(this.distX) : this.rightMenuWidth;
        if (offset < 0) {
          offset = 0;
        }
        if (this.isAnimated) {
          styles.transition = 'transform 0.2s';
        }
        styles.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }
      return styles;
    }
  },
  data: function data() {
    return {
      pageX: undefined,
      pageY: undefined,
      distX: 0,
      distY: 0,
      hasLeftMenu: false,
      hasRightMenu: false,
      animated: false,
      isAnimated: false,
      isOpen: false,
      styles: {
        transform: 'translate3d(0px, 0, 0)'
      },
      direction: '',
      leftMenuWidth: 160,
      rightMenuWidth: 160
    };
  },

  watch: {
    disabled: function disabled(newVal, oldVal) {
      if (newVal === true && !oldVal) {
        this.setOffset(0, true, true);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5af13bd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swipeout/swipeout-item.vue
var swipeout_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swipeout-item",on:{"touchstart":_vm.start,"mousedown":_vm.start,"touchmove":_vm.move,"mousemove":_vm.move,"touchend":_vm.end,"mouseup":_vm.end,"touchcancel":_vm.end}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.distX >= 0),expression:"distX >= 0"}],staticClass:"vux-swipeout-button-box vux-swipeout-button-box-left",style:(_vm.leftButtonBoxStyle)},[_vm._t("left-menu")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.distX <= 0),expression:"distX <= 0"}],staticClass:"vux-swipeout-button-box",style:(_vm.rightButtonBoxStyle)},[_vm._t("right-menu")],2),_vm._v(" "),_c('div',{ref:"content",staticClass:"vux-swipeout-content",style:(_vm.styles),on:{"mousedown":_vm.onContentClick,"touchstart":_vm.onContentClick}},[_vm._t("content")],2)])}
var swipeout_item_staticRenderFns = []
var swipeout_item_esExports = { render: swipeout_item_render, staticRenderFns: swipeout_item_staticRenderFns }
/* harmony default export */ var components_swipeout_swipeout_item = (swipeout_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swipeout/swipeout-item.vue
var swipeout_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swipeout_item___vue_template_functional__ = false
/* styles */
var swipeout_item___vue_styles__ = null
/* scopeId */
var swipeout_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swipeout_item___vue_module_identifier__ = null
var swipeout_item_Component = swipeout_item_normalizeComponent(
  swipeout_swipeout_item,
  components_swipeout_swipeout_item,
  swipeout_item___vue_template_functional__,
  swipeout_item___vue_styles__,
  swipeout_item___vue_scopeId__,
  swipeout_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swipeout_swipeout_item = (swipeout_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/assistantinfo/assistantinfo.vue








/* harmony default export */ var assistantinfo = ({
  name: "assistantinfo",
  components: { Swipeout: src_components_swipeout_swipeout, SwipeoutItem: src_components_swipeout_swipeout_item, SwipeoutButton: src_components_swipeout_swipeout_button, XButton: vux_src_components_x_button, XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      dataList: [],
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      total: 0,
      seq: this.$route.query.seq,
      role: this.$route.query.role,
      type: this.$route.query.type,
      isAdd: true
    };
  },

  methods: {
    addassistant: function addassistant() {
      this.$router.push({ name: 'assistant', query: { role: this.role, seq: this.seq, type: this.type } });
    },
    getInfo: function getInfo() {
      var _this = this;

      if (this.role === 'ADMIN' || this.type === 'done' || this.type === 'closed' || this.type === 'accept') {
        this.isAdd = false;
      }
      this.dataList = [];
      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=EXPT&offset=0&count=20', this.header).then(function (response) {
        _this.dataList = [].concat(toConsumableArray_default()(_this.dataList), toConsumableArray_default()(response.data.content));
        _this.total = response.data.total;
      });
    },
    more: function more() {
      var _this2 = this;

      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=EXPT&offset=' + this.dataList.length + '&count=20', this.header).then(function (response) {
        _this2.dataList = [].concat(toConsumableArray_default()(_this2.dataList), toConsumableArray_default()(response.data.content));
        _this2.total = response.data.total;
      });
    },
    onButtonClick: function onButtonClick(userid) {
      var _this3 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/set_repair_visible_to', {
        role: this.role,
        userid: userid.toString(),
        user_type: 'EXPT',
        visible: false
      }, this.header).then(function () {
        _this3.getInfo();
      }).catch(function (error) {
        _this3.$vux.alert.show({
          text: JSON.parse(error.response.data.error_message).faultstring,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  created: function created() {
    this.getInfo();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/assistantinfo/assistantinfo.vue








/* harmony default export */ var assistantinfo_assistantinfo = ({
  name: "assistantinfo",
  components: { Swipeout: src_components_swipeout_swipeout, SwipeoutItem: src_components_swipeout_swipeout_item, SwipeoutButton: src_components_swipeout_swipeout_button, XButton: vux_src_components_x_button, XHeader: vux_src_components_x_header },
  data: function data() {
    return {
      dataList: [],
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      total: 0,
      seq: this.$route.query.seq,
      role: this.$route.query.role,
      type: this.$route.query.type,
      isAdd: true
    };
  },

  methods: {
    addassistant: function addassistant() {
      this.$router.push({ name: 'assistant', query: { role: this.role, seq: this.seq, type: this.type } });
    },
    getInfo: function getInfo() {
      var _this = this;

      if (this.role === 'ADMIN' || this.type === 'done' || this.type === 'closed' || this.type === 'accept') {
        this.isAdd = false;
      }
      this.dataList = [];
      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=EXPT&offset=0&count=20', this.header).then(function (response) {
        _this.dataList = [].concat(toConsumableArray_default()(_this.dataList), toConsumableArray_default()(response.data.content));
        _this.total = response.data.total;
      });
    },
    more: function more() {
      var _this2 = this;

      this.$http.get('/api/v1/normalrepairs/' + this.seq + '/list_repair_visible_to?role=EXPT&offset=' + this.dataList.length + '&count=20', this.header).then(function (response) {
        _this2.dataList = [].concat(toConsumableArray_default()(_this2.dataList), toConsumableArray_default()(response.data.content));
        _this2.total = response.data.total;
      });
    },
    onButtonClick: function onButtonClick(userid) {
      var _this3 = this;

      this.$http.post('/api/v1/normalrepairs/' + this.seq + '/set_repair_visible_to', {
        role: this.role,
        userid: userid.toString(),
        user_type: 'EXPT',
        visible: false
      }, this.header).then(function () {
        _this3.getInfo();
      }).catch(function (error) {
        _this3.$vux.alert.show({
          text: JSON.parse(error.response.data.error_message).faultstring,
          type: 'cancel',
          time: '1000'
        });
      });
    }
  },
  created: function created() {
    this.getInfo();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484bf92b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assistantinfo/assistantinfo.vue
var assistantinfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',[_vm._v("协助人信息")]),_vm._v(" "),_c('swipeout',_vm._l((_vm.dataList),function(item,index){return _c('swipeout-item',{key:index,staticClass:"background-black",staticStyle:{"border-bottom":"1px solid #eee"},attrs:{"transition-mode":"follow"}},[_c('div',{attrs:{"slot":"right-menu"},slot:"right-menu"},[_c('swipeout-button',{attrs:{"type":"warn"},nativeOn:{"click":function($event){_vm.onButtonClick(item.userid)}}},[_vm._v("删除")])],1),_vm._v(" "),_c('div',{staticClass:"demo-content vux-1px-t",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n        "+_vm._s(item.name)+"--"+_vm._s(item.mobile)+"\n      ")])])})),_vm._v(" "),(_vm.isAdd)?_c('x-button',{staticStyle:{"margin":"1rem 0"},attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.addassistant($event)}}},[_vm._v("添加协助人")]):_vm._e(),_vm._v(" "),(_vm.dataList.length !== _vm.total)?_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){_vm.more()}}},[_vm._v("更多")]):_vm._e()],1)}
var assistantinfo_staticRenderFns = []
var assistantinfo_esExports = { render: assistantinfo_render, staticRenderFns: assistantinfo_staticRenderFns }
/* harmony default export */ var components_assistantinfo_assistantinfo = (assistantinfo_esExports);
// CONCATENATED MODULE: ./src/components/assistantinfo/assistantinfo.vue
function assistantinfo_injectStyle (ssrContext) {
  __webpack_require__("2Cg7")
}
var assistantinfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var assistantinfo___vue_template_functional__ = false
/* styles */
var assistantinfo___vue_styles__ = assistantinfo_injectStyle
/* scopeId */
var assistantinfo___vue_scopeId__ = "data-v-484bf92b"
/* moduleIdentifier (server only) */
var assistantinfo___vue_module_identifier__ = null
var assistantinfo_Component = assistantinfo_normalizeComponent(
  assistantinfo_assistantinfo,
  components_assistantinfo_assistantinfo,
  assistantinfo___vue_template_functional__,
  assistantinfo___vue_styles__,
  assistantinfo___vue_scopeId__,
  assistantinfo___vue_module_identifier__
)

/* harmony default export */ var src_components_assistantinfo_assistantinfo = (assistantinfo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/assistantinfo/assistantorder.vue








/* harmony default export */ var assistantorder = ({
  name: "assistantorder",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      type: 'false',
      isAdmin: true,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    goToRepair: function goToRepair(seq) {
      this.$router.push({ name: 'normalcomplete', query: { seq: seq, role: 'EXPT' } });
    },
    unfinished: function unfinished() {
      var _this = this;

      this.dataList = [];
      this.$http.get('/api/v1/normalrepairs/list_repair_visible_to_me?closed=false&role=EXPT&offset=0&count=10', this.header).then(function (response) {
        _this.dataList = [].concat(toConsumableArray_default()(_this.dataList), toConsumableArray_default()(response.data.content));
        _this.total = response.data.total;
      });
    },
    finished: function finished() {
      var _this2 = this;

      this.dataList = [];
      this.$http.get('api/v1/normalrepairs/list_repair_visible_to_me?closed=true&role=EXPT&offset=0&count=10', this.header).then(function (response) {
        _this2.dataList = [].concat(toConsumableArray_default()(_this2.dataList), toConsumableArray_default()(response.data.content));
        _this2.total = response.data.total;
      });
    },
    more: function more() {
      var _this3 = this;

      this.$http.get('api/v1/normalrepairs/list_repair_visible_to_me?role=EXPT&offset=' + this.dataList.length + '&count=10&closed=' + this.type, this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content));
        _this3.total = response.data.total;
      });
    }
  },
  created: function created() {
    var _this4 = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      if (res.data.length !== 0) {
        res.data.forEach(function (item) {
          if (item.role === 'EXPT') {
            var account = item.account;
            localStorage.setItem('account', account);
            _this4.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
              localStorage.setItem('token', res.data.token);
              localStorage.setItem('userid', res.data.userid);
              _this4.header = {
                headers: {
                  token: res.data.token,
                  opid: res.data.userid
                }
              };
              _this4.unfinished();
            });
          }
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/assistantinfo/assistantorder.vue








/* harmony default export */ var assistantinfo_assistantorder = ({
  name: "assistantorder",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      type: 'false',
      isAdmin: true,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    goToRepair: function goToRepair(seq) {
      this.$router.push({ name: 'normalcomplete', query: { seq: seq, role: 'EXPT' } });
    },
    unfinished: function unfinished() {
      var _this = this;

      this.dataList = [];
      this.$http.get('/api/v1/normalrepairs/list_repair_visible_to_me?closed=false&role=EXPT&offset=0&count=10', this.header).then(function (response) {
        _this.dataList = [].concat(toConsumableArray_default()(_this.dataList), toConsumableArray_default()(response.data.content));
        _this.total = response.data.total;
      });
    },
    finished: function finished() {
      var _this2 = this;

      this.dataList = [];
      this.$http.get('api/v1/normalrepairs/list_repair_visible_to_me?closed=true&role=EXPT&offset=0&count=10', this.header).then(function (response) {
        _this2.dataList = [].concat(toConsumableArray_default()(_this2.dataList), toConsumableArray_default()(response.data.content));
        _this2.total = response.data.total;
      });
    },
    more: function more() {
      var _this3 = this;

      this.$http.get('api/v1/normalrepairs/list_repair_visible_to_me?role=EXPT&offset=' + this.dataList.length + '&count=10&closed=' + this.type, this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content));
        _this3.total = response.data.total;
      });
    }
  },
  created: function created() {
    var _this4 = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      if (res.data.length !== 0) {
        res.data.forEach(function (item) {
          if (item.role === 'EXPT') {
            var account = item.account;
            localStorage.setItem('account', account);
            _this4.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
              localStorage.setItem('token', res.data.token);
              localStorage.setItem('userid', res.data.userid);
              _this4.header = {
                headers: {
                  token: res.data.token,
                  opid: res.data.userid
                }
              };
              _this4.unfinished();
            });
          }
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8d4ee7e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assistantinfo/assistantorder.vue
var assistantorder_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tab',[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.unfinished}},[_vm._v("未完成")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.finished}},[_vm._v("已完成")])],1),_vm._v(" "),_c('group',_vm._l((_vm.dataList),function(item,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'normalcomplete', query: { seq: item['seq'],role:'EXPT' }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(item.devname))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(item.start))])])])})),_vm._v(" "),(_vm.dataList.length !== _vm.total)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){_vm.more()}}},[_vm._v("更多\n  ")]):_vm._e()],1)}
var assistantorder_staticRenderFns = []
var assistantorder_esExports = { render: assistantorder_render, staticRenderFns: assistantorder_staticRenderFns }
/* harmony default export */ var components_assistantinfo_assistantorder = (assistantorder_esExports);
// CONCATENATED MODULE: ./src/components/assistantinfo/assistantorder.vue
function assistantorder_injectStyle (ssrContext) {
  __webpack_require__("CUAD")
}
var assistantorder_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var assistantorder___vue_template_functional__ = false
/* styles */
var assistantorder___vue_styles__ = assistantorder_injectStyle
/* scopeId */
var assistantorder___vue_scopeId__ = "data-v-d8d4ee7e"
/* moduleIdentifier (server only) */
var assistantorder___vue_module_identifier__ = null
var assistantorder_Component = assistantorder_normalizeComponent(
  assistantinfo_assistantorder,
  components_assistantinfo_assistantorder,
  assistantorder___vue_template_functional__,
  assistantorder___vue_styles__,
  assistantorder___vue_scopeId__,
  assistantorder___vue_module_identifier__
)

/* harmony default export */ var src_components_assistantinfo_assistantorder = (assistantorder_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53380570","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-table/index.vue
var x_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"vux-table",class:{'vux-table-bordered': _vm.fullBordered, 'vux-table-no-cell-bordered': !_vm.cellBordered, 'vux-table-no-content-bordered': !_vm.contentBordered}},[_vm._t("default")],2)}
var x_table_staticRenderFns = []
var x_table_esExports = { render: x_table_render, staticRenderFns: x_table_staticRenderFns }
/* harmony default export */ var src_components_x_table = (x_table_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-table/index.vue
function x_table_injectStyle (ssrContext) {
  __webpack_require__("+O8B")
}
var x_table_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_table___vue_template_functional__ = false
/* styles */
var x_table___vue_styles__ = x_table_injectStyle
/* scopeId */
var x_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_table___vue_module_identifier__ = null
var x_table_Component = x_table_normalizeComponent(
  components_x_table,
  src_components_x_table,
  x_table___vue_template_functional__,
  x_table___vue_styles__,
  x_table___vue_scopeId__,
  x_table___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_table = (x_table_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-qr/dist/vue-qr.js
var vue_qr = __webpack_require__("PUIo");
var vue_qr_default = /*#__PURE__*/__webpack_require__.n(vue_qr);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/certificate/viwocertificate.vue











/* harmony default export */ var viwocertificate = ({
  name: "viwocertificate",
  components: { XTable: vux_src_components_x_table, vueQr: vue_qr_default.a, XButton: vux_src_components_x_button, Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item },
  data: function data() {
    return {
      info: {},
      url: '',
      isImg: true,
      color: false,
      value: this.$route.query.seq,
      setting: this.$route.query.setting,
      header: {},
      imgList: [],
      list: [],
      infoList: [],
      src: ''
    };
  },

  methods: {
    showList: function showList() {
      this.$router.push({ name: 'viwocertificatelist' });
    },
    drawImg: function drawImg(imageUrl, item, index) {
      var _this = this;

      console.log(item);
      var canvas = document.getElementById("mycanvas");
      var context = canvas.getContext('2d');
      var img = new Image();
      img.src = imageUrl;

      img.onload = function () {
        if (img.complete) {

          canvas.setAttribute("width", img.width);
          canvas.setAttribute("height", img.height);

          context.drawImage(img, 0, 0, img.width, img.height);

          context.font = "120px Arial";
          context.fillStyle = 'black';
          context.textBaseline = 'top';
          context.fillText(item.state === 'OK' ? item.seq : 'XXXXXXXX', 1800, 395);

          context.font = "115px 宋体";
          context.fillStyle = 'black';
          context.textBaseline = 'top';
          var str = item.state === 'OK' ? ('已通过' + item.company + '相关培训和考核，符合条件。被认证为：').split('') : '您还没有通过北京精一强远科技有限公司考核认证，请联系您的授权单位进行审核认证为：'.split('');
          var company = '';
          var arr = [];
          var maxwidth = 1760;
          for (var i = 0; i < str.length; i++) {
            if (context.measureText(company).width < maxwidth && context.measureText(company + str[i]).width <= maxwidth) {
              company += str[i] + ' ';
            } else {
              maxwidth = 2000;
              arr.push(company);
              company = str[i] + '';
            }
          }
          arr.push(company);
          arr.forEach(function (item, index) {
            var x = index === 0 ? 480 : 240;
            context.fillText(item, x, 1650 + (index + 1) * 165);
          });

          context.font = "120px Arial";
          context.fillStyle = 'black';
          context.textBaseline = 'top';
          context.fillText(item.state === 'OK' ? item.start + ' ~ ' + item.end : '', 700, 2970);

          context.font = "300px Arial";
          context.fillStyle = 'black';
          context.textAlign = "center";
          context.textBaseline = 'top';
          context.fillText(item.name, 1240, 1200);

          context.drawImage(_this.$refs.vqr.getElementsByTagName('img')[index], 790, 3130, 900, 900);
          var src = canvas.toDataURL('image/png');
          _this.imgList.push(src);
        }
      };
    },
    setCert: function setCert() {
      var _this2 = this;

      this.$http.get('api/v1/certs/set_cert_default?seq=' + this.value, this.header).then(function (response) {
        _this2.$vux.alert.show({
          title: '',
          content: '设置成功'
        });
        _this2.$router.push({ name: 'viwocertificatelist' });
      }).catch(function (error) {
        _this2.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    setUsed: function setUsed(bol) {
      var _this3 = this;

      this.$http.get('api/v1/certs/set_cert_used?seq=' + this.value + '&used=' + bol, this.header).then(function (response) {
        _this3.$vux.alert.show({
          title: '',
          content: '设置成功'
        });
        _this3.$router.push({ name: 'viwocertificatelist' });
      }).catch(function (error) {
        _this3.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    changeIndex: function changeIndex(index) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(index);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }
  },
  created: function created() {
    var _this5 = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$vux.loading.show({ text: '加载中' });
    this.$http.get('static/config.json').then(function (response) {
      _this5.url = response.data.host;
    });
    this.$http.get('api/v1/wechat/' + unionid).then(function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(res) {
        var account, response, value, type, _response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, index, photo;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                account = void 0;

                res.data.forEach(function (item) {
                  if (item.role === 'EXPT') {
                    account = item.account;
                  }
                });
                response = void 0;

                if (!(!_this5.value || _this5.setting)) {
                  _context3.next = 14;
                  break;
                }

                if (!account) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 7;
                return _this5.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account });

              case 7:
                response = _context3.sent;

                _this5.header = {
                  headers: {
                    token: response.data.token,
                    opid: response.data.userid
                  }
                };
                _context3.next = 14;
                break;

              case 11:
                _this5.$vux.loading.hide();
                localStorage.setItem('viwocertificate', 'viwocertificate');
                _this5.$router.push({ name: 'vip' });

              case 14:
                value = _this5.value ? _this5.value : response.data.userid;
                type = _this5.value ? 'seq' : 'userid';

                if (!(type === 'seq')) {
                  _context3.next = 21;
                  break;
                }

                _this5.$http.get('api/v1/certs/get_cert?' + type + '=' + value).then(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(response) {
                    var photo;
                    return regenerator_default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this5.isImg = !_this5.value;
                            _context2.next = 3;
                            return _this5.$http.get('api/v1/photos?path=' + response.data.signet, _this5.header);

                          case 3:
                            photo = _context2.sent;

                            _this5.src = 'data:image/jpeg;base64,' + photo.data.value;
                            _this5.info = response.data;
                            _this5.value = response.data.seq;
                            _context2.t0 = _this5.info.state;
                            _context2.next = _context2.t0 === 'OK' ? 10 : _context2.t0 === 'WAIT_AUDIT' ? 12 : _context2.t0 === 'NO' ? 15 : _context2.t0 === 'EXPIRED' ? 19 : _context2.t0 === 'BLACKED' ? 23 : 27;
                            break;

                          case 10:
                            _this5.showImg();
                            return _context2.abrupt('break', 27);

                          case 12:
                            _this5.info.seq = '待审核';
                            _this5.color = true;
                            return _context2.abrupt('break', 27);

                          case 15:
                            _this5.showImg();
                            _this5.info.seq = '待授权单位认证录入';
                            _this5.color = true;
                            return _context2.abrupt('break', 27);

                          case 19:
                            _this5.info.seq = '已过期，需重新认证';
                            _this5.color = true;
                            _this5.isImg = false;
                            return _context2.abrupt('break', 27);

                          case 23:
                            _this5.info.seq = '无效证书';
                            _this5.color = true;
                            _this5.isImg = false;
                            return _context2.abrupt('break', 27);

                          case 27:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this5);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                _this5.$vux.loading.hide();
                _context3.next = 63;
                break;

              case 21:
                _context3.next = 23;
                return _this5.$http.get('/api/v1/certs/get_cert?' + type + '=' + value);

              case 23:
                _response = _context3.sent;

                _this5.infoList = _response.data;

                if (!(_response.data !== 0)) {
                  _context3.next = 62;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 29;
                _iterator = get_iterator_default()(_this5.infoList);

              case 31:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 44;
                  break;
                }

                item = _step.value;
                index = _this5.infoList.indexOf(item);

                _this5.value = _this5.infoList[index].seq;
                _this5.info = _this5.infoList[index];

                if (!_this5.info.inuse) {
                  _context3.next = 41;
                  break;
                }

                _context3.next = 39;
                return _this5.$http.get('api/photos?path=' + _this5.info.photo, _this5.header);

              case 39:
                photo = _context3.sent;

                _this5.drawImg('data:image/jpeg;base64,' + photo.data.value, item, index);

              case 41:
                _iteratorNormalCompletion = true;
                _context3.next = 31;
                break;

              case 44:
                _context3.next = 50;
                break;

              case 46:
                _context3.prev = 46;
                _context3.t0 = _context3['catch'](29);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 50:
                _context3.prev = 50;
                _context3.prev = 51;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 53:
                _context3.prev = 53;

                if (!_didIteratorError) {
                  _context3.next = 56;
                  break;
                }

                throw _iteratorError;

              case 56:
                return _context3.finish(53);

              case 57:
                return _context3.finish(50);

              case 58:
                _this5.list = _this5.imgList;
                _this5.$vux.loading.hide();
                _context3.next = 63;
                break;

              case 62:
                alert('暂无证书');

              case 63:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[29, 46, 50, 58], [51,, 53, 57]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/certificate/viwocertificate.vue











/* harmony default export */ var certificate_viwocertificate = ({
  name: "viwocertificate",
  components: { XTable: vux_src_components_x_table, vueQr: vue_qr_default.a, XButton: vux_src_components_x_button, Swiper: vux_src_components_swiper_swiper, SwiperItem: src_components_swiper_swiper_item },
  data: function data() {
    return {
      info: {},
      url: '',
      isImg: true,
      color: false,
      value: this.$route.query.seq,
      setting: this.$route.query.setting,
      header: {},
      imgList: [],
      list: [],
      infoList: [],
      src: ''
    };
  },

  methods: {
    showList: function showList() {
      this.$router.push({ name: 'viwocertificatelist' });
    },
    drawImg: function drawImg(imageUrl, item, index) {
      var _this = this;

      console.log(item);
      var canvas = document.getElementById("mycanvas");
      var context = canvas.getContext('2d');
      var img = new Image();
      img.src = imageUrl;

      img.onload = function () {
        if (img.complete) {

          canvas.setAttribute("width", img.width);
          canvas.setAttribute("height", img.height);

          context.drawImage(img, 0, 0, img.width, img.height);

          context.font = "120px Arial";
          context.fillStyle = 'black';
          context.textBaseline = 'top';
          context.fillText(item.state === 'OK' ? item.seq : 'XXXXXXXX', 1800, 395);

          context.font = "115px 宋体";
          context.fillStyle = 'black';
          context.textBaseline = 'top';
          var str = item.state === 'OK' ? ('已通过' + item.company + '相关培训和考核，符合条件。被认证为：').split('') : '您还没有通过北京精一强远科技有限公司考核认证，请联系您的授权单位进行审核认证为：'.split('');
          var company = '';
          var arr = [];
          var maxwidth = 1760;
          for (var i = 0; i < str.length; i++) {
            if (context.measureText(company).width < maxwidth && context.measureText(company + str[i]).width <= maxwidth) {
              company += str[i] + ' ';
            } else {
              maxwidth = 2000;
              arr.push(company);
              company = str[i] + '';
            }
          }
          arr.push(company);
          arr.forEach(function (item, index) {
            var x = index === 0 ? 480 : 240;
            context.fillText(item, x, 1650 + (index + 1) * 165);
          });

          context.font = "120px Arial";
          context.fillStyle = 'black';
          context.textBaseline = 'top';
          context.fillText(item.state === 'OK' ? item.start + ' ~ ' + item.end : '', 700, 2970);

          context.font = "300px Arial";
          context.fillStyle = 'black';
          context.textAlign = "center";
          context.textBaseline = 'top';
          context.fillText(item.name, 1240, 1200);

          context.drawImage(_this.$refs.vqr.getElementsByTagName('img')[index], 790, 3130, 900, 900);
          var src = canvas.toDataURL('image/png');
          _this.imgList.push(src);
        }
      };
    },
    setCert: function setCert() {
      var _this2 = this;

      this.$http.get('api/v1/certs/set_cert_default?seq=' + this.value, this.header).then(function (response) {
        _this2.$vux.alert.show({
          title: '',
          content: '设置成功'
        });
        _this2.$router.push({ name: 'viwocertificatelist' });
      }).catch(function (error) {
        _this2.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    setUsed: function setUsed(bol) {
      var _this3 = this;

      this.$http.get('api/v1/certs/set_cert_used?seq=' + this.value + '&used=' + bol, this.header).then(function (response) {
        _this3.$vux.alert.show({
          title: '',
          content: '设置成功'
        });
        _this3.$router.push({ name: 'viwocertificatelist' });
      }).catch(function (error) {
        _this3.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    changeIndex: function changeIndex(index) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(index);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    }
  },
  created: function created() {
    var _this5 = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$vux.loading.show({ text: '加载中' });
    this.$http.get('static/config.json').then(function (response) {
      _this5.url = response.data.host;
    });
    this.$http.get('api/v1/wechat/' + unionid).then(function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(res) {
        var account, response, value, type, _response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, index, photo;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                account = void 0;

                res.data.forEach(function (item) {
                  if (item.role === 'EXPT') {
                    account = item.account;
                  }
                });
                response = void 0;

                if (!(!_this5.value || _this5.setting)) {
                  _context3.next = 14;
                  break;
                }

                if (!account) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 7;
                return _this5.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account });

              case 7:
                response = _context3.sent;

                _this5.header = {
                  headers: {
                    token: response.data.token,
                    opid: response.data.userid
                  }
                };
                _context3.next = 14;
                break;

              case 11:
                _this5.$vux.loading.hide();
                localStorage.setItem('viwocertificate', 'viwocertificate');
                _this5.$router.push({ name: 'vip' });

              case 14:
                value = _this5.value ? _this5.value : response.data.userid;
                type = _this5.value ? 'seq' : 'userid';

                if (!(type === 'seq')) {
                  _context3.next = 21;
                  break;
                }

                _this5.$http.get('api/v1/certs/get_cert?' + type + '=' + value).then(function () {
                  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(response) {
                    var photo;
                    return regenerator_default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this5.isImg = !_this5.value;
                            _context2.next = 3;
                            return _this5.$http.get('api/v1/photos?path=' + response.data.signet, _this5.header);

                          case 3:
                            photo = _context2.sent;

                            _this5.src = 'data:image/jpeg;base64,' + photo.data.value;
                            _this5.info = response.data;
                            _this5.value = response.data.seq;
                            _context2.t0 = _this5.info.state;
                            _context2.next = _context2.t0 === 'OK' ? 10 : _context2.t0 === 'WAIT_AUDIT' ? 12 : _context2.t0 === 'NO' ? 15 : _context2.t0 === 'EXPIRED' ? 19 : _context2.t0 === 'BLACKED' ? 23 : 27;
                            break;

                          case 10:
                            _this5.showImg();
                            return _context2.abrupt('break', 27);

                          case 12:
                            _this5.info.seq = '待审核';
                            _this5.color = true;
                            return _context2.abrupt('break', 27);

                          case 15:
                            _this5.showImg();
                            _this5.info.seq = '待授权单位认证录入';
                            _this5.color = true;
                            return _context2.abrupt('break', 27);

                          case 19:
                            _this5.info.seq = '已过期，需重新认证';
                            _this5.color = true;
                            _this5.isImg = false;
                            return _context2.abrupt('break', 27);

                          case 23:
                            _this5.info.seq = '无效证书';
                            _this5.color = true;
                            _this5.isImg = false;
                            return _context2.abrupt('break', 27);

                          case 27:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this5);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
                _this5.$vux.loading.hide();
                _context3.next = 63;
                break;

              case 21:
                _context3.next = 23;
                return _this5.$http.get('/api/v1/certs/get_cert?' + type + '=' + value);

              case 23:
                _response = _context3.sent;

                _this5.infoList = _response.data;

                if (!(_response.data !== 0)) {
                  _context3.next = 62;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 29;
                _iterator = get_iterator_default()(_this5.infoList);

              case 31:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 44;
                  break;
                }

                item = _step.value;
                index = _this5.infoList.indexOf(item);

                _this5.value = _this5.infoList[index].seq;
                _this5.info = _this5.infoList[index];

                if (!_this5.info.inuse) {
                  _context3.next = 41;
                  break;
                }

                _context3.next = 39;
                return _this5.$http.get('api/photos?path=' + _this5.info.photo, _this5.header);

              case 39:
                photo = _context3.sent;

                _this5.drawImg('data:image/jpeg;base64,' + photo.data.value, item, index);

              case 41:
                _iteratorNormalCompletion = true;
                _context3.next = 31;
                break;

              case 44:
                _context3.next = 50;
                break;

              case 46:
                _context3.prev = 46;
                _context3.t0 = _context3['catch'](29);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 50:
                _context3.prev = 50;
                _context3.prev = 51;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 53:
                _context3.prev = 53;

                if (!_didIteratorError) {
                  _context3.next = 56;
                  break;
                }

                throw _iteratorError;

              case 56:
                return _context3.finish(53);

              case 57:
                return _context3.finish(50);

              case 58:
                _this5.list = _this5.imgList;
                _this5.$vux.loading.hide();
                _context3.next = 63;
                break;

              case 62:
                alert('暂无证书');

              case 63:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[29, 46, 50, 58], [51,, 53, 57]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7a0e648","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/certificate/viwocertificate.vue
var viwocertificate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticStyle:{"height":"100%"}},[(!_vm.isImg)?_c('div',{staticStyle:{"padding":"10px"}},[_c('x-table',{attrs:{"full-bordered":""}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"width":"35%"}},[_vm._v("专家姓名：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.info.name))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("证书编号：")]),_vm._v(" "),_c('td',{style:({'color':_vm.color?'red':'white'})},[_vm._v(_vm._s(_vm.info.seq))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("专家级别：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.info.level))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("执业产品类别：")]),_vm._v(" "),_c('td',_vm._l((_vm.info.lines),function(item,index){return _c('span',{key:index},[(index !== 0)?[_vm._v(",")]:_vm._e(),_vm._v(_vm._s(item)+"\n      ")],2)}))]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("授权单位：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.info.company))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("有效期：")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.info.start)+" — "+_vm._s(_vm.info.end))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("最高社会职称：")]),_vm._v(" "),_c('td',_vm._l((_vm.info.titles),function(item,index){return _c('span',{key:index},[(index !== 0)?[_vm._v(",")]:_vm._e(),_vm._v(_vm._s(item)+"\n      ")],2)}))])])]),_vm._v(" "),_c('img',{staticClass:"chapter_img",style:({'display': _vm.color ? 'none':'block'}),attrs:{"src":_vm.src,"alt":""}}),_vm._v(" "),(_vm.setting)?_c('div',{staticStyle:{"margin":"15px 5px 0 5px"}},[(!_vm.info.deft)?_c('x-button',{staticStyle:{"margin":"5px 0"},nativeOn:{"click":function($event){return _vm.setCert($event)}}},[_vm._v("设置默认")]):_vm._e(),_vm._v(" "),(!_vm.info.inuse)?_c('x-button',{staticStyle:{"margin":"5px 0"},nativeOn:{"click":function($event){_vm.setUsed(true)}}},[_vm._v("启用")]):_vm._e(),_vm._v(" "),(_vm.info.inuse)?_c('x-button',{staticStyle:{"margin":"5px 0"},nativeOn:{"click":function($event){_vm.setUsed(false)}}},[_vm._v("禁用")]):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('canvas',{attrs:{"id":"mycanvas"}}),_vm._v(" "),_c('div',{ref:"vqr",staticStyle:{"display":"none"}},_vm._l((_vm.infoList),function(item,index){return _c('div',{key:'aaa'+index},[_c('vue-qr',{staticStyle:{"display":"none"},attrs:{"text":_vm.url + '/viwocertificate?seq=' + item.seq,"margin":0,"size":900}})],1)})),_vm._v(" "),(_vm.isImg)?[_c('swiper',{attrs:{"height":'100%'}},_vm._l((_vm.list),function(item,index){return _c('swiper-item',{key:index,staticClass:"swiper-demo-img"},[_c('img',{staticStyle:{"display":"block","height":"100%","margin":"0 auto"},attrs:{"src":item}})])}))]:_vm._e(),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-ionic-outline icon",attrs:{"type":"ios-ionic-outline","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":_vm.showList}},[_c('path',{attrs:{"d":"M425.5 134.8c4.7-5.9 7.5-13.5 7.5-21.6 0-19.2-15.6-34.9-34.8-34.9-8.2 0-15.7 2.8-21.6 7.5-34-24.2-75-37.8-119.9-37.8C141.8 48 48 140.5 48 255.6S141.7 464 256.6 464C371.5 464 464 370.7 464 255.6c0-45-14.3-86.7-38.5-120.8zM398 91.3c12.2 0 22 9.9 22 22 0 12.2-9.9 22-22 22-12.2 0-22-9.9-22-22s9.8-22 22-22zm-6.2 300.4c-17.6 17.6-38.2 31.6-61.1 41.3-23.7 10-48.2 15.2-74.2 15.2-25.9 0-51.7-5.1-75.4-15.2-22.9-9.7-43.4-23.5-61.1-41.3-17.6-17.6-31.5-38.3-41.2-61.2-10-23.7-15.1-48.9-15.1-74.9 0-25.9 5.1-51.2 15.1-74.9 9.7-22.9 23.5-43.5 41.2-61.2s38.2-31.6 61.1-41.3c23.7-10 49.4-14.1 75.4-14.1 25.9 0 50.5 4 74.2 14.1 12.7 5.4 24.7 12.1 35.9 20-2.1 4.5-3.3 9.5-3.3 14.9 0 19.2 15.6 34.9 34.8 34.9 5.3 0 10.3-1.2 14.9-3.3 7.9 11.2 14.6 23.2 20 36 10 23.7 15.1 48.9 15.1 74.9 0 25.9-5.1 51.2-15.1 74.9-9.7 22.9-23.5 43.5-41.2 61.2z"}}),_c('path',{attrs:{"d":"M256.5 160.1c-53 0-96 42.8-96 95.9s42.9 96.1 96 96.1c53 0 96-43 96-96.1s-43-95.9-96-95.9zm0 175.7c-44.1 0-79.7-35.8-79.7-79.8 0-44.1 35.6-79.6 79.7-79.6s79.7 35.6 79.7 79.6c0 44.1-35.7 79.8-79.7 79.8z"}})])],2)}
var viwocertificate_staticRenderFns = []
var viwocertificate_esExports = { render: viwocertificate_render, staticRenderFns: viwocertificate_staticRenderFns }
/* harmony default export */ var components_certificate_viwocertificate = (viwocertificate_esExports);
// CONCATENATED MODULE: ./src/components/certificate/viwocertificate.vue
function viwocertificate_injectStyle (ssrContext) {
  __webpack_require__("oKmF")
}
var viwocertificate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var viwocertificate___vue_template_functional__ = false
/* styles */
var viwocertificate___vue_styles__ = viwocertificate_injectStyle
/* scopeId */
var viwocertificate___vue_scopeId__ = "data-v-d7a0e648"
/* moduleIdentifier (server only) */
var viwocertificate___vue_module_identifier__ = null
var viwocertificate_Component = viwocertificate_normalizeComponent(
  certificate_viwocertificate,
  components_certificate_viwocertificate,
  viwocertificate___vue_template_functional__,
  viwocertificate___vue_styles__,
  viwocertificate___vue_scopeId__,
  viwocertificate___vue_module_identifier__
)

/* harmony default export */ var src_components_certificate_viwocertificate = (viwocertificate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/job/resume.vue



/* harmony default export */ var resume = ({
  name: "resume",
  components: { Card: vux_src_components_card },
  data: function data() {
    return {
      name: this.$route.query.name,
      list: [{
        name: '销售经理',
        responsibilities: ['1、负责所管区域内公司产品行业需求调研、收集及整理；', '2、负责所管区域内的渠道布局与拓展,完成销售区域内的销售任务；', '3、负责所管区域内的渠道代理机构销售工作的管理与指导及关系维护；', '4、负责所管区域内产品推广、最终用户公关及关系维护；', '5、协助完成公司整体销售目标，完成领导交办的其他任务；'],
        requirements: ['1、本科及以上学历，计算机、市场营销等相关专业者优先；', '2、口齿清晰、善于表达，学习能力强，热爱营销工作；', '3、具有IT分销经验及良好的用户关系者优先；', '4、具有良好的协调、沟通能力，吃苦耐劳，具备团队协作精神，抗压能力强；']
      }, {
        name: '销售经理（OEM代工）',
        responsibilities: ['1、面向行业目标客户ODM/OEM需求调研、收集及整理，发掘新客户；', '2、根据客户需求制定相关代工方案&营销策略，完成合约的签订；', '3、根据产品/项目情况，与客户及后台部门进行沟通交流，协同完成产品/项目交付；', '4、大客户公关及关系维护；', '5、完成事业部规定的销售目标和任务；', '6、完成领导交办的其他任务；'],
        requirements: ['1、大学本科学历，计算机、市场营销、供应链管理等相关专业；', '2、熟悉供应链，对于生产运营管理有一定了解；', '3、有工厂工作经验者优先，有客户资源者优先；', '4、对计算机硬件（比如PC电脑、工作站、服务器、存储等产品）有一定了解；', '5、口齿清晰、善于表达，学习能力强，热爱营销工作；', '6、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力。']
      }, {
        name: 'C/C++软件开发工程师',
        responsibilities: ['1.负责集群存储/分布式文件系统软件开发；', '2.负责各操作系统下文件系统内核驱动软件开发；'],
        requirements: ['1.统招本科以上学历，计算机，软件工程及相关专业;', '2.优秀的计算机专业知识背景，扎实的数据结构、C/C++编程能力；', '3.熟悉常用数据结构和常用算法；', '4.熟练掌握并行处理和多线程开发技术；', '5.熟悉Windows下的程序开发，熟悉MFC/QT/GTK一种或多种框架结构优先；', '6.熟练使用Python语言，熟悉Linux操作系统优先；', '7.了解分布式文件系统、高可用技术、数据维护管理等技术者优先；']
      }, {
        name: '软件开发工程师',
        responsibilities: ['1、负责公司集群存储/分布式文件系统相关模块代码开发；'],
        requirements: ['1、熟悉linux操作系统；', '2、熟练掌握C语言、Shell/Perl/python其中一种或多种编程技术;', '3、熟悉常用数据结构和常用算法；', '4、熟悉常用文件系统(xfs/ext4)优先；', '5、熟悉开源分布式存储系统(gluster/ceph)等相关知识优先；', '6、熟悉一种操作系统（Win/Linux/OSX）内核开发技术优先；', '7、有相关项目开发经验者优先；']
      }, {
        name: '硬件测试工程师',
        responsibilities: ['1、负责产品硬件平台的测试和选型工作；', '2、负责计算机硬件部件的评测工作；', '3、负责跟进和解决生产环节出现的硬件问题；', '4、负责完成产品硬件部件的测试报告；', '5、负责各厂商来料变更的测试、封样及相关技术交涉工作；'],
        requirements: ['1、计算机及电子相关专业，本科以上学历；', '2、对计算机硬件有一定了解并具有浓厚兴趣；', '3、有较强的自学能力；', '4、做事严谨，责任心强，有团队意识；', '5、有经验者优先；']
      }, {
        name: '装配工程师',
        responsibilities: ['1、整机产品的软硬件装配；', '2、对生产制程中遇到的问题进行总结和反馈，对不良品整机进行故障定位；', '3、协助技术开发及质控部门完成现场质量及技术问题分析；', '4、完成新产品在生产环节试制工作并提交报告，完成工程化相关文档的整理与修订；'],
        requirements: ['1、计算机及电子相关专业，本科以上学历；', '2、熟悉PC部件，对计算机硬件相关知识有深入了解；', '3、具有较强的配合和沟能力，具有较强的责任心，能够承担工作压力；']
      }, {
        name: '结构工程师',
        responsibilities: ['1、负责公司自有产品及ODM客户产品结构系统的研发设计工作,同时包括散热、噪声、包装等设计；', '2、设计阶段进行装配设计缺陷评估，零件制造工艺评估，设计成本评估；', '3、参与产品样机、小批量导入及验证；', '4、负责产品结构异常处理及维护；', '5、负责外协厂家加工工艺沟通及管理；', '6、负责整理及编写相关技术文档；'],
        requirements: ['1、本科及以上学历，机械、电子、模具设计师、自动化或计算机类相关专业；', '2、熟练掌握proe、creo软件及autocad等软件；', '3、熟悉机加工、钣金件，产品包装设计等加工工艺，熟悉阳极化、喷漆、丝印等各种表面处理工艺；', '4、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力；', '5、具有广电类、服务器类产品腔体、机箱设计经验者优先考虑；']
      }, {
        name: '质量主管/经理',
        responsibilities: ['1、负责建立、健全公司质量管理体系；', '2、负责公司质量管理体系和产品的相关认证工作；', '3、负责相关质量标准、质量纲要的制订；', '4、负责对公司各部门工作、服务、产品质量定期和不定期执行监督检查和奖惩；', '5、对供方实行品质管控，反馈相关质量数据，组织整改提升；', '6、负责产品一次开箱合格率、返修率等质量指标的统计分析工作，并组织相关部门改进执', '7、负责售后质量问题的受理、跟踪、协调、管理工作，从信息收集到问题解决全程负责；', '8、负责重大质量问题的调查、跟踪处理及必要的现场支持工作；', '9、其他质量相关工作；'],
        requirements: ['1、计算机、统计学或同类专业，正规统招本科及以上学历；', '2、熟悉掌握办公软件、Solidwirk等绘图软件的使用、具有一定的公文写作、数据分析能力；', '3、熟悉质量体系（ISO9000/TS16949）及3c、节能等相关认证工作，有经验者优先；', '4、熟知供应链生产管理体系；', '5、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力；']
      }, {
        name: '检验工程师',
        responsibilities: ['1、负责公司所有产品（含三方产品）来料、生产、出入库前的检验与测试工作；', '2、不良品部件及整机的故障定位及维修；', '3、品质异常反馈及改善追踪、效果确认；', '4、及时填写质量记录，分析并提交质量报表；', '5、通过检验过程、记录，总结经验，寻求提升生产效率的方法；', '6、完成领导交办的其他任务；'],
        requirements: ['1、统招本科及以上学历，计算机、电子工程、自动化等相关专业；', '2、熟悉生产制造，有两年以上QC相关工作经验；', '3、熟悉服务器、非线性编辑工作站或有广电行业工作经验者优先；', '4、具有良好的判断分析能力；', '5、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力；']
      }, {
        name: '前端开发工程师',
        responsibilities: ['1、负责移动端H5和Web产品、推广活动等前端项目的开发和优化；', '2、负责和后端工程师对接数据交互，能快速理解和消化各方需求并落实为具体工作；', '3、对发现的产品Web前端缺陷能够快速、准确的定位，并妥善的解决；'],
        requirements: ['1、统招本科以上学历，计算机，软件工程及相关专业；', '2、精通HTML/XHTML、CSS等网页制作技术，熟悉页面架构和布局；', '3、精通JavaScript、Ajax等Web开发技术；', '4、熟悉 Vue/Angular框架并有实际工程经验者优先；', '5、熟悉小程序、微信端应用开发；']
      }],
      info: {}
    };
  },

  methods: {
    goToApply: function goToApply() {
      this.$router.push({ name: 'apply', query: { position: this.info.name } });
    }
  },
  mounted: function mounted() {
    for (var i = 0; i < this.list.length; i++) {
      if (this.name === this.list[i].name) {
        this.info = this.list[i];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/job/resume.vue



/* harmony default export */ var job_resume = ({
  name: "resume",
  components: { Card: vux_src_components_card },
  data: function data() {
    return {
      name: this.$route.query.name,
      list: [{
        name: '销售经理',
        responsibilities: ['1、负责所管区域内公司产品行业需求调研、收集及整理；', '2、负责所管区域内的渠道布局与拓展,完成销售区域内的销售任务；', '3、负责所管区域内的渠道代理机构销售工作的管理与指导及关系维护；', '4、负责所管区域内产品推广、最终用户公关及关系维护；', '5、协助完成公司整体销售目标，完成领导交办的其他任务；'],
        requirements: ['1、本科及以上学历，计算机、市场营销等相关专业者优先；', '2、口齿清晰、善于表达，学习能力强，热爱营销工作；', '3、具有IT分销经验及良好的用户关系者优先；', '4、具有良好的协调、沟通能力，吃苦耐劳，具备团队协作精神，抗压能力强；']
      }, {
        name: '销售经理（OEM代工）',
        responsibilities: ['1、面向行业目标客户ODM/OEM需求调研、收集及整理，发掘新客户；', '2、根据客户需求制定相关代工方案&营销策略，完成合约的签订；', '3、根据产品/项目情况，与客户及后台部门进行沟通交流，协同完成产品/项目交付；', '4、大客户公关及关系维护；', '5、完成事业部规定的销售目标和任务；', '6、完成领导交办的其他任务；'],
        requirements: ['1、大学本科学历，计算机、市场营销、供应链管理等相关专业；', '2、熟悉供应链，对于生产运营管理有一定了解；', '3、有工厂工作经验者优先，有客户资源者优先；', '4、对计算机硬件（比如PC电脑、工作站、服务器、存储等产品）有一定了解；', '5、口齿清晰、善于表达，学习能力强，热爱营销工作；', '6、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力。']
      }, {
        name: 'C/C++软件开发工程师',
        responsibilities: ['1.负责集群存储/分布式文件系统软件开发；', '2.负责各操作系统下文件系统内核驱动软件开发；'],
        requirements: ['1.统招本科以上学历，计算机，软件工程及相关专业;', '2.优秀的计算机专业知识背景，扎实的数据结构、C/C++编程能力；', '3.熟悉常用数据结构和常用算法；', '4.熟练掌握并行处理和多线程开发技术；', '5.熟悉Windows下的程序开发，熟悉MFC/QT/GTK一种或多种框架结构优先；', '6.熟练使用Python语言，熟悉Linux操作系统优先；', '7.了解分布式文件系统、高可用技术、数据维护管理等技术者优先；']
      }, {
        name: '软件开发工程师',
        responsibilities: ['1、负责公司集群存储/分布式文件系统相关模块代码开发；'],
        requirements: ['1、熟悉linux操作系统；', '2、熟练掌握C语言、Shell/Perl/python其中一种或多种编程技术;', '3、熟悉常用数据结构和常用算法；', '4、熟悉常用文件系统(xfs/ext4)优先；', '5、熟悉开源分布式存储系统(gluster/ceph)等相关知识优先；', '6、熟悉一种操作系统（Win/Linux/OSX）内核开发技术优先；', '7、有相关项目开发经验者优先；']
      }, {
        name: '硬件测试工程师',
        responsibilities: ['1、负责产品硬件平台的测试和选型工作；', '2、负责计算机硬件部件的评测工作；', '3、负责跟进和解决生产环节出现的硬件问题；', '4、负责完成产品硬件部件的测试报告；', '5、负责各厂商来料变更的测试、封样及相关技术交涉工作；'],
        requirements: ['1、计算机及电子相关专业，本科以上学历；', '2、对计算机硬件有一定了解并具有浓厚兴趣；', '3、有较强的自学能力；', '4、做事严谨，责任心强，有团队意识；', '5、有经验者优先；']
      }, {
        name: '装配工程师',
        responsibilities: ['1、整机产品的软硬件装配；', '2、对生产制程中遇到的问题进行总结和反馈，对不良品整机进行故障定位；', '3、协助技术开发及质控部门完成现场质量及技术问题分析；', '4、完成新产品在生产环节试制工作并提交报告，完成工程化相关文档的整理与修订；'],
        requirements: ['1、计算机及电子相关专业，本科以上学历；', '2、熟悉PC部件，对计算机硬件相关知识有深入了解；', '3、具有较强的配合和沟能力，具有较强的责任心，能够承担工作压力；']
      }, {
        name: '结构工程师',
        responsibilities: ['1、负责公司自有产品及ODM客户产品结构系统的研发设计工作,同时包括散热、噪声、包装等设计；', '2、设计阶段进行装配设计缺陷评估，零件制造工艺评估，设计成本评估；', '3、参与产品样机、小批量导入及验证；', '4、负责产品结构异常处理及维护；', '5、负责外协厂家加工工艺沟通及管理；', '6、负责整理及编写相关技术文档；'],
        requirements: ['1、本科及以上学历，机械、电子、模具设计师、自动化或计算机类相关专业；', '2、熟练掌握proe、creo软件及autocad等软件；', '3、熟悉机加工、钣金件，产品包装设计等加工工艺，熟悉阳极化、喷漆、丝印等各种表面处理工艺；', '4、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力；', '5、具有广电类、服务器类产品腔体、机箱设计经验者优先考虑；']
      }, {
        name: '质量主管/经理',
        responsibilities: ['1、负责建立、健全公司质量管理体系；', '2、负责公司质量管理体系和产品的相关认证工作；', '3、负责相关质量标准、质量纲要的制订；', '4、负责对公司各部门工作、服务、产品质量定期和不定期执行监督检查和奖惩；', '5、对供方实行品质管控，反馈相关质量数据，组织整改提升；', '6、负责产品一次开箱合格率、返修率等质量指标的统计分析工作，并组织相关部门改进执', '7、负责售后质量问题的受理、跟踪、协调、管理工作，从信息收集到问题解决全程负责；', '8、负责重大质量问题的调查、跟踪处理及必要的现场支持工作；', '9、其他质量相关工作；'],
        requirements: ['1、计算机、统计学或同类专业，正规统招本科及以上学历；', '2、熟悉掌握办公软件、Solidwirk等绘图软件的使用、具有一定的公文写作、数据分析能力；', '3、熟悉质量体系（ISO9000/TS16949）及3c、节能等相关认证工作，有经验者优先；', '4、熟知供应链生产管理体系；', '5、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力；']
      }, {
        name: '检验工程师',
        responsibilities: ['1、负责公司所有产品（含三方产品）来料、生产、出入库前的检验与测试工作；', '2、不良品部件及整机的故障定位及维修；', '3、品质异常反馈及改善追踪、效果确认；', '4、及时填写质量记录，分析并提交质量报表；', '5、通过检验过程、记录，总结经验，寻求提升生产效率的方法；', '6、完成领导交办的其他任务；'],
        requirements: ['1、统招本科及以上学历，计算机、电子工程、自动化等相关专业；', '2、熟悉生产制造，有两年以上QC相关工作经验；', '3、熟悉服务器、非线性编辑工作站或有广电行业工作经验者优先；', '4、具有良好的判断分析能力；', '5、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力；']
      }, {
        name: '前端开发工程师',
        responsibilities: ['1、负责移动端H5和Web产品、推广活动等前端项目的开发和优化；', '2、负责和后端工程师对接数据交互，能快速理解和消化各方需求并落实为具体工作；', '3、对发现的产品Web前端缺陷能够快速、准确的定位，并妥善的解决；'],
        requirements: ['1、统招本科以上学历，计算机，软件工程及相关专业；', '2、精通HTML/XHTML、CSS等网页制作技术，熟悉页面架构和布局；', '3、精通JavaScript、Ajax等Web开发技术；', '4、熟悉 Vue/Angular框架并有实际工程经验者优先；', '5、熟悉小程序、微信端应用开发；']
      }],
      info: {}
    };
  },

  methods: {
    goToApply: function goToApply() {
      this.$router.push({ name: 'apply', query: { position: this.info.name } });
    }
  },
  mounted: function mounted() {
    for (var i = 0; i < this.list.length; i++) {
      if (this.name === this.list[i].name) {
        this.info = this.list[i];
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7075a62c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/job/resume.vue
var resume_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('card',[_c('div',{staticClass:"card-header",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      "+_vm._s(_vm.info.name)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"card-padding",attrs:{"slot":"content"},slot:"content"},[_c('h5',[_vm._v("工作职责")]),_vm._v(" "),_vm._l((_vm.info.responsibilities),function(resinfo,resindex){return _c('p',{key:'index-' + resindex},[_vm._v(_vm._s(resinfo))])}),_vm._v(" "),_c('h5',[_vm._v("任职要求")]),_vm._v(" "),_vm._l((_vm.info.requirements),function(reqinfo,reqindex){return _c('p',{key:'index--' + reqindex},[_vm._v(_vm._s(reqinfo))])})],2),_vm._v(" "),_c('div',{staticClass:"card-footer",attrs:{"slot":"footer"},on:{"click":_vm.goToApply},slot:"footer"},[_vm._v("\n      熔入精一\n    ")])])],1)}
var resume_staticRenderFns = []
var resume_esExports = { render: resume_render, staticRenderFns: resume_staticRenderFns }
/* harmony default export */ var components_job_resume = (resume_esExports);
// CONCATENATED MODULE: ./src/components/job/resume.vue
function resume_injectStyle (ssrContext) {
  __webpack_require__("FlU4")
}
var resume_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var resume___vue_template_functional__ = false
/* styles */
var resume___vue_styles__ = resume_injectStyle
/* scopeId */
var resume___vue_scopeId__ = "data-v-7075a62c"
/* moduleIdentifier (server only) */
var resume___vue_module_identifier__ = null
var resume_Component = resume_normalizeComponent(
  job_resume,
  components_job_resume,
  resume___vue_template_functional__,
  resume___vue_styles__,
  resume___vue_scopeId__,
  resume___vue_module_identifier__
)

/* harmony default export */ var src_components_job_resume = (resume_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/job/apply.vue





/* harmony default export */ var apply = ({
  name: "apply",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      info: {
        name: '',
        mobile: ''
      },
      position: this.$route.query.position
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      if (!this.info.name || !this.info.mobile) {
        alert('请填写基本信息');
        return;
      }
      if (this.$refs.file.files.length === 0) {
        if (confirm('您没有上传简历，确认要提交么？')) {
          this.$http.post('api/v1/resumes', {
            openid: localStorage.getItem('openid'),
            info: {
              name: this.info.name,
              mobile: this.info.mobile,
              position: this.position,
              appendix: []
            }
          }).then(function () {
            alert('提交成功');
            _this.$router.push({ name: 'resumelist' });
          }).catch(function (error) {
            _this.$vux.alert.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
        }
      } else {
        var formData = new FormData();
        var fs = this.$refs.file.files;
        for (var i = 0; i < fs.length; i++) {
          var d = fs[0];
          if (d.size <= 1024 * 1024 * 100) {
            //文件必须小于100M
            formData.append("file", fs[i]);
            formData.append("name", this.info.name + '-' + this.info.mobile + '-' + d.name);
          } else {
            alert('上传文件过大！');
            return false;
          }
        }
        var arr = fs[0].name.split('.');
        this.$http.post('api/v1/photos/upload', formData).then(function (response) {
          _this.$http.post('api/v1/resumes', {
            openid: localStorage.getItem('openid'),
            info: {
              name: _this.info.name,
              mobile: _this.info.mobile,
              position: _this.position,
              appendix: [{ type: arr[arr.length - 1], path: JSON.parse(response.data).path }]
            }
          }).then(function () {
            alert('提交成功');
            _this.$router.push({ name: 'resumelist' });
          }).catch(function (error) {
            _this.$vux.alert.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
        }).catch(function (error) {
          _this.$vux.alert.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/job/apply.vue





/* harmony default export */ var job_apply = ({
  name: "apply",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      info: {
        name: '',
        mobile: ''
      },
      position: this.$route.query.position
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      if (!this.info.name || !this.info.mobile) {
        alert('请填写基本信息');
        return;
      }
      if (this.$refs.file.files.length === 0) {
        if (confirm('您没有上传简历，确认要提交么？')) {
          this.$http.post('api/v1/resumes', {
            openid: localStorage.getItem('openid'),
            info: {
              name: this.info.name,
              mobile: this.info.mobile,
              position: this.position,
              appendix: []
            }
          }).then(function () {
            alert('提交成功');
            _this.$router.push({ name: 'resumelist' });
          }).catch(function (error) {
            _this.$vux.alert.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
        }
      } else {
        var formData = new FormData();
        var fs = this.$refs.file.files;
        for (var i = 0; i < fs.length; i++) {
          var d = fs[0];
          if (d.size <= 1024 * 1024 * 100) {
            //文件必须小于100M
            formData.append("file", fs[i]);
            formData.append("name", this.info.name + '-' + this.info.mobile + '-' + d.name);
          } else {
            alert('上传文件过大！');
            return false;
          }
        }
        var arr = fs[0].name.split('.');
        this.$http.post('api/v1/photos/upload', formData).then(function (response) {
          _this.$http.post('api/v1/resumes', {
            openid: localStorage.getItem('openid'),
            info: {
              name: _this.info.name,
              mobile: _this.info.mobile,
              position: _this.position,
              appendix: [{ type: arr[arr.length - 1], path: JSON.parse(response.data).path }]
            }
          }).then(function () {
            alert('提交成功');
            _this.$router.push({ name: 'resumelist' });
          }).catch(function (error) {
            _this.$vux.alert.show({
              text: JSON.parse(error.response.data.error_message).zh_string,
              type: 'cancel',
              time: '1000'
            });
          });
        }).catch(function (error) {
          _this.$vux.alert.show({
            text: JSON.parse(error.response.data.error_message).zh_string,
            type: 'cancel',
            time: '1000'
          });
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f41d4a24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/job/apply.vue
var apply_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('group',[_c('x-input',{attrs:{"title":"姓名"},model:{value:(_vm.info.name),callback:function ($$v) {_vm.$set(_vm.info, "name", $$v)},expression:"info.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手机号","is-type":"china-mobile"},model:{value:(_vm.info.mobile),callback:function ($$v) {_vm.$set(_vm.info, "mobile", $$v)},expression:"info.mobile"}})],1),_vm._v(" "),_c('div',{staticClass:"file_wrap"},[_c('label',[_vm._v("上传简历")]),_vm._v(" "),_c('input',{ref:"file",attrs:{"type":"file","id":"file"}})]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("提交")])],1)}
var apply_staticRenderFns = []
var apply_esExports = { render: apply_render, staticRenderFns: apply_staticRenderFns }
/* harmony default export */ var components_job_apply = (apply_esExports);
// CONCATENATED MODULE: ./src/components/job/apply.vue
function apply_injectStyle (ssrContext) {
  __webpack_require__("JFGg")
}
var apply_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var apply___vue_template_functional__ = false
/* styles */
var apply___vue_styles__ = apply_injectStyle
/* scopeId */
var apply___vue_scopeId__ = "data-v-f41d4a24"
/* moduleIdentifier (server only) */
var apply___vue_module_identifier__ = null
var apply_Component = apply_normalizeComponent(
  job_apply,
  components_job_apply,
  apply___vue_template_functional__,
  apply___vue_styles__,
  apply___vue_scopeId__,
  apply___vue_module_identifier__
)

/* harmony default export */ var src_components_job_apply = (apply_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/job/resumelist.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var resumelist = ({
  name: "resumelist",
  data: function data() {
    return {
      list: [{ name: '销售经理', education: '本科', time: '经验不限', address: '广州 南宁 西宁' }, { name: '销售经理（OEM代工）', education: '本科', time: '经验不限', address: '北京' }, { name: 'C/C++软件开发工程师', education: '本科', time: '1-3年', address: '北京' }, { name: '软件开发工程师', education: '本科', time: '1-3年', address: '北京' }, { name: '硬件测试工程师', education: '本科', time: '经验不限', address: '北京' }, { name: '装配工程师', education: '本科', time: '经验不限', address: '北京' }, { name: '质量主管/经理', education: '本科', time: '经验不限', address: '北京' }, { name: '检验工程师', education: '本科', time: '经验不限', address: '北京' }, { name: '结构工程师', education: '本科', time: '经验不限', address: '北京' }, { name: '前端开发工程师', education: '本科', time: '1-3年', address: '北京' }]
    };
  },

  methods: {
    goToresume: function goToresume(name) {
      this.$router.push({ name: 'resume', query: { name: name } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/job/resumelist.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var job_resumelist = ({
  name: "resumelist",
  data: function data() {
    return {
      list: [{ name: '销售经理', education: '本科', time: '经验不限', address: '广州 南宁 西宁' }, { name: '销售经理（OEM代工）', education: '本科', time: '经验不限', address: '北京' }, { name: 'C/C++软件开发工程师', education: '本科', time: '1-3年', address: '北京' }, { name: '软件开发工程师', education: '本科', time: '1-3年', address: '北京' }, { name: '硬件测试工程师', education: '本科', time: '经验不限', address: '北京' }, { name: '装配工程师', education: '本科', time: '经验不限', address: '北京' }, { name: '质量主管/经理', education: '本科', time: '经验不限', address: '北京' }, { name: '检验工程师', education: '本科', time: '经验不限', address: '北京' }, { name: '结构工程师', education: '本科', time: '经验不限', address: '北京' }, { name: '前端开发工程师', education: '本科', time: '1-3年', address: '北京' }]
    };
  },

  methods: {
    goToresume: function goToresume(name) {
      this.$router.push({ name: 'resume', query: { name: name } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edf638de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/job/resumelist.vue
var resumelist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('img',{attrs:{"src":"/static/img/resume.jpg","alt":""}}),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"box-item",on:{"click":function($event){_vm.goToresume(item.name)}}},[_c('div',{staticClass:"item-left"},[_c('h4',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.time))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.education))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.address))])]),_vm._v(" "),_c('p',[_vm._v("详情")])])})],2)}
var resumelist_staticRenderFns = []
var resumelist_esExports = { render: resumelist_render, staticRenderFns: resumelist_staticRenderFns }
/* harmony default export */ var components_job_resumelist = (resumelist_esExports);
// CONCATENATED MODULE: ./src/components/job/resumelist.vue
function resumelist_injectStyle (ssrContext) {
  __webpack_require__("naaX")
}
var resumelist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var resumelist___vue_template_functional__ = false
/* styles */
var resumelist___vue_styles__ = resumelist_injectStyle
/* scopeId */
var resumelist___vue_scopeId__ = "data-v-edf638de"
/* moduleIdentifier (server only) */
var resumelist___vue_module_identifier__ = null
var resumelist_Component = resumelist_normalizeComponent(
  job_resumelist,
  components_job_resumelist,
  resumelist___vue_template_functional__,
  resumelist___vue_styles__,
  resumelist___vue_scopeId__,
  resumelist___vue_module_identifier__
)

/* harmony default export */ var src_components_job_resumelist = (resumelist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df815522","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("Fgsu")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fc8f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Saleslog/addsaleslog.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var addsaleslog = ({
  name: "addsaleslog",
  props: {
    date: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      textnum: 2,
      info: {
        customer_visited: [],
        project_added: [],
        project_updated: [],
        appendix: [],
        photos: [],
        solutions: [],
        myscore: ''
      },
      next: '',
      resource: '',
      other: '',
      visiable: [],
      visiableUserList: [],
      visiableUser: [],
      isClear: '',
      isVisitedCustomer: false,
      isSolutionCustomer: false,
      customerList: [],
      dateTime: this.date,
      isEditChange: this.isEdit,
      imgList: []
    };
  },

  methods: {
    addVisited: function addVisited() {
      this.info.customer_visited.push({
        customer: '',
        name: '',
        title: '',
        mobile: '',
        accompany: '',
        communicate: '',
        content: '',
        plan: '',
        prop: '',
        photos: []
      });
      this.imgList.push([]);
    },
    addSolution: function addSolution() {
      this.info.solutions.push({ customer: '', appendix: [] });
    },
    removeVisited: function removeVisited(index) {
      if (this.info.customer_visited[index].customer) {
        if (confirm('您已有更新内容，确认是否要删除？')) {
          if (confirm('您已有更新内容，再次确认是否要删除？')) {
            this.info.customer_visited.splice(index, 1);
          }
        }
      } else {
        this.info.customer_visited.splice(index, 1);
      }
    },
    removeSolution: function removeSolution(index) {
      this.info.solutions.splice(index);
    },
    checkMobile: function checkMobile(event) {
      var reg = /^1[0-9]{10}$/;
      if (!reg.test(event.target.value)) {
        this.$vux.alert.show({
          title: '',
          content: '请输入正确的手机号'
        });
      }
    },
    choseCustomer: function choseCustomer(index, value, type) {
      switch (type) {
        case 'visited':
          this.info.customer_visited[index].customer = value;
          this.saveInfo();
          this.isVisitedCustomer = false;
          break;
        case 'solution':
          this.info.solutions[index].customer = value;
          this.isSolutionCustomer = false;
          break;
      }
    },
    searchCustomer: function searchCustomer(even, type) {
      var _this = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/srvp_projects/project_similar?&offset=0&count=20&tp=customer&arg=' + event.target.value, header).then(function (response) {
        if (type === 'visited') {
          _this.isVisitedCustomer = true;
        } else if (type === 'solution') {
          _this.isSolutionCustomer = true;
        }
        _this.customerList = response.data.content;
      });
    },
    changeTextarea: function changeTextarea(value) {
      this.saveInfo();
      var num = typeof value === "string" ? value.split('\n').length : value.target.value.split('\n').length;
      if (num === 3) {
        this.textnum = 3;
      } else if (num >= 4) {
        this.textnum = 4;
      }
    },
    changeDate: function changeDate() {
      var _this2 = this;

      var start = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
      var end = new Date();
      var startDate = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate();
      var endDate = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate();
      this.$vux.datetime.show({
        value: this.dateTime, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        startDate: startDate,
        endDate: endDate,
        onConfirm: function onConfirm(event) {
          _this2.getInfoFromDate(event);
        }
      });
    },
    choseImg: function choseImg(visitedindex) {
      var _this3 = this;

      if (this.info.customer_visited[visitedindex].photos.length >= 5) {
        alert('最多允许上传5张照片');
        return;
      }
      weixin_js_sdk_default.a.chooseImage({
        count: 5 - this.info.customer_visited[visitedindex].photos.length, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          _this3.$vux.loading.show({
            text: 'Loading'
          });
          var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          var i = 0;
          var length = localIds.length;
          var serverIds = [];
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function () {
                var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
                  var header, response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, photo;

                  return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          // 返回图片的服务器端ID
                          header = {
                            headers: {
                              token: localStorage.getItem('token'),
                              opid: localStorage.getItem('userid')
                            }
                          };

                          serverIds.push(res.serverId);
                          i++;

                          if (!(i >= length)) {
                            _context.next = 38;
                            break;
                          }

                          _context.next = 6;
                          return _this3.$http.post('/api/v1/photos/wechat', { photo: serverIds }, header);

                        case 6:
                          response = _context.sent;

                          if (!response.data) {
                            _context.next = 38;
                            break;
                          }

                          _this3.info.customer_visited[visitedindex].photos = [].concat(toConsumableArray_default()(_this3.info.customer_visited[visitedindex].photos), toConsumableArray_default()(response.data));
                          _iteratorNormalCompletion = true;
                          _didIteratorError = false;
                          _iteratorError = undefined;
                          _context.prev = 12;
                          _iterator = get_iterator_default()(response['data']);

                        case 14:
                          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _context.next = 24;
                            break;
                          }

                          item = _step.value;
                          _context.next = 18;
                          return _this3.$http.get('api/v1/photos?path=' + item.thumb);

                        case 18:
                          photo = _context.sent;

                          _this3.imgList[visitedindex].push('data:image/jpeg;base64,' + photo.data['value']);
                          _this3.$vux.loading.hide();

                        case 21:
                          _iteratorNormalCompletion = true;
                          _context.next = 14;
                          break;

                        case 24:
                          _context.next = 30;
                          break;

                        case 26:
                          _context.prev = 26;
                          _context.t0 = _context["catch"](12);
                          _didIteratorError = true;
                          _iteratorError = _context.t0;

                        case 30:
                          _context.prev = 30;
                          _context.prev = 31;

                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }

                        case 33:
                          _context.prev = 33;

                          if (!_didIteratorError) {
                            _context.next = 36;
                            break;
                          }

                          throw _iteratorError;

                        case 36:
                          return _context.finish(33);

                        case 37:
                          return _context.finish(30);

                        case 38:
                          if (i < length && i <= 9) {
                            upload();
                          }

                        case 39:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this3, [[12, 26, 30, 38], [31,, 33, 37]]);
                }));

                return function success(_x) {
                  return _ref.apply(this, arguments);
                };
              }()
            });
          };
          upload();
        },
        fail: function fail() {
          _this3.$vux.loading.hide();
        }
      });
    },
    removeImg: function removeImg(visitedindex, photoindex) {
      this.imgList[visitedindex].splice(photoindex, 1);
      this.info.customer_visited[visitedindex].photos.splice(photoindex, 1);
    },
    removeAppendix: function removeAppendix(index) {
      this.info.appendix.splice(index, 1);
    },
    removeSolutionAppendix: function removeSolutionAppendix(solutionindex, index) {
      this.info.solutions[solutionindex].appendix.splice(index, 1);
    },
    choseAppendix: function choseAppendix(type, index) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var fs, appendix, i, formData, d, arr, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fs = void 0;
                appendix = [];
                _context2.t0 = type;
                _context2.next = _context2.t0 === 'appendix' ? 5 : _context2.t0 === 'solution' ? 11 : 13;
                break;

              case 5:
                fs = _this4.$refs.file.files;
                if (_this4.info.appendix) {
                  appendix = [].concat(toConsumableArray_default()(_this4.info.appendix));
                }

                if (!(appendix.length >= 3)) {
                  _context2.next = 10;
                  break;
                }

                alert('最多允许上传3份附件');
                return _context2.abrupt("return");

              case 10:
                return _context2.abrupt("break", 13);

              case 11:
                fs = _this4.$refs.filesolution[index].files;
                return _context2.abrupt("break", 13);

              case 13:
                _this4.$vux.loading.show({
                  text: 'Loading'
                });
                i = 0;

              case 15:
                if (!(i < fs.length)) {
                  _context2.next = 33;
                  break;
                }

                formData = new FormData();
                d = fs[i];

                if (!(d.size <= 1024 * 1024 * 100)) {
                  _context2.next = 28;
                  break;
                }

                //文件必须小于100M
                formData.append("file", fs[i]);
                arr = d.name;

                formData.append("name", arr);
                _context2.next = 24;
                return _this4.$http.post('api/v1/photos/upload', formData);

              case 24:
                response = _context2.sent;

                appendix.push({ path: response.data.path, suffix: arr });
                _context2.next = 30;
                break;

              case 28:
                alert('上传文件过大！');
                return _context2.abrupt("return", false);

              case 30:
                i++;
                _context2.next = 15;
                break;

              case 33:
                _this4.$vux.loading.hide();
                _context2.t1 = type;
                _context2.next = _context2.t1 === 'appendix' ? 37 : _context2.t1 === 'solution' ? 39 : 41;
                break;

              case 37:
                _this4.info.appendix = appendix;
                return _context2.abrupt("break", 41);

              case 39:
                _this4.info.solutions[index].appendix = appendix;
                return _context2.abrupt("break", 41);

              case 41:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    submit: function submit() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var i, item, reg, _i, _item;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < _this5.info.customer_visited.length)) {
                  _context3.next = 23;
                  break;
                }

                item = _this5.info.customer_visited[i];

                if (!(!item.customer && !item.name)) {
                  _context3.next = 7;
                  break;
                }

                _this5.info.customer_visited.splice(i, 1);
                i--;
                return _context3.abrupt("continue", 20);

              case 7:
                if (item.communicate) {
                  _context3.next = 10;
                  break;
                }

                alert('请选择客户拜访的沟通方式');
                return _context3.abrupt("return");

              case 10:
                if (item.mobile) {
                  _context3.next = 13;
                  break;
                }

                alert('请填写客户拜访的联系手机');
                return _context3.abrupt("return");

              case 13:
                if (item.prop) {
                  _context3.next = 16;
                  break;
                }

                alert('请填写客户性质');
                return _context3.abrupt("return");

              case 16:
                reg = /^1[0-9]{10}$/;

                if (reg.test(item.mobile)) {
                  _context3.next = 20;
                  break;
                }

                alert('请输入正确的手机号');
                return _context3.abrupt("return");

              case 20:
                i++;
                _context3.next = 1;
                break;

              case 23:
                _i = 0;

              case 24:
                if (!(_i < _this5.info.solutions.length)) {
                  _context3.next = 32;
                  break;
                }

                _item = _this5.info.solutions[_i];

                if (!(!_item.appendix || !_item.customer)) {
                  _context3.next = 29;
                  break;
                }

                alert('请补充提交方案情况');
                return _context3.abrupt("return");

              case 29:
                _i++;
                _context3.next = 24;
                break;

              case 32:
                if (_this5.info.myscore) {
                  _context3.next = 35;
                  break;
                }

                _this5.$vux.alert.show({
                  title: '',
                  content: '请填写自我评分'
                });
                return _context3.abrupt("return");

              case 35:
                if (_this5.isEditChange) {
                  _this5.editInfo();
                } else {
                  _this5.createInfo();
                }

              case 36:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    createInfo: function createInfo() {
      var _this6 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.info.resources = this.resource ? this.resource.split('\n') : [];
      this.info.others = this.other ? this.other.split('\n') : [];
      this.info.next = this.next ? this.next.split('\n') : [];
      var info = {
        day: this.dateTime,
        info: this.info
      };
      this.$http.post('/api/v1/sale_logs', info, header).then(function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(res) {
          return regenerator_default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this6.$http.get('/api/v1/sale_logs/' + res.data.logid + '/set_salelog_visible_to?userids=' + stringify_default()(_this6.visiable) + '&visible=true', header);

                case 2:
                  _this6.$vux.alert.show({
                    title: '',
                    content: '创建成功'
                  });
                  localStorage.removeItem(_this6.dateTime);
                  _this6.$emit('editAcreate');

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, _this6);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this6.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    editInfo: function editInfo() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var header, i, item, info, _info;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                header = {
                  headers: {
                    token: localStorage.getItem('token'),
                    opid: localStorage.getItem('userid')
                  }
                };

                for (i = 0; i < _this7.info.customer_visited.length; i++) {
                  item = _this7.info.customer_visited[i];

                  if (!item.customer && !item.name) {
                    _this7.info.customer_visited.splice(i, 1);
                    i--;
                  }
                }
                _this7.info.resources = _this7.resource ? _this7.resource.split('\n') : [];
                _this7.info.others = _this7.other ? _this7.other.split('\n') : [];
                _this7.info.next = _this7.next ? _this7.next.split('\n') : [];
                if (_this7.isClear) {
                  _this7.$http.delete('/api/v1/sale_logs/' + _this7.isClear, header).then(function () {}).catch(function (error) {
                    _this7.$vux.alert.show({
                      title: '',
                      content: JSON.parse(error.response.data.error_message).zh_string
                    });
                  });
                }

                if (!_this7.info.id) {
                  _context6.next = 23;
                  break;
                }

                info = {
                  customer_visited: _this7.info.customer_visited,
                  resources: _this7.info.resources,
                  others: _this7.info.others,
                  next: _this7.info.next,
                  appendix: _this7.info.appendix ? _this7.info.appendix : [],
                  photos: _this7.info.photos ? _this7.info.photos : [],
                  solutions: _this7.info.solutions ? _this7.info.solutions : [],
                  myscore: _this7.info.myscore
                };
                _context6.prev = 8;
                _context6.next = 11;
                return _this7.$http.get('/api/v1/sale_logs/' + _this7.info.id + '/set_salelog_visible_to?userids=' + stringify_default()(_this7.visiable) + '&visible=true', header);

              case 11:
                _context6.next = 13;
                return _this7.$http.put('/api/v1/sale_logs/' + _this7.info.id, { info: info }, header);

              case 13:
                _this7.$vux.alert.show({
                  title: '',
                  content: '修改成功'
                });
                _this7.$emit('editAcreate');
                _this7.$router.push({ name: 'saleslog' });
                _context6.next = 21;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6["catch"](8);

                _this7.$vux.alert.show({
                  title: '',
                  content: JSON.parse(_context6.t0.response.data.error_message).zh_string
                });

              case 21:
                _context6.next = 25;
                break;

              case 23:
                _info = {
                  day: _this7.dateTime,
                  info: _this7.info
                };

                _this7.$http.post('/api/v1/sale_logs', _info, header).then(function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(res) {
                    return regenerator_default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return _this7.$http.get('/api/v1/sale_logs/' + res.data.logid + '/set_salelog_visible_to?userids=' + stringify_default()(_this7.visiable) + '&visible=true', header);

                          case 2:
                            _this7.$vux.alert.show({
                              title: '',
                              content: '修改成功'
                            });
                            _this7.$emit('editAcreate');

                          case 4:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this7);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  _this7.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                });

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[8, 18]]);
      }))();
    },
    getInfoFromDate: function getInfoFromDate(date) {
      var _this8 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/sale_logs/get_my_salelog_by_day?day=' + date, header).then(function (response) {
        if (_this8.isEditChange) {
          if (response.data) {
            if (date === _this8.date) {
              _this8.info = response.data;
              _this8.imgList = [];
              _this8.visiable = [];
              /*this.info.photos.forEach(async item => {
                const photo = await this.$http.get('api/v1/photos?path=' + item.origin)
                this.imgList.push('data:image/jpeg;base64,' + photo.data['value'])
              })*/
              _this8.info.customer_visited.forEach(function (item) {
                _this8.imgList.push([]);
              });
              _this8.info.next.forEach(function (item, index) {
                _this8.next += index === 0 ? item : '\n' + item;
              });
              _this8.info.resources.forEach(function (item, index) {
                _this8.resource += index === 0 ? item : '\n' + item;
              });
              _this8.info.others.forEach(function (item, index) {
                _this8.other += index === 0 ? item : '\n' + item;
              });
              return;
            }
            _this8.$vux.alert.show({
              title: '',
              content: '您' + response.data['time'] + '已有日志，请修改为其他日期或编辑当天日志进行修改'
            });
            _this8.dateTime = _this8.info.time;
          } else {
            if (confirm('确认将' + _this8.info.time + '日志修改' + date + '日志，修改后' + _this8.info.time + '日志需要重新填写，确认修改？')) {
              _this8.info.project_added = response.data ? response.data['project_added'] : [];
              _this8.info.project_updated = response.data ? response.data['project_updated'] : [];
              _this8.info.appendix = response.data ? response.data['appendix'] : [];
              _this8.info.photos = response.data ? response.data['photos'] : [];
              _this8.info.solutions = response.data ? response.data['solutions'] : [];
              _this8.dateTime = date;
              _this8.isClear = _this8.info.id;
              delete _this8.info.id;
            } else {
              _this8.dateTime = _this8.info.time;
            }
          }
        } else {
          var info = localStorage.getItem(_this8.dateTime);
          _this8.imgList = [];
          if (response.data) {
            if (response.data.write) {
              _this8.$vux.alert.show({
                title: '',
                content: '您' + date + '已提交过日志，请修改为其他日期或编辑当天的日志进行修改'
              });
              _this8.info.project_updated = response.data['project_updated'];
              _this8.info.project_added = response.data['project_added'];
            } else {
              if (_this8.resource || _this8.other || _this8.next) {
                if (!confirm('您已有写入内容，确认将当前写入内容修改为' + date + '日志')) {
                  var info_json = JSON.parse(info);
                  if (info_json && info_json.hasOwnProperty('date') && info_json.date === date) {
                    _this8.info = info_json;
                    delete _this8.info.date;
                  } else {
                    _this8.info = {
                      project_added: [],
                      project_updated: [],
                      customer_visited: [],
                      solutions: [],
                      next: [],
                      others: [],
                      resources: [],
                      photos: [],
                      appendix: []
                    };
                  }
                }
              }
              _this8.info.project_updated = response.data.project_updated;
              _this8.info.project_added = response.data.project_added;
              _this8.info.id = response.data.id;
              _this8.isEditChange = true;
            }
          } else {
            if (_this8.resource || _this8.other || _this8.next) {
              if (!confirm('您已有写入内容，确认将当前写入内容修改为' + date + '日志')) {
                if (info) {
                  var _info_json = JSON.parse(info);
                  if (_info_json.date === date) {
                    _this8.info = _info_json;
                    delete _this8.info.date;
                  } else {
                    _this8.info = {
                      project_added: [],
                      project_updated: [],
                      customer_visited: [],
                      next: [],
                      others: [],
                      resources: [],
                      appendix: [],
                      photos: [],
                      solutions: []
                    };
                  }
                } else {
                  _this8.info = {
                    project_added: [],
                    project_updated: [],
                    customer_visited: [],
                    next: [],
                    others: [],
                    resources: [],
                    appendix: [],
                    photos: [],
                    solutions: []
                  };
                }
              }
            } else {
              _this8.info = {
                project_added: [],
                project_updated: [],
                customer_visited: [],
                next: [],
                others: [],
                resources: [],
                appendix: [],
                photos: [],
                solutions: []
              };
            }
          }
          _this8.dateTime = date;
          _this8.visiable = [];
          _this8.imgList = [];
          _this8.info.customer_visited.forEach(function (item) {
            _this8.imgList.push([]);
          });
          _this8.info.next.forEach(function (item, index) {
            _this8.next += index === 0 ? item : '\n' + item;
          });
          _this8.info.resources.forEach(function (item, index) {
            _this8.resource += index === 0 ? item : '\n' + item;
          });
          _this8.info.others.forEach(function (item, index) {
            _this8.other += index === 0 ? item : '\n' + item;
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this8.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    getVisiable: function getVisiable() {
      var _this9 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/sale_logs/' + this.id + '/list_salelog_visible_to?offset=0&count=9999', header).then(function (res) {
        _this9.visiableUserList = res.data['content'].filter(function (item) {
          return item.default;
        });
        res.data['content'].forEach(function (item) {
          if (!item.default) {
            _this9.visiable = [].concat(toConsumableArray_default()(_this9.visiable), [item.userid]);
          }
        });
      }).catch(function (error) {
        _this9.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    getVisiableUser: function getVisiableUser() {
      var _this10 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/agencies?task=ALL&offset=0&count=9999&hint=', header).then(function (response) {
        _this10.visiableUser = response.data;
      }).catch(function (error) {
        _this10.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    saveInfo: function saveInfo() {
      this.info.date = this.dateTime;
      this.info.resources = this.resource ? this.resource.split('\n') : [];
      this.info.others = this.other ? this.other.split('\n') : [];
      this.info.next = this.next ? this.next.split('\n') : [];
      localStorage.setItem(this.dateTime, stringify_default()(this.info));
    }
  },
  mounted: function mounted() {
    var _this11 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      _this11.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        url = isiOS ? config.host + src_components_global.entryUrl.split('?')[0] : config.host + _this11.$route.path;
        var noncestr = Math.random().toString(36).substr(2);
        _this11.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode'] // 必填，需要使用的JS接口列表
          });
          weixin_js_sdk_default.a.error(function (res) {
            //alert(res.errMsg)
          });
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    var _this12 = this;

    this.getInfoFromDate(this.date);
    this.getVisiableUser();
    if (this.id) {
      this.getVisiable();
    } else {
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/sale_logs/get_salelog_config?userid=' + localStorage.getItem('userid') + '&offset=0&count=999999', header).then(function (res) {
        _this12.visiableUserList = res.data['content'].map(function (item) {
          return { name: item.srvp.name };
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Saleslog/addsaleslog.vue





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Saleslog_addsaleslog = ({
  name: "addsaleslog",
  props: {
    date: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      textnum: 2,
      info: {
        customer_visited: [],
        project_added: [],
        project_updated: [],
        appendix: [],
        photos: [],
        solutions: [],
        myscore: ''
      },
      next: '',
      resource: '',
      other: '',
      visiable: [],
      visiableUserList: [],
      visiableUser: [],
      isClear: '',
      isVisitedCustomer: false,
      isSolutionCustomer: false,
      customerList: [],
      dateTime: this.date,
      isEditChange: this.isEdit,
      imgList: []
    };
  },

  methods: {
    addVisited: function addVisited() {
      this.info.customer_visited.push({
        customer: '',
        name: '',
        title: '',
        mobile: '',
        accompany: '',
        communicate: '',
        content: '',
        plan: '',
        prop: '',
        photos: []
      });
      this.imgList.push([]);
    },
    addSolution: function addSolution() {
      this.info.solutions.push({ customer: '', appendix: [] });
    },
    removeVisited: function removeVisited(index) {
      if (this.info.customer_visited[index].customer) {
        if (confirm('您已有更新内容，确认是否要删除？')) {
          if (confirm('您已有更新内容，再次确认是否要删除？')) {
            this.info.customer_visited.splice(index, 1);
          }
        }
      } else {
        this.info.customer_visited.splice(index, 1);
      }
    },
    removeSolution: function removeSolution(index) {
      this.info.solutions.splice(index);
    },
    checkMobile: function checkMobile(event) {
      var reg = /^1[0-9]{10}$/;
      if (!reg.test(event.target.value)) {
        this.$vux.alert.show({
          title: '',
          content: '请输入正确的手机号'
        });
      }
    },
    choseCustomer: function choseCustomer(index, value, type) {
      switch (type) {
        case 'visited':
          this.info.customer_visited[index].customer = value;
          this.saveInfo();
          this.isVisitedCustomer = false;
          break;
        case 'solution':
          this.info.solutions[index].customer = value;
          this.isSolutionCustomer = false;
          break;
      }
    },
    searchCustomer: function searchCustomer(even, type) {
      var _this = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/srvp_projects/project_similar?&offset=0&count=20&tp=customer&arg=' + event.target.value, header).then(function (response) {
        if (type === 'visited') {
          _this.isVisitedCustomer = true;
        } else if (type === 'solution') {
          _this.isSolutionCustomer = true;
        }
        _this.customerList = response.data.content;
      });
    },
    changeTextarea: function changeTextarea(value) {
      this.saveInfo();
      var num = typeof value === "string" ? value.split('\n').length : value.target.value.split('\n').length;
      if (num === 3) {
        this.textnum = 3;
      } else if (num >= 4) {
        this.textnum = 4;
      }
    },
    changeDate: function changeDate() {
      var _this2 = this;

      var start = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
      var end = new Date();
      var startDate = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate();
      var endDate = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate();
      this.$vux.datetime.show({
        value: this.dateTime, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        startDate: startDate,
        endDate: endDate,
        onConfirm: function onConfirm(event) {
          _this2.getInfoFromDate(event);
        }
      });
    },
    choseImg: function choseImg(visitedindex) {
      var _this3 = this;

      if (this.info.customer_visited[visitedindex].photos.length >= 5) {
        alert('最多允许上传5张照片');
        return;
      }
      weixin_js_sdk_default.a.chooseImage({
        count: 5 - this.info.customer_visited[visitedindex].photos.length, // 默认9
        sizeType: ['compressed'],
        sourceType: ['album', 'camera'],
        success: function success(res) {
          _this3.$vux.loading.show({
            text: 'Loading'
          });
          var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          var i = 0;
          var length = localIds.length;
          var serverIds = [];
          var upload = function upload() {
            weixin_js_sdk_default.a.uploadImage({
              localId: localIds[i], // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success: function () {
                var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
                  var header, response, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, photo;

                  return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          // 返回图片的服务器端ID
                          header = {
                            headers: {
                              token: localStorage.getItem('token'),
                              opid: localStorage.getItem('userid')
                            }
                          };

                          serverIds.push(res.serverId);
                          i++;

                          if (!(i >= length)) {
                            _context.next = 38;
                            break;
                          }

                          _context.next = 6;
                          return _this3.$http.post('/api/v1/photos/wechat', { photo: serverIds }, header);

                        case 6:
                          response = _context.sent;

                          if (!response.data) {
                            _context.next = 38;
                            break;
                          }

                          _this3.info.customer_visited[visitedindex].photos = [].concat(toConsumableArray_default()(_this3.info.customer_visited[visitedindex].photos), toConsumableArray_default()(response.data));
                          _iteratorNormalCompletion = true;
                          _didIteratorError = false;
                          _iteratorError = undefined;
                          _context.prev = 12;
                          _iterator = get_iterator_default()(response['data']);

                        case 14:
                          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _context.next = 24;
                            break;
                          }

                          item = _step.value;
                          _context.next = 18;
                          return _this3.$http.get('api/v1/photos?path=' + item.thumb);

                        case 18:
                          photo = _context.sent;

                          _this3.imgList[visitedindex].push('data:image/jpeg;base64,' + photo.data['value']);
                          _this3.$vux.loading.hide();

                        case 21:
                          _iteratorNormalCompletion = true;
                          _context.next = 14;
                          break;

                        case 24:
                          _context.next = 30;
                          break;

                        case 26:
                          _context.prev = 26;
                          _context.t0 = _context["catch"](12);
                          _didIteratorError = true;
                          _iteratorError = _context.t0;

                        case 30:
                          _context.prev = 30;
                          _context.prev = 31;

                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }

                        case 33:
                          _context.prev = 33;

                          if (!_didIteratorError) {
                            _context.next = 36;
                            break;
                          }

                          throw _iteratorError;

                        case 36:
                          return _context.finish(33);

                        case 37:
                          return _context.finish(30);

                        case 38:
                          if (i < length && i <= 9) {
                            upload();
                          }

                        case 39:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this3, [[12, 26, 30, 38], [31,, 33, 37]]);
                }));

                return function success(_x) {
                  return _ref.apply(this, arguments);
                };
              }()
            });
          };
          upload();
        },
        fail: function fail() {
          _this3.$vux.loading.hide();
        }
      });
    },
    removeImg: function removeImg(visitedindex, photoindex) {
      this.imgList[visitedindex].splice(photoindex, 1);
      this.info.customer_visited[visitedindex].photos.splice(photoindex, 1);
    },
    removeAppendix: function removeAppendix(index) {
      this.info.appendix.splice(index, 1);
    },
    removeSolutionAppendix: function removeSolutionAppendix(solutionindex, index) {
      this.info.solutions[solutionindex].appendix.splice(index, 1);
    },
    choseAppendix: function choseAppendix(type, index) {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var fs, appendix, i, formData, d, arr, response;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fs = void 0;
                appendix = [];
                _context2.t0 = type;
                _context2.next = _context2.t0 === 'appendix' ? 5 : _context2.t0 === 'solution' ? 11 : 13;
                break;

              case 5:
                fs = _this4.$refs.file.files;
                if (_this4.info.appendix) {
                  appendix = [].concat(toConsumableArray_default()(_this4.info.appendix));
                }

                if (!(appendix.length >= 3)) {
                  _context2.next = 10;
                  break;
                }

                alert('最多允许上传3份附件');
                return _context2.abrupt("return");

              case 10:
                return _context2.abrupt("break", 13);

              case 11:
                fs = _this4.$refs.filesolution[index].files;
                return _context2.abrupt("break", 13);

              case 13:
                _this4.$vux.loading.show({
                  text: 'Loading'
                });
                i = 0;

              case 15:
                if (!(i < fs.length)) {
                  _context2.next = 33;
                  break;
                }

                formData = new FormData();
                d = fs[i];

                if (!(d.size <= 1024 * 1024 * 100)) {
                  _context2.next = 28;
                  break;
                }

                //文件必须小于100M
                formData.append("file", fs[i]);
                arr = d.name;

                formData.append("name", arr);
                _context2.next = 24;
                return _this4.$http.post('api/v1/photos/upload', formData);

              case 24:
                response = _context2.sent;

                appendix.push({ path: response.data.path, suffix: arr });
                _context2.next = 30;
                break;

              case 28:
                alert('上传文件过大！');
                return _context2.abrupt("return", false);

              case 30:
                i++;
                _context2.next = 15;
                break;

              case 33:
                _this4.$vux.loading.hide();
                _context2.t1 = type;
                _context2.next = _context2.t1 === 'appendix' ? 37 : _context2.t1 === 'solution' ? 39 : 41;
                break;

              case 37:
                _this4.info.appendix = appendix;
                return _context2.abrupt("break", 41);

              case 39:
                _this4.info.solutions[index].appendix = appendix;
                return _context2.abrupt("break", 41);

              case 41:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    submit: function submit() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var i, item, reg, _i, _item;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                i = 0;

              case 1:
                if (!(i < _this5.info.customer_visited.length)) {
                  _context3.next = 23;
                  break;
                }

                item = _this5.info.customer_visited[i];

                if (!(!item.customer && !item.name)) {
                  _context3.next = 7;
                  break;
                }

                _this5.info.customer_visited.splice(i, 1);
                i--;
                return _context3.abrupt("continue", 20);

              case 7:
                if (item.communicate) {
                  _context3.next = 10;
                  break;
                }

                alert('请选择客户拜访的沟通方式');
                return _context3.abrupt("return");

              case 10:
                if (item.mobile) {
                  _context3.next = 13;
                  break;
                }

                alert('请填写客户拜访的联系手机');
                return _context3.abrupt("return");

              case 13:
                if (item.prop) {
                  _context3.next = 16;
                  break;
                }

                alert('请填写客户性质');
                return _context3.abrupt("return");

              case 16:
                reg = /^1[0-9]{10}$/;

                if (reg.test(item.mobile)) {
                  _context3.next = 20;
                  break;
                }

                alert('请输入正确的手机号');
                return _context3.abrupt("return");

              case 20:
                i++;
                _context3.next = 1;
                break;

              case 23:
                _i = 0;

              case 24:
                if (!(_i < _this5.info.solutions.length)) {
                  _context3.next = 32;
                  break;
                }

                _item = _this5.info.solutions[_i];

                if (!(!_item.appendix || !_item.customer)) {
                  _context3.next = 29;
                  break;
                }

                alert('请补充提交方案情况');
                return _context3.abrupt("return");

              case 29:
                _i++;
                _context3.next = 24;
                break;

              case 32:
                if (_this5.info.myscore) {
                  _context3.next = 35;
                  break;
                }

                _this5.$vux.alert.show({
                  title: '',
                  content: '请填写自我评分'
                });
                return _context3.abrupt("return");

              case 35:
                if (_this5.isEditChange) {
                  _this5.editInfo();
                } else {
                  _this5.createInfo();
                }

              case 36:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    createInfo: function createInfo() {
      var _this6 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.info.resources = this.resource ? this.resource.split('\n') : [];
      this.info.others = this.other ? this.other.split('\n') : [];
      this.info.next = this.next ? this.next.split('\n') : [];
      var info = {
        day: this.dateTime,
        info: this.info
      };
      this.$http.post('/api/v1/sale_logs', info, header).then(function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(res) {
          return regenerator_default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this6.$http.get('/api/v1/sale_logs/' + res.data.logid + '/set_salelog_visible_to?userids=' + stringify_default()(_this6.visiable) + '&visible=true', header);

                case 2:
                  _this6.$vux.alert.show({
                    title: '',
                    content: '创建成功'
                  });
                  localStorage.removeItem(_this6.dateTime);
                  _this6.$emit('editAcreate');

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, _this6);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        _this6.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    editInfo: function editInfo() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
        var header, i, item, info, _info;

        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                header = {
                  headers: {
                    token: localStorage.getItem('token'),
                    opid: localStorage.getItem('userid')
                  }
                };

                for (i = 0; i < _this7.info.customer_visited.length; i++) {
                  item = _this7.info.customer_visited[i];

                  if (!item.customer && !item.name) {
                    _this7.info.customer_visited.splice(i, 1);
                    i--;
                  }
                }
                _this7.info.resources = _this7.resource ? _this7.resource.split('\n') : [];
                _this7.info.others = _this7.other ? _this7.other.split('\n') : [];
                _this7.info.next = _this7.next ? _this7.next.split('\n') : [];
                if (_this7.isClear) {
                  _this7.$http.delete('/api/v1/sale_logs/' + _this7.isClear, header).then(function () {}).catch(function (error) {
                    _this7.$vux.alert.show({
                      title: '',
                      content: JSON.parse(error.response.data.error_message).zh_string
                    });
                  });
                }

                if (!_this7.info.id) {
                  _context6.next = 23;
                  break;
                }

                info = {
                  customer_visited: _this7.info.customer_visited,
                  resources: _this7.info.resources,
                  others: _this7.info.others,
                  next: _this7.info.next,
                  appendix: _this7.info.appendix ? _this7.info.appendix : [],
                  photos: _this7.info.photos ? _this7.info.photos : [],
                  solutions: _this7.info.solutions ? _this7.info.solutions : [],
                  myscore: _this7.info.myscore
                };
                _context6.prev = 8;
                _context6.next = 11;
                return _this7.$http.get('/api/v1/sale_logs/' + _this7.info.id + '/set_salelog_visible_to?userids=' + stringify_default()(_this7.visiable) + '&visible=true', header);

              case 11:
                _context6.next = 13;
                return _this7.$http.put('/api/v1/sale_logs/' + _this7.info.id, { info: info }, header);

              case 13:
                _this7.$vux.alert.show({
                  title: '',
                  content: '修改成功'
                });
                _this7.$emit('editAcreate');
                _this7.$router.push({ name: 'saleslog' });
                _context6.next = 21;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6["catch"](8);

                _this7.$vux.alert.show({
                  title: '',
                  content: JSON.parse(_context6.t0.response.data.error_message).zh_string
                });

              case 21:
                _context6.next = 25;
                break;

              case 23:
                _info = {
                  day: _this7.dateTime,
                  info: _this7.info
                };

                _this7.$http.post('/api/v1/sale_logs', _info, header).then(function () {
                  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(res) {
                    return regenerator_default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return _this7.$http.get('/api/v1/sale_logs/' + res.data.logid + '/set_salelog_visible_to?userids=' + stringify_default()(_this7.visiable) + '&visible=true', header);

                          case 2:
                            _this7.$vux.alert.show({
                              title: '',
                              content: '修改成功'
                            });
                            _this7.$emit('editAcreate');

                          case 4:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, _this7);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  _this7.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                });

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[8, 18]]);
      }))();
    },
    getInfoFromDate: function getInfoFromDate(date) {
      var _this8 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/sale_logs/get_my_salelog_by_day?day=' + date, header).then(function (response) {
        if (_this8.isEditChange) {
          if (response.data) {
            if (date === _this8.date) {
              _this8.info = response.data;
              _this8.imgList = [];
              _this8.visiable = [];
              /*this.info.photos.forEach(async item => {
                const photo = await this.$http.get('api/v1/photos?path=' + item.origin)
                this.imgList.push('data:image/jpeg;base64,' + photo.data['value'])
              })*/
              _this8.info.customer_visited.forEach(function (item) {
                _this8.imgList.push([]);
              });
              _this8.info.next.forEach(function (item, index) {
                _this8.next += index === 0 ? item : '\n' + item;
              });
              _this8.info.resources.forEach(function (item, index) {
                _this8.resource += index === 0 ? item : '\n' + item;
              });
              _this8.info.others.forEach(function (item, index) {
                _this8.other += index === 0 ? item : '\n' + item;
              });
              return;
            }
            _this8.$vux.alert.show({
              title: '',
              content: '您' + response.data['time'] + '已有日志，请修改为其他日期或编辑当天日志进行修改'
            });
            _this8.dateTime = _this8.info.time;
          } else {
            if (confirm('确认将' + _this8.info.time + '日志修改' + date + '日志，修改后' + _this8.info.time + '日志需要重新填写，确认修改？')) {
              _this8.info.project_added = response.data ? response.data['project_added'] : [];
              _this8.info.project_updated = response.data ? response.data['project_updated'] : [];
              _this8.info.appendix = response.data ? response.data['appendix'] : [];
              _this8.info.photos = response.data ? response.data['photos'] : [];
              _this8.info.solutions = response.data ? response.data['solutions'] : [];
              _this8.dateTime = date;
              _this8.isClear = _this8.info.id;
              delete _this8.info.id;
            } else {
              _this8.dateTime = _this8.info.time;
            }
          }
        } else {
          var info = localStorage.getItem(_this8.dateTime);
          _this8.imgList = [];
          if (response.data) {
            if (response.data.write) {
              _this8.$vux.alert.show({
                title: '',
                content: '您' + date + '已提交过日志，请修改为其他日期或编辑当天的日志进行修改'
              });
              _this8.info.project_updated = response.data['project_updated'];
              _this8.info.project_added = response.data['project_added'];
            } else {
              if (_this8.resource || _this8.other || _this8.next) {
                if (!confirm('您已有写入内容，确认将当前写入内容修改为' + date + '日志')) {
                  var info_json = JSON.parse(info);
                  if (info_json && info_json.hasOwnProperty('date') && info_json.date === date) {
                    _this8.info = info_json;
                    delete _this8.info.date;
                  } else {
                    _this8.info = {
                      project_added: [],
                      project_updated: [],
                      customer_visited: [],
                      solutions: [],
                      next: [],
                      others: [],
                      resources: [],
                      photos: [],
                      appendix: []
                    };
                  }
                }
              }
              _this8.info.project_updated = response.data.project_updated;
              _this8.info.project_added = response.data.project_added;
              _this8.info.id = response.data.id;
              _this8.isEditChange = true;
            }
          } else {
            if (_this8.resource || _this8.other || _this8.next) {
              if (!confirm('您已有写入内容，确认将当前写入内容修改为' + date + '日志')) {
                if (info) {
                  var _info_json = JSON.parse(info);
                  if (_info_json.date === date) {
                    _this8.info = _info_json;
                    delete _this8.info.date;
                  } else {
                    _this8.info = {
                      project_added: [],
                      project_updated: [],
                      customer_visited: [],
                      next: [],
                      others: [],
                      resources: [],
                      appendix: [],
                      photos: [],
                      solutions: []
                    };
                  }
                } else {
                  _this8.info = {
                    project_added: [],
                    project_updated: [],
                    customer_visited: [],
                    next: [],
                    others: [],
                    resources: [],
                    appendix: [],
                    photos: [],
                    solutions: []
                  };
                }
              }
            } else {
              _this8.info = {
                project_added: [],
                project_updated: [],
                customer_visited: [],
                next: [],
                others: [],
                resources: [],
                appendix: [],
                photos: [],
                solutions: []
              };
            }
          }
          _this8.dateTime = date;
          _this8.visiable = [];
          _this8.imgList = [];
          _this8.info.customer_visited.forEach(function (item) {
            _this8.imgList.push([]);
          });
          _this8.info.next.forEach(function (item, index) {
            _this8.next += index === 0 ? item : '\n' + item;
          });
          _this8.info.resources.forEach(function (item, index) {
            _this8.resource += index === 0 ? item : '\n' + item;
          });
          _this8.info.others.forEach(function (item, index) {
            _this8.other += index === 0 ? item : '\n' + item;
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this8.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    getVisiable: function getVisiable() {
      var _this9 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/sale_logs/' + this.id + '/list_salelog_visible_to?offset=0&count=9999', header).then(function (res) {
        _this9.visiableUserList = res.data['content'].filter(function (item) {
          return item.default;
        });
        res.data['content'].forEach(function (item) {
          if (!item.default) {
            _this9.visiable = [].concat(toConsumableArray_default()(_this9.visiable), [item.userid]);
          }
        });
      }).catch(function (error) {
        _this9.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    getVisiableUser: function getVisiableUser() {
      var _this10 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/agencies?task=ALL&offset=0&count=9999&hint=', header).then(function (response) {
        _this10.visiableUser = response.data;
      }).catch(function (error) {
        _this10.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    saveInfo: function saveInfo() {
      this.info.date = this.dateTime;
      this.info.resources = this.resource ? this.resource.split('\n') : [];
      this.info.others = this.other ? this.other.split('\n') : [];
      this.info.next = this.next ? this.next.split('\n') : [];
      localStorage.setItem(this.dateTime, stringify_default()(this.info));
    }
  },
  mounted: function mounted() {
    var _this11 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var url;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      _this11.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        url = isiOS ? config.host + src_components_global.entryUrl.split('?')[0] : config.host + _this11.$route.path;
        var noncestr = Math.random().toString(36).substr(2);
        _this11.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi', 'scanQRCode'] // 必填，需要使用的JS接口列表
          });
          weixin_js_sdk_default.a.error(function (res) {
            //alert(res.errMsg)
          });
        }).catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    var _this12 = this;

    this.getInfoFromDate(this.date);
    this.getVisiableUser();
    if (this.id) {
      this.getVisiable();
    } else {
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/sale_logs/get_salelog_config?userid=' + localStorage.getItem('userid') + '&offset=0&count=999999', header).then(function (res) {
        _this12.visiableUserList = res.data['content'].map(function (item) {
          return { name: item.srvp.name };
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-208198a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Saleslog/addsaleslog.vue
var addsaleslog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticStyle:{"padding-top":"5px","display":"flex","align-items":"center"}},[_c('h4',[_vm._v("日志时间")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateTime),expression:"dateTime"}],staticStyle:{"margin-left":"10px"},attrs:{"type":"text"},domProps:{"value":(_vm.dateTime)},on:{"click":_vm.changeDate,"input":function($event){if($event.target.composing){ return; }_vm.dateTime=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("一、今日新增商机备案("+_vm._s(_vm.info.project_added.length)+")")]),_vm._v(" "),(_vm.info.project_added)?_vm._l((_vm.info.project_added),function(add,addindex){return _c('p',{key:addindex},[_vm._v(_vm._s(addindex + 1 + '、')+_vm._s(add.desc))])}):[_c('p',[_vm._v("无")])]],2),_vm._v(" "),_c('div',[_c('h4',[_vm._v("二、今日更新项目信息("+_vm._s(_vm.info.project_updated.length)+")")]),_vm._v(" "),(_vm.info.project_updated)?_vm._l((_vm.info.project_updated),function(updated,updatedindex){return _c('p',{key:updatedindex},[_vm._v("\n        "+_vm._s(updatedindex + 1 + '、')+_vm._s(updated.desc)+"\n        "),_vm._l((updated.record),function(record,recordindex){return _c('span',{key:'record-'+recordindex,staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(record))])})],2)}):[_c('p',[_vm._v("无")])]],2),_vm._v(" "),_c('div',[_c('h4',[_vm._v("三、今日客户拜访情况("+_vm._s(_vm.info.customer_visited.length)+")")]),_vm._v(" "),_vm._l((_vm.info.customer_visited),function(visited,visitedindex){return _c('div',{key:visitedindex,staticClass:"visited_wrap"},[_c('button',{staticStyle:{"float":"right","background":"red","color":"#fff","padding":"5px","border":"none","outline":"none","margin-bottom":"5px","border-radius":"5px"},on:{"click":function($event){_vm.removeVisited(visitedindex)}}},[_vm._v("\n        删除\n      ")]),_vm._v(" "),_c('p',{staticStyle:{"position":"relative","clear":"both"}},[_c('label',[_vm._v("客户单位：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(visited.customer),expression:"visited.customer"}],attrs:{"type":"text"},domProps:{"value":(visited.customer)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(visited, "customer", $event.target.value)},function($event){_vm.searchCustomer($event,'visited')}]}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisitedCustomer),expression:"isVisitedCustomer"}],staticClass:"search_result_wrap"},_vm._l((_vm.customerList),function(customer,customerindex){return _c('span',{key:customerindex,on:{"click":function($event){_vm.choseCustomer(visitedindex,customer,'visited')}}},[_vm._v(_vm._s(customer))])}))]),_vm._v(" "),_c('p',[_c('label',[_vm._v("客户性质：")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(visited.prop),expression:"visited.prop"}],staticStyle:{"flex":"1","outline":"none","border-radius":"2px","border":"none","padding":"3px"},on:{"input":_vm.saveInfo,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(visited, "prop", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"签约经销商"}},[_vm._v("签约经销商")]),_vm._v(" "),_c('option',{attrs:{"value":"其他合作伙伴"}},[_vm._v("其他合作伙伴")]),_vm._v(" "),_c('option',{attrs:{"value":"最终用户"}},[_vm._v("最终用户")])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("联 系 人：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(visited.name),expression:"visited.name"}],attrs:{"type":"text"},domProps:{"value":(visited.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(visited, "name", $event.target.value)},_vm.saveInfo]}})]),_vm._v(" "),_c('p',[_c('label',[_vm._v("职  务：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(visited.title),expression:"visited.title"}],attrs:{"type":"text"},domProps:{"value":(visited.title)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(visited, "title", $event.target.value)},_vm.saveInfo]}})]),_vm._v(" "),_c('p',[_c('label',[_vm._v("联系手机：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(visited.mobile),expression:"visited.mobile"}],attrs:{"type":"text","maxlength":"11","oninput":"value=value.replace(/[^\\d]/g,'')"},domProps:{"value":(visited.mobile)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(visited, "mobile", $event.target.value)},_vm.saveInfo],"blur":function($event){_vm.checkMobile($event)}}})]),_vm._v(" "),_c('p',[_c('label',[_vm._v("列席人员：")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(visited.accompany),expression:"visited.accompany"}],attrs:{"type":"text"},domProps:{"value":(visited.accompany)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(visited, "accompany", $event.target.value)},_vm.saveInfo]}})]),_vm._v(" "),_c('p',[_c('label',[_vm._v("沟通方式：")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(visited.communicate),expression:"visited.communicate"}],staticStyle:{"flex":"1","outline":"none","border-radius":"2px","border":"none","padding":"3px"},on:{"input":_vm.saveInfo,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(visited, "communicate", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"现场拜访"}},[_vm._v("现场拜访")]),_vm._v(" "),_c('option',{attrs:{"value":"视频会议"}},[_vm._v("视频会议")]),_vm._v(" "),_c('option',{attrs:{"value":"电话沟通"}},[_vm._v("电话沟通")])])]),_vm._v(" "),_c('p',[_c('label',[_vm._v("沟通内容：")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(visited.content),expression:"visited.content"}],staticClass:"white-text",attrs:{"wrap":"soft","rows":_vm.textnum},domProps:{"value":(visited.content)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(visited, "content", $event.target.value)},function($event){_vm.changeTextarea($event)}]}})]),_vm._v(" "),_c('p',[_c('label',[_vm._v("跟进计划：")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(visited.plan),expression:"visited.plan"}],staticClass:"white-text",attrs:{"wrap":"soft","rows":_vm.textnum},domProps:{"value":(visited.plan)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(visited, "plan", $event.target.value)},function($event){_vm.changeTextarea($event)}]}})]),_vm._v(" "),_c('div',[_c('label',{staticStyle:{"font-size":"12px","color":"rgb(255, 255, 255)"}},[_vm._v("上传照片：")]),_vm._v(" "),_c('button',{staticClass:"photo_btn",on:{"click":function($event){_vm.choseImg(visitedindex)}}},[_vm._v("上传")]),_vm._v(" "),_c('div',{staticClass:"img_box"},_vm._l((_vm.imgList[visitedindex]),function(photo,photo_index){return _c('div',{key:photo_index},[_c('img',{attrs:{"src":photo,"alt":""}}),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.removeImg(visitedindex,photo_index)}}},[_vm._v("×")])])}))])])}),_vm._v(" "),_c('button',{staticClass:"add_btn",on:{"click":_vm.addVisited}},[_vm._v("添加")])],2),_vm._v(" "),_c('div',[_c('h4',[_vm._v("四、今日提交方案/报价情况("+_vm._s(_vm.info.solutions.length)+")")]),_vm._v(" "),_vm._l((_vm.info.solutions),function(solution,solutionsindex){return _c('div',{key:'solutions-' + solutionsindex,staticClass:"visited_wrap"},[_c('button',{staticStyle:{"float":"right","background":"red","color":"#fff","padding":"5px","border":"none","outline":"none","margin-bottom":"5px","border-radius":"5px"},on:{"click":function($event){_vm.removeSolution(solutionsindex)}}},[_vm._v("\n        删除\n      ")]),_vm._v(" "),_c('p',{staticStyle:{"position":"relative","clear":"both"}},[_c('label',[_vm._v("客户单位：")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(solution.customer),expression:"solution.customer"}],attrs:{"type":"text"},domProps:{"value":(solution.customer)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(solution, "customer", $event.target.value)},function($event){_vm.searchCustomer($event,'solution')}]}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSolutionCustomer),expression:"isSolutionCustomer"}],staticClass:"search_result_wrap"},_vm._l((_vm.customerList),function(customer,customerindex){return _c('span',{key:customerindex,on:{"click":function($event){_vm.choseCustomer(solutionsindex,customer,'solution')}}},[_vm._v(_vm._s(customer))])}))]),_vm._v(" "),_c('div',[_c('label',{staticStyle:{"font-size":"12px","color":"#fff"}},[_vm._v("方案附件：")]),_vm._v(" "),_c('div',[_c('h4',[_c('input',{ref:"filesolution",refInFor:true,attrs:{"type":"file","id":"filesolution","multiple":""},on:{"change":function($event){_vm.choseAppendix('solution',solutionsindex)}}})]),_vm._v(" "),_c('div',_vm._l((solution.appendix),function(appendix,appendix_index){return _c('p',{key:'sss-' + appendix_index,staticClass:"appendix"},[_vm._v("\n              "+_vm._s(appendix.suffix)+"\n              "),_c('span',{on:{"click":function($event){_vm.removeSolutionAppendix(solutionsindex,appendix_index)}}},[_vm._v("×")])])}))])])])}),_vm._v(" "),_c('button',{staticClass:"add_btn",on:{"click":_vm.addSolution}},[_vm._v("添加")])],2),_vm._v(" "),_c('div',[_c('h4',[_vm._v("五、下一工作日重点工作计划")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.next),expression:"next"}],attrs:{"wrap":"soft","rows":_vm.textnum},domProps:{"value":(_vm.next)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.next=$event.target.value},function($event){_vm.changeTextarea($event)}]}})]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("六、需公司协调资源")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.resource),expression:"resource"}],attrs:{"wrap":"soft","rows":_vm.textnum},domProps:{"value":(_vm.resource)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.resource=$event.target.value},function($event){_vm.changeTextarea($event)}]}})]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("七、其他需说明事项")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.other),expression:"other"}],attrs:{"wrap":"soft","rows":_vm.textnum},domProps:{"value":(_vm.other)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.other=$event.target.value},function($event){_vm.changeTextarea($event)}]}})]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("上传附件"),_c('input',{ref:"file",attrs:{"type":"file","id":"file","multiple":""},on:{"change":function($event){_vm.choseAppendix('appendix',null)}}})]),_vm._v(" "),_c('div',_vm._l((_vm.info.appendix),function(appendix,appendix_index){return _c('p',{key:appendix_index,staticClass:"appendix"},[_vm._v("\n        "+_vm._s(appendix.suffix)+"\n        "),_c('span',{on:{"click":function($event){_vm.removeAppendix(appendix_index)}}},[_vm._v("×")])])}))]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("发送到人")]),_vm._v(" "),_c('p',[_vm._v("默认发送：\n      "),_vm._l((_vm.visiableUserList),function(item,index){return _c('span',{key:index},[_vm._v(_vm._s(index ? ',' + item.name : item.name)+"\n      ")])})],2),_vm._v(" "),_c('p',[_vm._v("抄送：\n      "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.visiable),expression:"visiable"}],staticStyle:{"flex":".5"},attrs:{"multiple":"multiple"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.visiable=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.visiableUser),function(vis,visindex){return _c('option',{key:visindex,attrs:{"value":"volvo"},domProps:{"value":vis.userid}},[_vm._v("\n          "+_vm._s(vis.name)+"\n        ")])}))])]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("当日工作自我综合评分")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.info.myscore),expression:"info.myscore"}],staticStyle:{"margin":"5px 0 0 5px"},attrs:{"oninput":"value=value.replace(/[^\\d]/g,'')","minlength":"1","maxlength":"2"},domProps:{"value":(_vm.info.myscore)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.info, "myscore", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"submit",on:{"click":_vm.submit}},[_vm._v("提交")])])}
var addsaleslog_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#006892","border-radius":"5px"}},[_c('p',[_vm._v("请参考以下几个纬度综合评分")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v("12分：业绩明显超过计划，非常满意； ")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v("10分：业绩完成计划，基本满意；")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v("8分：业绩计划完成60%及以上，重点工作按计划推进；")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v("5分：业绩计划负偏离50%以上，重点工作计划未推进；")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v(" 0分：今日未开展工作（请假或碌碌无为的一天）。")])])}]
var addsaleslog_esExports = { render: addsaleslog_render, staticRenderFns: addsaleslog_staticRenderFns }
/* harmony default export */ var components_Saleslog_addsaleslog = (addsaleslog_esExports);
// CONCATENATED MODULE: ./src/components/Saleslog/addsaleslog.vue
function addsaleslog_injectStyle (ssrContext) {
  __webpack_require__("s8nJ")
}
var addsaleslog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var addsaleslog___vue_template_functional__ = false
/* styles */
var addsaleslog___vue_styles__ = addsaleslog_injectStyle
/* scopeId */
var addsaleslog___vue_scopeId__ = "data-v-208198a2"
/* moduleIdentifier (server only) */
var addsaleslog___vue_module_identifier__ = null
var addsaleslog_Component = addsaleslog_normalizeComponent(
  Saleslog_addsaleslog,
  components_Saleslog_addsaleslog,
  addsaleslog___vue_template_functional__,
  addsaleslog___vue_styles__,
  addsaleslog___vue_scopeId__,
  addsaleslog___vue_module_identifier__
)

/* harmony default export */ var src_components_Saleslog_addsaleslog = (addsaleslog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Saleslog/settinglogs.vue




/* harmony default export */ var settinglogs = ({
  name: "settinglogs",
  components: { XTable: vux_src_components_x_table, CheckIcon: vux_src_components_check_icon },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      isLeader: false,
      isName: false,
      visiableName: '',
      userList: [],
      userTotal: 0,
      visiableUser: [],
      date: '',
      visiableUserid: ''
    };
  },

  methods: {
    submit: function submit(bool, userid) {
      var _this = this;

      userid = userid ? userid : this.visiableUserid;
      if (!userid) {
        this.$vux.alert.show({
          title: '',
          content: '请选择日志可见人'
        });
        return;
      }
      var time = void 0;
      try {
        time = bool ? this.date : '1970-01-01';
      } catch (e) {
        time = '1970-01-01';
      }
      if (this.isLeader) {
        if (confirm('设置直属领导后，原设置将会被覆盖，是否继续？')) this.$http.get('/api/v1/sale_logs/config_my_salelog?src=' + localStorage.getItem('userid') + '&tag=' + userid + '&add=' + bool + '&start=' + time + '&is_leader=' + this.isLeader, this.header).then(function () {
          _this.getUserList();
          _this.$vux.alert.show({
            title: '',
            content: '设置成功'
          });
        }).catch(function (error) {
          _this.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        });
      } else {
        this.$http.get('/api/v1/sale_logs/config_my_salelog?src=' + localStorage.getItem('userid') + '&tag=' + userid + '&add=' + bool + '&start=' + time + '&is_leader=' + this.isLeader, this.header).then(function () {
          _this.getUserList();
          _this.$vux.alert.show({
            title: '',
            content: '设置成功'
          });
        }).catch(function (error) {
          _this.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        });
      }
    },
    changeDate: function changeDate() {
      var _this2 = this;

      this.$vux.datetime.show({
        value: this.date, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        onConfirm: function onConfirm(event) {
          _this2.date = event;
        }
      });
    },
    choseVisiable: function choseVisiable(value) {
      this.visiableName = value.name;
      this.visiableUserid = value.userid;
      this.isName = false;
    },
    getVisiableUser: function getVisiableUser(event) {
      var _this3 = this;

      var value = event ? event.target.value : '';
      this.$http.get('/api/v1/agencies?task=ALL&offset=0&count=9999&hint=' + value, this.header).then(function (response) {
        _this3.visiableUser = response.data;
        _this3.isName = event;
      }).catch(function (error) {
        _this3.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    getUserList: function getUserList() {
      var _this4 = this;

      this.$http.get('/api/v1/sale_logs/get_salelog_config?userid=' + localStorage.getItem('userid') + '&offset=0&count=10', this.header).then(function (response) {
        _this4.userList = response.data['content'];
        _this4.userTotal = response.data['total'];
      }).catch(function (error) {
        _this4.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    this.getVisiableUser('');
    this.getUserList();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Saleslog/settinglogs.vue




/* harmony default export */ var Saleslog_settinglogs = ({
  name: "settinglogs",
  components: { XTable: vux_src_components_x_table, CheckIcon: vux_src_components_check_icon },
  data: function data() {
    return {
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      isLeader: false,
      isName: false,
      visiableName: '',
      userList: [],
      userTotal: 0,
      visiableUser: [],
      date: '',
      visiableUserid: ''
    };
  },

  methods: {
    submit: function submit(bool, userid) {
      var _this = this;

      userid = userid ? userid : this.visiableUserid;
      if (!userid) {
        this.$vux.alert.show({
          title: '',
          content: '请选择日志可见人'
        });
        return;
      }
      var time = void 0;
      try {
        time = bool ? this.date : '1970-01-01';
      } catch (e) {
        time = '1970-01-01';
      }
      if (this.isLeader) {
        if (confirm('设置直属领导后，原设置将会被覆盖，是否继续？')) this.$http.get('/api/v1/sale_logs/config_my_salelog?src=' + localStorage.getItem('userid') + '&tag=' + userid + '&add=' + bool + '&start=' + time + '&is_leader=' + this.isLeader, this.header).then(function () {
          _this.getUserList();
          _this.$vux.alert.show({
            title: '',
            content: '设置成功'
          });
        }).catch(function (error) {
          _this.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        });
      } else {
        this.$http.get('/api/v1/sale_logs/config_my_salelog?src=' + localStorage.getItem('userid') + '&tag=' + userid + '&add=' + bool + '&start=' + time + '&is_leader=' + this.isLeader, this.header).then(function () {
          _this.getUserList();
          _this.$vux.alert.show({
            title: '',
            content: '设置成功'
          });
        }).catch(function (error) {
          _this.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        });
      }
    },
    changeDate: function changeDate() {
      var _this2 = this;

      this.$vux.datetime.show({
        value: this.date, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        onConfirm: function onConfirm(event) {
          _this2.date = event;
        }
      });
    },
    choseVisiable: function choseVisiable(value) {
      this.visiableName = value.name;
      this.visiableUserid = value.userid;
      this.isName = false;
    },
    getVisiableUser: function getVisiableUser(event) {
      var _this3 = this;

      var value = event ? event.target.value : '';
      this.$http.get('/api/v1/agencies?task=ALL&offset=0&count=9999&hint=' + value, this.header).then(function (response) {
        _this3.visiableUser = response.data;
        _this3.isName = event;
      }).catch(function (error) {
        _this3.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    getUserList: function getUserList() {
      var _this4 = this;

      this.$http.get('/api/v1/sale_logs/get_salelog_config?userid=' + localStorage.getItem('userid') + '&offset=0&count=10', this.header).then(function (response) {
        _this4.userList = response.data['content'];
        _this4.userTotal = response.data['total'];
      }).catch(function (error) {
        _this4.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    this.getVisiableUser('');
    this.getUserList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c03cf8dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Saleslog/settinglogs.vue
var settinglogs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"flex-box",staticStyle:{"margin-bottom":"5px"}},[_c('label',{staticStyle:{"width":"31%"}},[_vm._v("日志可见人")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visiableName),expression:"visiableName"}],attrs:{"type":"text"},domProps:{"value":(_vm.visiableName)},on:{"~click":function($event){_vm.isName=true},"input":[function($event){if($event.target.composing){ return; }_vm.visiableName=$event.target.value},function($event){_vm.getVisiableUser($event)}]}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isName),expression:"isName"}],staticClass:"search_result_wrap"},_vm._l((_vm.visiableUser),function(visiable,visiableindex){return _c('span',{key:visiableindex,on:{"click":function($event){_vm.choseVisiable(visiable)}}},[_vm._v(_vm._s(visiable.name))])}))]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('label',{staticStyle:{"width":"31%"}},[_vm._v("可见起始日期")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date),expression:"date"}],attrs:{"type":"text"},domProps:{"value":(_vm.date)},on:{"click":_vm.changeDate,"input":function($event){if($event.target.composing){ return; }_vm.date=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('label',{staticStyle:{"width":"31%"}},[_vm._v("是否直属上级")]),_vm._v(" "),_c('check-icon',{attrs:{"value":_vm.isLeader,"type":"plain"},on:{"update:value":function($event){_vm.isLeader=$event}}})],1),_vm._v(" "),_c('button',{staticClass:"add",on:{"click":function($event){_vm.submit(true,_vm.visiableUserid)}}},[_vm._v("添加")])]),_vm._v(" "),_c('x-table',{staticStyle:{"background-color":"#fff"},attrs:{"cell-bordered":false,"content-bordered":false}},[_c('thead',[_c('tr',{staticStyle:{"background-color":"#F7F7F7","color":"#000"}},[_c('th',[_vm._v("姓名")]),_vm._v(" "),_c('th',[_vm._v("可见起始日期")]),_vm._v(" "),_c('th',[_vm._v("是否直属上级")]),_vm._v(" "),_c('th',[_vm._v("操作")])])]),_vm._v(" "),_c('tbody',{staticStyle:{"color":"#000"}},_vm._l((_vm.userList),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.srvp.name))]),_vm._v(" "),_c('td',[(!item.isEdit)?[_vm._v("\n          "+_vm._s(item.start)+"\n        ")]:_vm._e(),_vm._v(" "),(item.isEdit)?[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date),expression:"date"}],staticStyle:{"background-color":"#eee"},attrs:{"type":"text"},domProps:{"value":(_vm.date)},on:{"click":_vm.changeDate,"input":function($event){if($event.target.composing){ return; }_vm.date=$event.target.value}}})]:_vm._e()],2),_vm._v(" "),_c('td',[(!item.isEdit)?[_vm._v(_vm._s(item.isleader ? '是' : '否'))]:[_c('check-icon',{attrs:{"value":_vm.isLeader,"type":"plain"},on:{"update:value":function($event){_vm.isLeader=$event}}})]],2),_vm._v(" "),_c('td',[(!item.isEdit)?[_c('button',{staticClass:"edit-button",staticStyle:{"background-color":"#40f842"},on:{"click":function($event){_vm.date=item.start;item.isEdit=true;_vm.isLeader=item.isleader}}},[_vm._v("编辑\n          ")]),_vm._v(" "),_c('button',{staticClass:"edit-button",staticStyle:{"background-color":"red"},on:{"click":function($event){_vm.submit(false,item.srvp.userid)}}},[_vm._v("删除\n          ")])]:_vm._e(),_vm._v(" "),(item.isEdit)?[_c('button',{staticClass:"edit-button",staticStyle:{"background-color":"#40f842"},on:{"click":function($event){_vm.submit(true,item.srvp.userid);item.isEdit = false}}},[_vm._v("确定\n          ")]),_vm._v(" "),_c('button',{staticClass:"edit-button",staticStyle:{"background-color":"#ddd"},on:{"click":function($event){item.isEdit=false;_vm.getUserList();}}},[_vm._v("\n            取消\n          ")])]:_vm._e()],2)])}))])],1)}
var settinglogs_staticRenderFns = []
var settinglogs_esExports = { render: settinglogs_render, staticRenderFns: settinglogs_staticRenderFns }
/* harmony default export */ var components_Saleslog_settinglogs = (settinglogs_esExports);
// CONCATENATED MODULE: ./src/components/Saleslog/settinglogs.vue
function settinglogs_injectStyle (ssrContext) {
  __webpack_require__("MGYK")
}
var settinglogs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var settinglogs___vue_template_functional__ = false
/* styles */
var settinglogs___vue_styles__ = settinglogs_injectStyle
/* scopeId */
var settinglogs___vue_scopeId__ = "data-v-c03cf8dc"
/* moduleIdentifier (server only) */
var settinglogs___vue_module_identifier__ = null
var settinglogs_Component = settinglogs_normalizeComponent(
  Saleslog_settinglogs,
  components_Saleslog_settinglogs,
  settinglogs___vue_template_functional__,
  settinglogs___vue_styles__,
  settinglogs___vue_scopeId__,
  settinglogs___vue_module_identifier__
)

/* harmony default export */ var src_components_Saleslog_settinglogs = (settinglogs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Saleslog/searchlogs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var searchlogs = ({
  name: "searchlogs",
  data: function data() {
    return {
      visiableName: '',
      visiableUserid: '',
      isName: false,
      visiableUser: [],
      start: '',
      end: '',
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    changeStartDate: function changeStartDate() {
      var _this = this;

      this.$vux.datetime.show({
        value: this.start, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        onConfirm: function onConfirm(event) {
          _this.start = event;
        }
      });
    },
    changeEndDate: function changeEndDate() {
      var _this2 = this;

      this.$vux.datetime.show({
        value: this.end, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        onConfirm: function onConfirm(event) {
          _this2.end = event;
        }
      });
    },
    search: function search() {
      this.$emit("search", { start: this.start, end: this.end, userid: this.visiableUserid });
    },
    choseVisiable: function choseVisiable(event) {
      this.visiableUserid = event.userid;
      this.visiableName = event.name;
      this.isName = false;
    },
    getVisiableUser: function getVisiableUser(value) {
      var _this3 = this;

      var hint = value ? value.target.value : '';
      this.$http.get('/api/v1/sale_logs/list_srvp_visible_to_me?offset=0&count=99&hint=' + hint, this.header).then(function (response) {
        _this3.visiableUser = response.data.content;
        _this3.isName = value;
      });
    }
  },
  created: function created() {
    this.getVisiableUser('');
    var startDate = new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-1');
    this.start = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate();
    this.end = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Saleslog/searchlogs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Saleslog_searchlogs = ({
  name: "searchlogs",
  data: function data() {
    return {
      visiableName: '',
      visiableUserid: '',
      isName: false,
      visiableUser: [],
      start: '',
      end: '',
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    changeStartDate: function changeStartDate() {
      var _this = this;

      this.$vux.datetime.show({
        value: this.start, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        onConfirm: function onConfirm(event) {
          _this.start = event;
        }
      });
    },
    changeEndDate: function changeEndDate() {
      var _this2 = this;

      this.$vux.datetime.show({
        value: this.end, // 其他参数同 props
        confirmText: '确定',
        cancelText: '取消',
        onConfirm: function onConfirm(event) {
          _this2.end = event;
        }
      });
    },
    search: function search() {
      this.$emit("search", { start: this.start, end: this.end, userid: this.visiableUserid });
    },
    choseVisiable: function choseVisiable(event) {
      this.visiableUserid = event.userid;
      this.visiableName = event.name;
      this.isName = false;
    },
    getVisiableUser: function getVisiableUser(value) {
      var _this3 = this;

      var hint = value ? value.target.value : '';
      this.$http.get('/api/v1/sale_logs/list_srvp_visible_to_me?offset=0&count=99&hint=' + hint, this.header).then(function (response) {
        _this3.visiableUser = response.data.content;
        _this3.isName = value;
      });
    }
  },
  created: function created() {
    this.getVisiableUser('');
    var startDate = new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-1');
    this.start = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate();
    this.end = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62f90dd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Saleslog/searchlogs.vue
var searchlogs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"flex-box",staticStyle:{"margin-bottom":"5px"}},[_c('label',{staticStyle:{"width":"31%"}},[_vm._v("提交人")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visiableName),expression:"visiableName"}],attrs:{"type":"text"},domProps:{"value":(_vm.visiableName)},on:{"~click":function($event){_vm.isName = true},"input":[function($event){if($event.target.composing){ return; }_vm.visiableName=$event.target.value},function($event){_vm.getVisiableUser($event)}]}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isName),expression:"isName"}],staticClass:"search_result_wrap"},_vm._l((_vm.visiableUser),function(visiable,visiableindex){return _c('span',{key:visiableindex,on:{"click":function($event){_vm.choseVisiable(visiable)}}},[_vm._v(_vm._s(visiable.name))])}))]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('label',{staticStyle:{"width":"31%"}},[_vm._v("起始日期")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.start),expression:"start"}],attrs:{"type":"text"},domProps:{"value":(_vm.start)},on:{"click":_vm.changeStartDate,"input":function($event){if($event.target.composing){ return; }_vm.start=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"flex-box"},[_c('label',{staticStyle:{"width":"31%"}},[_vm._v("结束日期")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.end),expression:"end"}],attrs:{"type":"text"},domProps:{"value":(_vm.end)},on:{"click":_vm.changeEndDate,"input":function($event){if($event.target.composing){ return; }_vm.end=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"add",on:{"click":function($event){_vm.search()}}},[_vm._v("筛选")])])])}
var searchlogs_staticRenderFns = []
var searchlogs_esExports = { render: searchlogs_render, staticRenderFns: searchlogs_staticRenderFns }
/* harmony default export */ var components_Saleslog_searchlogs = (searchlogs_esExports);
// CONCATENATED MODULE: ./src/components/Saleslog/searchlogs.vue
function searchlogs_injectStyle (ssrContext) {
  __webpack_require__("KwI3")
}
var searchlogs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var searchlogs___vue_template_functional__ = false
/* styles */
var searchlogs___vue_styles__ = searchlogs_injectStyle
/* scopeId */
var searchlogs___vue_scopeId__ = "data-v-62f90dd6"
/* moduleIdentifier (server only) */
var searchlogs___vue_module_identifier__ = null
var searchlogs_Component = searchlogs_normalizeComponent(
  Saleslog_searchlogs,
  components_Saleslog_searchlogs,
  searchlogs___vue_template_functional__,
  searchlogs___vue_styles__,
  searchlogs___vue_scopeId__,
  searchlogs___vue_module_identifier__
)

/* harmony default export */ var src_components_Saleslog_searchlogs = (searchlogs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Saleslog/index.vue




















/* harmony default export */ var Saleslog = ({
  name: 'saleslog',
  components: { Searchlogs: src_components_Saleslog_searchlogs, Settinglogs: src_components_Saleslog_settinglogs, Addsaleslog: src_components_Saleslog_addsaleslog, Card: vux_src_components_card, Confirm: components_confirm["a" /* default */], Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Tabbar: src_components_tabbar_tabbar, TabbarItem: src_components_tabbar_tabbar_item, Previewer: vux_src_components_previewer },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      remark: '',
      showScore: false,
      score: '',
      imgList: [],
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      logid: '',
      show: false,
      infoTotal: 0,
      infoList: [],
      tabIndex: 0,
      userid: '',
      results: [],
      value: '',
      tabbarCheck: [true, false, false, false],
      addInfo: {
        date: '',
        isEdit: '',
        id: ''
      },
      start: '2020-01-01',
      end: '2099-12-30',
      isGetNewData: false,
      SAVE_HEIGHT: 0,
      index: 0,
      height: 0
    };
  },

  methods: {
    showImg: function showImg(pathList, infoindex, visitedindex, photoindex) {
      var _this = this;

      this.imgList = this.infoList[infoindex].customer_visited[visitedindex].imgList;
      if (this.imgList[photoindex] && this.imgList[photoindex].hasOwnProperty('src')) {
        this.$refs.previewer.show(photoindex);
        return;
      }
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      var path = this.infoList[infoindex].customer_visited[visitedindex].photos[photoindex]['origin'];
      this.$vux.loading.show({ text: '加载中' });
      this.$http.get('api/v1/photos?path=' + path, header).then(function (res) {
        _this.$vux.loading.hide();
        if (_this.imgList[photoindex]) {
          _this.imgList[photoindex].src = 'data:image/jpeg;base64,' + res.data['value'];
        } else {
          _this.$set(_this.imgList, photoindex, { src: 'data:image/jpeg;base64,' + res.data['value'] });
        }
        _this.$refs.previewer.show(photoindex);
      });
    },
    download: function download(_ref) {
      var path = _ref.path,
          suffix = _ref.suffix;

      this.$router.push({
        name: "Download",
        query: { path: path, suffix: suffix }
      });
    },
    searchByUserid: function searchByUserid(userid) {
      if (confirm('查看他的全部日志')) {
        this.userid = userid;
        this.infoList = [];
        this.getReadData(0);
        this.SAVE_HEIGHT = 0;
      }
    },
    editAcreate: function editAcreate() {
      var _this2 = this;

      this.infoList = [];
      this.$set(this.tabbarCheck, 0, true);
      this.$set(this.tabbarCheck, 1, false);
      this.getData(0).then(function () {
        var top = 0;
        for (var i = 0; i < _this2.index; i++) {
          top += _this2.$refs.card[i].$el.offsetHeight;
        }
        document.querySelector('#card-wrap').scrollTo({ top: top });
        _this2.getPhoto(_this2.index);
      });
    },
    setting: function setting(num) {
      switch (num) {
        case 0:
          this.switchTabItem(0);
          break;
        case 1:
          var time = new Date();
          this.addInfo.isEdit = '';
          this.addInfo.date = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
          this.addInfo.id = '';
          break;
      }
      this.tabbarCheck = this.tabbarCheck.map(function (item, index) {
        return index === num;
      });
    },
    search: function search(event) {
      this.userid = event.userid;
      this.start = event.start;
      this.end = event.end;
      this.infoList = [];
      this.$set(this.tabbarCheck, 0, true);
      this.$set(this.tabbarCheck, 2, false);
      this.tabIndex = 1;
      this.getReadData(0);
    },
    addcomment: function addcomment() {
      var _this3 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.post('/api/v1/sale_logs/' + this.logid + '/comment_salelog', { comment: this.value }, header).then(function () {
        _this3.$vux.alert.show({
          title: '',
          content: '添加评论成功'
        });
        _this3.show = false;
        _this3.infoList = [];
        _this3.SAVE_HEIGHT = 0;
        _this3.height = 0;
        if (_this3.tabIndex === 0) {
          _this3.getData(0).then(function () {
            var top = 0;
            for (var i = 0; i < _this3.index; i++) {
              top += _this3.$refs.card[i].$el.offsetHeight;
            }
            document.querySelector('#card-wrap').scrollTo({ top: top });
            _this3.getPhoto(_this3.index);
          });
        } else if (_this3.tabIndex === 1) {
          _this3.getReadData(0).then(function () {
            var top = 0;
            for (var i = 0; i < _this3.index; i++) {
              top += _this3.$refs.card[i].$el.offsetHeight;
            }
            document.querySelector('#card-wrap').scrollTo({ top: top });
            _this3.getPhoto(_this3.index);
          });
        }
      }).catch(function (error) {
        _this3.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    addScore: function addScore() {
      var _this4 = this;

      if (!this.score) {
        alert('请添加分数');
        return;
      }
      if ((parseFloat(this.score) <= 6 || parseFloat(this.score) >= 10) && !this.remark) {
        alert('请添加评语');
        return;
      }
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/sale_logs/' + this.logid + '/salelog_leader_score_log?score=' + this.score + '&remark=' + this.remark, header).then(function () {
        _this4.showScore = false;
        _this4.$vux.alert.show({
          title: '',
          content: '评分成功'
        });
        _this4.infoList = [];
        _this4.SAVE_HEIGHT = 0;
        _this4.height = 0;
        if (_this4.tabIndex === 0) {
          _this4.getData(0).then(function () {
            var top = 0;
            for (var i = 0; i < _this4.index; i++) {
              top += _this4.$refs.card[i].$el.offsetHeight;
            }
            document.querySelector('#card-wrap').scrollTo({ top: top });
            _this4.getPhoto(_this4.index);
          });
        } else if (_this4.tabIndex === 1) {
          _this4.getReadData(0).then(function () {
            var top = 0;
            for (var i = 0; i < _this4.index; i++) {
              top += _this4.$refs.card[i].$el.offsetHeight;
            }
            document.querySelector('#card-wrap').scrollTo({ top: top });
            _this4.getPhoto(_this4.index);
          });
        }
      }).catch(function (error) {
        _this4.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    getResult: function getResult(val) {
      var _this5 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/agencies?task=ALL&offset=0&count=9999&hint=' + val, header).then(function (response) {
        _this5.results = response.data.map(function (item) {
          return { title: item.name, userid: item.userid };
        });
      });
    },
    resultClick: function resultClick(item) {
      window.alert('you click the result item: ' + stringify_default()(item));
    },
    switchTabItem: function switchTabItem(index) {
      this.tabIndex = index;
      this.start = '2020-01-01';
      this.end = '3000-12-30';
      this.infoList = [];
      this.userid = '';
      this.SAVE_HEIGHT = 0;
      this.height = 0;
      this.index = 0;
      switch (index) {
        case 0:
          this.getData(0);
          break;
        case 1:
          this.getReadData(0);
          break;
      }
    },
    add: function add(date, id, infoindex) {
      this.addInfo.isEdit = date;
      this.addInfo.date = date;
      this.addInfo.id = id.toString();
      this.tabbarCheck = this.tabbarCheck.map(function (item, index) {
        return index === 1;
      });
      this.index = infoindex;
    },
    getReadData: function getReadData(offset) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var header, url, _ref2, status, data, error;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                header = {
                  headers: {
                    token: localStorage.getItem('token'),
                    opid: localStorage.getItem('userid')
                  }
                };
                url = _this6.userid ? '&userid=' + _this6.userid : '';
                _context.next = 4;
                return _this6.$http.get('/api/v1/sale_logs/list_salelog_visible?offset=' + offset + '&count=99&start=' + _this6.start + '&end=' + _this6.end + url, header);

              case 4:
                _ref2 = _context.sent;
                status = _ref2.status;
                data = _ref2.data;
                error = _ref2.error;

                if (status !== 200) {
                  _this6.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                } else {
                  /*for (const item of data.content) {
                  item.imgList = []
                  const res = await this.$http.get('/api/v1/sale_logs/' + item.id + '/list_salelog_visible_to?offset=0&count=9999', header)
                  res.data.content.forEach((item_item, index_index) => {
                  item.visiable = index_index ? item.visiable : []
                  if (!item_item.default) {
                  item.visiable.push(item_item)
                  }
                  })
                  item.userList = res.data.content.filter(item => {
                  return item.default
                  })
                  for (const visited of item.customer_visited) {
                  visited.imgList = []
                  if (visited.photos) {
                  for (const visitedElement of visited.photos) {
                  this.$http.get('api/v1/photos?path=' + visitedElement.thumb).then(photo => {
                  visited.imgList.push({msrc: 'data:image/jpeg;base64,' + photo.data['value']})
                  })
                  }
                  }
                  }
                  }*/
                  _this6.infoList = [].concat(toConsumableArray_default()(_this6.infoList), toConsumableArray_default()(data.content.map(function (item) {
                    item.customer_visited.forEach(function (item) {
                      item.imgList = [];
                    });
                    return item;
                  })));
                  _this6.getPhoto(0).then();
                  _this6.infoTotal = data.total;
                  _this6.isGetNewData = false;
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    getData: function getData(offset) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var header, _ref3, status, data, error;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                header = {
                  headers: {
                    token: localStorage.getItem('token'),
                    opid: localStorage.getItem('userid')
                  }
                };
                _context2.next = 3;
                return _this7.$http.get('/api/v1/sale_logs?offset=' + offset + '&count=99&start=2020-01-01&end=2999-12-31', header);

              case 3:
                _ref3 = _context2.sent;
                status = _ref3.status;
                data = _ref3.data;
                error = _ref3.error;

                if (status !== 200) {
                  _this7.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                } else {
                  _this7.infoList = [].concat(toConsumableArray_default()(_this7.infoList), toConsumableArray_default()(data.content.map(function (item) {
                    item.customer_visited = item.customer_visited.map(function (item) {
                      return extends_default()({}, item, { imgList: [] });
                    });
                    return item;
                  })));
                  _this7.getPhoto(0).then();
                  _this7.infoTotal = data.total;
                  _this7.isGetNewData = false;
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    getPhoto: function getPhoto(index) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var item, header, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, visited, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, visitedElement, photo;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                item = _this8.infoList[index];

                item.imgList = [];
                header = {
                  headers: {
                    token: localStorage.getItem('token'),
                    opid: localStorage.getItem('userid')
                  }
                };

                if (!(_this8.tabIndex === 1)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this8.$http.get('/api/v1/sale_logs/' + item.id + '/mark_salelog_read', header);

              case 6:
                _context3.next = 8;
                return _this8.$http.get('/api/v1/sale_logs/' + item.id + '/list_salelog_visible_to?offset=0&count=9999', header);

              case 8:
                res = _context3.sent;

                res.data.content.forEach(function (item_item, index_index) {
                  item.visiable = index_index ? item.visiable : [];
                  if (!item_item.default) {
                    item.visiable.push(item_item);
                  }
                });
                item.userList = res.data.content.filter(function (item) {
                  return item.default;
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 14;
                _iterator = get_iterator_default()(item.customer_visited);

              case 16:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 51;
                  break;
                }

                visited = _step.value;

                visited.imgList = [];

                if (!visited.photos) {
                  _context3.next = 48;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 23;
                _iterator2 = get_iterator_default()(visited.photos);

              case 25:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context3.next = 34;
                  break;
                }

                visitedElement = _step2.value;
                _context3.next = 29;
                return _this8.$http.get('api/v1/photos?path=' + visitedElement.thumb);

              case 29:
                photo = _context3.sent;

                visited.imgList.push({ msrc: 'data:image/jpeg;base64,' + photo.data['value'] });

              case 31:
                _iteratorNormalCompletion2 = true;
                _context3.next = 25;
                break;

              case 34:
                _context3.next = 40;
                break;

              case 36:
                _context3.prev = 36;
                _context3.t0 = _context3['catch'](23);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 40:
                _context3.prev = 40;
                _context3.prev = 41;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 43:
                _context3.prev = 43;

                if (!_didIteratorError2) {
                  _context3.next = 46;
                  break;
                }

                throw _iteratorError2;

              case 46:
                return _context3.finish(43);

              case 47:
                return _context3.finish(40);

              case 48:
                _iteratorNormalCompletion = true;
                _context3.next = 16;
                break;

              case 51:
                _context3.next = 57;
                break;

              case 53:
                _context3.prev = 53;
                _context3.t1 = _context3['catch'](14);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 57:
                _context3.prev = 57;
                _context3.prev = 58;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 60:
                _context3.prev = 60;

                if (!_didIteratorError) {
                  _context3.next = 63;
                  break;
                }

                throw _iteratorError;

              case 63:
                return _context3.finish(60);

              case 64:
                return _context3.finish(57);

              case 65:
                _this8.$set(_this8.infoList, index, item);

              case 66:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[14, 53, 57, 65], [23, 36, 40, 48], [41,, 43, 47], [58,, 60, 64]]);
      }))();
    }
  },
  created: function created() {
    var _this9 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {
      var account = void 0;
      if (res.data.length !== 0) {
        res.data.forEach(function (item) {
          if (item.role === 'SRVP') {
            account = item.account;
          }
        });
        if (!account) {
          _this9.$vux.alert.show({
            title: '',
            content: '请绑定销售角色'
          });
          _this9.$router.push({ name: 'vip' });
        }
        _this9.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (response) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userid', response.data.userid);
          _this9.getData(0);
        });
      }
    });
  },
  mounted: function mounted() {
    var _this10 = this;

    var index = 0;
    var cardBox = document.querySelector('#card-wrap');
    cardBox.addEventListener('scroll', function () {
      if (_this10.SAVE_HEIGHT) {
        if (cardBox.scrollTop < _this10.SAVE_HEIGHT) {
          return;
        } else {
          _this10.SAVE_HEIGHT = cardBox.scrollTop;
        }
      } else {
        _this10.SAVE_HEIGHT = cardBox.scrollTop;
      }
      if (_this10.SAVE_HEIGHT === 0) return;
      if (_this10.height === 0) {
        _this10.height += _this10.$refs.card[0].$el.offsetHeight;
        index = 0;
      }
      if (cardBox.scrollTop + cardBox.offsetHeight - _this10.height >= cardBox.offsetHeight / 2) {
        index++;
        _this10.getPhoto(index).then();
        _this10.height += _this10.$refs.card[index].$el.offsetHeight;
      }
      if (cardBox.scrollHeight <= cardBox.scrollTop + cardBox.clientHeight + 300 && _this10.infoList.length < _this10.infoTotal && !_this10.isGetNewData && _this10.tabbarCheck[0]) {

        _this10.isGetNewData = true;
        switch (_this10.tabIndex) {
          case 0:
            _this10.getData(_this10.infoList.length);
            break;
          case 1:
            _this10.getReadData(_this10.infoList.length);
            break;
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Saleslog/index.vue




















/* harmony default export */ var components_Saleslog = ({
  name: 'saleslog',
  components: { Searchlogs: src_components_Saleslog_searchlogs, Settinglogs: src_components_Saleslog_settinglogs, Addsaleslog: src_components_Saleslog_addsaleslog, Card: vux_src_components_card, Confirm: components_confirm["a" /* default */], Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Tabbar: src_components_tabbar_tabbar, TabbarItem: src_components_tabbar_tabbar_item, Previewer: vux_src_components_previewer },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      remark: '',
      showScore: false,
      score: '',
      imgList: [],
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {

          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];

          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;

          var rect = thumbnail.getBoundingClientRect();

          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      },
      logid: '',
      show: false,
      infoTotal: 0,
      infoList: [],
      tabIndex: 0,
      userid: '',
      results: [],
      value: '',
      tabbarCheck: [true, false, false, false],
      addInfo: {
        date: '',
        isEdit: '',
        id: ''
      },
      start: '2020-01-01',
      end: '2099-12-30',
      isGetNewData: false,
      SAVE_HEIGHT: 0,
      index: 0,
      height: 0
    };
  },

  methods: {
    showImg: function showImg(pathList, infoindex, visitedindex, photoindex) {
      var _this = this;

      this.imgList = this.infoList[infoindex].customer_visited[visitedindex].imgList;
      if (this.imgList[photoindex] && this.imgList[photoindex].hasOwnProperty('src')) {
        this.$refs.previewer.show(photoindex);
        return;
      }
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      var path = this.infoList[infoindex].customer_visited[visitedindex].photos[photoindex]['origin'];
      this.$vux.loading.show({ text: '加载中' });
      this.$http.get('api/v1/photos?path=' + path, header).then(function (res) {
        _this.$vux.loading.hide();
        if (_this.imgList[photoindex]) {
          _this.imgList[photoindex].src = 'data:image/jpeg;base64,' + res.data['value'];
        } else {
          _this.$set(_this.imgList, photoindex, { src: 'data:image/jpeg;base64,' + res.data['value'] });
        }
        _this.$refs.previewer.show(photoindex);
      });
    },
    download: function download(_ref) {
      var path = _ref.path,
          suffix = _ref.suffix;

      this.$router.push({
        name: "Download",
        query: { path: path, suffix: suffix }
      });
    },
    searchByUserid: function searchByUserid(userid) {
      if (confirm('查看他的全部日志')) {
        this.userid = userid;
        this.infoList = [];
        this.getReadData(0);
        this.SAVE_HEIGHT = 0;
      }
    },
    editAcreate: function editAcreate() {
      var _this2 = this;

      this.infoList = [];
      this.$set(this.tabbarCheck, 0, true);
      this.$set(this.tabbarCheck, 1, false);
      this.getData(0).then(function () {
        var top = 0;
        for (var i = 0; i < _this2.index; i++) {
          top += _this2.$refs.card[i].$el.offsetHeight;
        }
        document.querySelector('#card-wrap').scrollTo({ top: top });
        _this2.getPhoto(_this2.index);
      });
    },
    setting: function setting(num) {
      switch (num) {
        case 0:
          this.switchTabItem(0);
          break;
        case 1:
          var time = new Date();
          this.addInfo.isEdit = '';
          this.addInfo.date = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();
          this.addInfo.id = '';
          break;
      }
      this.tabbarCheck = this.tabbarCheck.map(function (item, index) {
        return index === num;
      });
    },
    search: function search(event) {
      this.userid = event.userid;
      this.start = event.start;
      this.end = event.end;
      this.infoList = [];
      this.$set(this.tabbarCheck, 0, true);
      this.$set(this.tabbarCheck, 2, false);
      this.tabIndex = 1;
      this.getReadData(0);
    },
    addcomment: function addcomment() {
      var _this3 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.post('/api/v1/sale_logs/' + this.logid + '/comment_salelog', { comment: this.value }, header).then(function () {
        _this3.$vux.alert.show({
          title: '',
          content: '添加评论成功'
        });
        _this3.show = false;
        _this3.infoList = [];
        _this3.SAVE_HEIGHT = 0;
        _this3.height = 0;
        if (_this3.tabIndex === 0) {
          _this3.getData(0).then(function () {
            var top = 0;
            for (var i = 0; i < _this3.index; i++) {
              top += _this3.$refs.card[i].$el.offsetHeight;
            }
            document.querySelector('#card-wrap').scrollTo({ top: top });
            _this3.getPhoto(_this3.index);
          });
        } else if (_this3.tabIndex === 1) {
          _this3.getReadData(0).then(function () {
            var top = 0;
            for (var i = 0; i < _this3.index; i++) {
              top += _this3.$refs.card[i].$el.offsetHeight;
            }
            document.querySelector('#card-wrap').scrollTo({ top: top });
            _this3.getPhoto(_this3.index);
          });
        }
      }).catch(function (error) {
        _this3.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    addScore: function addScore() {
      var _this4 = this;

      if (!this.score) {
        alert('请添加分数');
        return;
      }
      if ((parseFloat(this.score) <= 6 || parseFloat(this.score) >= 10) && !this.remark) {
        alert('请添加评语');
        return;
      }
      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/sale_logs/' + this.logid + '/salelog_leader_score_log?score=' + this.score + '&remark=' + this.remark, header).then(function () {
        _this4.showScore = false;
        _this4.$vux.alert.show({
          title: '',
          content: '评分成功'
        });
        _this4.infoList = [];
        _this4.SAVE_HEIGHT = 0;
        _this4.height = 0;
        if (_this4.tabIndex === 0) {
          _this4.getData(0).then(function () {
            var top = 0;
            for (var i = 0; i < _this4.index; i++) {
              top += _this4.$refs.card[i].$el.offsetHeight;
            }
            document.querySelector('#card-wrap').scrollTo({ top: top });
            _this4.getPhoto(_this4.index);
          });
        } else if (_this4.tabIndex === 1) {
          _this4.getReadData(0).then(function () {
            var top = 0;
            for (var i = 0; i < _this4.index; i++) {
              top += _this4.$refs.card[i].$el.offsetHeight;
            }
            document.querySelector('#card-wrap').scrollTo({ top: top });
            _this4.getPhoto(_this4.index);
          });
        }
      }).catch(function (error) {
        _this4.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    getResult: function getResult(val) {
      var _this5 = this;

      var header = {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      };
      this.$http.get('/api/v1/agencies?task=ALL&offset=0&count=9999&hint=' + val, header).then(function (response) {
        _this5.results = response.data.map(function (item) {
          return { title: item.name, userid: item.userid };
        });
      });
    },
    resultClick: function resultClick(item) {
      window.alert('you click the result item: ' + stringify_default()(item));
    },
    switchTabItem: function switchTabItem(index) {
      this.tabIndex = index;
      this.start = '2020-01-01';
      this.end = '3000-12-30';
      this.infoList = [];
      this.userid = '';
      this.SAVE_HEIGHT = 0;
      this.height = 0;
      this.index = 0;
      switch (index) {
        case 0:
          this.getData(0);
          break;
        case 1:
          this.getReadData(0);
          break;
      }
    },
    add: function add(date, id, infoindex) {
      this.addInfo.isEdit = date;
      this.addInfo.date = date;
      this.addInfo.id = id.toString();
      this.tabbarCheck = this.tabbarCheck.map(function (item, index) {
        return index === 1;
      });
      this.index = infoindex;
    },
    getReadData: function getReadData(offset) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var header, url, _ref2, status, data, error;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                header = {
                  headers: {
                    token: localStorage.getItem('token'),
                    opid: localStorage.getItem('userid')
                  }
                };
                url = _this6.userid ? '&userid=' + _this6.userid : '';
                _context.next = 4;
                return _this6.$http.get('/api/v1/sale_logs/list_salelog_visible?offset=' + offset + '&count=99&start=' + _this6.start + '&end=' + _this6.end + url, header);

              case 4:
                _ref2 = _context.sent;
                status = _ref2.status;
                data = _ref2.data;
                error = _ref2.error;

                if (status !== 200) {
                  _this6.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                } else {
                  /*for (const item of data.content) {
                  item.imgList = []
                  const res = await this.$http.get('/api/v1/sale_logs/' + item.id + '/list_salelog_visible_to?offset=0&count=9999', header)
                  res.data.content.forEach((item_item, index_index) => {
                  item.visiable = index_index ? item.visiable : []
                  if (!item_item.default) {
                  item.visiable.push(item_item)
                  }
                  })
                  item.userList = res.data.content.filter(item => {
                  return item.default
                  })
                  for (const visited of item.customer_visited) {
                  visited.imgList = []
                  if (visited.photos) {
                  for (const visitedElement of visited.photos) {
                  this.$http.get('api/v1/photos?path=' + visitedElement.thumb).then(photo => {
                  visited.imgList.push({msrc: 'data:image/jpeg;base64,' + photo.data['value']})
                  })
                  }
                  }
                  }
                  }*/
                  _this6.infoList = [].concat(toConsumableArray_default()(_this6.infoList), toConsumableArray_default()(data.content.map(function (item) {
                    item.customer_visited.forEach(function (item) {
                      item.imgList = [];
                    });
                    return item;
                  })));
                  _this6.getPhoto(0).then();
                  _this6.infoTotal = data.total;
                  _this6.isGetNewData = false;
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    getData: function getData(offset) {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var header, _ref3, status, data, error;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                header = {
                  headers: {
                    token: localStorage.getItem('token'),
                    opid: localStorage.getItem('userid')
                  }
                };
                _context2.next = 3;
                return _this7.$http.get('/api/v1/sale_logs?offset=' + offset + '&count=99&start=2020-01-01&end=2999-12-31', header);

              case 3:
                _ref3 = _context2.sent;
                status = _ref3.status;
                data = _ref3.data;
                error = _ref3.error;

                if (status !== 200) {
                  _this7.$vux.alert.show({
                    title: '',
                    content: JSON.parse(error.response.data.error_message).zh_string
                  });
                } else {
                  _this7.infoList = [].concat(toConsumableArray_default()(_this7.infoList), toConsumableArray_default()(data.content.map(function (item) {
                    item.customer_visited = item.customer_visited.map(function (item) {
                      return extends_default()({}, item, { imgList: [] });
                    });
                    return item;
                  })));
                  _this7.getPhoto(0).then();
                  _this7.infoTotal = data.total;
                  _this7.isGetNewData = false;
                }

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    getPhoto: function getPhoto(index) {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var item, header, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, visited, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, visitedElement, photo;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                item = _this8.infoList[index];

                item.imgList = [];
                header = {
                  headers: {
                    token: localStorage.getItem('token'),
                    opid: localStorage.getItem('userid')
                  }
                };

                if (!(_this8.tabIndex === 1)) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 6;
                return _this8.$http.get('/api/v1/sale_logs/' + item.id + '/mark_salelog_read', header);

              case 6:
                _context3.next = 8;
                return _this8.$http.get('/api/v1/sale_logs/' + item.id + '/list_salelog_visible_to?offset=0&count=9999', header);

              case 8:
                res = _context3.sent;

                res.data.content.forEach(function (item_item, index_index) {
                  item.visiable = index_index ? item.visiable : [];
                  if (!item_item.default) {
                    item.visiable.push(item_item);
                  }
                });
                item.userList = res.data.content.filter(function (item) {
                  return item.default;
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 14;
                _iterator = get_iterator_default()(item.customer_visited);

              case 16:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 51;
                  break;
                }

                visited = _step.value;

                visited.imgList = [];

                if (!visited.photos) {
                  _context3.next = 48;
                  break;
                }

                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 23;
                _iterator2 = get_iterator_default()(visited.photos);

              case 25:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context3.next = 34;
                  break;
                }

                visitedElement = _step2.value;
                _context3.next = 29;
                return _this8.$http.get('api/v1/photos?path=' + visitedElement.thumb);

              case 29:
                photo = _context3.sent;

                visited.imgList.push({ msrc: 'data:image/jpeg;base64,' + photo.data['value'] });

              case 31:
                _iteratorNormalCompletion2 = true;
                _context3.next = 25;
                break;

              case 34:
                _context3.next = 40;
                break;

              case 36:
                _context3.prev = 36;
                _context3.t0 = _context3['catch'](23);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t0;

              case 40:
                _context3.prev = 40;
                _context3.prev = 41;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 43:
                _context3.prev = 43;

                if (!_didIteratorError2) {
                  _context3.next = 46;
                  break;
                }

                throw _iteratorError2;

              case 46:
                return _context3.finish(43);

              case 47:
                return _context3.finish(40);

              case 48:
                _iteratorNormalCompletion = true;
                _context3.next = 16;
                break;

              case 51:
                _context3.next = 57;
                break;

              case 53:
                _context3.prev = 53;
                _context3.t1 = _context3['catch'](14);
                _didIteratorError = true;
                _iteratorError = _context3.t1;

              case 57:
                _context3.prev = 57;
                _context3.prev = 58;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 60:
                _context3.prev = 60;

                if (!_didIteratorError) {
                  _context3.next = 63;
                  break;
                }

                throw _iteratorError;

              case 63:
                return _context3.finish(60);

              case 64:
                return _context3.finish(57);

              case 65:
                _this8.$set(_this8.infoList, index, item);

              case 66:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[14, 53, 57, 65], [23, 36, 40, 48], [41,, 43, 47], [58,, 60, 64]]);
      }))();
    }
  },
  created: function created() {
    var _this9 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {
      var account = void 0;
      if (res.data.length !== 0) {
        res.data.forEach(function (item) {
          if (item.role === 'SRVP') {
            account = item.account;
          }
        });
        if (!account) {
          _this9.$vux.alert.show({
            title: '',
            content: '请绑定销售角色'
          });
          _this9.$router.push({ name: 'vip' });
        }
        _this9.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (response) {
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('userid', response.data.userid);
          _this9.getData(0);
        });
      }
    });
  },
  mounted: function mounted() {
    var _this10 = this;

    var index = 0;
    var cardBox = document.querySelector('#card-wrap');
    cardBox.addEventListener('scroll', function () {
      if (_this10.SAVE_HEIGHT) {
        if (cardBox.scrollTop < _this10.SAVE_HEIGHT) {
          return;
        } else {
          _this10.SAVE_HEIGHT = cardBox.scrollTop;
        }
      } else {
        _this10.SAVE_HEIGHT = cardBox.scrollTop;
      }
      if (_this10.SAVE_HEIGHT === 0) return;
      if (_this10.height === 0) {
        _this10.height += _this10.$refs.card[0].$el.offsetHeight;
        index = 0;
      }
      if (cardBox.scrollTop + cardBox.offsetHeight - _this10.height >= cardBox.offsetHeight / 2) {
        index++;
        _this10.getPhoto(index).then();
        _this10.height += _this10.$refs.card[index].$el.offsetHeight;
      }
      if (cardBox.scrollHeight <= cardBox.scrollTop + cardBox.clientHeight + 300 && _this10.infoList.length < _this10.infoTotal && !_this10.isGetNewData && _this10.tabbarCheck[0]) {

        _this10.isGetNewData = true;
        switch (_this10.tabIndex) {
          case 0:
            _this10.getData(_this10.infoList.length);
            break;
          case 1:
            _this10.getReadData(_this10.infoList.length);
            break;
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a84703c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Saleslog/index.vue
var Saleslog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[(_vm.tabbarCheck[0])?_c('div',{staticStyle:{"height":"100%"}},[_c('tab',[_c('tab-item',{attrs:{"selected":_vm.tabIndex === 0},on:{"on-item-click":_vm.switchTabItem}},[_vm._v("我的日志")]),_vm._v(" "),_c('tab-item',{attrs:{"selected":_vm.tabIndex === 1},on:{"on-item-click":_vm.switchTabItem}},[_vm._v("查看日志")])],1),_vm._v(" "),(_vm.infoList.length)?_c('p',{staticStyle:{"display":"none"}},[_vm._v(_vm._s(_vm.infoList[0].time))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"height":"calc(100% - 44px)"},attrs:{"id":"card-wrap"}},_vm._l((_vm.infoList),function(info,infoindex){return _c('card',{key:'info_' + infoindex,ref:"card",refInFor:true},[(_vm.tabIndex === 1)?_c('div',{staticClass:"card-header",attrs:{"slot":"header"},slot:"header"},[_c('div',[_c('p',{staticStyle:{"margin":"0","padding":"0","font-size":"14px"}},[_vm._v(" "+_vm._s(info.operator.name)+"的日志")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","color":"rgb(153, 153, 153)","margin-left":"10px"}},[_vm._v(_vm._s(info.time))])]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-more icon-more",attrs:{"type":"ios-more","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.searchByUserid(info.operator.userid)}}},[_c('path',{attrs:{"d":"M256 224c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-127.6 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.4-32-32-32zm255.6 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}})])]):_vm._e(),_vm._v(" "),(_vm.tabIndex === 0)?_c('div',{staticClass:"card-header",staticStyle:{"display":"block"},attrs:{"slot":"header"},slot:"header"},[_vm._v("\n          "+_vm._s(info.time)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-padding",attrs:{"slot":"content"},slot:"content"},[_c('h5',[_vm._v("当日工作综合评分")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("自我评分：")]),_vm._v(_vm._s(info.myscore))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("领导评分：")]),_vm._v(_vm._s(info.lscore))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("领导评语：")]),_vm._v(_vm._s(info.remark))]),_vm._v(" "),_c('h5',[_vm._v("一、今日新增商机备案("+_vm._s(info.project_added.length)+")")]),_vm._v(" "),(info.project_added)?_vm._l((info.project_added),function(addproject,addindex){return _c('p',{key:'addproject-' + addindex},[_vm._v("\n              "+_vm._s(addindex + 1 + '、')+_vm._s(addproject.desc))])}):[_c('p',[_vm._v("无")])],_vm._v(" "),_c('h5',[_vm._v("二、今日更新项目信息("+_vm._s(info.project_updated.length)+")")]),_vm._v(" "),(info.project_updated)?_vm._l((info.project_updated),function(updateproject,updateindex){return _c('p',{key:'updateproject-' + updateindex},[_vm._v("\n              "+_vm._s(updateindex + 1 + '、')+_vm._s(updateproject.desc)+"\n              "),_vm._l((updateproject.record),function(record,recordindex){return _c('span',{key:'record-'+recordindex,staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(record))])})],2)}):[_c('p',[_vm._v("无")])],_vm._v(" "),_c('h5',[_vm._v("三、今日客户拜访情况("+_vm._s(info.customer_visited.length)+")")]),_vm._v(" "),_vm._l((info.customer_visited),function(visitedcustomer,visitedindex){return _c('div',{key:'visitedcustomer-' + visitedindex,staticClass:"visited_wrap"},[_c('p',[_c('b',[_vm._v("客户单位")]),_vm._v("："+_vm._s(visitedcustomer.customer))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("客户性质")]),_vm._v("："+_vm._s(visitedcustomer.prop))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("联系人")]),_vm._v("："+_vm._s(visitedcustomer.name))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("职务")]),_vm._v("："+_vm._s(visitedcustomer.title))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("联系手机")]),_vm._v("："+_vm._s(visitedcustomer.mobile))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("列席人员")]),_vm._v("："+_vm._s(visitedcustomer.accompany))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("沟通方式")]),_vm._v("："+_vm._s(visitedcustomer.communicate))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("沟通内容")]),_vm._v("："+_vm._s(visitedcustomer.content))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("下一步跟进计划")]),_vm._v("："+_vm._s(visitedcustomer.plan))]),_vm._v(" "),_c('div',{staticStyle:{"color":"rgba(17, 17, 17, 0.7)","padding-left":"10px"}},[_c('b',[_vm._v("上传照片：")]),_vm._v(" "),(visitedcustomer.photos && visitedcustomer.photos.length !== 0)?[(visitedcustomer.imgList.length === visitedcustomer.photos.length)?_c('div',{staticClass:"img_wrap"},_vm._l((visitedcustomer.imgList),function(photo,photo_index){return _c('div',{key:photo_index},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":photo.msrc,"alt":""},on:{"click":function($event){_vm.showImg(visitedcustomer.photos,infoindex,visitedindex,photo_index)}}})])})):_c('div',{staticClass:"img_wrap"},_vm._l((visitedcustomer.photos),function(photo,photo_index){return _c('div',{key:photo_index},[_c('img',{staticClass:"previewer-demo-img",attrs:{"src":__webpack_require__("B3Bl"),"alt":""},on:{"click":function($event){_vm.showImg(visitedcustomer.photos,infoindex,visitedindex,photo_index)}}})])}))]:_vm._e()],2)])}),_vm._v(" "),_c('h5',[_vm._v("四、今日提交方案/报价情况("+_vm._s(info.solutions.length)+")")]),_vm._v(" "),(info.solutions)?_vm._l((info.solutions),function(solution,solutionindex){return _c('div',{key:'solution'+solutionindex,staticStyle:{"border":"1px dotted","margin":"5px"}},[_c('p',{staticStyle:{"color":"rgba(17, 17, 17, 0.7)","margin":"5px 0","padding-left":"10px"}},[_c('b',[_vm._v("客户单位")]),_vm._v("："+_vm._s(solution.customer))]),_vm._v(" "),_c('div',{staticStyle:{"color":"rgba(17, 17, 17, 0.7)","margin":"5px 0","padding-left":"10px"}},[_c('b',[_vm._v("方案附件")]),_vm._v("："),_vm._l((solution.appendix),function(appendix,appendix_index){return _c('span',{key:'solution-appendix-'+appendix_index,staticStyle:{"margin-right":"10px"},on:{"click":function($event){_vm.download(appendix)}}},[_vm._v(_vm._s(appendix.suffix))])})],2)])}):[_c('p',[_vm._v("无")])],_vm._v(" "),_c('h5',[_vm._v("五、下一工作日重点工作计划")]),_vm._v(" "),(info.next)?_vm._l((info.next),function(next,nextindex){return _c('p',{key:'next-' + nextindex},[_vm._v("\n              "+_vm._s(next))])}):[_c('p',[_vm._v("无")])],_vm._v(" "),_c('h5',[_vm._v("六、需公司协调资源")]),_vm._v(" "),(info.resources)?_vm._l((info.resources),function(resources,resourcesindex){return _c('p',{key:'resources-' + resourcesindex},[_vm._v("\n              "+_vm._s(resources))])}):[_c('p',[_vm._v("无")])],_vm._v(" "),_c('h5',[_vm._v("七、其他需说明事项")]),_vm._v(" "),(info.others)?_vm._l((info.others),function(others,othersindex){return _c('p',{key:'others-' + othersindex},[_vm._v("\n              "+_vm._s(others))])}):_vm._e(),_vm._v(" "),_c('h5',[_vm._v("上传文件")]),_vm._v(" "),(info.appendix.length !== 0)?[_c('div',_vm._l((info.appendix),function(appendix,appendix_index){return _c('p',{key:appendix_index,on:{"click":function($event){_vm.download(appendix)}}},[_vm._v(_vm._s(appendix.suffix))])}))]:[_c('p',[_vm._v("无")])],_vm._v(" "),_c('h5',[_vm._v("发送到人")]),_vm._v(" "),(!info.userList)?[_c('p',[_vm._v("默认发送：无")])]:_vm._e(),_vm._v(" "),(info.userList)?[_c('p',[_vm._v("默认发送："),_vm._l((info.userList),function(user,user_index){return _c('span',{key:user_index},[_vm._v(_vm._s((user_index ? '，' + user.name : user.name) + '(' + (user.read ? '已读' : '未读') + ')'))])})],2)]:_vm._e(),_vm._v(" "),(!info.visiable)?[_c('p',[_vm._v("抄送：无")])]:_vm._e(),_vm._v(" "),(info.visiable)?[_c('p',[_vm._v("抄送："),_vm._l((info.visiable),function(visiable,visiable_index){return _c('span',[_vm._v(_vm._s((visiable_index ? '，' + visiable.name : visiable.name) + '(' + (visiable.read ? '已读' : '未读') + ')'))])})],2)]:_vm._e(),_vm._v(" "),_c('h5',[_vm._v("评价")]),_vm._v(" "),(info.comments)?_vm._l((info.comments),function(comment,commentindex){return _c('p',{key:'comments-' + commentindex},[_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(comment.user.name))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","color":"#999"}},[_vm._v(_vm._s(comment.time))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","display":"block","text-indent":"1rem"}},[_vm._v(_vm._s(comment.comment))])])}):_vm._e()],2),_vm._v(" "),(_vm.tabIndex === 1)?_c('div',{staticClass:"card-footer",attrs:{"slot":"footer"},slot:"footer"},[(info.can_score)?_c('span',{staticStyle:{"margin-right":"1rem"},on:{"click":function($event){_vm.showScore = true;_vm.score=info.lscore;_vm.remark = info.remark ? info.remark : '';_vm.logid=info.id;_vm.index = infoindex}}},[_vm._v("评分")]):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"1rem"},on:{"click":function($event){_vm.show = true;_vm.value='';_vm.logid=info.id;_vm.index= infoindex}}},[_vm._v("评价")])]):_vm._e(),_vm._v(" "),(_vm.tabIndex === 0)?_c('div',{staticClass:"card-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('span',{staticStyle:{"margin-right":"1rem"},on:{"click":function($event){_vm.add(info.time,info.id,infoindex)}}},[_vm._v("补充日志")]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"1rem"},on:{"click":function($event){_vm.show = true;_vm.value='';_vm.logid=info.id;_vm.index= infoindex}}},[_vm._v("评价")])]):_vm._e()])})),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{attrs:{"title":'添加评价',"theme":"android","close-on-confirm":false},on:{"on-cancel":function($event){_vm.show = false},"on-confirm":_vm.addcomment},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],attrs:{"rows":4},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})]),_vm._v(" "),_c('confirm',{attrs:{"title":"评分","theme":"android","close-on-confirm":false},on:{"on-cancel":function($event){_vm.showScore = false},"on-confirm":_vm.addScore},model:{value:(_vm.showScore),callback:function ($$v) {_vm.showScore=$$v},expression:"showScore"}},[_c('div',{staticStyle:{"background":"rgb(159 227 255)","border-radius":"5px","padding":"3px 0","font-size":"12px"}},[_c('p',[_vm._v("请参考以下几个纬度综合评分")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v("1.工作日志的及时性")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v("2.业务记录的完整性")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v("3.业务推进的合理性")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v("4.当日工作的饱和度")]),_vm._v(" "),_c('p',{staticStyle:{"text-indent":"1em"}},[_vm._v("另：评分大于等于10分或小于等于6分，必须需要评语。（200字以内）")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('label',{staticStyle:{"font-size":"14px","color":"#000"}},[_vm._v("评分")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.score),expression:"score"}],staticStyle:{"flex":"1","border-width":"1px"},attrs:{"oninput":"value=value.replace(/[^\\d]/g,'')","minlength":"1","maxlength":"2"},domProps:{"value":(_vm.score)},on:{"input":function($event){if($event.target.composing){ return; }_vm.score=$event.target.value}}})]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"font-size":"14px","color":"#000"}},[_vm._v("评语")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.remark),expression:"remark"}],staticStyle:{"flex":"1"},attrs:{"rows":4},domProps:{"value":(_vm.remark)},on:{"input":function($event){if($event.target.composing){ return; }_vm.remark=$event.target.value}}})])])],1)],1):_vm._e(),_vm._v(" "),(_vm.tabbarCheck[1])?_c('div',{staticStyle:{"height":"100%"}},[_c('addsaleslog',{attrs:{"id":_vm.addInfo.id,"date":_vm.addInfo.date,"is-edit":_vm.addInfo.isEdit},on:{"editAcreate":_vm.editAcreate}})],1):_vm._e(),_vm._v(" "),(_vm.tabbarCheck[2])?_c('div',[_c('searchlogs',{on:{"search":_vm.search}})],1):_vm._e(),_vm._v(" "),(_vm.tabbarCheck[3])?_c('div',[_c('settinglogs')],1):_vm._e(),_vm._v(" "),_c('tabbar',{staticStyle:{"position":"fixed"}},[_c('tabbar-item',{attrs:{"selected":_vm.tabbarCheck[0]}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-book",attrs:{"slot":"icon","type":"ios-book","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.setting(0)}},slot:"icon"},[_c('path',{attrs:{"d":"M164.466 64C109.266 64 64 89.98 64 143v283h22.141c12.86-26.334 44.238-42 78.325-42 40.224 0 73.877 27.528 81.616 64H248V95.346C230.76 73.951 198.981 64 164.466 64zm183.155 0c-34.332 0-66.713 9.851-83.621 31.011V448h1.797c7.739-36.472 41.495-64 81.722-64 34.085 0 61.149 11.666 78.429 42H448V143c0-53.02-45.177-79-100.379-79z"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("看日志")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":_vm.tabbarCheck[1]}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-compose",attrs:{"slot":"icon","type":"ios-compose","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.setting(1)}},slot:"icon"},[_c('path',{attrs:{"d":"M256 320h-64v-64l128-128H64v304h320V192z"}}),_c('path',{attrs:{"d":"M387.927 91.74L208 271.651V304h32.216l180.045-179.984zm56.286-11.428l-12.465-12.466C429.084 65.467 425.556 64 421.746 64a14.758 14.758 0 0 0-9.929 3.85L399.666 80l.08.08 11.293 11.293 21.02 21.02 12.15-12.15c2.383-2.625 3.791-6.117 3.791-9.929 0-3.81-1.408-7.339-3.787-10.002z"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("写日志")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":_vm.tabbarCheck[2]}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-search-strong",attrs:{"slot":"icon","type":"ios-search-strong","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.setting(2)}},slot:"icon"},[_c('path',{attrs:{"d":"M344.5 298c15-23.6 23.8-51.6 23.8-81.7 0-84.1-68.1-152.3-152.1-152.3C132.1 64 64 132.2 64 216.3c0 84.1 68.1 152.3 152.1 152.3 30.5 0 58.9-9 82.7-24.4l6.9-4.8L414.3 448l33.7-34.3-108.5-108.6 5-7.1zm-43.1-166.8c22.7 22.7 35.2 52.9 35.2 85s-12.5 62.3-35.2 85c-22.7 22.7-52.9 35.2-85 35.2s-62.3-12.5-85-35.2c-22.7-22.7-35.2-52.9-35.2-85s12.5-62.3 35.2-85c22.7-22.7 52.9-35.2 85-35.2s62.3 12.5 85 35.2z"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("日志筛选")])]),_vm._v(" "),_c('tabbar-item',{attrs:{"selected":_vm.tabbarCheck[3]}},[_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-gear-outline",attrs:{"slot":"icon","type":"ios-gear-outline","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"},on:{"click":function($event){_vm.setting(3)}},slot:"icon"},[_c('path',{attrs:{"d":"M256.9 159.9c-25.701 0-49.801 10-67.9 28.1s-28.1 42.199-28.1 67.9c0 25.699 10 49.699 28.1 67.9 18.1 18.1 42.301 28.1 67.9 28.1 25.699 0 49.799-10 67.9-28.1 18.1-18.102 28.1-42.201 28.1-67.9 0-25.701-10-49.701-28.1-67.9-18.101-18.1-42.2-28.1-67.9-28.1zm0 176c-44.301 0-80-35.9-80-80 0-44.101 35.699-80 80-80 44.299 0 80 35.899 80 80 0 44.1-35.701 80-80 80z"}}),_c('path',{attrs:{"d":"M201.787 82.828a65.378 65.378 0 0 0 16.775 17.069c11.012 7.715 23.957 11.793 37.438 11.793 13.481 0 26.428-4.078 37.439-11.793a65.398 65.398 0 0 0 16.773-17.068 179.969 179.969 0 0 1 29.927 12.411 65.403 65.403 0 0 0-.203 23.933c2.333 13.235 8.604 25.269 18.133 34.798 12.335 12.336 28.737 19.129 46.185 19.129 4.242 0 8.424-.399 12.52-1.195a179.858 179.858 0 0 1 12.405 29.947 65.388 65.388 0 0 0-17.054 16.776c-7.705 11.008-11.777 23.946-11.776 37.418 0 13.467 4.069 26.401 11.768 37.406a65.378 65.378 0 0 0 17.036 16.771 179.868 179.868 0 0 1-12.428 29.957 65.615 65.615 0 0 0-12.472-1.187c-17.448 0-33.85 6.795-46.183 19.131-9.515 9.514-15.781 21.527-18.123 34.74a65.397 65.397 0 0 0 .176 23.895 179.911 179.911 0 0 1-29.967 12.421 65.372 65.372 0 0 0-16.771-17.022c-11-7.689-23.928-11.754-37.386-11.754-13.457 0-26.385 4.064-37.385 11.755a65.399 65.399 0 0 0-16.771 17.021 179.932 179.932 0 0 1-29.966-12.42 65.397 65.397 0 0 0 .176-23.895c-2.342-13.214-8.608-25.228-18.123-34.741-12.335-12.336-28.737-19.13-46.185-19.13-4.226 0-8.39.396-12.471 1.187a180.012 180.012 0 0 1-12.428-29.958 65.378 65.378 0 0 0 17.036-16.771c7.699-11.004 11.769-23.939 11.769-37.408 0-13.471-4.072-26.41-11.777-37.418A65.403 65.403 0 0 0 82.82 201.85a179.882 179.882 0 0 1 12.405-29.946 65.54 65.54 0 0 0 12.521 1.196c17.446 0 33.849-6.794 46.185-19.13 9.529-9.53 15.799-21.563 18.133-34.799a65.376 65.376 0 0 0-.203-23.932 180.164 180.164 0 0 1 29.926-12.411M302.074 64C294.971 82.529 277.027 95.69 256 95.69c-21.025 0-38.969-13.161-46.073-31.69a196.255 196.255 0 0 0-57.128 23.688c8.068 18.122 4.682 40.104-10.182 54.97-9.631 9.631-22.25 14.443-34.87 14.443a49.429 49.429 0 0 1-20.083-4.255A196.3 196.3 0 0 0 64 209.984c18.51 7.112 31.652 25.049 31.652 46.062 0 21.008-13.133 38.936-31.631 46.054a196.32 196.32 0 0 0 23.693 57.128 49.42 49.42 0 0 1 20.031-4.232c12.621 0 25.238 4.812 34.871 14.443 14.841 14.841 18.238 36.781 10.215 54.889a196.251 196.251 0 0 0 57.131 23.673c7.127-18.479 25.046-31.596 46.037-31.596 20.992 0 38.91 13.115 46.037 31.596a196.234 196.234 0 0 0 57.132-23.675c-8.023-18.106-4.626-40.046 10.216-54.887 9.629-9.632 22.248-14.444 34.868-14.444 6.836 0 13.67 1.411 20.033 4.233a196.318 196.318 0 0 0 23.692-57.128c-18.498-7.118-31.63-25.048-31.63-46.054-.001-21.013 13.143-38.948 31.651-46.062a196.302 196.302 0 0 0-23.664-57.139 49.423 49.423 0 0 1-20.082 4.254c-12.621 0-25.238-4.811-34.871-14.442-14.863-14.863-18.248-36.846-10.18-54.97A196.24 196.24 0 0 0 302.074 64z"}})]),_vm._v(" "),_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("日志设置")])])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.imgList,"options":_vm.options}})],1)],1)}
var Saleslog_staticRenderFns = []
var Saleslog_esExports = { render: Saleslog_render, staticRenderFns: Saleslog_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Saleslog = (Saleslog_esExports);
// CONCATENATED MODULE: ./src/components/Saleslog/index.vue
function Saleslog_injectStyle (ssrContext) {
  __webpack_require__("c+RB")
}
var Saleslog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Saleslog___vue_template_functional__ = false
/* styles */
var Saleslog___vue_styles__ = Saleslog_injectStyle
/* scopeId */
var Saleslog___vue_scopeId__ = "data-v-6a84703c"
/* moduleIdentifier (server only) */
var Saleslog___vue_module_identifier__ = null
var Saleslog_Component = Saleslog_normalizeComponent(
  components_Saleslog,
  selectortype_template_index_0_src_components_Saleslog,
  Saleslog___vue_template_functional__,
  Saleslog___vue_styles__,
  Saleslog___vue_scopeId__,
  Saleslog___vue_module_identifier__
)

/* harmony default export */ var src_components_Saleslog = (Saleslog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Download.vue
//
//
//
//
//
//
//

/* harmony default export */ var Download = ({
  name: "Download",
  data: function data() {
    return {
      path: this.$route.query.path,
      suffix: this.$route.query.suffix
    };
  },

  methods: {
    is_weixin: function is_weixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("微信浏览器");
        return true;
      } else {
        console.log("不是微信浏览器");
        return false;
      }
    },
    dataURLtoBlob: function dataURLtoBlob(dataurl, encode) {
      var arr = dataurl,
          bstr = atob(arr),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: encode });
    },
    download: function download() {
      var _this = this;

      var is_weixin = this.is_weixin();
      this.$vux.loading.show({
        text: 'Loading'
      });
      if (is_weixin) {
        alert('点击右上角选择在浏览器打开');
        this.$vux.loading.hide();
        //是微信浏览器  显示返回按钮   （用户可以选择下载或者返回）
        return;
      } else {
        //不是微信浏览器
        //执行下载
        this.$http.get('api/v1/photos?path=' + this.path).then(function (res) {
          var aLink = document.createElement('a');
          var encode = '';
          var bm = '';
          var type = _this.suffix.split('.');
          switch (type[type.length - 1]) {
            case 'doc':
            case 'docx':
              encode = 'application/vnd.ms-word;charset=utf-8';
              bm = 'base64';
              break;
            case 'pdf':
              encode = 'application/pdf;charset=utf-8';
              bm = 'base64';
              break;
            case 'xlsx':
            case 'xls':
              encode = 'application/vnd.ms-excel;charset=utf-8';
              bm = 'base64';
              break;
            case 'ppt':
            case 'pptx':
              encode = 'pplication/vnd.ms-powerpoint;charset=utf-8';
              bm = 'base64';
              break;
            default:
              encode = 'text/plain;charset=utf-8';
              bm = 'base64';
              break;
          }
          if (!encode) {
            alert('暂不支持此格式下载');
            return;
          }
          _this.$vux.loading.hide();
          // var decodedData = atob(res.data["value"]);
          // var blob = new Blob([decodedData], {type: encode});
          var blob = _this.dataURLtoBlob(res.data["value"], encode);
          var evt = document.createEvent("MouseEvents");
          evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错, 感谢 Barret Lee 的反馈
          aLink.download = _this.suffix;
          aLink.href = URL.createObjectURL(blob);
          aLink.dispatchEvent(evt);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      setTimeout(function () {
        var is_weixin = _this2.is_weixin();
        if (is_weixin) {
          alert('点击右上角选择在浏览器打开');
          //是微信浏览器  显示返回按钮   （用户可以选择下载或者返回）
        }
      });
    }, 2000);
  },
  created: function created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //安卓终端
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //苹果终端
    if (isAndroid) {//判断为安卓手机
      // this.showBox = false;
    } else if (isIOS) {//判断为苹果手机
      // alert('这里苹果手机');
      // this.showBox = true; //判断显示的是哪一个页面，我这边设置的就是如果为true就显示iOS的页面，如果为false就显示安卓的页面
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Download.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_Download = ({
  name: "Download",
  data: function data() {
    return {
      path: this.$route.query.path,
      suffix: this.$route.query.suffix
    };
  },

  methods: {
    is_weixin: function is_weixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("微信浏览器");
        return true;
      } else {
        console.log("不是微信浏览器");
        return false;
      }
    },
    dataURLtoBlob: function dataURLtoBlob(dataurl, encode) {
      var arr = dataurl,
          bstr = atob(arr),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: encode });
    },
    download: function download() {
      var _this = this;

      var is_weixin = this.is_weixin();
      this.$vux.loading.show({
        text: 'Loading'
      });
      if (is_weixin) {
        alert('点击右上角选择在浏览器打开');
        this.$vux.loading.hide();
        //是微信浏览器  显示返回按钮   （用户可以选择下载或者返回）
        return;
      } else {
        //不是微信浏览器
        //执行下载
        this.$http.get('api/v1/photos?path=' + this.path).then(function (res) {
          var aLink = document.createElement('a');
          var encode = '';
          var bm = '';
          var type = _this.suffix.split('.');
          switch (type[type.length - 1]) {
            case 'doc':
            case 'docx':
              encode = 'application/vnd.ms-word;charset=utf-8';
              bm = 'base64';
              break;
            case 'pdf':
              encode = 'application/pdf;charset=utf-8';
              bm = 'base64';
              break;
            case 'xlsx':
            case 'xls':
              encode = 'application/vnd.ms-excel;charset=utf-8';
              bm = 'base64';
              break;
            case 'ppt':
            case 'pptx':
              encode = 'pplication/vnd.ms-powerpoint;charset=utf-8';
              bm = 'base64';
              break;
            default:
              encode = 'text/plain;charset=utf-8';
              bm = 'base64';
              break;
          }
          if (!encode) {
            alert('暂不支持此格式下载');
            return;
          }
          _this.$vux.loading.hide();
          // var decodedData = atob(res.data["value"]);
          // var blob = new Blob([decodedData], {type: encode});
          var blob = _this.dataURLtoBlob(res.data["value"], encode);
          var evt = document.createEvent("MouseEvents");
          evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错, 感谢 Barret Lee 的反馈
          aLink.download = _this.suffix;
          aLink.href = URL.createObjectURL(blob);
          aLink.dispatchEvent(evt);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      setTimeout(function () {
        var is_weixin = _this2.is_weixin();
        if (is_weixin) {
          alert('点击右上角选择在浏览器打开');
          //是微信浏览器  显示返回按钮   （用户可以选择下载或者返回）
        }
      });
    }, 2000);
  },
  created: function created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //安卓终端
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //苹果终端
    if (isAndroid) {//判断为安卓手机
      // this.showBox = false;
    } else if (isIOS) {//判断为苹果手机
      // alert('这里苹果手机');
      // this.showBox = true; //判断显示的是哪一个页面，我这边设置的就是如果为true就显示iOS的页面，如果为false就显示安卓的页面
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e296952","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Download.vue
var Download_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.suffix))]),_vm._v(" "),_c('button',{staticStyle:{"margin-top":"20px","margin-left":"100px","width":"120px","height":"60px","font-size":"20px"},on:{"click":_vm.download}},[_vm._v("下载")])])}
var Download_staticRenderFns = []
var Download_esExports = { render: Download_render, staticRenderFns: Download_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Download = (Download_esExports);
// CONCATENATED MODULE: ./src/components/Download.vue
function Download_injectStyle (ssrContext) {
  __webpack_require__("wHnH")
}
var Download_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Download___vue_template_functional__ = false
/* styles */
var Download___vue_styles__ = Download_injectStyle
/* scopeId */
var Download___vue_scopeId__ = "data-v-0e296952"
/* moduleIdentifier (server only) */
var Download___vue_module_identifier__ = null
var Download_Component = Download_normalizeComponent(
  components_Download,
  selectortype_template_index_0_src_components_Download,
  Download___vue_template_functional__,
  Download___vue_styles__,
  Download___vue_scopeId__,
  Download___vue_module_identifier__
)

/* harmony default export */ var src_components_Download = (Download_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject-jy/filingjy.vue








/* harmony default export */ var filingjy = ({
  name: "filingjy",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Confirm: components_confirm["a" /* default */], Checklist: vux_src_components_checklist },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      devtypeshow: false,
      smsDisabled: false,
      buttonText: '发送验证码',
      fastprojectshow: false,
      code: '',
      imgcode: '',
      imgCodeInput: '',
      imgCodeError: '',
      data: {
        customer: '',
        devtype: '',
        agent: '',
        company: '北京精一强远科技有限公司'
      },
      devtypeOther: '',
      name: '',
      mobile: '',
      quoteLine: [],
      checklist001: [],
      isLogin: false,
      isDisabled: false
    };
  },

  methods: {
    clear: function clear() {
      this.data = {
        customer: '',
        devtype: '',
        agent: '',
        company: '北京精一强远科技有限公司'
      };
      if (!this.isLogin) {
        this.name = '';
        this.mobile = '';
      }
      this.checklist001 = [];
    },
    goToList: function goToList() {
      if (this.isLogin) {
        this.$router.push({ name: 'filinglistjy' });
      } else {
        this.$vux.alert.show({
          title: "",
          content: "暂无订单信息"
        });
      }
    },
    sendCode: function sendCode() {
      var _this = this;

      if (!this.imgCodeInput) {
        this.imgCodeError = '请输入图形验证码';
        return;
      }

      var obj = {
        nationcode: '86',
        mobile: this.mobile,
        openid: localStorage.getItem('openid'),
        passwd: this.imgCodeInput
      };
      if (this.mobile) {
        this.$http.post('/api/v1/accounts/sms', obj).then(function (response) {
          if (response.data.result !== 0) {
            _this.imgCodeError = response.data.errmsg || '验证码发送失败';
          } else {
            _this.imgCodeError = '';
            localStorage.setItem('countDown', 60);
            _this.timeKeeping();
          }
        }).catch(function (error) {
          if (error.response && error.response.data) {
            _this.imgCodeError = error.response.data.errmsg || '图形验证码错误';
          } else {
            _this.imgCodeError = '发送失败，请重试';
          }
        });
      }
    },
    timeKeeping: function timeKeeping() {
      var _this2 = this;

      this.smsDisabled = true;
      var interval = setInterval(function () {

        var countDown = parseInt(localStorage.getItem('countDown'));

        _this2.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          localStorage.removeItem('countDown');
          _this2.buttonText = '重新发送';
          _this2.smsDisabled = false;
        } else {
          countDown--;
          localStorage.setItem('countDown', countDown);
        }
      }, 1000);
    },
    getImgCode: function getImgCode() {
      var _this3 = this;

      this.$http.get('/api/v1/photos/get_imgcode').then(function (response) {
        _this3.imgcode = response.data;
      }).catch(function () {
        _this3.imgCodeError = '获取图形验证码失败';
      });
    },
    refreshImgCode: function refreshImgCode() {
      this.imgCodeInput = '';
      this.imgCodeError = '';
      this.getImgCode();
    },
    onConfirm: function onConfirm() {
      var _this4 = this;

      var info = {
        code: this.code,
        mobile: this.mobile
      };
      this.$http.put('/api/v1/accounts/checksms', info).then(function () {
        _this4.$http.post('/api/v1/srvp_projects/report', {
          info: _this4.data,
          name: _this4.name,
          mobile: _this4.mobile,
          openid: localStorage.getItem('openid'),
          unionid: localStorage.getItem('unionid'),
          nickname: localStorage.getItem('nickname'),
          imgurl: localStorage.getItem('imgurl'),
          otp: 'official'
        }).then(function (response) {
          alert('提交成功');
          _this4.isDisabled = false;
          _this4.clear();
          _this4.$router.push({ name: 'filinglistjy' });
        }).catch(function (error) {
          _this4.isDisabled = false;
          _this4.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        });
      });
    },
    choseDevtype: function choseDevtype() {
      this.devtypeshow = true;
    },
    sureDevtype: function sureDevtype() {
      this.data.devtype = this.checklist001.join(',');
    },
    check: function check() {
      var _this5 = this;

      this.isDisabled = true;
      if (this.data.customer !== '' && this.data.devtype !== '' && this.data.agent !== '' && this.mobile && this.name) {
        if (this.isLogin) {
          var obj = {
            headers: {
              token: localStorage.getItem('token'),
              opid: localStorage.getItem('userid')
            }
          };
          this.$http.post('/api/v1/srvp_projects/admin_report', {
            role: 'INDV',
            info: this.data
          }, obj).then(function () {
            _this5.isDisabled = false;
            alert('提交成功');
            _this5.$router.push({ name: 'filinglistjy' });
          }).catch(function (error) {
            _this5.isDisabled = false;
            _this5.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        } else {
          this.fastprojectshow = true;
          this.refreshImgCode();
        }
      } else {
        alert('请补充信息');
        this.isDisabled = false;
      }
    }
  },
  computed: {
    fls: function fls() {
      return this.data.devtype === '其他';
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      _this6.$refs.devtype.$el.getElementsByClassName('weui-dialog')[0].setAttribute('id', 'auto');
    });
  },
  created: function created() {
    var _this7 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/srvp_products/user_list_cats?company=北京精一强远科技有限公司&hint=').then(function (response) {
      _this7.quoteLine = response.data;
    });
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {
      var len = res.data.length;
      if (len) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        _this7.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };

          _this7.$http.get('api/v1/accounts/' + opid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].type === 'INDV' || response.data[i].type === 'ENTP') {
                _this7.role = response.data[i].type;
                break;
              }
            }
            if (_this7.role === 'INDV' || _this7.role === 'ENTP') {
              _this7.isLogin = true;
              _this7.$http.get('/api/v1/users/' + opid, obj).then(function (res) {
                if (res.data.detail) {
                  _this7.name = res.data.detail.name;
                  _this7.mobile = res.data.detail.mobile;
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                _this7.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject-jy/filingjy.vue








/* harmony default export */ var srvpproject_jy_filingjy = ({
  name: "filingjy",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Confirm: components_confirm["a" /* default */], Checklist: vux_src_components_checklist },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      devtypeshow: false,
      smsDisabled: false,
      buttonText: '发送验证码',
      fastprojectshow: false,
      code: '',
      imgcode: '',
      imgCodeInput: '',
      imgCodeError: '',
      data: {
        customer: '',
        devtype: '',
        agent: '',
        company: '北京精一强远科技有限公司'
      },
      devtypeOther: '',
      name: '',
      mobile: '',
      quoteLine: [],
      checklist001: [],
      isLogin: false,
      isDisabled: false
    };
  },

  methods: {
    clear: function clear() {
      this.data = {
        customer: '',
        devtype: '',
        agent: '',
        company: '北京精一强远科技有限公司'
      };
      if (!this.isLogin) {
        this.name = '';
        this.mobile = '';
      }
      this.checklist001 = [];
    },
    goToList: function goToList() {
      if (this.isLogin) {
        this.$router.push({ name: 'filinglistjy' });
      } else {
        this.$vux.alert.show({
          title: "",
          content: "暂无订单信息"
        });
      }
    },
    sendCode: function sendCode() {
      var _this = this;

      if (!this.imgCodeInput) {
        this.imgCodeError = '请输入图形验证码';
        return;
      }

      var obj = {
        nationcode: '86',
        mobile: this.mobile,
        openid: localStorage.getItem('openid'),
        passwd: this.imgCodeInput
      };
      if (this.mobile) {
        this.$http.post('/api/v1/accounts/sms', obj).then(function (response) {
          if (response.data.result !== 0) {
            _this.imgCodeError = response.data.errmsg || '验证码发送失败';
          } else {
            _this.imgCodeError = '';
            localStorage.setItem('countDown', 60);
            _this.timeKeeping();
          }
        }).catch(function (error) {
          if (error.response && error.response.data) {
            _this.imgCodeError = error.response.data.errmsg || '图形验证码错误';
          } else {
            _this.imgCodeError = '发送失败，请重试';
          }
        });
      }
    },
    timeKeeping: function timeKeeping() {
      var _this2 = this;

      this.smsDisabled = true;
      var interval = setInterval(function () {

        var countDown = parseInt(localStorage.getItem('countDown'));

        _this2.buttonText = countDown + '秒';

        if (countDown === 0) {
          clearInterval(interval);
          localStorage.removeItem('countDown');
          _this2.buttonText = '重新发送';
          _this2.smsDisabled = false;
        } else {
          countDown--;
          localStorage.setItem('countDown', countDown);
        }
      }, 1000);
    },
    getImgCode: function getImgCode() {
      var _this3 = this;

      this.$http.get('/api/v1/photos/get_imgcode').then(function (response) {
        _this3.imgcode = response.data;
      }).catch(function () {
        _this3.imgCodeError = '获取图形验证码失败';
      });
    },
    refreshImgCode: function refreshImgCode() {
      this.imgCodeInput = '';
      this.imgCodeError = '';
      this.getImgCode();
    },
    onConfirm: function onConfirm() {
      var _this4 = this;

      var info = {
        code: this.code,
        mobile: this.mobile
      };
      this.$http.put('/api/v1/accounts/checksms', info).then(function () {
        _this4.$http.post('/api/v1/srvp_projects/report', {
          info: _this4.data,
          name: _this4.name,
          mobile: _this4.mobile,
          openid: localStorage.getItem('openid'),
          unionid: localStorage.getItem('unionid'),
          nickname: localStorage.getItem('nickname'),
          imgurl: localStorage.getItem('imgurl'),
          otp: 'official'
        }).then(function (response) {
          alert('提交成功');
          _this4.isDisabled = false;
          _this4.clear();
          _this4.$router.push({ name: 'filinglistjy' });
        }).catch(function (error) {
          _this4.isDisabled = false;
          _this4.$vux.alert.show({
            title: '',
            content: JSON.parse(error.response.data.error_message).zh_string
          });
        });
      });
    },
    choseDevtype: function choseDevtype() {
      this.devtypeshow = true;
    },
    sureDevtype: function sureDevtype() {
      this.data.devtype = this.checklist001.join(',');
    },
    check: function check() {
      var _this5 = this;

      this.isDisabled = true;
      if (this.data.customer !== '' && this.data.devtype !== '' && this.data.agent !== '' && this.mobile && this.name) {
        if (this.isLogin) {
          var obj = {
            headers: {
              token: localStorage.getItem('token'),
              opid: localStorage.getItem('userid')
            }
          };
          this.$http.post('/api/v1/srvp_projects/admin_report', {
            role: 'INDV',
            info: this.data
          }, obj).then(function () {
            _this5.isDisabled = false;
            alert('提交成功');
            _this5.$router.push({ name: 'filinglistjy' });
          }).catch(function (error) {
            _this5.isDisabled = false;
            _this5.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        } else {
          this.fastprojectshow = true;
          this.refreshImgCode();
        }
      } else {
        alert('请补充信息');
        this.isDisabled = false;
      }
    }
  },
  computed: {
    fls: function fls() {
      return this.data.devtype === '其他';
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      _this6.$refs.devtype.$el.getElementsByClassName('weui-dialog')[0].setAttribute('id', 'auto');
    });
  },
  created: function created() {
    var _this7 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/srvp_products/user_list_cats?company=北京精一强远科技有限公司&hint=').then(function (response) {
      _this7.quoteLine = response.data;
    });
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {
      var len = res.data.length;
      if (len) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        _this7.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          var opid = res.data.userid;
          var obj = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };

          _this7.$http.get('api/v1/accounts/' + opid, obj).then(function (response) {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].type === 'INDV' || response.data[i].type === 'ENTP') {
                _this7.role = response.data[i].type;
                break;
              }
            }
            if (_this7.role === 'INDV' || _this7.role === 'ENTP') {
              _this7.isLogin = true;
              _this7.$http.get('/api/v1/users/' + opid, obj).then(function (res) {
                if (res.data.detail) {
                  _this7.name = res.data.detail.name;
                  _this7.mobile = res.data.detail.mobile;
                }
              });
            }
          }).catch(function (error) {
            if (error.response) {
              if (error.response.data) {
                _this7.$vux.alert.show({
                  title: '',
                  content: JSON.parse(error.response.data.error_message).zh_string
                });
              }
            }
          });
        }).catch(function (error) {
          if (error.response) {
            if (error.response.data) {
              that.$vux.alert.show({
                title: '',
                content: JSON.parse(error.response.data.error_message).zh_string
              });
            }
          }
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-506178f3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/srvpproject-jy/filingjy.vue
var filingjy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"message"},[_vm._v("报备信息")]),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"title":"最终用户名称*","type":"text"},model:{value:(_vm.data.customer),callback:function ($$v) {_vm.$set(_vm.data, "customer", $$v)},expression:"data.customer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"拟采用产品类别*","type":"text"},nativeOn:{"click":function($event){return _vm.choseDevtype($event)}},model:{value:(_vm.data.devtype),callback:function ($$v) {_vm.$set(_vm.data, "devtype", $$v)},expression:"data.devtype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"拟推荐代理商*","type":"text"},model:{value:(_vm.data.agent),callback:function ($$v) {_vm.$set(_vm.data, "agent", $$v)},expression:"data.agent"}}),_vm._v(" "),(!_vm.isLogin)?_c('x-input',{attrs:{"title":"报备人姓名*","type":"text"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}):_vm._e(),_vm._v(" "),(!_vm.isLogin)?_c('x-input',{attrs:{"title":"报备人手机*","type":"number","is-type":"china-mobile"},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-around","margin":"1rem 0"}},[_c('x-button',{staticStyle:{"width":"40%"},attrs:{"type":"primary","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.check($event)}}},[_vm._v("提交")]),_vm._v(" "),_c('x-button',{staticStyle:{"width":"40%","margin-top":"0"},nativeOn:{"click":function($event){return _vm.clear($event)}}},[_vm._v("清除")])],1),_vm._v(" "),_c('x-button',{nativeOn:{"click":function($event){return _vm.goToList($event)}}},[_vm._v("我的备案")]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{attrs:{"theme":"android","title":"提示信息"},on:{"on-cancel":function($event){_vm.fastprojectshow = false},"on-confirm":_vm.onConfirm},model:{value:(_vm.fastprojectshow),callback:function ($$v) {_vm.fastprojectshow=$$v},expression:"fastprojectshow"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("您第一次报备，请点击获取验证码，谢谢")]),_vm._v(" "),_c('group',[_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"图形验证码","type":"text","placeholder":"请输入图形验证码"},model:{value:(_vm.imgCodeInput),callback:function ($$v) {_vm.imgCodeInput=$$v},expression:"imgCodeInput"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"slot":"right"},slot:"right"},[_c('img',{staticStyle:{"height":"30px","cursor":"pointer","margin-right":"5px"},attrs:{"src":_vm.imgcode,"alt":"图形验证码"},on:{"click":_vm.refreshImgCode}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#3399ff","cursor":"pointer","font-size":"12px"},on:{"click":_vm.refreshImgCode}},[_vm._v("换一张")])])]),_vm._v(" "),_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"短信验证码","type":"number","placeholder":"请输入短信验证码"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}},[_c('x-button',{attrs:{"slot":"right","type":"primary","mini":"","text":_vm.buttonText,"disabled":_vm.smsDisabled},nativeOn:{"click":function($event){return _vm.sendCode($event)}},slot:"right"})],1)],1),_vm._v(" "),(_vm.imgCodeError)?_c('p',{staticStyle:{"color":"red","text-align":"center","font-size":"12px","margin-top":"5px"}},[_vm._v(_vm._s(_vm.imgCodeError))]):_vm._e()],1),_vm._v(" "),_c('confirm',{ref:"devtype",attrs:{"theme":"android"},on:{"on-cancel":function($event){_vm.devtypeshow = false},"on-confirm":_vm.sureDevtype},model:{value:(_vm.devtypeshow),callback:function ($$v) {_vm.devtypeshow=$$v},expression:"devtypeshow"}},[_c('checklist',{staticClass:"weui-vcode",attrs:{"title":"拟采用产品类别","required":"","options":_vm.quoteLine},model:{value:(_vm.checklist001),callback:function ($$v) {_vm.checklist001=$$v},expression:"checklist001"}})],1)],1)],1)}
var filingjy_staticRenderFns = []
var filingjy_esExports = { render: filingjy_render, staticRenderFns: filingjy_staticRenderFns }
/* harmony default export */ var components_srvpproject_jy_filingjy = (filingjy_esExports);
// CONCATENATED MODULE: ./src/components/srvpproject-jy/filingjy.vue
function filingjy_injectStyle (ssrContext) {
  __webpack_require__("/45A")
}
var filingjy_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var filingjy___vue_template_functional__ = false
/* styles */
var filingjy___vue_styles__ = filingjy_injectStyle
/* scopeId */
var filingjy___vue_scopeId__ = "data-v-506178f3"
/* moduleIdentifier (server only) */
var filingjy___vue_module_identifier__ = null
var filingjy_Component = filingjy_normalizeComponent(
  srvpproject_jy_filingjy,
  components_srvpproject_jy_filingjy,
  filingjy___vue_template_functional__,
  filingjy___vue_styles__,
  filingjy___vue_scopeId__,
  filingjy___vue_module_identifier__
)

/* harmony default export */ var src_components_srvpproject_jy_filingjy = (filingjy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject-jy/filinglistjy.vue








/* harmony default export */ var filinglistjy = ({
  name: "filinglistjy",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      type: false
    };
  },

  methods: {
    goToFiling: function goToFiling() {
      this.$router.push({ name: 'filingjy' });
    },
    init: function init(info) {
      switch (info['state']) {
        case 'COMPLETE':
          info['state'] = '备案待补充';
          break;
        case 'AUDIT':
          info['state'] = '备案待审批';
          break;
        case 'REAUDIT':
          info['state'] = '重新备案,待审批';
          break;
        case 'ASUCCESS':
          info['state'] = '备案审批通过';
          break;
        case 'AFAIL':
          info['state'] = '备案审批失败';
          break;
        case 'REWARD':
          info['state'] = '备案等待奖励审批';
          break;
        case 'RSUCCESS':
          info['state'] = '奖励审批通过';
          break;
        case 'RFAIL':
          info['state'] = '奖励审批失败';
          break;
        case 'EXPIRED':
          info['state'] = '备案超时';
          break;
        default:
          break;
      }
      return info;
    },
    toAudit: function toAudit() {
      var _this = this;

      this.type = false;
      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=false&company=北京精一强远科技有限公司', this.header).then(function (response) {
        _this.dataList = response.data.content.map(function (item) {
          return _this.init(item);
        });
        _this.total = response.data.total;
      }).catch(function (error) {
        _this.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    auditEd: function auditEd() {
      var _this2 = this;

      this.type = true;
      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=true&company=北京精一强远科技有限公司', this.header).then(function (response) {
        _this2.dataList = response.data.content.map(function (item) {
          return _this2.init(item);
        });
        _this2.total = response.data.total;
      }).catch(function (error) {
        _this2.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    more: function more() {
      var _this3 = this;

      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=' + this.dataList.length + '&count=10&closed=' + this.type + '&company=北京精一强远科技有限公司', this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this3.init(item);
        });
        _this3.total = response.data.total;
      }).catch(function (error) {
        _this3.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    var _this4 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      var len = res.data.length;
      if (len) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        _this4.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          _this4.header = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };
          _this4.toAudit();
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject-jy/filinglistjy.vue








/* harmony default export */ var srvpproject_jy_filinglistjy = ({
  name: "filinglistjy",
  components: { Tab: src_components_tab_tab, TabItem: src_components_tab_tab_item, Group: group["a" /* default */], Cell: vux_src_components_cell, XButton: vux_src_components_x_button },
  data: function data() {
    return {
      dataList: [],
      total: 0,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      },
      type: false
    };
  },

  methods: {
    goToFiling: function goToFiling() {
      this.$router.push({ name: 'filingjy' });
    },
    init: function init(info) {
      switch (info['state']) {
        case 'COMPLETE':
          info['state'] = '备案待补充';
          break;
        case 'AUDIT':
          info['state'] = '备案待审批';
          break;
        case 'REAUDIT':
          info['state'] = '重新备案,待审批';
          break;
        case 'ASUCCESS':
          info['state'] = '备案审批通过';
          break;
        case 'AFAIL':
          info['state'] = '备案审批失败';
          break;
        case 'REWARD':
          info['state'] = '备案等待奖励审批';
          break;
        case 'RSUCCESS':
          info['state'] = '奖励审批通过';
          break;
        case 'RFAIL':
          info['state'] = '奖励审批失败';
          break;
        case 'EXPIRED':
          info['state'] = '备案超时';
          break;
        default:
          break;
      }
      return info;
    },
    toAudit: function toAudit() {
      var _this = this;

      this.type = false;
      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=false&company=北京精一强远科技有限公司', this.header).then(function (response) {
        _this.dataList = response.data.content.map(function (item) {
          return _this.init(item);
        });
        _this.total = response.data.total;
      }).catch(function (error) {
        _this.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    auditEd: function auditEd() {
      var _this2 = this;

      this.type = true;
      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=0&count=10&closed=true&company=北京精一强远科技有限公司', this.header).then(function (response) {
        _this2.dataList = response.data.content.map(function (item) {
          return _this2.init(item);
        });
        _this2.total = response.data.total;
      }).catch(function (error) {
        _this2.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    },
    more: function more() {
      var _this3 = this;

      this.$http.get('/api/v1/srvp_projects?role=INDV&offset=' + this.dataList.length + '&count=10&closed=' + this.type + '&company=北京精一强远科技有限公司', this.header).then(function (response) {
        _this3.dataList = [].concat(toConsumableArray_default()(_this3.dataList), toConsumableArray_default()(response.data.content)).map(function (item) {
          return _this3.init(item);
        });
        _this3.total = response.data.total;
      }).catch(function (error) {
        _this3.$vux.toast.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    var _this4 = this;

    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function (res) {

      var len = res.data.length;
      if (len) {
        var account = res.data[0].account;
        localStorage.setItem('account', account);
        _this4.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account }).then(function (res) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('userid', res.data.userid);
          _this4.header = {
            headers: {
              token: res.data.token,
              opid: res.data.userid
            }
          };
          _this4.toAudit();
        });
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65bf6425","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/srvpproject-jy/filinglistjy.vue
var filinglistjy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tab',[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.toAudit}},[_vm._v("未审核")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.auditEd}},[_vm._v("已审核")])],1),_vm._v(" "),_c('group',_vm._l((_vm.dataList),function(item,index){return _c('cell',{key:index,attrs:{"is-link":"","link":{ name: 'filingorderjy', query: { order: item,closed:_vm.type }}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(item.customer))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v(_vm._s(item.recordt))])]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(item.state))])])])})),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-plus-outline icon-white",attrs:{"type":"ios-plus-outline","size":"50","xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 512 512"},on:{"click":_vm.goToFiling}},[_c('path',{attrs:{"d":"M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm0 398.7c-105.1 0-190.7-85.5-190.7-190.7S150.9 65.3 256 65.3 446.7 150.9 446.7 256 361.1 446.7 256 446.7z"}}),_c('path',{attrs:{"d":"M264.1 128h-16.8v119.9H128v16.8h119.3V384h16.8V264.7H384v-16.8H264.1z"}})]),_vm._v(" "),(_vm.dataList.length !== _vm.total)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){_vm.more()}}},[_vm._v("更多")]):_vm._e()],1)}
var filinglistjy_staticRenderFns = []
var filinglistjy_esExports = { render: filinglistjy_render, staticRenderFns: filinglistjy_staticRenderFns }
/* harmony default export */ var components_srvpproject_jy_filinglistjy = (filinglistjy_esExports);
// CONCATENATED MODULE: ./src/components/srvpproject-jy/filinglistjy.vue
function filinglistjy_injectStyle (ssrContext) {
  __webpack_require__("K5PO")
}
var filinglistjy_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var filinglistjy___vue_template_functional__ = false
/* styles */
var filinglistjy___vue_styles__ = filinglistjy_injectStyle
/* scopeId */
var filinglistjy___vue_scopeId__ = "data-v-65bf6425"
/* moduleIdentifier (server only) */
var filinglistjy___vue_module_identifier__ = null
var filinglistjy_Component = filinglistjy_normalizeComponent(
  srvpproject_jy_filinglistjy,
  components_srvpproject_jy_filinglistjy,
  filinglistjy___vue_template_functional__,
  filinglistjy___vue_styles__,
  filinglistjy___vue_scopeId__,
  filinglistjy___vue_module_identifier__
)

/* harmony default export */ var src_components_srvpproject_jy_filinglistjy = (filinglistjy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject-jy/filingorderjy.vue








/* harmony default export */ var filingorderjy = ({
  name: "filingorderjy",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Checklist: vux_src_components_checklist, Confirm: components_confirm["a" /* default */] },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      orderDetail: this.$route.query.order,
      isReadonly: true,
      devtypeshow: false,
      checklist001: [],
      quoteLine: [],
      closed: this.$route.query.closed,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    choseDevtype: function choseDevtype() {
      if (this.isReadonly) {
        return;
      }
      this.checklist001 = this.orderDetail.devtype.split(',');
      this.devtypeshow = true;
    },
    sureDevtype: function sureDevtype() {
      this.orderDetail.devtype = this.checklist001.join(',');
    },
    deleteOrder: function deleteOrder() {
      var that = this;
      this.$vux.confirm.show({
        content: '确认删除此订单',
        theme: 'android',
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          that.$http.get('/api/v1/srvp_projects/' + that.orderDetail.seq + '/remove_my_project?role=INDV', that.header).then(function () {
            alert('删除成功');
            that.$router.push({ name: 'filinglistjy' });
          }).catch(function (error) {
            that.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        }
      });
    },
    saveOrder: function saveOrder() {
      var _this = this;

      this.$http.put('/api/v1/srvp_projects/' + this.orderDetail.seq + '/update_my_project', {
        role: 'INDV',
        info: {
          customer: this.orderDetail.customer,
          devtype: this.orderDetail.devtype,
          agent: this.orderDetail.agent,
          company: '北京精一强远科技有限公司'
        }
      }, this.header).then(function () {
        alert('修改备案成功');
        _this.$router.push({ name: 'filinglistjy' });
      }).catch(function (error) {
        _this.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('api/v1/srvp_products/user_list_cats?company=北京精一强远科技有限公司&hint=').then(function (response) {
      _this2.quoteLine = response.data;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/srvpproject-jy/filingorderjy.vue








/* harmony default export */ var srvpproject_jy_filingorderjy = ({
  name: "filingorderjy",
  components: { Group: group["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Checklist: vux_src_components_checklist, Confirm: components_confirm["a" /* default */] },
  directives: { TransferDom: transfer_dom["a" /* default */] },
  data: function data() {
    return {
      orderDetail: this.$route.query.order,
      isReadonly: true,
      devtypeshow: false,
      checklist001: [],
      quoteLine: [],
      closed: this.$route.query.closed,
      header: {
        headers: {
          token: localStorage.getItem('token'),
          opid: localStorage.getItem('userid')
        }
      }
    };
  },

  methods: {
    choseDevtype: function choseDevtype() {
      if (this.isReadonly) {
        return;
      }
      this.checklist001 = this.orderDetail.devtype.split(',');
      this.devtypeshow = true;
    },
    sureDevtype: function sureDevtype() {
      this.orderDetail.devtype = this.checklist001.join(',');
    },
    deleteOrder: function deleteOrder() {
      var that = this;
      this.$vux.confirm.show({
        content: '确认删除此订单',
        theme: 'android',
        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          that.$http.get('/api/v1/srvp_projects/' + that.orderDetail.seq + '/remove_my_project?role=INDV', that.header).then(function () {
            alert('删除成功');
            that.$router.push({ name: 'filinglistjy' });
          }).catch(function (error) {
            that.$vux.alert.show({
              title: '',
              content: JSON.parse(error.response.data.error_message).zh_string
            });
          });
        }
      });
    },
    saveOrder: function saveOrder() {
      var _this = this;

      this.$http.put('/api/v1/srvp_projects/' + this.orderDetail.seq + '/update_my_project', {
        role: 'INDV',
        info: {
          customer: this.orderDetail.customer,
          devtype: this.orderDetail.devtype,
          agent: this.orderDetail.agent,
          company: '北京精一强远科技有限公司'
        }
      }, this.header).then(function () {
        alert('修改备案成功');
        _this.$router.push({ name: 'filinglistjy' });
      }).catch(function (error) {
        _this.$vux.alert.show({
          title: '',
          content: JSON.parse(error.response.data.error_message).zh_string
        });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.get('api/v1/srvp_products/user_list_cats?company=北京精一强远科技有限公司&hint=').then(function (response) {
      _this2.quoteLine = response.data;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ca702ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/srvpproject-jy/filingorderjy.vue
var filingorderjy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',[_c('x-input',{attrs:{"title":"报备订单号","type":"text","readonly":""},model:{value:(_vm.orderDetail.seq),callback:function ($$v) {_vm.$set(_vm.orderDetail, "seq", $$v)},expression:"orderDetail.seq"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"用户名称","type":"text","readonly":_vm.isReadonly},model:{value:(_vm.orderDetail.customer),callback:function ($$v) {_vm.$set(_vm.orderDetail, "customer", $$v)},expression:"orderDetail.customer"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"设备类型","type":"text","readonly":_vm.isReadonly},nativeOn:{"click":function($event){return _vm.choseDevtype($event)}},model:{value:(_vm.orderDetail.devtype),callback:function ($$v) {_vm.$set(_vm.orderDetail, "devtype", $$v)},expression:"orderDetail.devtype"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"推荐代理商","type":"text","readonly":_vm.isReadonly},model:{value:(_vm.orderDetail.agent),callback:function ($$v) {_vm.$set(_vm.orderDetail, "agent", $$v)},expression:"orderDetail.agent"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"报备时间","type":"text","readonly":""},model:{value:(_vm.orderDetail.recordt),callback:function ($$v) {_vm.$set(_vm.orderDetail, "recordt", $$v)},expression:"orderDetail.recordt"}})],1),_vm._v(" "),(_vm.isReadonly && !_vm.closed)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){_vm.isReadonly = false}}},[_vm._v("编辑")]):_vm._e(),_vm._v(" "),(!_vm.isReadonly && !_vm.closed)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){return _vm.saveOrder($event)}}},[_vm._v("保存")]):_vm._e(),_vm._v(" "),(!_vm.closed)?_c('x-button',{staticStyle:{"margin-top":"1rem"},nativeOn:{"click":function($event){return _vm.deleteOrder($event)}}},[_vm._v("删除")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('confirm',{attrs:{"theme":"android"},on:{"on-cancel":function($event){_vm.devtypeshow = false},"on-confirm":_vm.sureDevtype},model:{value:(_vm.devtypeshow),callback:function ($$v) {_vm.devtypeshow=$$v},expression:"devtypeshow"}},[_c('checklist',{staticClass:"weui-vcode",attrs:{"title":"拟采用产品类别","required":"","options":_vm.quoteLine},model:{value:(_vm.checklist001),callback:function ($$v) {_vm.checklist001=$$v},expression:"checklist001"}})],1)],1)],1)}
var filingorderjy_staticRenderFns = []
var filingorderjy_esExports = { render: filingorderjy_render, staticRenderFns: filingorderjy_staticRenderFns }
/* harmony default export */ var components_srvpproject_jy_filingorderjy = (filingorderjy_esExports);
// CONCATENATED MODULE: ./src/components/srvpproject-jy/filingorderjy.vue
function filingorderjy_injectStyle (ssrContext) {
  __webpack_require__("FX6T")
}
var filingorderjy_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var filingorderjy___vue_template_functional__ = false
/* styles */
var filingorderjy___vue_styles__ = filingorderjy_injectStyle
/* scopeId */
var filingorderjy___vue_scopeId__ = "data-v-3ca702ca"
/* moduleIdentifier (server only) */
var filingorderjy___vue_module_identifier__ = null
var filingorderjy_Component = filingorderjy_normalizeComponent(
  srvpproject_jy_filingorderjy,
  components_srvpproject_jy_filingorderjy,
  filingorderjy___vue_template_functional__,
  filingorderjy___vue_styles__,
  filingorderjy___vue_scopeId__,
  filingorderjy___vue_module_identifier__
)

/* harmony default export */ var src_components_srvpproject_jy_filingorderjy = (filingorderjy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/certificate/viwocertificatelist.vue



//
//
//
//
//
//
//
//
//

/* harmony default export */ var viwocertificatelist = ({
  name: "viwocertificatelist",
  data: function data() {
    return {
      list: []
    };
  },

  methods: {
    showContent: function showContent(seq) {
      this.$router.push({ name: 'viwocertificate', query: { seq: seq, setting: true } });
    }
  },
  created: function created() {
    var _this = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
        var account, response, header;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //res.data = res.data.filter(item=>{
                //    return item.tp=='official' || item.role == 'ADMIN' || item.role == 'SRVP'
                //});       
                account = void 0;

                res.data.forEach(function (item) {
                  if (item.role === 'EXPT') {
                    account = item.account;
                  }
                });

                if (!account) {
                  _context.next = 10;
                  break;
                }

                _context.next = 5;
                return _this.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account });

              case 5:
                response = _context.sent;

                localStorage.setItem('userid', response.data.userid);
                localStorage.setItem('token', response.data.token);
                header = {
                  headers: {
                    token: response.data.token,
                    opid: response.data.userid
                  }
                };

                _this.$http.get('api/v1/certs/get_cert?userid=' + response.data.userid, header).then(function (response) {
                  _this.list = response.data.map(function (item) {
                    switch (item.state) {
                      case 'WAIT_AUDIT':
                        item.state = '待审核';
                        item.color = '#b2b2b2';
                        break;
                      case 'OK':
                        item.state = '审核通过';
                        item.color = '#0bb20c';
                        break;
                      case 'NO':
                        item.state = '审核未通过';
                        item.color = '#f76260';
                        break;
                      case 'EXPIRED':
                        item.state = '无效证书';
                        item.color = '#f76260';
                        break;
                      case 'BLACKED':
                        item.state = '已过期，需重新认证';
                        item.color = '#f76260';
                        break;
                      default:
                        item.state = '审核未通过';
                        item.color = '#f76260';
                    }
                    return extends_default()({}, item);
                  });
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/certificate/viwocertificatelist.vue



//
//
//
//
//
//
//
//
//

/* harmony default export */ var certificate_viwocertificatelist = ({
  name: "viwocertificatelist",
  data: function data() {
    return {
      list: []
    };
  },

  methods: {
    showContent: function showContent(seq) {
      this.$router.push({ name: 'viwocertificate', query: { seq: seq, setting: true } });
    }
  },
  created: function created() {
    var _this = this;

    var openid = localStorage.getItem('openid');
    var unionid = localStorage.getItem('unionid');
    this.$http.get('api/v1/wechat/' + unionid).then(function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(res) {
        var account, response, header;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //res.data = res.data.filter(item=>{
                //    return item.tp=='official' || item.role == 'ADMIN' || item.role == 'SRVP'
                //});       
                account = void 0;

                res.data.forEach(function (item) {
                  if (item.role === 'EXPT') {
                    account = item.account;
                  }
                });

                if (!account) {
                  _context.next = 10;
                  break;
                }

                _context.next = 5;
                return _this.$http.post('api/v1/wechat/' + unionid + '/token', { 'account': account });

              case 5:
                response = _context.sent;

                localStorage.setItem('userid', response.data.userid);
                localStorage.setItem('token', response.data.token);
                header = {
                  headers: {
                    token: response.data.token,
                    opid: response.data.userid
                  }
                };

                _this.$http.get('api/v1/certs/get_cert?userid=' + response.data.userid, header).then(function (response) {
                  _this.list = response.data.map(function (item) {
                    switch (item.state) {
                      case 'WAIT_AUDIT':
                        item.state = '待审核';
                        item.color = '#b2b2b2';
                        break;
                      case 'OK':
                        item.state = '审核通过';
                        item.color = '#0bb20c';
                        break;
                      case 'NO':
                        item.state = '审核未通过';
                        item.color = '#f76260';
                        break;
                      case 'EXPIRED':
                        item.state = '无效证书';
                        item.color = '#f76260';
                        break;
                      case 'BLACKED':
                        item.state = '已过期，需重新认证';
                        item.color = '#f76260';
                        break;
                      default:
                        item.state = '审核未通过';
                        item.color = '#f76260';
                    }
                    return extends_default()({}, item);
                  });
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47734029","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/certificate/viwocertificatelist.vue
var viwocertificatelist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item,index){return _c('p',{key:index,style:({backgroundColor:item.color}),on:{"click":function($event){_vm.showContent(item.seq)}}},[_c('span',[_vm._v(_vm._s(item.company))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.state))])])}))}
var viwocertificatelist_staticRenderFns = []
var viwocertificatelist_esExports = { render: viwocertificatelist_render, staticRenderFns: viwocertificatelist_staticRenderFns }
/* harmony default export */ var components_certificate_viwocertificatelist = (viwocertificatelist_esExports);
// CONCATENATED MODULE: ./src/components/certificate/viwocertificatelist.vue
function viwocertificatelist_injectStyle (ssrContext) {
  __webpack_require__("gc8R")
}
var viwocertificatelist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var viwocertificatelist___vue_template_functional__ = false
/* styles */
var viwocertificatelist___vue_styles__ = viwocertificatelist_injectStyle
/* scopeId */
var viwocertificatelist___vue_scopeId__ = "data-v-47734029"
/* moduleIdentifier (server only) */
var viwocertificatelist___vue_module_identifier__ = null
var viwocertificatelist_Component = viwocertificatelist_normalizeComponent(
  certificate_viwocertificatelist,
  components_certificate_viwocertificatelist,
  viwocertificatelist___vue_template_functional__,
  viwocertificatelist___vue_styles__,
  viwocertificatelist___vue_scopeId__,
  viwocertificatelist___vue_module_identifier__
)

/* harmony default export */ var src_components_certificate_viwocertificatelist = (viwocertificatelist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PcLogin.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var PcLogin = ({
  name: "PcLogin",
  data: function data() {
    return {
      uuid: this.$route.query.uuid,
      accountInfo: []
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var openid, unionid, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                openid = localStorage.getItem('openid');
                unionid = localStorage.getItem('unionid');
                _context2.next = 4;
                return _this.$http.get('/api/v1/wechat/' + unionid);

              case 4:
                _ref = _context2.sent;
                data = _ref.data;

                _this.accountInfo = data.filter(function (item) {
                  return item.role === 'SRVP' || item.role === 'ADMIN';
                }).map(function (item) {
                  switch (item.role) {
                    case 'SRVP':
                      item.role = '服务商管理员';
                      break;
                    case 'ADMIN':
                      item.role = '超级管理';
                      break;
                  }
                  return item;
                });
                if (_this.accountInfo.length === 0) {
                  _this.$vux.alert.show({
                    title: "",
                    content: "您还没有关联好云帷管理员账号，请在网页端继续输入账号信息进行关联，关联之后可以通过此微信快速登录好云帷平台。",
                    onHide: function () {
                      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                        var response;
                        return regenerator_default.a.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return _this.$http.post('/api/v1/accounts/bond_uuid', {
                                  uuid: _this.uuid,
                                  openid: localStorage.getItem('openid'),
                                  unionid: localStorage.getItem('unionid'),
                                  otp: 'official'
                                });

                              case 2:
                                response = _context.sent;

                                weixin_js_sdk_default.a.closeWindow();

                              case 4:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee, _this);
                      }));

                      return function onHide() {
                        return _ref2.apply(this, arguments);
                      };
                    }()
                  });
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    login: function login(account) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this2.$http.post('/api/v1/accounts/bond_uuid', {
                  uuid: _this2.uuid,
                  openid: localStorage.getItem('openid'),
                  unionid: localStorage.getItem('unionid'),
                  otp: 'official',
                  account: account
                });

              case 3:
                response = _context3.sent;

                if (response) {
                  alert('登录成功');
                  weixin_js_sdk_default.a.closeWindow();
                }
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                _this2.$vux.toast.show({
                  text: JSON.parse(_context3.t0.response.data.error_message).zh_string,
                  type: 'cancel',
                  time: '1000'
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 7]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      _this3.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        var url = isiOS ? config.host + src_components_global.entryUrl : config.host + _this3.$route.fullPath;
        var noncestr = Math.random().toString(36).substr(2);
        _this3.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['checkJsApi'] // 必填，需要使用的JS接口列表
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
          weixin_js_sdk_default.a.ready(function () {});
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    this.getData();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PcLogin.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_PcLogin = ({
  name: "PcLogin",
  data: function data() {
    return {
      uuid: this.$route.query.uuid,
      accountInfo: []
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var openid, unionid, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                openid = localStorage.getItem('openid');
                unionid = localStorage.getItem('unionid');
                _context2.next = 4;
                return _this.$http.get('/api/v1/wechat/' + unionid);

              case 4:
                _ref = _context2.sent;
                data = _ref.data;

                _this.accountInfo = data.filter(function (item) {
                  return item.role === 'SRVP' || item.role === 'ADMIN';
                }).map(function (item) {
                  switch (item.role) {
                    case 'SRVP':
                      item.role = '服务商管理员';
                      break;
                    case 'ADMIN':
                      item.role = '超级管理';
                      break;
                  }
                  return item;
                });
                if (_this.accountInfo.length === 0) {
                  _this.$vux.alert.show({
                    title: "",
                    content: "您还没有关联好云帷管理员账号，请在网页端继续输入账号信息进行关联，关联之后可以通过此微信快速登录好云帷平台。",
                    onHide: function () {
                      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                        var response;
                        return regenerator_default.a.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return _this.$http.post('/api/v1/accounts/bond_uuid', {
                                  uuid: _this.uuid,
                                  openid: localStorage.getItem('openid'),
                                  unionid: localStorage.getItem('unionid'),
                                  otp: 'official'
                                });

                              case 2:
                                response = _context.sent;

                                weixin_js_sdk_default.a.closeWindow();

                              case 4:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee, _this);
                      }));

                      return function onHide() {
                        return _ref2.apply(this, arguments);
                      };
                    }()
                  });
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    login: function login(account) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var response;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this2.$http.post('/api/v1/accounts/bond_uuid', {
                  uuid: _this2.uuid,
                  openid: localStorage.getItem('openid'),
                  unionid: localStorage.getItem('unionid'),
                  otp: 'official',
                  account: account
                });

              case 3:
                response = _context3.sent;

                if (response) {
                  alert('登录成功');
                  weixin_js_sdk_default.a.closeWindow();
                }
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                _this2.$vux.toast.show({
                  text: JSON.parse(_context3.t0.response.data.error_message).zh_string,
                  type: 'cancel',
                  time: '1000'
                });

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 7]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      _this3.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        var url = isiOS ? config.host + src_components_global.entryUrl : config.host + _this3.$route.fullPath;
        var noncestr = Math.random().toString(36).substr(2);
        _this3.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['checkJsApi'] // 必填，需要使用的JS接口列表
          });
          weixin_js_sdk_default.a.error(function (res) {
            alert(res.errMsg);
          });
          weixin_js_sdk_default.a.ready(function () {});
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  },
  created: function created() {
    this.getData();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed09906","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PcLogin.vue
var PcLogin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap_wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wrap"},_vm._l((_vm.accountInfo),function(item,index){return _c('div',{key:'account_' + index,on:{"click":function($event){_vm.login(item.account)}}},[_c('div',[_c('h3',[_vm._v(_vm._s(item.account))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.role))])]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-arrow-right",staticStyle:{"fill":"#fff"},attrs:{"type":"ios-arrow-right","size":"30","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M160 115.4L180.7 96 352 256 180.7 416 160 396.7 310.5 256z"}})])])}))])}
var PcLogin_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":__webpack_require__("ZBJ4"),"alt":""}}),_vm._v(" "),_c('h3',[_vm._v("请选择账号登录")])])}]
var PcLogin_esExports = { render: PcLogin_render, staticRenderFns: PcLogin_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_PcLogin = (PcLogin_esExports);
// CONCATENATED MODULE: ./src/components/PcLogin.vue
function PcLogin_injectStyle (ssrContext) {
  __webpack_require__("bVTv")
}
var PcLogin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PcLogin___vue_template_functional__ = false
/* styles */
var PcLogin___vue_styles__ = PcLogin_injectStyle
/* scopeId */
var PcLogin___vue_scopeId__ = "data-v-7ed09906"
/* moduleIdentifier (server only) */
var PcLogin___vue_module_identifier__ = null
var PcLogin_Component = PcLogin_normalizeComponent(
  components_PcLogin,
  selectortype_template_index_0_src_components_PcLogin,
  PcLogin___vue_template_functional__,
  PcLogin___vue_styles__,
  PcLogin___vue_scopeId__,
  PcLogin___vue_module_identifier__
)

/* harmony default export */ var src_components_PcLogin = (PcLogin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bondaccount.vue


//
//
//
//




/* harmony default export */ var bondaccount = ({
  name: "bondaccount",
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _ref, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$http.get('/api/v1/wechat/' + localStorage.getItem('openid') + '/Info');

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              if (data.subscribe) {
                _context.next = 7;
                break;
              }

              _this.$router.push({ name: "attention" });
              return _context.abrupt("return");

            case 7:
              _this.$http.post('/api/v1/wechat/bond_account', {
                userid: _this.$route.query.userid,
                state: new Date().getTime(),
                name: _this.$route.query.name,
                otp: 'official',
                openid: localStorage.getItem('openid'),
                unionid: localStorage.getItem('unionid'),
                nickname: localStorage.getItem('nickname'),
                imgurl: localStorage.getItem('imgurl')
              }).then(function () {
                alert('绑定成功');
                weixin_js_sdk_default.a.closeWindow();
              }).catch(function (error) {
                _this.$vux.alert.show({
                  content: JSON.parse(error.response.data.error_message).zh_string,
                  onHide: function onHide() {
                    weixin_js_sdk_default.a.closeWindow();
                  }
                });
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      _this2.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        var url = isiOS ? config.host + src_components_global.entryUrl : config.host + _this2.$route.fullPath;
        var noncestr = Math.random().toString(36).substr(2);
        _this2.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + encodeURIComponent(url)).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['checkJsApi'] // 必填，需要使用的JS接口列表
          });
          weixin_js_sdk_default.a.error(function (res) {
            // alert(res.errMsg)
          });
          weixin_js_sdk_default.a.ready(function () {});
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bondaccount.vue


//
//
//
//




/* harmony default export */ var components_bondaccount = ({
  name: "bondaccount",
  created: function created() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _ref, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$http.get('/api/v1/wechat/' + localStorage.getItem('openid') + '/Info');

            case 2:
              _ref = _context.sent;
              data = _ref.data;

              if (data.subscribe) {
                _context.next = 7;
                break;
              }

              _this.$router.push({ name: "attention" });
              return _context.abrupt("return");

            case 7:
              _this.$http.post('/api/v1/wechat/bond_account', {
                userid: _this.$route.query.userid,
                state: new Date().getTime(),
                name: _this.$route.query.name,
                otp: 'official',
                openid: localStorage.getItem('openid'),
                unionid: localStorage.getItem('unionid'),
                nickname: localStorage.getItem('nickname'),
                imgurl: localStorage.getItem('imgurl')
              }).then(function () {
                alert('绑定成功');
                weixin_js_sdk_default.a.closeWindow();
              }).catch(function (error) {
                _this.$vux.alert.show({
                  content: JSON.parse(error.response.data.error_message).zh_string,
                  onHide: function onHide() {
                    weixin_js_sdk_default.a.closeWindow();
                  }
                });
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      var timestamp = parseInt(new Date().getTime() / 1000);
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      _this2.$http.get('static/config.json').then(function (response) {
        var config = response.data;
        var url = isiOS ? config.host + src_components_global.entryUrl : config.host + _this2.$route.fullPath;
        var noncestr = Math.random().toString(36).substr(2);
        _this2.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + encodeURIComponent(url)).then(function (response) {
          weixin_js_sdk_default.a.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: noncestr, // 必填，生成签名的随机串
            signature: response.data, // 必填，签名
            jsApiList: ['checkJsApi'] // 必填，需要使用的JS接口列表
          });
          weixin_js_sdk_default.a.error(function (res) {
            // alert(res.errMsg)
          });
          weixin_js_sdk_default.a.ready(function () {});
        }).catch(function (error) {
          alert('服务器错误，请稍后重试');
          if (error.response) {
            console.log(error.response.data);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
        });
      }, function (response) {
        console.log('数据加载失败');
      });
    }, 500);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-454a022e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bondaccount.vue
var bondaccount_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var bondaccount_staticRenderFns = []
var bondaccount_esExports = { render: bondaccount_render, staticRenderFns: bondaccount_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bondaccount = (bondaccount_esExports);
// CONCATENATED MODULE: ./src/components/bondaccount.vue
function bondaccount_injectStyle (ssrContext) {
  __webpack_require__("Wy02")
}
var bondaccount_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bondaccount___vue_template_functional__ = false
/* styles */
var bondaccount___vue_styles__ = bondaccount_injectStyle
/* scopeId */
var bondaccount___vue_scopeId__ = "data-v-454a022e"
/* moduleIdentifier (server only) */
var bondaccount___vue_module_identifier__ = null
var bondaccount_Component = bondaccount_normalizeComponent(
  components_bondaccount,
  selectortype_template_index_0_src_components_bondaccount,
  bondaccount___vue_template_functional__,
  bondaccount___vue_styles__,
  bondaccount___vue_scopeId__,
  bondaccount___vue_module_identifier__
)

/* harmony default export */ var src_components_bondaccount = (bondaccount_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/promptUpdate.vue
//
//
//
//
//

/* harmony default export */ var promptUpdate = ({
  components: {},
  directives: {},
  data: function data() {
    return {};
  },

  methods: {
    getUserInfo: function getUserInfo(opid) {
      var app = this;
      var obj = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      var openid = localStorage.getItem('openid');
      this.$http.get("api/v1/wechat/need_update_wx?openid=" + openid, obj).then().cheat(function (res) {
        console.log(res);
      });
    }
  },
  created: function created() {
    //this.account = this.$route.params.account
    this.opid = localStorage.getItem("userid");
    this.getUserInfo(this.opid);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/promptUpdate.vue
//
//
//
//
//

/* harmony default export */ var components_promptUpdate = ({
  components: {},
  directives: {},
  data: function data() {
    return {};
  },

  methods: {
    getUserInfo: function getUserInfo(opid) {
      var app = this;
      var obj = {
        headers: {
          token: localStorage.getItem("token"),
          opid: opid
        }
      };
      var openid = localStorage.getItem('openid');
      this.$http.get("api/v1/wechat/need_update_wx?openid=" + openid, obj).then().cheat(function (res) {
        console.log(res);
      });
    }
  },
  created: function created() {
    //this.account = this.$route.params.account
    this.opid = localStorage.getItem("userid");
    this.getUserInfo(this.opid);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6071df15","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/promptUpdate.vue
var promptUpdate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var promptUpdate_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Title"},[_c('span',[_vm._v("好云帷 平台已由公众号迁移至小程序，你的微信版本较低，导致无法正常跳转小程序，请更新微信后重试")])])}]
var promptUpdate_esExports = { render: promptUpdate_render, staticRenderFns: promptUpdate_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_promptUpdate = (promptUpdate_esExports);
// CONCATENATED MODULE: ./src/components/promptUpdate.vue
function promptUpdate_injectStyle (ssrContext) {
  __webpack_require__("WB5g")
}
var promptUpdate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var promptUpdate___vue_template_functional__ = false
/* styles */
var promptUpdate___vue_styles__ = promptUpdate_injectStyle
/* scopeId */
var promptUpdate___vue_scopeId__ = "data-v-6071df15"
/* moduleIdentifier (server only) */
var promptUpdate___vue_module_identifier__ = null
var promptUpdate_Component = promptUpdate_normalizeComponent(
  components_promptUpdate,
  selectortype_template_index_0_src_components_promptUpdate,
  promptUpdate___vue_template_functional__,
  promptUpdate___vue_styles__,
  promptUpdate___vue_scopeId__,
  promptUpdate___vue_module_identifier__
)

/* harmony default export */ var src_components_promptUpdate = (promptUpdate_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js


































































































vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var src_router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/promptUpdate',
    name: 'promptUpdate',
    component: src_components_promptUpdate
  }, {
    path: '/bondaccount',
    name: 'bondaccount',
    component: src_components_bondaccount
  }, {
    path: '/PcLogin',
    name: 'PcLogin',
    component: src_components_PcLogin
  }, {
    path: '/download',
    name: 'Download',
    component: src_components_Download
  }, {
    path: '/saleslog',
    name: 'saleslog',
    component: src_components_Saleslog
  }, {
    path: '/resumelist',
    name: 'resumelist',
    component: src_components_job_resumelist
  }, {
    path: '/apply',
    name: 'apply',
    component: src_components_job_apply
  }, {
    path: '/resume',
    name: 'resume',
    component: src_components_job_resume
  }, {
    path: '/viwocertificatelist',
    name: 'viwocertificatelist',
    component: src_components_certificate_viwocertificatelist
  }, {
    path: '/viwocertificate',
    name: 'viwocertificate',
    component: src_components_certificate_viwocertificate
  }, {
    path: '/assistantorder',
    name: 'assistantorder',
    component: src_components_assistantinfo_assistantorder
  }, {
    path: '/assistantinfo',
    name: 'assistantinfo',
    component: src_components_assistantinfo_assistantinfo
  }, {
    path: '/assistant',
    name: 'assistant',
    component: src_components_assistantinfo_assistant
  }, {
    path: '/srvprepairinfo',
    name: 'srvprepairinfo',
    component: src_components_Indvrepair_srvprepairinfo
  }, {
    path: '/filingorder',
    name: 'filingorder',
    component: src_components_srvpproject_filingorder
  }, {
    path: '/filinglist',
    name: 'filinglist',
    component: src_components_srvpproject_filinglist
  }, {
    path: '/filing',
    name: 'filing',
    component: src_components_srvpproject_filing
  }, {
    path: '/Market',
    name: 'Market',
    component: src_components_Market
  }, {
    path: '/Askpay',
    name: 'Askpay',
    component: src_components_Pay_Askpay
  }, {
    path: '/needpay',
    name: 'needpay',
    component: src_components_Pay_needpay
  }, {
    path: '/Pay',
    name: 'Pay',
    component: src_components_Pay_Pay
  }, {
    path: '/Payinfo',
    name: 'Payinfo',
    component: src_components_Pay_Payinfo
  }, {
    path: '/Userpay',
    name: 'Userpay',
    component: src_components_Pay_Userpay
  }, {
    path: '/Desiginate',
    name: 'Desiginate',
    component: src_components_repairs_Desiginate
  }, {
    path: '/register',
    name: 'register',
    component: src_components_login_register //() => import('@/components/login/register')
  }, {
    path: '/login',
    name: 'login',
    component: src_components_login_login //() => import('@/components/login/login')
  }, {
    path: '/',
    name: 'vip',
    component: src_components_vip //() => import('@/components/vip'),
  }, {
    path: '/myInfo',
    name: 'myInfo',
    component: src_components_myInfo,
    redirect: '/promptUpdate'
  }, {
    path: '/expertInfo',
    name: 'expertInfo',
    component: src_components_expertInfo,
    redirect: '/promptUpdate'
  }, {
    path: '/workExp',
    name: 'workExp',
    component: src_components_workExp //() => import('@/components/workExp')
  }, {
    path: '/singleWorkExp',
    name: 'singleWorkExp',
    component: src_components_singleWorkExp //() => import('@/components/singleWorkExp')
  }, {
    path: '/idPhoto',
    name: 'idPhoto',
    component: src_components_idPhoto //() => import('@/components/idPhoto')
  }, {
    path: '/eduPhoto',
    name: 'eduPhoto',
    component: src_components_eduPhoto //() => import('@/components/eduPhoto')
  }, {
    path: '/skillPhoto',
    name: 'skillPhoto',
    component: src_components_skillPhoto //() => import('@/components/skillPhoto')
  }, {
    path: '/skill',
    name: 'skill',
    component: src_components_skill //() => import('@/components/skill')
  }, {
    path: '/singleSkill',
    name: 'singleSkill',
    component: src_components_singleSkill //() => import('@/components/singleSkill')
  }, {
    path: '/invitation',
    name: 'invitation',
    component: src_components_invitation //() => import('@/components/invitation')
  }, {
    path: '/protocal',
    name: 'protocal',
    component: src_components_protocal //() => import('@/components/protocal')
  }, {
    path: '/wallet',
    name: 'wallet',
    component: src_components_wallet,
    redirect: '/promptUpdate'
  }, {
    path: '/recharge',
    name: 'recharge',
    component: src_components_recharge //() => import('@/components/recharge')
  }, {
    path: '/withdraw',
    name: 'withdraw',
    component: src_components_withdraw //() => import('@/components/withdraw')
  }, {
    path: '/orders',
    name: 'orders',
    component: src_components_orders //() => import('@/components/orders')
  }, {
    path: '/orderDetail',
    name: 'orderDetail',
    component: src_components_orderDetail //() => import('@/components/orderDetail')
  }, {
    path: '/glzh',
    name: 'glzh',
    component: src_components_glzh //() => import('@/components/glzh')
  }, {
    path: '/xgmm',
    name: 'xgmm',
    component: src_components_xgmm //() => import('@/components/xgmm')
  }, {
    path: '/enterpriseUsers',
    name: 'enterpriseUsers',
    component: src_components_enterpriseUsers //() => import('@/components/enterpriseUsers')
  }, {
    path: '/attention',
    name: 'attention',
    component: src_components_attention //() => import('@/components/attention')
  }, {
    path: '/sbxx',
    name: 'sbxx',
    component: src_components_sbxx //() => import('@/components/sbxx')
  }, {
    path: '/forgetpassword',
    name: 'forgetpassword',
    component: src_components_forgetpassword //() => import('@/components/forgetpassword')
  }, {
    path: '/rapidrepairs',
    name: 'rapidrepairs',
    component: src_components_rapidrepairs //() => import('@/components/rapidrepairs')
  }, {
    path: '/rapidrepairslist',
    name: 'rapidrepairslist',
    component: src_components_rapidrepairslist //() => import('@/components/rapidrepairslist')
  }, {
    path: '/quicksetup',
    name: 'quicksetup',
    component: src_components_quicksetup //() => import('@/components/quicksetup')
  }, {
    path: '/quicklycomplete',
    name: 'quicklycomplete',
    component: src_components_quicklycomplete //() => import('@/components/quicklycomplete')
  }, {
    path: '/normalrepairs',
    name: 'normalrepairs',
    component: src_components_normalrepairs //() => import('@/components/normalrepairs')
  }, {
    path: '/normalrepairslist',
    name: 'normalrepairslist',
    component: src_components_normalrepairslist //() => import('@/components/normalrepairslist')
  }, {
    path: '/normalcomplete',
    name: 'normalcomplete',
    component: src_components_normalcomplete //() => import('@/components/normalcomplete')
  }, {
    path: '/normaldone',
    name: 'normaldone',
    component: src_components_normaldone //() => import('@/components/normaldone')
  }, {
    path: '/userhomepage',
    name: 'userhomepage',
    component: src_components_userhomepage //() => import('@/components/userhomepage')
  }, {
    path: '/solution_logs',
    name: 'solution_logs',
    component: src_components_solution_solution_logs //() => import('@/components/solution/solution_logs')
  }, {
    path: '/photo',
    name: 'photo',
    component: src_components_photo //() => import('@/components/photo')
  }, {
    path: '/engineer',
    name: 'engineer',
    component: src_components_engineer //() => import('@/components/engineer')
  }, {
    path: '/addmyInfo',
    name: 'addmyInfo',
    component: src_components_addmyInfo //() => import('@/components/addmyInfo')
  }, {
    path: '/detaillist',
    name: 'detaillist',
    component: src_components_detaillist //() => import('@/components/detaillist')
  }, {
    path: '/addfirmInfo',
    name: 'addfirmInfo',
    component: src_components_addfirmInfo //() => import('@/components/addfirmInfo')
  }, {
    path: '/records',
    name: 'records',
    component: src_components_records //() => import('@/components/records')
  }, {
    path: '/makeMemo',
    name: 'makeMemo',
    component: src_components_makeMemo //() => import('@/components/makeMemo')
  }, {
    path: '/addrate',
    name: 'addrate',
    component: src_components_addrate //() => import('@/components/addrate')
  }, {
    path: '/prgsdetail',
    name: 'prgsdetail',
    component: src_components_prgsdetail //() => import('@/components/prgsdetail')
  }, {
    path: '/cancelCause',
    name: 'cancelCause',
    component: src_components_cancelCause //() => import('@/components/cancelCause')
  }, {
    path: '/addexpertInfo',
    name: 'addexpertInfo',
    component: src_components_addexpertInfo //() => import('@/components/addexpertInfo')
  }, {
    path: '/cancel',
    name: 'cancel',
    component: src_components_cancel //() => import('@/components/cancel')
  }, {
    path: '/confirmfault',
    name: 'confirmfault',
    component: src_components_confirmfault //() => import('@/components/confirmfault')
  }, {
    path: '/finish',
    name: 'finish',
    component: src_components_finish //() => import('@/components/finish')
  }, {
    path: '/userevaluation',
    name: 'userevaluation',
    component: src_components_userevaluation //() => import('@/components/userevaluation')
  }, {
    path: '/myrecord',
    name: 'filinglistjy',
    component: src_components_srvpproject_jy_filinglistjy //() => import('@/components/myrecord')
  }, {
    path: '/myrecordcomplete',
    name: 'myrecordcomplete',
    component: src_components_myrecordcomplete //() => import('@/components/myrecordcomplete')
  }, {
    path: '/preparation',
    name: 'filingjy',
    component: src_components_srvpproject_jy_filingjy //() => import('@/components/preparation')
  }, {
    path: '/filingorderjy',
    name: 'filingorderjy',
    component: src_components_srvpproject_jy_filingorderjy //() => import('@/components/preparation')
  }, {
    path: '/myrecorddone',
    name: 'myrecorddone',
    component: src_components_myrecorddone //() => import('@/components/myrecorddone')
  }, {
    path: '/faultType',
    name: 'faultType',
    component: src_components_faultType //() => import('@/components/faultType')
  }, {
    path: '/faultType1',
    name: 'faultType1',
    component: src_components_faultType1 //() => import('@/components/faultType1')
  }, {
    path: '/Devicelist',
    name: 'Devicelist',
    component: src_components_Devicelist //() => import('@/components/Devicelist')
  }, {
    path: '/Devicedetails',
    name: 'Devicedetails',
    component: src_components_Devicedetails //() => import('@/components/Devicedetails')
  }, {
    path: '/recordlist',
    name: 'recordlist',
    component: src_components_recordlist //() => import('@/components/recordlist')
  }, {
    path: '/smallbox',
    name: 'smallbox',
    component: src_components_smallbox //() => import('@/components/smallbox')
  }, {
    path: '/addphoto',
    name: 'addphoto',
    component: src_components_addphoto //() => import('@/components/addphoto')
  }, {
    path: '/binding',
    name: 'binding',
    component: src_components_binding //() => import('@/components/binding')
  }, {
    path: '/list',
    name: 'list',
    component: src_components_Administrator_list //() => import('@/components/Administrator/list')
  }, {
    path: '/RepairOrder',
    name: 'RepairOrder',
    component: src_components_Administrator_RepairOrder //() => import('@/components/Administrator/RepairOrder')
  }, {
    path: '/FastRepairOrder',
    name: 'FastRepairOrder',
    component: src_components_Administrator_FastRepairOrder //() => import('@/components/Administrator/FastRepairOrder')
  }, {
    path: '/RepairSrvp',
    name: 'RepairSrvp',
    component: src_components_repairs_RepairSrvp //() => import('@/components/repairs/RepairSrvp')
  }, {
    path: '/RepairLog',
    name: 'RepairLog',
    component: src_components_repairs_RepairLog //() => import('@/components/repairs/RepairLog')
  }, {
    path: '/repair',
    name: 'repair',
    component: src_components_repair //() => import('@/components/repair')
  }, {
    path: '/RepairSolution',
    name: 'RepairSolution',
    component: src_components_repairs_RepairSolution //() => import('@/components/repairs/RepairSolution')
  }, {
    path: '/RegisterType',
    name: 'RegisterType',
    component: src_components_login_RegisterType
  }]
}));
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/datetime/index.js
var plugins_datetime = __webpack_require__("oVYx");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./static/js/json3.min.js
var json3_min = __webpack_require__("JPxP");
var json3_min_default = /*#__PURE__*/__webpack_require__.n(json3_min);

// CONCATENATED MODULE: ./src/main.js


















vue_esm["a" /* default */].use(plugins_toast["a" /* default */]);
vue_esm["a" /* default */].use(ajax["a" /* default */]);
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(plugins_confirm["a" /* default */]);
vue_esm["a" /* default */].use(plugins_datetime["a" /* default */]);

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

src_router.beforeEach(function (to, from, next) {
  if (!src_components_global.entryUrl && to.path !== '/login' && to.path.indexOf('?') === -1) {
    src_components_global.entryUrl = to.fullPath;
  }
  if (to.path === '/download') {
    next();
    return;
  }
  var openid = localStorage.getItem('openid') || src_components_global.openid;
  var unionid = localStorage.getItem('unionid') || src_components_global.unionid;
  if (!openid || !unionid || openid === unionid) {
    if (to.query.code) {
      ajax["a" /* default */].$http.get('/api/v1/wechat/?code=' + to.query.code + '&state=' + to.query.state).then(function (response) {
        localStorage.setItem('openid', response.data.openid);
        if (response.data.unionid) {
          localStorage.setItem('unionid', response.data.unionid);
          src_components_global.unionid = response.data.unionid;
        }

        src_components_global.openid = response.data.openid;

        window.location.reload();
      }).catch(function (error) {
        alert('服务器错误，请稍后重试');
      });
    } else {
      ajax["a" /* default */].$http.get('static/config.json').then(function (response) {
        var appid = response.data.appId;

        window.location.href = 'http://viwo.fineone.com.cn/get-weixin-code.html?appid=' + appid + '&scope=snsapi_userinfo&state=STATE&redirect_uri=' + response.data.host + to.fullPath;
      }, function (response) {
        console.log('数据加载失败');
      });
    }
  } else {
    var whiteList = ['/forgetpassword', '/register', '/login', '/rapidrepairs', "/sbxx", "/smallbox", "/attention", '/protocal', '/faultType', '/rapidrepairslist', '/userhomepage', "/quicklycomplete", '/quicksetup', '/normalrepairs', '/normalrepairslist', '/photo', '/repair', '/RegisterType', '/engineer', '/Devicelist', '/filing', '/viwocertificate', '/resume', '/apply', '/resumelist', '/preparation']; // 免登录白名单
    if (whiteList.indexOf(to.path) === -1) {
      ajax["a" /* default */].$http.get('/api/v1/wechat/' + localStorage.getItem('unionid')).then(function (res) {
        if (res.data.length === 0) {
          next('/login');
        } else {
          localStorage.setItem('account', stringify_default()(res.data));
          next();
        }
      });
    } else {
      next();
    }
  }
});

src_router.afterEach(function (to, from) {});
new vue_esm["a" /* default */]({
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "NMAk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ngll":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NhlS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NxQa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pqsh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QX3Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qy6+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RMDY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S3+C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S3ag":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SREC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UNGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 2 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-241efaf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var staticRenderFns = []
var esExports = { render: datetime_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_datetime = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("jYbJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_datetime,
  src_components_datetime,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UsvW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UzTD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WB5g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WDiO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wc+C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wy02":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X9XN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XAbY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YdJi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YgVi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28eb4a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("cqo/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZBJ4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "aiyf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bRlU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bVTv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c+RB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c9+y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cqo/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d1Im":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dKNu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dPMr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dWIQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "da65":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dpWl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e6ed":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ep0X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fMNz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gXUh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gc8R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "go8J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hKOj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iASr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j+UX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j0Yn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jQI1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jYbJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jjCP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3k2l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kllH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mfyC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "msxG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("55wj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nXml":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "naaX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nfGx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nnSp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o2+o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oIkO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oKmF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oWtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d30802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("2lnh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "owug":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pi9w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pmvC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qHQD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qbUw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r7UK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rFhX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e216ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("qHQD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("kllH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rTDE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s8nJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tUL0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u1Nj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u8xQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uGHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukTf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vRTY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wHnH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wHqe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wIxn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xtLV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y3o/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yQe0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z+Wg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zntn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7959e27b4c2433789f39.js